
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5bbd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5bbd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPddG", function(module, exports) {

$parcel$export(module.exports, "render", () => $0208a8f77b5dfae1$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $0208a8f77b5dfae1$var$_hoisted_1 = {
    id: "app"
};
function $0208a8f77b5dfae1$export$b3890eb0ae9dca99(_ctx, _cache) {
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0208a8f77b5dfae1$var$_hoisted_1, [
        (0, $TusQn.createVNode)(_component_router_view)
    ]);
}

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("eeJ70")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
/**
* @vue/runtime-core v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8POXm.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $8POXm.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $0a6cc4ba868319ae$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8POXm.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8POXm.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8POXm.hasChanged)(v1, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, (0, $8POXm.NOOP), scheduler);
    const scope = (0, $01W3b.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, $01W3b.isRef)(value)) $0a6cc4ba868319ae$var$traverse(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$0a6cc4ba868319ae$var$traverse(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) for(const key in value)$0a6cc4ba868319ae$var$traverse(value[key], depth, seen);
    return value;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy($0a6cc4ba868319ae$var$currentRenderingInstance) || $0a6cc4ba868319ae$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) return vnode;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8POXm.isArray)(source) || (0, $8POXm.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8POXm.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8POXm.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $8POXm.hasOwn)(rawProps, key) && !(0, $8POXm.hasOwn)(rawProps, (0, $8POXm.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $8POXm.extend)(slots, children);
            (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8POXm.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8POXm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8POXm.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style");
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, (0, $8POXm.NOOP), ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) cloned.transition = transition.clone(cloned);
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        reset();
        if ((0, $8POXm.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $8POXm.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.4.26";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
/**
* @vue/reactivity v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeEffect;
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $005d1fb7704e278c$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $005d1fb7704e278c$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $005d1fb7704e278c$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        let lastEffect = $005d1fb7704e278c$var$activeEffect;
        try {
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$activeEffect = this;
            this._runnings++;
            $005d1fb7704e278c$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this._runnings--;
            $005d1fb7704e278c$var$activeEffect = lastEffect;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            $005d1fb7704e278c$var$preCleanupEffect(this);
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$triggerComputed(computed) {
    return computed.value;
}
function $005d1fb7704e278c$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $005d1fb7704e278c$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$005d1fb7704e278c$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $005d1fb7704e278c$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn, (0, $8POXm.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $8POXm.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
let $005d1fb7704e278c$var$pauseScheduleStack = 0;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$262a949f95482a17() {
    $005d1fb7704e278c$var$pauseScheduleStack++;
}
function $005d1fb7704e278c$export$3539fa10306ef581() {
    $005d1fb7704e278c$var$pauseScheduleStack--;
    while(!$005d1fb7704e278c$var$pauseScheduleStack && $005d1fb7704e278c$var$queueEffectSchedulers.length)$005d1fb7704e278c$var$queueEffectSchedulers.shift()();
}
function $005d1fb7704e278c$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $005d1fb7704e278c$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $005d1fb7704e278c$var$queueEffectSchedulers = [];
function $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $005d1fb7704e278c$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $005d1fb7704e278c$export$3539fa10306ef581();
}
const $005d1fb7704e278c$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep(()=>depsMap.delete(key)));
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, dep, void 0);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $8POXm.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8POXm.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const dep of deps)if (dep) $005d1fb7704e278c$var$triggerEffects(dep, 4, void 0);
    $005d1fb7704e278c$export$3539fa10306ef581();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            $005d1fb7704e278c$export$262a949f95482a17();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$3539fa10306ef581();
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $8POXm.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
const $005d1fb7704e278c$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(()=>getter(this._value), ()=>$005d1fb7704e278c$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $8POXm.hasChanged)(self._value, self._value = self.effect.run())) $005d1fb7704e278c$var$triggerRefValue(self, 4);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $005d1fb7704e278c$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8POXm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $8POXm.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    var _a;
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $005d1fb7704e278c$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $005d1fb7704e278c$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $8POXm.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, 4, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
const $005d1fb7704e278c$export$483264c4ec4c46ce = $005d1fb7704e278c$export$2983e091f1a1e8e2;
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
/**
* @vue/shared v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("TusQn")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
/**
* @vue/runtime-dom v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $8POXm.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8POXm.isArray)(value)) el.checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});



parcelRegister("fXVTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f946cac51a0463$export$2e2bcd8739ae039);
let $b9f946cac51a0463$var$NOOP = ()=>{};
var $b9f946cac51a0463$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("75Mox", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $529e8a390f310e39$export$2e2bcd8739ae039);

var $2tmqH = parcelRequire("2tmqH");

var $iBtob = parcelRequire("iBtob");
var $529e8a390f310e39$export$2e2bcd8739ae039 = {
    name: "Login",
    mounted () {
        this.getLogin();
    },
    data () {
        return {
            input: {
                userName: "",
                password: ""
            }
        };
    },
    computed: {
        redirectTarget () {
            const query = this.$route.query.returnUrl;
            if (query && query.length > 0) return query;
            return "/dataspaces";
        }
    },
    methods: {
        async getLogin () {
            (0, $iBtob.ResetAuthCache)();
            let login = await (0, $2tmqH.default).auth();
            if (login.isAuthenticated) this.$router.replace(this.redirectTarget);
        },
        async login () {
            let { userName: userName, password: password } = this.input;
            let login = await (0, $2tmqH.default).login(userName, password);
            (0, $iBtob.ResetAuthCache)();
            if (login.succeeded) this.$router.replace(this.redirectTarget);
            else {
                let doc = document.getElementById("alert");
                doc.classList.remove("hidden");
            }
        }
    }
};

});
parcelRegister("2tmqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ccfb03dfbd54f9d$export$2e2bcd8739ae039);

var $2xZ6Q = parcelRequire("2xZ6Q");
const $1ccfb03dfbd54f9d$var$AuthorizationApi = {
    auth: async ()=>{
        const req = (0, $2xZ6Q.default).get(`/api/auth/signin`);
        const res = await req;
        return res.body;
    },
    login: async (userName, password)=>{
        const req = (0, $2xZ6Q.default).post(`/api/auth/signin`).send({
            userName: userName,
            password: password
        });
        const res = await req;
        return res.body;
    },
    logout: async ()=>{
        const req = (0, $2xZ6Q.default).get(`/api/auth/signout`);
        const res = await req;
        return res.body;
    }
};
var $1ccfb03dfbd54f9d$export$2e2bcd8739ae039 = $1ccfb03dfbd54f9d$var$AuthorizationApi;

});
parcelRegister("2xZ6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dae10df63e4f8ee$export$2e2bcd8739ae039);

var $6gZo1 = parcelRequire("6gZo1");
let $1dae10df63e4f8ee$var$serverBase = "";
const $1dae10df63e4f8ee$var$request = {
    get: (url)=>{
        return $6gZo1.get($1dae10df63e4f8ee$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    post: (url)=>{
        return $6gZo1.post($1dae10df63e4f8ee$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    postMultipart: (url)=>{
        return $6gZo1.post($1dae10df63e4f8ee$var$serverBase + url).withCredentials().set("Accept", "application/json");
    },
    put: (url)=>{
        return $6gZo1.put($1dae10df63e4f8ee$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    patch: (url)=>{
        return $6gZo1.patch($1dae10df63e4f8ee$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    },
    delete: (url)=>{
        return $6gZo1.delete($1dae10df63e4f8ee$var$serverBase + url).withCredentials().set("Accept", "application/json").set("Content-Type", "application/json");
    }
};
var $1dae10df63e4f8ee$export$2e2bcd8739ae039 = $1dae10df63e4f8ee$var$request;

});
parcelRegister("6gZo1", function(module, exports) {
"use strict";
/**
 * Root reference for iframes.
 */ let root;
if (typeof window !== "undefined") // Browser window
root = window;
else if (typeof self === "undefined") {
    // Other environments
    console.warn("Using browser-only version of superagent in non-browser environment");
    root = void 0;
} else // Web Worker
root = self;

var $9yRAu = parcelRequire("9yRAu");

var $hgGe6 = parcelRequire("hgGe6");

var $2rasJ = parcelRequire("2rasJ");

var $hli7k = parcelRequire("hli7k");

var $ess0W = parcelRequire("ess0W");
var $4913dac236115adc$require$isObject = $ess0W.isObject;
var $4913dac236115adc$require$mixin = $ess0W.mixin;
var $4913dac236115adc$require$hasOwn = $ess0W.hasOwn;

var $8GXcX = parcelRequire("8GXcX");

var $7fj1N = parcelRequire("7fj1N");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ module.exports = function(method, url) {
    // callback
    if (typeof url === "function") return new exports.Request("GET", method).end(url);
    // url first
    if (arguments.length === 1) return new exports.Request("GET", method);
    return new exports.Request(method, url);
};
exports = module.exports;
const request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */ request.getXHR = ()=>{
    if (root.XMLHttpRequest) return new root.XMLHttpRequest();
    throw new Error("Browser-only version of superagent could not find XHR");
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ const trim = "".trim ? (s)=>s.trim() : (s)=>s.replace(/(^\s*|\s*$)/g, "");
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(object) {
    if (!$4913dac236115adc$require$isObject(object)) return object;
    const pairs = [];
    for(const key in object)if ($4913dac236115adc$require$hasOwn(object, key)) pushEncodedKeyValuePair(pairs, key, object[key]);
    return pairs.join("&");
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, value) {
    if (value === undefined) return;
    if (value === null) {
        pairs.push(encodeURI(key));
        return;
    }
    if (Array.isArray(value)) for (const v of value)pushEncodedKeyValuePair(pairs, key, v);
    else if ($4913dac236115adc$require$isObject(value)) {
        for(const subkey in value)if ($4913dac236115adc$require$hasOwn(value, subkey)) pushEncodedKeyValuePair(pairs, `${key}[${subkey}]`, value[subkey]);
    } else pairs.push(encodeURI(key) + "=" + encodeURIComponent(value));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseString(string_) {
    const object = {};
    const pairs = string_.split("&");
    let pair;
    let pos;
    for(let i = 0, length_ = pairs.length; i < length_; ++i){
        pair = pairs[i];
        pos = pair.indexOf("=");
        if (pos === -1) object[decodeURIComponent(pair)] = "";
        else object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return object;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: "text/html",
    json: "application/json",
    xml: "text/xml",
    urlencoded: "application/x-www-form-urlencoded",
    form: "application/x-www-form-urlencoded",
    "form-data": "application/x-www-form-urlencoded"
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    "application/x-www-form-urlencoded": $2rasJ.stringify,
    "application/json": $hgGe6
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */ request.parse = {
    "application/x-www-form-urlencoded": parseString,
    "application/json": JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(string_) {
    const lines = string_.split(/\r?\n/);
    const fields = {};
    let index;
    let line;
    let field;
    let value;
    for(let i = 0, length_ = lines.length; i < length_; ++i){
        line = lines[i];
        index = line.indexOf(":");
        if (index === -1) continue;
        field = line.slice(0, index).toLowerCase();
        value = trim(line.slice(index + 1));
        fields[field] = value;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    // should match /json or +json
    // but not /json-seq
    return /[/+]json($|[^-\w])/i.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(request_) {
    this.req = request_;
    this.xhr = this.req.xhr;
    // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method !== "HEAD" && (this.xhr.responseType === "" || this.xhr.responseType === "text") || typeof this.xhr.responseType === "undefined" ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    let { status } = this.xhr;
    // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    this._setStatusProperties(status);
    this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    this.header = this.headers;
    // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header["content-type"] = this.xhr.getResponseHeader("content-type");
    this._setHeaderProperties(this.header);
    if (this.text === null && request_._responseType) this.body = this.xhr.response;
    else this.body = this.req.method === "HEAD" ? null : this._parseBody(this.text ? this.text : this.xhr.response);
}
$4913dac236115adc$require$mixin(Response.prototype, $8GXcX.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(string_) {
    let parse = request.parse[this.type];
    if (this.req._parser) return this.req._parser(this, string_);
    if (!parse && isJSON(this.type)) parse = request.parse["application/json"];
    return parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    const { req } = this;
    const { method } = req;
    const { url } = req;
    const message = `cannot ${method} ${url} (${this.status})`;
    const error = new Error(message);
    error.status = this.status;
    error.method = method;
    error.url = url;
    return error;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    const self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on("end", ()=>{
        let error = null;
        let res = null;
        try {
            res = new Response(self1);
        } catch (err) {
            error = new Error("Parser is unable to parse the response");
            error.parse = true;
            error.original = err;
            // issue #675: return the raw response if the response parsing fails
            if (self1.xhr) {
                // ie9 doesn't have 'response' property
                error.rawResponse = typeof self1.xhr.responseType === "undefined" ? self1.xhr.responseText : self1.xhr.response;
                // issue #876: return the http status code if the response parsing fails
                error.status = self1.xhr.status ? self1.xhr.status : null;
                error.statusCode = error.status; // backwards-compat only
            } else {
                error.rawResponse = null;
                error.status = null;
            }
            return self1.callback(error);
        }
        self1.emit("response", res);
        let new_error;
        try {
            if (!self1._isResponseOK(res)) new_error = new Error(res.statusText || res.text || "Unsuccessful HTTP response");
        } catch (err) {
            new_error = err; // ok() callback can throw
        }
        // #1000 don't catch errors from the callback to avoid double calling it
        if (new_error) {
            new_error.original = error;
            new_error.response = res;
            new_error.status = new_error.status || res.status;
            self1.callback(new_error, res);
        } else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */ // eslint-disable-next-line new-cap
$9yRAu(Request.prototype);
$4913dac236115adc$require$mixin(Request.prototype, $hli7k.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set("Content-Type", request.types[type] || type);
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set("Accept", request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (arguments.length === 1) pass = "";
    if (typeof pass === "object" && pass !== null) {
        // pass is optional and can be replaced with options
        options = pass;
        pass = "";
    }
    if (!options) options = {
        type: typeof btoa === "function" ? "basic" : "auto"
    };
    const encoder = options.encoder ? options.encoder : (string)=>{
        if (typeof btoa === "function") return btoa(string);
        throw new Error("Cannot use basic auth, btoa is not a function");
    };
    return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.query = function(value) {
    if (typeof value !== "string") value = serialize(value);
    if (value) this._query.push(value);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, options) {
    if (file) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(field, file, options || file.name);
    }
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(error, res) {
    if (this._shouldRetry(error, res)) return this._retry();
    const fn = this._callback;
    this.clearTimeout();
    if (error) {
        if (this._maxRetries) error.retries = this._retries - 1;
        this.emit("error", error);
    }
    fn(error, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    const error = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
    error.crossDomain = true;
    error.status = this.status;
    error.method = this.method;
    error.url = this.url;
    this.callback(error);
};
// This only warns, because the request is still likely to work
Request.prototype.agent = function() {
    console.warn("This is not supported in browser version of superagent");
    return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca;
// This throws, because it can't send/receive data as expected
Request.prototype.write = ()=>{
    throw new Error("Streaming is not supported in browser version of superagent");
};
Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */ Request.prototype._isHost = function(object) {
    // Native objects stringify to [object File], [object Blob], [object FormData], etc.
    return object && typeof object === "object" && !Array.isArray(object) && Object.prototype.toString.call(object) !== "[object Object]";
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    if (this._endCalled) console.warn("Warning: .end() was called twice. This is not supported in superagent");
    this._endCalled = true;
    // store callback
    this._callback = fn || noop;
    // querystring
    this._finalizeQueryString();
    this._end();
};
Request.prototype._setUploadTimeout = function() {
    const self1 = this;
    // upload timeout it's wokrs only if deadline timeout is off
    if (this._uploadTimeout && !this._uploadTimeoutTimer) this._uploadTimeoutTimer = setTimeout(()=>{
        self1._timeoutError("Upload timeout of ", self1._uploadTimeout, "ETIMEDOUT");
    }, this._uploadTimeout);
};
// eslint-disable-next-line complexity
Request.prototype._end = function() {
    if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
    const self1 = this;
    this.xhr = request.getXHR();
    const { xhr } = this;
    let data = this._formData || this._data;
    this._setTimeouts();
    // state change
    xhr.addEventListener("readystatechange", ()=>{
        const { readyState } = xhr;
        if (readyState >= 2 && self1._responseTimeoutTimer) clearTimeout(self1._responseTimeoutTimer);
        if (readyState !== 4) return;
        // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        let status;
        try {
            status = xhr.status;
        } catch (err) {
            status = 0;
        }
        if (!status) {
            if (self1.timedout || self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit("end");
    });
    // progress
    const handleProgress = (direction, e)=>{
        if (e.total > 0) {
            e.percent = e.loaded / e.total * 100;
            if (e.percent === 100) clearTimeout(self1._uploadTimeoutTimer);
        }
        e.direction = direction;
        self1.emit("progress", e);
    };
    if (this.hasListeners("progress")) try {
        xhr.addEventListener("progress", handleProgress.bind(null, "download"));
        if (xhr.upload) xhr.upload.addEventListener("progress", handleProgress.bind(null, "upload"));
    } catch (err) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    if (xhr.upload) this._setUploadTimeout();
    // initiate request
    try {
        if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
        else xhr.open(this.method, this.url, true);
    } catch (err) {
        // see #1149
        return this.callback(err);
    }
    // CORS
    if (this._withCredentials) xhr.withCredentials = true;
    // body
    if (!this._formData && this.method !== "GET" && this.method !== "HEAD" && typeof data !== "string" && !this._isHost(data)) {
        // serialize stuff
        const contentType = this._header["content-type"];
        let serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];
        if (!serialize && isJSON(contentType)) serialize = request.serialize["application/json"];
        if (serialize) data = serialize(data);
    }
    // set header fields
    for(const field in this.header){
        if (this.header[field] === null) continue;
        if ($4913dac236115adc$require$hasOwn(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
    // send stuff
    this.emit("request", this);
    // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data === "undefined" ? null : data);
};
request.agent = ()=>new $7fj1N();
for (const method of [
    "GET",
    "POST",
    "OPTIONS",
    "PATCH",
    "PUT",
    "DELETE"
])$7fj1N.prototype[method.toLowerCase()] = function(url, fn) {
    const request_ = new request.Request(method, url);
    this._setDefaults(request_);
    if (fn) request_.end(fn);
    return request_;
};
$7fj1N.prototype.del = $7fj1N.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = (url, data, fn)=>{
    const request_ = request("GET", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = (url, data, fn)=>{
    const request_ = request("HEAD", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = (url, data, fn)=>{
    const request_ = request("OPTIONS", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, data, fn) {
    const request_ = request("DELETE", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
}
request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = (url, data, fn)=>{
    const request_ = request("PATCH", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = (url, data, fn)=>{
    const request_ = request("POST", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = (url, data, fn)=>{
    const request_ = request("PUT", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};

});
parcelRegister("9yRAu", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $6f60db6a5819cdac$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $6f60db6a5819cdac$var$Emitter(obj) {
    if (obj) return $6f60db6a5819cdac$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $6f60db6a5819cdac$var$mixin(obj) {
    for(var key in $6f60db6a5819cdac$var$Emitter.prototype)obj[key] = $6f60db6a5819cdac$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.on = $6f60db6a5819cdac$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.off = $6f60db6a5819cdac$var$Emitter.prototype.removeListener = $6f60db6a5819cdac$var$Emitter.prototype.removeAllListeners = $6f60db6a5819cdac$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $6f60db6a5819cdac$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $6f60db6a5819cdac$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("hgGe6", function(module, exports) {
module.exports = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.default = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.stable = $c924af90aa582a4d$var$deterministicStringify;
$c924af90aa582a4d$var$stringify.stableStringify = $c924af90aa582a4d$var$deterministicStringify;
var $c924af90aa582a4d$var$LIMIT_REPLACE_NODE = "[...]";
var $c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $c924af90aa582a4d$var$arr = [];
var $c924af90aa582a4d$var$replacerStack = [];
function $c924af90aa582a4d$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $c924af90aa582a4d$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    $c924af90aa582a4d$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $c924af90aa582a4d$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $c924af90aa582a4d$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $c924af90aa582a4d$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $c924af90aa582a4d$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $c924af90aa582a4d$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $c924af90aa582a4d$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    var tmp = $c924af90aa582a4d$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($c924af90aa582a4d$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $c924af90aa582a4d$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $c924af90aa582a4d$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($c924af90aa582a4d$var$replacerStack.length > 0) for(var i = 0; i < $c924af90aa582a4d$var$replacerStack.length; i++){
            var part = $c924af90aa582a4d$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $c924af90aa582a4d$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});




parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $iBfJ5.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});


parcelRegister("hli7k", function(module, exports) {
"use strict";

var $ess0W = parcelRequire("ess0W");
var $ca02738322db5140$require$isObject = $ess0W.isObject;
var $ca02738322db5140$require$hasOwn = $ess0W.hasOwn;
/**
 * Expose `RequestBase`.
 */ module.exports = $ca02738322db5140$var$RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */ function $ca02738322db5140$var$RequestBase() {}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.clearTimeout = function() {
    clearTimeout(this._timer);
    clearTimeout(this._responseTimeoutTimer);
    clearTimeout(this._uploadTimeoutTimer);
    delete this._timer;
    delete this._responseTimeoutTimer;
    delete this._uploadTimeoutTimer;
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.parse = function(fn) {
    this._parser = fn;
    return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.responseType = function(value) {
    this._responseType = value;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.serialize = function(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.timeout = function(options) {
    if (!options || typeof options !== "object") {
        this._timeout = options;
        this._responseTimeout = 0;
        this._uploadTimeout = 0;
        return this;
    }
    for(const option in options)if ($ca02738322db5140$require$hasOwn(options, option)) switch(option){
        case "deadline":
            this._timeout = options.deadline;
            break;
        case "response":
            this._responseTimeout = options.response;
            break;
        case "upload":
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn("Unknown timeout option", option);
    }
    return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.retry = function(count, fn) {
    // Default to 1 if no count passed or true
    if (arguments.length === 0 || count === true) count = 1;
    if (count <= 0) count = 0;
    this._maxRetries = count;
    this._retries = 0;
    this._retryCallback = fn;
    return this;
};
//
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
const $ca02738322db5140$var$ERROR_CODES = new Set([
    "ETIMEDOUT",
    "ECONNRESET",
    "EADDRINUSE",
    "ECONNREFUSED",
    "EPIPE",
    "ENOTFOUND",
    "ENETUNREACH",
    "EAI_AGAIN"
]);
const $ca02738322db5140$var$STATUS_CODES = new Set([
    408,
    413,
    429,
    500,
    502,
    503,
    504,
    521,
    522,
    524
]);
// TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);
/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */ $ca02738322db5140$var$RequestBase.prototype._shouldRetry = function(error, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return false;
    if (this._retryCallback) try {
        const override = this._retryCallback(error, res);
        if (override === true) return true;
        if (override === false) return false;
    // undefined falls back to defaults
    } catch (err) {
        console.error(err);
    }
    // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
    /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */ if (res && res.status && $ca02738322db5140$var$STATUS_CODES.has(res.status)) return true;
    if (error) {
        if (error.code && $ca02738322db5140$var$ERROR_CODES.has(error.code)) return true;
        // Superagent timeout
        if (error.timeout && error.code === "ECONNABORTED") return true;
        if (error.crossDomain) return true;
    }
    return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */ $ca02738322db5140$var$RequestBase.prototype._retry = function() {
    this.clearTimeout();
    // node
    if (this.req) {
        this.req = null;
        this.req = this.request();
    }
    this._aborted = false;
    this.timedout = false;
    this.timedoutError = null;
    return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */ $ca02738322db5140$var$RequestBase.prototype.then = function(resolve, reject) {
    if (!this._fullfilledPromise) {
        const self = this;
        if (this._endCalled) console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
        this._fullfilledPromise = new Promise((resolve, reject)=>{
            self.on("abort", ()=>{
                if (this._maxRetries && this._maxRetries > this._retries) return;
                if (this.timedout && this.timedoutError) {
                    reject(this.timedoutError);
                    return;
                }
                const error = new Error("Aborted");
                error.code = "ABORTED";
                error.status = this.status;
                error.method = this.method;
                error.url = this.url;
                reject(error);
            });
            self.end((error, res)=>{
                if (error) reject(error);
                else resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
$ca02738322db5140$var$RequestBase.prototype.catch = function(callback) {
    return this.then(undefined, callback);
};
/**
 * Allow for extension
 */ $ca02738322db5140$var$RequestBase.prototype.use = function(fn) {
    fn(this);
    return this;
};
$ca02738322db5140$var$RequestBase.prototype.ok = function(callback) {
    if (typeof callback !== "function") throw new Error("Callback required");
    this._okCallback = callback;
    return this;
};
$ca02738322db5140$var$RequestBase.prototype._isResponseOK = function(res) {
    if (!res) return false;
    if (this._okCallback) return this._okCallback(res);
    return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ $ca02738322db5140$var$RequestBase.prototype.getHeader = $ca02738322db5140$var$RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.set = function(field, value) {
    if ($ca02738322db5140$require$isObject(field)) {
        for(const key in field)if ($ca02738322db5140$require$hasOwn(field, key)) this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = value;
    this.header[field] = value;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */ $ca02738322db5140$var$RequestBase.prototype.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @param {String} options extra options, e.g. 'blob'
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.field = function(name, value, options) {
    // name should be either a string or an object.
    if (name === null || undefined === name) throw new Error(".field(name, val) name can not be empty");
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($ca02738322db5140$require$isObject(name)) {
        for(const key in name)if ($ca02738322db5140$require$hasOwn(name, key)) this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(value)) {
        for(const i in value)if ($ca02738322db5140$require$hasOwn(value, i)) this.field(name, value[i]);
        return this;
    }
    // val should be defined now
    if (value === null || undefined === value) throw new Error(".field(name, val) val can not be empty");
    if (typeof value === "boolean") value = String(value);
    // fix https://github.com/ladjs/superagent/issues/1680
    if (options) this._getFormData().append(name, value, options);
    else this._getFormData().append(name, value);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    if (this.xhr) this.xhr.abort(); // browser
    if (this.req) this.req.abort(); // node
    this.clearTimeout();
    this.emit("abort");
    return this;
};
$ca02738322db5140$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case "basic":
            this.set("Authorization", `Basic ${base64Encoder(`${user}:${pass}`)}`);
            break;
        case "auto":
            this.username = user;
            this.password = pass;
            break;
        case "bearer":
            // usage would be .auth(accessToken, { type: 'bearer' })
            this.set("Authorization", `Bearer ${user}`);
            break;
        default:
            break;
    }
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 * @param {Boolean} [on=true] - Set 'withCredentials' state
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.withCredentials = function(on) {
    // This is browser-only functionality. Node side is no-op.
    if (on === undefined) on = true;
    this._withCredentials = on;
    return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */ $ca02738322db5140$var$RequestBase.prototype.maxResponseSize = function(n) {
    if (typeof n !== "number") throw new TypeError("Invalid argument");
    this._maxResponseSize = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ // eslint-disable-next-line complexity
$ca02738322db5140$var$RequestBase.prototype.send = function(data) {
    const isObject_ = $ca02738322db5140$require$isObject(data);
    let type = this._header["content-type"];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObject_ && !this._data) {
        if (Array.isArray(data)) this._data = [];
        else if (!this._isHost(data)) this._data = {};
    } else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
    // merge
    if (isObject_ && $ca02738322db5140$require$isObject(this._data)) for(const key in data){
        if (typeof data[key] == "bigint" && !data[key].toJSON) throw new Error("Cannot serialize BigInt value to json");
        if ($ca02738322db5140$require$hasOwn(data, key)) this._data[key] = data[key];
    }
    else if (typeof data === "bigint") throw new Error("Cannot send value of type BigInt");
    else if (typeof data === "string") {
        // default to x-www-form-urlencoded
        if (!type) this.type("form");
        type = this._header["content-type"];
        if (type) type = type.toLowerCase().trim();
        if (type === "application/x-www-form-urlencoded") this._data = this._data ? `${this._data}&${data}` : data;
        else this._data = (this._data || "") + data;
    } else this._data = data;
    if (!isObject_ || this._isHost(data)) return this;
    // default to json
    if (!type) this.type("json");
    return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */ $ca02738322db5140$var$RequestBase.prototype.sortQuery = function(sort) {
    // _sort default to true but otherwise can be a function or boolean
    this._sort = typeof sort === "undefined" ? true : sort;
    return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ $ca02738322db5140$var$RequestBase.prototype._finalizeQueryString = function() {
    const query = this._query.join("&");
    if (query) this.url += (this.url.includes("?") ? "&" : "?") + query;
    this._query.length = 0; // Makes the call idempotent
    if (this._sort) {
        const index = this.url.indexOf("?");
        if (index >= 0) {
            const queryArray = this.url.slice(index + 1).split("&");
            if (typeof this._sort === "function") queryArray.sort(this._sort);
            else queryArray.sort();
            this.url = this.url.slice(0, index) + "?" + queryArray.join("&");
        }
    }
};
// For backwards compat only
$ca02738322db5140$var$RequestBase.prototype._appendQueryString = ()=>{
    console.warn("Unsupported");
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ $ca02738322db5140$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (this._aborted) return;
    const error = new Error(`${reason + timeout}ms exceeded`);
    error.timeout = timeout;
    error.code = "ECONNABORTED";
    error.errno = errno;
    this.timedout = true;
    this.timedoutError = error;
    this.abort();
    this.callback(error);
};
$ca02738322db5140$var$RequestBase.prototype._setTimeouts = function() {
    const self = this;
    // deadline
    if (this._timeout && !this._timer) this._timer = setTimeout(()=>{
        self._timeoutError("Timeout of ", self._timeout, "ETIME");
    }, this._timeout);
    // response timeout
    if (this._responseTimeout && !this._responseTimeoutTimer) this._responseTimeoutTimer = setTimeout(()=>{
        self._timeoutError("Response timeout of ", self._responseTimeout, "ETIMEDOUT");
    }, this._responseTimeout);
};

});
parcelRegister("ess0W", function(module, exports) {

$parcel$export(module.exports, "type", () => $a869694114aee2b5$export$bf9fb029d174d554, (v) => $a869694114aee2b5$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "params", () => $a869694114aee2b5$export$281ad3752a540efe, (v) => $a869694114aee2b5$export$281ad3752a540efe = v);
$parcel$export(module.exports, "parseLinks", () => $a869694114aee2b5$export$255722312ba7ba74, (v) => $a869694114aee2b5$export$255722312ba7ba74 = v);
$parcel$export(module.exports, "isObject", () => $a869694114aee2b5$export$a6cdc56e425d0d0a, (v) => $a869694114aee2b5$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "hasOwn", () => $a869694114aee2b5$export$b5a638e9b3fff9f3, (v) => $a869694114aee2b5$export$b5a638e9b3fff9f3 = v);
$parcel$export(module.exports, "mixin", () => $a869694114aee2b5$export$e36fc9d62a853069, (v) => $a869694114aee2b5$export$e36fc9d62a853069 = v);
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ var $a869694114aee2b5$export$bf9fb029d174d554;
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $a869694114aee2b5$export$281ad3752a540efe;
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $a869694114aee2b5$export$255722312ba7ba74;
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */ var $a869694114aee2b5$export$bbc652556e2dc9ed;
/**
 * Check if `obj` is an object.
 *
 * @param {Object} object
 * @return {Boolean}
 * @api private
 */ var $a869694114aee2b5$export$a6cdc56e425d0d0a;
/**
 * Object.hasOwn fallback/polyfill.
 *
 * @type {(object: object, property: string) => boolean} object
 * @api private
 */ var $a869694114aee2b5$export$b5a638e9b3fff9f3;
var $a869694114aee2b5$export$e36fc9d62a853069;
"use strict";
$a869694114aee2b5$export$bf9fb029d174d554 = (string_)=>string_.split(/ *; */).shift();
$a869694114aee2b5$export$281ad3752a540efe = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *; */)){
        const parts = string_.split(/ *= */);
        const key = parts.shift();
        const value = parts.shift();
        if (key && value) object[key] = value;
    }
    return object;
};
$a869694114aee2b5$export$255722312ba7ba74 = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *, */)){
        const parts = string_.split(/ *; */);
        const url = parts[0].slice(1, -1);
        const rel = parts[1].split(/ *= */)[1].slice(1, -1);
        object[rel] = url;
    }
    return object;
};
$a869694114aee2b5$export$bbc652556e2dc9ed = (header, changesOrigin)=>{
    delete header["content-type"];
    delete header["content-length"];
    delete header["transfer-encoding"];
    delete header.host;
    // secuirty
    if (changesOrigin) {
        delete header.authorization;
        delete header.cookie;
    }
    return header;
};
$a869694114aee2b5$export$a6cdc56e425d0d0a = (object)=>{
    return object !== null && typeof object === "object";
};
$a869694114aee2b5$export$b5a638e9b3fff9f3 = Object.hasOwn || function(object, property) {
    if (object == null) throw new TypeError("Cannot convert undefined or null to object");
    return Object.prototype.hasOwnProperty.call(new Object(object), property);
};
$a869694114aee2b5$export$e36fc9d62a853069 = (target, source)=>{
    for(const key in source)if ($a869694114aee2b5$export$b5a638e9b3fff9f3(source, key)) target[key] = source[key];
};

});


parcelRegister("8GXcX", function(module, exports) {
"use strict";

var $ess0W = parcelRequire("ess0W");
/**
 * Expose `ResponseBase`.
 */ module.exports = $65402c774823aef2$var$ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */ function $65402c774823aef2$var$ResponseBase() {}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $65402c774823aef2$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ $65402c774823aef2$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    // TODO: moar!
    // TODO: make this a util
    // content-type
    const ct = header["content-type"] || "";
    this.type = $ess0W.type(ct);
    // params
    const parameters = $ess0W.params(ct);
    for(const key in parameters)if (Object.prototype.hasOwnProperty.call(parameters, key)) this[key] = parameters[key];
    this.links = {};
    // links
    try {
        if (header.link) this.links = $ess0W.parseLinks(header.link);
    } catch (err) {
    // ignore
    }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ $65402c774823aef2$var$ResponseBase.prototype._setStatusProperties = function(status) {
    const type = Math.trunc(status / 100);
    // status / class
    this.statusCode = status;
    this.status = this.statusCode;
    this.statusType = type;
    // basics
    this.info = type === 1;
    this.ok = type === 2;
    this.redirect = type === 3;
    this.clientError = type === 4;
    this.serverError = type === 5;
    this.error = type === 4 || type === 5 ? this.toError() : false;
    // sugar
    this.created = status === 201;
    this.accepted = status === 202;
    this.noContent = status === 204;
    this.badRequest = status === 400;
    this.unauthorized = status === 401;
    this.notAcceptable = status === 406;
    this.forbidden = status === 403;
    this.notFound = status === 404;
    this.unprocessableEntity = status === 422;
};

});

parcelRegister("7fj1N", function(module, exports) {
"use strict";
const $5468b1add91df428$var$defaults = [
    "use",
    "on",
    "once",
    "set",
    "query",
    "type",
    "accept",
    "auth",
    "withCredentials",
    "sortQuery",
    "retry",
    "ok",
    "redirects",
    "timeout",
    "buffer",
    "serialize",
    "parse",
    "ca",
    "key",
    "pfx",
    "cert",
    "disableTLSCerts"
];
class $5468b1add91df428$var$Agent {
    constructor(){
        this._defaults = [];
    }
    _setDefaults(request) {
        for (const def of this._defaults)request[def.fn](...def.args);
    }
}
for (const fn of $5468b1add91df428$var$defaults)// Default setting for all requests from this agent
$5468b1add91df428$var$Agent.prototype[fn] = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    this._defaults.push({
        fn: fn,
        args: args
    });
    return this;
};
module.exports = $5468b1add91df428$var$Agent;

});




parcelRegister("iBtob", function(module, exports) {

$parcel$export(module.exports, "ResetAuthCache", () => $d8b27abca5c36618$export$8cecbc515898cb3f);

var $2tmqH = parcelRequire("2tmqH");
let $d8b27abca5c36618$var$authCache = null;
var $d8b27abca5c36618$var$fetchUserInfo = async function() {
    if (!$d8b27abca5c36618$var$authCache) $d8b27abca5c36618$var$authCache = await (0, $2tmqH.default).auth();
    return $d8b27abca5c36618$var$authCache || {};
};
function $d8b27abca5c36618$export$8cecbc515898cb3f() {
    $d8b27abca5c36618$var$authCache = null;
}
async function $d8b27abca5c36618$export$5eac103c3c4b4319() {
    let auth = await $d8b27abca5c36618$var$fetchUserInfo();
    auth.userrole;
}
$d8b27abca5c36618$export$5eac103c3c4b4319;
async function $d8b27abca5c36618$export$b9a732e5b403b682() {
    let auth = await $d8b27abca5c36618$var$fetchUserInfo();
    return auth.userrole == "LyzarEditor" || auth.userrole == "Admin";
}

});


parcelRegister("dBFVp", function(module, exports) {

$parcel$export(module.exports, "render", () => $9e7f408006a78f26$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

var $4YlRB = parcelRequire("4YlRB");

var $a0lo7 = parcelRequire("a0lo7");
const $9e7f408006a78f26$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "header"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
        href: "/"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4YlRB))),
            alt: "Logo",
            class: "logo"
        })
    ])
], -1);
const $9e7f408006a78f26$var$_hoisted_2 = {
    class: "form-signin"
};
const $9e7f408006a78f26$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
    style: {
        "width": "50%"
    },
    class: "loginLogo",
    src: (0, (/*@__PURE__*/$parcel$interopDefault($a0lo7)))
}, null, -1);
const $9e7f408006a78f26$var$_hoisted_4 = {
    class: "h3 mb-3 font-weight-normal",
    style: {
        "text-align": "center",
        "padding-top": "30px"
    }
};
const $9e7f408006a78f26$var$_hoisted_5 = {
    id: "alert",
    class: "text-align: center alert alert-danger alert-dismissible hidden"
};
const $9e7f408006a78f26$var$_hoisted_6 = {
    for: "inputUserName",
    class: "sr-only"
};
const $9e7f408006a78f26$var$_hoisted_7 = [
    "placeholder"
];
const $9e7f408006a78f26$var$_hoisted_8 = {
    for: "inputPassword",
    class: "sr-only"
};
const $9e7f408006a78f26$var$_hoisted_9 = [
    "placeholder"
];
function $9e7f408006a78f26$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        $9e7f408006a78f26$var$_hoisted_1,
        (0, $TusQn.createElementVNode)("div", $9e7f408006a78f26$var$_hoisted_2, [
            $9e7f408006a78f26$var$_hoisted_3,
            (0, $TusQn.createElementVNode)("h1", $9e7f408006a78f26$var$_hoisted_4, (0, $8POXm.toDisplayString)(_ctx.$t("pleaseSignIn")), 1),
            (0, $TusQn.createElementVNode)("div", $9e7f408006a78f26$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("incorrectUserOrPassword")), 1),
            (0, $TusQn.createElementVNode)("label", $9e7f408006a78f26$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("email")), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                onKeyup: _cache[0] || (_cache[0] = (0, $eeJ70.withKeys)((...args)=>$options.login && $options.login(...args), [
                    "enter"
                ])),
                type: "userName",
                id: "inputUserName",
                class: "form-control",
                placeholder: _ctx.$t("enterLogin"),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.input.userName = $event),
                required: "",
                autofocus: ""
            }, null, 40, $9e7f408006a78f26$var$_hoisted_7), [
                [
                    (0, $eeJ70.vModelText),
                    $data.input.userName
                ]
            ]),
            (0, $TusQn.createElementVNode)("label", $9e7f408006a78f26$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("password")), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                onKeyup: _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((...args)=>$options.login && $options.login(...args), [
                    "enter"
                ])),
                type: "password",
                id: "inputPassword",
                class: "form-control",
                placeholder: _ctx.$t("enterPassword"),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.input.password = $event),
                required: ""
            }, null, 40, $9e7f408006a78f26$var$_hoisted_9), [
                [
                    (0, $eeJ70.vModelText),
                    $data.input.password
                ]
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-lg btn-primary btn-block",
                onClick: _cache[4] || (_cache[4] = (...args)=>$options.login && $options.login(...args))
            }, (0, $8POXm.toDisplayString)(_ctx.$t("signIn")), 1)
        ])
    ]);
}

});
parcelRegister("4YlRB", function(module, exports) {
module.exports = new URL("header-logo.dccf98dc.png", import.meta.url).toString();

});

parcelRegister("a0lo7", function(module, exports) {
module.exports = new URL("login_logo.d02bed8d.png", import.meta.url).toString();

});


parcelRegister("eMOAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac3cca372c0665ce$export$2e2bcd8739ae039);
let $ac3cca372c0665ce$var$NOOP = ()=>{};
var $ac3cca372c0665ce$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("iHldJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d9ccb4121e99d270$export$2e2bcd8739ae039);

var $5jPJV = parcelRequire("5jPJV");
var $d9ccb4121e99d270$export$2e2bcd8739ae039 = {
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.list = await (0, $5jPJV.default).list();
        },
        checkIfActive (name) {
            var self = this;
            if (self.$route.name == name) return "active";
        }
    },
    data () {
        return {
            list: []
        };
    }
};

});
parcelRegister("5jPJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3df6dc8816b45691$export$2e2bcd8739ae039);

var $2xZ6Q = parcelRequire("2xZ6Q");
const $3df6dc8816b45691$var$UserApi = {
    list: async ()=>{
        const req = (0, $2xZ6Q.default).get(`/api/user`);
        const res = await req;
        return res.body;
    },
    detail: async (user)=>{
        const req = (0, $2xZ6Q.default).get(`/api/user/${user}`);
        const res = await req;
        return res.body;
    },
    setPassword: async (id, password)=>{
        const req = (0, $2xZ6Q.default).put(`/api/user/${id}/resetpassword`).send(password);
        const res = await req;
        return res.body;
    },
    update: async (user)=>{
        const req = (0, $2xZ6Q.default).put(`/api/user/${user.id}`).send(user);
        const res = await req;
        return res.body;
    },
    create: async (user)=>{
        const req = (0, $2xZ6Q.default).post(`/api/user`).send(user);
        const res = await req;
        return res.body;
    },
    delete: async (userId)=>{
        const req = (0, $2xZ6Q.default).delete(`/api/user/${userId}`);
        await req;
    },
    createLog: async (audit)=>{
        const req = (0, $2xZ6Q.default).post(`/api/user/log`).send(audit);
        const res = await req;
        return res.body;
    }
};
var $3df6dc8816b45691$export$2e2bcd8739ae039 = $3df6dc8816b45691$var$UserApi;

});


parcelRegister("bhXij", function(module, exports) {

$parcel$export(module.exports, "render", () => $837f46dd13bdf6e4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $837f46dd13bdf6e4$var$_hoisted_1 = {
    class: "container py-5"
};
const $837f46dd13bdf6e4$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $837f46dd13bdf6e4$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $837f46dd13bdf6e4$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $837f46dd13bdf6e4$var$_hoisted_5 = {
    key: 0,
    class: "breadcrumb-item"
};
const $837f46dd13bdf6e4$var$_hoisted_6 = {
    key: 1,
    class: "breadcrumb-item"
};
const $837f46dd13bdf6e4$var$_hoisted_7 = {
    key: 2,
    class: "breadcrumb-item"
};
const $837f46dd13bdf6e4$var$_hoisted_8 = {
    class: "row"
};
const $837f46dd13bdf6e4$var$_hoisted_9 = {
    class: "col-3"
};
const $837f46dd13bdf6e4$var$_hoisted_10 = {
    class: "nav flex-column nav-pills",
    id: "v-pills-tab",
    role: "tablist",
    "aria-orientation": "vertical"
};
const $837f46dd13bdf6e4$var$_hoisted_11 = {
    class: "col-9"
};
const $837f46dd13bdf6e4$var$_hoisted_12 = {
    class: "tab-content",
    id: "v-pills-tabContent"
};
function $837f46dd13bdf6e4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $837f46dd13bdf6e4$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("settings")), 1),
        (0, $TusQn.createElementVNode)("nav", $837f46dd13bdf6e4$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $837f46dd13bdf6e4$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $837f46dd13bdf6e4$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/dataspaces"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                this.$route.name === "dataspaces" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $837f46dd13bdf6e4$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("dataspaces")), 1)) : this.$route.name === "users" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $837f46dd13bdf6e4$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)) : this.$route.name === "groups" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $837f46dd13bdf6e4$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $837f46dd13bdf6e4$var$_hoisted_8, [
            (0, $TusQn.createElementVNode)("div", $837f46dd13bdf6e4$var$_hoisted_9, [
                (0, $TusQn.createElementVNode)("div", $837f46dd13bdf6e4$var$_hoisted_10, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/dataspaces",
                        class: (0, $8POXm.normalizeClass)([
                            "nav-link",
                            this.checkIfActive("dataspaces")
                        ]),
                        id: "dataspaces",
                        "data-toggle": "pill",
                        role: "tab",
                        href: "#dataspaces",
                        "aria-controls": "dataspaces",
                        "aria-selected": "false"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dataspaces")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "class"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/users",
                        id: "users",
                        "data-toggle": "pill",
                        role: "tab",
                        "aria-selected": "true",
                        href: "#users",
                        class: (0, $8POXm.normalizeClass)([
                            "nav-link",
                            this.checkIfActive("users")
                        ])
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "class"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/groups",
                        class: (0, $8POXm.normalizeClass)([
                            "nav-link",
                            this.checkIfActive("groups")
                        ]),
                        id: "groups",
                        "data-toggle": "pill",
                        role: "tab",
                        "aria-controls": "groups",
                        "aria-selected": "false"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "class"
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $837f46dd13bdf6e4$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("div", $837f46dd13bdf6e4$var$_hoisted_12, [
                    (0, $TusQn.createVNode)(_component_router_view)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("9ucT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e80e99fd30a4420$export$2e2bcd8739ae039);
let $6e80e99fd30a4420$var$NOOP = ()=>{};
var $6e80e99fd30a4420$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("dK2mt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a01167337251b98e$export$2e2bcd8739ae039);

var $xXZ2h = parcelRequire("xXZ2h");

var $kds5T = parcelRequire("kds5T");

var $4gHdh = parcelRequire("4gHdh");

var $7ViRs = parcelRequire("7ViRs");

var $9e7n4 = parcelRequire("9e7n4");

var $45fvw = parcelRequire("45fvw");
var $a01167337251b98e$export$2e2bcd8739ae039 = {
    name: "Tables",
    components: {
        ImportModal: $xXZ2h.default,
        TableDeleteModal: $4gHdh.default,
        ReimportModal: $7ViRs.default,
        ExportModal: $9e7n4.default
    },
    data () {
        return {
            tables: [],
            filterInput: "",
            showImport: false,
            showDeleteTableModal: false,
            tableToDeleteName: "",
            showReimport: false,
            reimportItem: null,
            exportTableItem: null,
            showExport: false
        };
    },
    mounted () {
        this.loadTables();
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        },
        filteredTables () {
            if (!this.filterInput) return this.tables;
            const filter = this.filterInput.toLowerCase();
            return this.tables.filter((t)=>t.name.toLowerCase().includes(filter));
        }
    },
    methods: {
        async loadTables () {
            this.showDeleteTableModal = false;
            this.tables = await (0, $kds5T.default).tables(this.$route.params.id);
        },
        exportCsv (item) {
            var request = (0, $kds5T.default).tableExport(this.$route.params.id, item.name);
            window.open(request.url);
        },
        exportShp (item) {
            this.exportTableItem = item;
            this.showExport = true;
        },
        exportItem (item) {
            this.exportTableItem = item;
            this.showExport = true;
        },
        onImported () {
            this.showImport = false;
            this.loadTables();
        },
        showDeleteTable (item) {
            this.tableToDeleteName = item.name;
            this.showDeleteTableModal = true;
        },
        getDate (item) {
            var finalDate = item.reimportedDate;
            if (!finalDate) finalDate = item.createdDate;
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(finalDate).format("DD.MM.YYYY HH:mm");
        },
        getBatchLabel (item) {
            var result = "";
            if (item.batchName) result = item.batchName + " - " + item.origin;
            else result = item.origin;
            return result;
        },
        formatSize (mb) {
            if (mb == null) return "";
            var val = Math.max(1, Math.round(mb));
            return val.toLocaleString("cs-CZ") + " MB";
        },
        formatNumber (num) {
            if (num == null) return "";
            return num.toLocaleString("cs-CZ");
        },
        reimportTable (item) {
            this.reimportItem = item;
            this.showReimport = true;
        },
        closeReimport () {
            this.showReimport = false;
            this.reimportItem = null;
        }
    }
};

});
parcelRegister("xXZ2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $06619ca541d1619b$export$2e2bcd8739ae039);
let $06619ca541d1619b$var$script;



let $06619ca541d1619b$var$initialize = ()=>{
    $06619ca541d1619b$var$script = (parcelRequire("2VsX7"));
    if ($06619ca541d1619b$var$script.__esModule) $06619ca541d1619b$var$script = $06619ca541d1619b$var$script.default;
    $06619ca541d1619b$var$script.render = (parcelRequire("ayi7O")).render;
    (parcelRequire("5M3L6")).default($06619ca541d1619b$var$script);
    $06619ca541d1619b$var$script.__scopeId = "data-v-cd3987";
    $06619ca541d1619b$var$script.__file = "ImportModal.vue";
};
$06619ca541d1619b$var$initialize();
var $06619ca541d1619b$export$2e2bcd8739ae039 = $06619ca541d1619b$var$script;

});
parcelRegister("2VsX7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $22175d0195d2c93f$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");
var $22175d0195d2c93f$export$2e2bcd8739ae039 = {
    name: "CsvImport",
    props: [
        "dataSpaceId"
    ],
    data () {
        return {
            file: null,
            delimiter: ";",
            tableName: "",
            columns: [],
            previewRows: [],
            previewRowCount: 3,
            importing: false,
            errorMessage: "",
            fileType: "",
            files: []
        };
    },
    watch: {
        delimiter () {
            if (this.file) this.parseFile();
        }
    },
    methods: {
        parseFile () {
            const reader = new FileReader();
            console.log(reader);
            reader.onload = (e)=>{
                const header = e.target.result.split(/\r?\n/)[0].split(this.delimiter);
                this.columns = header.map((name, index)=>({
                        index: index,
                        name: name.trim(),
                        dataType: "nvarchar"
                    }));
            };
            reader.readAsText(this.file, "utf-8");
        },
        onFileSelected (event) {
            this.files = Array.from(event.target.files);
            if (!this.files.length) return;
            var ext = this.files[0].name.split(".").pop().toLowerCase();
            if (ext === "csv") {
                this.fileType = "csv";
                this.file = this.files[0];
                this.tableName = this.file.name.replace(/\.[^.]+$/, "");
                this.parseFile();
            } else {
                this.fileType = "shp";
                this.file = null;
                this.tableName = this.files[0].name.replace(/\.[^.]+$/, "");
                this.columns = [];
                this.previewRows = [];
            }
        },
        async submitImport () {
            this.importing = true;
            this.errorMessage = "";
            try {
                const formData = new FormData();
                formData.append("tableName", this.tableName.trim());
                formData.append("fileType", this.fileType);
                if (this.fileType === "shp") this.files.forEach((f)=>formData.append("files", f));
                else {
                    formData.append("file", this.files[0]);
                    formData.append("delimiter", this.delimiter);
                    formData.append("columns", JSON.stringify(this.columns));
                }
                await (0, $kds5T.default).importTable(this.dataSpaceId, formData);
                this.$emit("imported");
            } catch (error) {
                this.importing = false;
                var key = error?.response?.body?.message || "unknownError";
                this.errorMessage = this.$t(key);
            }
        },
        canCreateTable () {
            return !this.importing && !!this.tableName.trim();
        }
    }
};

});
parcelRegister("kds5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7ad06fb4cfbf01$export$2e2bcd8739ae039);

var $2xZ6Q = parcelRequire("2xZ6Q");
const $eb7ad06fb4cfbf01$var$dataspaceApi = {
    dataSpaceList: async ()=>{
        const req = (0, $2xZ6Q.default).get(`/api/dataspace`);
        const res = await req;
        return res.body;
    },
    tables: async (dataSpaceId)=>{
        const req = (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpaceId}/tables`);
        const res = await req;
        return res.body;
    },
    tableExport: (dataSpaceId, tableName)=>{
        const req = (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpaceId}/export/${encodeURIComponent(tableName)}`);
        return req;
    },
    tableShpExport: (dataSpaceId, tableName, query)=>{
        const req = (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpaceId}/export-shp/${encodeURIComponent(tableName)}?${query}`);
        return req;
    },
    dataSpaceDetail: async (dataSpace)=>{
        const req = (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpace}`);
        const res = await req;
        return res.body;
    },
    dataSpaceUpdate: async (dataSpace)=>{
        const req = (0, $2xZ6Q.default).put(`/api/dataspace/${dataSpace.id}`).send(dataSpace);
        const res = await req;
        return res.body;
    },
    dataSpaceCreate: async (dataSpace)=>{
        const req = (0, $2xZ6Q.default).post(`/api/dataspace`).send(dataSpace);
        const res = await req;
        return res.body;
    },
    dataSpaceDelete: async (dataSpaceId)=>{
        const req = (0, $2xZ6Q.default).delete(`/api/dataspace/${dataSpaceId}`);
        await req;
    },
    tableDelete: async (dataSpaceId, sqlTableName)=>{
        await (0, $2xZ6Q.default).delete(`/api/dataspace/${dataSpaceId}/tables/${sqlTableName}`);
    },
    importTable: async (dataSpaceId, formData)=>{
        const res = await (0, $2xZ6Q.default).postMultipart(`/api/dataspace/${dataSpaceId}/import`).send(formData);
        return res.body;
    },
    reimportTable: async (dataSpaceId, tableName, formData)=>{
        const res = await (0, $2xZ6Q.default).postMultipart(`/api/dataspace/${dataSpaceId}/tables/${tableName}/reimport`).attach("file", formData.get("file")).field("delimiter", formData.get("delimiter"));
        return res.body;
    },
    reimportTableShp: async (dataSpaceId, tableName, formData)=>{
        const res = await (0, $2xZ6Q.default).postMultipart(`/api/dataspace/${dataSpaceId}/tables/${tableName}/reimport-shp`).send(formData);
        return res.body;
    }
};
var $eb7ad06fb4cfbf01$export$2e2bcd8739ae039 = $eb7ad06fb4cfbf01$var$dataspaceApi;

});


parcelRegister("ayi7O", function(module, exports) {

$parcel$export(module.exports, "render", () => $7aeb239ce0704cae$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7aeb239ce0704cae$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $7aeb239ce0704cae$var$_hoisted_2 = {
    class: "modal-dialog modal-lg modal-dialog-centered",
    role: "document"
};
const $7aeb239ce0704cae$var$_hoisted_3 = {
    class: "modal-content",
    style: {
        "width": "100%"
    }
};
const $7aeb239ce0704cae$var$_hoisted_4 = {
    class: "modal-header"
};
const $7aeb239ce0704cae$var$_hoisted_5 = {
    class: "modal-title"
};
const $7aeb239ce0704cae$var$_hoisted_6 = {
    class: "modal-body"
};
const $7aeb239ce0704cae$var$_hoisted_7 = {
    key: 0,
    class: "text-center py-4"
};
const $7aeb239ce0704cae$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border text-primary mb-3",
    role: "status"
}, null, -1);
const $7aeb239ce0704cae$var$_hoisted_9 = {
    class: "text-muted"
};
const $7aeb239ce0704cae$var$_hoisted_10 = {
    key: 1
};
const $7aeb239ce0704cae$var$_hoisted_11 = {
    class: "row g-2 mb-3"
};
const $7aeb239ce0704cae$var$_hoisted_12 = {
    class: "col-md-12"
};
const $7aeb239ce0704cae$var$_hoisted_13 = {
    class: "form-label small fw-bold"
};
const $7aeb239ce0704cae$var$_hoisted_14 = {
    key: 0,
    class: "alert alert-danger alert-sm py-2 mt-2"
};
const $7aeb239ce0704cae$var$_hoisted_15 = {
    class: "row mb-3"
};
const $7aeb239ce0704cae$var$_hoisted_16 = {
    class: "col-md-8"
};
const $7aeb239ce0704cae$var$_hoisted_17 = {
    class: "form-label"
};
const $7aeb239ce0704cae$var$_hoisted_18 = {
    key: 0,
    class: "col-md-4"
};
const $7aeb239ce0704cae$var$_hoisted_19 = {
    class: "form-label small fw-bold"
};
const $7aeb239ce0704cae$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ";"
}, ";", -1);
const $7aeb239ce0704cae$var$_hoisted_21 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ","
}, ",", -1);
const $7aeb239ce0704cae$var$_hoisted_22 = [
    $7aeb239ce0704cae$var$_hoisted_20,
    $7aeb239ce0704cae$var$_hoisted_21
];
const $7aeb239ce0704cae$var$_hoisted_23 = {
    key: 1
};
const $7aeb239ce0704cae$var$_hoisted_24 = {
    class: "table table-bordered table-sm"
};
const $7aeb239ce0704cae$var$_hoisted_25 = [
    "onUpdate:modelValue"
];
const $7aeb239ce0704cae$var$_hoisted_26 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<option value="nvarchar">String</option><option value="int">Integer</option><option value="decimal">Decimal</option><option value="datetime">Date Time</option><option value="bit">Boolean</option>', 5);
const $7aeb239ce0704cae$var$_hoisted_31 = [
    $7aeb239ce0704cae$var$_hoisted_26
];
const $7aeb239ce0704cae$var$_hoisted_32 = {
    class: "modal-footer"
};
const $7aeb239ce0704cae$var$_hoisted_33 = [
    "disabled"
];
const $7aeb239ce0704cae$var$_hoisted_34 = [
    "disabled"
];
const $7aeb239ce0704cae$var$_hoisted_35 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $7aeb239ce0704cae$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $7aeb239ce0704cae$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("import")) + " (CSV/SHP)", 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close"))
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_6, [
                        $data.importing ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7aeb239ce0704cae$var$_hoisted_7, [
                            $7aeb239ce0704cae$var$_hoisted_8,
                            (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("importing")) + "...", 1)
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7aeb239ce0704cae$var$_hoisted_10, [
                            (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_11, [
                                (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_12, [
                                    (0, $TusQn.createElementVNode)("label", $7aeb239ce0704cae$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("file")), 1),
                                    (0, $TusQn.createElementVNode)("input", {
                                        type: "file",
                                        class: "form-control form-control-sm",
                                        accept: ".csv,.shp,.dbf,.shx,.prj,.cpg,.sbn,.sbx,.zip",
                                        onChange: _cache[1] || (_cache[1] = (...args)=>$options.onFileSelected && $options.onFileSelected(...args)),
                                        multiple: ""
                                    }, null, 32)
                                ])
                            ]),
                            $data.errorMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7aeb239ce0704cae$var$_hoisted_14, (0, $8POXm.toDisplayString)($data.errorMessage), 1)) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_15, [
                                (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_16, [
                                    (0, $TusQn.createElementVNode)("label", $7aeb239ce0704cae$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("tableName")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.tableName = $event),
                                        class: "form-control form-control-sm"
                                    }, null, 512), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            $data.tableName
                                        ]
                                    ])
                                ]),
                                $data.fileType === "csv" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7aeb239ce0704cae$var$_hoisted_18, [
                                    (0, $TusQn.createElementVNode)("label", $7aeb239ce0704cae$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("delimiter")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.delimiter = $event)
                                    }, $7aeb239ce0704cae$var$_hoisted_22, 512), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            $data.delimiter
                                        ]
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("", true)
                            ]),
                            $data.columns.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7aeb239ce0704cae$var$_hoisted_23, [
                                (0, $TusQn.createElementVNode)("table", $7aeb239ce0704cae$var$_hoisted_24, [
                                    (0, $TusQn.createElementVNode)("thead", null, [
                                        (0, $TusQn.createElementVNode)("tr", null, [
                                            (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("column")), 1),
                                            (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("dataType")), 1)
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("tbody", null, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.columns, (col)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                key: col.index
                                            }, [
                                                (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(col.name), 1),
                                                (0, $TusQn.createElementVNode)("td", null, [
                                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                        "onUpdate:modelValue": ($event)=>col.dataType = $event,
                                                        class: "form-select form-select-sm"
                                                    }, $7aeb239ce0704cae$var$_hoisted_31, 8, $7aeb239ce0704cae$var$_hoisted_25), [
                                                        [
                                                            (0, $eeJ70.vModelSelect),
                                                            col.dataType
                                                        ]
                                                    ])
                                                ])
                                            ]);
                                        }), 128))
                                    ])
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ]))
                    ]),
                    (0, $TusQn.createElementVNode)("div", $7aeb239ce0704cae$var$_hoisted_32, [
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("close")),
                            disabled: $data.importing
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 9, $7aeb239ce0704cae$var$_hoisted_33),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[5] || (_cache[5] = (...args)=>$options.submitImport && $options.submitImport(...args)),
                            disabled: !$options.canCreateTable()
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("import")), 9, $7aeb239ce0704cae$var$_hoisted_34)
                    ])
                ])
            ])
        ]),
        $7aeb239ce0704cae$var$_hoisted_35
    ], 64);
}

});

parcelRegister("5M3L6", function(module, exports) {

$parcel$export(module.exports, "default", () => $434459d423fd8327$export$2e2bcd8739ae039);
let $434459d423fd8327$var$NOOP = ()=>{};
var $434459d423fd8327$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("4gHdh", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ba2d4e167a3e93$export$2e2bcd8739ae039);
let $31ba2d4e167a3e93$var$script;



let $31ba2d4e167a3e93$var$initialize = ()=>{
    $31ba2d4e167a3e93$var$script = (parcelRequire("aHVxb"));
    if ($31ba2d4e167a3e93$var$script.__esModule) $31ba2d4e167a3e93$var$script = $31ba2d4e167a3e93$var$script.default;
    $31ba2d4e167a3e93$var$script.render = (parcelRequire("a78OH")).render;
    (parcelRequire("6WDdA")).default($31ba2d4e167a3e93$var$script);
    $31ba2d4e167a3e93$var$script.__scopeId = "data-v-4c53a8";
    $31ba2d4e167a3e93$var$script.__file = "TableDeleteModal.vue";
};
$31ba2d4e167a3e93$var$initialize();
var $31ba2d4e167a3e93$export$2e2bcd8739ae039 = $31ba2d4e167a3e93$var$script;

});
parcelRegister("aHVxb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7cba8c9b3eebd5d6$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");
var $7cba8c9b3eebd5d6$export$2e2bcd8739ae039 = {
    name: "dataTableModal",
    methods: {
        async deleteDataTable () {
            this.syncLoading = "";
            await (0, $kds5T.default).tableDelete(this.$parent.$route.params.id, this.$parent.tableToDeleteName);
            this.$emit("reload");
            this.$emit("close");
        }
    },
    data () {
        return {
            buttonLoading: "btn btn-primary",
            syncLoading: "hidden",
            files: []
        };
    }
};

});

parcelRegister("a78OH", function(module, exports) {

$parcel$export(module.exports, "render", () => $75d165a4a93fbfdd$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
var $8POXm = parcelRequire("8POXm");
const $75d165a4a93fbfdd$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $75d165a4a93fbfdd$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $75d165a4a93fbfdd$var$_hoisted_3 = {
    class: "modal-content"
};
const $75d165a4a93fbfdd$var$_hoisted_4 = {
    class: "modal-header"
};
const $75d165a4a93fbfdd$var$_hoisted_5 = {
    class: "modal-title"
};
const $75d165a4a93fbfdd$var$_hoisted_6 = {
    class: "modal-body"
};
const $75d165a4a93fbfdd$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0",
        "color": "red"
    }
};
const $75d165a4a93fbfdd$var$_hoisted_8 = {
    class: "modal-footer"
};
const $75d165a4a93fbfdd$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
}, null, -1);
function $75d165a4a93fbfdd$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $75d165a4a93fbfdd$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $75d165a4a93fbfdd$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $75d165a4a93fbfdd$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $75d165a4a93fbfdd$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $75d165a4a93fbfdd$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("tableDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close")),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $75d165a4a93fbfdd$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisTable")), 1),
                                (0, $TusQn.createElementVNode)("p", $75d165a4a93fbfdd$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("allDataWillBeLost")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $75d165a4a93fbfdd$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    class: (0, $8POXm.normalizeClass)([
                                        $data.buttonLoading,
                                        $data.syncLoading
                                    ]),
                                    type: "button",
                                    disabled: ""
                                }, [
                                    $75d165a4a93fbfdd$var$_hoisted_9,
                                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)
                                ], 2),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("close")),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteDataTable && $options.deleteDataTable(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("6WDdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e694c196b4361a$export$2e2bcd8739ae039);
let $50e694c196b4361a$var$NOOP = ()=>{};
var $50e694c196b4361a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7ViRs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c4c7cb2ec7432fe$export$2e2bcd8739ae039);
let $5c4c7cb2ec7432fe$var$script;



let $5c4c7cb2ec7432fe$var$initialize = ()=>{
    $5c4c7cb2ec7432fe$var$script = (parcelRequire("aqOvY"));
    if ($5c4c7cb2ec7432fe$var$script.__esModule) $5c4c7cb2ec7432fe$var$script = $5c4c7cb2ec7432fe$var$script.default;
    $5c4c7cb2ec7432fe$var$script.render = (parcelRequire("4AU63")).render;
    (parcelRequire("52oL5")).default($5c4c7cb2ec7432fe$var$script);
    $5c4c7cb2ec7432fe$var$script.__scopeId = "data-v-69b850";
    $5c4c7cb2ec7432fe$var$script.__file = "ReimportModal.vue";
};
$5c4c7cb2ec7432fe$var$initialize();
var $5c4c7cb2ec7432fe$export$2e2bcd8739ae039 = $5c4c7cb2ec7432fe$var$script;

});
parcelRegister("aqOvY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $798384414d4ee096$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");
var $798384414d4ee096$export$2e2bcd8739ae039 = {
    name: "ReimportModal",
    props: {
        table: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            files: [],
            delimiter: ";",
            fileType: "",
            reimporting: false,
            result: null,
            resultMessage: "",
            errorMessage: ""
        };
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        }
    },
    methods: {
        onFileSelected (event) {
            this.files = Array.from(event.target.files);
            if (!this.files.length) return;
            var ext = this.files[0].name.split(".").pop().toLowerCase();
            this.fileType = ext === "csv" ? "csv" : "shp";
        },
        async submit () {
            this.reimporting = true;
            this.result = null;
            this.errorMessage = "";
            try {
                const formData = new FormData();
                if (this.fileType === "shp") {
                    this.files.forEach((f)=>formData.append("files", f));
                    await (0, $kds5T.default).reimportTableShp(this.dataSpaceId, this.table.name, formData);
                } else {
                    formData.append("file", this.files[0]);
                    formData.append("delimiter", this.delimiter);
                    await (0, $kds5T.default).reimportTable(this.dataSpaceId, this.table.name, formData);
                }
                this.result = "success";
                this.resultMessage = this.$t("reimportSuccessful");
            } catch (error) {
                this.result = "error";
                var key = error?.response?.body?.message || "unknownError";
                this.resultMessage = this.$t(key);
            } finally{
                this.reimporting = false;
                this.$emit("reload");
            }
        }
    }
};

});

parcelRegister("4AU63", function(module, exports) {

$parcel$export(module.exports, "render", () => $358609d83074af87$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $358609d83074af87$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $358609d83074af87$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $358609d83074af87$var$_hoisted_3 = {
    class: "modal-content"
};
const $358609d83074af87$var$_hoisted_4 = {
    class: "modal-header"
};
const $358609d83074af87$var$_hoisted_5 = {
    class: "modal-title"
};
const $358609d83074af87$var$_hoisted_6 = [
    "disabled"
];
const $358609d83074af87$var$_hoisted_7 = {
    class: "modal-body"
};
const $358609d83074af87$var$_hoisted_8 = {
    key: 0,
    class: "text-center py-3"
};
const $358609d83074af87$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border text-primary mb-2",
    role: "status"
}, null, -1);
const $358609d83074af87$var$_hoisted_10 = {
    class: "text-muted"
};
const $358609d83074af87$var$_hoisted_11 = {
    key: 1,
    class: "text-center py-3"
};
const $358609d83074af87$var$_hoisted_12 = {
    class: "mt-2"
};
const $358609d83074af87$var$_hoisted_13 = {
    key: 2
};
const $358609d83074af87$var$_hoisted_14 = {
    key: 0,
    class: "alert alert-danger py-2"
};
const $358609d83074af87$var$_hoisted_15 = {
    class: "row g-2"
};
const $358609d83074af87$var$_hoisted_16 = {
    class: "col-md-12"
};
const $358609d83074af87$var$_hoisted_17 = {
    class: "form-label small fw-bold"
};
const $358609d83074af87$var$_hoisted_18 = {
    key: 0,
    class: "col-md-4"
};
const $358609d83074af87$var$_hoisted_19 = {
    class: "form-label small fw-bold"
};
const $358609d83074af87$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ";"
}, ";", -1);
const $358609d83074af87$var$_hoisted_21 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ","
}, ",", -1);
const $358609d83074af87$var$_hoisted_22 = [
    $358609d83074af87$var$_hoisted_20,
    $358609d83074af87$var$_hoisted_21
];
const $358609d83074af87$var$_hoisted_23 = {
    class: "modal-footer"
};
const $358609d83074af87$var$_hoisted_24 = [
    "disabled"
];
const $358609d83074af87$var$_hoisted_25 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-sync-alt"
}, null, -1);
const $358609d83074af87$var$_hoisted_26 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $358609d83074af87$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $358609d83074af87$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("reimport")) + ": " + (0, $8POXm.toDisplayString)($props.table.name), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close")),
                            disabled: $data.reimporting
                        }, null, 8, $358609d83074af87$var$_hoisted_6)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_7, [
                        $data.reimporting ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $358609d83074af87$var$_hoisted_8, [
                            $358609d83074af87$var$_hoisted_9,
                            (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("importing")) + "...", 1)
                        ])) : $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $358609d83074af87$var$_hoisted_11, [
                            (0, $TusQn.createElementVNode)("i", {
                                class: (0, $8POXm.normalizeClass)($data.result === "success" ? "fas fa-check-circle text-success" : "fas fa-times-circle text-danger"),
                                style: {
                                    "font-size": "32px"
                                }
                            }, null, 2),
                            (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_12, (0, $8POXm.toDisplayString)($data.resultMessage), 1)
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $358609d83074af87$var$_hoisted_13, [
                            $data.errorMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $358609d83074af87$var$_hoisted_14, (0, $8POXm.toDisplayString)($data.errorMessage), 1)) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_15, [
                                (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_16, [
                                    (0, $TusQn.createElementVNode)("label", $358609d83074af87$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("file")), 1),
                                    (0, $TusQn.createElementVNode)("input", {
                                        type: "file",
                                        class: "form-control form-control-sm",
                                        accept: ".csv,.shp,.dbf,.shx,.prj,.cpg,.sbn,.sbx",
                                        onChange: _cache[1] || (_cache[1] = (...args)=>$options.onFileSelected && $options.onFileSelected(...args)),
                                        multiple: ""
                                    }, null, 32)
                                ]),
                                $data.fileType === "csv" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $358609d83074af87$var$_hoisted_18, [
                                    (0, $TusQn.createElementVNode)("label", $358609d83074af87$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("delimiter")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.delimiter = $event)
                                    }, $358609d83074af87$var$_hoisted_22, 512), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            $data.delimiter
                                        ]
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("", true)
                            ])
                        ]))
                    ]),
                    (0, $TusQn.createElementVNode)("div", $358609d83074af87$var$_hoisted_23, [
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("close"))
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        !$data.reimporting && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("close"))
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[5] || (_cache[5] = (...args)=>$options.submit && $options.submit(...args)),
                                disabled: !$data.files.length
                            }, [
                                $358609d83074af87$var$_hoisted_25,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("reimport")), 1)
                            ], 8, $358609d83074af87$var$_hoisted_24)
                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ])
            ])
        ]),
        $358609d83074af87$var$_hoisted_26
    ], 64);
}

});

parcelRegister("52oL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab05824d60948f6$export$2e2bcd8739ae039);
let $3ab05824d60948f6$var$NOOP = ()=>{};
var $3ab05824d60948f6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9e7n4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b7b239d488727bb$export$2e2bcd8739ae039);
let $6b7b239d488727bb$var$script;



let $6b7b239d488727bb$var$initialize = ()=>{
    $6b7b239d488727bb$var$script = (parcelRequire("3D7zY"));
    if ($6b7b239d488727bb$var$script.__esModule) $6b7b239d488727bb$var$script = $6b7b239d488727bb$var$script.default;
    $6b7b239d488727bb$var$script.render = (parcelRequire("bq9y6")).render;
    (parcelRequire("3AQqD")).default($6b7b239d488727bb$var$script);
    $6b7b239d488727bb$var$script.__scopeId = "data-v-9bc518";
    $6b7b239d488727bb$var$script.__file = "ExportModal.vue";
};
$6b7b239d488727bb$var$initialize();
var $6b7b239d488727bb$export$2e2bcd8739ae039 = $6b7b239d488727bb$var$script;

});
parcelRegister("3D7zY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2a4ae4b71f196c3f$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");
var $2a4ae4b71f196c3f$export$2e2bcd8739ae039 = {
    name: "ExportModal",
    props: [
        "table",
        "dataSpaceId"
    ],
    data () {
        return {
            geoTables: [],
            geoColumns: [],
            geoTable: null,
            geoId: "",
            geoColumn: "_geo_",
            dataId: "",
            dataFrom: "",
            dataTo: "",
            errorMessage: ""
        };
    },
    computed: {
        dataColumns () {
            return (this.table.columns || []).filter((c)=>c.name.toLowerCase() !== "_geo_");
        },
        truncatedColumns () {
            return this.dataColumns.filter((c)=>c.name.length > 11).map((c)=>c.name);
        },
        substringedDuplicates () {
            var seen = {};
            var dupes = [];
            this.dataColumns.forEach((c)=>{
                var substringedName = c.name.substring(0, 11).toLowerCase();
                if (seen[substringedName]) {
                    if (!dupes.includes(seen[substringedName])) dupes.push(seen[substringedName]);
                    dupes.push(c.name);
                } else seen[substringedName] = c.name;
            });
            return dupes;
        },
        valid () {
            if (this.substringedDuplicates.length) return false;
            if (!this.geoTable) return true;
            return this.dataId && this.dataFrom && this.dataTo && this.geoId && this.geoColumn;
        }
    },
    async mounted () {
        const all = await (0, $kds5T.default).tables(this.dataSpaceId);
        this.geoTables = all.filter((t)=>//t.origin === 'SHP'
            (t.columns || []).some((c)=>c.name.toLowerCase() === "_geo_"));
    },
    methods: {
        async loadGeoColumns () {
            if (!this.geoTable) {
                this.geoColumns = [];
                return;
            }
            const t = this.geoTables.find((x)=>x.name === this.geoTable);
            this.geoColumns = (t.columns || []).filter((c)=>c.name.toLowerCase() !== "_geo_");
        },
        submitExport () {
            const params = new URLSearchParams();
            if (this.geoTable) {
                params.append("geoTable", this.geoTable);
                params.append("geoId", this.geoId);
                params.append("geoColumn", this.geoColumn);
                params.append("dataId", this.dataId);
                params.append("dataFrom", this.dataFrom);
                params.append("dataTo", this.dataTo);
            }
            var request = (0, $kds5T.default).tableShpExport(this.dataSpaceId, this.table.name, params.toString());
            window.open(request.url);
            this.$emit("close");
        }
    }
};

});

parcelRegister("bq9y6", function(module, exports) {

$parcel$export(module.exports, "render", () => $850987a42bfc480e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $850987a42bfc480e$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $850987a42bfc480e$var$_hoisted_2 = {
    class: "modal-dialog modal-lg modal-dialog-centered",
    role: "document"
};
const $850987a42bfc480e$var$_hoisted_3 = {
    class: "modal-content",
    style: {
        "width": "100%"
    }
};
const $850987a42bfc480e$var$_hoisted_4 = {
    class: "modal-header"
};
const $850987a42bfc480e$var$_hoisted_5 = {
    class: "modal-title"
};
const $850987a42bfc480e$var$_hoisted_6 = {
    class: "modal-body"
};
const $850987a42bfc480e$var$_hoisted_7 = {
    key: 0,
    class: "alert alert-danger"
};
const $850987a42bfc480e$var$_hoisted_8 = {
    class: "fw-bold mb-1"
};
const $850987a42bfc480e$var$_hoisted_9 = {
    class: "small mb-2"
};
const $850987a42bfc480e$var$_hoisted_10 = {
    class: "small fw-semibold"
};
const $850987a42bfc480e$var$_hoisted_11 = {
    key: 0,
    class: "alert alert-warning"
};
const $850987a42bfc480e$var$_hoisted_12 = {
    class: "fw-bold mb-1"
};
const $850987a42bfc480e$var$_hoisted_13 = {
    class: "small"
};
const $850987a42bfc480e$var$_hoisted_14 = {
    class: "row g-2 mb-3"
};
const $850987a42bfc480e$var$_hoisted_15 = {
    class: "col-md-4"
};
const $850987a42bfc480e$var$_hoisted_16 = {
    class: "form-label small fw-bold"
};
const $850987a42bfc480e$var$_hoisted_17 = [
    "value"
];
const $850987a42bfc480e$var$_hoisted_18 = {
    class: "col-md-4"
};
const $850987a42bfc480e$var$_hoisted_19 = {
    class: "form-label small fw-bold"
};
const $850987a42bfc480e$var$_hoisted_20 = [
    "value"
];
const $850987a42bfc480e$var$_hoisted_21 = {
    class: "col-md-4"
};
const $850987a42bfc480e$var$_hoisted_22 = {
    class: "form-label small fw-bold"
};
const $850987a42bfc480e$var$_hoisted_23 = [
    "value"
];
const $850987a42bfc480e$var$_hoisted_24 = {
    class: "mb-3"
};
const $850987a42bfc480e$var$_hoisted_25 = {
    class: "form-label small fw-bold"
};
const $850987a42bfc480e$var$_hoisted_26 = {
    value: null
};
const $850987a42bfc480e$var$_hoisted_27 = [
    "value"
];
const $850987a42bfc480e$var$_hoisted_28 = {
    key: 1,
    class: "mb-3"
};
const $850987a42bfc480e$var$_hoisted_29 = {
    class: "form-label small fw-bold"
};
const $850987a42bfc480e$var$_hoisted_30 = [
    "value"
];
const $850987a42bfc480e$var$_hoisted_31 = {
    key: 2,
    class: "alert alert-danger py-2 mt-3"
};
const $850987a42bfc480e$var$_hoisted_32 = {
    class: "modal-footer"
};
const $850987a42bfc480e$var$_hoisted_33 = [
    "disabled"
];
const $850987a42bfc480e$var$_hoisted_34 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $850987a42bfc480e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $850987a42bfc480e$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("export")) + " \u2014 " + (0, $8POXm.toDisplayString)($props.table.name), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close"))
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_6, [
                        $options.substringedDuplicates.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $850987a42bfc480e$var$_hoisted_7, [
                            (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("duplicateColumns")), 1),
                            (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("duplicateColumnsDescription")), 1),
                            (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_10, (0, $8POXm.toDisplayString)($options.substringedDuplicates.join(", ")), 1)
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            $options.truncatedColumns.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $850987a42bfc480e$var$_hoisted_11, [
                                (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("columnsWillBeTruncated")), 1),
                                (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_13, (0, $8POXm.toDisplayString)($options.truncatedColumns.join(", ")), 1)
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_14, [
                                (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_15, [
                                    (0, $TusQn.createElementVNode)("label", $850987a42bfc480e$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("idColumn")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.dataId = $event)
                                    }, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.dataColumns, (c)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: c.name,
                                                value: c.name
                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $850987a42bfc480e$var$_hoisted_17);
                                        }), 128))
                                    ], 512), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            $data.dataId
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_18, [
                                    (0, $TusQn.createElementVNode)("label", $850987a42bfc480e$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("fromColumn")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.dataFrom = $event)
                                    }, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.dataColumns, (c)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: c.name,
                                                value: c.name
                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $850987a42bfc480e$var$_hoisted_20);
                                        }), 128))
                                    ], 512), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            $data.dataFrom
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_21, [
                                    (0, $TusQn.createElementVNode)("label", $850987a42bfc480e$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("toColumn")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.dataTo = $event)
                                    }, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.dataColumns, (c)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: c.name,
                                                value: c.name
                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $850987a42bfc480e$var$_hoisted_23);
                                        }), 128))
                                    ], 512), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            $data.dataTo
                                        ]
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_24, [
                                (0, $TusQn.createElementVNode)("label", $850987a42bfc480e$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("geometryTable")), 1),
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.geoTable = $event),
                                    onChange: _cache[5] || (_cache[5] = (...args)=>$options.loadGeoColumns && $options.loadGeoColumns(...args))
                                }, [
                                    (0, $TusQn.createElementVNode)("option", $850987a42bfc480e$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("noGeometry")), 1),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.geoTables, (t)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: t.name,
                                            value: t.name
                                        }, (0, $8POXm.toDisplayString)(t.name), 9, $850987a42bfc480e$var$_hoisted_27);
                                    }), 128))
                                ], 544), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        $data.geoTable
                                    ]
                                ])
                            ]),
                            $data.geoTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $850987a42bfc480e$var$_hoisted_28, [
                                (0, $TusQn.createElementVNode)("label", $850987a42bfc480e$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("geometryIdColumn")), 1),
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.geoId = $event)
                                }, [
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.geoColumns, (c)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                            key: c.name,
                                            value: c.name
                                        }, (0, $8POXm.toDisplayString)(c.name), 9, $850987a42bfc480e$var$_hoisted_30);
                                    }), 128))
                                ], 512), [
                                    [
                                        (0, $eeJ70.vModelSelect),
                                        $data.geoId
                                    ]
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            $data.errorMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $850987a42bfc480e$var$_hoisted_31, (0, $8POXm.toDisplayString)($data.errorMessage), 1)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 64))
                    ]),
                    (0, $TusQn.createElementVNode)("div", $850987a42bfc480e$var$_hoisted_32, [
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[7] || (_cache[7] = ($event)=>_ctx.$emit("close"))
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[8] || (_cache[8] = (...args)=>$options.submitExport && $options.submitExport(...args)),
                            disabled: !$options.valid
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("export")), 9, $850987a42bfc480e$var$_hoisted_33)
                    ])
                ])
            ])
        ]),
        $850987a42bfc480e$var$_hoisted_34
    ], 64);
}

});

parcelRegister("3AQqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $29dd671f4eca6111$export$2e2bcd8739ae039);
let $29dd671f4eca6111$var$NOOP = ()=>{};
var $29dd671f4eca6111$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});


parcelRegister("95Nuc", function(module, exports) {

$parcel$export(module.exports, "render", () => $69eaf798e1acef79$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $69eaf798e1acef79$var$_hoisted_1 = {
    class: "container py-5"
};
const $69eaf798e1acef79$var$_hoisted_2 = {
    class: "table table-hover"
};
const $69eaf798e1acef79$var$_hoisted_3 = {
    colspan: "7",
    class: "text-center"
};
const $69eaf798e1acef79$var$_hoisted_4 = {
    colspan: "7",
    style: {
        "padding": "0"
    }
};
const $69eaf798e1acef79$var$_hoisted_5 = [
    "placeholder"
];
const $69eaf798e1acef79$var$_hoisted_6 = {
    class: "text-end"
};
const $69eaf798e1acef79$var$_hoisted_7 = {
    class: "text-end"
};
const $69eaf798e1acef79$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    class: "text-end"
}, null, -1);
const $69eaf798e1acef79$var$_hoisted_9 = {
    key: 0
};
const $69eaf798e1acef79$var$_hoisted_10 = {
    class: "table-name"
};
const $69eaf798e1acef79$var$_hoisted_11 = {
    class: "badge-type"
};
const $69eaf798e1acef79$var$_hoisted_12 = {
    class: "text-end"
};
const $69eaf798e1acef79$var$_hoisted_13 = {
    class: "text-end"
};
const $69eaf798e1acef79$var$_hoisted_14 = {
    class: "text-end"
};
const $69eaf798e1acef79$var$_hoisted_15 = [
    "onClick",
    "title"
];
const $69eaf798e1acef79$var$_hoisted_16 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-sync-alt"
}, null, -1);
const $69eaf798e1acef79$var$_hoisted_17 = [
    $69eaf798e1acef79$var$_hoisted_16
];
const $69eaf798e1acef79$var$_hoisted_18 = {
    class: "dropdown d-inline-block"
};
const $69eaf798e1acef79$var$_hoisted_19 = [
    "title"
];
const $69eaf798e1acef79$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-download"
}, null, -1);
const $69eaf798e1acef79$var$_hoisted_21 = [
    $69eaf798e1acef79$var$_hoisted_20
];
const $69eaf798e1acef79$var$_hoisted_22 = {
    class: "dropdown-menu dropdown-menu-end"
};
const $69eaf798e1acef79$var$_hoisted_23 = [
    "onClick"
];
const $69eaf798e1acef79$var$_hoisted_24 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-file-csv fa-fw me-2"
}, null, -1);
const $69eaf798e1acef79$var$_hoisted_25 = [
    "onClick"
];
const $69eaf798e1acef79$var$_hoisted_26 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-map fa-fw me-2"
}, null, -1);
const $69eaf798e1acef79$var$_hoisted_27 = [
    "onClick",
    "title"
];
const $69eaf798e1acef79$var$_hoisted_28 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash"
}, null, -1);
const $69eaf798e1acef79$var$_hoisted_29 = [
    $69eaf798e1acef79$var$_hoisted_28
];
const $69eaf798e1acef79$var$_hoisted_30 = {
    key: 1
};
const $69eaf798e1acef79$var$_hoisted_31 = {
    colspan: "7"
};
function $69eaf798e1acef79$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImportModal = (0, $TusQn.resolveComponent)("ImportModal");
    const _component_TableDeleteModal = (0, $TusQn.resolveComponent)("TableDeleteModal");
    const _component_ReimportModal = (0, $TusQn.resolveComponent)("ReimportModal");
    const _component_ExportModal = (0, $TusQn.resolveComponent)("ExportModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $69eaf798e1acef79$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("table", $69eaf798e1acef79$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $69eaf798e1acef79$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("tables")), 1)
                ]),
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("td", $69eaf798e1acef79$var$_hoisted_4, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "form-control",
                            style: {
                                "border": "none"
                            },
                            placeholder: _ctx.$t("filterByName"),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.filterInput = $event),
                            type: "search"
                        }, null, 8, $69eaf798e1acef79$var$_hoisted_5), [
                            [
                                (0, $eeJ70.vModelText),
                                $data.filterInput
                            ]
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                    (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("creationType")), 1),
                    (0, $TusQn.createElementVNode)("th", $69eaf798e1acef79$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("rows")), 1),
                    (0, $TusQn.createElementVNode)("th", $69eaf798e1acef79$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("size")), 1),
                    (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("updatedBy")), 1),
                    (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("updatedDate")), 1),
                    $69eaf798e1acef79$var$_hoisted_8
                ])
            ]),
            $options.filteredTables.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $69eaf798e1acef79$var$_hoisted_9, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.filteredTables, (item)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: item.id
                    }, [
                        (0, $TusQn.createElementVNode)("td", $69eaf798e1acef79$var$_hoisted_10, (0, $8POXm.toDisplayString)(item.name), 1),
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createElementVNode)("span", $69eaf798e1acef79$var$_hoisted_11, (0, $8POXm.toDisplayString)($options.getBatchLabel(item)), 1)
                        ]),
                        (0, $TusQn.createElementVNode)("td", $69eaf798e1acef79$var$_hoisted_12, (0, $8POXm.toDisplayString)($options.formatNumber(item.rowCount)), 1),
                        (0, $TusQn.createElementVNode)("td", $69eaf798e1acef79$var$_hoisted_13, (0, $8POXm.toDisplayString)($options.formatSize(item.sizeMB)), 1),
                        (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(item.reimportedBy || item.createdBy), 1),
                        (0, $TusQn.createElementVNode)("td", null, (0, $8POXm.toDisplayString)(this.getDate(item)), 1),
                        (0, $TusQn.createElementVNode)("td", $69eaf798e1acef79$var$_hoisted_14, [
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-sm text-secondary",
                                onClick: ($event)=>$options.reimportTable(item),
                                title: _ctx.$t("reimport")
                            }, $69eaf798e1acef79$var$_hoisted_17, 8, $69eaf798e1acef79$var$_hoisted_15),
                            (0, $TusQn.createElementVNode)("div", $69eaf798e1acef79$var$_hoisted_18, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-sm text-secondary",
                                    "data-bs-toggle": "dropdown",
                                    title: _ctx.$t("export")
                                }, $69eaf798e1acef79$var$_hoisted_21, 8, $69eaf798e1acef79$var$_hoisted_19),
                                (0, $TusQn.createElementVNode)("ul", $69eaf798e1acef79$var$_hoisted_22, [
                                    (0, $TusQn.createElementVNode)("li", null, [
                                        (0, $TusQn.createElementVNode)("button", {
                                            type: "button",
                                            class: "dropdown-item",
                                            onClick: ($event)=>$options.exportCsv(item)
                                        }, [
                                            $69eaf798e1acef79$var$_hoisted_24,
                                            (0, $TusQn.createTextVNode)(" CSV ")
                                        ], 8, $69eaf798e1acef79$var$_hoisted_23)
                                    ]),
                                    (0, $TusQn.createElementVNode)("li", null, [
                                        (0, $TusQn.createElementVNode)("button", {
                                            type: "button",
                                            class: "dropdown-item",
                                            onClick: ($event)=>$options.exportShp(item)
                                        }, [
                                            $69eaf798e1acef79$var$_hoisted_26,
                                            (0, $TusQn.createTextVNode)(" SHP ")
                                        ], 8, $69eaf798e1acef79$var$_hoisted_25)
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-sm text-secondary delete-action",
                                onClick: ($event)=>$options.showDeleteTable(item),
                                title: _ctx.$t("delete")
                            }, $69eaf798e1acef79$var$_hoisted_29, 8, $69eaf798e1acef79$var$_hoisted_27)
                        ])
                    ]);
                }), 128))
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $69eaf798e1acef79$var$_hoisted_30, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("td", $69eaf798e1acef79$var$_hoisted_31, (0, $8POXm.toDisplayString)(_ctx.$t("noTables")), 1)
                ])
            ]))
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event)=>$data.showImport = true)
        }, (0, $8POXm.toDisplayString)(_ctx.$t("import")), 1),
        $data.showImport ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ImportModal, {
            key: 0,
            dataSpaceId: $options.dataSpaceId,
            onImported: $options.onImported,
            onClose: _cache[2] || (_cache[2] = ($event)=>$data.showImport = false)
        }, null, 8, [
            "dataSpaceId",
            "onImported"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showDeleteTableModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_TableDeleteModal, {
            key: 1,
            data: $options.dataSpaceId,
            onReload: $options.loadTables,
            onClose: _cache[3] || (_cache[3] = ($event)=>$data.showDeleteTableModal = false)
        }, null, 8, [
            "data",
            "onReload"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showReimport && $data.reimportItem ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ReimportModal, {
            key: 2,
            table: $data.reimportItem,
            onReload: _cache[4] || (_cache[4] = ($event)=>$options.loadTables()),
            onClose: $options.closeReimport
        }, null, 8, [
            "table",
            "onClose"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showExport && $data.exportTableItem ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_ExportModal, {
            key: 3,
            table: $data.exportTableItem,
            dataSpaceId: _ctx.$route.params.id,
            onClose: _cache[5] || (_cache[5] = ($event)=>$data.showExport = false)
        }, null, 8, [
            "table",
            "dataSpaceId"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("gMLIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38626167f9bde6d$export$2e2bcd8739ae039);
let $c38626167f9bde6d$var$NOOP = ()=>{};
var $c38626167f9bde6d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("l40YM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f55abb2570d9d7e6$export$2e2bcd8739ae039);

var $7R1dy = parcelRequire("7R1dy");

var $5LQ63 = parcelRequire("5LQ63");

var $77lpg = parcelRequire("77lpg");

var $aUBz1 = parcelRequire("aUBz1");

var $1MX2s = parcelRequire("1MX2s");
var $f55abb2570d9d7e6$export$2e2bcd8739ae039 = {
    name: "DataBatchList",
    components: {
        DataBatchAdd: $5LQ63.default,
        DataBatchRunModal: $77lpg.default,
        DataBatchCopyModal: $aUBz1.default,
        DataBatchDeleteModal: $1MX2s.default
    },
    data () {
        return {
            batches: [],
            filterInput: "",
            showForm: false,
            showDataBatchRun: false,
            runningBatch: null,
            showCopy: false,
            copyingBatch: null,
            showDelete: false,
            deletingBatch: null
        };
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        }
    },
    mounted () {
        this.loadBatches();
    },
    methods: {
        editBatch (item) {
            this.$router.push(`/dataspace/${this.dataSpaceId}/batches/${item.id}`);
        },
        createBatch () {
            this.showForm = true;
        },
        async loadBatches () {
            var list = await (0, $7R1dy.default).dataBatchList(this.dataSpaceId);
            this.batches = list.sort((a, b)=>a.name.localeCompare(b.name)).map((b)=>{
                return b;
            });
        },
        async runBatch (item) {
            this.runningBatch = item;
            this.showDataBatchRun = true;
        },
        closeBatchRun () {
            this.showDataBatchRun = false;
            this.runningBatch = null;
        },
        statusBadgeClass (status) {
            var classes = {
                "Draft": "badge-status badge-draft",
                "Ready": "badge-status badge-ready",
                "Running": "badge-status badge-running",
                "Completed": "badge-status badge-completed",
                "Error": "badge-status badge-error"
            };
            return classes[status] || "badge-status badge-draft";
        },
        statusLabel (status) {
            var labels = {
                "Draft": this.$t("statusDraft"),
                "Ready": this.$t("statusReady"),
                "Running": this.$t("statusRunning"),
                "Completed": this.$t("statusCompleted"),
                "Error": this.$t("statusError")
            };
            return labels[status] || status;
        },
        formatDate (date) {
            if (!date) return "\u2013";
            return new Date(date).toLocaleString();
        },
        formatDuration (seconds) {
            if (seconds == null) return "-";
            var min = Math.floor(seconds / 60);
            var sec = seconds % 60;
            return `${min} min ${String(sec).padStart(2, "0")} s`;
        },
        copyBatch (item) {
            this.copyingBatch = item;
            this.showCopy = true;
        },
        closeCopy () {
            this.showCopy = false;
            this.copyingBatch = null;
        },
        deleteBatch (item) {
            this.deletingBatch = item;
            this.showDelete = true;
        },
        closeDelete () {
            this.showDelete = false;
            this.deletingBatch = null;
        }
    },
    notifications: {
        showRunSuccess: {
            title: "success",
            message: "batchRunSuccessful",
            type: "success"
        },
        showRunFail: {
            title: "failed",
            message: "batchRunUnsuccessful",
            type: "error"
        }
    }
};

});
parcelRegister("7R1dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7e6d6ae11a2dbf$export$2e2bcd8739ae039);

var $2xZ6Q = parcelRequire("2xZ6Q");
const $5b7e6d6ae11a2dbf$var$databatchApi = {
    dataBatchList: async (dataSpaceId)=>{
        const res = await (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpaceId}/batches`);
        return res.body;
    },
    dataBatchDetail: async (dataSpaceId, batchId)=>{
        const res = await (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpaceId}/batches/${batchId}`);
        return res.body;
    },
    dataBatchCreate: async (dataSpaceId, batch)=>{
        const res = await (0, $2xZ6Q.default).post(`/api/dataspace/${dataSpaceId}/batches`).send(batch);
        return res.body;
    },
    dataBatchUpdate: async (dataSpaceId, batchId, content)=>{
        const res = await (0, $2xZ6Q.default).put(`/api/dataspace/${dataSpaceId}/batches/${batchId}`).send(content);
        return res.body;
    },
    dataBatchDelete: async (dataSpaceId, batchId)=>{
        await (0, $2xZ6Q.default).delete(`/api/dataspace/${dataSpaceId}/batches/${batchId}`);
    },
    dataBatchRun: async (dataSpaceId, batchId, recreateTable)=>{
        const res = await (0, $2xZ6Q.default).get(`/api/dataspace/${dataSpaceId}/batches/${batchId}/run?recreateTable=${recreateTable}`);
        return res.body;
    }
};
var $5b7e6d6ae11a2dbf$export$2e2bcd8739ae039 = $5b7e6d6ae11a2dbf$var$databatchApi;

});

parcelRegister("5LQ63", function(module, exports) {

$parcel$export(module.exports, "default", () => $4339c0d8d1bae66b$export$2e2bcd8739ae039);
let $4339c0d8d1bae66b$var$script;



let $4339c0d8d1bae66b$var$initialize = ()=>{
    $4339c0d8d1bae66b$var$script = (parcelRequire("2kNEg"));
    if ($4339c0d8d1bae66b$var$script.__esModule) $4339c0d8d1bae66b$var$script = $4339c0d8d1bae66b$var$script.default;
    $4339c0d8d1bae66b$var$script.render = (parcelRequire("caaLJ")).render;
    (parcelRequire("4aGeA")).default($4339c0d8d1bae66b$var$script);
    $4339c0d8d1bae66b$var$script.__scopeId = "data-v-23fb4f";
    $4339c0d8d1bae66b$var$script.__file = "DataBatchAdd.vue";
};
$4339c0d8d1bae66b$var$initialize();
var $4339c0d8d1bae66b$export$2e2bcd8739ae039 = $4339c0d8d1bae66b$var$script;

});
parcelRegister("2kNEg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1b33f628b9878e12$export$2e2bcd8739ae039);

var $7R1dy = parcelRequire("7R1dy");
var $1b33f628b9878e12$export$2e2bcd8739ae039 = {
    name: "DataBatchForm",
    data () {
        return {
            name: "",
            batchType: "",
            saving: false
        };
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        },
        canCreate () {
            return this.name && this.batchType;
        }
    },
    methods: {
        async create () {
            this.saving = true;
            var result = await (0, $7R1dy.default).dataBatchCreate(this.dataSpaceId, {
                name: this.name,
                batchType: this.batchType
            });
            this.$router.push(`/dataspace/${this.dataSpaceId}/batches/${result.id}`);
            this.saving = false;
        }
    }
};

});

parcelRegister("caaLJ", function(module, exports) {

$parcel$export(module.exports, "render", () => $8daec5ab8928854d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $8daec5ab8928854d$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $8daec5ab8928854d$var$_hoisted_2 = {
    class: "modal-dialog modal-lg modal-dialog-centered",
    role: "document"
};
const $8daec5ab8928854d$var$_hoisted_3 = {
    class: "modal-content",
    style: {
        "width": "100%"
    }
};
const $8daec5ab8928854d$var$_hoisted_4 = {
    class: "modal-header"
};
const $8daec5ab8928854d$var$_hoisted_5 = {
    class: "modal-title"
};
const $8daec5ab8928854d$var$_hoisted_6 = {
    class: "modal-body"
};
const $8daec5ab8928854d$var$_hoisted_7 = {
    class: "form-label fw-bold small text-uppercase"
};
const $8daec5ab8928854d$var$_hoisted_8 = [
    "placeholder"
];
const $8daec5ab8928854d$var$_hoisted_9 = {
    class: "form-label fw-bold small text-uppercase"
};
const $8daec5ab8928854d$var$_hoisted_10 = {
    class: "type-cards"
};
const $8daec5ab8928854d$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-copy"
}, null, -1);
const $8daec5ab8928854d$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-layer-group"
}, null, -1);
const $8daec5ab8928854d$var$_hoisted_13 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-code-branch"
}, null, -1);
const $8daec5ab8928854d$var$_hoisted_14 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("strong", null, "Common Smallest Denominator", -1);
const $8daec5ab8928854d$var$_hoisted_15 = {
    class: "modal-footer"
};
const $8daec5ab8928854d$var$_hoisted_16 = [
    "disabled"
];
const $8daec5ab8928854d$var$_hoisted_17 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $8daec5ab8928854d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $8daec5ab8928854d$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("newBatch")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("cancel"))
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_6, [
                        (0, $TusQn.createElementVNode)("label", $8daec5ab8928854d$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("batchName")), 1),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.name = $event),
                            class: "form-control mb-4",
                            placeholder: _ctx.$t("batchNamePlaceholder")
                        }, null, 8, $8daec5ab8928854d$var$_hoisted_8), [
                            [
                                (0, $eeJ70.vModelText),
                                $data.name
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("label", $8daec5ab8928854d$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("dataLoadMethod")), 1),
                        (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_10, [
                            (0, $TusQn.createElementVNode)("div", {
                                class: (0, $8POXm.normalizeClass)([
                                    "type-card",
                                    {
                                        selected: $data.batchType === "Copy"
                                    }
                                ]),
                                onClick: _cache[2] || (_cache[2] = ($event)=>$data.batchType = "Copy")
                            }, [
                                $8daec5ab8928854d$var$_hoisted_11,
                                (0, $TusQn.createElementVNode)("strong", null, (0, $8POXm.toDisplayString)(_ctx.$t("typeCopy")), 1),
                                (0, $TusQn.createElementVNode)("small", null, (0, $8POXm.toDisplayString)(_ctx.$t("typeCopyDesc")), 1)
                            ], 2),
                            (0, $TusQn.createElementVNode)("div", {
                                class: (0, $8POXm.normalizeClass)([
                                    "type-card",
                                    {
                                        selected: $data.batchType === "Aggregation"
                                    }
                                ]),
                                onClick: _cache[3] || (_cache[3] = ($event)=>$data.batchType = "Aggregation")
                            }, [
                                $8daec5ab8928854d$var$_hoisted_12,
                                (0, $TusQn.createElementVNode)("strong", null, (0, $8POXm.toDisplayString)(_ctx.$t("typeAggregation")), 1),
                                (0, $TusQn.createElementVNode)("small", null, (0, $8POXm.toDisplayString)(_ctx.$t("typeAggregationDesc")), 1)
                            ], 2),
                            (0, $TusQn.createElementVNode)("div", {
                                class: (0, $8POXm.normalizeClass)([
                                    "type-card",
                                    {
                                        selected: $data.batchType === "CSD"
                                    }
                                ]),
                                onClick: _cache[4] || (_cache[4] = ($event)=>$data.batchType = "CSD")
                            }, [
                                $8daec5ab8928854d$var$_hoisted_13,
                                $8daec5ab8928854d$var$_hoisted_14,
                                (0, $TusQn.createElementVNode)("small", null, (0, $8POXm.toDisplayString)(_ctx.$t("typeCsdDesc")), 1)
                            ], 2)
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $8daec5ab8928854d$var$_hoisted_15, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "btn btn-secondary",
                            onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("cancel"))
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            class: "btn btn-primary",
                            onClick: _cache[6] || (_cache[6] = (...args)=>$options.create && $options.create(...args)),
                            disabled: !$options.canCreate || $data.saving
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("createBatch")), 9, $8daec5ab8928854d$var$_hoisted_16)
                    ])
                ])
            ])
        ]),
        $8daec5ab8928854d$var$_hoisted_17
    ], 64);
}

});

parcelRegister("4aGeA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3098db6bd20893e1$export$2e2bcd8739ae039);
let $3098db6bd20893e1$var$NOOP = ()=>{};
var $3098db6bd20893e1$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("77lpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e9cab59c79f05f$export$2e2bcd8739ae039);
let $52e9cab59c79f05f$var$script;



let $52e9cab59c79f05f$var$initialize = ()=>{
    $52e9cab59c79f05f$var$script = (parcelRequire("3AvWO"));
    if ($52e9cab59c79f05f$var$script.__esModule) $52e9cab59c79f05f$var$script = $52e9cab59c79f05f$var$script.default;
    $52e9cab59c79f05f$var$script.render = (parcelRequire("gZvfz")).render;
    (parcelRequire("3rYdg")).default($52e9cab59c79f05f$var$script);
    $52e9cab59c79f05f$var$script.__scopeId = "data-v-300745";
    $52e9cab59c79f05f$var$script.__file = "DataBatchRunModal.vue";
};
$52e9cab59c79f05f$var$initialize();
var $52e9cab59c79f05f$export$2e2bcd8739ae039 = $52e9cab59c79f05f$var$script;

});
parcelRegister("3AvWO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $29cd84055e45a2db$export$2e2bcd8739ae039);

var $7R1dy = parcelRequire("7R1dy");
var $29cd84055e45a2db$export$2e2bcd8739ae039 = {
    name: "DataBatchRunModal",
    props: {
        batch: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            running: false,
            result: null,
            resultMessage: "",
            recreateTable: this.batch.recreateTable || false
        };
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        }
    },
    methods: {
        async run () {
            this.running = true;
            this.result = null;
            try {
                await (0, $7R1dy.default).dataBatchRun(this.dataSpaceId, this.batch.id, this.recreateTable);
                this.result = "success";
                this.resultMessage = this.$t("batchRunSuccessful");
            } catch (error) {
                this.result = "error";
                var key = error?.response?.body?.message || "unknownError";
                this.resultMessage = this.$t(key);
            } finally{
                this.running = false;
                this.$emit("reload");
            }
        }
    }
};

});

parcelRegister("gZvfz", function(module, exports) {

$parcel$export(module.exports, "render", () => $c5ea9574d3b2c321$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $c5ea9574d3b2c321$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $c5ea9574d3b2c321$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $c5ea9574d3b2c321$var$_hoisted_3 = {
    class: "modal-content"
};
const $c5ea9574d3b2c321$var$_hoisted_4 = {
    class: "modal-header"
};
const $c5ea9574d3b2c321$var$_hoisted_5 = {
    class: "modal-title"
};
const $c5ea9574d3b2c321$var$_hoisted_6 = [
    "disabled"
];
const $c5ea9574d3b2c321$var$_hoisted_7 = {
    class: "modal-body"
};
const $c5ea9574d3b2c321$var$_hoisted_8 = {
    key: 0
};
const $c5ea9574d3b2c321$var$_hoisted_9 = {
    class: "fw-bold"
};
const $c5ea9574d3b2c321$var$_hoisted_10 = {
    key: 1,
    class: "text-center py-3"
};
const $c5ea9574d3b2c321$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border text-primary mb-2",
    role: "status"
}, null, -1);
const $c5ea9574d3b2c321$var$_hoisted_12 = {
    class: "text-muted"
};
const $c5ea9574d3b2c321$var$_hoisted_13 = {
    key: 2,
    class: "text-center py-3"
};
const $c5ea9574d3b2c321$var$_hoisted_14 = {
    class: "mt-2"
};
const $c5ea9574d3b2c321$var$_hoisted_15 = {
    class: "modal-footer"
};
const $c5ea9574d3b2c321$var$_hoisted_16 = {
    key: 0,
    class: "form-check me-auto"
};
const $c5ea9574d3b2c321$var$_hoisted_17 = {
    class: "form-check-label",
    for: "flexCheckDefault"
};
const $c5ea9574d3b2c321$var$_hoisted_18 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-play"
}, null, -1);
const $c5ea9574d3b2c321$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $c5ea9574d3b2c321$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $c5ea9574d3b2c321$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("runDataBatch")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close")),
                            disabled: $data.running
                        }, null, 8, $c5ea9574d3b2c321$var$_hoisted_6)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_7, [
                        !$data.running && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c5ea9574d3b2c321$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("areYouSureYouWantToRunThisDataBatch")), 1),
                            (0, $TusQn.createElementVNode)("p", $c5ea9574d3b2c321$var$_hoisted_9, (0, $8POXm.toDisplayString)($props.batch.name), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.running ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c5ea9574d3b2c321$var$_hoisted_10, [
                            $c5ea9574d3b2c321$var$_hoisted_11,
                            (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("running")) + "...", 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c5ea9574d3b2c321$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("i", {
                                class: (0, $8POXm.normalizeClass)($data.result === "success" ? "fas fa-check-circle text-success" : "fas fa-times-circle text-danger"),
                                style: {
                                    "font-size": "32px"
                                }
                            }, null, 2),
                            (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_14, (0, $8POXm.toDisplayString)($data.resultMessage), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $c5ea9574d3b2c321$var$_hoisted_15, [
                        !$data.running && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c5ea9574d3b2c321$var$_hoisted_16, [
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "flexCheckDefault",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.recreateTable = $event)
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelCheckbox),
                                    $data.recreateTable
                                ]
                            ]),
                            (0, $TusQn.createElementVNode)("label", $c5ea9574d3b2c321$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("recreateTable")), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("close"))
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        !$data.running && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 2
                        }, [
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("close"))
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[4] || (_cache[4] = (...args)=>$options.run && $options.run(...args))
                            }, [
                                $c5ea9574d3b2c321$var$_hoisted_18,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ])
                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ])
            ])
        ]),
        $c5ea9574d3b2c321$var$_hoisted_19
    ], 64);
}

});

parcelRegister("3rYdg", function(module, exports) {

$parcel$export(module.exports, "default", () => $283299bbf4cc1f82$export$2e2bcd8739ae039);
let $283299bbf4cc1f82$var$NOOP = ()=>{};
var $283299bbf4cc1f82$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aUBz1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f1c45bd43dc81f8$export$2e2bcd8739ae039);
let $7f1c45bd43dc81f8$var$script;



let $7f1c45bd43dc81f8$var$initialize = ()=>{
    $7f1c45bd43dc81f8$var$script = (parcelRequire("gr72c"));
    if ($7f1c45bd43dc81f8$var$script.__esModule) $7f1c45bd43dc81f8$var$script = $7f1c45bd43dc81f8$var$script.default;
    $7f1c45bd43dc81f8$var$script.render = (parcelRequire("3swvR")).render;
    (parcelRequire("5HE5l")).default($7f1c45bd43dc81f8$var$script);
    $7f1c45bd43dc81f8$var$script.__scopeId = "data-v-af4450";
    $7f1c45bd43dc81f8$var$script.__file = "DataBatchCopyModal.vue";
};
$7f1c45bd43dc81f8$var$initialize();
var $7f1c45bd43dc81f8$export$2e2bcd8739ae039 = $7f1c45bd43dc81f8$var$script;

});
parcelRegister("gr72c", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf749fdef146e965$export$2e2bcd8739ae039);

var $7R1dy = parcelRequire("7R1dy");
var $bf749fdef146e965$export$2e2bcd8739ae039 = {
    name: "DataBatchCopyModal",
    props: {
        batch: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            copying: false,
            result: null,
            resultMessage: "",
            newName: this.batch.name + " (copy)"
        };
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        }
    },
    methods: {
        async copy () {
            this.copying = true;
            this.result = null;
            try {
                var content = {
                    ...this.batch,
                    name: this.newName.trim()
                };
                delete content.id;
                await (0, $7R1dy.default).dataBatchCreate(this.dataSpaceId, content);
                this.result = "success";
                this.resultMessage = this.$t("batchCopySuccessful");
            } catch (error) {
                this.result = "error";
                var key = error?.response?.body?.message || "unknownError";
                this.resultMessage = this.$t(key);
            } finally{
                this.copying = false;
                this.$emit("reload");
            }
        }
    }
};

});

parcelRegister("3swvR", function(module, exports) {

$parcel$export(module.exports, "render", () => $284d34ffacd57858$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $284d34ffacd57858$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $284d34ffacd57858$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $284d34ffacd57858$var$_hoisted_3 = {
    class: "modal-content"
};
const $284d34ffacd57858$var$_hoisted_4 = {
    class: "modal-header"
};
const $284d34ffacd57858$var$_hoisted_5 = {
    class: "modal-title"
};
const $284d34ffacd57858$var$_hoisted_6 = [
    "disabled"
];
const $284d34ffacd57858$var$_hoisted_7 = {
    class: "modal-body"
};
const $284d34ffacd57858$var$_hoisted_8 = {
    key: 0
};
const $284d34ffacd57858$var$_hoisted_9 = {
    class: "mb-3"
};
const $284d34ffacd57858$var$_hoisted_10 = {
    class: "form-label small fw-bold"
};
const $284d34ffacd57858$var$_hoisted_11 = {
    key: 1,
    class: "text-center py-3"
};
const $284d34ffacd57858$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border text-primary mb-2",
    role: "status"
}, null, -1);
const $284d34ffacd57858$var$_hoisted_13 = {
    class: "text-muted"
};
const $284d34ffacd57858$var$_hoisted_14 = {
    key: 2,
    class: "text-center py-3"
};
const $284d34ffacd57858$var$_hoisted_15 = {
    class: "mt-2"
};
const $284d34ffacd57858$var$_hoisted_16 = {
    class: "modal-footer"
};
const $284d34ffacd57858$var$_hoisted_17 = [
    "disabled"
];
const $284d34ffacd57858$var$_hoisted_18 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-copy"
}, null, -1);
const $284d34ffacd57858$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $284d34ffacd57858$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $284d34ffacd57858$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("copyBatch")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close")),
                            disabled: $data.copying
                        }, null, 8, $284d34ffacd57858$var$_hoisted_6)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_7, [
                        !$data.copying && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $284d34ffacd57858$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("label", $284d34ffacd57858$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("newBatchName")), 1),
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.newName = $event)
                                }, null, 512), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        $data.newName
                                    ]
                                ])
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.copying ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $284d34ffacd57858$var$_hoisted_11, [
                            $284d34ffacd57858$var$_hoisted_12,
                            (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("copying")) + "...", 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $284d34ffacd57858$var$_hoisted_14, [
                            (0, $TusQn.createElementVNode)("i", {
                                class: (0, $8POXm.normalizeClass)($data.result === "success" ? "fas fa-check-circle text-success" : "fas fa-times-circle text-danger"),
                                style: {
                                    "font-size": "32px"
                                }
                            }, null, 2),
                            (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_15, (0, $8POXm.toDisplayString)($data.resultMessage), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $284d34ffacd57858$var$_hoisted_16, [
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("close"))
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        !$data.copying && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("close"))
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[4] || (_cache[4] = (...args)=>$options.copy && $options.copy(...args)),
                                disabled: !$data.newName.trim()
                            }, [
                                $284d34ffacd57858$var$_hoisted_18,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ], 8, $284d34ffacd57858$var$_hoisted_17)
                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ])
            ])
        ]),
        $284d34ffacd57858$var$_hoisted_19
    ], 64);
}

});

parcelRegister("5HE5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $42700ff96cd12200$export$2e2bcd8739ae039);
let $42700ff96cd12200$var$NOOP = ()=>{};
var $42700ff96cd12200$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1MX2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d811fa5f5c53a9$export$2e2bcd8739ae039);
let $14d811fa5f5c53a9$var$script;



let $14d811fa5f5c53a9$var$initialize = ()=>{
    $14d811fa5f5c53a9$var$script = (parcelRequire("eiugC"));
    if ($14d811fa5f5c53a9$var$script.__esModule) $14d811fa5f5c53a9$var$script = $14d811fa5f5c53a9$var$script.default;
    $14d811fa5f5c53a9$var$script.render = (parcelRequire("fLj5Q")).render;
    (parcelRequire("d31wX")).default($14d811fa5f5c53a9$var$script);
    $14d811fa5f5c53a9$var$script.__scopeId = "data-v-25e432";
    $14d811fa5f5c53a9$var$script.__file = "DataBatchDeleteModal.vue";
};
$14d811fa5f5c53a9$var$initialize();
var $14d811fa5f5c53a9$export$2e2bcd8739ae039 = $14d811fa5f5c53a9$var$script;

});
parcelRegister("eiugC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a68a3986fa236af7$export$2e2bcd8739ae039);

var $7R1dy = parcelRequire("7R1dy");
var $a68a3986fa236af7$export$2e2bcd8739ae039 = {
    name: "DataBatchDeleteModal",
    props: {
        batch: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            deleting: false,
            result: null,
            resultMessage: ""
        };
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        }
    },
    methods: {
        async deleteBatch () {
            this.deleting = true;
            this.result = null;
            try {
                await (0, $7R1dy.default).dataBatchDelete(this.dataSpaceId, this.batch.id);
                this.result = "success";
                this.resultMessage = this.$t("batchDeleteSuccessful");
            } catch (error) {
                this.result = "error";
                var key = error?.response?.body?.message || "unknownError";
                this.resultMessage = this.$t(key);
            } finally{
                this.deleting = false;
                this.$emit("reload");
            }
        }
    }
};

});

parcelRegister("fLj5Q", function(module, exports) {

$parcel$export(module.exports, "render", () => $b79a0e5225863e39$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b79a0e5225863e39$var$_hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog"
};
const $b79a0e5225863e39$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $b79a0e5225863e39$var$_hoisted_3 = {
    class: "modal-content"
};
const $b79a0e5225863e39$var$_hoisted_4 = {
    class: "modal-header"
};
const $b79a0e5225863e39$var$_hoisted_5 = {
    class: "modal-title"
};
const $b79a0e5225863e39$var$_hoisted_6 = [
    "disabled"
];
const $b79a0e5225863e39$var$_hoisted_7 = {
    class: "modal-body"
};
const $b79a0e5225863e39$var$_hoisted_8 = {
    key: 0
};
const $b79a0e5225863e39$var$_hoisted_9 = {
    class: "fw-bold"
};
const $b79a0e5225863e39$var$_hoisted_10 = {
    key: 1,
    class: "text-center py-3"
};
const $b79a0e5225863e39$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "spinner-border text-primary mb-2",
    role: "status"
}, null, -1);
const $b79a0e5225863e39$var$_hoisted_12 = {
    class: "text-muted"
};
const $b79a0e5225863e39$var$_hoisted_13 = {
    key: 2,
    class: "text-center py-3"
};
const $b79a0e5225863e39$var$_hoisted_14 = {
    class: "mt-2"
};
const $b79a0e5225863e39$var$_hoisted_15 = {
    class: "modal-footer"
};
const $b79a0e5225863e39$var$_hoisted_16 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $b79a0e5225863e39$var$_hoisted_17 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "modal-backdrop fade show"
}, null, -1);
function $b79a0e5225863e39$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("h5", $b79a0e5225863e39$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("deleteBatch")), 1),
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close")),
                            disabled: $data.deleting
                        }, null, 8, $b79a0e5225863e39$var$_hoisted_6)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_7, [
                        !$data.deleting && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b79a0e5225863e39$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("confirmDeleteBatch")), 1),
                            (0, $TusQn.createElementVNode)("p", $b79a0e5225863e39$var$_hoisted_9, (0, $8POXm.toDisplayString)($props.batch.name), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.deleting ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b79a0e5225863e39$var$_hoisted_10, [
                            $b79a0e5225863e39$var$_hoisted_11,
                            (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("deleting")) + "...", 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b79a0e5225863e39$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("i", {
                                class: (0, $8POXm.normalizeClass)($data.result === "success" ? "fas fa-check-circle text-success" : "fas fa-times-circle text-danger"),
                                style: {
                                    "font-size": "32px"
                                }
                            }, null, 2),
                            (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_14, (0, $8POXm.toDisplayString)($data.resultMessage), 1)
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $b79a0e5225863e39$var$_hoisted_15, [
                        $data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("close"))
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1)) : (0, $TusQn.createCommentVNode)("", true),
                        !$data.deleting && !$data.result ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                            key: 1
                        }, [
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("close"))
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("cancel")), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-danger",
                                onClick: _cache[3] || (_cache[3] = (...args)=>$options.deleteBatch && $options.deleteBatch(...args))
                            }, [
                                $b79a0e5225863e39$var$_hoisted_16,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ], 64)) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ])
            ])
        ]),
        $b79a0e5225863e39$var$_hoisted_17
    ], 64);
}

});

parcelRegister("d31wX", function(module, exports) {

$parcel$export(module.exports, "default", () => $97fcbe17647318c1$export$2e2bcd8739ae039);
let $97fcbe17647318c1$var$NOOP = ()=>{};
var $97fcbe17647318c1$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("gSbhn", function(module, exports) {

$parcel$export(module.exports, "render", () => $c48a704ef0a6b078$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $c48a704ef0a6b078$var$_hoisted_1 = {
    class: "d-flex justify-content-between align-items-start mb-3"
};
const $c48a704ef0a6b078$var$_hoisted_2 = {
    key: 0,
    class: "text-muted"
};
const $c48a704ef0a6b078$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $c48a704ef0a6b078$var$_hoisted_4 = {
    key: 0,
    class: "table table-hover"
};
const $c48a704ef0a6b078$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    class: "text-end"
}, null, -1);
const $c48a704ef0a6b078$var$_hoisted_6 = {
    class: "badge-type"
};
const $c48a704ef0a6b078$var$_hoisted_7 = {
    class: "text-end"
};
const $c48a704ef0a6b078$var$_hoisted_8 = [
    "onClick",
    "title"
];
const $c48a704ef0a6b078$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-pencil-alt"
}, null, -1);
const $c48a704ef0a6b078$var$_hoisted_10 = [
    $c48a704ef0a6b078$var$_hoisted_9
];
const $c48a704ef0a6b078$var$_hoisted_11 = [
    "onClick",
    "title",
    "disabled"
];
const $c48a704ef0a6b078$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-play"
}, null, -1);
const $c48a704ef0a6b078$var$_hoisted_13 = [
    $c48a704ef0a6b078$var$_hoisted_12
];
const $c48a704ef0a6b078$var$_hoisted_14 = [
    "onClick",
    "title"
];
const $c48a704ef0a6b078$var$_hoisted_15 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-copy"
}, null, -1);
const $c48a704ef0a6b078$var$_hoisted_16 = [
    $c48a704ef0a6b078$var$_hoisted_15
];
const $c48a704ef0a6b078$var$_hoisted_17 = [
    "onClick",
    "title"
];
const $c48a704ef0a6b078$var$_hoisted_18 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $c48a704ef0a6b078$var$_hoisted_19 = [
    $c48a704ef0a6b078$var$_hoisted_18
];
const $c48a704ef0a6b078$var$_hoisted_20 = {
    key: 1,
    class: "text-muted"
};
function $c48a704ef0a6b078$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DataBatchAdd = (0, $TusQn.resolveComponent)("DataBatchAdd");
    const _component_DataBatchRunModal = (0, $TusQn.resolveComponent)("DataBatchRunModal");
    const _component_DataBatchCopyModal = (0, $TusQn.resolveComponent)("DataBatchCopyModal");
    const _component_DataBatchDeleteModal = (0, $TusQn.resolveComponent)("DataBatchDeleteModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("div", $c48a704ef0a6b078$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("h4", null, (0, $8POXm.toDisplayString)(_ctx.$t("batches")), 1),
                $data.batches.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("small", $c48a704ef0a6b078$var$_hoisted_2, (0, $8POXm.toDisplayString)($data.batches.length) + " " + (0, $8POXm.toDisplayString)(_ctx.$t("batchesInDataSpace")), 1)) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createElementVNode)("button", {
                class: "btn btn-primary btn-sm",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.createBatch && $options.createBatch(...args))
            }, [
                $c48a704ef0a6b078$var$_hoisted_3,
                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("newBatch")), 1)
            ])
        ]),
        $data.batches.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $c48a704ef0a6b078$var$_hoisted_4, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                    (0, $TusQn.createElementVNode)("th", null, (0, $8POXm.toDisplayString)(_ctx.$t("type")), 1),
                    $c48a704ef0a6b078$var$_hoisted_5
                ])
            ]),
            (0, $TusQn.createElementVNode)("tbody", null, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.batches, (item)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: item.id
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createElementVNode)("strong", null, (0, $8POXm.toDisplayString)(item.name), 1)
                        ]),
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createElementVNode)("span", $c48a704ef0a6b078$var$_hoisted_6, (0, $8POXm.toDisplayString)(item.batchType || "\u2013"), 1)
                        ]),
                        (0, $TusQn.createElementVNode)("td", $c48a704ef0a6b078$var$_hoisted_7, [
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-icon",
                                onClick: ($event)=>$options.editBatch(item),
                                title: _ctx.$t("edit")
                            }, $c48a704ef0a6b078$var$_hoisted_10, 8, $c48a704ef0a6b078$var$_hoisted_8),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-icon",
                                onClick: ($event)=>$options.runBatch(item),
                                title: _ctx.$t("run"),
                                disabled: item.status === "Running"
                            }, $c48a704ef0a6b078$var$_hoisted_13, 8, $c48a704ef0a6b078$var$_hoisted_11),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-icon",
                                onClick: ($event)=>$options.copyBatch(item),
                                title: _ctx.$t("copy")
                            }, $c48a704ef0a6b078$var$_hoisted_16, 8, $c48a704ef0a6b078$var$_hoisted_14),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-icon",
                                onClick: ($event)=>$options.deleteBatch(item),
                                title: _ctx.$t("delete")
                            }, $c48a704ef0a6b078$var$_hoisted_19, 8, $c48a704ef0a6b078$var$_hoisted_17)
                        ])
                    ]);
                }), 128))
            ])
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c48a704ef0a6b078$var$_hoisted_20, (0, $8POXm.toDisplayString)(_ctx.$t("noBatches")), 1)),
        $data.showForm ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_DataBatchAdd, {
            key: 2,
            onCreated: _cache[1] || (_cache[1] = ($event)=>{
                $data.showForm = false;
                $options.loadBatches();
            }),
            onCancel: _cache[2] || (_cache[2] = ($event)=>$data.showForm = false)
        })) : (0, $TusQn.createCommentVNode)("", true),
        $data.showDataBatchRun && $data.runningBatch ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_DataBatchRunModal, {
            key: 3,
            batch: $data.runningBatch,
            onReload: _cache[3] || (_cache[3] = ($event)=>$options.loadBatches()),
            onClose: $options.closeBatchRun
        }, null, 8, [
            "batch",
            "onClose"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showCopy && $data.copyingBatch ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_DataBatchCopyModal, {
            key: 4,
            batch: $data.copyingBatch,
            onReload: _cache[4] || (_cache[4] = ($event)=>$options.loadBatches()),
            onClose: $options.closeCopy
        }, null, 8, [
            "batch",
            "onClose"
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.showDelete && $data.deletingBatch ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_DataBatchDeleteModal, {
            key: 5,
            batch: $data.deletingBatch,
            onReload: _cache[5] || (_cache[5] = ($event)=>$options.loadBatches()),
            onClose: $options.closeDelete
        }, null, 8, [
            "batch",
            "onClose"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("83NLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de535d79ca98b1c$export$2e2bcd8739ae039);
let $5de535d79ca98b1c$var$NOOP = ()=>{};
var $5de535d79ca98b1c$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("eEd0R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aa9ee534b3494fa9$export$2e2bcd8739ae039);

var $8ylwZ = parcelRequire("8ylwZ");
var $aa9ee534b3494fa9$export$2e2bcd8739ae039 = {
    methods: {
        async onSubmit () {
            this.model.domain = "";
            let group = await (0, $8ylwZ.default).create(this.model);
            this.$router.push({
                name: "groupdetail",
                params: {
                    id: group.id
                }
            });
        }
    },
    data () {
        return {
            model: {
                name: ""
            }
        };
    }
};

});
parcelRegister("8ylwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a23353b214cb47$export$2e2bcd8739ae039);

var $2xZ6Q = parcelRequire("2xZ6Q");
const $63a23353b214cb47$var$GroupApi = {
    list: async ()=>{
        const req = (0, $2xZ6Q.default).get(`/api/group`);
        const res = await req;
        return res.body;
    },
    detail: async (group)=>{
        const req = (0, $2xZ6Q.default).get(`/api/group/${group}`);
        const res = await req;
        return res.body;
    },
    setPassword: async (id, password)=>{
        const req = (0, $2xZ6Q.default).put(`/api/group/${id}/resetpassword`).send(password);
        const res = await req;
        return res.body;
    },
    update: async (group)=>{
        const req = (0, $2xZ6Q.default).put(`/api/group/${group.id}`).send(group);
        const res = await req;
        return res.body;
    },
    create: async (group)=>{
        const req = (0, $2xZ6Q.default).post(`/api/group`).send(group);
        const res = await req;
        return res.body;
    },
    delete: async (groupId)=>{
        const req = (0, $2xZ6Q.default).delete(`/api/group/${groupId}`);
        await req;
    }
};
var $63a23353b214cb47$export$2e2bcd8739ae039 = $63a23353b214cb47$var$GroupApi;

});


parcelRegister("8fT8l", function(module, exports) {

$parcel$export(module.exports, "render", () => $602a7dd4a52757c4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $602a7dd4a52757c4$var$_hoisted_1 = {
    class: "container py-5"
};
const $602a7dd4a52757c4$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $602a7dd4a52757c4$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $602a7dd4a52757c4$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $602a7dd4a52757c4$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $602a7dd4a52757c4$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $602a7dd4a52757c4$var$_hoisted_7 = {
    class: "mb-3 col-md-4"
};
const $602a7dd4a52757c4$var$_hoisted_8 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $602a7dd4a52757c4$var$_hoisted_9 = [
    "placeholder"
];
function $602a7dd4a52757c4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $602a7dd4a52757c4$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("groupCreation")), 1),
        (0, $TusQn.createElementVNode)("nav", $602a7dd4a52757c4$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $602a7dd4a52757c4$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $602a7dd4a52757c4$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $602a7dd4a52757c4$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/groups"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $602a7dd4a52757c4$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $602a7dd4a52757c4$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("label", $602a7dd4a52757c4$var$_hoisted_8, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.model.name = $event),
                type: "text",
                class: "form-control",
                id: "name",
                placeholder: _ctx.$t("enterGroupName")
            }, null, 8, $602a7dd4a52757c4$var$_hoisted_9), [
                [
                    (0, $eeJ70.vModelText),
                    $data.model.name
                ]
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
        }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
    ]);
}

});

parcelRegister("9pQMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6daf63e4683bb6a5$export$2e2bcd8739ae039);
let $6daf63e4683bb6a5$var$NOOP = ()=>{};
var $6daf63e4683bb6a5$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("5mc4j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3e685e677fa2e0e7$export$2e2bcd8739ae039);

var $8ylwZ = parcelRequire("8ylwZ");
var $3e685e677fa2e0e7$export$2e2bcd8739ae039 = {
    name: "groupdetail",
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async saveGroup () {
            await (0, $8ylwZ.default).update(this.data);
            this.showSuccess();
        },
        async requestData () {
            this.data = await (0, $8ylwZ.default).detail(this.$route.params.id);
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "groupUpdated",
            type: "success"
        }
    },
    data () {
        return {
            data: {
                name: "",
                id: ""
            }
        };
    }
};

});

parcelRegister("7Tdkd", function(module, exports) {

$parcel$export(module.exports, "render", () => $5be80189028e6267$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5be80189028e6267$var$_hoisted_1 = {
    class: "container py-5"
};
const $5be80189028e6267$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $5be80189028e6267$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $5be80189028e6267$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $5be80189028e6267$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $5be80189028e6267$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $5be80189028e6267$var$_hoisted_7 = {
    class: "row mb-3"
};
const $5be80189028e6267$var$_hoisted_8 = {
    class: "col-md-6"
};
const $5be80189028e6267$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "form-label"
}, "Id", -1);
const $5be80189028e6267$var$_hoisted_10 = {
    class: "row mb-3"
};
const $5be80189028e6267$var$_hoisted_11 = {
    class: "col-md-6"
};
const $5be80189028e6267$var$_hoisted_12 = {
    class: "form-label"
};
function $5be80189028e6267$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5be80189028e6267$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("groupDetail")), 1),
        (0, $TusQn.createElementVNode)("nav", $5be80189028e6267$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $5be80189028e6267$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $5be80189028e6267$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5be80189028e6267$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/groups"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $5be80189028e6267$var$_hoisted_6, (0, $8POXm.toDisplayString)($data.data.name), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5be80189028e6267$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("div", $5be80189028e6267$var$_hoisted_8, [
                $5be80189028e6267$var$_hoisted_9,
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    disabled: "",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.id = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.id
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $5be80189028e6267$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("div", $5be80189028e6267$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $5be80189028e6267$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.name = $event)
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = (...args)=>$options.saveGroup && $options.saveGroup(...args))
        }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
    ]);
}

});

parcelRegister("eSXPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6485487c3b81b8$export$2e2bcd8739ae039);
let $ad6485487c3b81b8$var$NOOP = ()=>{};
var $ad6485487c3b81b8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("azYLk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7b3c4e62580de168$export$2e2bcd8739ae039);

var $8ylwZ = parcelRequire("8ylwZ");

var $a0suP = parcelRequire("a0suP");
var $7b3c4e62580de168$export$2e2bcd8739ae039 = {
    name: "groups",
    components: {
        GroupModal: $a0suP.default
    },
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.list = await (0, $8ylwZ.default).list();
        },
        showDeleteGroupModal (item) {
            this.groupToDeleteId = item.id;
            this.groupToDeleteName = item.name;
            this.isModalVisible = true;
        }
    },
    data () {
        return {
            groupToDeleteId: "",
            groupToDeleteName: "",
            isModalVisible: false,
            list: []
        };
    }
};

});
parcelRegister("a0suP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7490023dd2fdc22b$export$2e2bcd8739ae039);
let $7490023dd2fdc22b$var$script;



let $7490023dd2fdc22b$var$initialize = ()=>{
    $7490023dd2fdc22b$var$script = (parcelRequire("gTbuT"));
    if ($7490023dd2fdc22b$var$script.__esModule) $7490023dd2fdc22b$var$script = $7490023dd2fdc22b$var$script.default;
    $7490023dd2fdc22b$var$script.render = (parcelRequire("foKsZ")).render;
    (parcelRequire("b3L6g")).default($7490023dd2fdc22b$var$script);
    $7490023dd2fdc22b$var$script.__scopeId = "data-v-00be59";
    $7490023dd2fdc22b$var$script.__file = "GroupDeleteModal.vue";
};
$7490023dd2fdc22b$var$initialize();
var $7490023dd2fdc22b$export$2e2bcd8739ae039 = $7490023dd2fdc22b$var$script;

});
parcelRegister("gTbuT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c4bab388fc46391d$export$2e2bcd8739ae039);

var $8ylwZ = parcelRequire("8ylwZ");
var $c4bab388fc46391d$export$2e2bcd8739ae039 = {
    name: "groupDeleteModal",
    methods: {
        close () {
            this.$parent.isModalVisible = false;
        },
        async deleteGroup () {
            await (0, $8ylwZ.default).delete(this.$parent.groupToDeleteId);
            this.close();
            this.$emit("reload");
        }
    }
};

});

parcelRegister("foKsZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $b35d2431b0cdb40e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
var $8POXm = parcelRequire("8POXm");
const $b35d2431b0cdb40e$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $b35d2431b0cdb40e$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $b35d2431b0cdb40e$var$_hoisted_3 = {
    class: "modal-content"
};
const $b35d2431b0cdb40e$var$_hoisted_4 = {
    class: "modal-header"
};
const $b35d2431b0cdb40e$var$_hoisted_5 = {
    class: "modal-title"
};
const $b35d2431b0cdb40e$var$_hoisted_6 = {
    class: "modal-body"
};
const $b35d2431b0cdb40e$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $b35d2431b0cdb40e$var$_hoisted_8 = {
    class: "modal-footer"
};
function $b35d2431b0cdb40e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $b35d2431b0cdb40e$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $b35d2431b0cdb40e$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $b35d2431b0cdb40e$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $b35d2431b0cdb40e$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $b35d2431b0cdb40e$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("groupDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b35d2431b0cdb40e$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $b35d2431b0cdb40e$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisGroup")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $b35d2431b0cdb40e$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteGroup && $options.deleteGroup(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("b3L6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $80d48294da76ea8e$export$2e2bcd8739ae039);
let $80d48294da76ea8e$var$NOOP = ()=>{};
var $80d48294da76ea8e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("8F88h", function(module, exports) {

$parcel$export(module.exports, "render", () => $64e87607d68a034d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $64e87607d68a034d$var$_hoisted_1 = {
    class: "table table-bordered table-responsive-md"
};
const $64e87607d68a034d$var$_hoisted_2 = {
    class: "text-center"
};
const $64e87607d68a034d$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-lg fa-plus"
}, null, -1);
const $64e87607d68a034d$var$_hoisted_4 = {
    key: 0
};
const $64e87607d68a034d$var$_hoisted_5 = [
    "onClick"
];
function $64e87607d68a034d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupModal = (0, $TusQn.resolveComponent)("GroupModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("table", $64e87607d68a034d$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $64e87607d68a034d$var$_hoisted_2, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("groups")) + " ", 1),
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            style: {
                                "float": "right"
                            },
                            to: {
                                name: "groupadd"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $64e87607d68a034d$var$_hoisted_3
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
            $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $64e87607d68a034d$var$_hoisted_4, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: {
                                    name: "groupdetail",
                                    params: {
                                        id: item.id
                                    }
                                }
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ]),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "float": "right",
                                    "padding-top": "10px",
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>$options.showDeleteGroupModal(item),
                                class: "fas fa-sm fa-trash"
                            }, null, 8, $64e87607d68a034d$var$_hoisted_5)
                        ])
                    ]);
                }), 128))
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        $data.isModalVisible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_GroupModal, {
            key: 0,
            onReload: $options.requestData
        }, null, 8, [
            "onReload"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("7SllT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bbe23a637543173$export$2e2bcd8739ae039);
let $5bbe23a637543173$var$NOOP = ()=>{};
var $5bbe23a637543173$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("30lCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $230225d546b58beb$export$2e2bcd8739ae039);

var $5jPJV = parcelRequire("5jPJV");

var $eIVtJ = parcelRequire("eIVtJ");
var $230225d546b58beb$export$2e2bcd8739ae039 = {
    components: {
        GroupToUserDialog: $eIVtJ.default
    },
    methods: {
        async onSubmit () {
            let content = JSON.parse(this.data.content);
            content.team = this.data.teamName;
            content.role = this.data.role;
            content.groupId = this.data.groupId;
            this.data.content = JSON.stringify(content);
            let user = await (0, $5jPJV.default).create(this.data);
            await (0, $5jPJV.default).setPassword(user.id, this.data);
            this.$router.push({
                name: "userdetail",
                params: {
                    id: user.id
                }
            });
        },
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.groupName = modalData.name;
            this.data.groupId = modalData.id;
            this.closeModal();
        },
        showModal () {
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        }
    },
    data () {
        return {
            isModalVisible: false,
            data: {
                groupName: "",
                groupId: 0,
                userName: "",
                name: "",
                role: "",
                teamName: "",
                content: "{}",
                password: ""
            }
        };
    }
};

});
parcelRegister("eIVtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab81c2d0053c7b84$export$2e2bcd8739ae039);
let $ab81c2d0053c7b84$var$script;



let $ab81c2d0053c7b84$var$initialize = ()=>{
    $ab81c2d0053c7b84$var$script = (parcelRequire("02YK3"));
    if ($ab81c2d0053c7b84$var$script.__esModule) $ab81c2d0053c7b84$var$script = $ab81c2d0053c7b84$var$script.default;
    $ab81c2d0053c7b84$var$script.render = (parcelRequire("d4Upa")).render;
    (parcelRequire("hWBfG")).default($ab81c2d0053c7b84$var$script);
    $ab81c2d0053c7b84$var$script.__scopeId = "data-v-461c9a";
    $ab81c2d0053c7b84$var$script.__file = "GroupToUserDialog.vue";
};
$ab81c2d0053c7b84$var$initialize();
var $ab81c2d0053c7b84$export$2e2bcd8739ae039 = $ab81c2d0053c7b84$var$script;

});
parcelRegister("02YK3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $008f4e154ba6eb36$export$2e2bcd8739ae039);

var $8ylwZ = parcelRequire("8ylwZ");
var $008f4e154ba6eb36$export$2e2bcd8739ae039 = {
    name: "GroupToUserDialog",
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.list = await (0, $8ylwZ.default).list();
            this.checked();
        },
        checked (id) {
            if (this.$parent.data && this.$parent.data.groupId && this.$parent.data.groupId === id) return true;
            else return false;
        },
        onChange (data) {
            this.selectedRadio = data;
        },
        close () {
            this.$emit("close");
        },
        confirm () {
            this.$emit("confirm", this.selectedRadio);
        }
    },
    data () {
        return {
            list: [],
            selectedRadio: {}
        };
    }
};

});

parcelRegister("d4Upa", function(module, exports) {

$parcel$export(module.exports, "render", () => $985766f3484a3d4f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
var $8POXm = parcelRequire("8POXm");
const $985766f3484a3d4f$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $985766f3484a3d4f$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg",
    role: "document"
};
const $985766f3484a3d4f$var$_hoisted_3 = {
    class: "modal-content"
};
const $985766f3484a3d4f$var$_hoisted_4 = {
    class: "modal-header"
};
const $985766f3484a3d4f$var$_hoisted_5 = {
    class: "modal-title"
};
const $985766f3484a3d4f$var$_hoisted_6 = {
    class: "modal-body",
    style: {
        "padding": "0",
        "height": "196px"
    }
};
const $985766f3484a3d4f$var$_hoisted_7 = {
    class: "table"
};
const $985766f3484a3d4f$var$_hoisted_8 = {
    key: 0,
    class: "bodyDialog"
};
const $985766f3484a3d4f$var$_hoisted_9 = {
    class: "form-check"
};
const $985766f3484a3d4f$var$_hoisted_10 = [
    "for"
];
const $985766f3484a3d4f$var$_hoisted_11 = [
    "checked",
    "id",
    "onChange"
];
const $985766f3484a3d4f$var$_hoisted_12 = {
    class: "modal-footer"
};
function $985766f3484a3d4f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $985766f3484a3d4f$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $985766f3484a3d4f$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $985766f3484a3d4f$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $985766f3484a3d4f$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $985766f3484a3d4f$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $985766f3484a3d4f$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("table", $985766f3484a3d4f$var$_hoisted_7, [
                                    $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $985766f3484a3d4f$var$_hoisted_8, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (item, i)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                key: i
                                            }, [
                                                (0, $TusQn.createElementVNode)("td", $985766f3484a3d4f$var$_hoisted_9, [
                                                    (0, $TusQn.createElementVNode)("label", {
                                                        style: {
                                                            "padding-left": "20px"
                                                        },
                                                        class: "margin form-check-label",
                                                        for: item.id
                                                    }, [
                                                        (0, $TusQn.createElementVNode)("input", {
                                                            checked: $options.checked(item.id),
                                                            id: item.id,
                                                            type: "radio",
                                                            class: "form-check-input",
                                                            onChange: ($event)=>$options.onChange({
                                                                    id: item.id,
                                                                    name: item.name
                                                                }),
                                                            name: "optradio"
                                                        }, null, 40, $985766f3484a3d4f$var$_hoisted_11),
                                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                                    ], 8, $985766f3484a3d4f$var$_hoisted_10)
                                                ])
                                            ]);
                                        }), 128))
                                    ])) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("div", $985766f3484a3d4f$var$_hoisted_12, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.confirm && $options.confirm(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("hWBfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d104bfeacf26782b$export$2e2bcd8739ae039);
let $d104bfeacf26782b$var$NOOP = ()=>{};
var $d104bfeacf26782b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9qKIT", function(module, exports) {

$parcel$export(module.exports, "render", () => $6ddac90386e33480$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $6ddac90386e33480$var$_hoisted_1 = {
    class: "container py-5"
};
const $6ddac90386e33480$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $6ddac90386e33480$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $6ddac90386e33480$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $6ddac90386e33480$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $6ddac90386e33480$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $6ddac90386e33480$var$_hoisted_7 = {
    class: "row"
};
const $6ddac90386e33480$var$_hoisted_8 = {
    class: "mb-3 col-md-6"
};
const $6ddac90386e33480$var$_hoisted_9 = {
    class: "form-label",
    for: "name",
    required: ""
};
const $6ddac90386e33480$var$_hoisted_10 = [
    "placeholder"
];
const $6ddac90386e33480$var$_hoisted_11 = {
    class: "mb-3 col-md-6"
};
const $6ddac90386e33480$var$_hoisted_12 = {
    class: "form-label"
};
const $6ddac90386e33480$var$_hoisted_13 = {
    disabled: ""
};
const $6ddac90386e33480$var$_hoisted_14 = {
    value: "Viewer",
    id: "viewer"
};
const $6ddac90386e33480$var$_hoisted_15 = {
    value: "LyzarEditor",
    id: "projectadmin"
};
const $6ddac90386e33480$var$_hoisted_16 = {
    value: "Admin",
    id: "admin"
};
const $6ddac90386e33480$var$_hoisted_17 = {
    class: "row mb-3"
};
const $6ddac90386e33480$var$_hoisted_18 = {
    class: "col-md-6"
};
const $6ddac90386e33480$var$_hoisted_19 = {
    class: "form-label",
    for: "userName",
    required: ""
};
const $6ddac90386e33480$var$_hoisted_20 = [
    "placeholder"
];
const $6ddac90386e33480$var$_hoisted_21 = {
    class: "col-md-6"
};
const $6ddac90386e33480$var$_hoisted_22 = {
    class: "form-label"
};
const $6ddac90386e33480$var$_hoisted_23 = [
    "placeholder"
];
const $6ddac90386e33480$var$_hoisted_24 = {
    class: "row mb-3"
};
const $6ddac90386e33480$var$_hoisted_25 = {
    class: "col-md-6"
};
const $6ddac90386e33480$var$_hoisted_26 = {
    class: "form-label",
    for: "password"
};
const $6ddac90386e33480$var$_hoisted_27 = [
    "placeholder"
];
const $6ddac90386e33480$var$_hoisted_28 = {
    class: "col-md-6"
};
const $6ddac90386e33480$var$_hoisted_29 = {
    class: "form-label"
};
const $6ddac90386e33480$var$_hoisted_30 = {
    class: "input-group"
};
const $6ddac90386e33480$var$_hoisted_31 = [
    "placeholder"
];
const $6ddac90386e33480$var$_hoisted_32 = {
    class: "input-group-append"
};
function $6ddac90386e33480$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupToUserDialog = (0, $TusQn.resolveComponent)("GroupToUserDialog");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ddac90386e33480$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("userCreation")), 1),
        (0, $TusQn.createElementVNode)("nav", $6ddac90386e33480$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $6ddac90386e33480$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $6ddac90386e33480$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: {
                            name: "modelings"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $6ddac90386e33480$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/settings/users"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $6ddac90386e33480$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("label", $6ddac90386e33480$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event),
                    type: "text",
                    class: "form-control",
                    id: "name",
                    placeholder: _ctx.$t("enterUserName")
                }, null, 8, $6ddac90386e33480$var$_hoisted_10), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.name
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $6ddac90386e33480$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("role")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    id: "role",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.role = $event),
                    class: "form-control"
                }, [
                    (0, $TusQn.createElementVNode)("option", $6ddac90386e33480$var$_hoisted_13, (0, $8POXm.toDisplayString)(_ctx.$t("chooseRole")), 1),
                    (0, $TusQn.createElementVNode)("option", $6ddac90386e33480$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("viewer")), 1),
                    (0, $TusQn.createElementVNode)("option", $6ddac90386e33480$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("projectadmin")), 1),
                    (0, $TusQn.createElementVNode)("option", $6ddac90386e33480$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("admin")), 1)
                ], 512), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $data.data.role
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("label", $6ddac90386e33480$var$_hoisted_19, (0, $8POXm.toDisplayString)(_ctx.$t("loginName")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.userName = $event),
                    type: "text",
                    class: "form-control",
                    id: "userName",
                    placeholder: _ctx.$t("enterLogin")
                }, null, 8, $6ddac90386e33480$var$_hoisted_20), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.userName
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("label", $6ddac90386e33480$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("team")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "form-control",
                    placeholder: _ctx.$t("teamName"),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.teamName = $event)
                }, null, 8, $6ddac90386e33480$var$_hoisted_23), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.teamName
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_24, [
            (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_25, [
                (0, $TusQn.createElementVNode)("label", $6ddac90386e33480$var$_hoisted_26, (0, $8POXm.toDisplayString)(_ctx.$t("password")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.data.password = $event),
                    type: "Password",
                    class: "form-control",
                    id: "password",
                    placeholder: _ctx.$t("enterPassword")
                }, null, 8, $6ddac90386e33480$var$_hoisted_27), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.data.password
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_28, [
                (0, $TusQn.createElementVNode)("label", $6ddac90386e33480$var$_hoisted_29, (0, $8POXm.toDisplayString)(_ctx.$t("group")), 1),
                (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_30, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        placeholder: _ctx.$t("chooseGroup"),
                        onClick: _cache[5] || (_cache[5] = (...args)=>$options.showModal && $options.showModal(...args)),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.data.groupName = $event),
                        readonly: ""
                    }, null, 8, $6ddac90386e33480$var$_hoisted_31), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.groupName
                        ]
                    ]),
                    (0, $TusQn.createElementVNode)("div", $6ddac90386e33480$var$_hoisted_32, [
                        (0, $TusQn.createElementVNode)("button", {
                            class: "btn btn-outline-secondary",
                            onClick: _cache[7] || (_cache[7] = (...args)=>$options.showModal && $options.showModal(...args)),
                            type: "button"
                        }, (0, $8POXm.toDisplayString)(_ctx.$t("choose")), 1)
                    ])
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[8] || (_cache[8] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
        }, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_GroupToUserDialog, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("doVnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c1a07ecc888d044$export$2e2bcd8739ae039);
let $9c1a07ecc888d044$var$NOOP = ()=>{};
var $9c1a07ecc888d044$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bSAur", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8a610b04a0e7a831$export$2e2bcd8739ae039);

var $eIVtJ = parcelRequire("eIVtJ");

var $5jPJV = parcelRequire("5jPJV");

var $8ylwZ = parcelRequire("8ylwZ");
var $8a610b04a0e7a831$export$2e2bcd8739ae039 = {
    name: "userdetail",
    components: {
        GroupToUserDialog: $eIVtJ.default
    },
    data () {
        return {
            pending: true,
            isModalVisible: false,
            error: false,
            data: {
                groupName: "",
                groupId: 0,
                name: "",
                userName: "",
                teamName: "",
                role: ""
            }
        };
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "userUpdated",
            type: "success"
        }
    },
    watch: {
        $route: "requestData"
    },
    mounted () {
        this.requestData();
    },
    methods: {
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.groupName = modalData.name;
            this.data.groupId = modalData.id;
            this.closeModal();
        },
        showModal () {
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        },
        async saveUser () {
            let content = JSON.parse(this.data.content);
            content.groupId = this.data.groupId;
            content.team = this.data.teamName;
            content.role = this.data.role;
            this.data.content = JSON.stringify(content);
            await (0, $5jPJV.default).update(this.data);
            this.showSuccess();
        },
        async requestData () {
            let self = this;
            this.pending = true;
            try {
                const data = await (0, $5jPJV.default).detail(this.$route.params.id);
                this.data = data;
                this.error = false;
                if (data && data.content != null) {
                    let content = JSON.parse(data.content);
                    if (content.groupId && content.groupId > 0) {
                        self.data.groupId = content.groupId;
                        let groupName = await (0, $8ylwZ.default).detail(content.groupId);
                        if (groupName) self.data.groupName = groupName.name;
                    } else self.data.groupId = 0;
                    if (content.team) self.data.teamName = content.team;
                    if (content.role) self.data.role = content.role;
                }
            } catch (e) {
                this.data = null;
                this.error = e;
            }
            this.pending = false;
        }
    },
    render () {
        return this.$scopedSlots.default({
            pending: this.pending,
            error: this.error,
            data: this.data
        });
    }
};

});

parcelRegister("a8yfi", function(module, exports) {

$parcel$export(module.exports, "render", () => $7615373e6a5b130d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $7615373e6a5b130d$var$_hoisted_1 = {
    class: "container py-5"
};
const $7615373e6a5b130d$var$_hoisted_2 = {
    key: 0
};
const $7615373e6a5b130d$var$_hoisted_3 = {
    key: 1
};
const $7615373e6a5b130d$var$_hoisted_4 = {
    key: 2
};
const $7615373e6a5b130d$var$_hoisted_5 = {
    "aria-label": "breadcrumb"
};
const $7615373e6a5b130d$var$_hoisted_6 = {
    class: "breadcrumb"
};
const $7615373e6a5b130d$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $7615373e6a5b130d$var$_hoisted_8 = {
    class: "breadcrumb-item"
};
const $7615373e6a5b130d$var$_hoisted_9 = {
    class: "breadcrumb-item"
};
const $7615373e6a5b130d$var$_hoisted_10 = {
    class: "row mb-3"
};
const $7615373e6a5b130d$var$_hoisted_11 = {
    class: "col-md-6"
};
const $7615373e6a5b130d$var$_hoisted_12 = {
    class: "form-label"
};
const $7615373e6a5b130d$var$_hoisted_13 = {
    class: "col-md-6"
};
const $7615373e6a5b130d$var$_hoisted_14 = {
    class: "form-label"
};
const $7615373e6a5b130d$var$_hoisted_15 = {
    disabled: ""
};
const $7615373e6a5b130d$var$_hoisted_16 = {
    value: "Viewer",
    id: "viewer"
};
const $7615373e6a5b130d$var$_hoisted_17 = {
    value: "LyzarEditor",
    id: "projectadmin"
};
const $7615373e6a5b130d$var$_hoisted_18 = {
    value: "Admin",
    id: "admin"
};
const $7615373e6a5b130d$var$_hoisted_19 = {
    class: "row mb-3"
};
const $7615373e6a5b130d$var$_hoisted_20 = {
    class: "col-md-6"
};
const $7615373e6a5b130d$var$_hoisted_21 = {
    class: "form-label"
};
const $7615373e6a5b130d$var$_hoisted_22 = {
    class: "col-md-6"
};
const $7615373e6a5b130d$var$_hoisted_23 = {
    class: "form-label"
};
const $7615373e6a5b130d$var$_hoisted_24 = [
    "placeholder"
];
const $7615373e6a5b130d$var$_hoisted_25 = {
    class: "row mb-3"
};
const $7615373e6a5b130d$var$_hoisted_26 = {
    class: "col-md-6"
};
const $7615373e6a5b130d$var$_hoisted_27 = {
    class: "form-label"
};
const $7615373e6a5b130d$var$_hoisted_28 = {
    class: "input-group"
};
const $7615373e6a5b130d$var$_hoisted_29 = [
    "placeholder"
];
const $7615373e6a5b130d$var$_hoisted_30 = {
    class: "input-group-append"
};
const $7615373e6a5b130d$var$_hoisted_31 = {
    class: "col-md-6"
};
const $7615373e6a5b130d$var$_hoisted_32 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    style: {
        "display": "block"
    }
}, "\xa0", -1);
function $7615373e6a5b130d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_GroupToUserDialog = (0, $TusQn.resolveComponent)("GroupToUserDialog");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7615373e6a5b130d$var$_hoisted_1, [
        $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7615373e6a5b130d$var$_hoisted_2, (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)) : $data.error ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7615373e6a5b130d$var$_hoisted_3, (0, $8POXm.toDisplayString)(_ctx.$t("error")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $7615373e6a5b130d$var$_hoisted_4, [
            (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("userDetail")), 1),
            (0, $TusQn.createElementVNode)("nav", $7615373e6a5b130d$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("ol", $7615373e6a5b130d$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("li", $7615373e6a5b130d$var$_hoisted_7, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: {
                                name: "modelings"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("li", $7615373e6a5b130d$var$_hoisted_8, [
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: "/settings/users"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")), 1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("li", $7615373e6a5b130d$var$_hoisted_9, (0, $8POXm.toDisplayString)($data.data.name), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_10, [
                (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("label", $7615373e6a5b130d$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.data.name = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.name
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("label", $7615373e6a5b130d$var$_hoisted_14, (0, $8POXm.toDisplayString)(_ctx.$t("role")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                        id: "role",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.data.role = $event),
                        class: "form-control"
                    }, [
                        (0, $TusQn.createElementVNode)("option", $7615373e6a5b130d$var$_hoisted_15, (0, $8POXm.toDisplayString)(_ctx.$t("chooseRole")), 1),
                        (0, $TusQn.createElementVNode)("option", $7615373e6a5b130d$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("viewer")), 1),
                        (0, $TusQn.createElementVNode)("option", $7615373e6a5b130d$var$_hoisted_17, (0, $8POXm.toDisplayString)(_ctx.$t("projectadmin")), 1),
                        (0, $TusQn.createElementVNode)("option", $7615373e6a5b130d$var$_hoisted_18, (0, $8POXm.toDisplayString)(_ctx.$t("admin")), 1)
                    ], 512), [
                        [
                            (0, $eeJ70.vModelSelect),
                            $data.data.role
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_19, [
                (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_20, [
                    (0, $TusQn.createElementVNode)("label", $7615373e6a5b130d$var$_hoisted_21, (0, $8POXm.toDisplayString)(_ctx.$t("loginName")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.data.userName = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.userName
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_22, [
                    (0, $TusQn.createElementVNode)("label", $7615373e6a5b130d$var$_hoisted_23, (0, $8POXm.toDisplayString)(_ctx.$t("team")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        placeholder: _ctx.$t("teamName"),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.data.teamName = $event)
                    }, null, 8, $7615373e6a5b130d$var$_hoisted_24), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.data.teamName
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_25, [
                (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_26, [
                    (0, $TusQn.createElementVNode)("label", $7615373e6a5b130d$var$_hoisted_27, (0, $8POXm.toDisplayString)(_ctx.$t("group")), 1),
                    (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_28, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "form-control",
                            placeholder: _ctx.$t("chooseGroup"),
                            onClick: _cache[4] || (_cache[4] = (...args)=>$options.showModal && $options.showModal(...args)),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.data.groupName = $event),
                            readonly: ""
                        }, null, 8, $7615373e6a5b130d$var$_hoisted_29), [
                            [
                                (0, $eeJ70.vModelText),
                                $data.data.groupName
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_30, [
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-outline-secondary",
                                onClick: _cache[6] || (_cache[6] = (...args)=>$options.showModal && $options.showModal(...args)),
                                type: "button"
                            }, (0, $8POXm.toDisplayString)(_ctx.$t("choose")), 1)
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $7615373e6a5b130d$var$_hoisted_31, [
                    $7615373e6a5b130d$var$_hoisted_32,
                    (0, $TusQn.createElementVNode)("button", {
                        class: "btn btn-primary",
                        onClick: _cache[7] || (_cache[7] = (...args)=>$options.saveUser && $options.saveUser(...args)),
                        style: {
                            "float": "right"
                        }
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
                ])
            ])
        ])),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_GroupToUserDialog, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("gMcEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36af1695e718520$export$2e2bcd8739ae039);
let $c36af1695e718520$var$NOOP = ()=>{};
var $c36af1695e718520$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("h4Sdx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c6ecddd58162a725$export$2e2bcd8739ae039);

var $5jPJV = parcelRequire("5jPJV");

var $grWtY = parcelRequire("grWtY");

var $iqICt = parcelRequire("iqICt");
var $c6ecddd58162a725$export$2e2bcd8739ae039 = {
    name: "users",
    components: {
        UserDeleteModal: $iqICt.default,
        PasswordModal: $grWtY.default
    },
    mounted () {
        this.requestData();
    },
    data () {
        return {
            userToDeleteId: "",
            userToDeleteName: "",
            userToChangePasswordId: "",
            userToChangePasswordName: "",
            isDeleteModalVisible: false,
            modalId: 0,
            isModalVisible: false,
            list: []
        };
    },
    methods: {
        async requestData () {
            this.list = await (0, $5jPJV.default).list();
        },
        showDeleteUserModal (user) {
            this.userToDeleteId = user.id;
            this.userToDeleteName = user.name;
            this.isDeleteModalVisible = true;
        },
        closeDeleteModal () {
            this.isDeleteModalVisible = false;
        },
        confirmModal (modalData) {
            this.modalData = modalData;
            this.data.parentName = modalData.name;
            this.data.parentId = modalData.id;
            this.closeModal();
        },
        showModal (user) {
            this.userToChangePasswordId = user.id;
            this.userToChangePasswordName = user.name;
            this.isModalVisible = true;
        },
        closeModal () {
            this.isModalVisible = false;
        }
    }
};

});
parcelRegister("grWtY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf9c885bdbc176bd$export$2e2bcd8739ae039);
let $bf9c885bdbc176bd$var$script;



let $bf9c885bdbc176bd$var$initialize = ()=>{
    $bf9c885bdbc176bd$var$script = (parcelRequire("lFHZV"));
    if ($bf9c885bdbc176bd$var$script.__esModule) $bf9c885bdbc176bd$var$script = $bf9c885bdbc176bd$var$script.default;
    $bf9c885bdbc176bd$var$script.render = (parcelRequire("j7pMA")).render;
    (parcelRequire("8qOK4")).default($bf9c885bdbc176bd$var$script);
    $bf9c885bdbc176bd$var$script.__scopeId = "data-v-bdec3a";
    $bf9c885bdbc176bd$var$script.__file = "UserPasswordDialog.vue";
};
$bf9c885bdbc176bd$var$initialize();
var $bf9c885bdbc176bd$export$2e2bcd8739ae039 = $bf9c885bdbc176bd$var$script;

});
parcelRegister("lFHZV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fc6f8e59b8881eda$export$2e2bcd8739ae039);

var $5jPJV = parcelRequire("5jPJV");
var $fc6f8e59b8881eda$export$2e2bcd8739ae039 = {
    name: "modal",
    notifications: {
        showSuccess: {
            title: "Password change",
            message: "Password succesfully changed!",
            type: "success"
        },
        showError: {
            title: "Password change",
            message: "Your password is too short!",
            type: "error"
        }
    },
    methods: {
        close () {
            this.$emit("close");
            this.danger = "";
            this.model.password = "";
        },
        async setPassword () {
            if (this.model.password.length > 3) {
                await (0, $5jPJV.default).setPassword(this.$parent.userToChangePasswordId, this.model);
                this.showSuccess();
                this.$emit("close");
                this.danger = "";
                this.model.password = "";
            } else {
                this.showError();
                this.danger = "danger";
            }
        }
    },
    data () {
        return {
            danger: "",
            model: {
                password: ""
            }
        };
    }
};

});

parcelRegister("j7pMA", function(module, exports) {

$parcel$export(module.exports, "render", () => $deb2abaa06113f87$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $deb2abaa06113f87$var$_hoisted_1 = {
    class: "user-password-dialog modal modal-fade",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
};
const $deb2abaa06113f87$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered modal-lg"
};
const $deb2abaa06113f87$var$_hoisted_3 = {
    class: "modal-content"
};
const $deb2abaa06113f87$var$_hoisted_4 = {
    class: "modal-header"
};
const $deb2abaa06113f87$var$_hoisted_5 = {
    class: "modal-title"
};
const $deb2abaa06113f87$var$_hoisted_6 = {
    class: "modal-body"
};
const $deb2abaa06113f87$var$_hoisted_7 = {
    class: "modal-footer"
};
function $deb2abaa06113f87$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $deb2abaa06113f87$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $deb2abaa06113f87$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $deb2abaa06113f87$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $deb2abaa06113f87$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("h5", $deb2abaa06113f87$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("passwordChange")), 1),
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn-close",
                        onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                        "data-dismiss": "modal",
                        "aria-label": "Close"
                    })
                ]),
                (0, $TusQn.createElementVNode)("div", $deb2abaa06113f87$var$_hoisted_6, [
                    (0, $TusQn.createElementVNode)("form", null, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: (0, $8POXm.normalizeClass)([
                                "form-control",
                                $data.danger
                            ]),
                            type: "password",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.model.password = $event)
                        }, null, 2), [
                            [
                                (0, $eeJ70.vModelText),
                                $data.model.password
                            ]
                        ])
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", $deb2abaa06113f87$var$_hoisted_7, [
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[2] || (_cache[2] = (...args)=>$options.close && $options.close(...args)),
                        "data-dismiss": "modal"
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[3] || (_cache[3] = (...args)=>$options.setPassword && $options.setPassword(...args))
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("confirm")), 1)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("8qOK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $62381cbc6cf79cd2$export$2e2bcd8739ae039);
let $62381cbc6cf79cd2$var$NOOP = ()=>{};
var $62381cbc6cf79cd2$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iqICt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ad44384bd34f3f$export$2e2bcd8739ae039);
let $d6ad44384bd34f3f$var$script;



let $d6ad44384bd34f3f$var$initialize = ()=>{
    $d6ad44384bd34f3f$var$script = (parcelRequire("ia4PY"));
    if ($d6ad44384bd34f3f$var$script.__esModule) $d6ad44384bd34f3f$var$script = $d6ad44384bd34f3f$var$script.default;
    $d6ad44384bd34f3f$var$script.render = (parcelRequire("i5pVx")).render;
    (parcelRequire("d7EUP")).default($d6ad44384bd34f3f$var$script);
    $d6ad44384bd34f3f$var$script.__scopeId = "data-v-7d18cf";
    $d6ad44384bd34f3f$var$script.__file = "UserDeleteModal.vue";
};
$d6ad44384bd34f3f$var$initialize();
var $d6ad44384bd34f3f$export$2e2bcd8739ae039 = $d6ad44384bd34f3f$var$script;

});
parcelRegister("ia4PY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d38ce9b9c7f75a4e$export$2e2bcd8739ae039);

var $5jPJV = parcelRequire("5jPJV");
var $d38ce9b9c7f75a4e$export$2e2bcd8739ae039 = {
    name: "userModal",
    methods: {
        close () {
            this.$emit("closeDeleteDialog");
        },
        async deleteUser () {
            await (0, $5jPJV.default).delete(this.$parent.userToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};

});

parcelRegister("i5pVx", function(module, exports) {

$parcel$export(module.exports, "render", () => $d2acce36df4d259c$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
var $8POXm = parcelRequire("8POXm");
const $d2acce36df4d259c$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $d2acce36df4d259c$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $d2acce36df4d259c$var$_hoisted_3 = {
    class: "modal-content"
};
const $d2acce36df4d259c$var$_hoisted_4 = {
    class: "modal-header"
};
const $d2acce36df4d259c$var$_hoisted_5 = {
    class: "modal-title"
};
const $d2acce36df4d259c$var$_hoisted_6 = {
    class: "modal-body"
};
const $d2acce36df4d259c$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0"
    }
};
const $d2acce36df4d259c$var$_hoisted_8 = {
    class: "modal-footer"
};
function $d2acce36df4d259c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $d2acce36df4d259c$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $d2acce36df4d259c$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $d2acce36df4d259c$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $d2acce36df4d259c$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $d2acce36df4d259c$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("userDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $d2acce36df4d259c$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", $d2acce36df4d259c$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisUser")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $d2acce36df4d259c$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteUser && $options.deleteUser(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("d7EUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $98dbaac5eb112645$export$2e2bcd8739ae039);
let $98dbaac5eb112645$var$NOOP = ()=>{};
var $98dbaac5eb112645$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("hhsPj", function(module, exports) {

$parcel$export(module.exports, "render", () => $c94a6290cd7c007b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $c94a6290cd7c007b$var$_hoisted_1 = {
    class: "table table-bordered table-responsive-md"
};
const $c94a6290cd7c007b$var$_hoisted_2 = {
    class: "text-center"
};
const $c94a6290cd7c007b$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-lg fa-plus"
}, null, -1);
const $c94a6290cd7c007b$var$_hoisted_4 = {
    key: 0
};
const $c94a6290cd7c007b$var$_hoisted_5 = [
    "onClick"
];
const $c94a6290cd7c007b$var$_hoisted_6 = [
    "onClick"
];
function $c94a6290cd7c007b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_PasswordModal = (0, $TusQn.resolveComponent)("PasswordModal");
    const _component_UserDeleteModal = (0, $TusQn.resolveComponent)("UserDeleteModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createElementVNode)("table", $c94a6290cd7c007b$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $c94a6290cd7c007b$var$_hoisted_2, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("users")) + " ", 1),
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            style: {
                                "float": "right"
                            },
                            to: {
                                name: "useradd"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $c94a6290cd7c007b$var$_hoisted_3
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
            $data.list.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $c94a6290cd7c007b$var$_hoisted_4, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.list, (user, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createVNode)(_component_RouterLink, {
                                to: {
                                    name: "userdetail",
                                    params: {
                                        id: user.id
                                    }
                                }
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(user.name), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ]),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "cursor": "pointer",
                                    "float": "right",
                                    "padding-top": "10px"
                                },
                                title: "Delete user",
                                onClick: ($event)=>$options.showDeleteUserModal(user),
                                class: "fas fa-sm fa-trash"
                            }, null, 8, $c94a6290cd7c007b$var$_hoisted_5),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "cursor": "pointer",
                                    "float": "right",
                                    "padding-top": "10px",
                                    "padding-right": "15px"
                                },
                                title: "Change password",
                                onClick: ($event)=>$options.showModal(user),
                                class: "fa fa-sm fa-key",
                                "aria-hidden": "true"
                            }, null, 8, $c94a6290cd7c007b$var$_hoisted_6)
                        ])
                    ]);
                }), 128))
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_PasswordModal, {
            onClose: $options.closeModal,
            onConfirm: $options.confirmModal
        }, null, 8, [
            "onClose",
            "onConfirm"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isModalVisible
            ]
        ]),
        (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_UserDeleteModal, {
            onReload: $options.requestData,
            onCloseDeleteDialog: $options.closeDeleteModal
        }, null, 8, [
            "onReload",
            "onCloseDeleteDialog"
        ]), [
            [
                (0, $eeJ70.vShow),
                $data.isDeleteModalVisible
            ]
        ])
    ]);
}

});

parcelRegister("dnh18", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bca9f9f22a7e881$export$2e2bcd8739ae039);
let $9bca9f9f22a7e881$var$NOOP = ()=>{};
var $9bca9f9f22a7e881$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6nLKk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a59ed7a0ee896a4$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");

var $2tmqH = parcelRequire("2tmqH");
var $4a59ed7a0ee896a4$export$2e2bcd8739ae039 = {
    name: "DataSpaceList",
    mounted () {
        this.requestData();
    },
    computed: {
        listOfDataSpaces () {
            var dataSpaceList = this.dataSpaceList;
            if (this.filterInput) {
                const lowerCaseFilter = this.filterInput.toLowerCase();
                dataSpaceList = dataSpaceList.filter((viz)=>{
                    if (viz.name.toLowerCase().includes(lowerCaseFilter)) return viz;
                });
            }
            return dataSpaceList.sort((a, b)=>a.name.localeCompare(b.name));
        }
    },
    methods: {
        async requestData () {
            this.loginInfo = await (0, $2tmqH.default).auth();
            var groupId = this.loginInfo.usergroup;
            var allDataSpaces = await (0, $kds5T.default).dataSpaceList();
            if (this.loginInfo.userrole == "Admin") this.dataSpaceList = allDataSpaces;
            else for(var i in allDataSpaces){
                var dataSpace = allDataSpaces[i];
                var parsedContent = JSON.parse(dataSpace.content);
                if (parsedContent["groups"]) {
                    let findIndex = parsedContent["groups"].findIndex((g)=>g.groupId == groupId);
                    if (findIndex > -1) this.dataSpaceList.push(dataSpace);
                }
            }
        },
        showAlert () {
            this.hidden = "showAlertBlock";
        },
        async changeUser () {
            await (0, $2tmqH.default).logout();
            this.$router.push("/");
        }
    },
    data () {
        return {
            loginInfo: {
                isAuthenticated: false,
                usergroup: null,
                userrole: ""
            },
            hidden: "hidden",
            userrole: "",
            dataSpaceList: [],
            filterInput: "",
            params: "",
            name: ""
        };
    }
};

});

parcelRegister("e74pe", function(module, exports) {

$parcel$export(module.exports, "render", () => $a465231033247310$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

var $4YlRB = parcelRequire("4YlRB");
const $a465231033247310$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "header"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
        href: "/"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4YlRB))),
            alt: "Logo",
            class: "logo"
        })
    ])
], -1);
const $a465231033247310$var$_hoisted_2 = {
    class: "modelings container py-5"
};
const $a465231033247310$var$_hoisted_3 = {
    class: "table-responsive"
};
const $a465231033247310$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("b", null, "here", -1);
const $a465231033247310$var$_hoisted_5 = {
    class: "table table-bordered table-responsive-md"
};
const $a465231033247310$var$_hoisted_6 = {
    class: "text-center"
};
const $a465231033247310$var$_hoisted_7 = {
    style: {
        "padding": "0"
    }
};
const $a465231033247310$var$_hoisted_8 = [
    "placeholder"
];
const $a465231033247310$var$_hoisted_9 = {
    key: 0
};
const $a465231033247310$var$_hoisted_10 = {
    key: 1
};
const $a465231033247310$var$_hoisted_11 = {
    class: "under-buttons"
};
const $a465231033247310$var$_hoisted_12 = {
    key: 0,
    style: {
        "float": "left"
    }
};
const $a465231033247310$var$_hoisted_13 = {
    class: "logout"
};
function $a465231033247310$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        $a465231033247310$var$_hoisted_1,
        (0, $TusQn.createElementVNode)("div", $a465231033247310$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $a465231033247310$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", {
                    class: (0, $8POXm.normalizeClass)([
                        "alert alert-info",
                        $data.hidden
                    ]),
                    role: "alert"
                }, [
                    (0, $TusQn.createTextVNode)(" Please enter your credentials "),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $a465231033247310$var$_hoisted_4
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createTextVNode)(". ")
                ], 2),
                (0, $TusQn.createElementVNode)("table", $a465231033247310$var$_hoisted_5, [
                    (0, $TusQn.createElementVNode)("thead", null, [
                        (0, $TusQn.createElementVNode)("tr", null, [
                            (0, $TusQn.createElementVNode)("th", $a465231033247310$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("dataSpaces")), 1)
                        ]),
                        (0, $TusQn.createElementVNode)("tr", null, [
                            (0, $TusQn.createElementVNode)("td", $a465231033247310$var$_hoisted_7, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    class: "form-control",
                                    style: {
                                        "border": "none"
                                    },
                                    placeholder: _ctx.$t("filterByName"),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.filterInput = $event),
                                    type: "search"
                                }, null, 8, $a465231033247310$var$_hoisted_8), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        $data.filterInput
                                    ]
                                ])
                            ])
                        ])
                    ]),
                    $options.listOfDataSpaces.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $a465231033247310$var$_hoisted_9, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.listOfDataSpaces, (item, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                key: i
                            }, [
                                (0, $TusQn.createElementVNode)("td", null, [
                                    (0, $TusQn.createVNode)(_component_RouterLink, {
                                        to: {
                                            name: "dataspace",
                                            params: {
                                                id: item.id
                                            }
                                        }
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $a465231033247310$var$_hoisted_10, [
                        (0, $TusQn.createElementVNode)("tr", null, (0, $8POXm.toDisplayString)(_ctx.$t("noAssignedDataSpace")), 1)
                    ]))
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $a465231033247310$var$_hoisted_11, [
                $data.loginInfo.userrole == "Admin" && $data.loginInfo.isAuthenticated ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a465231033247310$var$_hoisted_12, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "settings/dataspaces",
                        class: "btn btn-secondary"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("settings")), 1)
                            ]),
                        _: 1
                    })
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.createElementVNode)("div", $a465231033247310$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[1] || (_cache[1] = ($event)=>$options.changeUser()),
                        style: {
                            "float": "right",
                            "margin-right": "20px"
                        }
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("logout")), 1)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("jyh5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3be72ed6da985e1$export$2e2bcd8739ae039);
let $e3be72ed6da985e1$var$NOOP = ()=>{};
var $e3be72ed6da985e1$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("k9Hha", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eac6379432cf16f3$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");
var $eac6379432cf16f3$export$2e2bcd8739ae039 = {
    name: "DataSpaceLayout",
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        }
    },
    watch: {
        dataSpaceId: {
            immediate: true,
            handler (newId) {
                if (newId) this.loadDataSpace(newId);
            }
        }
    },
    methods: {
        async loadDataSpace (id) {
            var ds = await (0, $kds5T.default).dataSpaceDetail(id);
            this.dataSpaceName = ds.name ?? "";
        },
        isActive (section) {
            var path = this.$route.path;
            if (section === "tables") return path.includes("/tables") ? "active" : "";
            if (section === "batches") return path.includes("/batches") ? "active" : "";
            return "";
        }
    },
    data () {
        return {
            dataSpaceName: ""
        };
    }
};

});

parcelRegister("aAXUF", function(module, exports) {

$parcel$export(module.exports, "render", () => $7b6bbdab30971e2e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

var $4YlRB = parcelRequire("4YlRB");
const $7b6bbdab30971e2e$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "header"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
        href: "/"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4YlRB))),
            alt: "Logo",
            class: "logo"
        })
    ])
], -1);
const $7b6bbdab30971e2e$var$_hoisted_2 = {
    class: "dataspace-layout"
};
const $7b6bbdab30971e2e$var$_hoisted_3 = {
    class: "dataspace-sidebar"
};
const $7b6bbdab30971e2e$var$_hoisted_4 = {
    class: "sidebar-header"
};
const $7b6bbdab30971e2e$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-arrow-left"
}, null, -1);
const $7b6bbdab30971e2e$var$_hoisted_6 = {
    class: "sidebar-title"
};
const $7b6bbdab30971e2e$var$_hoisted_7 = {
    class: "sidebar-nav"
};
const $7b6bbdab30971e2e$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-table"
}, null, -1);
const $7b6bbdab30971e2e$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-cogs"
}, null, -1);
const $7b6bbdab30971e2e$var$_hoisted_10 = {
    class: "dataspace-content"
};
function $7b6bbdab30971e2e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        $7b6bbdab30971e2e$var$_hoisted_1,
        (0, $TusQn.createElementVNode)("div", $7b6bbdab30971e2e$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $7b6bbdab30971e2e$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("div", $7b6bbdab30971e2e$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: "/dataspaces",
                        class: "sidebar-back"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $7b6bbdab30971e2e$var$_hoisted_5
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createElementVNode)("span", $7b6bbdab30971e2e$var$_hoisted_6, (0, $8POXm.toDisplayString)($data.dataSpaceName), 1)
                ]),
                (0, $TusQn.createElementVNode)("nav", $7b6bbdab30971e2e$var$_hoisted_7, [
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/dataspace/${$options.dataSpaceId}/tables`,
                        class: (0, $8POXm.normalizeClass)([
                            "sidebar-link",
                            $options.isActive("tables")
                        ])
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $7b6bbdab30971e2e$var$_hoisted_8,
                                (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(_ctx.$t("tables")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to",
                        "class"
                    ]),
                    (0, $TusQn.createVNode)(_component_RouterLink, {
                        to: `/dataspace/${$options.dataSpaceId}/batches`,
                        class: (0, $8POXm.normalizeClass)([
                            "sidebar-link",
                            $options.isActive("batches")
                        ])
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $7b6bbdab30971e2e$var$_hoisted_9,
                                (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(_ctx.$t("batches")), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "to",
                        "class"
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $7b6bbdab30971e2e$var$_hoisted_10, [
                (0, $TusQn.createVNode)(_component_router_view)
            ])
        ])
    ]);
}

});

parcelRegister("9LSDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d2e335cc604cfa$export$2e2bcd8739ae039);
let $71d2e335cc604cfa$var$NOOP = ()=>{};
var $71d2e335cc604cfa$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3ynak", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $29668445f29bc227$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");

var $54xA9 = parcelRequire("54xA9");
var $29668445f29bc227$export$2e2bcd8739ae039 = {
    name: "DataSpaceList",
    components: {
        DataSpaceDeleteModal: $54xA9.default
    },
    mounted () {
        this.requestData();
    },
    computed: {
        listOfDataSpaces () {
            if (!this.filterInput) return this.dataSpaceList.sort((a, b)=>a.name.localeCompare(b.name));
            else {
                const lowerCaseFilter = this.filterInput.toLowerCase();
                return this.dataSpaceList.sort((a, b)=>a.name.localeCompare(b.name)).filter((dataSpace)=>{
                    if (dataSpace.name.toLowerCase().includes(lowerCaseFilter)) return dataSpace;
                });
            }
        }
    },
    methods: {
        async requestData () {
            this.dataSpaceList = await (0, $kds5T.default).dataSpaceList();
        },
        showDeleteDataSpaceModal (item) {
            this.dataSpaceToDeleteId = item.id;
            this.dataSpaceToDeleteName = item.name;
            this.isModalVisible = true;
        }
    },
    data () {
        return {
            dataSpaceList: [],
            dataSpaceToDeleteName: "",
            dataSpaceToDeleteId: "",
            isModalVisible: false,
            filterInput: ""
        };
    }
};

});
parcelRegister("54xA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b17602cf11a55ea$export$2e2bcd8739ae039);
let $3b17602cf11a55ea$var$script;



let $3b17602cf11a55ea$var$initialize = ()=>{
    $3b17602cf11a55ea$var$script = (parcelRequire("xHCVw"));
    if ($3b17602cf11a55ea$var$script.__esModule) $3b17602cf11a55ea$var$script = $3b17602cf11a55ea$var$script.default;
    $3b17602cf11a55ea$var$script.render = (parcelRequire("g4sv1")).render;
    (parcelRequire("aEQII")).default($3b17602cf11a55ea$var$script);
    $3b17602cf11a55ea$var$script.__scopeId = "data-v-c47803";
    $3b17602cf11a55ea$var$script.__file = "DataSpaceDeleteModal.vue";
};
$3b17602cf11a55ea$var$initialize();
var $3b17602cf11a55ea$export$2e2bcd8739ae039 = $3b17602cf11a55ea$var$script;

});
parcelRegister("xHCVw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0654ec90e5cee070$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");
var $0654ec90e5cee070$export$2e2bcd8739ae039 = {
    name: "dataSpaceModal",
    methods: {
        close () {
            this.$parent.isModalVisible = false;
        },
        async deleteDataSpace () {
            this.syncLoading = "";
            await (0, $kds5T.default).dataSpaceDelete(this.$parent.dataSpaceToDeleteId);
            this.close();
            this.$emit("reload");
        }
    },
    data () {
        return {
            buttonLoading: "btn btn-primary",
            syncLoading: "hidden",
            files: []
        };
    }
};

});

parcelRegister("g4sv1", function(module, exports) {

$parcel$export(module.exports, "render", () => $bb33206d38dd7141$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
var $8POXm = parcelRequire("8POXm");
const $bb33206d38dd7141$var$_hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog"
};
const $bb33206d38dd7141$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const $bb33206d38dd7141$var$_hoisted_3 = {
    class: "modal-content"
};
const $bb33206d38dd7141$var$_hoisted_4 = {
    class: "modal-header"
};
const $bb33206d38dd7141$var$_hoisted_5 = {
    class: "modal-title"
};
const $bb33206d38dd7141$var$_hoisted_6 = {
    class: "modal-body"
};
const $bb33206d38dd7141$var$_hoisted_7 = {
    style: {
        "margin-bottom": "0",
        "color": "red"
    }
};
const $bb33206d38dd7141$var$_hoisted_8 = {
    class: "modal-footer"
};
const $bb33206d38dd7141$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
}, null, -1);
function $bb33206d38dd7141$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "modal-fade"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $bb33206d38dd7141$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("div", $bb33206d38dd7141$var$_hoisted_2, [
                        (0, $TusQn.createElementVNode)("div", $bb33206d38dd7141$var$_hoisted_3, [
                            (0, $TusQn.createElementVNode)("div", $bb33206d38dd7141$var$_hoisted_4, [
                                (0, $TusQn.createElementVNode)("h5", $bb33206d38dd7141$var$_hoisted_5, (0, $8POXm.toDisplayString)(_ctx.$t("dataSpaceDelete")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.close && $options.close(...args)),
                                    "aria-label": "Close"
                                })
                            ]),
                            (0, $TusQn.createElementVNode)("div", $bb33206d38dd7141$var$_hoisted_6, [
                                (0, $TusQn.createElementVNode)("p", null, (0, $8POXm.toDisplayString)(_ctx.$t("wannaDeleteThisDataSpace")), 1),
                                (0, $TusQn.createElementVNode)("p", $bb33206d38dd7141$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("allDataWillBeLost")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $bb33206d38dd7141$var$_hoisted_8, [
                                (0, $TusQn.createElementVNode)("button", {
                                    class: (0, $8POXm.normalizeClass)([
                                        $data.buttonLoading,
                                        $data.syncLoading
                                    ]),
                                    type: "button",
                                    disabled: ""
                                }, [
                                    $bb33206d38dd7141$var$_hoisted_9,
                                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)
                                ], 2),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
                                    "data-dismiss": "modal"
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("close")), 1),
                                (0, $TusQn.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.deleteDataSpace && $options.deleteDataSpace(...args))
                                }, (0, $8POXm.toDisplayString)(_ctx.$t("delete")), 1)
                            ])
                        ])
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("aEQII", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2688f8bc9e062c$export$2e2bcd8739ae039);
let $7c2688f8bc9e062c$var$NOOP = ()=>{};
var $7c2688f8bc9e062c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("74Tqc", function(module, exports) {

$parcel$export(module.exports, "render", () => $5273e5b668b6f777$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $5273e5b668b6f777$var$_hoisted_1 = {
    class: "table-responsive"
};
const $5273e5b668b6f777$var$_hoisted_2 = {
    class: "table table-bordered table-responsive-md"
};
const $5273e5b668b6f777$var$_hoisted_3 = {
    class: "text-center"
};
const $5273e5b668b6f777$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-lg fa-plus"
}, null, -1);
const $5273e5b668b6f777$var$_hoisted_5 = {
    key: 0
};
const $5273e5b668b6f777$var$_hoisted_6 = [
    "placeholder"
];
const $5273e5b668b6f777$var$_hoisted_7 = [
    "onClick"
];
const $5273e5b668b6f777$var$_hoisted_8 = {
    key: 1
};
const $5273e5b668b6f777$var$_hoisted_9 = [
    "placeholder"
];
function $5273e5b668b6f777$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    const _component_DataSpaceDeleteModal = (0, $TusQn.resolveComponent)("DataSpaceDeleteModal");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5273e5b668b6f777$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("table", $5273e5b668b6f777$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("thead", null, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.createElementVNode)("th", $5273e5b668b6f777$var$_hoisted_3, [
                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dataSpaces")) + " ", 1),
                        (0, $TusQn.createVNode)(_component_router_link, {
                            style: {
                                "float": "right"
                            },
                            to: {
                                name: "dataspaceadd"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $5273e5b668b6f777$var$_hoisted_4
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
            $options.listOfDataSpaces.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $5273e5b668b6f777$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        style: {
                            "border": "none"
                        },
                        class: "form-control",
                        placeholder: _ctx.$t("dataSpaceName"),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.filterInput = $event),
                        type: "search"
                    }, null, 8, $5273e5b668b6f777$var$_hoisted_6), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.filterInput
                        ]
                    ])
                ]),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.listOfDataSpaces, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("td", null, [
                            (0, $TusQn.createVNode)(_component_router_link, {
                                to: {
                                    name: "dataspacedetail",
                                    params: {
                                        id: item.id
                                    }
                                }
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(item.name), 1)
                                    ]),
                                _: 2
                            }, 1032, [
                                "to"
                            ]),
                            (0, $TusQn.createElementVNode)("i", {
                                style: {
                                    "float": "right",
                                    "padding-top": "10px",
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>$options.showDeleteDataSpaceModal(item),
                                class: "fas fa-sm fa-trash"
                            }, null, 8, $5273e5b668b6f777$var$_hoisted_7)
                        ])
                    ]);
                }), 128))
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $5273e5b668b6f777$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("tr", null, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "form-control",
                        placeholder: _ctx.$t("filterByName"),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.filterInput = $event),
                        type: "search"
                    }, null, 8, $5273e5b668b6f777$var$_hoisted_9), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.filterInput
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("tr", null, (0, $8POXm.toDisplayString)(_ctx.$t("noAssignedDataSpace")), 1)
            ]))
        ]),
        $data.isModalVisible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_DataSpaceDeleteModal, {
            key: 0,
            onReload: $options.requestData
        }, null, 8, [
            "onReload"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("cdsQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $024b90ce1af8037a$export$2e2bcd8739ae039);
let $024b90ce1af8037a$var$NOOP = ()=>{};
var $024b90ce1af8037a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("fWhQl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b9aa1d1764d53e2b$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");

var $8ylwZ = parcelRequire("8ylwZ");
var $b9aa1d1764d53e2b$export$2e2bcd8739ae039 = {
    mounted () {
        this.requestData();
    },
    methods: {
        async requestData () {
            this.groups = await (0, $8ylwZ.default).list();
        },
        async onSubmit () {
            if (this.model.name.length < 1) {
                this.requiredName = "required";
                return;
            }
            if (this.model && this.model.name.length > 1) {
                this.model.content = JSON.stringify(this.content);
                let dataSpace = await (0, $kds5T.default).dataSpaceCreate(this.model);
                this.$router.push({
                    name: "dataspacedetail",
                    params: {
                        id: dataSpace.id
                    }
                });
            }
        },
        groupCheck (group, event) {
            if (!this.content.groups) this.content.groups = [];
            if (event.target.checked) {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index < 0) this.content.groups.push({
                    "groupId": group.id
                });
            } else {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index >= 0) this.content.groups.splice(index, 1);
            }
        },
        isGroupChecked (item) {
            return this.content["groups"]?.findIndex((f)=>f["groupId"] == item.id) >= 0;
        }
    },
    data () {
        return {
            groups: [],
            content: {},
            id: "Id",
            dataSpaces: "DataSpaces",
            requiredName: "",
            model: {
                name: "",
                content: "{}"
            }
        };
    }
};

});

parcelRegister("dNYRU", function(module, exports) {

$parcel$export(module.exports, "render", () => $a0cf11351f0f2514$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $a0cf11351f0f2514$var$_hoisted_1 = {
    class: "container py-5"
};
const $a0cf11351f0f2514$var$_hoisted_2 = {
    "aria-label": "breadcrumb"
};
const $a0cf11351f0f2514$var$_hoisted_3 = {
    class: "breadcrumb"
};
const $a0cf11351f0f2514$var$_hoisted_4 = {
    class: "breadcrumb-item"
};
const $a0cf11351f0f2514$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $a0cf11351f0f2514$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $a0cf11351f0f2514$var$_hoisted_7 = {
    class: "form-row mb-3"
};
const $a0cf11351f0f2514$var$_hoisted_8 = {
    class: "form-group col-md-3"
};
const $a0cf11351f0f2514$var$_hoisted_9 = {
    for: "name"
};
const $a0cf11351f0f2514$var$_hoisted_10 = {
    class: "row col-md-12"
};
const $a0cf11351f0f2514$var$_hoisted_11 = {
    class: "form-label"
};
const $a0cf11351f0f2514$var$_hoisted_12 = {
    class: "input-group mb-3"
};
const $a0cf11351f0f2514$var$_hoisted_13 = [
    "for"
];
const $a0cf11351f0f2514$var$_hoisted_14 = {
    class: "input-group-text"
};
const $a0cf11351f0f2514$var$_hoisted_15 = [
    "id",
    "onChange",
    "checked"
];
const $a0cf11351f0f2514$var$_hoisted_16 = {
    class: "form-row"
};
const $a0cf11351f0f2514$var$_hoisted_17 = {
    class: "col-md-4"
};
function $a0cf11351f0f2514$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $a0cf11351f0f2514$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("dataSpaceCreation")), 1),
        (0, $TusQn.createElementVNode)("nav", $a0cf11351f0f2514$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("ol", $a0cf11351f0f2514$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("li", $a0cf11351f0f2514$var$_hoisted_4, [
                    (0, $TusQn.createVNode)(_component_router_link, {
                        to: {
                            name: "dataspaces"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $a0cf11351f0f2514$var$_hoisted_5, [
                    (0, $TusQn.createVNode)(_component_router_link, {
                        to: "/settings/dataspaces"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dataSpaces")), 1)
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("li", $a0cf11351f0f2514$var$_hoisted_6, (0, $8POXm.toDisplayString)(_ctx.$t("create")), 1)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("label", $a0cf11351f0f2514$var$_hoisted_9, (0, $8POXm.toDisplayString)(_ctx.$t("dataSpaceName")), 1),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.model.name = $event),
                    type: "text",
                    class: (0, $8POXm.normalizeClass)([
                        "form-control",
                        _ctx.requiredCenter
                    ]),
                    id: "name",
                    placeholder: "Enter Data Space name"
                }, null, 2), [
                    [
                        (0, $eeJ70.vModelText),
                        $data.model.name
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_10, [
            (0, $TusQn.createElementVNode)("label", $a0cf11351f0f2514$var$_hoisted_11, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups, (item, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    class: "col-md-3",
                    key: i
                }, [
                    (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("label", {
                            class: "form-control readonly",
                            for: "group_" + i
                        }, (0, $8POXm.toDisplayString)(item.name), 9, $a0cf11351f0f2514$var$_hoisted_13),
                        (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_14, [
                            (0, $TusQn.createElementVNode)("input", {
                                class: "form-check-input mt-0",
                                type: "checkbox",
                                id: "group_" + i,
                                onChange: ($event)=>$options.groupCheck(item, $event),
                                checked: $options.isGroupChecked(item)
                            }, null, 40, $a0cf11351f0f2514$var$_hoisted_15)
                        ])
                    ])
                ]);
            }), 128))
        ]),
        (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_16, [
            (0, $TusQn.createElementVNode)("div", $a0cf11351f0f2514$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.onSubmit && $options.onSubmit(...args))
                }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
            ])
        ])
    ]);
}

});

parcelRegister("jGVcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e55e4f2443f09d9d$export$2e2bcd8739ae039);
let $e55e4f2443f09d9d$var$NOOP = ()=>{};
var $e55e4f2443f09d9d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8R3d6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6725c374e3116bf4$export$2e2bcd8739ae039);

var $kds5T = parcelRequire("kds5T");

var $8ylwZ = parcelRequire("8ylwZ");
var $6725c374e3116bf4$export$2e2bcd8739ae039 = {
    name: "dataSpacedetail",
    notifications: {
        showSuccess: {
            title: "Getan!",
            message: "DataSpace was succesfully updated.",
            type: "success"
        }
    },
    mounted () {
        this.requestData();
    },
    methods: {
        groupCheck (group, event) {
            if (!this.content.groups) this.content.groups = [];
            if (event.target.checked) {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index < 0) this.content.groups.push({
                    "groupId": group.id
                });
            } else {
                var index = this.content.groups.findIndex((f)=>f.groupId == group.id);
                if (index >= 0) this.content.groups.splice(index, 1);
            }
        },
        isGroupChecked (item) {
            return this.content["groups"]?.findIndex((f)=>f["groupId"] == item.id) >= 0;
        },
        async saveDataSpace () {
            this.model.content = JSON.stringify(this.content);
            await (0, $kds5T.default).dataSpaceUpdate(this.model);
            this.showSuccess();
        },
        async requestData () {
            var model = await (0, $kds5T.default).dataSpaceDetail(this.$route.params.id);
            this.content = JSON.parse(model.content);
            this.model = model;
            this.groups = await (0, $8ylwZ.default).list();
            this.pending = false;
        }
    },
    data () {
        return {
            pending: true,
            groups: [],
            model: {
                name: "",
                groups: []
            }
        };
    }
};

});

parcelRegister("4zIj9", function(module, exports) {

$parcel$export(module.exports, "render", () => $354cccf01d892ce4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $354cccf01d892ce4$var$_hoisted_1 = {
    key: 0
};
const $354cccf01d892ce4$var$_hoisted_2 = {
    key: 1,
    class: "container py-5"
};
const $354cccf01d892ce4$var$_hoisted_3 = {
    "aria-label": "breadcrumb"
};
const $354cccf01d892ce4$var$_hoisted_4 = {
    class: "breadcrumb"
};
const $354cccf01d892ce4$var$_hoisted_5 = {
    class: "breadcrumb-item"
};
const $354cccf01d892ce4$var$_hoisted_6 = {
    class: "breadcrumb-item"
};
const $354cccf01d892ce4$var$_hoisted_7 = {
    class: "breadcrumb-item"
};
const $354cccf01d892ce4$var$_hoisted_8 = {
    class: "form-row"
};
const $354cccf01d892ce4$var$_hoisted_9 = {
    class: "form-group col-md-3 mb-3"
};
const $354cccf01d892ce4$var$_hoisted_10 = {
    for: "name",
    class: "form-label mb-2"
};
const $354cccf01d892ce4$var$_hoisted_11 = {
    class: "row col-md-12"
};
const $354cccf01d892ce4$var$_hoisted_12 = {
    class: "form-label"
};
const $354cccf01d892ce4$var$_hoisted_13 = {
    class: "input-group mb-3"
};
const $354cccf01d892ce4$var$_hoisted_14 = [
    "for"
];
const $354cccf01d892ce4$var$_hoisted_15 = {
    class: "input-group-text"
};
const $354cccf01d892ce4$var$_hoisted_16 = [
    "id",
    "onChange",
    "checked"
];
const $354cccf01d892ce4$var$_hoisted_17 = {
    class: "form-row"
};
const $354cccf01d892ce4$var$_hoisted_18 = {
    class: "col-md-4"
};
function $354cccf01d892ce4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    return $data.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $354cccf01d892ce4$var$_hoisted_1, (0, $8POXm.toDisplayString)(_ctx.$t("loading")), 1)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $354cccf01d892ce4$var$_hoisted_2, [
        (0, $TusQn.createElementVNode)("div", null, [
            (0, $TusQn.createElementVNode)("h2", null, (0, $8POXm.toDisplayString)(_ctx.$t("dataSpaceDetail")), 1),
            (0, $TusQn.createElementVNode)("nav", $354cccf01d892ce4$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("ol", $354cccf01d892ce4$var$_hoisted_4, [
                    (0, $TusQn.createElementVNode)("li", $354cccf01d892ce4$var$_hoisted_5, [
                        (0, $TusQn.createVNode)(_component_router_link, {
                            to: {
                                name: "dataspaces"
                            }
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("home")), 1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("li", $354cccf01d892ce4$var$_hoisted_6, [
                        (0, $TusQn.createVNode)(_component_router_link, {
                            to: "/settings/dataspaces"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("dataSpaces")), 1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $TusQn.createElementVNode)("li", $354cccf01d892ce4$var$_hoisted_7, (0, $8POXm.toDisplayString)(_ctx.$t("detail")), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_9, [
                    (0, $TusQn.createElementVNode)("label", $354cccf01d892ce4$var$_hoisted_10, (0, $8POXm.toDisplayString)(_ctx.$t("dataSpaceName")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.model.name = $event),
                        type: "text",
                        class: "form-control",
                        id: "name",
                        placeholder: "Enter dataSpace name"
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.model.name
                        ]
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_11, [
                (0, $TusQn.createElementVNode)("label", $354cccf01d892ce4$var$_hoisted_12, (0, $8POXm.toDisplayString)(_ctx.$t("groups")), 1),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.groups, (item, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        class: "col-md-3",
                        key: i
                    }, [
                        (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_13, [
                            (0, $TusQn.createElementVNode)("label", {
                                class: "form-control readonly",
                                for: "group_" + i
                            }, (0, $8POXm.toDisplayString)(item.name), 9, $354cccf01d892ce4$var$_hoisted_14),
                            (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_15, [
                                (0, $TusQn.createElementVNode)("input", {
                                    class: "form-check-input mt-0",
                                    type: "checkbox",
                                    id: "group_" + i,
                                    onChange: ($event)=>$options.groupCheck(item, $event),
                                    checked: $options.isGroupChecked(item)
                                }, null, 40, $354cccf01d892ce4$var$_hoisted_16)
                            ])
                        ])
                    ]);
                }), 128))
            ]),
            (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_17, [
                (0, $TusQn.createElementVNode)("div", $354cccf01d892ce4$var$_hoisted_18, [
                    (0, $TusQn.createElementVNode)("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[1] || (_cache[1] = (...args)=>$options.saveDataSpace && $options.saveDataSpace(...args))
                    }, (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
                ])
            ])
        ])
    ]));
}

});

parcelRegister("dNIIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0c28ab8a20fbeb2$export$2e2bcd8739ae039);
let $a0c28ab8a20fbeb2$var$NOOP = ()=>{};
var $a0c28ab8a20fbeb2$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3DPp2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2a6ce32c38beb481$export$2e2bcd8739ae039);

var $7R1dy = parcelRequire("7R1dy");

var $kds5T = parcelRequire("kds5T");

var $77lpg = parcelRequire("77lpg");
var $2a6ce32c38beb481$export$2e2bcd8739ae039 = {
    name: "DataBatchDetail",
    components: {
        DataBatchRunModal: $77lpg.default
    },
    data () {
        return {
            saving: false,
            running: false,
            showRunModal: false,
            tables: [],
            inputColumns: [],
            copyExcludedColumns: [],
            content: null,
            transformations: [
                {
                    value: "minimum",
                    label: "Minimum"
                },
                {
                    value: "maximum",
                    label: "Maximum"
                },
                {
                    value: "mostLength",
                    label: "Most length"
                },
                {
                    value: "sum",
                    label: "Sum"
                },
                {
                    value: "weightedSum",
                    label: "Weighted sum"
                },
                {
                    value: "statisticalAverage",
                    label: "Statistical average"
                },
                {
                    value: "weightedAverage",
                    label: "Weighted average"
                }
            ],
            aggregations: [
                {
                    value: "minimum",
                    label: "Minimum"
                },
                {
                    value: "maximum",
                    label: "Maximum"
                },
                {
                    value: "sum",
                    label: "Sum"
                },
                {
                    value: "weightedSum",
                    label: "Weighted sum"
                },
                {
                    value: "statisticalAverage",
                    label: "Statistical average"
                },
                {
                    value: "count",
                    label: "Count"
                }
            ]
        };
    },
    watch: {
        "content.inputTable" (val) {
            // naplneni columns podle tabulky
            if (val) {
                var table = this.tables.find((t)=>t.name === val);
                this.inputColumns = table ? table.columns : [];
                if (!this.content.groupByColumns) this.content.groupByColumns = [];
            } else this.inputColumns = [];
        }
    },
    computed: {
        dataSpaceId () {
            return this.$route.params.id;
        },
        batchId () {
            return this.$route.params.batchId;
        },
        togglableCopyColumns () {
            return this.getColumnsForTable(this.content.inputTable).filter((c)=>!this.isKeyColumn(c.name)).map((c)=>c.name);
        },
        allCopyChecked () {
            return this.togglableCopyColumns.every((n)=>!this.isExcluded(n));
        }
    },
    async mounted () {
        await this.loadTables();
        await this.loadBatch();
    },
    methods: {
        async loadBatch () {
            this.content = await (0, $7R1dy.default).dataBatchDetail(this.dataSpaceId, this.batchId);
            if (this.content.csdTables) this.content.csdTables.forEach((tbl)=>{
                if (!tbl.selectedColumns) tbl.selectedColumns = [];
            });
            if (this.content.transformations) this.content.transformations.forEach((tbl)=>{
                if (!tbl.selectedColumns) tbl.selectedColumns = [];
            });
            if (!this.content.copyExcludedColumns) this.content.copyExcludedColumns = [];
        },
        async loadTables () {
            this.tables = await (0, $kds5T.default).tables(this.dataSpaceId);
        },
        toggleAllCopyColumns () {
            if (!this.content.copyExcludedColumns) this.content.copyExcludedColumns = [];
            if (this.allCopyChecked) this.togglableCopyColumns.forEach((n)=>{
                if (!this.content.copyExcludedColumns.includes(n)) this.content.copyExcludedColumns.push(n);
            });
            else this.content.copyExcludedColumns = this.content.copyExcludedColumns.filter((n)=>!this.togglableCopyColumns.includes(n));
        },
        isExcluded (name) {
            if (!this.content.copyExcludedColumns) this.content.copyExcludedColumns = [];
            return this.content.copyExcludedColumns.includes(name);
        },
        toggleCopyColumn (name) {
            if (!this.content.copyExcludedColumns) this.content.copyExcludedColumns = [];
            var i = this.content.copyExcludedColumns.indexOf(name);
            if (i === -1) this.content.copyExcludedColumns.push(name);
            else this.content.copyExcludedColumns.splice(i, 1);
        },
        isKeyColumn (name) {
            return name === this.content.inputIdColumn || name === this.content.inputFromColumn || name === this.content.inputToColumn;
        },
        async onInputTableChange () {
            var table = this.tables.find((t)=>t.name === this.content.inputTable);
            this.inputColumns = table ? table.columns : [];
        },
        getColumnsForTable (tableName) {
            var table = this.tables.find((t)=>t.name === tableName);
            return table ? table.columns : [];
        },
        addAggregation () {
            if (!this.content.aggregations) this.content.aggregations = [];
            this.content.aggregations.push({
                column: "",
                alias: "",
                dataType: "",
                function: "",
                temporary: false
            });
        },
        addGroupBy () {
            if (!this.content.groupBy) this.content.groupBy = [];
            this.content.groupBy.push({
                column: ""
            });
        },
        addCsdTable () {
            if (!this.content.csdTables) this.content.csdTables = [];
            this.content.csdTables.push({
                table: "",
                idColumn: "",
                fromColumn: "",
                toColumn: "",
                selectedColumns: []
            });
        },
        addCsdColumn (tbl) {
            if (!tbl.selectedColumns) tbl.selectedColumns = [];
            tbl.selectedColumns.push({
                name: "",
                alias: "",
                dataType: "",
                temporary: false
            });
        },
        prefillDataType (tbl, col) {
            if (!col.name) return;
            var tableCol = this.getColumnsForTable(tbl.table).find((c)=>c.name === col.name);
            console.log(tableCol);
            if (tableCol) col.dataType = tableCol.dataType;
        },
        prefillAggregation (agg) {
            if (!agg.column) return;
            var col = this.inputColumns.find((c)=>c.name === agg.column);
            if (col) {
                if (!agg.alias) agg.alias = col.name;
                if (!agg.dataType) agg.dataType = col.dataType;
            }
        },
        addTransformation () {
            if (!this.content.transformations) this.content.transformations = [];
            this.content.transformations.push({
                table: "",
                idColumn: "",
                fromColumn: "",
                toColumn: "",
                selectedColumns: []
            });
        },
        addTransformationColumn (tbl) {
            if (!tbl.selectedColumns) tbl.selectedColumns = [];
            tbl.selectedColumns.push({
                name: "",
                alias: "",
                dataType: "",
                transformation: "",
                temporary: false
            });
        },
        addExpression () {
            if (!this.content.expressions) this.content.expressions = [];
            this.content.expressions.push({
                alias: "",
                dataType: "",
                expression: "",
                temporary: false
            });
        },
        moveExpression (index, direction) {
            var arr = this.content.expressions;
            var newIndex = index + direction;
            var item = arr.splice(index, 1)[0];
            arr.splice(newIndex, 0, item);
        },
        async saveBatch () {
            this.saving = true;
            this.content.outputTableName = this.content.outputTableName.trim();
            await (0, $7R1dy.default).dataBatchUpdate(this.dataSpaceId, this.batchId, this.content);
            this.showSuccess();
            this.saving = false;
        },
        async runBatch () {
            this.saving = true;
            try {
                this.content.outputTableName = this.content.outputTableName.trim();
                await (0, $7R1dy.default).dataBatchUpdate(this.dataSpaceId, this.batchId, this.content);
                this.saving = false;
                this.showRunModal = true;
            } catch (error) {
                this.saving = false;
                this.showRunFail();
            }
        },
        goBack () {
            this.$router.push(`/dataspace/${this.dataSpaceId}/batches`);
        },
        isTableNameInvalid () {
            if (!this.content.outputTableName) return true;
            var trimmedName = this.content.outputTableName.trim();
            return !trimmedName || trimmedName.includes(" ");
        }
    },
    notifications: {
        showSuccess: {
            title: "success",
            message: "batchUpdated",
            type: "success"
        },
        showRunSuccess: {
            title: "success",
            message: "batchRunSuccessful",
            type: "success"
        },
        showRunFail: {
            title: "failed",
            message: "batchRunUnsuccessful",
            type: "error"
        }
    }
};

});

parcelRegister("kcVnV", function(module, exports) {

$parcel$export(module.exports, "render", () => $eb6171179a371c45$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $eb6171179a371c45$var$_hoisted_1 = {
    key: 0
};
const $eb6171179a371c45$var$_hoisted_2 = {
    class: "d-flex justify-content-between align-items-start mb-4"
};
const $eb6171179a371c45$var$_hoisted_3 = {
    class: "d-flex align-items-center gap-2 mb-1"
};
const $eb6171179a371c45$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-arrow-left"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_5 = [
    $eb6171179a371c45$var$_hoisted_4
];
const $eb6171179a371c45$var$_hoisted_6 = {
    class: "mb-0"
};
const $eb6171179a371c45$var$_hoisted_7 = {
    class: "badge-type"
};
const $eb6171179a371c45$var$_hoisted_8 = {
    class: "d-flex gap-2"
};
const $eb6171179a371c45$var$_hoisted_9 = [
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-floppy-disk"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_11 = [
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-play"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_13 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_14 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_15 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_16 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_17 = {
    key: 0
};
const $eb6171179a371c45$var$_hoisted_18 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_19 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_20 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_21 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-regular fa-file"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_22 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_23 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_24 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_25 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_26 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_27 = {
    class: "col-md-12"
};
const $eb6171179a371c45$var$_hoisted_28 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_29 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_30 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_31 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_32 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-regular fa-file"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_33 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_34 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_35 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_36 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_37 = {
    value: ""
};
const $eb6171179a371c45$var$_hoisted_38 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_39 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_40 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_41 = [
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_42 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_43 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_44 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_45 = [
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_46 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_47 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_48 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_49 = [
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_50 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_51 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_52 = {
    class: "col-md-12"
};
const $eb6171179a371c45$var$_hoisted_53 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_54 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_55 = {
    key: 0
};
const $eb6171179a371c45$var$_hoisted_56 = {
    class: "form-check border-bottom pb-2 mb-2"
};
const $eb6171179a371c45$var$_hoisted_57 = [
    "checked"
];
const $eb6171179a371c45$var$_hoisted_58 = {
    class: "form-check-label small fw-bold",
    for: "copy-all"
};
const $eb6171179a371c45$var$_hoisted_59 = {
    style: {
        "max-height": "300px",
        "overflow-y": "auto"
    }
};
const $eb6171179a371c45$var$_hoisted_60 = [
    "id",
    "checked",
    "disabled",
    "onChange"
];
const $eb6171179a371c45$var$_hoisted_61 = [
    "for"
];
const $eb6171179a371c45$var$_hoisted_62 = {
    class: "text-muted"
};
const $eb6171179a371c45$var$_hoisted_63 = {
    key: 1
};
const $eb6171179a371c45$var$_hoisted_64 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_65 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_66 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_67 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-regular fa-file"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_68 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_69 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_70 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_71 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_72 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_73 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_74 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_75 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_76 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_77 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_78 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_79 = {
    class: "col-md-12"
};
const $eb6171179a371c45$var$_hoisted_80 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_81 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_82 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_83 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_84 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-solid fa-diagram-project"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_85 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_86 = {
    class: "row g-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_87 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_88 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_89 = {
    value: ""
};
const $eb6171179a371c45$var$_hoisted_90 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_91 = {
    key: 0
};
const $eb6171179a371c45$var$_hoisted_92 = {
    class: "d-flex justify-content-between align-items-center mb-2"
};
const $eb6171179a371c45$var$_hoisted_93 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_94 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_95 = {
    key: 0,
    class: "table table-sm table-bordered mb-3"
};
const $eb6171179a371c45$var$_hoisted_96 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_97 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_98 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_99 = {
    style: {
        "width": "70px"
    },
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_100 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    style: {
        "width": "50px"
    }
}, null, -1);
const $eb6171179a371c45$var$_hoisted_101 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_102 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_103 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_104 = [
    "placeholder",
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_105 = {
    class: "text-center"
};
const $eb6171179a371c45$var$_hoisted_106 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_107 = {
    class: "text-center"
};
const $eb6171179a371c45$var$_hoisted_108 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_109 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_110 = [
    $eb6171179a371c45$var$_hoisted_109
];
const $eb6171179a371c45$var$_hoisted_111 = {
    class: "d-flex justify-content-between align-items-center mb-2"
};
const $eb6171179a371c45$var$_hoisted_112 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_113 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_114 = {
    key: 1,
    class: "table table-sm table-bordered"
};
const $eb6171179a371c45$var$_hoisted_115 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_116 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_117 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_118 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_119 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_120 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    style: {
        "width": "50px"
    }
}, null, -1);
const $eb6171179a371c45$var$_hoisted_121 = [
    "onUpdate:modelValue",
    "onChange"
];
const $eb6171179a371c45$var$_hoisted_122 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_123 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_124 = [
    "placeholder",
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_125 = [
    "onUpdate:modelValue",
    "placeholder"
];
const $eb6171179a371c45$var$_hoisted_126 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_127 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_128 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_129 = {
    class: "text-center"
};
const $eb6171179a371c45$var$_hoisted_130 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_131 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_132 = [
    $eb6171179a371c45$var$_hoisted_131
];
const $eb6171179a371c45$var$_hoisted_133 = {
    key: 2
};
const $eb6171179a371c45$var$_hoisted_134 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_135 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_136 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_137 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-regular fa-file"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_138 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_139 = {
    class: "row g-2 mb-4"
};
const $eb6171179a371c45$var$_hoisted_140 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_141 = {
    class: "form-label small text-muted"
};
const $eb6171179a371c45$var$_hoisted_142 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_143 = {
    class: "form-label small text-muted"
};
const $eb6171179a371c45$var$_hoisted_144 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_145 = {
    class: "form-label small text-muted"
};
const $eb6171179a371c45$var$_hoisted_146 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_147 = {
    class: "form-label small text-muted"
};
const $eb6171179a371c45$var$_hoisted_148 = {
    class: "row g-2 mt-3"
};
const $eb6171179a371c45$var$_hoisted_149 = {
    class: "col-md-12"
};
const $eb6171179a371c45$var$_hoisted_150 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_151 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_152 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_153 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_154 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-solid fa-download"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_155 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_156 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_157 = {
    class: "d-flex align-items-center gap-2"
};
const $eb6171179a371c45$var$_hoisted_158 = {
    class: "fw-semibold small"
};
const $eb6171179a371c45$var$_hoisted_159 = {
    key: 0,
    class: "text-muted"
};
const $eb6171179a371c45$var$_hoisted_160 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_161 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_162 = [
    $eb6171179a371c45$var$_hoisted_161
];
const $eb6171179a371c45$var$_hoisted_163 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_164 = {
    class: "row g-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_165 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_166 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_167 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_168 = {
    value: ""
};
const $eb6171179a371c45$var$_hoisted_169 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_170 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_171 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "small"
}, "ID", -1);
const $eb6171179a371c45$var$_hoisted_172 = [
    "onUpdate:modelValue",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_173 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_174 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_175 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_176 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "small"
}, "FROM", -1);
const $eb6171179a371c45$var$_hoisted_177 = [
    "onUpdate:modelValue",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_178 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_179 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_180 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_181 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "small"
}, "TO", -1);
const $eb6171179a371c45$var$_hoisted_182 = [
    "onUpdate:modelValue",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_183 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_184 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_185 = {
    class: "d-flex justify-content-between align-items-center mb-2"
};
const $eb6171179a371c45$var$_hoisted_186 = {
    class: "small text-muted fw-bold mb-0"
};
const $eb6171179a371c45$var$_hoisted_187 = [
    "onClick",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_188 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_189 = {
    key: 0,
    class: "table table-sm table-bordered mb-0"
};
const $eb6171179a371c45$var$_hoisted_190 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_191 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_192 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_193 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_194 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    style: {
        "width": "50px"
    }
}, null, -1);
const $eb6171179a371c45$var$_hoisted_195 = [
    "onUpdate:modelValue",
    "onChange"
];
const $eb6171179a371c45$var$_hoisted_196 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_197 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_198 = [
    "placeholder",
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_199 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_200 = {
    class: "text-center"
};
const $eb6171179a371c45$var$_hoisted_201 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_202 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_203 = [
    $eb6171179a371c45$var$_hoisted_202
];
const $eb6171179a371c45$var$_hoisted_204 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_205 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_206 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_207 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_208 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-solid fa-shuffle"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_209 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_210 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_211 = {
    class: "d-flex align-items-center gap-2"
};
const $eb6171179a371c45$var$_hoisted_212 = {
    class: "fw-semibold small"
};
const $eb6171179a371c45$var$_hoisted_213 = {
    key: 0,
    class: "text-muted"
};
const $eb6171179a371c45$var$_hoisted_214 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_215 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_216 = [
    $eb6171179a371c45$var$_hoisted_215
];
const $eb6171179a371c45$var$_hoisted_217 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_218 = {
    class: "row g-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_219 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_220 = {
    class: "small fw-bold"
};
const $eb6171179a371c45$var$_hoisted_221 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_222 = {
    value: ""
};
const $eb6171179a371c45$var$_hoisted_223 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_224 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_225 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "small text-muted"
}, "ID", -1);
const $eb6171179a371c45$var$_hoisted_226 = [
    "onUpdate:modelValue",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_227 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_228 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_229 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "small text-muted"
}, "FROM", -1);
const $eb6171179a371c45$var$_hoisted_230 = [
    "onUpdate:modelValue",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_231 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_232 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_233 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "small text-muted"
}, "TO", -1);
const $eb6171179a371c45$var$_hoisted_234 = [
    "onUpdate:modelValue",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_235 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_236 = {
    key: 0,
    class: "table table-sm table-bordered mb-0"
};
const $eb6171179a371c45$var$_hoisted_237 = {
    class: "small text-muted"
};
const $eb6171179a371c45$var$_hoisted_238 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_239 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_240 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_241 = {
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_242 = {
    style: {
        "width": "70px"
    },
    class: "pl-1"
};
const $eb6171179a371c45$var$_hoisted_243 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("th", {
    style: {
        "width": "50px"
    }
}, null, -1);
const $eb6171179a371c45$var$_hoisted_244 = [
    "onUpdate:modelValue",
    "onChange"
];
const $eb6171179a371c45$var$_hoisted_245 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_246 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_247 = [
    "placeholder",
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_248 = [
    "onUpdate:modelValue",
    "placeholder"
];
const $eb6171179a371c45$var$_hoisted_249 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_250 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: ""
}, null, -1);
const $eb6171179a371c45$var$_hoisted_251 = [
    "value"
];
const $eb6171179a371c45$var$_hoisted_252 = {
    class: "text-center"
};
const $eb6171179a371c45$var$_hoisted_253 = [
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_254 = {
    class: "text-center"
};
const $eb6171179a371c45$var$_hoisted_255 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_256 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_257 = [
    $eb6171179a371c45$var$_hoisted_256
];
const $eb6171179a371c45$var$_hoisted_258 = [
    "onClick",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_259 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_260 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_261 = {
    class: "card mb-3"
};
const $eb6171179a371c45$var$_hoisted_262 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_263 = {
    class: "d-flex align-items-center gap-2 mb-3"
};
const $eb6171179a371c45$var$_hoisted_264 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center",
    style: {
        "width": "36px",
        "height": "36px"
    }
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
        class: "fa-solid fa-code"
    })
], -1);
const $eb6171179a371c45$var$_hoisted_265 = {
    class: "fw-semibold"
};
const $eb6171179a371c45$var$_hoisted_266 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_267 = {
    class: "d-flex align-items-center gap-2"
};
const $eb6171179a371c45$var$_hoisted_268 = {
    class: "fw-semibold small"
};
const $eb6171179a371c45$var$_hoisted_269 = [
    "onClick",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_270 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-chevron-up"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_271 = [
    $eb6171179a371c45$var$_hoisted_270
];
const $eb6171179a371c45$var$_hoisted_272 = [
    "onClick",
    "disabled"
];
const $eb6171179a371c45$var$_hoisted_273 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-chevron-down"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_274 = [
    $eb6171179a371c45$var$_hoisted_273
];
const $eb6171179a371c45$var$_hoisted_275 = [
    "onClick"
];
const $eb6171179a371c45$var$_hoisted_276 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-trash-alt"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_277 = [
    $eb6171179a371c45$var$_hoisted_276
];
const $eb6171179a371c45$var$_hoisted_278 = {
    class: "card-body"
};
const $eb6171179a371c45$var$_hoisted_279 = {
    class: "row g-2 mb-2"
};
const $eb6171179a371c45$var$_hoisted_280 = {
    class: "col-md-4"
};
const $eb6171179a371c45$var$_hoisted_281 = {
    class: ""
};
const $eb6171179a371c45$var$_hoisted_282 = [
    "onUpdate:modelValue",
    "placeholder"
];
const $eb6171179a371c45$var$_hoisted_283 = {
    class: "col-md-3"
};
const $eb6171179a371c45$var$_hoisted_284 = {
    class: ""
};
const $eb6171179a371c45$var$_hoisted_285 = [
    "onUpdate:modelValue",
    "placeholder"
];
const $eb6171179a371c45$var$_hoisted_286 = {
    class: "col-md-3 d-flex align-items-end"
};
const $eb6171179a371c45$var$_hoisted_287 = {
    class: "form-check mb-1"
};
const $eb6171179a371c45$var$_hoisted_288 = [
    "id",
    "onUpdate:modelValue"
];
const $eb6171179a371c45$var$_hoisted_289 = [
    "for"
];
const $eb6171179a371c45$var$_hoisted_290 = {
    class: ""
};
const $eb6171179a371c45$var$_hoisted_291 = [
    "onUpdate:modelValue",
    "placeholder"
];
const $eb6171179a371c45$var$_hoisted_292 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("i", {
    class: "fas fa-plus"
}, null, -1);
const $eb6171179a371c45$var$_hoisted_293 = {
    key: 1,
    class: "text-muted"
};
function $eb6171179a371c45$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DataBatchRunModal = (0, $TusQn.resolveComponent)("DataBatchRunModal");
    return $data.content ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("button", {
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: _cache[0] || (_cache[0] = (...args)=>$options.goBack && $options.goBack(...args))
                    }, $eb6171179a371c45$var$_hoisted_5),
                    (0, $TusQn.createElementVNode)("h4", $eb6171179a371c45$var$_hoisted_6, (0, $8POXm.toDisplayString)($data.content.name), 1),
                    (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_7, (0, $8POXm.toDisplayString)($data.content.batchType), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_8, [
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-sm btn-outline-white",
                    style: {
                        "border": "1px solid black"
                    },
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.saveBatch && $options.saveBatch(...args)),
                    disabled: $data.saving || $options.isTableNameInvalid()
                }, [
                    $eb6171179a371c45$var$_hoisted_10,
                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("save")), 1)
                ], 8, $eb6171179a371c45$var$_hoisted_9),
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.runBatch && $options.runBatch(...args)),
                    disabled: $data.running || $options.isTableNameInvalid()
                }, [
                    $eb6171179a371c45$var$_hoisted_12,
                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("saveAndRun")), 1)
                ], 8, $eb6171179a371c45$var$_hoisted_11)
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_13, [
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_15, [
                    (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_16, (0, $8POXm.toDisplayString)(_ctx.$t("name")), 1),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.content.name = $event),
                        class: "form-control form-control-sm"
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            $data.content.name
                        ]
                    ])
                ])
            ])
        ]),
        $data.content.batchType === "Copy" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_17, [
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_19, [
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_20, [
                        $eb6171179a371c45$var$_hoisted_21,
                        (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_22, (0, $8POXm.toDisplayString)(_ctx.$t("output")), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_23, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_24, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_25, (0, $8POXm.toDisplayString)(_ctx.$t("outputTable")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.content.outputTableName = $event),
                                class: "form-control form-control-sm"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputTableName
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_26, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_27, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_28, (0, $8POXm.toDisplayString)(_ctx.$t("outputFilter")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.content.outputFilter = $event),
                                class: "form-control form-control-sm"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputFilter
                                ]
                            ])
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_29, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_30, [
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_31, [
                        $eb6171179a371c45$var$_hoisted_32,
                        (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_33, (0, $8POXm.toDisplayString)(_ctx.$t("input")), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_34, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_35, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_36, (0, $8POXm.toDisplayString)(_ctx.$t("inputTable")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.content.inputTable = $event),
                                class: "form-select form-select-sm"
                            }, [
                                (0, $TusQn.createElementVNode)("option", $eb6171179a371c45$var$_hoisted_37, (0, $8POXm.toDisplayString)(_ctx.$t("selectTable")), 1),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.tables, (t)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: t.name,
                                        value: t.name
                                    }, (0, $8POXm.toDisplayString)(t.name), 9, $eb6171179a371c45$var$_hoisted_38);
                                }), 128))
                            ], 512), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $data.content.inputTable
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_39, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_40, (0, $8POXm.toDisplayString)(_ctx.$t("inputIdName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.content.inputIdColumn = $event),
                                class: "form-select form-select-sm",
                                disabled: !$data.content.inputTable
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable($data.content.inputTable), (c)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: c.name,
                                        value: c.name
                                    }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_42);
                                }), 128))
                            ], 8, $eb6171179a371c45$var$_hoisted_41), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $data.content.inputIdColumn
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_43, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_44, (0, $8POXm.toDisplayString)(_ctx.$t("inputFromName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$data.content.inputFromColumn = $event),
                                class: "form-select form-select-sm",
                                disabled: !$data.content.inputTable
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable($data.content.inputTable), (c)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: c.name,
                                        value: c.name
                                    }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_46);
                                }), 128))
                            ], 8, $eb6171179a371c45$var$_hoisted_45), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $data.content.inputFromColumn
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_47, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_48, (0, $8POXm.toDisplayString)(_ctx.$t("inputToName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$data.content.inputToColumn = $event),
                                class: "form-select form-select-sm",
                                disabled: !$data.content.inputTable
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable($data.content.inputTable), (c)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: c.name,
                                        value: c.name
                                    }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_50);
                                }), 128))
                            ], 8, $eb6171179a371c45$var$_hoisted_49), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $data.content.inputToColumn
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_51, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_52, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_53, (0, $8POXm.toDisplayString)(_ctx.$t("inputFilter")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$data.content.inputFilter = $event),
                                class: "form-control form-control-sm"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.inputFilter
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_54, [
                        $data.content.inputTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_55, [
                            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_56, [
                                (0, $TusQn.createElementVNode)("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "copy-all",
                                    checked: $options.allCopyChecked,
                                    onChange: _cache[11] || (_cache[11] = (...args)=>$options.toggleAllCopyColumns && $options.toggleAllCopyColumns(...args))
                                }, null, 40, $eb6171179a371c45$var$_hoisted_57),
                                (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_58, (0, $8POXm.toDisplayString)(_ctx.$t("outputColumns")), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_59, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable($data.content.inputTable), (col)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                        key: col.name,
                                        class: "form-check"
                                    }, [
                                        (0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: `copy-${col.name}`,
                                            checked: !$options.isExcluded(col.name),
                                            disabled: $options.isKeyColumn(col.name),
                                            onChange: ($event)=>$options.toggleCopyColumn(col.name)
                                        }, null, 40, $eb6171179a371c45$var$_hoisted_60),
                                        (0, $TusQn.createElementVNode)("label", {
                                            class: "form-check-label small",
                                            for: `copy-${col.name}`
                                        }, [
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(col.name) + " ", 1),
                                            (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_62, (0, $8POXm.toDisplayString)(col.dataType), 1)
                                        ], 8, $eb6171179a371c45$var$_hoisted_61)
                                    ]);
                                }), 128))
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.content.batchType === "Aggregation" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_63, [
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_64, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_65, [
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_66, [
                        $eb6171179a371c45$var$_hoisted_67,
                        (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_68, (0, $8POXm.toDisplayString)(_ctx.$t("output")), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_69, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_70, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_71, (0, $8POXm.toDisplayString)(_ctx.$t("outputTable")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$data.content.outputTableName = $event),
                                class: "form-control form-control-sm"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputTableName
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_72, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_73, (0, $8POXm.toDisplayString)(_ctx.$t("outputIdName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$data.content.outputIdColumn = $event),
                                class: "form-control form-control-sm",
                                placeholder: "objectId"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputIdColumn
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_74, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_75, (0, $8POXm.toDisplayString)(_ctx.$t("outputFromName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$data.content.outputFromColumn = $event),
                                class: "form-control form-control-sm",
                                placeholder: "from"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputFromColumn
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_76, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_77, (0, $8POXm.toDisplayString)(_ctx.$t("outputToName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>$data.content.outputToColumn = $event),
                                class: "form-control form-control-sm",
                                placeholder: "to"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputToColumn
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_78, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_79, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_80, (0, $8POXm.toDisplayString)(_ctx.$t("outputFilter")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event)=>$data.content.outputFilter = $event),
                                class: "form-control form-control-sm"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputFilter
                                ]
                            ])
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_81, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_82, [
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_83, [
                        $eb6171179a371c45$var$_hoisted_84,
                        (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_85, (0, $8POXm.toDisplayString)(_ctx.$t("aggregation")), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_86, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_87, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_88, (0, $8POXm.toDisplayString)(_ctx.$t("inputTable")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event)=>$data.content.inputTable = $event),
                                class: "form-select form-select-sm"
                            }, [
                                (0, $TusQn.createElementVNode)("option", $eb6171179a371c45$var$_hoisted_89, (0, $8POXm.toDisplayString)(_ctx.$t("selectTable")), 1),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.tables, (t)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                        key: t.name,
                                        value: t.name
                                    }, (0, $8POXm.toDisplayString)(t.name), 9, $eb6171179a371c45$var$_hoisted_90);
                                }), 128))
                            ], 512), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $data.content.inputTable
                                ]
                            ])
                        ])
                    ]),
                    $data.content.inputTable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_91, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_92, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_93, (0, $8POXm.toDisplayString)(_ctx.$t("groupBy")), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-outline-primary",
                                onClick: _cache[18] || (_cache[18] = (...args)=>$options.addGroupBy && $options.addGroupBy(...args))
                            }, [
                                $eb6171179a371c45$var$_hoisted_94,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addGroupBy")), 1)
                            ])
                        ]),
                        $data.content.groupBy && $data.content.groupBy.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $eb6171179a371c45$var$_hoisted_95, [
                            (0, $TusQn.createElementVNode)("thead", null, [
                                (0, $TusQn.createElementVNode)("tr", $eb6171179a371c45$var$_hoisted_96, [
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_97, (0, $8POXm.toDisplayString)(_ctx.$t("column")), 1),
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_98, (0, $8POXm.toDisplayString)(_ctx.$t("alias")), 1),
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_99, (0, $8POXm.toDisplayString)(_ctx.$t("temporary")), 1),
                                    $eb6171179a371c45$var$_hoisted_100
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("tbody", null, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.content.groupBy, (agg, i)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                        key: i
                                    }, [
                                        (0, $TusQn.createElementVNode)("td", null, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                "onUpdate:modelValue": ($event)=>agg.column = $event,
                                                class: "form-select form-select-sm"
                                            }, [
                                                $eb6171179a371c45$var$_hoisted_102,
                                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.inputColumns, (col)=>{
                                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                        key: col.name,
                                                        value: col.name
                                                    }, (0, $8POXm.toDisplayString)(col.name), 9, $eb6171179a371c45$var$_hoisted_103);
                                                }), 128))
                                            ], 8, $eb6171179a371c45$var$_hoisted_101), [
                                                [
                                                    (0, $eeJ70.vModelSelect),
                                                    agg.column
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", null, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                placeholder: agg.name || "",
                                                "onUpdate:modelValue": ($event)=>agg.alias = $event
                                            }, null, 8, $eb6171179a371c45$var$_hoisted_104), [
                                                [
                                                    (0, $eeJ70.vModelText),
                                                    agg.alias
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", $eb6171179a371c45$var$_hoisted_105, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                class: "form-check-input mt-2",
                                                type: "checkbox",
                                                "onUpdate:modelValue": ($event)=>agg.temporary = $event
                                            }, null, 8, $eb6171179a371c45$var$_hoisted_106), [
                                                [
                                                    (0, $eeJ70.vModelCheckbox),
                                                    agg.temporary
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", $eb6171179a371c45$var$_hoisted_107, [
                                            (0, $TusQn.createElementVNode)("button", {
                                                class: "btn btn-sm btn-outline-danger",
                                                onClick: ($event)=>$data.content.groupBy.splice(i, 1)
                                            }, $eb6171179a371c45$var$_hoisted_110, 8, $eb6171179a371c45$var$_hoisted_108)
                                        ])
                                    ]);
                                }), 128))
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_111, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_112, (0, $8POXm.toDisplayString)(_ctx.$t("aggregateColumns")), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-outline-primary",
                                onClick: _cache[19] || (_cache[19] = (...args)=>$options.addAggregation && $options.addAggregation(...args))
                            }, [
                                $eb6171179a371c45$var$_hoisted_113,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addColumn")), 1)
                            ])
                        ]),
                        $data.content.aggregations && $data.content.aggregations.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $eb6171179a371c45$var$_hoisted_114, [
                            (0, $TusQn.createElementVNode)("thead", null, [
                                (0, $TusQn.createElementVNode)("tr", $eb6171179a371c45$var$_hoisted_115, [
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_116, (0, $8POXm.toDisplayString)(_ctx.$t("column")), 1),
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_117, (0, $8POXm.toDisplayString)(_ctx.$t("alias")), 1),
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_118, (0, $8POXm.toDisplayString)(_ctx.$t("dataType")), 1),
                                    (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_119, (0, $8POXm.toDisplayString)(_ctx.$t("function")), 1),
                                    $eb6171179a371c45$var$_hoisted_120
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("tbody", null, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.content.aggregations, (agg, i)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                        key: i
                                    }, [
                                        (0, $TusQn.createElementVNode)("td", null, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                "onUpdate:modelValue": ($event)=>agg.column = $event,
                                                class: "form-select form-select-sm",
                                                onChange: ($event)=>$options.prefillAggregation(agg)
                                            }, [
                                                $eb6171179a371c45$var$_hoisted_122,
                                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.inputColumns, (col)=>{
                                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                        key: col.name,
                                                        value: col.name
                                                    }, (0, $8POXm.toDisplayString)(col.name), 9, $eb6171179a371c45$var$_hoisted_123);
                                                }), 128))
                                            ], 40, $eb6171179a371c45$var$_hoisted_121), [
                                                [
                                                    (0, $eeJ70.vModelSelect),
                                                    agg.column
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", null, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                placeholder: agg.name || "",
                                                "onUpdate:modelValue": ($event)=>agg.alias = $event
                                            }, null, 8, $eb6171179a371c45$var$_hoisted_124), [
                                                [
                                                    (0, $eeJ70.vModelText),
                                                    agg.alias
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", null, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                "onUpdate:modelValue": ($event)=>agg.dataType = $event,
                                                placeholder: agg.dataType || ""
                                            }, null, 8, $eb6171179a371c45$var$_hoisted_125), [
                                                [
                                                    (0, $eeJ70.vModelText),
                                                    agg.dataType
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", null, [
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                "onUpdate:modelValue": ($event)=>agg.function = $event,
                                                class: "form-select form-select-sm"
                                            }, [
                                                $eb6171179a371c45$var$_hoisted_127,
                                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.aggregations, (fn)=>{
                                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                        key: fn.value,
                                                        value: fn.value
                                                    }, (0, $8POXm.toDisplayString)(fn.label), 9, $eb6171179a371c45$var$_hoisted_128);
                                                }), 128))
                                            ], 8, $eb6171179a371c45$var$_hoisted_126), [
                                                [
                                                    (0, $eeJ70.vModelSelect),
                                                    agg.function
                                                ]
                                            ])
                                        ]),
                                        (0, $TusQn.createElementVNode)("td", $eb6171179a371c45$var$_hoisted_129, [
                                            (0, $TusQn.createElementVNode)("button", {
                                                class: "btn btn-sm btn-outline-danger",
                                                onClick: ($event)=>$data.content.aggregations.splice(i, 1)
                                            }, $eb6171179a371c45$var$_hoisted_132, 8, $eb6171179a371c45$var$_hoisted_130)
                                        ])
                                    ]);
                                }), 128))
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ])) : (0, $TusQn.createCommentVNode)("", true)
                ])
            ])
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $data.content.batchType === "CSD" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_133, [
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_134, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_135, [
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_136, [
                        $eb6171179a371c45$var$_hoisted_137,
                        (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_138, (0, $8POXm.toDisplayString)(_ctx.$t("output")), 1)
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_139, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_140, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_141, (0, $8POXm.toDisplayString)(_ctx.$t("outputTableName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event)=>$data.content.outputTableName = $event),
                                class: "form-control form-control-sm",
                                style: {
                                    "max-width": "400px"
                                }
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputTableName
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_142, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_143, (0, $8POXm.toDisplayString)(_ctx.$t("outputIdName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event)=>$data.content.outputIdColumn = $event),
                                class: "form-control form-control-sm",
                                placeholder: "objectId"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputIdColumn
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_144, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_145, (0, $8POXm.toDisplayString)(_ctx.$t("outputFromName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event)=>$data.content.outputFromColumn = $event),
                                class: "form-control form-control-sm",
                                placeholder: "from"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputFromColumn
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_146, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_147, (0, $8POXm.toDisplayString)(_ctx.$t("outputToName")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event)=>$data.content.outputToColumn = $event),
                                class: "form-control form-control-sm",
                                placeholder: "to"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputToColumn
                                ]
                            ])
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_148, [
                        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_149, [
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_150, (0, $8POXm.toDisplayString)(_ctx.$t("outputFilter")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event)=>$data.content.outputFilter = $event),
                                class: "form-control form-control-sm"
                            }, null, 512), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $data.content.outputFilter
                                ]
                            ])
                        ])
                    ])
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_151, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_152, [
                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_153, [
                        $eb6171179a371c45$var$_hoisted_154,
                        (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_155, (0, $8POXm.toDisplayString)(_ctx.$t("inputs")), 1)
                    ]),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.content.csdTables || [], (tbl, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: i,
                            class: "card mb-3"
                        }, [
                            (0, $TusQn.createElementVNode)("div", {
                                class: "card-header bg-white d-flex justify-content-between align-items-center",
                                style: {
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>tbl.collapsed = !tbl.collapsed
                            }, [
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_157, [
                                    (0, $TusQn.createElementVNode)("i", {
                                        class: (0, $8POXm.normalizeClass)([
                                            "fas",
                                            tbl.collapsed ? "fa-chevron-right" : "fa-chevron-down"
                                        ]),
                                        style: {
                                            "width": "20px"
                                        }
                                    }, null, 2),
                                    (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_158, [
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("input")) + " " + (0, $8POXm.toDisplayString)(i + 1) + " ", 1),
                                        tbl.table ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $eb6171179a371c45$var$_hoisted_159, "- " + (0, $8POXm.toDisplayString)(tbl.table), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: ($event)=>$data.content.csdTables.splice(i, 1)
                                }, $eb6171179a371c45$var$_hoisted_162, 8, $eb6171179a371c45$var$_hoisted_160)
                            ], 8, $eb6171179a371c45$var$_hoisted_156),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_163, [
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_164, [
                                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_165, [
                                        (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_166, (0, $8POXm.toDisplayString)(_ctx.$t("inputTable")), 1),
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>tbl.table = $event,
                                            class: "form-select form-select-sm"
                                        }, [
                                            (0, $TusQn.createElementVNode)("option", $eb6171179a371c45$var$_hoisted_168, (0, $8POXm.toDisplayString)(_ctx.$t("selectTable")), 1),
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.tables, (t)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: t.name,
                                                    value: t.name
                                                }, (0, $8POXm.toDisplayString)(t.name), 9, $eb6171179a371c45$var$_hoisted_169);
                                            }), 128))
                                        ], 8, $eb6171179a371c45$var$_hoisted_167), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                tbl.table
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_170, [
                                        $eb6171179a371c45$var$_hoisted_171,
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>tbl.idColumn = $event,
                                            class: "form-select form-select-sm",
                                            disabled: !tbl.table
                                        }, [
                                            $eb6171179a371c45$var$_hoisted_173,
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: c.name,
                                                    value: c.name
                                                }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_174);
                                            }), 128))
                                        ], 8, $eb6171179a371c45$var$_hoisted_172), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                tbl.idColumn
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_175, [
                                        $eb6171179a371c45$var$_hoisted_176,
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>tbl.fromColumn = $event,
                                            class: "form-select form-select-sm",
                                            disabled: !tbl.table
                                        }, [
                                            $eb6171179a371c45$var$_hoisted_178,
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: c.name,
                                                    value: c.name
                                                }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_179);
                                            }), 128))
                                        ], 8, $eb6171179a371c45$var$_hoisted_177), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                tbl.fromColumn
                                            ]
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_180, [
                                        $eb6171179a371c45$var$_hoisted_181,
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                            "onUpdate:modelValue": ($event)=>tbl.toColumn = $event,
                                            class: "form-select form-select-sm",
                                            disabled: !tbl.table
                                        }, [
                                            $eb6171179a371c45$var$_hoisted_183,
                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                    key: c.name,
                                                    value: c.name
                                                }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_184);
                                            }), 128))
                                        ], 8, $eb6171179a371c45$var$_hoisted_182), [
                                            [
                                                (0, $eeJ70.vModelSelect),
                                                tbl.toColumn
                                            ]
                                        ])
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_185, [
                                    (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_186, (0, $8POXm.toDisplayString)(_ctx.$t("includeColumns")), 1),
                                    (0, $TusQn.createElementVNode)("button", {
                                        class: "btn btn-sm btn-outline-primary",
                                        onClick: ($event)=>$options.addCsdColumn(tbl),
                                        disabled: !tbl.table
                                    }, [
                                        $eb6171179a371c45$var$_hoisted_188,
                                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addColumn")), 1)
                                    ], 8, $eb6171179a371c45$var$_hoisted_187)
                                ]),
                                tbl.selectedColumns && tbl.selectedColumns.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $eb6171179a371c45$var$_hoisted_189, [
                                    (0, $TusQn.createElementVNode)("thead", null, [
                                        (0, $TusQn.createElementVNode)("tr", $eb6171179a371c45$var$_hoisted_190, [
                                            (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_191, (0, $8POXm.toDisplayString)(_ctx.$t("column")), 1),
                                            (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_192, (0, $8POXm.toDisplayString)(_ctx.$t("alias")), 1),
                                            (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_193, (0, $8POXm.toDisplayString)(_ctx.$t("dataType")), 1),
                                            $eb6171179a371c45$var$_hoisted_194
                                        ])
                                    ]),
                                    (0, $TusQn.createElementVNode)("tbody", null, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(tbl.selectedColumns, (col, j)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                                key: j
                                            }, [
                                                (0, $TusQn.createElementVNode)("td", null, [
                                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                        "onUpdate:modelValue": ($event)=>col.name = $event,
                                                        class: "form-select form-select-sm",
                                                        onChange: ($event)=>$options.prefillDataType(tbl, col)
                                                    }, [
                                                        $eb6171179a371c45$var$_hoisted_196,
                                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                                key: c.name,
                                                                value: c.name
                                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_197);
                                                        }), 128))
                                                    ], 40, $eb6171179a371c45$var$_hoisted_195), [
                                                        [
                                                            (0, $eeJ70.vModelSelect),
                                                            col.name
                                                        ]
                                                    ])
                                                ]),
                                                (0, $TusQn.createElementVNode)("td", null, [
                                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                        type: "text",
                                                        class: "form-control form-control-sm",
                                                        placeholder: col.name || "",
                                                        "onUpdate:modelValue": ($event)=>col.alias = $event
                                                    }, null, 8, $eb6171179a371c45$var$_hoisted_198), [
                                                        [
                                                            (0, $eeJ70.vModelText),
                                                            col.alias
                                                        ]
                                                    ])
                                                ]),
                                                (0, $TusQn.createElementVNode)("td", null, [
                                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                        type: "text",
                                                        class: "form-control form-control-sm",
                                                        "onUpdate:modelValue": ($event)=>col.dataType = $event,
                                                        placeholder: "nvarchar(MAX)"
                                                    }, null, 8, $eb6171179a371c45$var$_hoisted_199), [
                                                        [
                                                            (0, $eeJ70.vModelText),
                                                            col.dataType
                                                        ]
                                                    ])
                                                ]),
                                                (0, $TusQn.createElementVNode)("td", $eb6171179a371c45$var$_hoisted_200, [
                                                    (0, $TusQn.createElementVNode)("button", {
                                                        class: "btn btn-sm btn-outline-danger",
                                                        onClick: ($event)=>tbl.selectedColumns.splice(j, 1)
                                                    }, $eb6171179a371c45$var$_hoisted_203, 8, $eb6171179a371c45$var$_hoisted_201)
                                                ])
                                            ]);
                                        }), 128))
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("", true)
                            ], 512), [
                                [
                                    (0, $eeJ70.vShow),
                                    !tbl.collapsed
                                ]
                            ])
                        ]);
                    }), 128)),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "btn btn-sm btn-outline-primary",
                        onClick: _cache[25] || (_cache[25] = (...args)=>$options.addCsdTable && $options.addCsdTable(...args))
                    }, [
                        $eb6171179a371c45$var$_hoisted_204,
                        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addInput")), 1)
                    ])
                ])
            ])
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_205, [
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_206, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_207, [
                    $eb6171179a371c45$var$_hoisted_208,
                    (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_209, (0, $8POXm.toDisplayString)(_ctx.$t("transformations")), 1)
                ]),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.content.transformations || [], (tbl, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: i,
                        class: "card mb-3"
                    }, [
                        (0, $TusQn.createElementVNode)("div", {
                            class: "card-header bg-white d-flex justify-content-between align-items-center",
                            style: {
                                "cursor": "pointer"
                            },
                            onClick: ($event)=>tbl.collapsed = !tbl.collapsed
                        }, [
                            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_211, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "fas",
                                        tbl.collapsed ? "fa-chevron-right" : "fa-chevron-down"
                                    ]),
                                    style: {
                                        "width": "20px"
                                    }
                                }, null, 2),
                                (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_212, [
                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(_ctx.$t("transformation")) + " " + (0, $8POXm.toDisplayString)(i + 1) + " ", 1),
                                    tbl.table ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $eb6171179a371c45$var$_hoisted_213, "- " + (0, $8POXm.toDisplayString)(tbl.table), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-outline-danger",
                                onClick: ($event)=>$data.content.transformations.splice(i, 1)
                            }, $eb6171179a371c45$var$_hoisted_216, 8, $eb6171179a371c45$var$_hoisted_214)
                        ], 8, $eb6171179a371c45$var$_hoisted_210),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_217, [
                            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_218, [
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_219, [
                                    (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_220, (0, $8POXm.toDisplayString)(_ctx.$t("transformationTable")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        "onUpdate:modelValue": ($event)=>tbl.table = $event,
                                        class: "form-select form-select-sm"
                                    }, [
                                        (0, $TusQn.createElementVNode)("option", $eb6171179a371c45$var$_hoisted_222, (0, $8POXm.toDisplayString)(_ctx.$t("selectTable")), 1),
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.tables, (t)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: t.name,
                                                value: t.name
                                            }, (0, $8POXm.toDisplayString)(t.name), 9, $eb6171179a371c45$var$_hoisted_223);
                                        }), 128))
                                    ], 8, $eb6171179a371c45$var$_hoisted_221), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            tbl.table
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_224, [
                                    $eb6171179a371c45$var$_hoisted_225,
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        "onUpdate:modelValue": ($event)=>tbl.idColumn = $event,
                                        class: "form-select form-select-sm",
                                        disabled: !tbl.table
                                    }, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: c.name,
                                                value: c.name
                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_227);
                                        }), 128))
                                    ], 8, $eb6171179a371c45$var$_hoisted_226), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            tbl.idColumn
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_228, [
                                    $eb6171179a371c45$var$_hoisted_229,
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        "onUpdate:modelValue": ($event)=>tbl.fromColumn = $event,
                                        class: "form-select form-select-sm",
                                        disabled: !tbl.table
                                    }, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: c.name,
                                                value: c.name
                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_231);
                                        }), 128))
                                    ], 8, $eb6171179a371c45$var$_hoisted_230), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            tbl.fromColumn
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_232, [
                                    $eb6171179a371c45$var$_hoisted_233,
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                        "onUpdate:modelValue": ($event)=>tbl.toColumn = $event,
                                        class: "form-select form-select-sm",
                                        disabled: !tbl.table
                                    }, [
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                key: c.name,
                                                value: c.name
                                            }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_235);
                                        }), 128))
                                    ], 8, $eb6171179a371c45$var$_hoisted_234), [
                                        [
                                            (0, $eeJ70.vModelSelect),
                                            tbl.toColumn
                                        ]
                                    ])
                                ])
                            ]),
                            tbl.selectedColumns && tbl.selectedColumns.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("table", $eb6171179a371c45$var$_hoisted_236, [
                                (0, $TusQn.createElementVNode)("thead", null, [
                                    (0, $TusQn.createElementVNode)("tr", $eb6171179a371c45$var$_hoisted_237, [
                                        (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_238, (0, $8POXm.toDisplayString)(_ctx.$t("column")), 1),
                                        (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_239, (0, $8POXm.toDisplayString)(_ctx.$t("alias")), 1),
                                        (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_240, (0, $8POXm.toDisplayString)(_ctx.$t("dataType")), 1),
                                        (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_241, (0, $8POXm.toDisplayString)(_ctx.$t("function")), 1),
                                        (0, $TusQn.createElementVNode)("th", $eb6171179a371c45$var$_hoisted_242, (0, $8POXm.toDisplayString)(_ctx.$t("temporary")), 1),
                                        $eb6171179a371c45$var$_hoisted_243
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("tbody", null, [
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(tbl.selectedColumns, (col, j)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                            key: j
                                        }, [
                                            (0, $TusQn.createElementVNode)("td", null, [
                                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                    "onUpdate:modelValue": ($event)=>col.name = $event,
                                                    class: "form-select form-select-sm",
                                                    onChange: ($event)=>$options.prefillDataType(tbl, col)
                                                }, [
                                                    $eb6171179a371c45$var$_hoisted_245,
                                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($options.getColumnsForTable(tbl.table), (c)=>{
                                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                            key: c.name,
                                                            value: c.name
                                                        }, (0, $8POXm.toDisplayString)(c.name), 9, $eb6171179a371c45$var$_hoisted_246);
                                                    }), 128))
                                                ], 40, $eb6171179a371c45$var$_hoisted_244), [
                                                    [
                                                        (0, $eeJ70.vModelSelect),
                                                        col.name
                                                    ]
                                                ])
                                            ]),
                                            (0, $TusQn.createElementVNode)("td", null, [
                                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                    type: "text",
                                                    class: "form-control form-control-sm",
                                                    placeholder: col.name || "",
                                                    "onUpdate:modelValue": ($event)=>col.alias = $event
                                                }, null, 8, $eb6171179a371c45$var$_hoisted_247), [
                                                    [
                                                        (0, $eeJ70.vModelText),
                                                        col.alias
                                                    ]
                                                ])
                                            ]),
                                            (0, $TusQn.createElementVNode)("td", null, [
                                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                    type: "text",
                                                    class: "form-control form-control-sm",
                                                    "onUpdate:modelValue": ($event)=>col.dataType = $event,
                                                    placeholder: col.dataType || ""
                                                }, null, 8, $eb6171179a371c45$var$_hoisted_248), [
                                                    [
                                                        (0, $eeJ70.vModelText),
                                                        col.dataType
                                                    ]
                                                ])
                                            ]),
                                            (0, $TusQn.createElementVNode)("td", null, [
                                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                                    "onUpdate:modelValue": ($event)=>col.transformation = $event,
                                                    class: "form-select form-select-sm"
                                                }, [
                                                    $eb6171179a371c45$var$_hoisted_250,
                                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.transformations, (fn)=>{
                                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                                            key: fn.value,
                                                            value: fn.value
                                                        }, (0, $8POXm.toDisplayString)(fn.label), 9, $eb6171179a371c45$var$_hoisted_251);
                                                    }), 128))
                                                ], 8, $eb6171179a371c45$var$_hoisted_249), [
                                                    [
                                                        (0, $eeJ70.vModelSelect),
                                                        col.transformation
                                                    ]
                                                ])
                                            ]),
                                            (0, $TusQn.createElementVNode)("td", $eb6171179a371c45$var$_hoisted_252, [
                                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                                    class: "form-check-input mt-2",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event)=>col.temporary = $event
                                                }, null, 8, $eb6171179a371c45$var$_hoisted_253), [
                                                    [
                                                        (0, $eeJ70.vModelCheckbox),
                                                        col.temporary
                                                    ]
                                                ])
                                            ]),
                                            (0, $TusQn.createElementVNode)("td", $eb6171179a371c45$var$_hoisted_254, [
                                                (0, $TusQn.createElementVNode)("button", {
                                                    class: "btn btn-sm btn-outline-danger",
                                                    onClick: ($event)=>tbl.selectedColumns.splice(j, 1)
                                                }, $eb6171179a371c45$var$_hoisted_257, 8, $eb6171179a371c45$var$_hoisted_255)
                                            ])
                                        ]);
                                    }), 128))
                                ])
                            ])) : (0, $TusQn.createCommentVNode)("", true),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "btn btn-sm btn-outline-primary mt-2",
                                onClick: ($event)=>$options.addTransformationColumn(tbl),
                                disabled: !tbl.table
                            }, [
                                $eb6171179a371c45$var$_hoisted_259,
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addColumn")), 1)
                            ], 8, $eb6171179a371c45$var$_hoisted_258)
                        ], 512), [
                            [
                                (0, $eeJ70.vShow),
                                !tbl.collapsed
                            ]
                        ])
                    ]);
                }), 128)),
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-sm btn-outline-primary",
                    onClick: _cache[26] || (_cache[26] = (...args)=>$options.addTransformation && $options.addTransformation(...args))
                }, [
                    $eb6171179a371c45$var$_hoisted_260,
                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addTransformation")), 1)
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_261, [
            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_262, [
                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_263, [
                    $eb6171179a371c45$var$_hoisted_264,
                    (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_265, (0, $8POXm.toDisplayString)(_ctx.$t("expressions")), 1)
                ]),
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.content.expressions || [], (expr, i)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: i,
                        class: "card mb-2"
                    }, [
                        (0, $TusQn.createElementVNode)("div", {
                            class: "card-header bg-white d-flex justify-content-between align-items-center",
                            style: {
                                "cursor": "pointer"
                            },
                            onClick: ($event)=>expr.collapsed = !expr.collapsed
                        }, [
                            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_267, [
                                (0, $TusQn.createElementVNode)("i", {
                                    class: (0, $8POXm.normalizeClass)([
                                        "fas",
                                        expr.collapsed ? "fa-chevron-right" : "fa-chevron-down"
                                    ]),
                                    style: {
                                        "width": "20px"
                                    }
                                }, null, 2),
                                (0, $TusQn.createElementVNode)("span", $eb6171179a371c45$var$_hoisted_268, (0, $8POXm.toDisplayString)(expr.alias || _ctx.$t("expression") + " " + (i + 1)), 1)
                            ]),
                            (0, $TusQn.createElementVNode)("div", {
                                class: "d-flex gap-1",
                                onClick: _cache[27] || (_cache[27] = (0, $eeJ70.withModifiers)(()=>{}, [
                                    "stop"
                                ]))
                            }, [
                                (0, $TusQn.createElementVNode)("button", {
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event)=>$options.moveExpression(i, -1),
                                    disabled: i === 0
                                }, $eb6171179a371c45$var$_hoisted_271, 8, $eb6171179a371c45$var$_hoisted_269),
                                (0, $TusQn.createElementVNode)("button", {
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event)=>$options.moveExpression(i, 1),
                                    disabled: i === $data.content.expressions.length - 1
                                }, $eb6171179a371c45$var$_hoisted_274, 8, $eb6171179a371c45$var$_hoisted_272),
                                (0, $TusQn.createElementVNode)("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: ($event)=>$data.content.expressions.splice(i, 1)
                                }, $eb6171179a371c45$var$_hoisted_277, 8, $eb6171179a371c45$var$_hoisted_275)
                            ])
                        ], 8, $eb6171179a371c45$var$_hoisted_266),
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_278, [
                            (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_279, [
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_280, [
                                    (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_281, (0, $8POXm.toDisplayString)(_ctx.$t("alias")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control form-control-sm",
                                        "onUpdate:modelValue": ($event)=>expr.alias = $event,
                                        placeholder: _ctx.$t("alias")
                                    }, null, 8, $eb6171179a371c45$var$_hoisted_282), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            expr.alias
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_283, [
                                    (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_284, (0, $8POXm.toDisplayString)(_ctx.$t("dataType")), 1),
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control form-control-sm",
                                        "onUpdate:modelValue": ($event)=>expr.dataType = $event,
                                        placeholder: _ctx.$t("dataType")
                                    }, null, 8, $eb6171179a371c45$var$_hoisted_285), [
                                        [
                                            (0, $eeJ70.vModelText),
                                            expr.dataType
                                        ]
                                    ])
                                ]),
                                (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_286, [
                                    (0, $TusQn.createElementVNode)("div", $eb6171179a371c45$var$_hoisted_287, [
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: `expr-tmp-${i}`,
                                            "onUpdate:modelValue": ($event)=>expr.temporary = $event
                                        }, null, 8, $eb6171179a371c45$var$_hoisted_288), [
                                            [
                                                (0, $eeJ70.vModelCheckbox),
                                                expr.temporary
                                            ]
                                        ]),
                                        (0, $TusQn.createElementVNode)("label", {
                                            class: "form-check-label",
                                            for: `expr-tmp-${i}`
                                        }, (0, $8POXm.toDisplayString)(_ctx.$t("temporary")), 9, $eb6171179a371c45$var$_hoisted_289)
                                    ])
                                ])
                            ]),
                            (0, $TusQn.createElementVNode)("label", $eb6171179a371c45$var$_hoisted_290, (0, $8POXm.toDisplayString)(_ctx.$t("expression")), 1),
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                                class: "form-control form-control-sm",
                                rows: "4",
                                "onUpdate:modelValue": ($event)=>expr.expression = $event,
                                placeholder: _ctx.$t("expressionPlaceholder")
                            }, null, 8, $eb6171179a371c45$var$_hoisted_291), [
                                [
                                    (0, $eeJ70.vModelText),
                                    expr.expression
                                ]
                            ])
                        ], 512), [
                            [
                                (0, $eeJ70.vShow),
                                !expr.collapsed
                            ]
                        ])
                    ]);
                }), 128)),
                (0, $TusQn.createElementVNode)("button", {
                    class: "btn btn-sm btn-outline-primary",
                    onClick: _cache[28] || (_cache[28] = (...args)=>$options.addExpression && $options.addExpression(...args))
                }, [
                    $eb6171179a371c45$var$_hoisted_292,
                    (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(_ctx.$t("addExpression")), 1)
                ])
            ])
        ]),
        $data.showRunModal ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_DataBatchRunModal, {
            key: 3,
            batch: $data.content,
            onClose: _cache[29] || (_cache[29] = ($event)=>$data.showRunModal = false)
        }, null, 8, [
            "batch"
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $eb6171179a371c45$var$_hoisted_293, (0, $8POXm.toDisplayString)(_ctx.$t("loading")) + "...", 1));
}

});

parcelRegister("cq6vQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $90acf6fef6bdb6c3$export$2e2bcd8739ae039);
let $90acf6fef6bdb6c3$var$NOOP = ()=>{};
var $90acf6fef6bdb6c3$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("h8ls9", function(module, exports) {

$parcel$export(module.exports, "fadeOut", () => fadeOut);
$parcel$export(module.exports, "LIB_NAME", () => LIB_NAME);
$parcel$export(module.exports, "ERROR", () => ERROR);
$parcel$export(module.exports, "WARN", () => WARN);
$parcel$export(module.exports, "SUCCESS", () => SUCCESS);
$parcel$export(module.exports, "INFO", () => INFO);
$parcel$export(module.exports, "CONTAINER_CLASS", () => CONTAINER_CLASS);
$parcel$export(module.exports, "NOTIFICATION_CLASS", () => NOTIFICATION_CLASS);
$parcel$export(module.exports, "TITLE_CLASS", () => TITLE_CLASS);
$parcel$export(module.exports, "ICON_CLASS", () => ICON_CLASS);
$parcel$export(module.exports, "MESSAGE_CLASS", () => MESSAGE_CLASS);
$parcel$export(module.exports, "ERROR_CLASS", () => ERROR_CLASS);
$parcel$export(module.exports, "WARN_CLASS", () => WARN_CLASS);
$parcel$export(module.exports, "SUCCESS_CLASS", () => SUCCESS_CLASS);
$parcel$export(module.exports, "INFO_CLASS", () => INFO_CLASS);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => DEFAULT_TIMEOUT);
$parcel$export(module.exports, "flatten", () => flatten);
$parcel$export(module.exports, "makeCss", () => makeCss);
$parcel$export(module.exports, "appendStyles", () => appendStyles);
$parcel$export(module.exports, "makeNode", () => makeNode);
$parcel$export(module.exports, "config", () => config);
$parcel$export(module.exports, "createIcon", () => createIcon);
$parcel$export(module.exports, "addElem", () => addElem);
$parcel$export(module.exports, "getTypeClass", () => getTypeClass);
$parcel$export(module.exports, "default", () => $c793d3262494b830$export$2e2bcd8739ae039);
function fadeOut(element, cb) {
    if (element.style.opacity && element.style.opacity > 0.05) element.style.opacity = element.style.opacity - 0.05;
    else if (element.style.opacity && element.style.opacity <= 0.1) {
        if (element.parentNode) {
            element.parentNode.removeChild(element);
            if (cb) cb();
        }
    } else element.style.opacity = 0.9;
    setTimeout(()=>fadeOut.apply(this, [
            element,
            cb
        ]), 1000 / 30);
}
const LIB_NAME = "mini-toastr";
const ERROR = "error";
const WARN = "warn";
const SUCCESS = "success";
const INFO = "info";
const CONTAINER_CLASS = LIB_NAME;
const NOTIFICATION_CLASS = `${LIB_NAME}__notification`;
const TITLE_CLASS = `${LIB_NAME}-notification__title`;
const ICON_CLASS = `${LIB_NAME}-notification__icon`;
const MESSAGE_CLASS = `${LIB_NAME}-notification__message`;
const ERROR_CLASS = `-${ERROR}`;
const WARN_CLASS = `-${WARN}`;
const SUCCESS_CLASS = `-${SUCCESS}`;
const INFO_CLASS = `-${INFO}`;
const DEFAULT_TIMEOUT = 3000;
const EMPTY_STRING = "";
function flatten(obj, into, prefix) {
    into = into || {};
    prefix = prefix || EMPTY_STRING;
    for(const k in obj)if (obj.hasOwnProperty(k)) {
        const prop = obj[k];
        if (prop && typeof prop === "object" && !(prop instanceof Date || prop instanceof RegExp)) flatten(prop, into, prefix + k + " ");
        else if (into[prefix] && typeof into[prefix] === "object") into[prefix][k] = prop;
        else {
            into[prefix] = {};
            into[prefix][k] = prop;
        }
    }
    return into;
}
function makeCss(obj) {
    const flat = flatten(obj);
    let str = JSON.stringify(flat, null, 2);
    str = str.replace(/"([^"]*)": {/g, "$1 {").replace(/"([^"]*)"/g, "$1").replace(/(\w*-?\w*): ([\w\d .#]*),?/g, "$1: $2;").replace(/},/g, "}\n").replace(/ &([.:])/g, "$1");
    str = str.substr(1, str.lastIndexOf("}") - 1);
    return str;
}
function appendStyles(css) {
    let head = document.head || document.getElementsByTagName("head")[0];
    let styleElem = makeNode("style");
    styleElem.id = `${LIB_NAME}-styles`;
    styleElem.type = "text/css";
    if (styleElem.styleSheet) styleElem.styleSheet.cssText = css;
    else styleElem.appendChild(document.createTextNode(css));
    head.appendChild(styleElem);
}
const config = {
    types: {
        ERROR: ERROR,
        WARN: WARN,
        SUCCESS: SUCCESS,
        INFO: INFO
    },
    animation: fadeOut,
    timeout: DEFAULT_TIMEOUT,
    icons: {},
    appendTarget: document.body,
    node: makeNode(),
    allowHtml: false,
    style: {
        [`.${CONTAINER_CLASS}`]: {
            position: "fixed",
            "z-index": 99999,
            right: "12px",
            top: "12px"
        },
        [`.${NOTIFICATION_CLASS}`]: {
            cursor: "pointer",
            padding: "12px 18px",
            margin: "0 0 6px 0",
            "background-color": "#000",
            opacity: 0.8,
            color: "#fff",
            "border-radius": "3px",
            "box-shadow": "#3c3b3b 0 0 12px",
            width: "300px",
            [`&.${ERROR_CLASS}`]: {
                "background-color": "#D5122B"
            },
            [`&.${WARN_CLASS}`]: {
                "background-color": "#F5AA1E"
            },
            [`&.${SUCCESS_CLASS}`]: {
                "background-color": "#7AC13E"
            },
            [`&.${INFO_CLASS}`]: {
                "background-color": "#4196E1"
            },
            "&:hover": {
                opacity: 1,
                "box-shadow": "#000 0 0 12px"
            }
        },
        [`.${TITLE_CLASS}`]: {
            "font-weight": "500"
        },
        [`.${MESSAGE_CLASS}`]: {
            display: "inline-block",
            "vertical-align": "middle",
            width: "240px",
            padding: "0 12px"
        }
    }
};
function makeNode(type = "div") {
    return document.createElement(type);
}
function createIcon(node, type, config) {
    const iconNode = makeNode(config.icons[type].nodeType);
    const attrs = config.icons[type].attrs;
    for(const k in attrs)if (attrs.hasOwnProperty(k)) iconNode.setAttribute(k, attrs[k]);
    node.appendChild(iconNode);
}
function addElem(node, text, className, config) {
    const elem = makeNode();
    elem.className = className;
    if (config.allowHtml) elem.innerHTML = text;
    else elem.appendChild(document.createTextNode(text));
    node.appendChild(elem);
}
function getTypeClass(type) {
    if (type === SUCCESS) return SUCCESS_CLASS;
    if (type === WARN) return WARN_CLASS;
    if (type === ERROR) return ERROR_CLASS;
    if (type === INFO) return INFO_CLASS;
    return EMPTY_STRING;
}
const miniToastr = {
    config: config,
    isInitialised: false,
    showMessage (message, title, type, timeout, cb, overrideConf) {
        const config = {};
        Object.assign(config, this.config);
        Object.assign(config, overrideConf);
        const notificationElem = makeNode();
        notificationElem.className = `${NOTIFICATION_CLASS} ${getTypeClass(type)}`;
        notificationElem.onclick = function() {
            config.animation(notificationElem, null);
        };
        if (title) addElem(notificationElem, title, TITLE_CLASS, config);
        if (config.icons[type]) createIcon(notificationElem, type, config);
        if (message) addElem(notificationElem, message, MESSAGE_CLASS, config);
        config.node.insertBefore(notificationElem, config.node.firstChild);
        setTimeout(()=>config.animation(notificationElem, cb), timeout || config.timeout);
        if (cb) cb();
        return this;
    },
    init (aConfig) {
        const newConfig = {};
        Object.assign(newConfig, config);
        Object.assign(newConfig, aConfig);
        this.config = newConfig;
        const cssStr = makeCss(newConfig.style);
        appendStyles(cssStr);
        newConfig.node.id = CONTAINER_CLASS;
        newConfig.node.className = CONTAINER_CLASS;
        newConfig.appendTarget.appendChild(newConfig.node);
        Object.keys(newConfig.types).forEach((v)=>{
            this[newConfig.types[v]] = (function(message, title, timeout, cb, config) {
                this.showMessage(message, title, newConfig.types[v], timeout, cb, config);
                return this;
            }).bind(this);
        });
        this.isInitialised = true;
        return this;
    },
    setIcon (type, nodeType = "i", attrs = []) {
        attrs.class = attrs.class ? attrs.class + " " + ICON_CLASS : ICON_CLASS;
        this.config.icons[type] = {
            nodeType: nodeType,
            attrs: attrs
        };
    }
};
var $c793d3262494b830$export$2e2bcd8739ae039 = miniToastr;

});


let $14645da86d433629$var$script;


let $14645da86d433629$var$initialize = ()=>{
    $14645da86d433629$var$script = {};
    $14645da86d433629$var$script.render = (parcelRequire("aPddG")).render;
    (parcelRequire("fXVTF")).default($14645da86d433629$var$script);
    $14645da86d433629$var$script.__scopeId = "data-v-6fc7cf";
    $14645da86d433629$var$script.__file = "App.vue";
};
$14645da86d433629$var$initialize();
var $14645da86d433629$export$2e2bcd8739ae039 = $14645da86d433629$var$script;


/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ""));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, "");
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? "element" : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(",") : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = "alert";
const $e9dd36436aec3b21$var$DATA_KEY$a = "bs.alert";
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = "button";
const $e9dd36436aec3b21$var$DATA_KEY$9 = "bs.button";
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = ".data-api";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = "swipe";
const $e9dd36436aec3b21$var$EVENT_KEY$9 = ".bs.swipe";
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = "touch";
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = "pen";
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = "carousel";
const $e9dd36436aec3b21$var$DATA_KEY$8 = "bs.carousel";
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = ".data-api";
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = "next";
const $e9dd36436aec3b21$var$ORDER_PREV = "prev";
const $e9dd36436aec3b21$var$DIRECTION_LEFT = "left";
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = "right";
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = "carousel";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = "slide";
const $e9dd36436aec3b21$var$CLASS_NAME_END = "carousel-item-end";
const $e9dd36436aec3b21$var$CLASS_NAME_START = "carousel-item-start";
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = "carousel-item-next";
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = "carousel-item-prev";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = ".active";
const $e9dd36436aec3b21$var$SELECTOR_ITEM = ".carousel-item";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = "collapse";
const $e9dd36436aec3b21$var$DATA_KEY$7 = "bs.collapse";
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = "collapse";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = "collapsing";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = "collapsed";
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $e9dd36436aec3b21$var$WIDTH = "width";
const $e9dd36436aec3b21$var$HEIGHT = "height";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = "dropdown";
const $e9dd36436aec3b21$var$DATA_KEY$6 = "bs.dropdown";
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = "Escape";
const $e9dd36436aec3b21$var$TAB_KEY$1 = "Tab";
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = "dropup";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = "dropend";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = "dropstart";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = ".navbar";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? "top-end" : "top-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? "top-start" : "top-end";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? "bottom-end" : "bottom-start";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? "bottom-start" : "bottom-end";
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? "left-start" : "right-start";
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? "right-start" : "left-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = "top";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = "backdrop";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = "show";
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = "focustrap";
const $e9dd36436aec3b21$var$DATA_KEY$5 = "bs.focustrap";
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = "Tab";
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = "forward";
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = "backward";
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $e9dd36436aec3b21$var$PROPERTY_PADDING = "padding-right";
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = "modal";
const $e9dd36436aec3b21$var$DATA_KEY$4 = "bs.modal";
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = "Escape";
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = "modal-open";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = "modal-static";
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = ".modal.show";
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = ".modal-dialog";
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = ".modal-body";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = "offcanvas";
const $e9dd36436aec3b21$var$DATA_KEY$3 = "bs.offcanvas";
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = "Escape";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = "showing";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = "hiding";
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $e9dd36436aec3b21$var$OPEN_SELECTOR = ".offcanvas.show";
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = "TemplateFactory";
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = "tooltip";
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = "modal";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = "show";
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $e9dd36436aec3b21$var$TRIGGER_HOVER = "hover";
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = "focus";
const $e9dd36436aec3b21$var$TRIGGER_CLICK = "click";
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = "manual";
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = "hide";
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = "hidden";
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = "show";
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = "shown";
const $e9dd36436aec3b21$var$EVENT_INSERTED = "inserted";
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = "click";
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = "focusin";
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = "focusout";
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = "mouseenter";
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = "mouseleave";
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $e9dd36436aec3b21$var$isRTL() ? "right" : "left"
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = "popover";
const $e9dd36436aec3b21$var$SELECTOR_TITLE = ".popover-header";
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = ".popover-body";
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = "scrollspy";
const $e9dd36436aec3b21$var$DATA_KEY$2 = "bs.scrollspy";
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = ".data-api";
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = "[href]";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = ".nav-link";
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = ".dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = "tab";
const $e9dd36436aec3b21$var$DATA_KEY$1 = "bs.tab";
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = "ArrowRight";
const $e9dd36436aec3b21$var$ARROW_UP_KEY = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = "ArrowDown";
const $e9dd36436aec3b21$var$HOME_KEY = "Home";
const $e9dd36436aec3b21$var$END_KEY = "End";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = "show";
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = "dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = "toast";
const $e9dd36436aec3b21$var$DATA_KEY = "bs.toast";
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = "showing";
const $e9dd36436aec3b21$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);





/*!
  * vue-router v4.3.2
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === "function";


const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = "plugin:settings:set";



let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}


class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2138e2947b5f69c4$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $55cc2ea2e53f2ca6$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $e0da45b668fffb6e$export$c22522a4dfa48e9c)();
    const hook = (0, $e0da45b668fffb6e$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $e0da45b668fffb6e$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $5dd8e5d828be8ae1$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


const $a809ac530d32f081$var$isBrowser = typeof document !== "undefined";
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
/**
 * Encoding Rules (␣ = Space)
 * - Path: ␣ " < > # ? { }
 * - Query: ␣ " < > # & =
 * - Hash: ␣ " < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI("" + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, "|").replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, "[").replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, "%2B").replace($a809ac530d32f081$var$ENC_SPACE_RE, "+").replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$AMPERSAND_RE, "%26").replace($a809ac530d32f081$var$ENC_BACKTICK_RE, "`").replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? "" : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: $a809ac530d32f081$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, "#") + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, "");
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error(), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$a809ac530d32f081$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $a809ac530d32f081$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $a809ac530d32f081$var$isRecordChildOf(record, child));
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $01W3b.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) return router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = $a809ac530d32f081$var$isRouteLocation((0, $01W3b.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $de8f43bece76d38a$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $a809ac530d32f081$var$RED_100;
                        textColor = $a809ac530d32f081$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("beforeEach"),
                from: $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $a809ac530d32f081$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
const $a809ac530d32f081$var$RED_100 = 0xfee2e2;
const $a809ac530d32f081$var$RED_700 = 0xb91c1c;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
            path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $a809ac530d32f081$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorListeners = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}


let $248cf7a27eb3f256$var$script;



let $248cf7a27eb3f256$var$initialize = ()=>{
    $248cf7a27eb3f256$var$script = (parcelRequire("75Mox"));
    if ($248cf7a27eb3f256$var$script.__esModule) $248cf7a27eb3f256$var$script = $248cf7a27eb3f256$var$script.default;
    $248cf7a27eb3f256$var$script.render = (parcelRequire("dBFVp")).render;
    (parcelRequire("eMOAy")).default($248cf7a27eb3f256$var$script);
    $248cf7a27eb3f256$var$script.__scopeId = "data-v-cccd63";
    $248cf7a27eb3f256$var$script.__file = "Login.vue";
};
$248cf7a27eb3f256$var$initialize();
var $248cf7a27eb3f256$export$2e2bcd8739ae039 = $248cf7a27eb3f256$var$script;


let $a8c015f47bc2f04c$var$script;



let $a8c015f47bc2f04c$var$initialize = ()=>{
    $a8c015f47bc2f04c$var$script = (parcelRequire("iHldJ"));
    if ($a8c015f47bc2f04c$var$script.__esModule) $a8c015f47bc2f04c$var$script = $a8c015f47bc2f04c$var$script.default;
    $a8c015f47bc2f04c$var$script.render = (parcelRequire("bhXij")).render;
    (parcelRequire("9ucT6")).default($a8c015f47bc2f04c$var$script);
    $a8c015f47bc2f04c$var$script.__scopeId = "data-v-b12afe";
    $a8c015f47bc2f04c$var$script.__file = "Settings.vue";
};
$a8c015f47bc2f04c$var$initialize();
var $a8c015f47bc2f04c$export$2e2bcd8739ae039 = $a8c015f47bc2f04c$var$script;


let $174b8bb734ab4162$var$script;



let $174b8bb734ab4162$var$initialize = ()=>{
    $174b8bb734ab4162$var$script = (parcelRequire("dK2mt"));
    if ($174b8bb734ab4162$var$script.__esModule) $174b8bb734ab4162$var$script = $174b8bb734ab4162$var$script.default;
    $174b8bb734ab4162$var$script.render = (parcelRequire("95Nuc")).render;
    (parcelRequire("gMLIY")).default($174b8bb734ab4162$var$script);
    $174b8bb734ab4162$var$script.__scopeId = "data-v-66dc3b";
    $174b8bb734ab4162$var$script.__file = "Tables.vue";
};
$174b8bb734ab4162$var$initialize();
var $174b8bb734ab4162$export$2e2bcd8739ae039 = $174b8bb734ab4162$var$script;


let $e7efa51bf9cf8e14$var$script;



let $e7efa51bf9cf8e14$var$initialize = ()=>{
    $e7efa51bf9cf8e14$var$script = (parcelRequire("l40YM"));
    if ($e7efa51bf9cf8e14$var$script.__esModule) $e7efa51bf9cf8e14$var$script = $e7efa51bf9cf8e14$var$script.default;
    $e7efa51bf9cf8e14$var$script.render = (parcelRequire("gSbhn")).render;
    (parcelRequire("83NLO")).default($e7efa51bf9cf8e14$var$script);
    $e7efa51bf9cf8e14$var$script.__scopeId = "data-v-a3ab5a";
    $e7efa51bf9cf8e14$var$script.__file = "Batches.vue";
};
$e7efa51bf9cf8e14$var$initialize();
var $e7efa51bf9cf8e14$export$2e2bcd8739ae039 = $e7efa51bf9cf8e14$var$script;


let $38891033ecf8c1cf$var$script;



let $38891033ecf8c1cf$var$initialize = ()=>{
    $38891033ecf8c1cf$var$script = (parcelRequire("eEd0R"));
    if ($38891033ecf8c1cf$var$script.__esModule) $38891033ecf8c1cf$var$script = $38891033ecf8c1cf$var$script.default;
    $38891033ecf8c1cf$var$script.render = (parcelRequire("8fT8l")).render;
    (parcelRequire("9pQMq")).default($38891033ecf8c1cf$var$script);
    $38891033ecf8c1cf$var$script.__scopeId = "data-v-374a8c";
    $38891033ecf8c1cf$var$script.__file = "GroupAdd.vue";
};
$38891033ecf8c1cf$var$initialize();
var $38891033ecf8c1cf$export$2e2bcd8739ae039 = $38891033ecf8c1cf$var$script;


let $0c5fe0d0c325b22b$var$script;



let $0c5fe0d0c325b22b$var$initialize = ()=>{
    $0c5fe0d0c325b22b$var$script = (parcelRequire("5mc4j"));
    if ($0c5fe0d0c325b22b$var$script.__esModule) $0c5fe0d0c325b22b$var$script = $0c5fe0d0c325b22b$var$script.default;
    $0c5fe0d0c325b22b$var$script.render = (parcelRequire("7Tdkd")).render;
    (parcelRequire("eSXPF")).default($0c5fe0d0c325b22b$var$script);
    $0c5fe0d0c325b22b$var$script.__scopeId = "data-v-4ca794";
    $0c5fe0d0c325b22b$var$script.__file = "GroupDetail.vue";
};
$0c5fe0d0c325b22b$var$initialize();
var $0c5fe0d0c325b22b$export$2e2bcd8739ae039 = $0c5fe0d0c325b22b$var$script;


let $2a4d96dc130b20f5$var$script;



let $2a4d96dc130b20f5$var$initialize = ()=>{
    $2a4d96dc130b20f5$var$script = (parcelRequire("azYLk"));
    if ($2a4d96dc130b20f5$var$script.__esModule) $2a4d96dc130b20f5$var$script = $2a4d96dc130b20f5$var$script.default;
    $2a4d96dc130b20f5$var$script.render = (parcelRequire("8F88h")).render;
    (parcelRequire("7SllT")).default($2a4d96dc130b20f5$var$script);
    $2a4d96dc130b20f5$var$script.__scopeId = "data-v-963d84";
    $2a4d96dc130b20f5$var$script.__file = "GroupList.vue";
};
$2a4d96dc130b20f5$var$initialize();
var $2a4d96dc130b20f5$export$2e2bcd8739ae039 = $2a4d96dc130b20f5$var$script;


let $0c3134a3cf9ca83b$var$script;



let $0c3134a3cf9ca83b$var$initialize = ()=>{
    $0c3134a3cf9ca83b$var$script = (parcelRequire("30lCV"));
    if ($0c3134a3cf9ca83b$var$script.__esModule) $0c3134a3cf9ca83b$var$script = $0c3134a3cf9ca83b$var$script.default;
    $0c3134a3cf9ca83b$var$script.render = (parcelRequire("9qKIT")).render;
    (parcelRequire("doVnZ")).default($0c3134a3cf9ca83b$var$script);
    $0c3134a3cf9ca83b$var$script.__scopeId = "data-v-833eb0";
    $0c3134a3cf9ca83b$var$script.__file = "UserAdd.vue";
};
$0c3134a3cf9ca83b$var$initialize();
var $0c3134a3cf9ca83b$export$2e2bcd8739ae039 = $0c3134a3cf9ca83b$var$script;


let $6cba8b9c8e68be7b$var$script;



let $6cba8b9c8e68be7b$var$initialize = ()=>{
    $6cba8b9c8e68be7b$var$script = (parcelRequire("bSAur"));
    if ($6cba8b9c8e68be7b$var$script.__esModule) $6cba8b9c8e68be7b$var$script = $6cba8b9c8e68be7b$var$script.default;
    $6cba8b9c8e68be7b$var$script.render = (parcelRequire("a8yfi")).render;
    (parcelRequire("gMcEt")).default($6cba8b9c8e68be7b$var$script);
    $6cba8b9c8e68be7b$var$script.__scopeId = "data-v-0058f0";
    $6cba8b9c8e68be7b$var$script.__file = "UserDetail.vue";
};
$6cba8b9c8e68be7b$var$initialize();
var $6cba8b9c8e68be7b$export$2e2bcd8739ae039 = $6cba8b9c8e68be7b$var$script;


let $ff85e646a198fd84$var$script;



let $ff85e646a198fd84$var$initialize = ()=>{
    $ff85e646a198fd84$var$script = (parcelRequire("h4Sdx"));
    if ($ff85e646a198fd84$var$script.__esModule) $ff85e646a198fd84$var$script = $ff85e646a198fd84$var$script.default;
    $ff85e646a198fd84$var$script.render = (parcelRequire("hhsPj")).render;
    (parcelRequire("dnh18")).default($ff85e646a198fd84$var$script);
    $ff85e646a198fd84$var$script.__scopeId = "data-v-6ab5a1";
    $ff85e646a198fd84$var$script.__file = "UserList.vue";
};
$ff85e646a198fd84$var$initialize();
var $ff85e646a198fd84$export$2e2bcd8739ae039 = $ff85e646a198fd84$var$script;



var $2tmqH = parcelRequire("2tmqH");
let $374e35e75513b153$var$script;



let $374e35e75513b153$var$initialize = ()=>{
    $374e35e75513b153$var$script = (parcelRequire("6nLKk"));
    if ($374e35e75513b153$var$script.__esModule) $374e35e75513b153$var$script = $374e35e75513b153$var$script.default;
    $374e35e75513b153$var$script.render = (parcelRequire("e74pe")).render;
    (parcelRequire("jyh5C")).default($374e35e75513b153$var$script);
    $374e35e75513b153$var$script.__scopeId = "data-v-50061a";
    $374e35e75513b153$var$script.__file = "DataSpace.vue";
};
$374e35e75513b153$var$initialize();
var $374e35e75513b153$export$2e2bcd8739ae039 = $374e35e75513b153$var$script;


let $27a19f6673f78274$var$script;



let $27a19f6673f78274$var$initialize = ()=>{
    $27a19f6673f78274$var$script = (parcelRequire("k9Hha"));
    if ($27a19f6673f78274$var$script.__esModule) $27a19f6673f78274$var$script = $27a19f6673f78274$var$script.default;
    $27a19f6673f78274$var$script.render = (parcelRequire("aAXUF")).render;
    (parcelRequire("9LSDK")).default($27a19f6673f78274$var$script);
    $27a19f6673f78274$var$script.__scopeId = "data-v-e41369";
    $27a19f6673f78274$var$script.__file = "DataSpaceLayout.vue";
};
$27a19f6673f78274$var$initialize();
var $27a19f6673f78274$export$2e2bcd8739ae039 = $27a19f6673f78274$var$script;


let $60fa11e5f5ebfa33$var$script;



let $60fa11e5f5ebfa33$var$initialize = ()=>{
    $60fa11e5f5ebfa33$var$script = (parcelRequire("3ynak"));
    if ($60fa11e5f5ebfa33$var$script.__esModule) $60fa11e5f5ebfa33$var$script = $60fa11e5f5ebfa33$var$script.default;
    $60fa11e5f5ebfa33$var$script.render = (parcelRequire("74Tqc")).render;
    (parcelRequire("cdsQ8")).default($60fa11e5f5ebfa33$var$script);
    $60fa11e5f5ebfa33$var$script.__scopeId = "data-v-93b226";
    $60fa11e5f5ebfa33$var$script.__file = "DataSpaceList.vue";
};
$60fa11e5f5ebfa33$var$initialize();
var $60fa11e5f5ebfa33$export$2e2bcd8739ae039 = $60fa11e5f5ebfa33$var$script;


let $98e1fc226d4e1d4e$var$script;



let $98e1fc226d4e1d4e$var$initialize = ()=>{
    $98e1fc226d4e1d4e$var$script = (parcelRequire("fWhQl"));
    if ($98e1fc226d4e1d4e$var$script.__esModule) $98e1fc226d4e1d4e$var$script = $98e1fc226d4e1d4e$var$script.default;
    $98e1fc226d4e1d4e$var$script.render = (parcelRequire("dNYRU")).render;
    (parcelRequire("jGVcp")).default($98e1fc226d4e1d4e$var$script);
    $98e1fc226d4e1d4e$var$script.__scopeId = "data-v-d21e47";
    $98e1fc226d4e1d4e$var$script.__file = "DataSpaceAdd.vue";
};
$98e1fc226d4e1d4e$var$initialize();
var $98e1fc226d4e1d4e$export$2e2bcd8739ae039 = $98e1fc226d4e1d4e$var$script;


let $55047fb8d3aaa558$var$script;



let $55047fb8d3aaa558$var$initialize = ()=>{
    $55047fb8d3aaa558$var$script = (parcelRequire("8R3d6"));
    if ($55047fb8d3aaa558$var$script.__esModule) $55047fb8d3aaa558$var$script = $55047fb8d3aaa558$var$script.default;
    $55047fb8d3aaa558$var$script.render = (parcelRequire("4zIj9")).render;
    (parcelRequire("dNIIN")).default($55047fb8d3aaa558$var$script);
    $55047fb8d3aaa558$var$script.__scopeId = "data-v-dca001";
    $55047fb8d3aaa558$var$script.__file = "DataSpaceDetail.vue";
};
$55047fb8d3aaa558$var$initialize();
var $55047fb8d3aaa558$export$2e2bcd8739ae039 = $55047fb8d3aaa558$var$script;


let $77135deaa4567ff3$var$script;



let $77135deaa4567ff3$var$initialize = ()=>{
    $77135deaa4567ff3$var$script = (parcelRequire("3DPp2"));
    if ($77135deaa4567ff3$var$script.__esModule) $77135deaa4567ff3$var$script = $77135deaa4567ff3$var$script.default;
    $77135deaa4567ff3$var$script.render = (parcelRequire("kcVnV")).render;
    (parcelRequire("cq6vQ")).default($77135deaa4567ff3$var$script);
    $77135deaa4567ff3$var$script.__scopeId = "data-v-419b5f";
    $77135deaa4567ff3$var$script.__file = "DataBatchDetail.vue";
};
$77135deaa4567ff3$var$initialize();
var $77135deaa4567ff3$export$2e2bcd8739ae039 = $77135deaa4567ff3$var$script;


const $060fe58cae938b62$var$routes = [
    {
        path: "/",
        name: "Login",
        component: (0, $248cf7a27eb3f256$export$2e2bcd8739ae039)
    },
    {
        path: "/dataspaces",
        name: "DataSpaces",
        component: (0, $374e35e75513b153$export$2e2bcd8739ae039)
    },
    {
        path: "/dataspace/:id",
        component: (0, $27a19f6673f78274$export$2e2bcd8739ae039),
        props: true,
        children: [
            {
                path: "",
                name: "dataspace",
                redirect: (to)=>`/dataspace/${to.params.id}/tables`
            },
            {
                path: "tables",
                name: "tables",
                component: (0, $174b8bb734ab4162$export$2e2bcd8739ae039)
            },
            {
                path: "batches",
                name: "batches",
                component: (0, $e7efa51bf9cf8e14$export$2e2bcd8739ae039)
            },
            {
                path: "batches/:batchId",
                name: "batchDetail",
                component: (0, $77135deaa4567ff3$export$2e2bcd8739ae039)
            }
        ]
    },
    //ADMIN - SETTINGS
    {
        path: "/dataspaceadd",
        name: "dataspaceadd",
        component: (0, $98e1fc226d4e1d4e$export$2e2bcd8739ae039)
    },
    {
        path: "/dataspacedetail/:id",
        name: "dataspacedetail",
        component: (0, $55047fb8d3aaa558$export$2e2bcd8739ae039),
        props: true
    },
    {
        path: "/groupadd",
        name: "groupadd",
        component: (0, $38891033ecf8c1cf$export$2e2bcd8739ae039)
    },
    {
        path: "/groupdetail/:id",
        name: "groupdetail",
        component: (0, $0c5fe0d0c325b22b$export$2e2bcd8739ae039),
        props: true
    },
    {
        path: "/userdetail/:id",
        name: "userdetail",
        component: (0, $6cba8b9c8e68be7b$export$2e2bcd8739ae039),
        props: true
    },
    {
        path: "/useradd",
        name: "useradd",
        component: (0, $0c3134a3cf9ca83b$export$2e2bcd8739ae039)
    },
    {
        path: "/settings",
        name: "settings",
        component: (0, $a8c015f47bc2f04c$export$2e2bcd8739ae039),
        props: true,
        children: [
            {
                path: "users",
                name: "users",
                component: (0, $ff85e646a198fd84$export$2e2bcd8739ae039)
            },
            {
                path: "groups",
                name: "groups",
                component: (0, $2a4d96dc130b20f5$export$2e2bcd8739ae039)
            },
            {
                path: "dataspaces",
                name: "dataspaces",
                component: (0, $60fa11e5f5ebfa33$export$2e2bcd8739ae039)
            }
        ]
    }
];
const $060fe58cae938b62$var$router = (0, $a809ac530d32f081$export$baddd0131ee8c05b)({
    history: (0, $a809ac530d32f081$export$542bc3a76486c94d)(),
    routes: $060fe58cae938b62$var$routes
});
$060fe58cae938b62$var$router.beforeEach(async (to, from, next)=>{
    var auth = await (0, $2tmqH.default).auth();
    if (to.name !== "Login" && !auth.isAuthenticated) next({
        name: "Login",
        query: {
            returnUrl: to.fullPath
        }
    });
    else next();
});
if (!window.indexedDB) console.log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
var $060fe58cae938b62$export$2e2bcd8739ae039 = $060fe58cae938b62$var$router;


var $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES;
(function(DEFAULT_MESSAGE_TYPES) {
    DEFAULT_MESSAGE_TYPES["error"] = "error";
    DEFAULT_MESSAGE_TYPES["warn"] = "warn";
    DEFAULT_MESSAGE_TYPES["info"] = "info";
    DEFAULT_MESSAGE_TYPES["success"] = "success";
})($0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES || ($0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES = {}));
const $0b901d553092e5c6$var$VueNotifications = {
    types: {
        error: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.error,
        warn: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.warn,
        info: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.info,
        success: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.success
    },
    propertyName: "notifications",
    config: {
        type: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.info,
        timeout: 3000
    },
    pluginOptions: {},
    installed: false,
    install (vueConstructor, pluginOptions) {
        if (this.installed) throw console.error("VueNotifications: plugin already installed");
        const mixin = $0b901d553092e5c6$var$makeMixin();
        vueConstructor.mixin(mixin);
        this.setPluginOptions(pluginOptions);
        this.installed = true;
    },
    setPluginOptions (pluginOptions) {
        this.pluginOptions = pluginOptions;
    }
};
function $0b901d553092e5c6$var$getValues(config, vueApp) {
    let result = {
        type: $0b901d553092e5c6$var$DEFAULT_MESSAGE_TYPES.info
    };
    Object.keys(config).forEach((field)=>{
        if (field === "cb") result = {
            ...result,
            [field]: config[field].bind(vueApp)
        };
        else result = {
            ...result,
            [field]: typeof config[field] === "function" ? config[field].call(vueApp) : config[field]
        };
    });
    return result;
}
function $0b901d553092e5c6$var$showMessage(config, vueApp) {
    const valuesObj = $0b901d553092e5c6$var$getValues(config, vueApp);
    const isMethodOverridden = $0b901d553092e5c6$var$VueNotifications.pluginOptions[valuesObj.type];
    const method = isMethodOverridden ? $0b901d553092e5c6$var$VueNotifications.pluginOptions[valuesObj.type] : console.log;
    method(valuesObj, vueApp);
    if (config.cb) config.cb();
}
function $0b901d553092e5c6$var$setMethod(vueApp, name, componentOptions) {
    let { methods: methods } = componentOptions;
    if (!methods) methods = {};
    if (!methods[name]) methods[name] = $0b901d553092e5c6$var$makeMethod(vueApp, name, componentOptions);
    else console.warn(`VueNotifications: trying to create method which is already exist: ${name}`);
}
function $0b901d553092e5c6$var$makeMethod(vueApp, methodName, componentOptions) {
    return (config)=>{
        // TODO (S.Panfilov) 'componentOptions' is an extended 'ComponentOptions' with our 'VueNotifications.propertyName'
        const pluginOptions = componentOptions[$0b901d553092e5c6$var$VueNotifications.propertyName];
        const methodConfig = pluginOptions ? pluginOptions[methodName] : {};
        const newConfig = {
            ...$0b901d553092e5c6$var$VueNotifications.config,
            ...methodConfig,
            ...config
        };
        $0b901d553092e5c6$var$showMessage(newConfig, vueApp);
    };
}
function $0b901d553092e5c6$var$initVueNotificationPlugin(vueApp, notifications) {
    if (!notifications) return;
    Object.keys(notifications).forEach((name)=>$0b901d553092e5c6$var$setMethod(vueApp, name, vueApp.$options));
    vueApp.$emit("vue-notifications-initiated");
}
function $0b901d553092e5c6$var$unlinkVueNotificationPlugin(vueApp, notifications) {
    if (!notifications) return;
    const { methods: methods } = vueApp.$options;
    if (!methods) return;
    Object.keys(notifications).forEach((name)=>{
        if (methods[name]) {
            methods[name] = undefined;
            delete methods[name];
        }
    });
    vueApp.$emit("vue-notifications-unlinked");
}
function $0b901d553092e5c6$var$makeMixin() {
    return {
        beforeCreate () {
            const notificationsField = this.$options[$0b901d553092e5c6$var$VueNotifications.propertyName];
            if (notificationsField) $0b901d553092e5c6$var$initVueNotificationPlugin(this, notificationsField);
        },
        beforeDestroy: function() {
            const notificationsField = this.$options[$0b901d553092e5c6$var$VueNotifications.propertyName];
            $0b901d553092e5c6$var$unlinkVueNotificationPlugin(this, notificationsField);
        }
    };
}
if (typeof window !== "undefined" && window.Vue) window.Vue.use($0b901d553092e5c6$var$VueNotifications);
var $0b901d553092e5c6$export$2e2bcd8739ae039 = $0b901d553092e5c6$var$VueNotifications;


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $a0ff767aa05ebc8a$var$ei(_) {
    return _ && _.__esModule && Object.prototype.hasOwnProperty.call(_, "default") ? _.default : _;
}
var $a0ff767aa05ebc8a$var$Ue = {
    exports: {}
};
/*!
 * ApexCharts v3.45.2
 * (c) 2018-2024 ApexCharts
 * Released under the MIT License.
 */ (function(_, Re) {
    function Ae(y, e) {
        var t = Object.keys(y);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(y);
            e && (i = i.filter(function(a) {
                return Object.getOwnPropertyDescriptor(y, a).enumerable;
            })), t.push.apply(t, i);
        }
        return t;
    }
    function X(y) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e] != null ? arguments[e] : {};
            e % 2 ? Ae(Object(t), !0).forEach(function(i) {
                ee(y, i, t[i]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(t)) : Ae(Object(t)).forEach(function(i) {
                Object.defineProperty(y, i, Object.getOwnPropertyDescriptor(t, i));
            });
        }
        return y;
    }
    function U(y) {
        return U = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
            return typeof e;
        } : function(e) {
            return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, U(y);
    }
    function F(y, e) {
        if (!(y instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function ce(y, e) {
        for(var t = 0; t < e.length; t++){
            var i = e[t];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(y, i.key, i);
        }
    }
    function Y(y, e, t) {
        return e && ce(y.prototype, e), t && ce(y, t), y;
    }
    function ee(y, e, t) {
        return e in y ? Object.defineProperty(y, e, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : y[e] = t, y;
    }
    function ge(y, e) {
        if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
        y.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: y,
                writable: !0,
                configurable: !0
            }
        }), e && Se(y, e);
    }
    function me(y) {
        return me = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, me(y);
    }
    function Se(y, e) {
        return Se = Object.setPrototypeOf || function(t, i) {
            return t.__proto__ = i, t;
        }, Se(y, e);
    }
    function ze(y) {
        if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return y;
    }
    function ue(y) {
        var e = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch  {
                return !1;
            }
        }();
        return function() {
            var t, i = me(y);
            if (e) {
                var a = me(this).constructor;
                t = Reflect.construct(i, arguments, a);
            } else t = i.apply(this, arguments);
            return function(s, r) {
                if (r && (typeof r == "object" || typeof r == "function")) return r;
                if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                return ze(s);
            }(this, t);
        };
    }
    function Me(y, e) {
        return function(t) {
            if (Array.isArray(t)) return t;
        }(y) || function(t, i) {
            var a = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
            if (a != null) {
                var s, r, n = [], o = !0, h = !1;
                try {
                    for(a = a.call(t); !(o = (s = a.next()).done) && (n.push(s.value), !i || n.length !== i); o = !0);
                } catch (c) {
                    h = !0, r = c;
                } finally{
                    try {
                        o || a.return == null || a.return();
                    } finally{
                        if (h) throw r;
                    }
                }
                return n;
            }
        }(y, e) || Xe(y, e) || function() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
    }
    function J(y) {
        return function(e) {
            if (Array.isArray(e)) return Ce(e);
        }(y) || function(e) {
            if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
        }(y) || Xe(y) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
    }
    function Xe(y, e) {
        if (y) {
            if (typeof y == "string") return Ce(y, e);
            var t = Object.prototype.toString.call(y).slice(8, -1);
            return t === "Object" && y.constructor && (t = y.constructor.name), t === "Map" || t === "Set" ? Array.from(y) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Ce(y, e) : void 0;
        }
    }
    function Ce(y, e) {
        (e == null || e > y.length) && (e = y.length);
        for(var t = 0, i = new Array(e); t < e; t++)i[t] = y[t];
        return i;
    }
    var P = function() {
        function y() {
            F(this, y);
        }
        return Y(y, [
            {
                key: "shadeRGBColor",
                value: function(e, t) {
                    var i = t.split(","), a = e < 0 ? 0 : 255, s = e < 0 ? -1 * e : e, r = parseInt(i[0].slice(4), 10), n = parseInt(i[1], 10), o = parseInt(i[2], 10);
                    return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - n) * s) + n) + "," + (Math.round((a - o) * s) + o) + ")";
                }
            },
            {
                key: "shadeHexColor",
                value: function(e, t) {
                    var i = parseInt(t.slice(1), 16), a = e < 0 ? 0 : 255, s = e < 0 ? -1 * e : e, r = i >> 16, n = i >> 8 & 255, o = 255 & i;
                    return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - n) * s) + n) + (Math.round((a - o) * s) + o)).toString(16).slice(1);
                }
            },
            {
                key: "shadeColor",
                value: function(e, t) {
                    return y.isColorHex(t) ? this.shadeHexColor(e, t) : this.shadeRGBColor(e, t);
                }
            }
        ], [
            {
                key: "bind",
                value: function(e, t) {
                    return function() {
                        return e.apply(t, arguments);
                    };
                }
            },
            {
                key: "isObject",
                value: function(e) {
                    return e && U(e) === "object" && !Array.isArray(e) && e != null;
                }
            },
            {
                key: "is",
                value: function(e, t) {
                    return Object.prototype.toString.call(t) === "[object " + e + "]";
                }
            },
            {
                key: "listToArray",
                value: function(e) {
                    var t, i = [];
                    for(t = 0; t < e.length; t++)i[t] = e[t];
                    return i;
                }
            },
            {
                key: "extend",
                value: function(e, t) {
                    var i = this;
                    typeof Object.assign != "function" && (Object.assign = function(s) {
                        if (s == null) throw new TypeError("Cannot convert undefined or null to object");
                        for(var r = Object(s), n = 1; n < arguments.length; n++){
                            var o = arguments[n];
                            if (o != null) for(var h in o)o.hasOwnProperty(h) && (r[h] = o[h]);
                        }
                        return r;
                    });
                    var a = Object.assign({}, e);
                    return this.isObject(e) && this.isObject(t) && Object.keys(t).forEach(function(s) {
                        i.isObject(t[s]) && s in e ? a[s] = i.extend(e[s], t[s]) : Object.assign(a, ee({}, s, t[s]));
                    }), a;
                }
            },
            {
                key: "extendArray",
                value: function(e, t) {
                    var i = [];
                    return e.map(function(a) {
                        i.push(y.extend(t, a));
                    }), e = i;
                }
            },
            {
                key: "monthMod",
                value: function(e) {
                    return e % 12;
                }
            },
            {
                key: "clone",
                value: function(e) {
                    if (y.is("Array", e)) {
                        for(var t = [], i = 0; i < e.length; i++)t[i] = this.clone(e[i]);
                        return t;
                    }
                    if (y.is("Null", e)) return null;
                    if (y.is("Date", e)) return e;
                    if (U(e) === "object") {
                        var a = {};
                        for(var s in e)e.hasOwnProperty(s) && (a[s] = this.clone(e[s]));
                        return a;
                    }
                    return e;
                }
            },
            {
                key: "log10",
                value: function(e) {
                    return Math.log(e) / Math.LN10;
                }
            },
            {
                key: "roundToBase10",
                value: function(e) {
                    return Math.pow(10, Math.floor(Math.log10(e)));
                }
            },
            {
                key: "roundToBase",
                value: function(e, t) {
                    return Math.pow(t, Math.floor(Math.log(e) / Math.log(t)));
                }
            },
            {
                key: "parseNumber",
                value: function(e) {
                    return e === null ? e : parseFloat(e);
                }
            },
            {
                key: "stripNumber",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
                    return Number.isInteger(e) ? e : parseFloat(e.toPrecision(t));
                }
            },
            {
                key: "randomId",
                value: function() {
                    return (Math.random() + 1).toString(36).substring(4);
                }
            },
            {
                key: "noExponents",
                value: function(e) {
                    var t = String(e).split(/[eE]/);
                    if (t.length === 1) return t[0];
                    var i = "", a = e < 0 ? "-" : "", s = t[0].replace(".", ""), r = Number(t[1]) + 1;
                    if (r < 0) {
                        for(i = a + "0."; r++;)i += "0";
                        return i + s.replace(/^-/, "");
                    }
                    for(r -= s.length; r--;)i += "0";
                    return s + i;
                }
            },
            {
                key: "getDimensions",
                value: function(e) {
                    var t = getComputedStyle(e, null), i = e.clientHeight, a = e.clientWidth;
                    return i -= parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), [
                        a -= parseFloat(t.paddingLeft) + parseFloat(t.paddingRight),
                        i
                    ];
                }
            },
            {
                key: "getBoundingClientRect",
                value: function(e) {
                    var t = e.getBoundingClientRect();
                    return {
                        top: t.top,
                        right: t.right,
                        bottom: t.bottom,
                        left: t.left,
                        width: e.clientWidth,
                        height: e.clientHeight,
                        x: t.left,
                        y: t.top
                    };
                }
            },
            {
                key: "getLargestStringFromArr",
                value: function(e) {
                    return e.reduce(function(t, i) {
                        return Array.isArray(i) && (i = i.reduce(function(a, s) {
                            return a.length > s.length ? a : s;
                        })), t.length > i.length ? t : i;
                    }, 0);
                }
            },
            {
                key: "hexToRgba",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#999999", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.6;
                    e.substring(0, 1) !== "#" && (e = "#999999");
                    var i = e.replace("#", "");
                    i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                    for(var a = 0; a < i.length; a++)i[a] = parseInt(i[a].length === 1 ? i[a] + i[a] : i[a], 16);
                    return t !== void 0 && i.push(t), "rgba(" + i.join(",") + ")";
                }
            },
            {
                key: "getOpacityFromRGBA",
                value: function(e) {
                    return parseFloat(e.replace(/^.*,(.+)\)/, "$1"));
                }
            },
            {
                key: "rgb2hex",
                value: function(e) {
                    return (e = e.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && e.length === 4 ? "#" + ("0" + parseInt(e[1], 10).toString(16)).slice(-2) + ("0" + parseInt(e[2], 10).toString(16)).slice(-2) + ("0" + parseInt(e[3], 10).toString(16)).slice(-2) : "";
                }
            },
            {
                key: "isColorHex",
                value: function(e) {
                    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(e);
                }
            },
            {
                key: "getPolygonPos",
                value: function(e, t) {
                    for(var i = [], a = 2 * Math.PI / t, s = 0; s < t; s++){
                        var r = {};
                        r.x = e * Math.sin(s * a), r.y = -e * Math.cos(s * a), i.push(r);
                    }
                    return i;
                }
            },
            {
                key: "polarToCartesian",
                value: function(e, t, i, a) {
                    var s = (a - 90) * Math.PI / 180;
                    return {
                        x: e + i * Math.cos(s),
                        y: t + i * Math.sin(s)
                    };
                }
            },
            {
                key: "escapeString",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", i = e.toString().slice();
                    return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, t);
                }
            },
            {
                key: "negToZero",
                value: function(e) {
                    return e < 0 ? 0 : e;
                }
            },
            {
                key: "moveIndexInArray",
                value: function(e, t, i) {
                    if (i >= e.length) for(var a = i - e.length + 1; a--;)e.push(void 0);
                    return e.splice(i, 0, e.splice(t, 1)[0]), e;
                }
            },
            {
                key: "extractNumber",
                value: function(e) {
                    return parseFloat(e.replace(/[^\d.]*/g, ""));
                }
            },
            {
                key: "findAncestor",
                value: function(e, t) {
                    for(; (e = e.parentElement) && !e.classList.contains(t););
                    return e;
                }
            },
            {
                key: "setELstyles",
                value: function(e, t) {
                    for(var i in t)t.hasOwnProperty(i) && (e.style.key = t[i]);
                }
            },
            {
                key: "isNumber",
                value: function(e) {
                    return !isNaN(e) && parseFloat(Number(e)) === e && !isNaN(parseInt(e, 10));
                }
            },
            {
                key: "isFloat",
                value: function(e) {
                    return Number(e) === e && e % 1 != 0;
                }
            },
            {
                key: "isSafari",
                value: function() {
                    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                }
            },
            {
                key: "isFirefox",
                value: function() {
                    return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                }
            },
            {
                key: "isIE11",
                value: function() {
                    if (window.navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.appVersion.indexOf("Trident/") > -1) return !0;
                }
            },
            {
                key: "isIE",
                value: function() {
                    var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
                    if (t > 0) return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
                    if (e.indexOf("Trident/") > 0) {
                        var i = e.indexOf("rv:");
                        return parseInt(e.substring(i + 3, e.indexOf(".", i)), 10);
                    }
                    var a = e.indexOf("Edge/");
                    return a > 0 && parseInt(e.substring(a + 5, e.indexOf(".", a)), 10);
                }
            }
        ]), y;
    }(), de = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.setEasingFunctions();
        }
        return Y(y, [
            {
                key: "setEasingFunctions",
                value: function() {
                    var e;
                    if (!this.w.globals.easing) {
                        switch(this.w.config.chart.animations.easing){
                            case "linear":
                                e = "-";
                                break;
                            case "easein":
                                e = "<";
                                break;
                            case "easeout":
                                e = ">";
                                break;
                            case "easeinout":
                            default:
                                e = "<>";
                                break;
                            case "swing":
                                e = function(t) {
                                    var i = 1.70158;
                                    return (t -= 1) * t * ((i + 1) * t + i) + 1;
                                };
                                break;
                            case "bounce":
                                e = function(t) {
                                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
                                };
                                break;
                            case "elastic":
                                e = function(t) {
                                    return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - 0.075) * (2 * Math.PI) / 0.3) + 1;
                                };
                        }
                        this.w.globals.easing = e;
                    }
                }
            },
            {
                key: "animateLine",
                value: function(e, t, i, a) {
                    e.attr(t).animate(a).attr(i);
                }
            },
            {
                key: "animateMarker",
                value: function(e, t, i, a, s, r) {
                    t || (t = 0), e.attr({
                        r: t,
                        width: t,
                        height: t
                    }).animate(a, s).attr({
                        r: i,
                        width: i.width,
                        height: i.height
                    }).afterAll(function() {
                        r();
                    });
                }
            },
            {
                key: "animateCircle",
                value: function(e, t, i, a, s) {
                    e.attr({
                        r: t.r,
                        cx: t.cx,
                        cy: t.cy
                    }).animate(a, s).attr({
                        r: i.r,
                        cx: i.cx,
                        cy: i.cy
                    });
                }
            },
            {
                key: "animateRect",
                value: function(e, t, i, a, s) {
                    e.attr(t).animate(a).attr(i).afterAll(function() {
                        return s();
                    });
                }
            },
            {
                key: "animatePathsGradually",
                value: function(e) {
                    var t = e.el, i = e.realIndex, a = e.j, s = e.fill, r = e.pathFrom, n = e.pathTo, o = e.speed, h = e.delay, c = this.w, d = 0;
                    c.config.chart.animations.animateGradually.enabled && (d = c.config.chart.animations.animateGradually.delay), c.config.chart.animations.dynamicAnimation.enabled && c.globals.dataChanged && c.config.chart.type !== "bar" && (d = 0), this.morphSVG(t, i, a, c.config.chart.type !== "line" || c.globals.comboCharts ? s : "stroke", r, n, o, h * d);
                }
            },
            {
                key: "showDelayedElements",
                value: function() {
                    this.w.globals.delayedElements.forEach(function(e) {
                        var t = e.el;
                        t.classList.remove("apexcharts-element-hidden"), t.classList.add("apexcharts-hidden-element-shown");
                    });
                }
            },
            {
                key: "animationCompleted",
                value: function(e) {
                    var t = this.w;
                    t.globals.animationEnded || (t.globals.animationEnded = !0, this.showDelayedElements(), typeof t.config.chart.events.animationEnd == "function" && t.config.chart.events.animationEnd(this.ctx, {
                        el: e,
                        w: t
                    }));
                }
            },
            {
                key: "morphSVG",
                value: function(e, t, i, a, s, r, n, o) {
                    var h = this, c = this.w;
                    s || (s = e.attr("pathFrom")), r || (r = e.attr("pathTo"));
                    var d = function(g) {
                        return c.config.chart.type === "radar" && (n = 1), "M 0 ".concat(c.globals.gridHeight);
                    };
                    (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = d()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = d()), c.globals.shouldAnimate || (n = 1), e.plot(s).animate(1, c.globals.easing, o).plot(s).animate(n, c.globals.easing, o).plot(r).afterAll(function() {
                        P.isNumber(i) ? i === c.globals.series[c.globals.maxValsInArrayIndex].length - 2 && c.globals.shouldAnimate && h.animationCompleted(e) : a !== "none" && c.globals.shouldAnimate && (!c.globals.comboCharts && t === c.globals.series.length - 1 || c.globals.comboCharts) && h.animationCompleted(e), h.showDelayedElements();
                    });
                }
            }
        ]), y;
    }(), Z = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "getDefaultFilter",
                value: function(e, t) {
                    var i = this.w;
                    e.unfilter(!0), new window.SVG.Filter().size("120%", "180%", "-5%", "-40%"), i.config.states.normal.filter !== "none" ? this.applyFilter(e, t, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(e, i.config.chart.dropShadow, t);
                }
            },
            {
                key: "addNormalFilter",
                value: function(e, t) {
                    var i = this.w;
                    i.config.chart.dropShadow.enabled && !e.node.classList.contains("apexcharts-marker") && this.dropShadow(e, i.config.chart.dropShadow, t);
                }
            },
            {
                key: "addLightenFilter",
                value: function(e, t, i) {
                    var a = this, s = this.w, r = i.intensity;
                    e.unfilter(!0), new window.SVG.Filter(), e.filter(function(n) {
                        var o = s.config.chart.dropShadow;
                        (o.enabled ? a.addShadow(n, t, o) : n).componentTransfer({
                            rgb: {
                                type: "linear",
                                slope: 1.5,
                                intercept: r
                            }
                        });
                    }), e.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(e.filterer.node);
                }
            },
            {
                key: "addDarkenFilter",
                value: function(e, t, i) {
                    var a = this, s = this.w, r = i.intensity;
                    e.unfilter(!0), new window.SVG.Filter(), e.filter(function(n) {
                        var o = s.config.chart.dropShadow;
                        (o.enabled ? a.addShadow(n, t, o) : n).componentTransfer({
                            rgb: {
                                type: "linear",
                                slope: r
                            }
                        });
                    }), e.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(e.filterer.node);
                }
            },
            {
                key: "applyFilter",
                value: function(e, t, i) {
                    var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
                    switch(i){
                        case "none":
                            this.addNormalFilter(e, t);
                            break;
                        case "lighten":
                            this.addLightenFilter(e, t, {
                                intensity: a
                            });
                            break;
                        case "darken":
                            this.addDarkenFilter(e, t, {
                                intensity: a
                            });
                    }
                }
            },
            {
                key: "addShadow",
                value: function(e, t, i) {
                    var a = i.blur, s = i.top, r = i.left, n = i.color, o = i.opacity, h = e.flood(Array.isArray(n) ? n[t] : n, o).composite(e.sourceAlpha, "in").offset(r, s).gaussianBlur(a).merge(e.source);
                    return e.blend(e.source, h);
                }
            },
            {
                key: "dropShadow",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = t.top, s = t.left, r = t.blur, n = t.color, o = t.opacity, h = t.noUserSpaceOnUse, c = this.w;
                    return e.unfilter(!0), P.isIE() && c.config.chart.type === "radialBar" || (n = Array.isArray(n) ? n[i] : n, e.filter(function(d) {
                        var g = null;
                        g = P.isSafari() || P.isFirefox() || P.isIE() ? d.flood(n, o).composite(d.sourceAlpha, "in").offset(s, a).gaussianBlur(r) : d.flood(n, o).composite(d.sourceAlpha, "in").offset(s, a).gaussianBlur(r).merge(d.source), d.blend(d.source, g);
                    }), h || e.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(e.filterer.node)), e;
                }
            },
            {
                key: "setSelectionFilter",
                value: function(e, t, i) {
                    var a = this.w;
                    if (a.globals.selectedDataPoints[t] !== void 0 && a.globals.selectedDataPoints[t].indexOf(i) > -1) {
                        e.node.setAttribute("selected", !0);
                        var s = a.config.states.active.filter;
                        s !== "none" && this.applyFilter(e, t, s.type, s.value);
                    }
                }
            },
            {
                key: "_scaleFilterSize",
                value: function(e) {
                    (function(t) {
                        for(var i in t)t.hasOwnProperty(i) && e.setAttribute(i, t[i]);
                    })({
                        width: "200%",
                        height: "200%",
                        x: "-50%",
                        y: "-50%"
                    });
                }
            }
        ]), y;
    }(), M = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "roundPathCorners",
                value: function(e, t) {
                    function i(S, C, L) {
                        var I = C.x - S.x, z = C.y - S.y, T = Math.sqrt(I * I + z * z);
                        return a(S, C, Math.min(1, L / T));
                    }
                    function a(S, C, L) {
                        return {
                            x: S.x + (C.x - S.x) * L,
                            y: S.y + (C.y - S.y) * L
                        };
                    }
                    function s(S, C) {
                        S.length > 2 && (S[S.length - 2] = C.x, S[S.length - 1] = C.y);
                    }
                    function r(S) {
                        return {
                            x: parseFloat(S[S.length - 2]),
                            y: parseFloat(S[S.length - 1])
                        };
                    }
                    e.indexOf("NaN") > -1 && (e = "");
                    var n = e.split(/[,\s]/).reduce(function(S, C) {
                        var L = C.match("([a-zA-Z])(.+)");
                        return L ? (S.push(L[1]), S.push(L[2])) : S.push(C), S;
                    }, []).reduce(function(S, C) {
                        return parseFloat(C) == C && S.length ? S[S.length - 1].push(C) : S.push([
                            C
                        ]), S;
                    }, []), o = [];
                    if (n.length > 1) {
                        var h = r(n[0]), c = null;
                        n[n.length - 1][0] == "Z" && n[0].length > 2 && (c = [
                            "L",
                            h.x,
                            h.y
                        ], n[n.length - 1] = c), o.push(n[0]);
                        for(var d = 1; d < n.length; d++){
                            var g = o[o.length - 1], p = n[d], f = p == c ? n[1] : n[d + 1];
                            if (f && g && g.length > 2 && p[0] == "L" && f.length > 2 && f[0] == "L") {
                                var b, m, w = r(g), A = r(p), l = r(f);
                                b = i(A, w, t), m = i(A, l, t), s(p, b), p.origPoint = A, o.push(p);
                                var u = a(b, A, 0.5), x = a(A, m, 0.5), v = [
                                    "C",
                                    u.x,
                                    u.y,
                                    x.x,
                                    x.y,
                                    m.x,
                                    m.y
                                ];
                                v.origPoint = A, o.push(v);
                            } else o.push(p);
                        }
                        if (c) {
                            var k = r(o[o.length - 1]);
                            o.push([
                                "Z"
                            ]), s(o[0], k);
                        }
                    } else o = n;
                    return o.reduce(function(S, C) {
                        return S + C.join(" ") + " ";
                    }, "");
                }
            },
            {
                key: "drawLine",
                value: function(e, t, i, a) {
                    var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "butt";
                    return this.w.globals.dom.Paper.line().attr({
                        x1: e,
                        y1: t,
                        x2: i,
                        y2: a,
                        stroke: s,
                        "stroke-dasharray": r,
                        "stroke-width": n,
                        "stroke-linecap": o
                    });
                }
            },
            {
                key: "drawRect",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "#fefefe", n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, o = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, h = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null, c = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : 0, d = this.w.globals.dom.Paper.rect();
                    return d.attr({
                        x: e,
                        y: t,
                        width: i > 0 ? i : 0,
                        height: a > 0 ? a : 0,
                        rx: s,
                        ry: s,
                        opacity: n,
                        "stroke-width": o !== null ? o : 0,
                        stroke: h !== null ? h : "none",
                        "stroke-dasharray": c
                    }), d.node.setAttribute("fill", r), d;
                }
            },
            {
                key: "drawPolygon",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "none";
                    return this.w.globals.dom.Paper.polygon(e).attr({
                        fill: a,
                        stroke: t,
                        "stroke-width": i
                    });
                }
            },
            {
                key: "drawCircle",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    e < 0 && (e = 0);
                    var i = this.w.globals.dom.Paper.circle(2 * e);
                    return t !== null && i.attr(t), i;
                }
            },
            {
                key: "drawPath",
                value: function(e) {
                    var t = e.d, i = t === void 0 ? "" : t, a = e.stroke, s = a === void 0 ? "#a8a8a8" : a, r = e.strokeWidth, n = r === void 0 ? 1 : r, o = e.fill, h = e.fillOpacity, c = h === void 0 ? 1 : h, d = e.strokeOpacity, g = d === void 0 ? 1 : d, p = e.classes, f = e.strokeLinecap, b = f === void 0 ? null : f, m = e.strokeDashArray, w = m === void 0 ? 0 : m, A = this.w;
                    return b === null && (b = A.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(A.globals.gridHeight)), A.globals.dom.Paper.path(i).attr({
                        fill: o,
                        "fill-opacity": c,
                        stroke: s,
                        "stroke-opacity": g,
                        "stroke-linecap": b,
                        "stroke-width": n,
                        "stroke-dasharray": w,
                        class: p
                    });
                }
            },
            {
                key: "group",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = this.w.globals.dom.Paper.group();
                    return e !== null && t.attr(e), t;
                }
            },
            {
                key: "move",
                value: function(e, t) {
                    var i = [
                        "M",
                        e,
                        t
                    ].join(" ");
                    return i;
                }
            },
            {
                key: "line",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = null;
                    return i === null ? a = [
                        " L",
                        e,
                        t
                    ].join(" ") : i === "H" ? a = [
                        " H",
                        e
                    ].join(" ") : i === "V" && (a = [
                        " V",
                        t
                    ].join(" ")), a;
                }
            },
            {
                key: "curve",
                value: function(e, t, i, a, s, r) {
                    var n = [
                        "C",
                        e,
                        t,
                        i,
                        a,
                        s,
                        r
                    ].join(" ");
                    return n;
                }
            },
            {
                key: "quadraticCurve",
                value: function(e, t, i, a) {
                    return [
                        "Q",
                        e,
                        t,
                        i,
                        a
                    ].join(" ");
                }
            },
            {
                key: "arc",
                value: function(e, t, i, a, s, r, n) {
                    var o = "A";
                    arguments.length > 7 && arguments[7] !== void 0 && arguments[7] && (o = "a");
                    var h = [
                        o,
                        e,
                        t,
                        i,
                        a,
                        s,
                        r,
                        n
                    ].join(" ");
                    return h;
                }
            },
            {
                key: "renderPaths",
                value: function(e) {
                    var t, i = e.j, a = e.realIndex, s = e.pathFrom, r = e.pathTo, n = e.stroke, o = e.strokeWidth, h = e.strokeLinecap, c = e.fill, d = e.animationDelay, g = e.initialSpeed, p = e.dataChangeSpeed, f = e.className, b = e.shouldClipToGrid, m = b === void 0 || b, w = e.bindEventsOnPaths, A = w === void 0 || w, l = e.drawShadow, u = l === void 0 || l, x = this.w, v = new Z(this.ctx), k = new de(this.ctx), S = this.w.config.chart.animations.enabled, C = S && this.w.config.chart.animations.dynamicAnimation.enabled, L = !!(S && !x.globals.resized || C && x.globals.dataChanged && x.globals.shouldAnimate);
                    L ? t = s : (t = r, x.globals.animationEnded = !0);
                    var I = x.config.stroke.dashArray, z = 0;
                    z = Array.isArray(I) ? I[a] : x.config.stroke.dashArray;
                    var T = this.drawPath({
                        d: t,
                        stroke: n,
                        strokeWidth: o,
                        fill: c,
                        fillOpacity: 1,
                        classes: f,
                        strokeLinecap: h,
                        strokeDashArray: z
                    });
                    if (T.attr("index", a), m && T.attr({
                        "clip-path": "url(#gridRectMask".concat(x.globals.cuid, ")")
                    }), x.config.states.normal.filter.type !== "none") v.getDefaultFilter(T, a);
                    else if (x.config.chart.dropShadow.enabled && u && (!x.config.chart.dropShadow.enabledOnSeries || x.config.chart.dropShadow.enabledOnSeries && x.config.chart.dropShadow.enabledOnSeries.indexOf(a) !== -1)) {
                        var E = x.config.chart.dropShadow;
                        v.dropShadow(T, E, a);
                    }
                    A && (T.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, T)), T.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, T)), T.node.addEventListener("mousedown", this.pathMouseDown.bind(this, T))), T.attr({
                        pathTo: r,
                        pathFrom: s
                    });
                    var R = {
                        el: T,
                        j: i,
                        realIndex: a,
                        pathFrom: s,
                        pathTo: r,
                        fill: c,
                        strokeWidth: o,
                        delay: d
                    };
                    return !S || x.globals.resized || x.globals.dataChanged ? !x.globals.resized && x.globals.dataChanged || k.showDelayedElements() : k.animatePathsGradually(X(X({}, R), {}, {
                        speed: g
                    })), x.globals.dataChanged && C && L && k.animatePathsGradually(X(X({}, R), {}, {
                        speed: p
                    })), T;
                }
            },
            {
                key: "drawPattern",
                value: function(e, t, i) {
                    var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
                    return this.w.globals.dom.Paper.pattern(t, i, function(r) {
                        e === "horizontalLines" ? r.line(0, 0, i, 0).stroke({
                            color: a,
                            width: s + 1
                        }) : e === "verticalLines" ? r.line(0, 0, 0, t).stroke({
                            color: a,
                            width: s + 1
                        }) : e === "slantedLines" ? r.line(0, 0, t, i).stroke({
                            color: a,
                            width: s
                        }) : e === "squares" ? r.rect(t, i).fill("none").stroke({
                            color: a,
                            width: s
                        }) : e === "circles" && r.circle(t).fill("none").stroke({
                            color: a,
                            width: s
                        });
                    });
                }
            },
            {
                key: "drawGradient",
                value: function(e, t, i, a, s) {
                    var r, n = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, h = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, c = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0, d = this.w;
                    t.length < 9 && t.indexOf("#") === 0 && (t = P.hexToRgba(t, a)), i.length < 9 && i.indexOf("#") === 0 && (i = P.hexToRgba(i, s));
                    var g = 0, p = 1, f = 1, b = null;
                    o !== null && (g = o[0] !== void 0 ? o[0] / 100 : 0, p = o[1] !== void 0 ? o[1] / 100 : 1, f = o[2] !== void 0 ? o[2] / 100 : 1, b = o[3] !== void 0 ? o[3] / 100 : null);
                    var m = !(d.config.chart.type !== "donut" && d.config.chart.type !== "pie" && d.config.chart.type !== "polarArea" && d.config.chart.type !== "bubble");
                    if (r = h === null || h.length === 0 ? d.globals.dom.Paper.gradient(m ? "radial" : "linear", function(l) {
                        l.at(g, t, a), l.at(p, i, s), l.at(f, i, s), b !== null && l.at(b, t, a);
                    }) : d.globals.dom.Paper.gradient(m ? "radial" : "linear", function(l) {
                        (Array.isArray(h[c]) ? h[c] : h).forEach(function(u) {
                            l.at(u.offset / 100, u.color, u.opacity);
                        });
                    }), m) {
                        var w = d.globals.gridWidth / 2, A = d.globals.gridHeight / 2;
                        d.config.chart.type !== "bubble" ? r.attr({
                            gradientUnits: "userSpaceOnUse",
                            cx: w,
                            cy: A,
                            r: n
                        }) : r.attr({
                            cx: 0.5,
                            cy: 0.5,
                            r: 0.8,
                            fx: 0.2,
                            fy: 0.2
                        });
                    } else e === "vertical" ? r.from(0, 0).to(0, 1) : e === "diagonal" ? r.from(0, 0).to(1, 1) : e === "horizontal" ? r.from(0, 1).to(1, 1) : e === "diagonal2" && r.from(1, 0).to(0, 1);
                    return r;
                }
            },
            {
                key: "getTextBasedOnMaxWidth",
                value: function(e) {
                    var t = e.text, i = e.maxWidth, a = e.fontSize, s = e.fontFamily, r = this.getTextRects(t, a, s), n = r.width / t.length, o = Math.floor(i / n);
                    return i < r.width ? t.slice(0, o - 3) + "..." : t;
                }
            },
            {
                key: "drawText",
                value: function(e) {
                    var t = this, i = e.x, a = e.y, s = e.text, r = e.textAnchor, n = e.fontSize, o = e.fontFamily, h = e.fontWeight, c = e.foreColor, d = e.opacity, g = e.maxWidth, p = e.cssClass, f = p === void 0 ? "" : p, b = e.isPlainText, m = b === void 0 || b, w = e.dominantBaseline, A = w === void 0 ? "auto" : w, l = this.w;
                    s === void 0 && (s = "");
                    var u = s;
                    r || (r = "start"), c && c.length || (c = l.config.chart.foreColor), o = o || l.config.chart.fontFamily, h = h || "regular";
                    var x, v = {
                        maxWidth: g,
                        fontSize: n = n || "11px",
                        fontFamily: o
                    };
                    return Array.isArray(s) ? x = l.globals.dom.Paper.text(function(k) {
                        for(var S = 0; S < s.length; S++)u = s[S], g && (u = t.getTextBasedOnMaxWidth(X({
                            text: s[S]
                        }, v))), S === 0 ? k.tspan(u) : k.tspan(u).newLine();
                    }) : (g && (u = this.getTextBasedOnMaxWidth(X({
                        text: s
                    }, v))), x = m ? l.globals.dom.Paper.plain(s) : l.globals.dom.Paper.text(function(k) {
                        return k.tspan(u);
                    })), x.attr({
                        x: i,
                        y: a,
                        "text-anchor": r,
                        "dominant-baseline": A,
                        "font-size": n,
                        "font-family": o,
                        "font-weight": h,
                        fill: c,
                        class: "apexcharts-text " + f
                    }), x.node.style.fontFamily = o, x.node.style.opacity = d, x;
                }
            },
            {
                key: "drawMarker",
                value: function(e, t, i) {
                    e = e || 0;
                    var a = i.pSize || 0, s = null;
                    if (i.shape === "square" || i.shape === "rect") {
                        var r = i.pRadius === void 0 ? a / 2 : i.pRadius;
                        t !== null && a || (a = 0, r = 0);
                        var n = 1.2 * a + r, o = this.drawRect(n, n, n, n, r);
                        o.attr({
                            x: e - n / 2,
                            y: t - n / 2,
                            cx: e,
                            cy: t,
                            class: i.class ? i.class : "",
                            fill: i.pointFillColor,
                            "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                            stroke: i.pointStrokeColor,
                            "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                            "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                        }), s = o;
                    } else i.shape !== "circle" && i.shape || (P.isNumber(t) || (a = 0, t = 0), s = this.drawCircle(a, {
                        cx: e,
                        cy: t,
                        class: i.class ? i.class : "",
                        stroke: i.pointStrokeColor,
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }));
                    return s;
                }
            },
            {
                key: "pathMouseEnter",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = parseInt(e.node.getAttribute("index"), 10), r = parseInt(e.node.getAttribute("j"), 10);
                    if (typeof i.config.chart.events.dataPointMouseEnter == "function" && i.config.chart.events.dataPointMouseEnter(t, this.ctx, {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                        t,
                        this.ctx,
                        {
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: i
                        }
                    ]), (i.config.states.active.filter.type === "none" || e.node.getAttribute("selected") !== "true") && i.config.states.hover.filter.type !== "none" && !i.globals.isTouchDevice) {
                        var n = i.config.states.hover.filter;
                        a.applyFilter(e, s, n.type, n.value);
                    }
                }
            },
            {
                key: "pathMouseLeave",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = parseInt(e.node.getAttribute("index"), 10), r = parseInt(e.node.getAttribute("j"), 10);
                    typeof i.config.chart.events.dataPointMouseLeave == "function" && i.config.chart.events.dataPointMouseLeave(t, this.ctx, {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                        t,
                        this.ctx,
                        {
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: i
                        }
                    ]), i.config.states.active.filter.type !== "none" && e.node.getAttribute("selected") === "true" || i.config.states.hover.filter.type !== "none" && a.getDefaultFilter(e, s);
                }
            },
            {
                key: "pathMouseDown",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = parseInt(e.node.getAttribute("index"), 10), r = parseInt(e.node.getAttribute("j"), 10), n = "false";
                    if (e.node.getAttribute("selected") === "true") {
                        if (e.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                            var o = i.globals.selectedDataPoints[s].indexOf(r);
                            i.globals.selectedDataPoints[s].splice(o, 1);
                        }
                    } else {
                        if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                            i.globals.selectedDataPoints = [];
                            var h = i.globals.dom.Paper.select(".apexcharts-series path").members, c = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, d = function(f) {
                                Array.prototype.forEach.call(f, function(b) {
                                    b.node.setAttribute("selected", "false"), a.getDefaultFilter(b, s);
                                });
                            };
                            d(h), d(c);
                        }
                        e.node.setAttribute("selected", "true"), n = "true", i.globals.selectedDataPoints[s] === void 0 && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                    }
                    if (n === "true") {
                        var g = i.config.states.active.filter;
                        if (g !== "none") a.applyFilter(e, s, g.type, g.value);
                        else if (i.config.states.hover.filter !== "none" && !i.globals.isTouchDevice) {
                            var p = i.config.states.hover.filter;
                            a.applyFilter(e, s, p.type, p.value);
                        }
                    } else i.config.states.active.filter.type !== "none" && (i.config.states.hover.filter.type === "none" || i.globals.isTouchDevice ? a.getDefaultFilter(e, s) : (p = i.config.states.hover.filter, a.applyFilter(e, s, p.type, p.value)));
                    typeof i.config.chart.events.dataPointSelection == "function" && i.config.chart.events.dataPointSelection(t, this.ctx, {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }), t && this.ctx.events.fireEvent("dataPointSelection", [
                        t,
                        this.ctx,
                        {
                            selectedDataPoints: i.globals.selectedDataPoints,
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: i
                        }
                    ]);
                }
            },
            {
                key: "rotateAroundCenter",
                value: function(e) {
                    var t = {};
                    return e && typeof e.getBBox == "function" && (t = e.getBBox()), {
                        x: t.x + t.width / 2,
                        y: t.y + t.height / 2
                    };
                }
            },
            {
                key: "getTextRects",
                value: function(e, t, i, a) {
                    var s = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], r = this.w, n = this.drawText({
                        x: -200,
                        y: -200,
                        text: e,
                        textAnchor: "start",
                        fontSize: t,
                        fontFamily: i,
                        foreColor: "#fff",
                        opacity: 0
                    });
                    a && n.attr("transform", a), r.globals.dom.Paper.add(n);
                    var o = n.bbox();
                    return s || (o = n.node.getBoundingClientRect()), n.remove(), {
                        width: o.width,
                        height: o.height
                    };
                }
            },
            {
                key: "placeTextWithEllipsis",
                value: function(e, t, i) {
                    if (typeof e.getComputedTextLength == "function" && (e.textContent = t, t.length > 0 && e.getComputedTextLength() >= i / 1.1)) {
                        for(var a = t.length - 3; a > 0; a -= 3)if (e.getSubStringLength(0, a) <= i / 1.1) return void (e.textContent = t.substring(0, a) + "...");
                        e.textContent = ".";
                    }
                }
            }
        ], [
            {
                key: "setAttrs",
                value: function(e, t) {
                    for(var i in t)t.hasOwnProperty(i) && e.setAttribute(i, t[i]);
                }
            }
        ]), y;
    }(), q = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "getStackedSeriesTotals",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = this.w, i = [];
                    if (t.globals.series.length === 0) return i;
                    for(var a = 0; a < t.globals.series[t.globals.maxValsInArrayIndex].length; a++){
                        for(var s = 0, r = 0; r < t.globals.series.length; r++)t.globals.series[r][a] !== void 0 && e.indexOf(r) === -1 && (s += t.globals.series[r][a]);
                        i.push(s);
                    }
                    return i;
                }
            },
            {
                key: "getSeriesTotalByIndex",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    return e === null ? this.w.config.series.reduce(function(t, i) {
                        return t + i;
                    }, 0) : this.w.globals.series[e].reduce(function(t, i) {
                        return t + i;
                    }, 0);
                }
            },
            {
                key: "getStackedSeriesTotalsByGroups",
                value: function() {
                    var e = this, t = this.w, i = [];
                    return t.globals.seriesGroups.forEach(function(a) {
                        var s = [];
                        t.config.series.forEach(function(n, o) {
                            a.indexOf(n.name) > -1 && s.push(o);
                        });
                        var r = t.globals.series.map(function(n, o) {
                            return s.indexOf(o) === -1 ? o : -1;
                        }).filter(function(n) {
                            return n !== -1;
                        });
                        i.push(e.getStackedSeriesTotals(r));
                    }), i;
                }
            },
            {
                key: "isSeriesNull",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    return (e === null ? this.w.config.series.filter(function(t) {
                        return t !== null;
                    }) : this.w.config.series[e].data.filter(function(t) {
                        return t !== null;
                    })).length === 0;
                }
            },
            {
                key: "seriesHaveSameValues",
                value: function(e) {
                    return this.w.globals.series[e].every(function(t, i, a) {
                        return t === a[0];
                    });
                }
            },
            {
                key: "getCategoryLabels",
                value: function(e) {
                    var t = this.w, i = e.slice();
                    return t.config.xaxis.convertedCatToNumeric && (i = e.map(function(a, s) {
                        return t.config.xaxis.labels.formatter(a - t.globals.minX + 1);
                    })), i;
                }
            },
            {
                key: "getLargestSeries",
                value: function() {
                    var e = this.w;
                    e.globals.maxValsInArrayIndex = e.globals.series.map(function(t) {
                        return t.length;
                    }).indexOf(Math.max.apply(Math, e.globals.series.map(function(t) {
                        return t.length;
                    })));
                }
            },
            {
                key: "getLargestMarkerSize",
                value: function() {
                    var e = this.w, t = 0;
                    return e.globals.markers.size.forEach(function(i) {
                        t = Math.max(t, i);
                    }), e.config.markers.discrete && e.config.markers.discrete.length && e.config.markers.discrete.forEach(function(i) {
                        t = Math.max(t, i.size);
                    }), t > 0 && (t += e.config.markers.hover.sizeOffset + 1), e.globals.markers.largestSize = t, t;
                }
            },
            {
                key: "getSeriesTotals",
                value: function() {
                    var e = this.w;
                    e.globals.seriesTotals = e.globals.series.map(function(t, i) {
                        var a = 0;
                        if (Array.isArray(t)) for(var s = 0; s < t.length; s++)a += t[s];
                        else a += t;
                        return a;
                    });
                }
            },
            {
                key: "getSeriesTotalsXRange",
                value: function(e, t) {
                    var i = this.w;
                    return i.globals.series.map(function(a, s) {
                        for(var r = 0, n = 0; n < a.length; n++)i.globals.seriesX[s][n] > e && i.globals.seriesX[s][n] < t && (r += a[n]);
                        return r;
                    });
                }
            },
            {
                key: "getPercentSeries",
                value: function() {
                    var e = this.w;
                    e.globals.seriesPercent = e.globals.series.map(function(t, i) {
                        var a = [];
                        if (Array.isArray(t)) for(var s = 0; s < t.length; s++){
                            var r = e.globals.stackedSeriesTotals[s], n = 0;
                            r && (n = 100 * t[s] / r), a.push(n);
                        }
                        else {
                            var o = 100 * t / e.globals.seriesTotals.reduce(function(h, c) {
                                return h + c;
                            }, 0);
                            a.push(o);
                        }
                        return a;
                    });
                }
            },
            {
                key: "getCalculatedRatios",
                value: function() {
                    var e, t, i, a = this.w.globals, s = [], r = 0, n = [], o = 0.1, h = 0;
                    if (a.yRange = [], a.isMultipleYAxis) for(var c = 0; c < a.minYArr.length; c++)a.yRange.push(Math.abs(a.minYArr[c] - a.maxYArr[c])), n.push(0);
                    else a.yRange.push(Math.abs(a.minY - a.maxY));
                    a.xRange = Math.abs(a.maxX - a.minX), a.zRange = Math.abs(a.maxZ - a.minZ);
                    for(var d = 0; d < a.yRange.length; d++)s.push(a.yRange[d] / a.gridHeight);
                    if (t = a.xRange / a.gridWidth, e = a.yRange / a.gridWidth, i = a.xRange / a.gridHeight, (r = a.zRange / a.gridHeight * 16) || (r = 1), a.minY !== Number.MIN_VALUE && Math.abs(a.minY) !== 0 && (a.hasNegs = !0), a.isMultipleYAxis) {
                        n = [];
                        for(var g = 0; g < s.length; g++)n.push(-a.minYArr[g] / s[g]);
                    } else n.push(-a.minY / s[0]), a.minY !== Number.MIN_VALUE && Math.abs(a.minY) !== 0 && (o = -a.minY / e, h = a.minX / t);
                    return {
                        yRatio: s,
                        invertedYRatio: e,
                        zRatio: r,
                        xRatio: t,
                        invertedXRatio: i,
                        baseLineInvertedY: o,
                        baseLineY: n,
                        baseLineX: h
                    };
                }
            },
            {
                key: "getLogSeries",
                value: function(e) {
                    var t = this, i = this.w;
                    return i.globals.seriesLog = e.map(function(a, s) {
                        return i.config.yaxis[s] && i.config.yaxis[s].logarithmic ? a.map(function(r) {
                            return r === null ? null : t.getLogVal(i.config.yaxis[s].logBase, r, s);
                        }) : a;
                    }), i.globals.invalidLogScale ? e : i.globals.seriesLog;
                }
            },
            {
                key: "getBaseLog",
                value: function(e, t) {
                    return Math.log(t) / Math.log(e);
                }
            },
            {
                key: "getLogVal",
                value: function(e, t, i) {
                    if (t === 0) return 0;
                    var a = this.w, s = a.globals.minYArr[i] === 0 ? -1 : this.getBaseLog(e, a.globals.minYArr[i]), r = (a.globals.maxYArr[i] === 0 ? 0 : this.getBaseLog(e, a.globals.maxYArr[i])) - s;
                    return t < 1 ? t / r : (this.getBaseLog(e, t) - s) / r;
                }
            },
            {
                key: "getLogYRatios",
                value: function(e) {
                    var t = this, i = this.w, a = this.w.globals;
                    return a.yLogRatio = e.slice(), a.logYRange = a.yRange.map(function(s, r) {
                        if (i.config.yaxis[r] && t.w.config.yaxis[r].logarithmic) {
                            var n, o = -Number.MAX_VALUE, h = Number.MIN_VALUE;
                            return a.seriesLog.forEach(function(c, d) {
                                c.forEach(function(g) {
                                    i.config.yaxis[d] && i.config.yaxis[d].logarithmic && (o = Math.max(g, o), h = Math.min(g, h));
                                });
                            }), n = Math.pow(a.yRange[r], Math.abs(h - o) / a.yRange[r]), a.yLogRatio[r] = n / a.gridHeight, n;
                        }
                    }), a.invalidLogScale ? e.slice() : a.yLogRatio;
                }
            }
        ], [
            {
                key: "checkComboSeries",
                value: function(e) {
                    var t = !1, i = 0, a = 0;
                    return e.length && e[0].type !== void 0 && e.forEach(function(s) {
                        s.type !== "bar" && s.type !== "column" && s.type !== "candlestick" && s.type !== "boxPlot" || i++, s.type !== void 0 && a++;
                    }), a > 0 && (t = !0), {
                        comboBarCount: i,
                        comboCharts: t
                    };
                }
            },
            {
                key: "extendArrayProps",
                value: function(e, t, i) {
                    return t.yaxis && (t = e.extendYAxis(t, i)), t.annotations && (t.annotations.yaxis && (t = e.extendYAxisAnnotations(t)), t.annotations.xaxis && (t = e.extendXAxisAnnotations(t)), t.annotations.points && (t = e.extendPointAnnotations(t))), t;
                }
            }
        ]), y;
    }(), ve = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e;
        }
        return Y(y, [
            {
                key: "setOrientations",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, i = this.w;
                    if (e.label.orientation === "vertical") {
                        var a = t !== null ? t : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                        if (s !== null) {
                            var r = s.getBoundingClientRect();
                            s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4), e.label.position === "top" ? s.setAttribute("y", parseFloat(s.getAttribute("y")) + r.width) : s.setAttribute("y", parseFloat(s.getAttribute("y")) - r.width);
                            var n = this.annoCtx.graphics.rotateAroundCenter(s), o = n.x, h = n.y;
                            s.setAttribute("transform", "rotate(-90 ".concat(o, " ").concat(h, ")"));
                        }
                    }
                }
            },
            {
                key: "addBackgroundToAnno",
                value: function(e, t) {
                    var i = this.w;
                    if (!e || t.label.text === void 0 || t.label.text !== void 0 && !String(t.label.text).trim()) return null;
                    var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = e.getBoundingClientRect(), r = t.label.style.padding.left, n = t.label.style.padding.right, o = t.label.style.padding.top, h = t.label.style.padding.bottom;
                    t.label.orientation === "vertical" && (o = t.label.style.padding.left, h = t.label.style.padding.right, r = t.label.style.padding.top, n = t.label.style.padding.bottom);
                    var c = s.left - a.left - r, d = s.top - a.top - o, g = this.annoCtx.graphics.drawRect(c - i.globals.barPadForNumericAxis, d, s.width + r + n, s.height + o + h, t.label.borderRadius, t.label.style.background, 1, t.label.borderWidth, t.label.borderColor, 0);
                    return t.id && g.node.classList.add(t.id), g;
                }
            },
            {
                key: "annotationsBackground",
                value: function() {
                    var e = this, t = this.w, i = function(a, s, r) {
                        var n = t.globals.dom.baseEl.querySelector(".apexcharts-".concat(r, "-annotations .apexcharts-").concat(r, "-annotation-label[rel='").concat(s, "']"));
                        if (n) {
                            var o = n.parentNode, h = e.addBackgroundToAnno(n, a);
                            h && (o.insertBefore(h.node, n), a.label.mouseEnter && h.node.addEventListener("mouseenter", a.label.mouseEnter.bind(e, a)), a.label.mouseLeave && h.node.addEventListener("mouseleave", a.label.mouseLeave.bind(e, a)), a.label.click && h.node.addEventListener("click", a.label.click.bind(e, a)));
                        }
                    };
                    t.config.annotations.xaxis.map(function(a, s) {
                        i(a, s, "xaxis");
                    }), t.config.annotations.yaxis.map(function(a, s) {
                        i(a, s, "yaxis");
                    }), t.config.annotations.points.map(function(a, s) {
                        i(a, s, "point");
                    });
                }
            },
            {
                key: "getY1Y2",
                value: function(e, t) {
                    var i, a = e === "y1" ? t.y : t.y2, s = this.w;
                    if (this.annoCtx.invertAxis) {
                        var r = s.globals.labels.indexOf(a);
                        s.config.xaxis.convertedCatToNumeric && (r = s.globals.categoryLabels.indexOf(a));
                        var n = s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                        n && (i = parseFloat(n.getAttribute("y"))), t.seriesIndex !== void 0 && s.globals.barHeight && (i = i - s.globals.barHeight / 2 * (s.globals.series.length - 1) + s.globals.barHeight * t.seriesIndex);
                    } else {
                        var o;
                        s.config.yaxis[t.yAxisIndex].logarithmic ? o = (a = new q(this.annoCtx.ctx).getLogVal(a, t.yAxisIndex)) / s.globals.yLogRatio[t.yAxisIndex] : o = (a - s.globals.minYArr[t.yAxisIndex]) / (s.globals.yRange[t.yAxisIndex] / s.globals.gridHeight), i = s.globals.gridHeight - o, !t.marker || t.y !== void 0 && t.y !== null || (i = 0), s.config.yaxis[t.yAxisIndex] && s.config.yaxis[t.yAxisIndex].reversed && (i = o);
                    }
                    return typeof a == "string" && a.indexOf("px") > -1 && (i = parseFloat(a)), i;
                }
            },
            {
                key: "getX1X2",
                value: function(e, t) {
                    var i = this.w, a = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, s = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, r = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, n = (t.x - a) / (r / i.globals.gridWidth);
                    this.annoCtx.inversedReversedAxis && (n = (s - t.x) / (r / i.globals.gridWidth)), i.config.xaxis.type !== "category" && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (n = this.getStringX(t.x));
                    var o = (t.x2 - a) / (r / i.globals.gridWidth);
                    return this.annoCtx.inversedReversedAxis && (o = (s - t.x2) / (r / i.globals.gridWidth)), i.config.xaxis.type !== "category" && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (o = this.getStringX(t.x2)), t.x !== void 0 && t.x !== null || !t.marker || (n = i.globals.gridWidth), e === "x1" && typeof t.x == "string" && t.x.indexOf("px") > -1 && (n = parseFloat(t.x)), e === "x2" && typeof t.x2 == "string" && t.x2.indexOf("px") > -1 && (o = parseFloat(t.x2)), t.seriesIndex !== void 0 && i.globals.barWidth && !this.annoCtx.invertAxis && (n = n - i.globals.barWidth / 2 * (i.globals.series.length - 1) + i.globals.barWidth * t.seriesIndex), e === "x1" ? n : o;
                }
            },
            {
                key: "getStringX",
                value: function(e) {
                    var t = this.w, i = e;
                    t.config.xaxis.convertedCatToNumeric && t.globals.categoryLabels.length && (e = t.globals.categoryLabels.indexOf(e) + 1);
                    var a = t.globals.labels.indexOf(e), s = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (a + 1) + ")");
                    return s && (i = parseFloat(s.getAttribute("x"))), i;
                }
            }
        ]), y;
    }(), Oe = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new ve(this.annoCtx);
        }
        return Y(y, [
            {
                key: "addXaxisAnnotation",
                value: function(e, t, i) {
                    var a, s = this.w, r = this.helpers.getX1X2("x1", e), n = e.label.text, o = e.strokeDashArray;
                    if (P.isNumber(r)) {
                        if (e.x2 === null || e.x2 === void 0) {
                            var h = this.annoCtx.graphics.drawLine(r + e.offsetX, 0 + e.offsetY, r + e.offsetX, s.globals.gridHeight + e.offsetY, e.borderColor, o, e.borderWidth);
                            t.appendChild(h.node), e.id && h.node.classList.add(e.id);
                        } else {
                            if ((a = this.helpers.getX1X2("x2", e)) < r) {
                                var c = r;
                                r = a, a = c;
                            }
                            var d = this.annoCtx.graphics.drawRect(r + e.offsetX, 0 + e.offsetY, a - r, s.globals.gridHeight + e.offsetY, 0, e.fillColor, e.opacity, 1, e.borderColor, o);
                            d.node.classList.add("apexcharts-annotation-rect"), d.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), t.appendChild(d.node), e.id && d.node.classList.add(e.id);
                        }
                        var g = this.annoCtx.graphics.getTextRects(n, parseFloat(e.label.style.fontSize)), p = e.label.position === "top" ? 4 : e.label.position === "center" ? s.globals.gridHeight / 2 + (e.label.orientation === "vertical" ? g.width / 2 : 0) : s.globals.gridHeight, f = this.annoCtx.graphics.drawText({
                            x: r + e.label.offsetX,
                            y: p + e.label.offsetY - (e.label.orientation === "vertical" ? e.label.position === "top" ? g.width / 2 - 12 : -g.width / 2 : 0),
                            text: n,
                            textAnchor: e.label.textAnchor,
                            fontSize: e.label.style.fontSize,
                            fontFamily: e.label.style.fontFamily,
                            fontWeight: e.label.style.fontWeight,
                            foreColor: e.label.style.color,
                            cssClass: "apexcharts-xaxis-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "")
                        });
                        f.attr({
                            rel: i
                        }), t.appendChild(f.node), this.annoCtx.helpers.setOrientations(e, i);
                    }
                }
            },
            {
                key: "drawXAxisAnnotations",
                value: function() {
                    var e = this, t = this.w, i = this.annoCtx.graphics.group({
                        class: "apexcharts-xaxis-annotations"
                    });
                    return t.config.annotations.xaxis.map(function(a, s) {
                        e.addXaxisAnnotation(a, i.node, s);
                    }), i;
                }
            }
        ]), y;
    }(), He = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e, this.helpers = new ve(this.annoCtx);
        }
        return Y(y, [
            {
                key: "addYaxisAnnotation",
                value: function(e, t, i) {
                    var a, s = this.w, r = e.strokeDashArray, n = this.helpers.getY1Y2("y1", e), o = e.label.text;
                    if (e.y2 === null || e.y2 === void 0) {
                        var h = this.annoCtx.graphics.drawLine(0 + e.offsetX, n + e.offsetY, this._getYAxisAnnotationWidth(e), n + e.offsetY, e.borderColor, r, e.borderWidth);
                        t.appendChild(h.node), e.id && h.node.classList.add(e.id);
                    } else {
                        if ((a = this.helpers.getY1Y2("y2", e)) > n) {
                            var c = n;
                            n = a, a = c;
                        }
                        var d = this.annoCtx.graphics.drawRect(0 + e.offsetX, a + e.offsetY, this._getYAxisAnnotationWidth(e), n - a, 0, e.fillColor, e.opacity, 1, e.borderColor, r);
                        d.node.classList.add("apexcharts-annotation-rect"), d.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), t.appendChild(d.node), e.id && d.node.classList.add(e.id);
                    }
                    var g = e.label.position === "right" ? s.globals.gridWidth : e.label.position === "center" ? s.globals.gridWidth / 2 : 0, p = this.annoCtx.graphics.drawText({
                        x: g + e.label.offsetX,
                        y: (a ?? n) + e.label.offsetY - 3,
                        text: o,
                        textAnchor: e.label.textAnchor,
                        fontSize: e.label.style.fontSize,
                        fontFamily: e.label.style.fontFamily,
                        fontWeight: e.label.style.fontWeight,
                        foreColor: e.label.style.color,
                        cssClass: "apexcharts-yaxis-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "")
                    });
                    p.attr({
                        rel: i
                    }), t.appendChild(p.node);
                }
            },
            {
                key: "_getYAxisAnnotationWidth",
                value: function(e) {
                    var t = this.w;
                    return t.globals.gridWidth, (e.width.indexOf("%") > -1 ? t.globals.gridWidth * parseInt(e.width, 10) / 100 : parseInt(e.width, 10)) + e.offsetX;
                }
            },
            {
                key: "drawYAxisAnnotations",
                value: function() {
                    var e = this, t = this.w, i = this.annoCtx.graphics.group({
                        class: "apexcharts-yaxis-annotations"
                    });
                    return t.config.annotations.yaxis.map(function(a, s) {
                        e.addYaxisAnnotation(a, i.node, s);
                    }), i;
                }
            }
        ]), y;
    }(), pe = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.annoCtx = e, this.helpers = new ve(this.annoCtx);
        }
        return Y(y, [
            {
                key: "addPointAnnotation",
                value: function(e, t, i) {
                    this.w;
                    var a = this.helpers.getX1X2("x1", e), s = this.helpers.getY1Y2("y1", e);
                    if (P.isNumber(a)) {
                        var r = {
                            pSize: e.marker.size,
                            pointStrokeWidth: e.marker.strokeWidth,
                            pointFillColor: e.marker.fillColor,
                            pointStrokeColor: e.marker.strokeColor,
                            shape: e.marker.shape,
                            pRadius: e.marker.radius,
                            class: "apexcharts-point-annotation-marker ".concat(e.marker.cssClass, " ").concat(e.id ? e.id : "")
                        }, n = this.annoCtx.graphics.drawMarker(a + e.marker.offsetX, s + e.marker.offsetY, r);
                        t.appendChild(n.node);
                        var o = e.label.text ? e.label.text : "", h = this.annoCtx.graphics.drawText({
                            x: a + e.label.offsetX,
                            y: s + e.label.offsetY - e.marker.size - parseFloat(e.label.style.fontSize) / 1.6,
                            text: o,
                            textAnchor: e.label.textAnchor,
                            fontSize: e.label.style.fontSize,
                            fontFamily: e.label.style.fontFamily,
                            fontWeight: e.label.style.fontWeight,
                            foreColor: e.label.style.color,
                            cssClass: "apexcharts-point-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "")
                        });
                        if (h.attr({
                            rel: i
                        }), t.appendChild(h.node), e.customSVG.SVG) {
                            var c = this.annoCtx.graphics.group({
                                class: "apexcharts-point-annotations-custom-svg " + e.customSVG.cssClass
                            });
                            c.attr({
                                transform: "translate(".concat(a + e.customSVG.offsetX, ", ").concat(s + e.customSVG.offsetY, ")")
                            }), c.node.innerHTML = e.customSVG.SVG, t.appendChild(c.node);
                        }
                        if (e.image.path) {
                            var d = e.image.width ? e.image.width : 20, g = e.image.height ? e.image.height : 20;
                            n = this.annoCtx.addImage({
                                x: a + e.image.offsetX - d / 2,
                                y: s + e.image.offsetY - g / 2,
                                width: d,
                                height: g,
                                path: e.image.path,
                                appendTo: ".apexcharts-point-annotations"
                            });
                        }
                        e.mouseEnter && n.node.addEventListener("mouseenter", e.mouseEnter.bind(this, e)), e.mouseLeave && n.node.addEventListener("mouseleave", e.mouseLeave.bind(this, e)), e.click && n.node.addEventListener("click", e.click.bind(this, e));
                    }
                }
            },
            {
                key: "drawPointAnnotations",
                value: function() {
                    var e = this, t = this.w, i = this.annoCtx.graphics.group({
                        class: "apexcharts-point-annotations"
                    });
                    return t.config.annotations.points.map(function(a, s) {
                        e.addPointAnnotation(a, i.node, s);
                    }), i;
                }
            }
        ]), y;
    }(), H = {
        name: "en",
        options: {
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            shortMonths: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            days: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            shortDays: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            toolbar: {
                exportToSVG: "Download SVG",
                exportToPNG: "Download PNG",
                exportToCSV: "Download CSV",
                menu: "Menu",
                selection: "Selection",
                selectionZoom: "Selection Zoom",
                zoomIn: "Zoom In",
                zoomOut: "Zoom Out",
                pan: "Panning",
                reset: "Reset Zoom"
            }
        }
    }, G = function() {
        function y() {
            F(this, y), this.yAxis = {
                show: !0,
                showAlways: !1,
                showForNullSeries: !0,
                seriesName: void 0,
                opposite: !1,
                reversed: !1,
                logarithmic: !1,
                logBase: 10,
                tickAmount: void 0,
                stepSize: void 0,
                forceNiceScale: !1,
                max: void 0,
                min: void 0,
                floating: !1,
                decimalsInFloat: void 0,
                labels: {
                    show: !0,
                    minWidth: 0,
                    maxWidth: 160,
                    offsetX: 0,
                    offsetY: 0,
                    align: void 0,
                    rotate: 0,
                    padding: 20,
                    style: {
                        colors: [],
                        fontSize: "11px",
                        fontWeight: 400,
                        fontFamily: void 0,
                        cssClass: ""
                    },
                    formatter: void 0
                },
                axisBorder: {
                    show: !1,
                    color: "#e0e0e0",
                    width: 1,
                    offsetX: 0,
                    offsetY: 0
                },
                axisTicks: {
                    show: !1,
                    color: "#e0e0e0",
                    width: 6,
                    offsetX: 0,
                    offsetY: 0
                },
                title: {
                    text: void 0,
                    rotate: -90,
                    offsetY: 0,
                    offsetX: 0,
                    style: {
                        color: void 0,
                        fontSize: "11px",
                        fontWeight: 900,
                        fontFamily: void 0,
                        cssClass: ""
                    }
                },
                tooltip: {
                    enabled: !1,
                    offsetX: 0
                },
                crosshairs: {
                    show: !0,
                    position: "front",
                    stroke: {
                        color: "#b6b6b6",
                        width: 1,
                        dashArray: 0
                    }
                }
            }, this.pointAnnotation = {
                id: void 0,
                x: 0,
                y: null,
                yAxisIndex: 0,
                seriesIndex: void 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                marker: {
                    size: 4,
                    fillColor: "#fff",
                    strokeWidth: 2,
                    strokeColor: "#333",
                    shape: "circle",
                    offsetX: 0,
                    offsetY: 0,
                    radius: 2,
                    cssClass: ""
                },
                label: {
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    borderRadius: 2,
                    text: void 0,
                    textAnchor: "middle",
                    offsetX: 0,
                    offsetY: 0,
                    mouseEnter: void 0,
                    mouseLeave: void 0,
                    click: void 0,
                    style: {
                        background: "#fff",
                        color: void 0,
                        fontSize: "11px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        cssClass: "",
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 2
                        }
                    }
                },
                customSVG: {
                    SVG: void 0,
                    cssClass: void 0,
                    offsetX: 0,
                    offsetY: 0
                },
                image: {
                    path: void 0,
                    width: 20,
                    height: 20,
                    offsetX: 0,
                    offsetY: 0
                }
            }, this.yAxisAnnotation = {
                id: void 0,
                y: 0,
                y2: null,
                strokeDashArray: 1,
                fillColor: "#c2c2c2",
                borderColor: "#c2c2c2",
                borderWidth: 1,
                opacity: 0.3,
                offsetX: 0,
                offsetY: 0,
                width: "100%",
                yAxisIndex: 0,
                label: {
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    borderRadius: 2,
                    text: void 0,
                    textAnchor: "end",
                    position: "right",
                    offsetX: 0,
                    offsetY: -3,
                    mouseEnter: void 0,
                    mouseLeave: void 0,
                    click: void 0,
                    style: {
                        background: "#fff",
                        color: void 0,
                        fontSize: "11px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        cssClass: "",
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 2
                        }
                    }
                }
            }, this.xAxisAnnotation = {
                id: void 0,
                x: 0,
                x2: null,
                strokeDashArray: 1,
                fillColor: "#c2c2c2",
                borderColor: "#c2c2c2",
                borderWidth: 1,
                opacity: 0.3,
                offsetX: 0,
                offsetY: 0,
                label: {
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    borderRadius: 2,
                    text: void 0,
                    textAnchor: "middle",
                    orientation: "vertical",
                    position: "top",
                    offsetX: 0,
                    offsetY: 0,
                    mouseEnter: void 0,
                    mouseLeave: void 0,
                    click: void 0,
                    style: {
                        background: "#fff",
                        color: void 0,
                        fontSize: "11px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        cssClass: "",
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 2
                        }
                    }
                }
            }, this.text = {
                x: 0,
                y: 0,
                text: "",
                textAnchor: "start",
                foreColor: void 0,
                fontSize: "13px",
                fontFamily: void 0,
                fontWeight: 400,
                appendTo: ".apexcharts-annotations",
                backgroundColor: "transparent",
                borderColor: "#c2c2c2",
                borderRadius: 0,
                borderWidth: 0,
                paddingLeft: 4,
                paddingRight: 4,
                paddingTop: 2,
                paddingBottom: 2
            };
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    return {
                        annotations: {
                            yaxis: [
                                this.yAxisAnnotation
                            ],
                            xaxis: [
                                this.xAxisAnnotation
                            ],
                            points: [
                                this.pointAnnotation
                            ],
                            texts: [],
                            images: [],
                            shapes: []
                        },
                        chart: {
                            animations: {
                                enabled: !0,
                                easing: "easeinout",
                                speed: 800,
                                animateGradually: {
                                    delay: 150,
                                    enabled: !0
                                },
                                dynamicAnimation: {
                                    enabled: !0,
                                    speed: 350
                                }
                            },
                            background: "transparent",
                            locales: [
                                H
                            ],
                            defaultLocale: "en",
                            dropShadow: {
                                enabled: !1,
                                enabledOnSeries: void 0,
                                top: 2,
                                left: 2,
                                blur: 4,
                                color: "#000",
                                opacity: 0.35
                            },
                            events: {
                                animationEnd: void 0,
                                beforeMount: void 0,
                                mounted: void 0,
                                updated: void 0,
                                click: void 0,
                                mouseMove: void 0,
                                mouseLeave: void 0,
                                xAxisLabelClick: void 0,
                                legendClick: void 0,
                                markerClick: void 0,
                                selection: void 0,
                                dataPointSelection: void 0,
                                dataPointMouseEnter: void 0,
                                dataPointMouseLeave: void 0,
                                beforeZoom: void 0,
                                beforeResetZoom: void 0,
                                zoomed: void 0,
                                scrolled: void 0,
                                brushScrolled: void 0
                            },
                            foreColor: "#373d3f",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            height: "auto",
                            parentHeightOffset: 15,
                            redrawOnParentResize: !0,
                            redrawOnWindowResize: !0,
                            id: void 0,
                            group: void 0,
                            nonce: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            selection: {
                                enabled: !1,
                                type: "x",
                                fill: {
                                    color: "#24292e",
                                    opacity: 0.1
                                },
                                stroke: {
                                    width: 1,
                                    color: "#24292e",
                                    opacity: 0.4,
                                    dashArray: 3
                                },
                                xaxis: {
                                    min: void 0,
                                    max: void 0
                                },
                                yaxis: {
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            sparkline: {
                                enabled: !1
                            },
                            brush: {
                                enabled: !1,
                                autoScaleYaxis: !0,
                                target: void 0,
                                targets: void 0
                            },
                            stacked: !1,
                            stackOnlyBar: !0,
                            stackType: "normal",
                            toolbar: {
                                show: !0,
                                offsetX: 0,
                                offsetY: 0,
                                tools: {
                                    download: !0,
                                    selection: !0,
                                    zoom: !0,
                                    zoomin: !0,
                                    zoomout: !0,
                                    pan: !0,
                                    reset: !0,
                                    customIcons: []
                                },
                                export: {
                                    csv: {
                                        filename: void 0,
                                        columnDelimiter: ",",
                                        headerCategory: "category",
                                        headerValue: "value",
                                        dateFormatter: function(e) {
                                            return new Date(e).toDateString();
                                        }
                                    },
                                    png: {
                                        filename: void 0
                                    },
                                    svg: {
                                        filename: void 0
                                    }
                                },
                                autoSelected: "zoom"
                            },
                            type: "line",
                            width: "100%",
                            zoom: {
                                enabled: !0,
                                type: "x",
                                autoScaleYaxis: !1,
                                zoomedArea: {
                                    fill: {
                                        color: "#90CAF9",
                                        opacity: 0.4
                                    },
                                    stroke: {
                                        color: "#0D47A1",
                                        opacity: 0.4,
                                        width: 1
                                    }
                                }
                            }
                        },
                        plotOptions: {
                            area: {
                                fillTo: "origin"
                            },
                            bar: {
                                horizontal: !1,
                                columnWidth: "70%",
                                barHeight: "70%",
                                distributed: !1,
                                borderRadius: 0,
                                borderRadiusApplication: "around",
                                borderRadiusWhenStacked: "last",
                                rangeBarOverlap: !0,
                                rangeBarGroupRows: !1,
                                hideZeroBarsWhenGrouped: !1,
                                isDumbbell: !1,
                                dumbbellColors: void 0,
                                isFunnel: !1,
                                isFunnel3d: !0,
                                colors: {
                                    ranges: [],
                                    backgroundBarColors: [],
                                    backgroundBarOpacity: 1,
                                    backgroundBarRadius: 0
                                },
                                dataLabels: {
                                    position: "top",
                                    maxItems: 100,
                                    hideOverflowingLabels: !0,
                                    orientation: "horizontal",
                                    total: {
                                        enabled: !1,
                                        formatter: void 0,
                                        offsetX: 0,
                                        offsetY: 0,
                                        style: {
                                            color: "#373d3f",
                                            fontSize: "12px",
                                            fontFamily: void 0,
                                            fontWeight: 600
                                        }
                                    }
                                }
                            },
                            bubble: {
                                zScaling: !0,
                                minBubbleRadius: void 0,
                                maxBubbleRadius: void 0
                            },
                            candlestick: {
                                colors: {
                                    upward: "#00B746",
                                    downward: "#EF403C"
                                },
                                wick: {
                                    useFillColor: !0
                                }
                            },
                            boxPlot: {
                                colors: {
                                    upper: "#00E396",
                                    lower: "#008FFB"
                                }
                            },
                            heatmap: {
                                radius: 2,
                                enableShades: !0,
                                shadeIntensity: 0.5,
                                reverseNegativeShade: !1,
                                distributed: !1,
                                useFillColorAsStroke: !1,
                                colorScale: {
                                    inverse: !1,
                                    ranges: [],
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            treemap: {
                                enableShades: !0,
                                shadeIntensity: 0.5,
                                distributed: !1,
                                reverseNegativeShade: !1,
                                useFillColorAsStroke: !1,
                                borderRadius: 4,
                                dataLabels: {
                                    format: "scale"
                                },
                                colorScale: {
                                    inverse: !1,
                                    ranges: [],
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            radialBar: {
                                inverseOrder: !1,
                                startAngle: 0,
                                endAngle: 360,
                                offsetX: 0,
                                offsetY: 0,
                                hollow: {
                                    margin: 5,
                                    size: "50%",
                                    background: "transparent",
                                    image: void 0,
                                    imageWidth: 150,
                                    imageHeight: 150,
                                    imageOffsetX: 0,
                                    imageOffsetY: 0,
                                    imageClipped: !0,
                                    position: "front",
                                    dropShadow: {
                                        enabled: !1,
                                        top: 0,
                                        left: 0,
                                        blur: 3,
                                        color: "#000",
                                        opacity: 0.5
                                    }
                                },
                                track: {
                                    show: !0,
                                    startAngle: void 0,
                                    endAngle: void 0,
                                    background: "#f2f2f2",
                                    strokeWidth: "97%",
                                    opacity: 1,
                                    margin: 5,
                                    dropShadow: {
                                        enabled: !1,
                                        top: 0,
                                        left: 0,
                                        blur: 3,
                                        color: "#000",
                                        opacity: 0.5
                                    }
                                },
                                dataLabels: {
                                    show: !0,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: 0,
                                        formatter: function(e) {
                                            return e;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "14px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 16,
                                        formatter: function(e) {
                                            return e + "%";
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(e) {
                                            return e.globals.seriesTotals.reduce(function(t, i) {
                                                return t + i;
                                            }, 0) / e.globals.series.length + "%";
                                        }
                                    }
                                },
                                barLabels: {
                                    enabled: !1,
                                    margin: 5,
                                    useSeriesColors: !0,
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    formatter: function(e) {
                                        return e;
                                    },
                                    onClick: void 0
                                }
                            },
                            pie: {
                                customScale: 1,
                                offsetX: 0,
                                offsetY: 0,
                                startAngle: 0,
                                endAngle: 360,
                                expandOnClick: !0,
                                dataLabels: {
                                    offset: 0,
                                    minAngleToShowLabel: 10
                                },
                                donut: {
                                    size: "65%",
                                    background: "transparent",
                                    labels: {
                                        show: !1,
                                        name: {
                                            show: !0,
                                            fontSize: "16px",
                                            fontFamily: void 0,
                                            fontWeight: 600,
                                            color: void 0,
                                            offsetY: -10,
                                            formatter: function(e) {
                                                return e;
                                            }
                                        },
                                        value: {
                                            show: !0,
                                            fontSize: "20px",
                                            fontFamily: void 0,
                                            fontWeight: 400,
                                            color: void 0,
                                            offsetY: 10,
                                            formatter: function(e) {
                                                return e;
                                            }
                                        },
                                        total: {
                                            show: !1,
                                            showAlways: !1,
                                            label: "Total",
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            fontFamily: void 0,
                                            color: void 0,
                                            formatter: function(e) {
                                                return e.globals.seriesTotals.reduce(function(t, i) {
                                                    return t + i;
                                                }, 0);
                                            }
                                        }
                                    }
                                }
                            },
                            polarArea: {
                                rings: {
                                    strokeWidth: 1,
                                    strokeColor: "#e8e8e8"
                                },
                                spokes: {
                                    strokeWidth: 1,
                                    connectorColors: "#e8e8e8"
                                }
                            },
                            radar: {
                                size: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                polygons: {
                                    strokeWidth: 1,
                                    strokeColors: "#e8e8e8",
                                    connectorColors: "#e8e8e8",
                                    fill: {
                                        colors: void 0
                                    }
                                }
                            }
                        },
                        colors: void 0,
                        dataLabels: {
                            enabled: !0,
                            enabledOnSeries: void 0,
                            formatter: function(e) {
                                return e !== null ? e : "";
                            },
                            textAnchor: "middle",
                            distributed: !1,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0,
                                fontWeight: 600,
                                colors: void 0
                            },
                            background: {
                                enabled: !0,
                                foreColor: "#fff",
                                borderRadius: 2,
                                padding: 4,
                                opacity: 0.9,
                                borderWidth: 1,
                                borderColor: "#fff",
                                dropShadow: {
                                    enabled: !1,
                                    top: 1,
                                    left: 1,
                                    blur: 1,
                                    color: "#000",
                                    opacity: 0.45
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: 0.45
                            }
                        },
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: 0.85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: 0.5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            },
                            image: {
                                src: [],
                                width: void 0,
                                height: void 0
                            },
                            pattern: {
                                style: "squares",
                                width: 6,
                                height: 6,
                                strokeWidth: 2
                            }
                        },
                        forecastDataPoints: {
                            count: 0,
                            fillOpacity: 0.5,
                            strokeWidth: void 0,
                            dashArray: 4
                        },
                        grid: {
                            show: !0,
                            borderColor: "#e0e0e0",
                            strokeDashArray: 0,
                            position: "back",
                            xaxis: {
                                lines: {
                                    show: !1
                                }
                            },
                            yaxis: {
                                lines: {
                                    show: !0
                                }
                            },
                            row: {
                                colors: void 0,
                                opacity: 0.5
                            },
                            column: {
                                colors: void 0,
                                opacity: 0.5
                            },
                            padding: {
                                top: 0,
                                right: 10,
                                bottom: 0,
                                left: 12
                            }
                        },
                        labels: [],
                        legend: {
                            show: !0,
                            showForSingleSeries: !1,
                            showForNullSeries: !0,
                            showForZeroSeries: !0,
                            floating: !1,
                            position: "bottom",
                            horizontalAlign: "center",
                            inverseOrder: !1,
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 400,
                            width: void 0,
                            height: void 0,
                            formatter: void 0,
                            tooltipHoverFormatter: void 0,
                            offsetX: -20,
                            offsetY: 4,
                            customLegendItems: [],
                            labels: {
                                colors: void 0,
                                useSeriesColors: !1
                            },
                            markers: {
                                width: 12,
                                height: 12,
                                strokeWidth: 0,
                                fillColors: void 0,
                                strokeColor: "#fff",
                                radius: 12,
                                customHTML: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                onClick: void 0
                            },
                            itemMargin: {
                                horizontal: 5,
                                vertical: 2
                            },
                            onItemClick: {
                                toggleDataSeries: !0
                            },
                            onItemHover: {
                                highlightDataSeries: !0
                            }
                        },
                        markers: {
                            discrete: [],
                            size: 0,
                            colors: void 0,
                            strokeColors: "#fff",
                            strokeWidth: 2,
                            strokeOpacity: 0.9,
                            strokeDashArray: 0,
                            fillOpacity: 1,
                            shape: "circle",
                            width: 8,
                            height: 8,
                            radius: 2,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0,
                            onDblClick: void 0,
                            showNullDataPoints: !0,
                            hover: {
                                size: void 0,
                                sizeOffset: 3
                            }
                        },
                        noData: {
                            text: void 0,
                            align: "center",
                            verticalAlign: "middle",
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "14px",
                                fontFamily: void 0
                            }
                        },
                        responsive: [],
                        series: void 0,
                        states: {
                            normal: {
                                filter: {
                                    type: "none",
                                    value: 0
                                }
                            },
                            hover: {
                                filter: {
                                    type: "lighten",
                                    value: 0.1
                                }
                            },
                            active: {
                                allowMultipleDataPointsSelection: !1,
                                filter: {
                                    type: "darken",
                                    value: 0.5
                                }
                            }
                        },
                        title: {
                            text: void 0,
                            align: "left",
                            margin: 5,
                            offsetX: 0,
                            offsetY: 0,
                            floating: !1,
                            style: {
                                fontSize: "14px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                color: void 0
                            }
                        },
                        subtitle: {
                            text: void 0,
                            align: "left",
                            margin: 5,
                            offsetX: 0,
                            offsetY: 30,
                            floating: !1,
                            style: {
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                color: void 0
                            }
                        },
                        stroke: {
                            show: !0,
                            curve: "smooth",
                            lineCap: "butt",
                            width: 2,
                            colors: void 0,
                            dashArray: 0,
                            fill: {
                                type: "solid",
                                colors: void 0,
                                opacity: 0.85,
                                gradient: {
                                    shade: "dark",
                                    type: "horizontal",
                                    shadeIntensity: 0.5,
                                    gradientToColors: void 0,
                                    inverseColors: !0,
                                    opacityFrom: 1,
                                    opacityTo: 1,
                                    stops: [
                                        0,
                                        50,
                                        100
                                    ],
                                    colorStops: []
                                }
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            enabledOnSeries: void 0,
                            shared: !0,
                            hideEmptySeries: !1,
                            followCursor: !1,
                            intersect: !1,
                            inverseOrder: !1,
                            custom: void 0,
                            fillSeriesColor: !1,
                            theme: "light",
                            cssClass: "",
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            },
                            onDatasetHover: {
                                highlightDataSeries: !1
                            },
                            x: {
                                show: !0,
                                format: "dd MMM",
                                formatter: void 0
                            },
                            y: {
                                formatter: void 0,
                                title: {
                                    formatter: function(e) {
                                        return e ? e + ": " : "";
                                    }
                                }
                            },
                            z: {
                                formatter: void 0,
                                title: "Size: "
                            },
                            marker: {
                                show: !0,
                                fillColors: void 0
                            },
                            items: {
                                display: "flex"
                            },
                            fixed: {
                                enabled: !1,
                                position: "topRight",
                                offsetX: 0,
                                offsetY: 0
                            }
                        },
                        xaxis: {
                            type: "category",
                            categories: [],
                            convertedCatToNumeric: !1,
                            offsetX: 0,
                            offsetY: 0,
                            overwriteCategories: void 0,
                            labels: {
                                show: !0,
                                rotate: -45,
                                rotateAlways: !1,
                                hideOverlappingLabels: !0,
                                trim: !1,
                                minHeight: void 0,
                                maxHeight: 120,
                                showDuplicates: !0,
                                style: {
                                    colors: [],
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    fontFamily: void 0,
                                    cssClass: ""
                                },
                                offsetX: 0,
                                offsetY: 0,
                                format: void 0,
                                formatter: void 0,
                                datetimeUTC: !0,
                                datetimeFormatter: {
                                    year: "yyyy",
                                    month: "MMM 'yy",
                                    day: "dd MMM",
                                    hour: "HH:mm",
                                    minute: "HH:mm:ss",
                                    second: "HH:mm:ss"
                                }
                            },
                            group: {
                                groups: [],
                                style: {
                                    colors: [],
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    fontFamily: void 0,
                                    cssClass: ""
                                }
                            },
                            axisBorder: {
                                show: !0,
                                color: "#e0e0e0",
                                width: "100%",
                                height: 1,
                                offsetX: 0,
                                offsetY: 0
                            },
                            axisTicks: {
                                show: !0,
                                color: "#e0e0e0",
                                height: 6,
                                offsetX: 0,
                                offsetY: 0
                            },
                            stepSize: void 0,
                            tickAmount: void 0,
                            tickPlacement: "on",
                            min: void 0,
                            max: void 0,
                            range: void 0,
                            floating: !1,
                            decimalsInFloat: void 0,
                            position: "bottom",
                            title: {
                                text: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                style: {
                                    color: void 0,
                                    fontSize: "12px",
                                    fontWeight: 900,
                                    fontFamily: void 0,
                                    cssClass: ""
                                }
                            },
                            crosshairs: {
                                show: !0,
                                width: 1,
                                position: "back",
                                opacity: 0.9,
                                stroke: {
                                    color: "#b6b6b6",
                                    width: 1,
                                    dashArray: 3
                                },
                                fill: {
                                    type: "solid",
                                    color: "#B1B9C4",
                                    gradient: {
                                        colorFrom: "#D8E3F0",
                                        colorTo: "#BED1E6",
                                        stops: [
                                            0,
                                            100
                                        ],
                                        opacityFrom: 0.4,
                                        opacityTo: 0.5
                                    }
                                },
                                dropShadow: {
                                    enabled: !1,
                                    left: 0,
                                    top: 0,
                                    blur: 1,
                                    opacity: 0.4
                                }
                            },
                            tooltip: {
                                enabled: !0,
                                offsetY: 0,
                                formatter: void 0,
                                style: {
                                    fontSize: "12px",
                                    fontFamily: void 0
                                }
                            }
                        },
                        yaxis: this.yAxis,
                        theme: {
                            mode: "light",
                            palette: "palette1",
                            monochrome: {
                                enabled: !1,
                                color: "#008FFB",
                                shadeTo: "light",
                                shadeIntensity: 0.65
                            }
                        }
                    };
                }
            }
        ]), y;
    }(), ie = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.graphics = new M(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new ve(this), this.xAxisAnnotations = new Oe(this), this.yAxisAnnotations = new He(this), this.pointsAnnotations = new pe(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
        }
        return Y(y, [
            {
                key: "drawAxesAnnotations",
                value: function() {
                    var e = this.w;
                    if (e.globals.axisCharts) {
                        for(var t = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = e.config.chart.animations.enabled, r = [
                            t,
                            i,
                            a
                        ], n = [
                            i.node,
                            t.node,
                            a.node
                        ], o = 0; o < 3; o++)e.globals.dom.elGraphical.add(r[o]), !s || e.globals.resized || e.globals.dataChanged || e.config.chart.type !== "scatter" && e.config.chart.type !== "bubble" && e.globals.dataPoints > 1 && n[o].classList.add("apexcharts-element-hidden"), e.globals.delayedElements.push({
                            el: n[o],
                            index: 0
                        });
                        this.helpers.annotationsBackground();
                    }
                }
            },
            {
                key: "drawImageAnnos",
                value: function() {
                    var e = this;
                    this.w.config.annotations.images.map(function(t, i) {
                        e.addImage(t, i);
                    });
                }
            },
            {
                key: "drawTextAnnos",
                value: function() {
                    var e = this;
                    this.w.config.annotations.texts.map(function(t, i) {
                        e.addText(t, i);
                    });
                }
            },
            {
                key: "addXaxisAnnotation",
                value: function(e, t, i) {
                    this.xAxisAnnotations.addXaxisAnnotation(e, t, i);
                }
            },
            {
                key: "addYaxisAnnotation",
                value: function(e, t, i) {
                    this.yAxisAnnotations.addYaxisAnnotation(e, t, i);
                }
            },
            {
                key: "addPointAnnotation",
                value: function(e, t, i) {
                    this.pointsAnnotations.addPointAnnotation(e, t, i);
                }
            },
            {
                key: "addText",
                value: function(e, t) {
                    var i = e.x, a = e.y, s = e.text, r = e.textAnchor, n = e.foreColor, o = e.fontSize, h = e.fontFamily, c = e.fontWeight, d = e.cssClass, g = e.backgroundColor, p = e.borderWidth, f = e.strokeDashArray, b = e.borderRadius, m = e.borderColor, w = e.appendTo, A = w === void 0 ? ".apexcharts-svg" : w, l = e.paddingLeft, u = l === void 0 ? 4 : l, x = e.paddingRight, v = x === void 0 ? 4 : x, k = e.paddingBottom, S = k === void 0 ? 2 : k, C = e.paddingTop, L = C === void 0 ? 2 : C, I = this.w, z = this.graphics.drawText({
                        x: i,
                        y: a,
                        text: s,
                        textAnchor: r || "start",
                        fontSize: o || "12px",
                        fontWeight: c || "regular",
                        fontFamily: h || I.config.chart.fontFamily,
                        foreColor: n || I.config.chart.foreColor,
                        cssClass: d
                    }), T = I.globals.dom.baseEl.querySelector(A);
                    T && T.appendChild(z.node);
                    var E = z.bbox();
                    if (s) {
                        var R = this.graphics.drawRect(E.x - u, E.y - L, E.width + u + v, E.height + S + L, b, g || "transparent", 1, p, m, f);
                        T.insertBefore(R.node, z.node);
                    }
                }
            },
            {
                key: "addImage",
                value: function(e, t) {
                    var i = this.w, a = e.path, s = e.x, r = s === void 0 ? 0 : s, n = e.y, o = n === void 0 ? 0 : n, h = e.width, c = h === void 0 ? 20 : h, d = e.height, g = d === void 0 ? 20 : d, p = e.appendTo, f = p === void 0 ? ".apexcharts-svg" : p, b = i.globals.dom.Paper.image(a);
                    b.size(c, g).move(r, o);
                    var m = i.globals.dom.baseEl.querySelector(f);
                    return m && m.appendChild(b.node), b;
                }
            },
            {
                key: "addXaxisAnnotationExternal",
                value: function(e, t, i) {
                    return this.addAnnotationExternal({
                        params: e,
                        pushToMemory: t,
                        context: i,
                        type: "xaxis",
                        contextMethod: i.addXaxisAnnotation
                    }), i;
                }
            },
            {
                key: "addYaxisAnnotationExternal",
                value: function(e, t, i) {
                    return this.addAnnotationExternal({
                        params: e,
                        pushToMemory: t,
                        context: i,
                        type: "yaxis",
                        contextMethod: i.addYaxisAnnotation
                    }), i;
                }
            },
            {
                key: "addPointAnnotationExternal",
                value: function(e, t, i) {
                    return this.invertAxis === void 0 && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                        params: e,
                        pushToMemory: t,
                        context: i,
                        type: "point",
                        contextMethod: i.addPointAnnotation
                    }), i;
                }
            },
            {
                key: "addAnnotationExternal",
                value: function(e) {
                    var t = e.params, i = e.pushToMemory, a = e.context, s = e.type, r = e.contextMethod, n = a, o = n.w, h = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), c = h.childNodes.length + 1, d = new G(), g = Object.assign({}, s === "xaxis" ? d.xAxisAnnotation : s === "yaxis" ? d.yAxisAnnotation : d.pointAnnotation), p = P.extend(g, t);
                    switch(s){
                        case "xaxis":
                            this.addXaxisAnnotation(p, h, c);
                            break;
                        case "yaxis":
                            this.addYaxisAnnotation(p, h, c);
                            break;
                        case "point":
                            this.addPointAnnotation(p, h, c);
                    }
                    var f = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(c, "']")), b = this.helpers.addBackgroundToAnno(f, p);
                    return b && h.insertBefore(b.node, f), i && o.globals.memory.methodsToExec.push({
                        context: n,
                        id: p.id ? p.id : P.randomId(),
                        method: r,
                        label: "addAnnotation",
                        params: t
                    }), a;
                }
            },
            {
                key: "clearAnnotations",
                value: function(e) {
                    var t = e.w, i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                    t.globals.memory.methodsToExec.map(function(a, s) {
                        a.label !== "addText" && a.label !== "addAnnotation" || t.globals.memory.methodsToExec.splice(s, 1);
                    }), i = P.listToArray(i), Array.prototype.forEach.call(i, function(a) {
                        for(; a.firstChild;)a.removeChild(a.firstChild);
                    });
                }
            },
            {
                key: "removeAnnotation",
                value: function(e, t) {
                    var i = e.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(t));
                    a && (i.globals.memory.methodsToExec.map(function(s, r) {
                        s.id === t && i.globals.memory.methodsToExec.splice(r, 1);
                    }), Array.prototype.forEach.call(a, function(s) {
                        s.parentElement.removeChild(s);
                    }));
                }
            }
        ]), y;
    }(), B = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.months31 = [
                1,
                3,
                5,
                7,
                8,
                10,
                12
            ], this.months30 = [
                2,
                4,
                6,
                9,
                11
            ], this.daysCntOfYear = [
                0,
                31,
                59,
                90,
                120,
                151,
                181,
                212,
                243,
                273,
                304,
                334
            ];
        }
        return Y(y, [
            {
                key: "isValidDate",
                value: function(e) {
                    return typeof e != "number" && !isNaN(this.parseDate(e));
                }
            },
            {
                key: "getTimeStamp",
                value: function(e) {
                    return Date.parse(e) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(e).toISOString().substr(0, 25)).getTime() : new Date(e).getTime() : e;
                }
            },
            {
                key: "getDate",
                value: function(e) {
                    return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(e).toUTCString()) : new Date(e);
                }
            },
            {
                key: "parseDate",
                value: function(e) {
                    var t = Date.parse(e);
                    if (!isNaN(t)) return this.getTimeStamp(e);
                    var i = Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                    return i = this.getTimeStamp(i);
                }
            },
            {
                key: "parseDateWithTimezone",
                value: function(e) {
                    return Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                }
            },
            {
                key: "formatDate",
                value: function(e, t) {
                    var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                        "\0"
                    ].concat(J(i.months)), r = [
                        "\x01"
                    ].concat(J(i.shortMonths)), n = [
                        "\x02"
                    ].concat(J(i.days)), o = [
                        "\x03"
                    ].concat(J(i.shortDays));
                    function h(S, C) {
                        var L = S + "";
                        for(C = C || 2; L.length < C;)L = "0" + L;
                        return L;
                    }
                    var c = a ? e.getUTCFullYear() : e.getFullYear();
                    t = (t = (t = t.replace(/(^|[^\\])yyyy+/g, "$1" + c)).replace(/(^|[^\\])yy/g, "$1" + c.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + c);
                    var d = (a ? e.getUTCMonth() : e.getMonth()) + 1;
                    t = (t = (t = (t = t.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + h(d))).replace(/(^|[^\\])M/g, "$1" + d);
                    var g = a ? e.getUTCDate() : e.getDate();
                    t = (t = (t = (t = t.replace(/(^|[^\\])dddd+/g, "$1" + n[0])).replace(/(^|[^\\])ddd/g, "$1" + o[0])).replace(/(^|[^\\])dd/g, "$1" + h(g))).replace(/(^|[^\\])d/g, "$1" + g);
                    var p = a ? e.getUTCHours() : e.getHours(), f = p > 12 ? p - 12 : p === 0 ? 12 : p;
                    t = (t = (t = (t = t.replace(/(^|[^\\])HH+/g, "$1" + h(p))).replace(/(^|[^\\])H/g, "$1" + p)).replace(/(^|[^\\])hh+/g, "$1" + h(f))).replace(/(^|[^\\])h/g, "$1" + f);
                    var b = a ? e.getUTCMinutes() : e.getMinutes();
                    t = (t = t.replace(/(^|[^\\])mm+/g, "$1" + h(b))).replace(/(^|[^\\])m/g, "$1" + b);
                    var m = a ? e.getUTCSeconds() : e.getSeconds();
                    t = (t = t.replace(/(^|[^\\])ss+/g, "$1" + h(m))).replace(/(^|[^\\])s/g, "$1" + m);
                    var w = a ? e.getUTCMilliseconds() : e.getMilliseconds();
                    t = t.replace(/(^|[^\\])fff+/g, "$1" + h(w, 3)), w = Math.round(w / 10), t = t.replace(/(^|[^\\])ff/g, "$1" + h(w)), w = Math.round(w / 10);
                    var A = p < 12 ? "AM" : "PM";
                    t = (t = (t = t.replace(/(^|[^\\])f/g, "$1" + w)).replace(/(^|[^\\])TT+/g, "$1" + A)).replace(/(^|[^\\])T/g, "$1" + A.charAt(0));
                    var l = A.toLowerCase();
                    t = (t = t.replace(/(^|[^\\])tt+/g, "$1" + l)).replace(/(^|[^\\])t/g, "$1" + l.charAt(0));
                    var u = -e.getTimezoneOffset(), x = a || !u ? "Z" : u > 0 ? "+" : "-";
                    if (!a) {
                        var v = (u = Math.abs(u)) % 60;
                        x += h(Math.floor(u / 60)) + ":" + h(v);
                    }
                    t = t.replace(/(^|[^\\])K/g, "$1" + x);
                    var k = (a ? e.getUTCDay() : e.getDay()) + 1;
                    return t = (t = (t = (t = (t = t.replace(new RegExp(n[0], "g"), n[k])).replace(new RegExp(o[0], "g"), o[k])).replace(new RegExp(s[0], "g"), s[d])).replace(new RegExp(r[0], "g"), r[d])).replace(/\\(.)/g, "$1");
                }
            },
            {
                key: "getTimeUnitsfromTimestamp",
                value: function(e, t, i) {
                    var a = this.w;
                    a.config.xaxis.min !== void 0 && (e = a.config.xaxis.min), a.config.xaxis.max !== void 0 && (t = a.config.xaxis.max);
                    var s = this.getDate(e), r = this.getDate(t), n = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), o = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                    return {
                        minMillisecond: parseInt(n[6], 10),
                        maxMillisecond: parseInt(o[6], 10),
                        minSecond: parseInt(n[5], 10),
                        maxSecond: parseInt(o[5], 10),
                        minMinute: parseInt(n[4], 10),
                        maxMinute: parseInt(o[4], 10),
                        minHour: parseInt(n[3], 10),
                        maxHour: parseInt(o[3], 10),
                        minDate: parseInt(n[2], 10),
                        maxDate: parseInt(o[2], 10),
                        minMonth: parseInt(n[1], 10) - 1,
                        maxMonth: parseInt(o[1], 10) - 1,
                        minYear: parseInt(n[0], 10),
                        maxYear: parseInt(o[0], 10)
                    };
                }
            },
            {
                key: "isLeapYear",
                value: function(e) {
                    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
                }
            },
            {
                key: "calculcateLastDaysOfMonth",
                value: function(e, t, i) {
                    return this.determineDaysOfMonths(e, t) - i;
                }
            },
            {
                key: "determineDaysOfYear",
                value: function(e) {
                    var t = 365;
                    return this.isLeapYear(e) && (t = 366), t;
                }
            },
            {
                key: "determineRemainingDaysOfYear",
                value: function(e, t, i) {
                    var a = this.daysCntOfYear[t] + i;
                    return t > 1 && this.isLeapYear() && a++, a;
                }
            },
            {
                key: "determineDaysOfMonths",
                value: function(e, t) {
                    var i = 30;
                    switch(e = P.monthMod(e), !0){
                        case this.months30.indexOf(e) > -1:
                            e === 2 && (i = this.isLeapYear(t) ? 29 : 28);
                            break;
                        case this.months31.indexOf(e) > -1:
                        default:
                            i = 31;
                    }
                    return i;
                }
            }
        ]), y;
    }(), re = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
        }
        return Y(y, [
            {
                key: "xLabelFormat",
                value: function(e, t, i, a) {
                    var s = this.w;
                    if (s.config.xaxis.type === "datetime" && s.config.xaxis.labels.formatter === void 0 && s.config.tooltip.x.formatter === void 0) {
                        var r = new B(this.ctx);
                        return r.formatDate(r.getDate(t), s.config.tooltip.x.format);
                    }
                    return e(t, i, a);
                }
            },
            {
                key: "defaultGeneralFormatter",
                value: function(e) {
                    return Array.isArray(e) ? e.map(function(t) {
                        return t;
                    }) : e;
                }
            },
            {
                key: "defaultYFormatter",
                value: function(e, t, i) {
                    var a = this.w;
                    return P.isNumber(e) && (e = a.globals.yValueDecimal !== 0 ? e.toFixed(t.decimalsInFloat !== void 0 ? t.decimalsInFloat : a.globals.yValueDecimal) : a.globals.maxYArr[i] - a.globals.minYArr[i] < 5 ? e.toFixed(1) : e.toFixed(0)), e;
                }
            },
            {
                key: "setLabelFormatters",
                value: function() {
                    var e = this, t = this.w;
                    return t.globals.xaxisTooltipFormatter = function(i) {
                        return e.defaultGeneralFormatter(i);
                    }, t.globals.ttKeyFormatter = function(i) {
                        return e.defaultGeneralFormatter(i);
                    }, t.globals.ttZFormatter = function(i) {
                        return i;
                    }, t.globals.legendFormatter = function(i) {
                        return e.defaultGeneralFormatter(i);
                    }, t.config.xaxis.labels.formatter !== void 0 ? t.globals.xLabelFormatter = t.config.xaxis.labels.formatter : t.globals.xLabelFormatter = function(i) {
                        if (P.isNumber(i)) {
                            if (!t.config.xaxis.convertedCatToNumeric && t.config.xaxis.type === "numeric") {
                                if (P.isNumber(t.config.xaxis.decimalsInFloat)) return i.toFixed(t.config.xaxis.decimalsInFloat);
                                var a = t.globals.maxX - t.globals.minX;
                                return a > 0 && a < 100 ? i.toFixed(1) : i.toFixed(0);
                            }
                            return t.globals.isBarHorizontal && t.globals.maxY - t.globals.minYArr < 4 ? i.toFixed(1) : i.toFixed(0);
                        }
                        return i;
                    }, typeof t.config.tooltip.x.formatter == "function" ? t.globals.ttKeyFormatter = t.config.tooltip.x.formatter : t.globals.ttKeyFormatter = t.globals.xLabelFormatter, typeof t.config.xaxis.tooltip.formatter == "function" && (t.globals.xaxisTooltipFormatter = t.config.xaxis.tooltip.formatter), (Array.isArray(t.config.tooltip.y) || t.config.tooltip.y.formatter !== void 0) && (t.globals.ttVal = t.config.tooltip.y), t.config.tooltip.z.formatter !== void 0 && (t.globals.ttZFormatter = t.config.tooltip.z.formatter), t.config.legend.formatter !== void 0 && (t.globals.legendFormatter = t.config.legend.formatter), t.config.yaxis.forEach(function(i, a) {
                        i.labels.formatter !== void 0 ? t.globals.yLabelFormatters[a] = i.labels.formatter : t.globals.yLabelFormatters[a] = function(s) {
                            return t.globals.xyCharts ? Array.isArray(s) ? s.map(function(r) {
                                return e.defaultYFormatter(r, i, a);
                            }) : e.defaultYFormatter(s, i, a) : s;
                        };
                    }), t.globals;
                }
            },
            {
                key: "heatmapLabelFormatters",
                value: function() {
                    var e = this.w;
                    if (e.config.chart.type === "heatmap") {
                        e.globals.yAxisScale[0].result = e.globals.seriesNames.slice();
                        var t = e.globals.seriesNames.reduce(function(i, a) {
                            return i.length > a.length ? i : a;
                        }, 0);
                        e.globals.yAxisScale[0].niceMax = t, e.globals.yAxisScale[0].niceMin = t;
                    }
                }
            }
        ]), y;
    }(), fe = function(y) {
        var e, t = y.isTimeline, i = y.ctx, a = y.seriesIndex, s = y.dataPointIndex, r = y.y1, n = y.y2, o = y.w, h = o.globals.seriesRangeStart[a][s], c = o.globals.seriesRangeEnd[a][s], d = o.globals.labels[s], g = o.config.series[a].name ? o.config.series[a].name : "", p = o.globals.ttKeyFormatter, f = o.config.tooltip.y.title.formatter, b = {
            w: o,
            seriesIndex: a,
            dataPointIndex: s,
            start: h,
            end: c
        };
        typeof f == "function" && (g = f(g, b)), (e = o.config.series[a].data[s]) !== null && e !== void 0 && e.x && (d = o.config.series[a].data[s].x), t || o.config.xaxis.type === "datetime" && (d = new re(i).xLabelFormat(o.globals.ttKeyFormatter, d, d, {
            i: void 0,
            dateFormatter: new B(i).formatDate,
            w: o
        })), typeof p == "function" && (d = p(d, b)), Number.isFinite(r) && Number.isFinite(n) && (h = r, c = n);
        var m = "", w = "", A = o.globals.colors[a];
        if (o.config.tooltip.x.formatter === void 0) {
            if (o.config.xaxis.type === "datetime") {
                var l = new B(i);
                m = l.formatDate(l.getDate(h), o.config.tooltip.x.format), w = l.formatDate(l.getDate(c), o.config.tooltip.x.format);
            } else m = h, w = c;
        } else m = o.config.tooltip.x.formatter(h), w = o.config.tooltip.x.formatter(c);
        return {
            start: h,
            end: c,
            startVal: m,
            endVal: w,
            ylabel: d,
            color: A,
            seriesName: g
        };
    }, ne = function(y) {
        var e = y.color, t = y.seriesName, i = y.ylabel, a = y.start, s = y.end, r = y.seriesIndex, n = y.dataPointIndex, o = y.ctx.tooltip.tooltipLabels.getFormatters(r);
        a = o.yLbFormatter(a), s = o.yLbFormatter(s);
        var h = o.yLbFormatter(y.w.globals.series[r][n]), c = `<span class="value start-value">
  `.concat(a, `
  </span> <span class="separator">-</span> <span class="value end-value">
  `).concat(s, `
  </span>`);
        return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (t || "") + '</span></div><div> <span class="category">' + i + ": </span> " + (y.w.globals.comboCharts ? y.w.config.series[r].type === "rangeArea" || y.w.config.series[r].type === "rangeBar" ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
    }, oe = function() {
        function y(e) {
            F(this, y), this.opts = e;
        }
        return Y(y, [
            {
                key: "hideYAxis",
                value: function() {
                    this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
                }
            },
            {
                key: "line",
                value: function() {
                    return {
                        chart: {
                            animations: {
                                easing: "swing"
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        stroke: {
                            width: 5,
                            curve: "straight"
                        },
                        markers: {
                            size: 0,
                            hover: {
                                sizeOffset: 6
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    };
                }
            },
            {
                key: "sparkline",
                value: function(e) {
                    return this.hideYAxis(), P.extend(e, {
                        grid: {
                            show: !1,
                            padding: {
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0
                            }
                        },
                        legend: {
                            show: !1
                        },
                        xaxis: {
                            labels: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            },
                            axisBorder: {
                                show: !1
                            },
                            axisTicks: {
                                show: !1
                            }
                        },
                        chart: {
                            toolbar: {
                                show: !1
                            },
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        }
                    });
                }
            },
            {
                key: "bar",
                value: function() {
                    return {
                        chart: {
                            stacked: !1,
                            animations: {
                                easing: "swing"
                            }
                        },
                        plotOptions: {
                            bar: {
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        dataLabels: {
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            },
                            background: {
                                enabled: !1
                            }
                        },
                        stroke: {
                            width: 0,
                            lineCap: "round"
                        },
                        fill: {
                            opacity: 0.85
                        },
                        legend: {
                            markers: {
                                shape: "square",
                                radius: 2,
                                size: 8
                            }
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        xaxis: {
                            tooltip: {
                                enabled: !1
                            },
                            tickPlacement: "between",
                            crosshairs: {
                                width: "barWidth",
                                position: "back",
                                fill: {
                                    type: "gradient"
                                },
                                dropShadow: {
                                    enabled: !1
                                },
                                stroke: {
                                    width: 0
                                }
                            }
                        }
                    };
                }
            },
            {
                key: "funnel",
                value: function() {
                    return this.hideYAxis(), X(X({}, this.bar()), {}, {
                        chart: {
                            animations: {
                                easing: "linear",
                                speed: 800,
                                animateGradually: {
                                    enabled: !1
                                }
                            }
                        },
                        plotOptions: {
                            bar: {
                                horizontal: !0,
                                borderRadiusApplication: "around",
                                borderRadius: 0,
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        grid: {
                            show: !1,
                            padding: {
                                left: 0,
                                right: 0
                            }
                        },
                        xaxis: {
                            labels: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            },
                            axisBorder: {
                                show: !1
                            },
                            axisTicks: {
                                show: !1
                            }
                        }
                    });
                }
            },
            {
                key: "candlestick",
                value: function() {
                    var e = this;
                    return {
                        stroke: {
                            width: 1,
                            colors: [
                                "#333"
                            ]
                        },
                        fill: {
                            opacity: 1
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !0,
                            custom: function(t) {
                                var i = t.seriesIndex, a = t.dataPointIndex, s = t.w;
                                return e._getBoxTooltip(s, i, a, [
                                    "Open",
                                    "High",
                                    "",
                                    "Low",
                                    "Close"
                                ], "candlestick");
                            }
                        },
                        states: {
                            active: {
                                filter: {
                                    type: "none"
                                }
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    };
                }
            },
            {
                key: "boxPlot",
                value: function() {
                    var e = this;
                    return {
                        chart: {
                            animations: {
                                dynamicAnimation: {
                                    enabled: !1
                                }
                            }
                        },
                        stroke: {
                            width: 1,
                            colors: [
                                "#24292e"
                            ]
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !0,
                            custom: function(t) {
                                var i = t.seriesIndex, a = t.dataPointIndex, s = t.w;
                                return e._getBoxTooltip(s, i, a, [
                                    "Minimum",
                                    "Q1",
                                    "Median",
                                    "Q3",
                                    "Maximum"
                                ], "boxPlot");
                            }
                        },
                        markers: {
                            size: 5,
                            strokeWidth: 1,
                            strokeColors: "#111"
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    };
                }
            },
            {
                key: "rangeBar",
                value: function() {
                    return {
                        chart: {
                            animations: {
                                animateGradually: !1
                            }
                        },
                        stroke: {
                            width: 0,
                            lineCap: "square"
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 0,
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        dataLabels: {
                            enabled: !1,
                            formatter: function(e, t) {
                                t.ctx;
                                var i = t.seriesIndex, a = t.dataPointIndex, s = t.w, r = function() {
                                    var n = s.globals.seriesRangeStart[i][a];
                                    return s.globals.seriesRangeEnd[i][a] - n;
                                };
                                return s.globals.comboCharts ? s.config.series[i].type === "rangeBar" || s.config.series[i].type === "rangeArea" ? r() : e : r();
                            },
                            background: {
                                enabled: !1
                            },
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        markers: {
                            size: 10
                        },
                        tooltip: {
                            shared: !1,
                            followCursor: !0,
                            custom: function(e) {
                                return e.w.config.plotOptions && e.w.config.plotOptions.bar && e.w.config.plotOptions.bar.horizontal ? function(t) {
                                    var i = fe(X(X({}, t), {}, {
                                        isTimeline: !0
                                    })), a = i.color, s = i.seriesName, r = i.ylabel, n = i.startVal, o = i.endVal;
                                    return ne(X(X({}, t), {}, {
                                        color: a,
                                        seriesName: s,
                                        ylabel: r,
                                        start: n,
                                        end: o
                                    }));
                                }(e) : function(t) {
                                    var i = fe(t), a = i.color, s = i.seriesName, r = i.ylabel, n = i.start, o = i.end;
                                    return ne(X(X({}, t), {}, {
                                        color: a,
                                        seriesName: s,
                                        ylabel: r,
                                        start: n,
                                        end: o
                                    }));
                                }(e);
                            }
                        },
                        xaxis: {
                            tickPlacement: "between",
                            tooltip: {
                                enabled: !1
                            },
                            crosshairs: {
                                stroke: {
                                    width: 0
                                }
                            }
                        }
                    };
                }
            },
            {
                key: "dumbbell",
                value: function(e) {
                    var t, i;
                    return (t = e.plotOptions.bar) !== null && t !== void 0 && t.barHeight || (e.plotOptions.bar.barHeight = 2), (i = e.plotOptions.bar) !== null && i !== void 0 && i.columnWidth || (e.plotOptions.bar.columnWidth = 2), e;
                }
            },
            {
                key: "area",
                value: function() {
                    return {
                        stroke: {
                            width: 4,
                            fill: {
                                type: "solid",
                                gradient: {
                                    inverseColors: !1,
                                    shade: "light",
                                    type: "vertical",
                                    opacityFrom: 0.65,
                                    opacityTo: 0.5,
                                    stops: [
                                        0,
                                        100,
                                        100
                                    ]
                                }
                            }
                        },
                        fill: {
                            type: "gradient",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: 0.65,
                                opacityTo: 0.5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        },
                        markers: {
                            size: 0,
                            hover: {
                                sizeOffset: 6
                            }
                        },
                        tooltip: {
                            followCursor: !1
                        }
                    };
                }
            },
            {
                key: "rangeArea",
                value: function() {
                    return {
                        stroke: {
                            curve: "straight",
                            width: 0
                        },
                        fill: {
                            type: "solid",
                            opacity: 0.6
                        },
                        markers: {
                            size: 0
                        },
                        states: {
                            hover: {
                                filter: {
                                    type: "none"
                                }
                            },
                            active: {
                                filter: {
                                    type: "none"
                                }
                            }
                        },
                        tooltip: {
                            intersect: !1,
                            shared: !0,
                            followCursor: !0,
                            custom: function(e) {
                                return function(t) {
                                    var i = fe(t), a = i.color, s = i.seriesName, r = i.ylabel, n = i.start, o = i.end;
                                    return ne(X(X({}, t), {}, {
                                        color: a,
                                        seriesName: s,
                                        ylabel: r,
                                        start: n,
                                        end: o
                                    }));
                                }(e);
                            }
                        }
                    };
                }
            },
            {
                key: "brush",
                value: function(e) {
                    return P.extend(e, {
                        chart: {
                            toolbar: {
                                autoSelected: "selection",
                                show: !1
                            },
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        stroke: {
                            width: 1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        xaxis: {
                            tooltip: {
                                enabled: !1
                            }
                        }
                    });
                }
            },
            {
                key: "stacked100",
                value: function(e) {
                    e.dataLabels = e.dataLabels || {}, e.dataLabels.formatter = e.dataLabels.formatter || void 0;
                    var t = e.dataLabels.formatter;
                    return e.yaxis.forEach(function(i, a) {
                        e.yaxis[a].min = 0, e.yaxis[a].max = 100;
                    }), e.chart.type === "bar" && (e.dataLabels.formatter = t || function(i) {
                        return typeof i == "number" && i ? i.toFixed(0) + "%" : i;
                    }), e;
                }
            },
            {
                key: "stackedBars",
                value: function() {
                    var e = this.bar();
                    return X(X({}, e), {}, {
                        plotOptions: X(X({}, e.plotOptions), {}, {
                            bar: X(X({}, e.plotOptions.bar), {}, {
                                borderRadiusApplication: "end",
                                borderRadiusWhenStacked: "last"
                            })
                        })
                    });
                }
            },
            {
                key: "convertCatToNumeric",
                value: function(e) {
                    return e.xaxis.convertedCatToNumeric = !0, e;
                }
            },
            {
                key: "convertCatToNumericXaxis",
                value: function(e, t, i) {
                    e.xaxis.type = "numeric", e.xaxis.labels = e.xaxis.labels || {}, e.xaxis.labels.formatter = e.xaxis.labels.formatter || function(r) {
                        return P.isNumber(r) ? Math.floor(r) : r;
                    };
                    var a = e.xaxis.labels.formatter, s = e.xaxis.categories && e.xaxis.categories.length ? e.xaxis.categories : e.labels;
                    return i && i.length && (s = i.map(function(r) {
                        return Array.isArray(r) ? r : String(r);
                    })), s && s.length && (e.xaxis.labels.formatter = function(r) {
                        return P.isNumber(r) ? a(s[Math.floor(r) - 1]) : a(r);
                    }), e.xaxis.categories = [], e.labels = [], e.xaxis.tickAmount = e.xaxis.tickAmount || "dataPoints", e;
                }
            },
            {
                key: "bubble",
                value: function() {
                    return {
                        dataLabels: {
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        xaxis: {
                            crosshairs: {
                                width: 0
                            }
                        },
                        fill: {
                            type: "solid",
                            gradient: {
                                shade: "light",
                                inverse: !0,
                                shadeIntensity: 0.55,
                                opacityFrom: 0.4,
                                opacityTo: 0.8
                            }
                        }
                    };
                }
            },
            {
                key: "scatter",
                value: function() {
                    return {
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        markers: {
                            size: 6,
                            strokeWidth: 1,
                            hover: {
                                sizeOffset: 2
                            }
                        }
                    };
                }
            },
            {
                key: "heatmap",
                value: function() {
                    return {
                        chart: {
                            stacked: !1
                        },
                        fill: {
                            opacity: 1
                        },
                        dataLabels: {
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        stroke: {
                            colors: [
                                "#fff"
                            ]
                        },
                        tooltip: {
                            followCursor: !0,
                            marker: {
                                show: !1
                            },
                            x: {
                                show: !1
                            }
                        },
                        legend: {
                            position: "top",
                            markers: {
                                shape: "square",
                                size: 10,
                                offsetY: 2
                            }
                        },
                        grid: {
                            padding: {
                                right: 20
                            }
                        }
                    };
                }
            },
            {
                key: "treemap",
                value: function() {
                    return {
                        chart: {
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            style: {
                                fontSize: 14,
                                fontWeight: 600,
                                colors: [
                                    "#fff"
                                ]
                            }
                        },
                        stroke: {
                            show: !0,
                            width: 2,
                            colors: [
                                "#fff"
                            ]
                        },
                        legend: {
                            show: !1
                        },
                        fill: {
                            gradient: {
                                stops: [
                                    0,
                                    100
                                ]
                            }
                        },
                        tooltip: {
                            followCursor: !0,
                            x: {
                                show: !1
                            }
                        },
                        grid: {
                            padding: {
                                left: 0,
                                right: 0
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            }
                        }
                    };
                }
            },
            {
                key: "pie",
                value: function() {
                    return {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        plotOptions: {
                            pie: {
                                donut: {
                                    labels: {
                                        show: !1
                                    }
                                }
                            }
                        },
                        dataLabels: {
                            formatter: function(e) {
                                return e.toFixed(1) + "%";
                            },
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            },
                            background: {
                                enabled: !1
                            },
                            dropShadow: {
                                enabled: !0
                            }
                        },
                        stroke: {
                            colors: [
                                "#fff"
                            ]
                        },
                        fill: {
                            opacity: 1,
                            gradient: {
                                shade: "light",
                                stops: [
                                    0,
                                    100
                                ]
                            }
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    };
                }
            },
            {
                key: "donut",
                value: function() {
                    return {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        dataLabels: {
                            formatter: function(e) {
                                return e.toFixed(1) + "%";
                            },
                            style: {
                                colors: [
                                    "#fff"
                                ]
                            },
                            background: {
                                enabled: !1
                            },
                            dropShadow: {
                                enabled: !0
                            }
                        },
                        stroke: {
                            colors: [
                                "#fff"
                            ]
                        },
                        fill: {
                            opacity: 1,
                            gradient: {
                                shade: "light",
                                shadeIntensity: 0.35,
                                stops: [
                                    80,
                                    100
                                ],
                                opacityFrom: 1,
                                opacityTo: 1
                            }
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    };
                }
            },
            {
                key: "polarArea",
                value: function() {
                    return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        dataLabels: {
                            formatter: function(e) {
                                return e.toFixed(1) + "%";
                            },
                            enabled: !1
                        },
                        stroke: {
                            show: !0,
                            width: 2
                        },
                        fill: {
                            opacity: 0.7
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    };
                }
            },
            {
                key: "radar",
                value: function() {
                    return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                        dataLabels: {
                            enabled: !1,
                            style: {
                                fontSize: "11px"
                            }
                        },
                        stroke: {
                            width: 2
                        },
                        markers: {
                            size: 3,
                            strokeWidth: 1,
                            strokeOpacity: 1
                        },
                        fill: {
                            opacity: 0.2
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0,
                            followCursor: !0
                        },
                        grid: {
                            show: !1
                        },
                        xaxis: {
                            labels: {
                                formatter: function(e) {
                                    return e;
                                },
                                style: {
                                    colors: [
                                        "#a8a8a8"
                                    ],
                                    fontSize: "11px"
                                }
                            },
                            tooltip: {
                                enabled: !1
                            },
                            crosshairs: {
                                show: !1
                            }
                        }
                    };
                }
            },
            {
                key: "radialBar",
                value: function() {
                    return {
                        chart: {
                            animations: {
                                dynamicAnimation: {
                                    enabled: !0,
                                    speed: 800
                                }
                            },
                            toolbar: {
                                show: !1
                            }
                        },
                        fill: {
                            gradient: {
                                shade: "dark",
                                shadeIntensity: 0.4,
                                inverseColors: !1,
                                type: "diagonal2",
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    70,
                                    98,
                                    100
                                ]
                            }
                        },
                        legend: {
                            show: !1,
                            position: "right"
                        },
                        tooltip: {
                            enabled: !1,
                            fillSeriesColor: !0
                        }
                    };
                }
            },
            {
                key: "_getBoxTooltip",
                value: function(e, t, i, a, s) {
                    var r = e.globals.seriesCandleO[t][i], n = e.globals.seriesCandleH[t][i], o = e.globals.seriesCandleM[t][i], h = e.globals.seriesCandleL[t][i], c = e.globals.seriesCandleC[t][i];
                    return e.config.series[t].type && e.config.series[t].type !== s ? `<div class="apexcharts-custom-tooltip">
          `.concat(e.config.series[t].name ? e.config.series[t].name : "series-" + (t + 1), ": <strong>").concat(e.globals.series[t][i], `</strong>
        </div>`) : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(e.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + n + "</span></div>" + (o ? "<div>".concat(a[2], ': <span class="value">') + o + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + h + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + c + "</span></div></div>";
                }
            }
        ]), y;
    }(), Le = function() {
        function y(e) {
            F(this, y), this.opts = e;
        }
        return Y(y, [
            {
                key: "init",
                value: function(e) {
                    var t = e.responsiveOverride, i = this.opts, a = new G(), s = new oe(i);
                    this.chartType = i.chart.type, i = this.extendYAxis(i), i = this.extendAnnotations(i);
                    var r = a.init(), n = {};
                    if (i && U(i) === "object") {
                        var o, h, c, d, g, p, f, b, m = {};
                        m = [
                            "line",
                            "area",
                            "bar",
                            "candlestick",
                            "boxPlot",
                            "rangeBar",
                            "rangeArea",
                            "bubble",
                            "scatter",
                            "heatmap",
                            "treemap",
                            "pie",
                            "polarArea",
                            "donut",
                            "radar",
                            "radialBar"
                        ].indexOf(i.chart.type) !== -1 ? s[i.chart.type]() : s.line(), (o = i.plotOptions) !== null && o !== void 0 && (h = o.bar) !== null && h !== void 0 && h.isFunnel && (m = s.funnel()), i.chart.stacked && i.chart.type === "bar" && (m = s.stackedBars()), (c = i.chart.brush) !== null && c !== void 0 && c.enabled && (m = s.brush(m)), i.chart.stacked && i.chart.stackType === "100%" && (i = s.stacked100(i)), (d = i.plotOptions) !== null && d !== void 0 && (g = d.bar) !== null && g !== void 0 && g.isDumbbell && (i = s.dumbbell(i)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(i), i.xaxis = i.xaxis || window.Apex.xaxis || {}, t || (i.xaxis.convertedCatToNumeric = !1), ((p = (i = this.checkForCatToNumericXAxis(this.chartType, m, i)).chart.sparkline) !== null && p !== void 0 && p.enabled || (f = window.Apex.chart) !== null && f !== void 0 && (b = f.sparkline) !== null && b !== void 0 && b.enabled) && (m = s.sparkline(m)), n = P.extend(r, m);
                    }
                    var w = P.extend(n, window.Apex);
                    return r = P.extend(w, i), r = this.handleUserInputErrors(r);
                }
            },
            {
                key: "checkForCatToNumericXAxis",
                value: function(e, t, i) {
                    var a, s, r = new oe(i), n = (e === "bar" || e === "boxPlot") && ((a = i.plotOptions) === null || a === void 0 || (s = a.bar) === null || s === void 0 ? void 0 : s.horizontal), o = e === "pie" || e === "polarArea" || e === "donut" || e === "radar" || e === "radialBar" || e === "heatmap", h = i.xaxis.type !== "datetime" && i.xaxis.type !== "numeric", c = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : t.xaxis && t.xaxis.tickPlacement;
                    return n || o || !h || c === "between" || (i = r.convertCatToNumeric(i)), i;
                }
            },
            {
                key: "extendYAxis",
                value: function(e, t) {
                    var i = new G();
                    (e.yaxis === void 0 || !e.yaxis || Array.isArray(e.yaxis) && e.yaxis.length === 0) && (e.yaxis = {}), e.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (e.yaxis = P.extend(e.yaxis, window.Apex.yaxis)), e.yaxis.constructor !== Array ? e.yaxis = [
                        P.extend(i.yAxis, e.yaxis)
                    ] : e.yaxis = P.extendArray(e.yaxis, i.yAxis);
                    var a = !1;
                    e.yaxis.forEach(function(r) {
                        r.logarithmic && (a = !0);
                    });
                    var s = e.series;
                    return t && !s && (s = t.config.series), a && s.length !== e.yaxis.length && s.length && (e.yaxis = s.map(function(r, n) {
                        if (r.name || (s[n].name = "series-".concat(n + 1)), e.yaxis[n]) return e.yaxis[n].seriesName = s[n].name, e.yaxis[n];
                        var o = P.extend(i.yAxis, e.yaxis[0]);
                        return o.show = !1, o;
                    })), a && s.length > 1 && s.length !== e.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), e;
                }
            },
            {
                key: "extendAnnotations",
                value: function(e) {
                    return e.annotations === void 0 && (e.annotations = {}, e.annotations.yaxis = [], e.annotations.xaxis = [], e.annotations.points = []), e = this.extendYAxisAnnotations(e), e = this.extendXAxisAnnotations(e), e = this.extendPointAnnotations(e);
                }
            },
            {
                key: "extendYAxisAnnotations",
                value: function(e) {
                    var t = new G();
                    return e.annotations.yaxis = P.extendArray(e.annotations.yaxis !== void 0 ? e.annotations.yaxis : [], t.yAxisAnnotation), e;
                }
            },
            {
                key: "extendXAxisAnnotations",
                value: function(e) {
                    var t = new G();
                    return e.annotations.xaxis = P.extendArray(e.annotations.xaxis !== void 0 ? e.annotations.xaxis : [], t.xAxisAnnotation), e;
                }
            },
            {
                key: "extendPointAnnotations",
                value: function(e) {
                    var t = new G();
                    return e.annotations.points = P.extendArray(e.annotations.points !== void 0 ? e.annotations.points : [], t.pointAnnotation), e;
                }
            },
            {
                key: "checkForDarkTheme",
                value: function(e) {
                    e.theme && e.theme.mode === "dark" && (e.tooltip || (e.tooltip = {}), e.tooltip.theme !== "light" && (e.tooltip.theme = "dark"), e.chart.foreColor || (e.chart.foreColor = "#f6f7f8"), e.chart.background || (e.chart.background = "#424242"), e.theme.palette || (e.theme.palette = "palette4"));
                }
            },
            {
                key: "handleUserInputErrors",
                value: function(e) {
                    var t = e;
                    if (t.tooltip.shared && t.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                    if (t.chart.type === "bar" && t.plotOptions.bar.horizontal) {
                        if (t.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                        t.yaxis[0].reversed && (t.yaxis[0].opposite = !0), t.xaxis.tooltip.enabled = !1, t.yaxis[0].tooltip.enabled = !1, t.chart.zoom.enabled = !1;
                    }
                    return t.chart.type !== "bar" && t.chart.type !== "rangeBar" || t.tooltip.shared && t.xaxis.crosshairs.width === "barWidth" && t.series.length > 1 && (t.xaxis.crosshairs.width = "tickWidth"), t.chart.type !== "candlestick" && t.chart.type !== "boxPlot" || t.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(t.chart.type, " chart is not supported.")), t.yaxis[0].reversed = !1), t;
                }
            }
        ]), y;
    }(), Ze = function() {
        function y() {
            F(this, y);
        }
        return Y(y, [
            {
                key: "initGlobalVars",
                value: function(e) {
                    e.series = [], e.seriesCandleO = [], e.seriesCandleH = [], e.seriesCandleM = [], e.seriesCandleL = [], e.seriesCandleC = [], e.seriesRangeStart = [], e.seriesRangeEnd = [], e.seriesRange = [], e.seriesPercent = [], e.seriesGoals = [], e.seriesX = [], e.seriesZ = [], e.seriesNames = [], e.seriesTotals = [], e.seriesLog = [], e.seriesColors = [], e.stackedSeriesTotals = [], e.seriesXvalues = [], e.seriesYvalues = [], e.labels = [], e.hasXaxisGroups = !1, e.groups = [], e.hasSeriesGroups = !1, e.seriesGroups = [], e.categoryLabels = [], e.timescaleLabels = [], e.noLabelsProvided = !1, e.resizeTimer = null, e.selectionResizeTimer = null, e.delayedElements = [], e.pointsArray = [], e.dataLabelsRects = [], e.isXNumeric = !1, e.skipLastTimelinelabel = !1, e.skipFirstTimelinelabel = !1, e.isDataXYZ = !1, e.isMultiLineX = !1, e.isMultipleYAxis = !1, e.maxY = -Number.MAX_VALUE, e.minY = Number.MIN_VALUE, e.minYArr = [], e.maxYArr = [], e.maxX = -Number.MAX_VALUE, e.minX = Number.MAX_VALUE, e.initialMaxX = -Number.MAX_VALUE, e.initialMinX = Number.MAX_VALUE, e.maxDate = 0, e.minDate = Number.MAX_VALUE, e.minZ = Number.MAX_VALUE, e.maxZ = -Number.MAX_VALUE, e.minXDiff = Number.MAX_VALUE, e.yAxisScale = [], e.xAxisScale = null, e.xAxisTicksPositions = [], e.yLabelsCoords = [], e.yTitleCoords = [], e.barPadForNumericAxis = 0, e.padHorizontal = 0, e.xRange = 0, e.yRange = [], e.zRange = 0, e.dataPoints = 0, e.xTickAmount = 0;
                }
            },
            {
                key: "globalVars",
                value: function(e) {
                    return {
                        chartID: null,
                        cuid: null,
                        events: {
                            beforeMount: [],
                            mounted: [],
                            updated: [],
                            clicked: [],
                            selection: [],
                            dataPointSelection: [],
                            zoomed: [],
                            scrolled: []
                        },
                        colors: [],
                        clientX: null,
                        clientY: null,
                        fill: {
                            colors: []
                        },
                        stroke: {
                            colors: []
                        },
                        dataLabels: {
                            style: {
                                colors: []
                            }
                        },
                        radarPolygons: {
                            fill: {
                                colors: []
                            }
                        },
                        markers: {
                            colors: [],
                            size: e.markers.size,
                            largestSize: 0
                        },
                        animationEnded: !1,
                        isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                        isDirty: !1,
                        isExecCalled: !1,
                        initialConfig: null,
                        initialSeries: [],
                        lastXAxis: [],
                        lastYAxis: [],
                        columnSeries: null,
                        labels: [],
                        timescaleLabels: [],
                        noLabelsProvided: !1,
                        allSeriesCollapsed: !1,
                        collapsedSeries: [],
                        collapsedSeriesIndices: [],
                        ancillaryCollapsedSeries: [],
                        ancillaryCollapsedSeriesIndices: [],
                        risingSeries: [],
                        dataFormatXNumeric: !1,
                        capturedSeriesIndex: -1,
                        capturedDataPointIndex: -1,
                        selectedDataPoints: [],
                        goldenPadding: 35,
                        invalidLogScale: !1,
                        ignoreYAxisIndexes: [],
                        yAxisSameScaleIndices: [],
                        maxValsInArrayIndex: 0,
                        radialSize: 0,
                        selection: void 0,
                        zoomEnabled: e.chart.toolbar.autoSelected === "zoom" && e.chart.toolbar.tools.zoom && e.chart.zoom.enabled,
                        panEnabled: e.chart.toolbar.autoSelected === "pan" && e.chart.toolbar.tools.pan,
                        selectionEnabled: e.chart.toolbar.autoSelected === "selection" && e.chart.toolbar.tools.selection,
                        yaxis: null,
                        mousedown: !1,
                        lastClientPosition: {},
                        visibleXRange: void 0,
                        yValueDecimal: 0,
                        total: 0,
                        SVGNS: "http://www.w3.org/2000/svg",
                        svgWidth: 0,
                        svgHeight: 0,
                        noData: !1,
                        locale: {},
                        dom: {},
                        memory: {
                            methodsToExec: []
                        },
                        shouldAnimate: !0,
                        skipLastTimelinelabel: !1,
                        skipFirstTimelinelabel: !1,
                        delayedElements: [],
                        axisCharts: !0,
                        isDataXYZ: !1,
                        resized: !1,
                        resizeTimer: null,
                        comboCharts: !1,
                        dataChanged: !1,
                        previousPaths: [],
                        allSeriesHasEqualX: !0,
                        pointsArray: [],
                        dataLabelsRects: [],
                        lastDrawnDataLabelsIndexes: [],
                        hasNullValues: !1,
                        easing: null,
                        zoomed: !1,
                        gridWidth: 0,
                        gridHeight: 0,
                        rotateXLabels: !1,
                        defaultLabels: !1,
                        xLabelFormatter: void 0,
                        yLabelFormatters: [],
                        xaxisTooltipFormatter: void 0,
                        ttKeyFormatter: void 0,
                        ttVal: void 0,
                        ttZFormatter: void 0,
                        LINE_HEIGHT_RATIO: 1.618,
                        xAxisLabelsHeight: 0,
                        xAxisGroupLabelsHeight: 0,
                        xAxisLabelsWidth: 0,
                        yAxisLabelsWidth: 0,
                        scaleX: 1,
                        scaleY: 1,
                        translateX: 0,
                        translateY: 0,
                        translateYAxisX: [],
                        yAxisWidths: [],
                        translateXAxisY: 0,
                        translateXAxisX: 0,
                        tooltip: null
                    };
                }
            },
            {
                key: "init",
                value: function(e) {
                    var t = this.globalVars(e);
                    return this.initGlobalVars(t), t.initialConfig = P.extend({}, e), t.initialSeries = P.clone(e.series), t.lastXAxis = P.clone(t.initialConfig.xaxis), t.lastYAxis = P.clone(t.initialConfig.yaxis), t;
                }
            }
        ]), y;
    }(), ft = function() {
        function y(e) {
            F(this, y), this.opts = e;
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    var e = new Le(this.opts).init({
                        responsiveOverride: !1
                    });
                    return {
                        config: e,
                        globals: new Ze().init(e)
                    };
                }
            }
        ]), y;
    }(), ae = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0;
        }
        return Y(y, [
            {
                key: "clippedImgArea",
                value: function(e) {
                    var t = this.w, i = t.config, a = parseInt(t.globals.gridWidth, 10), s = parseInt(t.globals.gridHeight, 10), r = a > s ? a : s, n = e.image, o = 0, h = 0;
                    e.width === void 0 && e.height === void 0 ? i.fill.image.width !== void 0 && i.fill.image.height !== void 0 ? (o = i.fill.image.width + 1, h = i.fill.image.height) : (o = r + 1, h = r) : (o = e.width, h = e.height);
                    var c = document.createElementNS(t.globals.SVGNS, "pattern");
                    M.setAttrs(c, {
                        id: e.patternID,
                        patternUnits: e.patternUnits ? e.patternUnits : "userSpaceOnUse",
                        width: o + "px",
                        height: h + "px"
                    });
                    var d = document.createElementNS(t.globals.SVGNS, "image");
                    c.appendChild(d), d.setAttributeNS(window.SVG.xlink, "href", n), M.setAttrs(d, {
                        x: 0,
                        y: 0,
                        preserveAspectRatio: "none",
                        width: o + "px",
                        height: h + "px"
                    }), d.style.opacity = e.opacity, t.globals.dom.elDefs.node.appendChild(c);
                }
            },
            {
                key: "getSeriesIndex",
                value: function(e) {
                    var t = this.w, i = t.config.chart.type;
                    return (i === "bar" || i === "rangeBar") && t.config.plotOptions.bar.distributed || i === "heatmap" || i === "treemap" ? this.seriesIndex = e.seriesNumber : this.seriesIndex = e.seriesNumber % t.globals.series.length, this.seriesIndex;
                }
            },
            {
                key: "fillPath",
                value: function(e) {
                    var t = this.w;
                    this.opts = e;
                    var i, a, s, r = this.w.config;
                    this.seriesIndex = this.getSeriesIndex(e);
                    var n = this.getFillColors()[this.seriesIndex];
                    t.globals.seriesColors[this.seriesIndex] !== void 0 && (n = t.globals.seriesColors[this.seriesIndex]), typeof n == "function" && (n = n({
                        seriesIndex: this.seriesIndex,
                        dataPointIndex: e.dataPointIndex,
                        value: e.value,
                        w: t
                    }));
                    var o = e.fillType ? e.fillType : this.getFillType(this.seriesIndex), h = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                    e.color && (n = e.color), n || (n = "#fff", console.warn("undefined color - ApexCharts"));
                    var c = n;
                    if (n.indexOf("rgb") === -1 ? n.length < 9 && (c = P.hexToRgba(n, h)) : n.indexOf("rgba") > -1 && (h = P.getOpacityFromRGBA(n)), e.opacity && (h = e.opacity), o === "pattern" && (a = this.handlePatternFill({
                        fillConfig: e.fillConfig,
                        patternFill: a,
                        fillColor: n,
                        fillOpacity: h,
                        defaultColor: c
                    })), o === "gradient" && (s = this.handleGradientFill({
                        fillConfig: e.fillConfig,
                        fillColor: n,
                        fillOpacity: h,
                        i: this.seriesIndex
                    })), o === "image") {
                        var d = r.fill.image.src, g = e.patternID ? e.patternID : "";
                        this.clippedImgArea({
                            opacity: h,
                            image: Array.isArray(d) ? e.seriesNumber < d.length ? d[e.seriesNumber] : d[0] : d,
                            width: e.width ? e.width : void 0,
                            height: e.height ? e.height : void 0,
                            patternUnits: e.patternUnits,
                            patternID: "pattern".concat(t.globals.cuid).concat(e.seriesNumber + 1).concat(g)
                        }), i = "url(#pattern".concat(t.globals.cuid).concat(e.seriesNumber + 1).concat(g, ")");
                    } else i = o === "gradient" ? s : o === "pattern" ? a : c;
                    return e.solid && (i = c), i;
                }
            },
            {
                key: "getFillType",
                value: function(e) {
                    var t = this.w;
                    return Array.isArray(t.config.fill.type) ? t.config.fill.type[e] : t.config.fill.type;
                }
            },
            {
                key: "getFillColors",
                value: function() {
                    var e = this.w, t = e.config, i = this.opts, a = [];
                    return e.globals.comboCharts ? e.config.series[this.seriesIndex].type === "line" ? Array.isArray(e.globals.stroke.colors) ? a = e.globals.stroke.colors : a.push(e.globals.stroke.colors) : Array.isArray(e.globals.fill.colors) ? a = e.globals.fill.colors : a.push(e.globals.fill.colors) : t.chart.type === "line" ? Array.isArray(e.globals.stroke.colors) ? a = e.globals.stroke.colors : a.push(e.globals.stroke.colors) : Array.isArray(e.globals.fill.colors) ? a = e.globals.fill.colors : a.push(e.globals.fill.colors), i.fillColors !== void 0 && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
                }
            },
            {
                key: "handlePatternFill",
                value: function(e) {
                    var t = e.fillConfig, i = e.patternFill, a = e.fillColor, s = e.fillOpacity, r = e.defaultColor, n = this.w.config.fill;
                    t && (n = t);
                    var o = this.opts, h = new M(this.ctx), c = Array.isArray(n.pattern.strokeWidth) ? n.pattern.strokeWidth[this.seriesIndex] : n.pattern.strokeWidth, d = a;
                    return Array.isArray(n.pattern.style) ? i = n.pattern.style[o.seriesNumber] !== void 0 ? h.drawPattern(n.pattern.style[o.seriesNumber], n.pattern.width, n.pattern.height, d, c, s) : r : i = h.drawPattern(n.pattern.style, n.pattern.width, n.pattern.height, d, c, s), i;
                }
            },
            {
                key: "handleGradientFill",
                value: function(e) {
                    var t = e.fillColor, i = e.fillOpacity, a = e.fillConfig, s = e.i, r = this.w.config.fill;
                    a && (r = X(X({}, r), a));
                    var n, o = this.opts, h = new M(this.ctx), c = new P(), d = r.gradient.type, g = t, p = r.gradient.opacityFrom === void 0 ? i : Array.isArray(r.gradient.opacityFrom) ? r.gradient.opacityFrom[s] : r.gradient.opacityFrom;
                    g.indexOf("rgba") > -1 && (p = P.getOpacityFromRGBA(g));
                    var f = r.gradient.opacityTo === void 0 ? i : Array.isArray(r.gradient.opacityTo) ? r.gradient.opacityTo[s] : r.gradient.opacityTo;
                    if (r.gradient.gradientToColors === void 0 || r.gradient.gradientToColors.length === 0) n = r.gradient.shade === "dark" ? c.shadeColor(-1 * parseFloat(r.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? P.rgb2hex(t) : t) : c.shadeColor(parseFloat(r.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? P.rgb2hex(t) : t);
                    else if (r.gradient.gradientToColors[o.seriesNumber]) {
                        var b = r.gradient.gradientToColors[o.seriesNumber];
                        n = b, b.indexOf("rgba") > -1 && (f = P.getOpacityFromRGBA(b));
                    } else n = t;
                    if (r.gradient.gradientFrom && (g = r.gradient.gradientFrom), r.gradient.gradientTo && (n = r.gradient.gradientTo), r.gradient.inverseColors) {
                        var m = g;
                        g = n, n = m;
                    }
                    return g.indexOf("rgb") > -1 && (g = P.rgb2hex(g)), n.indexOf("rgb") > -1 && (n = P.rgb2hex(n)), h.drawGradient(d, g, n, p, f, o.size, r.gradient.stops, r.gradient.colorStops, s);
                }
            }
        ]), y;
    }(), Pe = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "setGlobalMarkerSize",
                value: function() {
                    var e = this.w;
                    if (e.globals.markers.size = Array.isArray(e.config.markers.size) ? e.config.markers.size : [
                        e.config.markers.size
                    ], e.globals.markers.size.length > 0) {
                        if (e.globals.markers.size.length < e.globals.series.length + 1) for(var t = 0; t <= e.globals.series.length; t++)e.globals.markers.size[t] === void 0 && e.globals.markers.size.push(e.globals.markers.size[0]);
                    } else e.globals.markers.size = e.config.series.map(function(i) {
                        return e.config.markers.size;
                    });
                }
            },
            {
                key: "plotChartMarkers",
                value: function(e, t, i, a) {
                    var s, r = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], n = this.w, o = t, h = e, c = null, d = new M(this.ctx), g = n.config.markers.discrete && n.config.markers.discrete.length;
                    if ((n.globals.markers.size[t] > 0 || r || g) && (c = d.group({
                        class: r || g ? "" : "apexcharts-series-markers"
                    })).attr("clip-path", "url(#gridRectMarkerMask".concat(n.globals.cuid, ")")), Array.isArray(h.x)) for(var p = 0; p < h.x.length; p++){
                        var f = i;
                        i === 1 && p === 0 && (f = 0), i === 1 && p === 1 && (f = 1);
                        var b = "apexcharts-marker";
                        if (n.config.chart.type !== "line" && n.config.chart.type !== "area" || n.globals.comboCharts || n.config.tooltip.intersect || (b += " no-pointer-events"), (Array.isArray(n.config.markers.size) ? n.globals.markers.size[t] > 0 : n.config.markers.size > 0) || r || g) {
                            P.isNumber(h.y[p]) ? b += " w".concat(P.randomId()) : b = "apexcharts-nullpoint";
                            var m = this.getMarkerConfig({
                                cssClass: b,
                                seriesIndex: t,
                                dataPointIndex: f
                            });
                            n.config.series[o].data[f] && (n.config.series[o].data[f].fillColor && (m.pointFillColor = n.config.series[o].data[f].fillColor), n.config.series[o].data[f].strokeColor && (m.pointStrokeColor = n.config.series[o].data[f].strokeColor)), a && (m.pSize = a), (h.x[p] < 0 || h.x[p] > n.globals.gridWidth || h.y[p] < -n.globals.markers.largestSize || h.y[p] > n.globals.gridHeight + n.globals.markers.largestSize) && (m.pSize = 0), (s = d.drawMarker(h.x[p], h.y[p], m)).attr("rel", f), s.attr("j", f), s.attr("index", t), s.node.setAttribute("default-marker-size", m.pSize), new Z(this.ctx).setSelectionFilter(s, t, f), this.addEvents(s), c && c.add(s);
                        } else n.globals.pointsArray[t] === void 0 && (n.globals.pointsArray[t] = []), n.globals.pointsArray[t].push([
                            h.x[p],
                            h.y[p]
                        ]);
                    }
                    return c;
                }
            },
            {
                key: "getMarkerConfig",
                value: function(e) {
                    var t = e.cssClass, i = e.seriesIndex, a = e.dataPointIndex, s = a === void 0 ? null : a, r = e.finishRadius, n = r === void 0 ? null : r, o = this.w, h = this.getMarkerStyle(i), c = o.globals.markers.size[i], d = o.config.markers;
                    return s !== null && d.discrete.length && d.discrete.map(function(g) {
                        g.seriesIndex === i && g.dataPointIndex === s && (h.pointStrokeColor = g.strokeColor, h.pointFillColor = g.fillColor, c = g.size, h.pointShape = g.shape);
                    }), {
                        pSize: n === null ? c : n,
                        pRadius: d.radius,
                        width: Array.isArray(d.width) ? d.width[i] : d.width,
                        height: Array.isArray(d.height) ? d.height[i] : d.height,
                        pointStrokeWidth: Array.isArray(d.strokeWidth) ? d.strokeWidth[i] : d.strokeWidth,
                        pointStrokeColor: h.pointStrokeColor,
                        pointFillColor: h.pointFillColor,
                        shape: h.pointShape || (Array.isArray(d.shape) ? d.shape[i] : d.shape),
                        class: t,
                        pointStrokeOpacity: Array.isArray(d.strokeOpacity) ? d.strokeOpacity[i] : d.strokeOpacity,
                        pointStrokeDashArray: Array.isArray(d.strokeDashArray) ? d.strokeDashArray[i] : d.strokeDashArray,
                        pointFillOpacity: Array.isArray(d.fillOpacity) ? d.fillOpacity[i] : d.fillOpacity,
                        seriesIndex: i
                    };
                }
            },
            {
                key: "addEvents",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx);
                    e.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, e)), e.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, e)), e.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, e)), e.node.addEventListener("click", t.config.markers.onClick), e.node.addEventListener("dblclick", t.config.markers.onDblClick), e.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, e), {
                        passive: !0
                    });
                }
            },
            {
                key: "getMarkerStyle",
                value: function(e) {
                    var t = this.w, i = t.globals.markers.colors, a = t.config.markers.strokeColor || t.config.markers.strokeColors;
                    return {
                        pointStrokeColor: Array.isArray(a) ? a[e] : a,
                        pointFillColor: Array.isArray(i) ? i[e] : i
                    };
                }
            }
        ]), y;
    }(), $e = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled;
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e, t, i) {
                    var a = this.w, s = new M(this.ctx), r = i.realIndex, n = i.pointsPos, o = i.zRatio, h = i.elParent, c = s.group({
                        class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                    });
                    if (c.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(n.x)) for(var d = 0; d < n.x.length; d++){
                        var g = t + 1, p = !0;
                        t === 0 && d === 0 && (g = 0), t === 0 && d === 1 && (g = 1);
                        var f = 0, b = a.globals.markers.size[r];
                        if (o !== 1 / 0) {
                            var m = a.config.plotOptions.bubble;
                            b = a.globals.seriesZ[r][g], m.zScaling && (b /= o), m.minBubbleRadius && b < m.minBubbleRadius && (b = m.minBubbleRadius), m.maxBubbleRadius && b > m.maxBubbleRadius && (b = m.maxBubbleRadius);
                        }
                        a.config.chart.animations.enabled || (f = b);
                        var w = n.x[d], A = n.y[d];
                        if (f = f || 0, A !== null && a.globals.series[r][g] !== void 0 || (p = !1), p) {
                            var l = this.drawPoint(w, A, f, b, r, g, t);
                            c.add(l);
                        }
                        h.add(c);
                    }
                }
            },
            {
                key: "drawPoint",
                value: function(e, t, i, a, s, r, n) {
                    var o = this.w, h = s, c = new de(this.ctx), d = new Z(this.ctx), g = new ae(this.ctx), p = new Pe(this.ctx), f = new M(this.ctx), b = p.getMarkerConfig({
                        cssClass: "apexcharts-marker",
                        seriesIndex: h,
                        dataPointIndex: r,
                        finishRadius: o.config.chart.type === "bubble" || o.globals.comboCharts && o.config.series[s] && o.config.series[s].type === "bubble" ? a : null
                    });
                    a = b.pSize;
                    var m, w = g.fillPath({
                        seriesNumber: s,
                        dataPointIndex: r,
                        color: b.pointFillColor,
                        patternUnits: "objectBoundingBox",
                        value: o.globals.series[s][n]
                    });
                    if (b.shape === "circle" ? m = f.drawCircle(i) : b.shape !== "square" && b.shape !== "rect" || (m = f.drawRect(0, 0, b.width - b.pointStrokeWidth / 2, b.height - b.pointStrokeWidth / 2, b.pRadius)), o.config.series[h].data[r] && o.config.series[h].data[r].fillColor && (w = o.config.series[h].data[r].fillColor), m.attr({
                        x: e - b.width / 2 - b.pointStrokeWidth / 2,
                        y: t - b.height / 2 - b.pointStrokeWidth / 2,
                        cx: e,
                        cy: t,
                        fill: w,
                        "fill-opacity": b.pointFillOpacity,
                        stroke: b.pointStrokeColor,
                        r: a,
                        "stroke-width": b.pointStrokeWidth,
                        "stroke-dasharray": b.pointStrokeDashArray,
                        "stroke-opacity": b.pointStrokeOpacity
                    }), o.config.chart.dropShadow.enabled) {
                        var A = o.config.chart.dropShadow;
                        d.dropShadow(m, A, s);
                    }
                    if (!this.initialAnim || o.globals.dataChanged || o.globals.resized) o.globals.animationEnded = !0;
                    else {
                        var l = o.config.chart.animations.speed;
                        c.animateMarker(m, 0, b.shape === "circle" ? a : {
                            width: b.width,
                            height: b.height
                        }, l, o.globals.easing, function() {
                            window.setTimeout(function() {
                                c.animationCompleted(m);
                            }, 100);
                        });
                    }
                    if (o.globals.dataChanged && b.shape === "circle") {
                        if (this.dynamicAnim) {
                            var u, x, v, k, S = o.config.chart.animations.dynamicAnimation.speed;
                            (k = o.globals.previousPaths[s] && o.globals.previousPaths[s][n]) != null && (u = k.x, x = k.y, v = k.r !== void 0 ? k.r : a);
                            for(var C = 0; C < o.globals.collapsedSeries.length; C++)o.globals.collapsedSeries[C].index === s && (S = 1, a = 0);
                            e === 0 && t === 0 && (a = 0), c.animateCircle(m, {
                                cx: u,
                                cy: x,
                                r: v
                            }, {
                                cx: e,
                                cy: t,
                                r: a
                            }, S, o.globals.easing);
                        } else m.attr({
                            r: a
                        });
                    }
                    return m.attr({
                        rel: r,
                        j: r,
                        index: s,
                        "default-marker-size": a
                    }), d.setSelectionFilter(m, s, r), p.addEvents(m), m.node.classList.add("apexcharts-marker"), m;
                }
            },
            {
                key: "centerTextInBubble",
                value: function(e) {
                    var t = this.w;
                    return {
                        y: e += parseInt(t.config.dataLabels.style.fontSize, 10) / 4
                    };
                }
            }
        ]), y;
    }(), ye = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "dataLabelsCorrection",
                value: function(e, t, i, a, s, r, n) {
                    var o = this.w, h = !1, c = new M(this.ctx).getTextRects(i, n), d = c.width, g = c.height;
                    t < 0 && (t = 0), t > o.globals.gridHeight + g && (t = o.globals.gridHeight + g / 2), o.globals.dataLabelsRects[a] === void 0 && (o.globals.dataLabelsRects[a] = []), o.globals.dataLabelsRects[a].push({
                        x: e,
                        y: t,
                        width: d,
                        height: g
                    });
                    var p = o.globals.dataLabelsRects[a].length - 2, f = o.globals.lastDrawnDataLabelsIndexes[a] !== void 0 ? o.globals.lastDrawnDataLabelsIndexes[a][o.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                    if (o.globals.dataLabelsRects[a][p] !== void 0) {
                        var b = o.globals.dataLabelsRects[a][f];
                        (e > b.x + b.width || t > b.y + b.height || t + g < b.y || e + d < b.x) && (h = !0);
                    }
                    return (s === 0 || r) && (h = !0), {
                        x: e,
                        y: t,
                        textRects: c,
                        drawnextLabel: h
                    };
                }
            },
            {
                key: "drawDataLabel",
                value: function(e) {
                    var t = this, i = e.type, a = e.pos, s = e.i, r = e.j, n = e.isRangeStart, o = e.strokeWidth, h = o === void 0 ? 2 : o, c = this.w, d = new M(this.ctx), g = c.config.dataLabels, p = 0, f = 0, b = r, m = null;
                    if (!g.enabled || !Array.isArray(a.x)) return m;
                    m = d.group({
                        class: "apexcharts-data-labels"
                    });
                    for(var w = 0; w < a.x.length; w++)if (p = a.x[w] + g.offsetX, f = a.y[w] + g.offsetY + h, !isNaN(p)) {
                        r === 1 && w === 0 && (b = 0), r === 1 && w === 1 && (b = 1);
                        var A = c.globals.series[s][b];
                        i === "rangeArea" && (A = n ? c.globals.seriesRangeStart[s][b] : c.globals.seriesRangeEnd[s][b]);
                        var l = "", u = function(x) {
                            return c.config.dataLabels.formatter(x, {
                                ctx: t.ctx,
                                seriesIndex: s,
                                dataPointIndex: b,
                                w: c
                            });
                        };
                        c.config.chart.type === "bubble" ? (l = u(A = c.globals.seriesZ[s][b]), f = a.y[w], f = new $e(this.ctx).centerTextInBubble(f, s, b).y) : A !== void 0 && (l = u(A)), this.plotDataLabelsText({
                            x: p,
                            y: f,
                            text: l,
                            i: s,
                            j: b,
                            parent: m,
                            offsetCorrection: !0,
                            dataLabelsConfig: c.config.dataLabels
                        });
                    }
                    return m;
                }
            },
            {
                key: "plotDataLabelsText",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = e.x, s = e.y, r = e.i, n = e.j, o = e.text, h = e.textAnchor, c = e.fontSize, d = e.parent, g = e.dataLabelsConfig, p = e.color, f = e.alwaysDrawDataLabel, b = e.offsetCorrection;
                    if (!(Array.isArray(t.config.dataLabels.enabledOnSeries) && t.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                        var m = {
                            x: a,
                            y: s,
                            drawnextLabel: !0,
                            textRects: null
                        };
                        b && (m = this.dataLabelsCorrection(a, s, o, r, n, f, parseInt(g.style.fontSize, 10))), t.globals.zoomed || (a = m.x, s = m.y), m.textRects && (a < -20 - m.textRects.width || a > t.globals.gridWidth + m.textRects.width + 30) && (o = "");
                        var w = t.globals.dataLabels.style.colors[r];
                        ((t.config.chart.type === "bar" || t.config.chart.type === "rangeBar") && t.config.plotOptions.bar.distributed || t.config.dataLabels.distributed) && (w = t.globals.dataLabels.style.colors[n]), typeof w == "function" && (w = w({
                            series: t.globals.series,
                            seriesIndex: r,
                            dataPointIndex: n,
                            w: t
                        })), p && (w = p);
                        var A = g.offsetX, l = g.offsetY;
                        if (t.config.chart.type !== "bar" && t.config.chart.type !== "rangeBar" || (A = 0, l = 0), m.drawnextLabel) {
                            var u = i.drawText({
                                width: 100,
                                height: parseInt(g.style.fontSize, 10),
                                x: a + A,
                                y: s + l,
                                foreColor: w,
                                textAnchor: h || g.textAnchor,
                                text: o,
                                fontSize: c || g.style.fontSize,
                                fontFamily: g.style.fontFamily,
                                fontWeight: g.style.fontWeight || "normal"
                            });
                            if (u.attr({
                                class: "apexcharts-datalabel",
                                cx: a,
                                cy: s
                            }), g.dropShadow.enabled) {
                                var x = g.dropShadow;
                                new Z(this.ctx).dropShadow(u, x);
                            }
                            d.add(u), t.globals.lastDrawnDataLabelsIndexes[r] === void 0 && (t.globals.lastDrawnDataLabelsIndexes[r] = []), t.globals.lastDrawnDataLabelsIndexes[r].push(n);
                        }
                    }
                }
            },
            {
                key: "addBackgroundToDataLabel",
                value: function(e, t) {
                    var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, n = t.width, o = t.height, h = new M(this.ctx).drawRect(t.x - s, t.y - r / 2, n + 2 * s, o + r, a.borderRadius, i.config.chart.background === "transparent" ? "#fff" : i.config.chart.background, a.opacity, a.borderWidth, a.borderColor);
                    return a.dropShadow.enabled && new Z(this.ctx).dropShadow(h, a.dropShadow), h;
                }
            },
            {
                key: "dataLabelsBackground",
                value: function() {
                    var e = this.w;
                    if (e.config.chart.type !== "bubble") for(var t = e.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < t.length; i++){
                        var a = t[i], s = a.getBBox(), r = null;
                        if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                            a.parentNode.insertBefore(r.node, a);
                            var n = a.getAttribute("fill");
                            e.config.chart.animations.enabled && !e.globals.resized && !e.globals.dataChanged ? r.animate().attr({
                                fill: n
                            }) : r.attr({
                                fill: n
                            }), a.setAttribute("fill", e.config.dataLabels.background.foreColor);
                        }
                    }
                }
            },
            {
                key: "bringForward",
                value: function() {
                    for(var e = this.w, t = e.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = e.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < t.length; a++)i && i.insertBefore(t[a], i.nextSibling);
                }
            }
        ]), y;
    }(), te = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
        }
        return Y(y, [
            {
                key: "getAllSeriesEls",
                value: function() {
                    return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
                }
            },
            {
                key: "getSeriesByName",
                value: function(e) {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(P.escapeString(e), "']"));
                }
            },
            {
                key: "isSeriesHidden",
                value: function(e) {
                    var t = this.getSeriesByName(e), i = parseInt(t.getAttribute("data:realIndex"), 10);
                    return {
                        isHidden: t.classList.contains("apexcharts-series-collapsed"),
                        realIndex: i
                    };
                }
            },
            {
                key: "addCollapsedClassToSeries",
                value: function(e, t) {
                    var i = this.w;
                    function a(s) {
                        for(var r = 0; r < s.length; r++)s[r].index === t && e.node.classList.add("apexcharts-series-collapsed");
                    }
                    a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
                }
            },
            {
                key: "toggleSeries",
                value: function(e) {
                    var t = this.isSeriesHidden(e);
                    return this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, t.isHidden), t.isHidden;
                }
            },
            {
                key: "showSeries",
                value: function(e) {
                    var t = this.isSeriesHidden(e);
                    t.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, !0);
                }
            },
            {
                key: "hideSeries",
                value: function(e) {
                    var t = this.isSeriesHidden(e);
                    t.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, !1);
                }
            },
            {
                key: "resetSeries",
                value: function() {
                    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], a = this.w, s = P.clone(a.globals.initialSeries);
                    a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, e && (t && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
                }
            },
            {
                key: "emptyCollapsedSeries",
                value: function(e) {
                    for(var t = this.w, i = 0; i < e.length; i++)t.globals.collapsedSeriesIndices.indexOf(i) > -1 && (e[i].data = []);
                    return e;
                }
            },
            {
                key: "toggleSeriesOnHover",
                value: function(e, t) {
                    var i = this.w;
                    t || (t = e.target);
                    var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                    if (e.type === "mousemove") {
                        var s = parseInt(t.getAttribute("rel"), 10) - 1, r = null, n = null;
                        i.globals.axisCharts || i.config.chart.type === "radialBar" ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s, "']")), n = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "'] path"));
                        for(var o = 0; o < a.length; o++)a[o].classList.add(this.legendInactiveClass);
                        r !== null && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), n !== null && n.classList.remove(this.legendInactiveClass));
                    } else if (e.type === "mouseout") for(var h = 0; h < a.length; h++)a[h].classList.remove(this.legendInactiveClass);
                }
            },
            {
                key: "highlightRangeInSeries",
                value: function(e, t) {
                    var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(o) {
                        for(var h = 0; h < s.length; h++)s[h].classList[o](i.legendInactiveClass);
                    };
                    if (e.type === "mousemove") {
                        var n = parseInt(t.getAttribute("rel"), 10) - 1;
                        r("add"), function(o) {
                            for(var h = 0; h < s.length; h++){
                                var c = parseInt(s[h].getAttribute("val"), 10);
                                c >= o.from && c <= o.to && s[h].classList.remove(i.legendInactiveClass);
                            }
                        }(a.config.plotOptions.heatmap.colorScale.ranges[n]);
                    } else e.type === "mouseout" && r("remove");
                }
            },
            {
                key: "getActiveConfigSeriesIndex",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "asc", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = this.w, a = 0;
                    if (i.config.series.length > 1) {
                        for(var s = i.config.series.map(function(n, o) {
                            return n.data && n.data.length > 0 && i.globals.collapsedSeriesIndices.indexOf(o) === -1 && (!i.globals.comboCharts || t.length === 0 || t.length && t.indexOf(i.config.series[o].type) > -1) ? o : -1;
                        }), r = e === "asc" ? 0 : s.length - 1; e === "asc" ? r < s.length : r >= 0; e === "asc" ? r++ : r--)if (s[r] !== -1) {
                            a = s[r];
                            break;
                        }
                    }
                    return a;
                }
            },
            {
                key: "getBarSeriesIndices",
                value: function() {
                    return this.w.globals.comboCharts ? this.w.config.series.map(function(e, t) {
                        return e.type === "bar" || e.type === "column" ? t : -1;
                    }).filter(function(e) {
                        return e !== -1;
                    }) : this.w.config.series.map(function(e, t) {
                        return t;
                    });
                }
            },
            {
                key: "getPreviousPaths",
                value: function() {
                    var e = this.w;
                    function t(r, n, o) {
                        for(var h = r[n].childNodes, c = {
                            type: o,
                            paths: [],
                            realIndex: r[n].getAttribute("data:realIndex")
                        }, d = 0; d < h.length; d++)if (h[d].hasAttribute("pathTo")) {
                            var g = h[d].getAttribute("pathTo");
                            c.paths.push({
                                d: g
                            });
                        }
                        e.globals.previousPaths.push(c);
                    }
                    e.globals.previousPaths = [], [
                        "line",
                        "area",
                        "bar",
                        "rangebar",
                        "rangeArea",
                        "candlestick",
                        "radar"
                    ].forEach(function(r) {
                        for(var n, o = (n = r, e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(n, "-series .apexcharts-series"))), h = 0; h < o.length; h++)t(o, h, r);
                    }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                    var i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e.config.chart.type, " .apexcharts-series"));
                    if (i.length > 0) for(var a = function(r) {
                        for(var n = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(r, "'] rect")), o = [], h = function(d) {
                            var g = function(f) {
                                return n[d].getAttribute(f);
                            }, p = {
                                x: parseFloat(g("x")),
                                y: parseFloat(g("y")),
                                width: parseFloat(g("width")),
                                height: parseFloat(g("height"))
                            };
                            o.push({
                                rect: p,
                                color: n[d].getAttribute("color")
                            });
                        }, c = 0; c < n.length; c++)h(c);
                        e.globals.previousPaths.push(o);
                    }, s = 0; s < i.length; s++)a(s);
                    e.globals.axisCharts || (e.globals.previousPaths = e.globals.series);
                }
            },
            {
                key: "handlePrevBubbleScatterPaths",
                value: function(e) {
                    var t = this.w, i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e, "-series .apexcharts-series"));
                    if (i.length > 0) for(var a = 0; a < i.length; a++){
                        for(var s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], n = 0; n < s.length; n++)r.push({
                            x: s[n].getAttribute("cx"),
                            y: s[n].getAttribute("cy"),
                            r: s[n].getAttribute("r")
                        });
                        t.globals.previousPaths.push(r);
                    }
                }
            },
            {
                key: "clearPreviousPaths",
                value: function() {
                    var e = this.w;
                    e.globals.previousPaths = [], e.globals.allSeriesCollapsed = !1;
                }
            },
            {
                key: "handleNoData",
                value: function() {
                    var e = this.w, t = e.config.noData, i = new M(this.ctx), a = e.globals.svgWidth / 2, s = e.globals.svgHeight / 2, r = "middle";
                    if (e.globals.noData = !0, e.globals.animationEnded = !0, t.align === "left" ? (a = 10, r = "start") : t.align === "right" && (a = e.globals.svgWidth - 10, r = "end"), t.verticalAlign === "top" ? s = 50 : t.verticalAlign === "bottom" && (s = e.globals.svgHeight - 50), a += t.offsetX, s = s + parseInt(t.style.fontSize, 10) + 2 + t.offsetY, t.text !== void 0 && t.text !== "") {
                        var n = i.drawText({
                            x: a,
                            y: s,
                            text: t.text,
                            textAnchor: r,
                            fontSize: t.style.fontSize,
                            fontFamily: t.style.fontFamily,
                            foreColor: t.style.color,
                            opacity: 1,
                            class: "apexcharts-text-nodata"
                        });
                        e.globals.dom.Paper.add(n);
                    }
                }
            },
            {
                key: "setNullSeriesToZeroValues",
                value: function(e) {
                    for(var t = this.w, i = 0; i < e.length; i++)if (e[i].length === 0) for(var a = 0; a < e[t.globals.maxValsInArrayIndex].length; a++)e[i].push(0);
                    return e;
                }
            },
            {
                key: "hasAllSeriesEqualX",
                value: function() {
                    for(var e = !0, t = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                        e = !1;
                        break;
                    }
                    return t.globals.allSeriesHasEqualX = e, e;
                }
            },
            {
                key: "filteredSeriesX",
                value: function() {
                    var e = this.w.globals.seriesX.map(function(t) {
                        return t.length > 0 ? t : [];
                    });
                    return e;
                }
            }
        ]), y;
    }(), Je = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new q(this.ctx);
        }
        return Y(y, [
            {
                key: "isMultiFormat",
                value: function() {
                    return this.isFormatXY() || this.isFormat2DArray();
                }
            },
            {
                key: "isFormatXY",
                value: function() {
                    var e = this.w.config.series.slice(), t = new te(this.ctx);
                    if (this.activeSeriesIndex = t.getActiveConfigSeriesIndex(), e[this.activeSeriesIndex].data !== void 0 && e[this.activeSeriesIndex].data.length > 0 && e[this.activeSeriesIndex].data[0] !== null && e[this.activeSeriesIndex].data[0].x !== void 0 && e[this.activeSeriesIndex].data[0] !== null) return !0;
                }
            },
            {
                key: "isFormat2DArray",
                value: function() {
                    var e = this.w.config.series.slice(), t = new te(this.ctx);
                    if (this.activeSeriesIndex = t.getActiveConfigSeriesIndex(), e[this.activeSeriesIndex].data !== void 0 && e[this.activeSeriesIndex].data.length > 0 && e[this.activeSeriesIndex].data[0] !== void 0 && e[this.activeSeriesIndex].data[0] !== null && e[this.activeSeriesIndex].data[0].constructor === Array) return !0;
                }
            },
            {
                key: "handleFormat2DArray",
                value: function(e, t) {
                    for(var i = this.w.config, a = this.w.globals, s = i.chart.type === "boxPlot" || i.series[t].type === "boxPlot", r = 0; r < e[t].data.length; r++)if (e[t].data[r][1] !== void 0 && (Array.isArray(e[t].data[r][1]) && e[t].data[r][1].length === 4 && !s ? this.twoDSeries.push(P.parseNumber(e[t].data[r][1][3])) : e[t].data[r].length >= 5 ? this.twoDSeries.push(P.parseNumber(e[t].data[r][4])) : this.twoDSeries.push(P.parseNumber(e[t].data[r][1])), a.dataFormatXNumeric = !0), i.xaxis.type === "datetime") {
                        var n = new Date(e[t].data[r][0]);
                        n = new Date(n).getTime(), this.twoDSeriesX.push(n);
                    } else this.twoDSeriesX.push(e[t].data[r][0]);
                    for(var o = 0; o < e[t].data.length; o++)e[t].data[o][2] !== void 0 && (this.threeDSeries.push(e[t].data[o][2]), a.isDataXYZ = !0);
                }
            },
            {
                key: "handleFormatXY",
                value: function(e, t) {
                    var i = this.w.config, a = this.w.globals, s = new B(this.ctx), r = t;
                    a.collapsedSeriesIndices.indexOf(t) > -1 && (r = this.activeSeriesIndex);
                    for(var n = 0; n < e[t].data.length; n++)e[t].data[n].y !== void 0 && (Array.isArray(e[t].data[n].y) ? this.twoDSeries.push(P.parseNumber(e[t].data[n].y[e[t].data[n].y.length - 1])) : this.twoDSeries.push(P.parseNumber(e[t].data[n].y))), e[t].data[n].goals !== void 0 && Array.isArray(e[t].data[n].goals) ? (this.seriesGoals[t] === void 0 && (this.seriesGoals[t] = []), this.seriesGoals[t].push(e[t].data[n].goals)) : (this.seriesGoals[t] === void 0 && (this.seriesGoals[t] = []), this.seriesGoals[t].push(null));
                    for(var o = 0; o < e[r].data.length; o++){
                        var h = typeof e[r].data[o].x == "string", c = Array.isArray(e[r].data[o].x), d = !c && !!s.isValidDate(e[r].data[o].x);
                        if (h || d) {
                            if (h || i.xaxis.convertedCatToNumeric) {
                                var g = a.isBarHorizontal && a.isRangeData;
                                i.xaxis.type !== "datetime" || g ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(e[r].data[o].x), isNaN(e[r].data[o].x) || this.w.config.xaxis.type === "category" || typeof e[r].data[o].x == "string" || (a.isXNumeric = !0)) : this.twoDSeriesX.push(s.parseDate(e[r].data[o].x));
                            } else i.xaxis.type === "datetime" ? this.twoDSeriesX.push(s.parseDate(e[r].data[o].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(e[r].data[o].x)));
                        } else c ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(e[r].data[o].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(e[r].data[o].x));
                    }
                    if (e[t].data[0] && e[t].data[0].z !== void 0) {
                        for(var p = 0; p < e[t].data.length; p++)this.threeDSeries.push(e[t].data[p].z);
                        a.isDataXYZ = !0;
                    }
                }
            },
            {
                key: "handleRangeData",
                value: function(e, t) {
                    var i = this.w.globals, a = {};
                    return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", e, t) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", e, t)), i.seriesRangeStart.push(a.start), i.seriesRangeEnd.push(a.end), i.seriesRange.push(a.rangeUniques), i.seriesRange.forEach(function(s, r) {
                        s && s.forEach(function(n, o) {
                            n.y.forEach(function(h, c) {
                                for(var d = 0; d < n.y.length; d++)if (c !== d) {
                                    var g = h.y1, p = h.y2, f = n.y[d].y1;
                                    g <= n.y[d].y2 && f <= p && (n.overlaps.indexOf(h.rangeName) < 0 && n.overlaps.push(h.rangeName), n.overlaps.indexOf(n.y[d].rangeName) < 0 && n.overlaps.push(n.y[d].rangeName));
                                }
                            });
                        });
                    }), a;
                }
            },
            {
                key: "handleCandleStickBoxData",
                value: function(e, t) {
                    var i = this.w.globals, a = {};
                    return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", e, t) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", e, t)), i.seriesCandleO[t] = a.o, i.seriesCandleH[t] = a.h, i.seriesCandleM[t] = a.m, i.seriesCandleL[t] = a.l, i.seriesCandleC[t] = a.c, a;
                }
            },
            {
                key: "handleRangeDataFormat",
                value: function(e, t, i) {
                    var a = [], s = [], r = t[i].data.filter(function(c, d, g) {
                        return d === g.findIndex(function(p) {
                            return p.x === c.x;
                        });
                    }).map(function(c, d) {
                        return {
                            x: c.x,
                            overlaps: [],
                            y: []
                        };
                    });
                    if (e === "array") for(var n = 0; n < t[i].data.length; n++)Array.isArray(t[i].data[n]) ? (a.push(t[i].data[n][1][0]), s.push(t[i].data[n][1][1])) : (a.push(t[i].data[n]), s.push(t[i].data[n]));
                    else if (e === "xy") for(var o = function(c) {
                        var d = Array.isArray(t[i].data[c].y), g = P.randomId(), p = t[i].data[c].x, f = {
                            y1: d ? t[i].data[c].y[0] : t[i].data[c].y,
                            y2: d ? t[i].data[c].y[1] : t[i].data[c].y,
                            rangeName: g
                        };
                        t[i].data[c].rangeName = g;
                        var b = r.findIndex(function(m) {
                            return m.x === p;
                        });
                        r[b].y.push(f), a.push(f.y1), s.push(f.y2);
                    }, h = 0; h < t[i].data.length; h++)o(h);
                    return {
                        start: a,
                        end: s,
                        rangeUniques: r
                    };
                }
            },
            {
                key: "handleCandleStickBoxDataFormat",
                value: function(e, t, i) {
                    var a = this.w, s = a.config.chart.type === "boxPlot" || a.config.series[i].type === "boxPlot", r = [], n = [], o = [], h = [], c = [];
                    if (e === "array") {
                        if (s && t[i].data[0].length === 6 || !s && t[i].data[0].length === 5) for(var d = 0; d < t[i].data.length; d++)r.push(t[i].data[d][1]), n.push(t[i].data[d][2]), s ? (o.push(t[i].data[d][3]), h.push(t[i].data[d][4]), c.push(t[i].data[d][5])) : (h.push(t[i].data[d][3]), c.push(t[i].data[d][4]));
                        else for(var g = 0; g < t[i].data.length; g++)Array.isArray(t[i].data[g][1]) && (r.push(t[i].data[g][1][0]), n.push(t[i].data[g][1][1]), s ? (o.push(t[i].data[g][1][2]), h.push(t[i].data[g][1][3]), c.push(t[i].data[g][1][4])) : (h.push(t[i].data[g][1][2]), c.push(t[i].data[g][1][3])));
                    } else if (e === "xy") for(var p = 0; p < t[i].data.length; p++)Array.isArray(t[i].data[p].y) && (r.push(t[i].data[p].y[0]), n.push(t[i].data[p].y[1]), s ? (o.push(t[i].data[p].y[2]), h.push(t[i].data[p].y[3]), c.push(t[i].data[p].y[4])) : (h.push(t[i].data[p].y[2]), c.push(t[i].data[p].y[3])));
                    return {
                        o: r,
                        h: n,
                        m: o,
                        l: h,
                        c: c
                    };
                }
            },
            {
                key: "parseDataAxisCharts",
                value: function(e) {
                    var t, i = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.ctx, s = this.w.config, r = this.w.globals, n = new B(a), o = s.labels.length > 0 ? s.labels.slice() : s.xaxis.categories.slice();
                    if (r.isRangeBar = s.chart.type === "rangeBar" && r.isBarHorizontal, r.hasXaxisGroups = s.xaxis.type === "category" && s.xaxis.group.groups.length > 0, r.hasXaxisGroups && (r.groups = s.xaxis.group.groups), r.hasSeriesGroups = (t = e[0]) === null || t === void 0 ? void 0 : t.group, r.hasSeriesGroups) {
                        var h = [], c = J(new Set(e.map(function(f) {
                            return f.group;
                        })));
                        e.forEach(function(f, b) {
                            var m = c.indexOf(f.group);
                            h[m] || (h[m] = []), h[m].push(f.name);
                        }), r.seriesGroups = h;
                    }
                    for(var d = function() {
                        for(var f = 0; f < o.length; f++)if (typeof o[f] == "string") {
                            if (!n.isValidDate(o[f])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                            i.twoDSeriesX.push(n.parseDate(o[f]));
                        } else i.twoDSeriesX.push(o[f]);
                    }, g = 0; g < e.length; g++){
                        if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], e[g].data === void 0) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                        if (s.chart.type !== "rangeBar" && s.chart.type !== "rangeArea" && e[g].type !== "rangeBar" && e[g].type !== "rangeArea" || (r.isRangeData = !0, s.chart.type !== "rangeBar" && s.chart.type !== "rangeArea" || this.handleRangeData(e, g)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(e, g) : this.isFormatXY() && this.handleFormatXY(e, g), s.chart.type !== "candlestick" && e[g].type !== "candlestick" && s.chart.type !== "boxPlot" && e[g].type !== "boxPlot" || this.handleCandleStickBoxData(e, g), r.series.push(this.twoDSeries), r.labels.push(this.twoDSeriesX), r.seriesX.push(this.twoDSeriesX), r.seriesGoals = this.seriesGoals, g !== this.activeSeriesIndex || this.fallbackToCategory || (r.isXNumeric = !0);
                        else {
                            s.xaxis.type === "datetime" ? (r.isXNumeric = !0, d(), r.seriesX.push(this.twoDSeriesX)) : s.xaxis.type === "numeric" && (r.isXNumeric = !0, o.length > 0 && (this.twoDSeriesX = o, r.seriesX.push(this.twoDSeriesX))), r.labels.push(this.twoDSeriesX);
                            var p = e[g].data.map(function(f) {
                                return P.parseNumber(f);
                            });
                            r.series.push(p);
                        }
                        r.seriesZ.push(this.threeDSeries), e[g].name !== void 0 ? r.seriesNames.push(e[g].name) : r.seriesNames.push("series-" + parseInt(g + 1, 10)), e[g].color !== void 0 ? r.seriesColors.push(e[g].color) : r.seriesColors.push(void 0);
                    }
                    return this.w;
                }
            },
            {
                key: "parseDataNonAxisCharts",
                value: function(e) {
                    var t = this.w.globals, i = this.w.config;
                    t.series = e.slice(), t.seriesNames = i.labels.slice();
                    for(var a = 0; a < t.series.length; a++)t.seriesNames[a] === void 0 && t.seriesNames.push("series-" + (a + 1));
                    return this.w;
                }
            },
            {
                key: "handleExternalLabelsData",
                value: function(e) {
                    var t = this.w.config, i = this.w.globals;
                    t.xaxis.categories.length > 0 ? i.labels = t.xaxis.categories : t.labels.length > 0 ? i.labels = t.labels.slice() : this.fallbackToCategory ? (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(a) {
                        a.forEach(function(s) {
                            i.labels.indexOf(s.x) < 0 && s.x && i.labels.push(s.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), t.xaxis.convertedCatToNumeric && (new oe(t).convertCatToNumericXaxis(t, this.ctx, i.seriesX[0]), this._generateExternalLabels(e))) : this._generateExternalLabels(e);
                }
            },
            {
                key: "_generateExternalLabels",
                value: function(e) {
                    var t = this.w.globals, i = this.w.config, a = [];
                    if (t.axisCharts) {
                        if (t.series.length > 0) {
                            if (this.isFormatXY()) for(var s = i.series.map(function(d, g) {
                                return d.data.filter(function(p, f, b) {
                                    return b.findIndex(function(m) {
                                        return m.x === p.x;
                                    }) === f;
                                });
                            }), r = s.reduce(function(d, g, p, f) {
                                return f[d].length > g.length ? d : p;
                            }, 0), n = 0; n < s[r].length; n++)a.push(n + 1);
                            else for(var o = 0; o < t.series[t.maxValsInArrayIndex].length; o++)a.push(o + 1);
                        }
                        t.seriesX = [];
                        for(var h = 0; h < e.length; h++)t.seriesX.push(a);
                        this.w.globals.isBarHorizontal || (t.isXNumeric = !0);
                    }
                    if (a.length === 0) {
                        a = t.axisCharts ? [] : t.series.map(function(d, g) {
                            return g + 1;
                        });
                        for(var c = 0; c < e.length; c++)t.seriesX.push(a);
                    }
                    t.labels = a, i.xaxis.convertedCatToNumeric && (t.categoryLabels = a.map(function(d) {
                        return i.xaxis.labels.formatter(d);
                    })), t.noLabelsProvided = !0;
                }
            },
            {
                key: "parseData",
                value: function(e) {
                    var t = this.w, i = t.config, a = t.globals;
                    if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(e), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(e), i.chart.stacked) {
                        var s = new te(this.ctx);
                        a.series = s.setNullSeriesToZeroValues(a.series);
                    }
                    this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), a.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && (i.xaxis.type !== "numeric" || i.labels.length !== 0 || i.xaxis.categories.length !== 0) || this.handleExternalLabelsData(e);
                    for(var r = this.coreUtils.getCategoryLabels(a.labels), n = 0; n < r.length; n++)if (Array.isArray(r[n])) {
                        a.isMultiLineX = !0;
                        break;
                    }
                }
            },
            {
                key: "excludeCollapsedSeriesInYAxis",
                value: function() {
                    var e = this, t = this.w;
                    t.globals.ignoreYAxisIndexes = t.globals.collapsedSeries.map(function(i, a) {
                        if (e.w.globals.isMultipleYAxis && !t.config.chart.stacked) return i.index;
                    });
                }
            }
        ]), y;
    }(), xe = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "getLabel",
                value: function(e, t, i, a) {
                    var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "12px", n = !(arguments.length > 6 && arguments[6] !== void 0) || arguments[6], o = this.w, h = e[a] === void 0 ? "" : e[a], c = h, d = o.globals.xLabelFormatter, g = o.config.xaxis.labels.formatter, p = !1, f = new re(this.ctx), b = h;
                    n && (c = f.xLabelFormat(d, h, b, {
                        i: a,
                        dateFormatter: new B(this.ctx).formatDate,
                        w: o
                    }), g !== void 0 && (c = g(h, e[a], {
                        i: a,
                        dateFormatter: new B(this.ctx).formatDate,
                        w: o
                    })));
                    var m, w;
                    t.length > 0 ? (m = t[a].unit, w = null, t.forEach(function(x) {
                        x.unit === "month" ? w = "year" : x.unit === "day" ? w = "month" : x.unit === "hour" ? w = "day" : x.unit === "minute" && (w = "hour");
                    }), p = w === m, i = t[a].position, c = t[a].value) : o.config.xaxis.type === "datetime" && g === void 0 && (c = ""), c === void 0 && (c = ""), c = Array.isArray(c) ? c : c.toString();
                    var A = new M(this.ctx), l = {};
                    l = o.globals.rotateXLabels && n ? A.getTextRects(c, parseInt(r, 10), null, "rotate(".concat(o.config.xaxis.labels.rotate, " 0 0)"), !1) : A.getTextRects(c, parseInt(r, 10));
                    var u = !o.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                    return !Array.isArray(c) && (c.indexOf("NaN") === 0 || c.toLowerCase().indexOf("invalid") === 0 || c.toLowerCase().indexOf("infinity") >= 0 || s.indexOf(c) >= 0 && u) && (c = ""), {
                        x: i,
                        text: c,
                        textRect: l,
                        isBold: p
                    };
                }
            },
            {
                key: "checkLabelBasedOnTickamount",
                value: function(e, t, i) {
                    var a = this.w, s = a.config.xaxis.tickAmount;
                    return s === "dataPoints" && (s = Math.round(a.globals.gridWidth / 120)), s > i || e % Math.round(i / (s + 1)) == 0 || (t.text = ""), t;
                }
            },
            {
                key: "checkForOverflowingLabels",
                value: function(e, t, i, a, s) {
                    var r = this.w;
                    if (e === 0 && r.globals.skipFirstTimelinelabel && (t.text = ""), e === i - 1 && r.globals.skipLastTimelinelabel && (t.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                        var n = s[s.length - 1];
                        t.x < n.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + n.x && (t.text = "");
                    }
                    return t;
                }
            },
            {
                key: "checkForReversedLabels",
                value: function(e, t) {
                    var i = this.w;
                    return i.config.yaxis[e] && i.config.yaxis[e].reversed && t.reverse(), t;
                }
            },
            {
                key: "isYAxisHidden",
                value: function(e) {
                    var t = this.w, i = new q(this.ctx);
                    return !t.config.yaxis[e].show || !t.config.yaxis[e].showForNullSeries && i.isSeriesNull(e) && t.globals.collapsedSeriesIndices.indexOf(e) === -1;
                }
            },
            {
                key: "getYAxisForeColor",
                value: function(e, t) {
                    var i = this.w;
                    return Array.isArray(e) && i.globals.yAxisScale[t] && this.ctx.theme.pushExtraColors(e, i.globals.yAxisScale[t].result.length, !1), e;
                }
            },
            {
                key: "drawYAxisTicks",
                value: function(e, t, i, a, s, r, n) {
                    var o = this.w, h = new M(this.ctx), c = o.globals.translateY;
                    if (a.show && t > 0) {
                        o.config.yaxis[s].opposite === !0 && (e += a.width);
                        for(var d = t; d >= 0; d--){
                            var g = c + t / 10 + o.config.yaxis[s].labels.offsetY - 1;
                            o.globals.isBarHorizontal && (g = r * d), o.config.chart.type === "heatmap" && (g += r / 2);
                            var p = h.drawLine(e + i.offsetX - a.width + a.offsetX, g + a.offsetY, e + i.offsetX + a.offsetX, g + a.offsetY, a.color);
                            n.add(p), c += r;
                        }
                    }
                }
            }
        ]), y;
    }(), Ee = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "scaleSvgNode",
                value: function(e, t) {
                    var i = parseFloat(e.getAttributeNS(null, "width")), a = parseFloat(e.getAttributeNS(null, "height"));
                    e.setAttributeNS(null, "width", i * t), e.setAttributeNS(null, "height", a * t), e.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
                }
            },
            {
                key: "fixSvgStringForIe11",
                value: function(e) {
                    if (!P.isIE11()) return e.replace(/&nbsp;/g, "&#160;");
                    var t = 0, i = e.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, function(a) {
                        return ++t === 2 ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"' : a;
                    });
                    return i = (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1");
                }
            },
            {
                key: "getSvgString",
                value: function(e) {
                    e == null && (e = 1);
                    var t = this.w.globals.dom.Paper.svg();
                    if (e !== 1) {
                        var i = this.w.globals.dom.Paper.node.cloneNode(!0);
                        this.scaleSvgNode(i, e), t = new XMLSerializer().serializeToString(i);
                    }
                    return this.fixSvgStringForIe11(t);
                }
            },
            {
                key: "cleanup",
                value: function() {
                    var e = this.w, t = e.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = e.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                    Array.prototype.forEach.call(a, function(s) {
                        s.setAttribute("width", 0);
                    }), t && t[0] && (t[0].setAttribute("x", -500), t[0].setAttribute("x1", -500), t[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
                }
            },
            {
                key: "svgUrl",
                value: function() {
                    this.cleanup();
                    var e = this.getSvgString(), t = new Blob([
                        e
                    ], {
                        type: "image/svg+xml;charset=utf-8"
                    });
                    return URL.createObjectURL(t);
                }
            },
            {
                key: "dataURI",
                value: function(e) {
                    var t = this;
                    return new Promise(function(i) {
                        var a = t.w, s = e ? e.scale || e.width / a.globals.svgWidth : 1;
                        t.cleanup();
                        var r = document.createElement("canvas");
                        r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                        var n = a.config.chart.background === "transparent" ? "#fff" : a.config.chart.background, o = r.getContext("2d");
                        o.fillStyle = n, o.fillRect(0, 0, r.width * s, r.height * s);
                        var h = t.getSvgString(s);
                        if (window.canvg && P.isIE11()) {
                            var c = window.canvg.Canvg.fromString(o, h, {
                                ignoreClear: !0,
                                ignoreDimensions: !0
                            });
                            c.start();
                            var d = r.msToBlob();
                            c.stop(), i({
                                blob: d
                            });
                        } else {
                            var g = "data:image/svg+xml," + encodeURIComponent(h), p = new Image();
                            p.crossOrigin = "anonymous", p.onload = function() {
                                if (o.drawImage(p, 0, 0), r.msToBlob) {
                                    var f = r.msToBlob();
                                    i({
                                        blob: f
                                    });
                                } else {
                                    var b = r.toDataURL("image/png");
                                    i({
                                        imgURI: b
                                    });
                                }
                            }, p.src = g;
                        }
                    });
                }
            },
            {
                key: "exportToSVG",
                value: function() {
                    this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg");
                }
            },
            {
                key: "exportToPng",
                value: function() {
                    var e = this;
                    this.dataURI().then(function(t) {
                        var i = t.imgURI, a = t.blob;
                        a ? navigator.msSaveOrOpenBlob(a, e.w.globals.chartID + ".png") : e.triggerDownload(i, e.w.config.chart.toolbar.export.png.filename, ".png");
                    });
                }
            },
            {
                key: "exportToCSV",
                value: function(e) {
                    var t = this, i = e.series, a = e.fileName, s = e.columnDelimiter, r = s === void 0 ? "," : s, n = e.lineDelimiter, o = n === void 0 ? `
` : n, h = this.w;
                    i || (i = h.config.series);
                    var c, d, g = [], p = [], f = "", b = h.globals.series.map(function(v, k) {
                        return h.globals.collapsedSeriesIndices.indexOf(k) === -1 ? v : [];
                    }), m = function(v) {
                        return h.config.xaxis.type === "datetime" && String(v).length >= 10;
                    }, w = Math.max.apply(Math, J(i.map(function(v) {
                        return v.data ? v.data.length : 0;
                    }))), A = new Je(this.ctx), l = new xe(this.ctx), u = function(v) {
                        var k = "";
                        if (h.globals.axisCharts) {
                            if (h.config.xaxis.type === "category" || h.config.xaxis.convertedCatToNumeric) {
                                if (h.globals.isBarHorizontal) {
                                    var S = h.globals.yLabelFormatters[0], C = new te(t.ctx).getActiveConfigSeriesIndex();
                                    k = S(h.globals.labels[v], {
                                        seriesIndex: C,
                                        dataPointIndex: v,
                                        w: h
                                    });
                                } else k = l.getLabel(h.globals.labels, h.globals.timescaleLabels, 0, v).text;
                            }
                            h.config.xaxis.type === "datetime" && (h.config.xaxis.categories.length ? k = h.config.xaxis.categories[v] : h.config.labels.length && (k = h.config.labels[v]));
                        } else k = h.config.labels[v];
                        return Array.isArray(k) && (k = k.join(" ")), P.isNumber(k) ? k : k.split(r).join("");
                    }, x = function(v, k) {
                        if (g.length && k === 0 && p.push(g.join(r)), v.data) {
                            v.data = v.data.length && v.data || J(Array(w)).map(function() {
                                return "";
                            });
                            for(var S = 0; S < v.data.length; S++){
                                g = [];
                                var C = u(S);
                                if (C || (A.isFormatXY() ? C = i[k].data[S].x : A.isFormat2DArray() && (C = i[k].data[S] ? i[k].data[S][0] : "")), k === 0) {
                                    g.push(m(C) ? h.config.chart.toolbar.export.csv.dateFormatter(C) : P.isNumber(C) ? C : C.split(r).join(""));
                                    for(var L = 0; L < h.globals.series.length; L++){
                                        var I;
                                        A.isFormatXY() ? g.push((I = i[L].data[S]) === null || I === void 0 ? void 0 : I.y) : g.push(b[L][S]);
                                    }
                                }
                                (h.config.chart.type === "candlestick" || v.type && v.type === "candlestick") && (g.pop(), g.push(h.globals.seriesCandleO[k][S]), g.push(h.globals.seriesCandleH[k][S]), g.push(h.globals.seriesCandleL[k][S]), g.push(h.globals.seriesCandleC[k][S])), (h.config.chart.type === "boxPlot" || v.type && v.type === "boxPlot") && (g.pop(), g.push(h.globals.seriesCandleO[k][S]), g.push(h.globals.seriesCandleH[k][S]), g.push(h.globals.seriesCandleM[k][S]), g.push(h.globals.seriesCandleL[k][S]), g.push(h.globals.seriesCandleC[k][S])), h.config.chart.type === "rangeBar" && (g.pop(), g.push(h.globals.seriesRangeStart[k][S]), g.push(h.globals.seriesRangeEnd[k][S])), g.length && p.push(g.join(r));
                            }
                        }
                    };
                    g.push(h.config.chart.toolbar.export.csv.headerCategory), h.config.chart.type === "boxPlot" ? (g.push("minimum"), g.push("q1"), g.push("median"), g.push("q3"), g.push("maximum")) : h.config.chart.type === "candlestick" ? (g.push("open"), g.push("high"), g.push("low"), g.push("close")) : h.config.chart.type === "rangeBar" ? (g.push("minimum"), g.push("maximum")) : i.map(function(v, k) {
                        var S = (v.name ? v.name : "series-".concat(k)) + "";
                        h.globals.axisCharts && g.push(S.split(r).join("") ? S.split(r).join("") : "series-".concat(k));
                    }), h.globals.axisCharts || (g.push(h.config.chart.toolbar.export.csv.headerValue), p.push(g.join(r))), h.globals.allSeriesHasEqualX || !h.globals.axisCharts || h.config.xaxis.categories.length || h.config.labels.length ? i.map(function(v, k) {
                        h.globals.axisCharts ? x(v, k) : ((g = []).push(h.globals.labels[k].split(r).join("")), g.push(b[k]), p.push(g.join(r)));
                    }) : (c = /* @__PURE__ */ new Set(), d = {}, i.forEach(function(v, k) {
                        v == null || v.data.forEach(function(S) {
                            var C, L;
                            if (A.isFormatXY()) C = S.x, L = S.y;
                            else {
                                if (!A.isFormat2DArray()) return;
                                C = S[0], L = S[1];
                            }
                            d[C] || (d[C] = Array(i.length).fill("")), d[C][k] = L, c.add(C);
                        });
                    }), g.length && p.push(g.join(r)), Array.from(c).sort().forEach(function(v) {
                        p.push([
                            m(v) && h.config.xaxis.type === "datetime" ? h.config.chart.toolbar.export.csv.dateFormatter(v) : P.isNumber(v) ? v : v.split(r).join(""),
                            d[v].join(r)
                        ]);
                    })), f += p.join(o), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\uFEFF" + f), a || h.config.chart.toolbar.export.csv.filename, ".csv");
                }
            },
            {
                key: "triggerDownload",
                value: function(e, t, i) {
                    var a = document.createElement("a");
                    a.href = e, a.download = (t || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
                }
            }
        ]), y;
    }(), Ie = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.elgrid = t, this.w = e.w;
            var i = this.w;
            this.axesUtils = new xe(e), this.xaxisLabels = i.globals.labels.slice(), i.globals.timescaleLabels.length > 0 && !i.globals.isBarHorizontal && (this.xaxisLabels = i.globals.timescaleLabels.slice()), i.config.xaxis.overwriteCategories && (this.xaxisLabels = i.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], i.config.xaxis.position === "top" ? this.offY = 0 : this.offY = i.globals.gridHeight + 1, this.offY = this.offY + i.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = i.config.chart.type === "bar" && i.config.plotOptions.bar.horizontal, this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.xaxisBorderWidth = i.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = i.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = i.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = i.config.xaxis.axisBorder.height, this.yaxis = i.config.yaxis[0];
        }
        return Y(y, [
            {
                key: "drawXaxis",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = t.group({
                        class: "apexcharts-xaxis",
                        transform: "translate(".concat(e.config.xaxis.offsetX, ", ").concat(e.config.xaxis.offsetY, ")")
                    }), a = t.group({
                        class: "apexcharts-xaxis-texts-g",
                        transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                    });
                    i.add(a);
                    for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                    if (this.drawXAxisLabelAndGroup(!0, t, a, s, e.globals.isXNumeric, function(f, b) {
                        return b;
                    }), e.globals.hasXaxisGroups) {
                        var n = e.globals.groups;
                        s = [];
                        for(var o = 0; o < n.length; o++)s.push(n[o].title);
                        var h = {};
                        e.config.xaxis.group.style && (h.xaxisFontSize = e.config.xaxis.group.style.fontSize, h.xaxisFontFamily = e.config.xaxis.group.style.fontFamily, h.xaxisForeColors = e.config.xaxis.group.style.colors, h.fontWeight = e.config.xaxis.group.style.fontWeight, h.cssClass = e.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, t, a, s, !1, function(f, b) {
                            return n[f].cols * b;
                        }, h);
                    }
                    if (e.config.xaxis.title.text !== void 0) {
                        var c = t.group({
                            class: "apexcharts-xaxis-title"
                        }), d = t.drawText({
                            x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                            y: this.offY + parseFloat(this.xaxisFontSize) + (e.config.xaxis.position === "bottom" ? e.globals.xAxisLabelsHeight : -e.globals.xAxisLabelsHeight - 10) + e.config.xaxis.title.offsetY,
                            text: e.config.xaxis.title.text,
                            textAnchor: "middle",
                            fontSize: e.config.xaxis.title.style.fontSize,
                            fontFamily: e.config.xaxis.title.style.fontFamily,
                            fontWeight: e.config.xaxis.title.style.fontWeight,
                            foreColor: e.config.xaxis.title.style.color,
                            cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                        });
                        c.add(d), i.add(c);
                    }
                    if (e.config.xaxis.axisBorder.show) {
                        var g = e.globals.barPadForNumericAxis, p = t.drawLine(e.globals.padHorizontal + e.config.xaxis.axisBorder.offsetX - g, this.offY, this.xaxisBorderWidth + g, this.offY, e.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                        this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(p) : i.add(p);
                    }
                    return i;
                }
            },
            {
                key: "drawXAxisLabelAndGroup",
                value: function(e, t, i, a, s, r) {
                    var n, o = this, h = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, c = [], d = [], g = this.w, p = h.xaxisFontSize || this.xaxisFontSize, f = h.xaxisFontFamily || this.xaxisFontFamily, b = h.xaxisForeColors || this.xaxisForeColors, m = h.fontWeight || g.config.xaxis.labels.style.fontWeight, w = h.cssClass || g.config.xaxis.labels.style.cssClass, A = g.globals.padHorizontal, l = a.length, u = g.config.xaxis.type === "category" ? g.globals.dataPoints : l;
                    if (u === 0 && l > u && (u = l), s) {
                        var x = u > 1 ? u - 1 : u;
                        n = g.globals.gridWidth / Math.min(x, l - 1), A = A + r(0, n) / 2 + g.config.xaxis.labels.offsetX;
                    } else n = g.globals.gridWidth / u, A = A + r(0, n) + g.config.xaxis.labels.offsetX;
                    for(var v = function(S) {
                        var C = A - r(S, n) / 2 + g.config.xaxis.labels.offsetX;
                        S === 0 && l === 1 && n / 2 === A && u === 1 && (C = g.globals.gridWidth / 2);
                        var L = o.axesUtils.getLabel(a, g.globals.timescaleLabels, C, S, c, p, e), I = 28;
                        if (g.globals.rotateXLabels && e && (I = 22), g.config.xaxis.title.text && g.config.xaxis.position === "top" && (I += parseFloat(g.config.xaxis.title.style.fontSize) + 2), e || (I = I + parseFloat(p) + (g.globals.xAxisLabelsHeight - g.globals.xAxisGroupLabelsHeight) + (g.globals.rotateXLabels ? 10 : 0)), L = g.config.xaxis.tickAmount !== void 0 && g.config.xaxis.tickAmount !== "dataPoints" && g.config.xaxis.type !== "datetime" ? o.axesUtils.checkLabelBasedOnTickamount(S, L, l) : o.axesUtils.checkForOverflowingLabels(S, L, l, c, d), g.config.xaxis.labels.show) {
                            var z = t.drawText({
                                x: L.x,
                                y: o.offY + g.config.xaxis.labels.offsetY + I - (g.config.xaxis.position === "top" ? g.globals.xAxisHeight + g.config.xaxis.axisTicks.height - 2 : 0),
                                text: L.text,
                                textAnchor: "middle",
                                fontWeight: L.isBold ? 600 : m,
                                fontSize: p,
                                fontFamily: f,
                                foreColor: Array.isArray(b) ? e && g.config.xaxis.convertedCatToNumeric ? b[g.globals.minX + S - 1] : b[S] : b,
                                isPlainText: !1,
                                cssClass: (e ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + w
                            });
                            if (i.add(z), z.on("click", function(E) {
                                if (typeof g.config.chart.events.xAxisLabelClick == "function") {
                                    var R = Object.assign({}, g, {
                                        labelIndex: S
                                    });
                                    g.config.chart.events.xAxisLabelClick(E, o.ctx, R);
                                }
                            }), e) {
                                var T = document.createElementNS(g.globals.SVGNS, "title");
                                T.textContent = Array.isArray(L.text) ? L.text.join(" ") : L.text, z.node.appendChild(T), L.text !== "" && (c.push(L.text), d.push(L));
                            }
                        }
                        S < l - 1 && (A += r(S + 1, n));
                    }, k = 0; k <= l - 1; k++)v(k);
                }
            },
            {
                key: "drawXaxisInversed",
                value: function(e) {
                    var t, i, a = this, s = this.w, r = new M(this.ctx), n = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[e] : 0, o = r.group({
                        class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                        rel: e
                    }), h = r.group({
                        class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                        transform: "translate(" + n + ", 0)"
                    });
                    o.add(h);
                    var c = [];
                    if (s.config.yaxis[e].show) for(var d = 0; d < this.xaxisLabels.length; d++)c.push(this.xaxisLabels[d]);
                    t = s.globals.gridHeight / c.length, i = -t / 2.2;
                    var g = s.globals.yLabelFormatters[0], p = s.config.yaxis[0].labels;
                    if (p.show) for(var f = function(x) {
                        var v = c[x] === void 0 ? "" : c[x];
                        v = g(v, {
                            seriesIndex: e,
                            dataPointIndex: x,
                            w: s
                        });
                        var k = a.axesUtils.getYAxisForeColor(p.style.colors, e), S = 0;
                        Array.isArray(v) && (S = v.length / 2 * parseInt(p.style.fontSize, 10));
                        var C = p.offsetX - 15, L = "end";
                        a.yaxis.opposite && (L = "start"), s.config.yaxis[0].labels.align === "left" ? (C = p.offsetX, L = "start") : s.config.yaxis[0].labels.align === "center" ? (C = p.offsetX, L = "middle") : s.config.yaxis[0].labels.align === "right" && (L = "end");
                        var I = r.drawText({
                            x: C,
                            y: i + t + p.offsetY - S,
                            text: v,
                            textAnchor: L,
                            foreColor: Array.isArray(k) ? k[x] : k,
                            fontSize: p.style.fontSize,
                            fontFamily: p.style.fontFamily,
                            fontWeight: p.style.fontWeight,
                            isPlainText: !1,
                            cssClass: "apexcharts-yaxis-label " + p.style.cssClass,
                            maxWidth: p.maxWidth
                        });
                        h.add(I), I.on("click", function(E) {
                            if (typeof s.config.chart.events.xAxisLabelClick == "function") {
                                var R = Object.assign({}, s, {
                                    labelIndex: x
                                });
                                s.config.chart.events.xAxisLabelClick(E, a.ctx, R);
                            }
                        });
                        var z = document.createElementNS(s.globals.SVGNS, "title");
                        if (z.textContent = Array.isArray(v) ? v.join(" ") : v, I.node.appendChild(z), s.config.yaxis[e].labels.rotate !== 0) {
                            var T = r.rotateAroundCenter(I.node);
                            I.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[e].labels.rotate, " 0 ").concat(T.y, ")"));
                        }
                        i += t;
                    }, b = 0; b <= c.length - 1; b++)f(b);
                    if (s.config.yaxis[0].title.text !== void 0) {
                        var m = r.group({
                            class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                            transform: "translate(" + n + ", 0)"
                        }), w = r.drawText({
                            x: s.config.yaxis[0].title.offsetX,
                            y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                            text: s.config.yaxis[0].title.text,
                            textAnchor: "middle",
                            foreColor: s.config.yaxis[0].title.style.color,
                            fontSize: s.config.yaxis[0].title.style.fontSize,
                            fontWeight: s.config.yaxis[0].title.style.fontWeight,
                            fontFamily: s.config.yaxis[0].title.style.fontFamily,
                            cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                        });
                        m.add(w), o.add(m);
                    }
                    var A = 0;
                    this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (A = s.globals.gridWidth);
                    var l = s.config.xaxis.axisBorder;
                    if (l.show) {
                        var u = r.drawLine(s.globals.padHorizontal + l.offsetX + A, 1 + l.offsetY, s.globals.padHorizontal + l.offsetX + A, s.globals.gridHeight + l.offsetY, l.color, 0);
                        this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(u) : o.add(u);
                    }
                    return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(A, c.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, t, o), o;
                }
            },
            {
                key: "drawXaxisTicks",
                value: function(e, t, i) {
                    var a = this.w, s = e;
                    if (!(e < 0 || e - 2 > a.globals.gridWidth)) {
                        var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                        if (t = t + r + a.config.xaxis.axisTicks.height, a.config.xaxis.position === "top" && (t = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                            var n = new M(this.ctx).drawLine(e + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, t + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                            i.add(n), n.node.classList.add("apexcharts-xaxis-tick");
                        }
                    }
                }
            },
            {
                key: "getXAxisTicksPositions",
                value: function() {
                    var e = this.w, t = [], i = this.xaxisLabels.length, a = e.globals.padHorizontal;
                    if (e.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, t.push(a);
                    else for(var r = i, n = 0; n < r; n++){
                        var o = r;
                        e.globals.isXNumeric && e.config.chart.type !== "bar" && (o -= 1), a += e.globals.gridWidth / o, t.push(a);
                    }
                    return t;
                }
            },
            {
                key: "xAxisLabelCorrections",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                    if (e.globals.rotateXLabels || e.config.xaxis.labels.rotateAlways) for(var n = 0; n < a.length; n++){
                        var o = t.rotateAroundCenter(a[n]);
                        o.y = o.y - 1, o.x = o.x + 1, a[n].setAttribute("transform", "rotate(".concat(e.config.xaxis.labels.rotate, " ").concat(o.x, " ").concat(o.y, ")")), a[n].setAttribute("text-anchor", "end"), i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                        var h = a[n].childNodes;
                        e.config.xaxis.labels.trim && Array.prototype.forEach.call(h, function(p) {
                            t.placeTextWithEllipsis(p, p.textContent, e.globals.xAxisLabelsHeight - (e.config.legend.position === "bottom" ? 20 : 10));
                        });
                    }
                    else (function() {
                        for(var p = e.globals.gridWidth / (e.globals.labels.length + 1), f = 0; f < a.length; f++){
                            var b = a[f].childNodes;
                            e.config.xaxis.labels.trim && e.config.xaxis.type !== "datetime" && Array.prototype.forEach.call(b, function(m) {
                                t.placeTextWithEllipsis(m, m.textContent, p);
                            });
                        }
                    })();
                    if (s.length > 0) {
                        var c = s[s.length - 1].getBBox(), d = s[0].getBBox();
                        c.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), d.x + d.width > e.globals.gridWidth && !e.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                        for(var g = 0; g < r.length; g++)t.placeTextWithEllipsis(r[g], r[g].textContent, e.config.yaxis[0].labels.maxWidth - (e.config.yaxis[0].title.text ? 2 * parseFloat(e.config.yaxis[0].title.style.fontSize) : 0) - 15);
                    }
                }
            }
        ]), y;
    }(), Qe = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.xaxisLabels = t.globals.labels.slice(), this.axesUtils = new xe(e), this.isRangeBar = t.globals.seriesRange.length && t.globals.isBarHorizontal, t.globals.timescaleLabels.length > 0 && (this.xaxisLabels = t.globals.timescaleLabels.slice());
        }
        return Y(y, [
            {
                key: "drawGridArea",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = this.w, i = new M(this.ctx);
                    e === null && (e = i.group({
                        class: "apexcharts-grid"
                    }));
                    var a = i.drawLine(t.globals.padHorizontal, 1, t.globals.padHorizontal, t.globals.gridHeight, "transparent"), s = i.drawLine(t.globals.padHorizontal, t.globals.gridHeight, t.globals.gridWidth, t.globals.gridHeight, "transparent");
                    return e.add(s), e.add(a), e;
                }
            },
            {
                key: "drawGrid",
                value: function() {
                    var e = null;
                    return this.w.globals.axisCharts && (e = this.renderGrid(), this.drawGridArea(e.el)), e;
                }
            },
            {
                key: "createGridMask",
                value: function() {
                    var e = this.w, t = e.globals, i = new M(this.ctx), a = Array.isArray(e.config.stroke.width) ? 0 : e.config.stroke.width;
                    if (Array.isArray(e.config.stroke.width)) {
                        var s = 0;
                        e.config.stroke.width.forEach(function(d) {
                            s = Math.max(s, d);
                        }), a = s;
                    }
                    t.dom.elGridRectMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(t.cuid)), t.dom.elGridRectMarkerMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(t.cuid)), t.dom.elForecastMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elForecastMask.setAttribute("id", "forecastMask".concat(t.cuid)), t.dom.elNonForecastMask = document.createElementNS(t.SVGNS, "clipPath"), t.dom.elNonForecastMask.setAttribute("id", "nonForecastMask".concat(t.cuid));
                    var r = e.config.chart.type, n = 0, o = 0;
                    (r === "bar" || r === "rangeBar" || r === "candlestick" || r === "boxPlot" || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && (n = e.config.grid.padding.left, o = e.config.grid.padding.right, t.barPadForNumericAxis > n && (n = t.barPadForNumericAxis, o = t.barPadForNumericAxis)), t.dom.elGridRect = i.drawRect(-a - n - 2, 2 * -a - 2, t.gridWidth + a + o + n + 4, t.gridHeight + 4 * a + 4, 0, "#fff");
                    var h = e.globals.markers.largestSize + 1;
                    t.dom.elGridRectMarker = i.drawRect(2 * -h, 2 * -h, t.gridWidth + 4 * h, t.gridHeight + 4 * h, 0, "#fff"), t.dom.elGridRectMask.appendChild(t.dom.elGridRect.node), t.dom.elGridRectMarkerMask.appendChild(t.dom.elGridRectMarker.node);
                    var c = t.dom.baseEl.querySelector("defs");
                    c.appendChild(t.dom.elGridRectMask), c.appendChild(t.dom.elForecastMask), c.appendChild(t.dom.elNonForecastMask), c.appendChild(t.dom.elGridRectMarkerMask);
                }
            },
            {
                key: "_drawGridLines",
                value: function(e) {
                    var t = e.i, i = e.x1, a = e.y1, s = e.x2, r = e.y2, n = e.xCount, o = e.parent, h = this.w;
                    if (!(t === 0 && h.globals.skipFirstTimelinelabel || t === n - 1 && h.globals.skipLastTimelinelabel && !h.config.xaxis.labels.formatter || h.config.chart.type === "radar")) {
                        h.config.grid.xaxis.lines.show && this._drawGridLine({
                            i: t,
                            x1: i,
                            y1: a,
                            x2: s,
                            y2: r,
                            xCount: n,
                            parent: o
                        });
                        var c = 0;
                        if (h.globals.hasXaxisGroups && h.config.xaxis.tickPlacement === "between") {
                            var d = h.globals.groups;
                            if (d) {
                                for(var g = 0, p = 0; g < t && p < d.length; p++)g += d[p].cols;
                                g === t && (c = 0.6 * h.globals.xAxisLabelsHeight);
                            }
                        }
                        new Ie(this.ctx).drawXaxisTicks(i, c, h.globals.dom.elGraphical);
                    }
                }
            },
            {
                key: "_drawGridLine",
                value: function(e) {
                    var t = e.i, i = e.x1, a = e.y1, s = e.x2, r = e.y2, n = e.xCount, o = e.parent, h = this.w, c = !1, d = o.node.classList.contains("apexcharts-gridlines-horizontal"), g = h.config.grid.strokeDashArray, p = h.globals.barPadForNumericAxis;
                    (a === 0 && r === 0 || i === 0 && s === 0) && (c = !0), a === h.globals.gridHeight && r === h.globals.gridHeight && (c = !0), !h.globals.isBarHorizontal || t !== 0 && t !== n - 1 || (c = !0);
                    var f = new M(this).drawLine(i - (d ? p : 0), a, s + (d ? p : 0), r, h.config.grid.borderColor, g);
                    f.node.classList.add("apexcharts-gridline"), c && h.config.grid.show ? this.elGridBorders.add(f) : o.add(f);
                }
            },
            {
                key: "_drawGridBandRect",
                value: function(e) {
                    var t = e.c, i = e.x1, a = e.y1, s = e.x2, r = e.y2, n = e.type, o = this.w, h = new M(this.ctx), c = o.globals.barPadForNumericAxis;
                    if (n !== "column" || o.config.xaxis.type !== "datetime") {
                        var d = o.config.grid[n].colors[t], g = h.drawRect(i - (n === "row" ? c : 0), a, s + (n === "row" ? 2 * c : 0), r, 0, d, o.config.grid[n].opacity);
                        this.elg.add(g), g.attr("clip-path", "url(#gridRectMask".concat(o.globals.cuid, ")")), g.node.classList.add("apexcharts-grid-".concat(n));
                    }
                }
            },
            {
                key: "_drawXYLines",
                value: function(e) {
                    var t = this, i = e.xCount, a = e.tickAmount, s = this.w;
                    if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                        var r, n = s.globals.padHorizontal, o = s.globals.gridHeight;
                        s.globals.timescaleLabels.length ? function(f) {
                            for(var b = f.xC, m = f.x1, w = f.y1, A = f.x2, l = f.y2, u = 0; u < b; u++)m = t.xaxisLabels[u].position, A = t.xaxisLabels[u].position, t._drawGridLines({
                                i: u,
                                x1: m,
                                y1: w,
                                x2: A,
                                y2: l,
                                xCount: i,
                                parent: t.elgridLinesV
                            });
                        }({
                            xC: i,
                            x1: n,
                            y1: 0,
                            x2: r,
                            y2: o
                        }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(f) {
                            for(var b = f.xC, m = f.x1, w = f.y1, A = f.x2, l = f.y2, u = 0; u < b + (s.globals.isXNumeric ? 0 : 1); u++)u === 0 && b === 1 && s.globals.dataPoints === 1 && (A = m = s.globals.gridWidth / 2), t._drawGridLines({
                                i: u,
                                x1: m,
                                y1: w,
                                x2: A,
                                y2: l,
                                xCount: i,
                                parent: t.elgridLinesV
                            }), A = m += s.globals.gridWidth / (s.globals.isXNumeric ? b - 1 : b);
                        }({
                            xC: i,
                            x1: n,
                            y1: 0,
                            x2: r,
                            y2: o
                        }));
                    }
                    if (s.config.grid.yaxis.lines.show) {
                        var h = 0, c = 0, d = s.globals.gridWidth, g = a + 1;
                        this.isRangeBar && (g = s.globals.labels.length);
                        for(var p = 0; p < g + (this.isRangeBar ? 1 : 0); p++)this._drawGridLine({
                            i: p,
                            xCount: g + (this.isRangeBar ? 1 : 0),
                            x1: 0,
                            y1: h,
                            x2: d,
                            y2: c,
                            parent: this.elgridLinesH
                        }), c = h += s.globals.gridHeight / (this.isRangeBar ? g : a);
                    }
                }
            },
            {
                key: "_drawInvertedXYLines",
                value: function(e) {
                    var t = e.xCount, i = this.w;
                    if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, n = 0; n < t + 1; n++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: n,
                        xCount: t + 1,
                        x1: s,
                        y1: 0,
                        x2: a,
                        y2: r,
                        parent: this.elgridLinesV
                    }), new Ie(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s = s + i.globals.gridWidth / t + 0.3;
                    if (i.config.grid.yaxis.lines.show) for(var o = 0, h = 0, c = i.globals.gridWidth, d = 0; d < i.globals.dataPoints + 1; d++)this._drawGridLine({
                        i: d,
                        xCount: i.globals.dataPoints + 1,
                        x1: 0,
                        y1: o,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = o += i.globals.gridHeight / i.globals.dataPoints;
                }
            },
            {
                key: "renderGrid",
                value: function() {
                    var e = this.w, t = new M(this.ctx);
                    this.elg = t.group({
                        class: "apexcharts-grid"
                    }), this.elgridLinesH = t.group({
                        class: "apexcharts-gridlines-horizontal"
                    }), this.elgridLinesV = t.group({
                        class: "apexcharts-gridlines-vertical"
                    }), this.elGridBorders = t.group({
                        class: "apexcharts-grid-borders"
                    }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), e.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                    for(var i, a = e.globals.yAxisScale.length ? e.globals.yAxisScale[0].result.length - 1 : 5, s = 0; s < e.globals.series.length && (e.globals.yAxisScale[s] !== void 0 && (a = e.globals.yAxisScale[s].result.length - 1), !(a > 2)); s++);
                    if (!e.globals.isBarHorizontal || this.isRangeBar) {
                        var r, n, o;
                        i = this.xaxisLabels.length, this.isRangeBar && (i--, a = e.globals.labels.length, e.config.xaxis.tickAmount && e.config.xaxis.labels.formatter && (i = e.config.xaxis.tickAmount), ((r = e.globals.yAxisScale) === null || r === void 0 || (n = r[0]) === null || n === void 0 || (o = n.result) === null || o === void 0 ? void 0 : o.length) > 0 && e.config.xaxis.type !== "datetime" && (i = e.globals.yAxisScale[0].result.length - 1)), this._drawXYLines({
                            xCount: i,
                            tickAmount: a
                        });
                    } else i = a, a = e.globals.xTickAmount, this._drawInvertedXYLines({
                        xCount: i,
                        tickAmount: a
                    });
                    return this.drawGridBands(i, a), {
                        el: this.elg,
                        elGridBorders: this.elGridBorders,
                        xAxisTickWidth: e.globals.gridWidth / i
                    };
                }
            },
            {
                key: "drawGridBands",
                value: function(e, t) {
                    var i = this.w;
                    if (i.config.grid.row.colors !== void 0 && i.config.grid.row.colors.length > 0) for(var a = 0, s = i.globals.gridHeight / t, r = i.globals.gridWidth, n = 0, o = 0; n < t; n++, o++)o >= i.config.grid.row.colors.length && (o = 0), this._drawGridBandRect({
                        c: o,
                        x1: 0,
                        y1: a,
                        x2: r,
                        y2: s,
                        type: "row"
                    }), a += i.globals.gridHeight / t;
                    if (i.config.grid.column.colors !== void 0 && i.config.grid.column.colors.length > 0) for(var h = i.globals.isBarHorizontal || i.config.xaxis.tickPlacement !== "on" || i.config.xaxis.type !== "category" && !i.config.xaxis.convertedCatToNumeric ? e : e - 1, c = i.globals.padHorizontal, d = i.globals.padHorizontal + i.globals.gridWidth / h, g = i.globals.gridHeight, p = 0, f = 0; p < e; p++, f++)f >= i.config.grid.column.colors.length && (f = 0), this._drawGridBandRect({
                        c: f,
                        x1: c,
                        y1: 0,
                        x2: d,
                        y2: g,
                        type: "column"
                    }), c += i.globals.gridWidth / h;
                }
            }
        ]), y;
    }(), we = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "niceScale",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 ? arguments[4] : void 0, r = this.w, n = Math.abs(t - e);
                    if ((i = this._adjustTicksForSmallRange(i, a, n)) === "dataPoints" && (i = r.globals.dataPoints - 1), e === Number.MIN_VALUE && t === 0 || !P.isNumber(e) && !P.isNumber(t) || e === Number.MIN_VALUE && t === -Number.MAX_VALUE) return e = 0, t = i, this.linearScale(e, t, i, a, r.config.yaxis[a].stepSize);
                    e > t ? (console.warn("axis.min cannot be greater than axis.max"), t = e + 0.1) : e === t && (e = e === 0 ? 0 : e - 0.5, t = t === 0 ? 2 : t + 0.5);
                    var o = [];
                    n < 1 && s && (r.config.chart.type === "candlestick" || r.config.series[a].type === "candlestick" || r.config.chart.type === "boxPlot" || r.config.series[a].type === "boxPlot" || r.globals.isRangeData) && (t *= 1.01);
                    var h = i + 1;
                    h < 2 ? h = 2 : h > 2 && (h -= 2);
                    var c = n / h, d = Math.floor(P.log10(c)), g = Math.pow(10, d), p = Math.round(c / g);
                    p < 1 && (p = 1);
                    var f = p * g;
                    r.config.yaxis[a].stepSize && (f = r.config.yaxis[a].stepSize), r.globals.isBarHorizontal && r.config.xaxis.stepSize && r.config.xaxis.type !== "datetime" && (f = r.config.xaxis.stepSize);
                    var b = f * Math.floor(e / f), m = f * Math.ceil(t / f), w = b;
                    if (s && n > 2) {
                        for(; o.push(P.stripNumber(w, 7)), !((w += f) > m););
                        return {
                            result: o,
                            niceMin: o[0],
                            niceMax: o[o.length - 1]
                        };
                    }
                    var A = e;
                    (o = []).push(P.stripNumber(A, 7));
                    for(var l = Math.abs(t - e) / i, u = 0; u <= i; u++)A += l, o.push(A);
                    return o[o.length - 2] >= t && o.pop(), {
                        result: o,
                        niceMin: o[0],
                        niceMax: o[o.length - 1]
                    };
                }
            },
            {
                key: "linearScale",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0, r = Math.abs(t - e);
                    (i = this._adjustTicksForSmallRange(i, a, r)) === "dataPoints" && (i = this.w.globals.dataPoints - 1), s || (s = r / i), i === Number.MAX_VALUE && (i = 5, s = 1);
                    for(var n = [], o = e; i >= 0;)n.push(o), o += s, i -= 1;
                    return {
                        result: n,
                        niceMin: n[0],
                        niceMax: n[n.length - 1]
                    };
                }
            },
            {
                key: "logarithmicScaleNice",
                value: function(e, t, i) {
                    t <= 0 && (t = Math.max(e, i)), e <= 0 && (e = Math.min(t, i));
                    for(var a = [], s = Math.ceil(Math.log(t) / Math.log(i) + 1), r = Math.floor(Math.log(e) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                    return {
                        result: a,
                        niceMin: a[0],
                        niceMax: a[a.length - 1]
                    };
                }
            },
            {
                key: "logarithmicScale",
                value: function(e, t, i) {
                    t <= 0 && (t = Math.max(e, i)), e <= 0 && (e = Math.min(t, i));
                    for(var a = [], s = Math.log(t) / Math.log(i), r = Math.log(e) / Math.log(i), n = s - r, o = Math.round(n), h = n / o, c = 0, d = r; c < o; c++, d += h)a.push(Math.pow(i, d));
                    return a.push(Math.pow(i, s)), {
                        result: a,
                        niceMin: e,
                        niceMax: t
                    };
                }
            },
            {
                key: "_adjustTicksForSmallRange",
                value: function(e, t, i) {
                    var a = e;
                    if (t !== void 0 && this.w.config.yaxis[t].labels.formatter && this.w.config.yaxis[t].tickAmount === void 0) {
                        var s = Number(this.w.config.yaxis[t].labels.formatter(1));
                        P.isNumber(s) && this.w.globals.yValueDecimal === 0 && (a = Math.ceil(i));
                    }
                    return a < e ? a : e;
                }
            },
            {
                key: "setYScaleForIndex",
                value: function(e, t, i) {
                    var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[e];
                    a.yAxisScale[e] === void 0 && (a.yAxisScale[e] = []);
                    var n = Math.abs(i - t);
                    if (r.logarithmic && n <= 5 && (a.invalidLogScale = !0), r.logarithmic && n > 5) a.allSeriesCollapsed = !1, a.yAxisScale[e] = this.logarithmicScale(t, i, r.logBase), a.yAxisScale[e] = r.forceNiceScale ? this.logarithmicScaleNice(t, i, r.logBase) : this.logarithmicScale(t, i, r.logBase);
                    else if (i !== -Number.MAX_VALUE && P.isNumber(i)) {
                        if (a.allSeriesCollapsed = !1, r.min === void 0 && r.max === void 0 || r.forceNiceScale) {
                            var o = s.yaxis[e].max === void 0 && s.yaxis[e].min === void 0 || s.yaxis[e].forceNiceScale;
                            a.yAxisScale[e] = this.niceScale(t, i, r.tickAmount ? r.tickAmount : n < 5 && n > 1 ? n + 1 : 5, e, o);
                        } else a.yAxisScale[e] = this.linearScale(t, i, r.tickAmount, e, s.yaxis[e].stepSize);
                    } else a.yAxisScale[e] = this.linearScale(0, 5, 5, e, s.yaxis[e].stepSize);
                }
            },
            {
                key: "setXScale",
                value: function(e, t) {
                    var i = this.w, a = i.globals, s = Math.abs(t - e);
                    return t !== -Number.MAX_VALUE && P.isNumber(t) ? a.xAxisScale = this.linearScale(e, t, i.config.xaxis.tickAmount ? i.config.xaxis.tickAmount : s < 5 && s > 1 ? s + 1 : 5, 0, i.config.xaxis.stepSize) : a.xAxisScale = this.linearScale(0, 5, 5), a.xAxisScale;
                }
            },
            {
                key: "setMultipleYScales",
                value: function() {
                    var e = this, t = this.w.globals, i = this.w.config, a = t.minYArr.concat([]), s = t.maxYArr.concat([]), r = [];
                    i.yaxis.forEach(function(n, o) {
                        var h = o;
                        i.series.forEach(function(g, p) {
                            g.name === n.seriesName && (h = p, o !== p ? r.push({
                                index: p,
                                similarIndex: o,
                                alreadyExists: !0
                            }) : r.push({
                                index: p
                            }));
                        });
                        var c = a[h], d = s[h];
                        e.setYScaleForIndex(o, c, d);
                    }), this.sameScaleInMultipleAxes(a, s, r);
                }
            },
            {
                key: "sameScaleInMultipleAxes",
                value: function(e, t, i) {
                    var a = this, s = this.w.config, r = this.w.globals, n = [];
                    i.forEach(function(b) {
                        b.alreadyExists && (n[b.index] === void 0 && (n[b.index] = []), n[b.index].push(b.index), n[b.index].push(b.similarIndex));
                    }), r.yAxisSameScaleIndices = n, n.forEach(function(b, m) {
                        n.forEach(function(w, A) {
                            var l, u;
                            m !== A && (l = b, u = w, l.filter(function(x) {
                                return u.indexOf(x) !== -1;
                            })).length > 0 && (n[m] = n[m].concat(n[A]));
                        });
                    });
                    var o = n.map(function(b) {
                        return b.filter(function(m, w) {
                            return b.indexOf(m) === w;
                        });
                    }).map(function(b) {
                        return b.sort();
                    });
                    n = n.filter(function(b) {
                        return !!b;
                    });
                    var h = o.slice(), c = h.map(function(b) {
                        return JSON.stringify(b);
                    });
                    h = h.filter(function(b, m) {
                        return c.indexOf(JSON.stringify(b)) === m;
                    });
                    var d = [], g = [];
                    e.forEach(function(b, m) {
                        h.forEach(function(w, A) {
                            w.indexOf(m) > -1 && (d[A] === void 0 && (d[A] = [], g[A] = []), d[A].push({
                                key: m,
                                value: b
                            }), g[A].push({
                                key: m,
                                value: t[m]
                            }));
                        });
                    });
                    var p = Array.apply(null, Array(h.length)).map(Number.prototype.valueOf, Number.MIN_VALUE), f = Array.apply(null, Array(h.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                    d.forEach(function(b, m) {
                        b.forEach(function(w, A) {
                            p[m] = Math.min(w.value, p[m]);
                        });
                    }), g.forEach(function(b, m) {
                        b.forEach(function(w, A) {
                            f[m] = Math.max(w.value, f[m]);
                        });
                    }), e.forEach(function(b, m) {
                        g.forEach(function(w, A) {
                            var l = p[A], u = f[A];
                            s.chart.stacked && (u = 0, w.forEach(function(x, v) {
                                x.value !== -Number.MAX_VALUE && (u += x.value), l !== Number.MIN_VALUE && (l += d[A][v].value);
                            })), w.forEach(function(x, v) {
                                w[v].key === m && (s.yaxis[m].min !== void 0 && (l = typeof s.yaxis[m].min == "function" ? s.yaxis[m].min(r.minY) : s.yaxis[m].min), s.yaxis[m].max !== void 0 && (u = typeof s.yaxis[m].max == "function" ? s.yaxis[m].max(r.maxY) : s.yaxis[m].max), a.setYScaleForIndex(m, l, u));
                            });
                        });
                    });
                }
            },
            {
                key: "autoScaleY",
                value: function(e, t, i) {
                    e || (e = this);
                    var a = e.w;
                    if (a.globals.isMultipleYAxis || a.globals.collapsedSeries.length) return console.warn("autoScaleYaxis not supported in a multi-yaxis chart."), t;
                    var s = a.globals.seriesX[0], r = a.config.chart.stacked;
                    return t.forEach(function(n, o) {
                        for(var h = 0, c = 0; c < s.length; c++)if (s[c] >= i.xaxis.min) {
                            h = c;
                            break;
                        }
                        var d, g, p = a.globals.minYArr[o], f = a.globals.maxYArr[o], b = a.globals.stackedSeriesTotals;
                        a.globals.series.forEach(function(m, w) {
                            var A = m[h];
                            r ? (A = b[h], d = g = A, b.forEach(function(l, u) {
                                s[u] <= i.xaxis.max && s[u] >= i.xaxis.min && (l > g && l !== null && (g = l), m[u] < d && m[u] !== null && (d = m[u]));
                            })) : (d = g = A, m.forEach(function(l, u) {
                                if (s[u] <= i.xaxis.max && s[u] >= i.xaxis.min) {
                                    var x = l, v = l;
                                    a.globals.series.forEach(function(k, S) {
                                        l !== null && (x = Math.min(k[u], x), v = Math.max(k[u], v));
                                    }), v > g && v !== null && (g = v), x < d && x !== null && (d = x);
                                }
                            })), d === void 0 && g === void 0 && (d = p, g = f), g *= g < 0 ? 0.9 : 1.1, (d *= d < 0 ? 1.1 : 0.9) === 0 && g === 0 && (d = -1, g = 1), g < 0 && g < f && (g = f), d < 0 && d > p && (d = p), t.length > 1 ? (t[w].min = n.min === void 0 ? d : n.min, t[w].max = n.max === void 0 ? g : n.max) : (t[0].min = n.min === void 0 ? d : n.min, t[0].max = n.max === void 0 ? g : n.max);
                        });
                    }), t;
                }
            }
        ]), y;
    }(), De = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.scales = new we(e);
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    this.setYRange(), this.setXRange(), this.setZRange();
                }
            },
            {
                key: "getMinYMaxY",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, s = this.w.config, r = this.w.globals, n = -Number.MAX_VALUE, o = Number.MIN_VALUE;
                    a === null && (a = e + 1);
                    var h = r.series, c = h, d = h;
                    s.chart.type === "candlestick" ? (c = r.seriesCandleL, d = r.seriesCandleH) : s.chart.type === "boxPlot" ? (c = r.seriesCandleO, d = r.seriesCandleC) : r.isRangeData && (c = r.seriesRangeStart, d = r.seriesRangeEnd);
                    for(var g = e; g < a; g++){
                        r.dataPoints = Math.max(r.dataPoints, h[g].length), r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(b) {
                            return b !== void 0;
                        }).length), r.labels.length && s.xaxis.type !== "datetime" && r.series.reduce(function(b, m) {
                            return b + m.length;
                        }, 0) !== 0 && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                        for(var p = 0; p < r.series[g].length; p++){
                            var f = h[g][p];
                            f !== null && P.isNumber(f) ? (d[g][p] !== void 0 && (n = Math.max(n, d[g][p]), t = Math.min(t, d[g][p])), c[g][p] !== void 0 && (t = Math.min(t, c[g][p]), i = Math.max(i, c[g][p])), this.w.config.chart.type !== "candlestick" && this.w.config.chart.type !== "boxPlot" && this.w.config.chart.type === "rangeArea" && this.w.config.chart.type === "rangeBar" || (this.w.config.chart.type !== "candlestick" && this.w.config.chart.type !== "boxPlot" || r.seriesCandleC[g][p] !== void 0 && (n = Math.max(n, r.seriesCandleO[g][p]), n = Math.max(n, r.seriesCandleH[g][p]), n = Math.max(n, r.seriesCandleL[g][p]), n = Math.max(n, r.seriesCandleC[g][p]), this.w.config.chart.type === "boxPlot" && (n = Math.max(n, r.seriesCandleM[g][p]))), !s.series[g].type || s.series[g].type === "candlestick" && s.series[g].type === "boxPlot" && s.series[g].type === "rangeArea" && s.series[g].type === "rangeBar" || (n = Math.max(n, r.series[g][p]), t = Math.min(t, r.series[g][p])), i = n), r.seriesGoals[g] && r.seriesGoals[g][p] && Array.isArray(r.seriesGoals[g][p]) && r.seriesGoals[g][p].forEach(function(b) {
                                o !== Number.MIN_VALUE && (o = Math.min(o, b.value), t = o), n = Math.max(n, b.value), i = n;
                            }), P.isFloat(f) && (f = P.noExponents(f), r.yValueDecimal = Math.max(r.yValueDecimal, f.toString().split(".")[1].length)), o > c[g][p] && c[g][p] < 0 && (o = c[g][p])) : r.hasNullValues = !0;
                        }
                    }
                    return s.chart.type === "rangeBar" && r.seriesRangeStart.length && r.isBarHorizontal && (o = t), s.chart.type === "bar" && (o < 0 && n < 0 && (n = 0), o === Number.MIN_VALUE && (o = 0)), {
                        minY: o,
                        maxY: n,
                        lowestY: t,
                        highestY: i
                    };
                }
            },
            {
                key: "setYRange",
                value: function() {
                    var e = this.w.globals, t = this.w.config;
                    e.maxY = -Number.MAX_VALUE, e.minY = Number.MIN_VALUE;
                    var i = Number.MAX_VALUE;
                    if (e.isMultipleYAxis) for(var a = 0; a < e.series.length; a++){
                        var s = this.getMinYMaxY(a, i, null, a + 1);
                        e.minYArr.push(s.minY), e.maxYArr.push(s.maxY), i = s.lowestY;
                    }
                    var r = this.getMinYMaxY(0, i, null, e.series.length);
                    if (e.minY = r.minY, e.maxY = r.maxY, i = r.lowestY, t.chart.stacked && this._setStackedMinMax(), (t.chart.type === "line" || t.chart.type === "area" || t.chart.type === "candlestick" || t.chart.type === "boxPlot" || t.chart.type === "rangeBar" && !e.isBarHorizontal) && e.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== e.maxY) {
                        var n = e.maxY - i;
                        (i >= 0 && i <= 10 || t.yaxis[0].min !== void 0 || t.yaxis[0].max !== void 0) && (n = 0), e.minY = i - 5 * n / 100, i > 0 && e.minY < 0 && (e.minY = 0), e.maxY = e.maxY + 5 * n / 100;
                    }
                    return t.yaxis.forEach(function(o, h) {
                        o.max !== void 0 && (typeof o.max == "number" ? e.maxYArr[h] = o.max : typeof o.max == "function" && (e.maxYArr[h] = o.max(e.isMultipleYAxis ? e.maxYArr[h] : e.maxY)), e.maxY = e.maxYArr[h]), o.min !== void 0 && (typeof o.min == "number" ? e.minYArr[h] = o.min : typeof o.min == "function" && (e.minYArr[h] = o.min(e.isMultipleYAxis ? e.minYArr[h] === Number.MIN_VALUE ? 0 : e.minYArr[h] : e.minY)), e.minY = e.minYArr[h]);
                    }), e.isBarHorizontal && [
                        "min",
                        "max"
                    ].forEach(function(o) {
                        t.xaxis[o] !== void 0 && typeof t.xaxis[o] == "number" && (o === "min" ? e.minY = t.xaxis[o] : e.maxY = t.xaxis[o]);
                    }), e.isMultipleYAxis ? (this.scales.setMultipleYScales(), e.minY = i, e.yAxisScale.forEach(function(o, h) {
                        e.minYArr[h] = o.niceMin, e.maxYArr[h] = o.niceMax;
                    })) : (this.scales.setYScaleForIndex(0, e.minY, e.maxY), e.minY = e.yAxisScale[0].niceMin, e.maxY = e.yAxisScale[0].niceMax, e.minYArr[0] = e.yAxisScale[0].niceMin, e.maxYArr[0] = e.yAxisScale[0].niceMax), {
                        minY: e.minY,
                        maxY: e.maxY,
                        minYArr: e.minYArr,
                        maxYArr: e.maxYArr,
                        yAxisScale: e.yAxisScale
                    };
                }
            },
            {
                key: "setXRange",
                value: function() {
                    var e = this.w.globals, t = this.w.config, i = t.xaxis.type === "numeric" || t.xaxis.type === "datetime" || t.xaxis.type === "category" && !e.noLabelsProvided || e.noLabelsProvided || e.isXNumeric;
                    if (e.isXNumeric && function() {
                        for(var n = 0; n < e.series.length; n++)if (e.labels[n]) for(var o = 0; o < e.labels[n].length; o++)e.labels[n][o] !== null && P.isNumber(e.labels[n][o]) && (e.maxX = Math.max(e.maxX, e.labels[n][o]), e.initialMaxX = Math.max(e.maxX, e.labels[n][o]), e.minX = Math.min(e.minX, e.labels[n][o]), e.initialMinX = Math.min(e.minX, e.labels[n][o]));
                    }(), e.noLabelsProvided && t.xaxis.categories.length === 0 && (e.maxX = e.labels[e.labels.length - 1], e.initialMaxX = e.labels[e.labels.length - 1], e.minX = 1, e.initialMinX = 1), e.isXNumeric || e.noLabelsProvided || e.dataFormatXNumeric) {
                        var a;
                        if (t.xaxis.tickAmount === void 0 ? (a = Math.round(e.svgWidth / 150), t.xaxis.type === "numeric" && e.dataPoints < 30 && (a = e.dataPoints - 1), a > e.dataPoints && e.dataPoints !== 0 && (a = e.dataPoints - 1)) : t.xaxis.tickAmount === "dataPoints" ? (e.series.length > 1 && (a = e.series[e.maxValsInArrayIndex].length - 1), e.isXNumeric && (a = e.maxX - e.minX - 1)) : a = t.xaxis.tickAmount, e.xTickAmount = a, t.xaxis.max !== void 0 && typeof t.xaxis.max == "number" && (e.maxX = t.xaxis.max), t.xaxis.min !== void 0 && typeof t.xaxis.min == "number" && (e.minX = t.xaxis.min), t.xaxis.range !== void 0 && (e.minX = e.maxX - t.xaxis.range), e.minX !== Number.MAX_VALUE && e.maxX !== -Number.MAX_VALUE) {
                            if (t.xaxis.convertedCatToNumeric && !e.dataFormatXNumeric) {
                                for(var s = [], r = e.minX - 1; r < e.maxX; r++)s.push(r + 1);
                                e.xAxisScale = {
                                    result: s,
                                    niceMin: s[0],
                                    niceMax: s[s.length - 1]
                                };
                            } else e.xAxisScale = this.scales.setXScale(e.minX, e.maxX);
                        } else e.xAxisScale = this.scales.linearScale(0, a, a, 0, t.xaxis.stepSize), e.noLabelsProvided && e.labels.length > 0 && (e.xAxisScale = this.scales.linearScale(1, e.labels.length, a - 1, 0, t.xaxis.stepSize), e.seriesX = e.labels.slice());
                        i && (e.labels = e.xAxisScale.result.slice());
                    }
                    return e.isBarHorizontal && e.labels.length && (e.xTickAmount = e.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                        minX: e.minX,
                        maxX: e.maxX
                    };
                }
            },
            {
                key: "setZRange",
                value: function() {
                    var e = this.w.globals;
                    if (e.isDataXYZ) {
                        for(var t = 0; t < e.series.length; t++)if (e.seriesZ[t] !== void 0) for(var i = 0; i < e.seriesZ[t].length; i++)e.seriesZ[t][i] !== null && P.isNumber(e.seriesZ[t][i]) && (e.maxZ = Math.max(e.maxZ, e.seriesZ[t][i]), e.minZ = Math.min(e.minZ, e.seriesZ[t][i]));
                    }
                }
            },
            {
                key: "_handleSingleDataPoint",
                value: function() {
                    var e = this.w.globals, t = this.w.config;
                    if (e.minX === e.maxX) {
                        var i = new B(this.ctx);
                        if (t.xaxis.type === "datetime") {
                            var a = i.getDate(e.minX);
                            t.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), e.minX = new Date(a).getTime();
                            var s = i.getDate(e.maxX);
                            t.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), e.maxX = new Date(s).getTime();
                        } else (t.xaxis.type === "numeric" || t.xaxis.type === "category" && !e.noLabelsProvided) && (e.minX = e.minX - 2, e.initialMinX = e.minX, e.maxX = e.maxX + 2, e.initialMaxX = e.maxX);
                    }
                }
            },
            {
                key: "_getMinXDiff",
                value: function() {
                    var e = this.w.globals;
                    e.isXNumeric && e.seriesX.forEach(function(t, i) {
                        t.length === 1 && t.push(e.seriesX[e.maxValsInArrayIndex][e.seriesX[e.maxValsInArrayIndex].length - 1]);
                        var a = t.slice();
                        a.sort(function(s, r) {
                            return s - r;
                        }), a.forEach(function(s, r) {
                            if (r > 0) {
                                var n = s - a[r - 1];
                                n > 0 && (e.minXDiff = Math.min(n, e.minXDiff));
                            }
                        }), e.dataPoints !== 1 && e.minXDiff !== Number.MAX_VALUE || (e.minXDiff = 0.5);
                    });
                }
            },
            {
                key: "_setStackedMinMax",
                value: function() {
                    var e = this, t = this.w.globals;
                    if (t.series.length) {
                        var i = t.seriesGroups;
                        i.length || (i = [
                            this.w.config.series.map(function(r) {
                                return r.name;
                            })
                        ]);
                        var a = {}, s = {};
                        i.forEach(function(r) {
                            a[r] = [], s[r] = [], e.w.config.series.map(function(n, o) {
                                return r.indexOf(n.name) > -1 ? o : null;
                            }).filter(function(n) {
                                return n !== null;
                            }).forEach(function(n) {
                                for(var o = 0; o < t.series[t.maxValsInArrayIndex].length; o++){
                                    var h, c;
                                    a[r][o] === void 0 && (a[r][o] = 0, s[r][o] = 0), (e.w.config.chart.stacked && !t.comboCharts || e.w.config.chart.stacked && t.comboCharts && (!e.w.config.chart.stackOnlyBar || ((h = e.w.config.series) === null || h === void 0 || (c = h[n]) === null || c === void 0 ? void 0 : c.type) === "bar")) && t.series[n][o] !== null && P.isNumber(t.series[n][o]) && (t.series[n][o] > 0 ? a[r][o] += parseFloat(t.series[n][o]) + 1e-4 : s[r][o] += parseFloat(t.series[n][o]));
                                }
                            });
                        }), Object.entries(a).forEach(function(r) {
                            var n = Me(r, 1)[0];
                            a[n].forEach(function(o, h) {
                                t.maxY = Math.max(t.maxY, a[n][h]), t.minY = Math.min(t.minY, s[n][h]);
                            });
                        });
                    }
                }
            }
        ]), y;
    }(), Ne = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.elgrid = t, this.w = e.w;
            var i = this.w;
            this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.axisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = i.config.chart.type === "bar" && i.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, i.config.xaxis.position === "bottom" && (this.xAxisoffX = i.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new xe(e);
        }
        return Y(y, [
            {
                key: "drawYaxis",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx), s = i.config.yaxis[e].labels.style, r = s.fontSize, n = s.fontFamily, o = s.fontWeight, h = a.group({
                        class: "apexcharts-yaxis",
                        rel: e,
                        transform: "translate(" + i.globals.translateYAxisX[e] + ", 0)"
                    });
                    if (this.axesUtils.isYAxisHidden(e)) return h;
                    var c = a.group({
                        class: "apexcharts-yaxis-texts-g"
                    });
                    h.add(c);
                    var d = i.globals.yAxisScale[e].result.length - 1, g = i.globals.gridHeight / d, p = i.globals.translateY, f = i.globals.yLabelFormatters[e], b = i.globals.yAxisScale[e].result.slice();
                    b = this.axesUtils.checkForReversedLabels(e, b);
                    var m = "";
                    if (i.config.yaxis[e].labels.show) for(var w = function(C) {
                        var L = b[C];
                        L = f(L, C, i);
                        var I = i.config.yaxis[e].labels.padding;
                        i.config.yaxis[e].opposite && i.config.yaxis.length !== 0 && (I *= -1);
                        var z = "end";
                        i.config.yaxis[e].opposite && (z = "start"), i.config.yaxis[e].labels.align === "left" ? z = "start" : i.config.yaxis[e].labels.align === "center" ? z = "middle" : i.config.yaxis[e].labels.align === "right" && (z = "end");
                        var T = t.axesUtils.getYAxisForeColor(s.colors, e), E = i.config.yaxis[e].labels.offsetY;
                        i.config.chart.type === "heatmap" && (E -= (i.globals.gridHeight / i.globals.series.length - 1) / 2);
                        var R = a.drawText({
                            x: I,
                            y: p + d / 10 + E + 1,
                            text: L,
                            textAnchor: z,
                            fontSize: r,
                            fontFamily: n,
                            fontWeight: o,
                            maxWidth: i.config.yaxis[e].labels.maxWidth,
                            foreColor: Array.isArray(T) ? T[C] : T,
                            isPlainText: !1,
                            cssClass: "apexcharts-yaxis-label " + s.cssClass
                        });
                        C === d && (m = R), c.add(R);
                        var O = document.createElementNS(i.globals.SVGNS, "title");
                        if (O.textContent = Array.isArray(L) ? L.join(" ") : L, R.node.appendChild(O), i.config.yaxis[e].labels.rotate !== 0) {
                            var D = a.rotateAroundCenter(m.node), W = a.rotateAroundCenter(R.node);
                            R.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[e].labels.rotate, " ").concat(D.x, " ").concat(W.y, ")"));
                        }
                        p += g;
                    }, A = d; A >= 0; A--)w(A);
                    if (i.config.yaxis[e].title.text !== void 0) {
                        var l = a.group({
                            class: "apexcharts-yaxis-title"
                        }), u = 0;
                        i.config.yaxis[e].opposite && (u = i.globals.translateYAxisX[e]);
                        var x = a.drawText({
                            x: u,
                            y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[e].title.offsetY,
                            text: i.config.yaxis[e].title.text,
                            textAnchor: "end",
                            foreColor: i.config.yaxis[e].title.style.color,
                            fontSize: i.config.yaxis[e].title.style.fontSize,
                            fontWeight: i.config.yaxis[e].title.style.fontWeight,
                            fontFamily: i.config.yaxis[e].title.style.fontFamily,
                            cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[e].title.style.cssClass
                        });
                        l.add(x), h.add(l);
                    }
                    var v = i.config.yaxis[e].axisBorder, k = 31 + v.offsetX;
                    if (i.config.yaxis[e].opposite && (k = -31 - v.offsetX), v.show) {
                        var S = a.drawLine(k, i.globals.translateY + v.offsetY - 2, k, i.globals.gridHeight + i.globals.translateY + v.offsetY + 2, v.color, 0, v.width);
                        h.add(S);
                    }
                    return i.config.yaxis[e].axisTicks.show && this.axesUtils.drawYAxisTicks(k, d, v, i.config.yaxis[e].axisTicks, e, g, h), h;
                }
            },
            {
                key: "drawYaxisInversed",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = i.group({
                        class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                    }), s = i.group({
                        class: "apexcharts-xaxis-texts-g",
                        transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                    });
                    a.add(s);
                    var r = t.globals.yAxisScale[e].result.length - 1, n = t.globals.gridWidth / r + 0.1, o = n + t.config.xaxis.labels.offsetX, h = t.globals.xLabelFormatter, c = t.globals.yAxisScale[e].result.slice(), d = t.globals.timescaleLabels;
                    d.length > 0 && (this.xaxisLabels = d.slice(), r = (c = d.slice()).length), c = this.axesUtils.checkForReversedLabels(e, c);
                    var g = d.length;
                    if (t.config.xaxis.labels.show) for(var p = g ? 0 : r; g ? p < g : p >= 0; g ? p++ : p--){
                        var f = c[p];
                        f = h(f, p, t);
                        var b = t.globals.gridWidth + t.globals.padHorizontal - (o - n + t.config.xaxis.labels.offsetX);
                        if (d.length) {
                            var m = this.axesUtils.getLabel(c, d, b, p, this.drawnLabels, this.xaxisFontSize);
                            b = m.x, f = m.text, this.drawnLabels.push(m.text), p === 0 && t.globals.skipFirstTimelinelabel && (f = ""), p === c.length - 1 && t.globals.skipLastTimelinelabel && (f = "");
                        }
                        var w = i.drawText({
                            x: b,
                            y: this.xAxisoffX + t.config.xaxis.labels.offsetY + 30 - (t.config.xaxis.position === "top" ? t.globals.xAxisHeight + t.config.xaxis.axisTicks.height - 2 : 0),
                            text: f,
                            textAnchor: "middle",
                            foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[e] : this.xaxisForeColors,
                            fontSize: this.xaxisFontSize,
                            fontFamily: this.xaxisFontFamily,
                            fontWeight: t.config.xaxis.labels.style.fontWeight,
                            isPlainText: !1,
                            cssClass: "apexcharts-xaxis-label " + t.config.xaxis.labels.style.cssClass
                        });
                        s.add(w), w.tspan(f);
                        var A = document.createElementNS(t.globals.SVGNS, "title");
                        A.textContent = f, w.node.appendChild(A), o += n;
                    }
                    return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
                }
            },
            {
                key: "inversedYAxisBorder",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = t.config.xaxis.axisBorder;
                    if (a.show) {
                        var s = 0;
                        t.config.chart.type === "bar" && t.globals.isXNumeric && (s -= 15);
                        var r = i.drawLine(t.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, t.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                        this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(r) : e.add(r);
                    }
                }
            },
            {
                key: "inversedYAxisTitleText",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx);
                    if (t.config.xaxis.title.text !== void 0) {
                        var a = i.group({
                            class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                        }), s = i.drawText({
                            x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                            y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(t.config.xaxis.title.style.fontSize) + t.config.xaxis.title.offsetY + 20,
                            text: t.config.xaxis.title.text,
                            textAnchor: "middle",
                            fontSize: t.config.xaxis.title.style.fontSize,
                            fontFamily: t.config.xaxis.title.style.fontFamily,
                            fontWeight: t.config.xaxis.title.style.fontWeight,
                            foreColor: t.config.xaxis.title.style.color,
                            cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                        });
                        a.add(s), e.add(a);
                    }
                }
            },
            {
                key: "yAxisTitleRotate",
                value: function(e, t) {
                    var i = this.w, a = new M(this.ctx), s = {
                        width: 0,
                        height: 0
                    }, r = {
                        width: 0,
                        height: 0
                    }, n = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-texts-g"));
                    n !== null && (s = n.getBoundingClientRect());
                    var o = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-title text"));
                    if (o !== null && (r = o.getBoundingClientRect()), o !== null) {
                        var h = this.xPaddingForYAxisTitle(e, s, r, t);
                        o.setAttribute("x", h.xPos - (t ? 10 : 0));
                    }
                    if (o !== null) {
                        var c = a.rotateAroundCenter(o);
                        o.setAttribute("transform", "rotate(".concat(t ? -1 * i.config.yaxis[e].title.rotate : i.config.yaxis[e].title.rotate, " ").concat(c.x, " ").concat(c.y, ")"));
                    }
                }
            },
            {
                key: "xPaddingForYAxisTitle",
                value: function(e, t, i, a) {
                    var s = this.w, r = 0, n = 0, o = 10;
                    return s.config.yaxis[e].title.text === void 0 || e < 0 ? {
                        xPos: n,
                        padd: 0
                    } : (a ? (n = t.width + s.config.yaxis[e].title.offsetX + i.width / 2 + o / 2, (r += 1) === 0 && (n -= o / 2)) : (n = -1 * t.width + s.config.yaxis[e].title.offsetX + o / 2 + i.width / 2, s.globals.isBarHorizontal && (o = 25, n = -1 * t.width - s.config.yaxis[e].title.offsetX - o)), {
                        xPos: n,
                        padd: o
                    });
                }
            },
            {
                key: "setYAxisXPosition",
                value: function(e, t) {
                    var i = this.w, a = 0, s = 0, r = 18, n = 1;
                    i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map(function(o, h) {
                        var c = i.globals.ignoreYAxisIndexes.indexOf(h) > -1 || !o.show || o.floating || e[h].width === 0, d = e[h].width + t[h].width;
                        o.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[h] = s - o.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + n, c || (n = n + d + 20), i.globals.translateYAxisX[h] = s - o.labels.offsetX + 20) : (a = i.globals.translateX - r, c || (r = r + d + 20), i.globals.translateYAxisX[h] = a + o.labels.offsetX);
                    });
                }
            },
            {
                key: "setYAxisTextAlignments",
                value: function() {
                    var e = this.w, t = e.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                    (t = P.listToArray(t)).forEach(function(i, a) {
                        var s = e.config.yaxis[a];
                        if (s && !s.floating && s.labels.align !== void 0) {
                            var r = e.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(a, "'] .apexcharts-yaxis-texts-g")), n = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(a, "'] .apexcharts-yaxis-label"));
                            n = P.listToArray(n);
                            var o = r.getBoundingClientRect();
                            s.labels.align === "left" ? (n.forEach(function(h, c) {
                                h.setAttribute("text-anchor", "start");
                            }), s.opposite || r.setAttribute("transform", "translate(-".concat(o.width, ", 0)"))) : s.labels.align === "center" ? (n.forEach(function(h, c) {
                                h.setAttribute("text-anchor", "middle");
                            }), r.setAttribute("transform", "translate(".concat(o.width / 2 * (s.opposite ? 1 : -1), ", 0)"))) : s.labels.align === "right" && (n.forEach(function(h, c) {
                                h.setAttribute("text-anchor", "end");
                            }), s.opposite && r.setAttribute("transform", "translate(".concat(o.width, ", 0)")));
                        }
                    });
                }
            }
        ]), y;
    }(), xt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.documentEvent = P.bind(this.documentEvent, this);
        }
        return Y(y, [
            {
                key: "addEventListener",
                value: function(e, t) {
                    var i = this.w;
                    i.globals.events.hasOwnProperty(e) ? i.globals.events[e].push(t) : i.globals.events[e] = [
                        t
                    ];
                }
            },
            {
                key: "removeEventListener",
                value: function(e, t) {
                    var i = this.w;
                    if (i.globals.events.hasOwnProperty(e)) {
                        var a = i.globals.events[e].indexOf(t);
                        a !== -1 && i.globals.events[e].splice(a, 1);
                    }
                }
            },
            {
                key: "fireEvent",
                value: function(e, t) {
                    var i = this.w;
                    if (i.globals.events.hasOwnProperty(e)) {
                        t && t.length || (t = []);
                        for(var a = i.globals.events[e], s = a.length, r = 0; r < s; r++)a[r].apply(null, t);
                    }
                }
            },
            {
                key: "setupEventHandlers",
                value: function() {
                    var e = this, t = this.w, i = this.ctx, a = t.globals.dom.baseEl.querySelector(t.globals.chartClass);
                    this.ctx.eventList.forEach(function(s) {
                        a.addEventListener(s, function(r) {
                            var n = Object.assign({}, t, {
                                seriesIndex: t.globals.capturedSeriesIndex,
                                dataPointIndex: t.globals.capturedDataPointIndex
                            });
                            r.type === "mousemove" || r.type === "touchmove" ? typeof t.config.chart.events.mouseMove == "function" && t.config.chart.events.mouseMove(r, i, n) : r.type === "mouseleave" || r.type === "touchleave" ? typeof t.config.chart.events.mouseLeave == "function" && t.config.chart.events.mouseLeave(r, i, n) : (r.type === "mouseup" && r.which === 1 || r.type === "touchend") && (typeof t.config.chart.events.click == "function" && t.config.chart.events.click(r, i, n), i.ctx.events.fireEvent("click", [
                                r,
                                i,
                                n
                            ]));
                        }, {
                            capture: !1,
                            passive: !0
                        });
                    }), this.ctx.eventList.forEach(function(s) {
                        t.globals.dom.baseEl.addEventListener(s, e.documentEvent, {
                            passive: !0
                        });
                    }), this.ctx.core.setupBrushHandler();
                }
            },
            {
                key: "documentEvent",
                value: function(e) {
                    var t = this.w, i = e.target.className;
                    if (e.type === "click") {
                        var a = t.globals.dom.baseEl.querySelector(".apexcharts-menu");
                        a && a.classList.contains("apexcharts-menu-open") && i !== "apexcharts-menu-icon" && a.classList.remove("apexcharts-menu-open");
                    }
                    t.globals.clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX, t.globals.clientY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
                }
            }
        ]), y;
    }(), bt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "setCurrentLocaleValues",
                value: function(e) {
                    var t = this.w.config.chart.locales;
                    window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (t = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                    var i = t.filter(function(s) {
                        return s.name === e;
                    })[0];
                    if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                    var a = P.extend(H, i);
                    this.w.globals.locale = a.options;
                }
            }
        ]), y;
    }(), mt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "drawAxis",
                value: function(e, t) {
                    var i, a, s = this, r = this.w.globals, n = this.w.config, o = new Ie(this.ctx, t), h = new Ne(this.ctx, t);
                    r.axisCharts && e !== "radar" && (r.isBarHorizontal ? (a = h.drawYaxisInversed(0), i = o.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = o.drawXaxis(), r.dom.elGraphical.add(i), n.yaxis.map(function(c, d) {
                        if (r.ignoreYAxisIndexes.indexOf(d) === -1 && (a = h.drawYaxis(d), r.dom.Paper.add(a), s.w.config.grid.position === "back")) {
                            var g = r.dom.Paper.children()[1];
                            g.remove(), r.dom.Paper.add(g);
                        }
                    })));
                }
            }
        ]), y;
    }(), We = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "drawXCrosshairs",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = new Z(this.ctx), a = e.config.xaxis.crosshairs.fill.gradient, s = e.config.xaxis.crosshairs.dropShadow, r = e.config.xaxis.crosshairs.fill.type, n = a.colorFrom, o = a.colorTo, h = a.opacityFrom, c = a.opacityTo, d = a.stops, g = s.enabled, p = s.left, f = s.top, b = s.blur, m = s.color, w = s.opacity, A = e.config.xaxis.crosshairs.fill.color;
                    if (e.config.xaxis.crosshairs.show) {
                        r === "gradient" && (A = t.drawGradient("vertical", n, o, h, c, null, d, null));
                        var l = t.drawRect();
                        e.config.xaxis.crosshairs.width === 1 && (l = t.drawLine());
                        var u = e.globals.gridHeight;
                        (!P.isNumber(u) || u < 0) && (u = 0);
                        var x = e.config.xaxis.crosshairs.width;
                        (!P.isNumber(x) || x < 0) && (x = 0), l.attr({
                            class: "apexcharts-xcrosshairs",
                            x: 0,
                            y: 0,
                            y2: u,
                            width: x,
                            height: u,
                            fill: A,
                            filter: "none",
                            "fill-opacity": e.config.xaxis.crosshairs.opacity,
                            stroke: e.config.xaxis.crosshairs.stroke.color,
                            "stroke-width": e.config.xaxis.crosshairs.stroke.width,
                            "stroke-dasharray": e.config.xaxis.crosshairs.stroke.dashArray
                        }), g && (l = i.dropShadow(l, {
                            left: p,
                            top: f,
                            blur: b,
                            color: m,
                            opacity: w
                        })), e.globals.dom.elGraphical.add(l);
                    }
                }
            },
            {
                key: "drawYCrosshairs",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = e.config.yaxis[0].crosshairs, a = e.globals.barPadForNumericAxis;
                    if (e.config.yaxis[0].crosshairs.show) {
                        var s = t.drawLine(-a, 0, e.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                        s.attr({
                            class: "apexcharts-ycrosshairs"
                        }), e.globals.dom.elGraphical.add(s);
                    }
                    var r = t.drawLine(-a, 0, e.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                    r.attr({
                        class: "apexcharts-ycrosshairs-hidden"
                    }), e.globals.dom.elGraphical.add(r);
                }
            }
        ]), y;
    }(), vt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "checkResponsiveConfig",
                value: function(e) {
                    var t = this, i = this.w, a = i.config;
                    if (a.responsive.length !== 0) {
                        var s = a.responsive.slice();
                        s.sort(function(h, c) {
                            return h.breakpoint > c.breakpoint ? 1 : c.breakpoint > h.breakpoint ? -1 : 0;
                        }).reverse();
                        var r = new Le({}), n = function() {
                            var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = s[0].breakpoint, d = window.innerWidth > 0 ? window.innerWidth : screen.width;
                            if (d > c) {
                                var g = q.extendArrayProps(r, i.globals.initialConfig, i);
                                h = P.extend(g, h), h = P.extend(i.config, h), t.overrideResponsiveOptions(h);
                            } else for(var p = 0; p < s.length; p++)d < s[p].breakpoint && (h = q.extendArrayProps(r, s[p].options, i), h = P.extend(i.config, h), t.overrideResponsiveOptions(h));
                        };
                        if (e) {
                            var o = q.extendArrayProps(r, e, i);
                            o = P.extend(i.config, o), n(o = P.extend(o, e));
                        } else n({});
                    }
                }
            },
            {
                key: "overrideResponsiveOptions",
                value: function(e) {
                    var t = new Le(e).init({
                        responsiveOverride: !0
                    });
                    this.w.config = t;
                }
            }
        ]), y;
    }(), yt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.colors = [], this.w = e.w;
            var t = this.w;
            this.isColorFn = !1, this.isHeatmapDistributed = t.config.chart.type === "treemap" && t.config.plotOptions.treemap.distributed || t.config.chart.type === "heatmap" && t.config.plotOptions.heatmap.distributed, this.isBarDistributed = t.config.plotOptions.bar.distributed && (t.config.chart.type === "bar" || t.config.chart.type === "rangeBar");
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    this.setDefaultColors();
                }
            },
            {
                key: "setDefaultColors",
                value: function() {
                    var e, t = this, i = this.w, a = new P();
                    if (i.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(i.config.theme.mode)), i.config.colors === void 0 || ((e = i.config.colors) === null || e === void 0 ? void 0 : e.length) === 0 ? i.globals.colors = this.predefined() : (i.globals.colors = i.config.colors, Array.isArray(i.config.colors) && i.config.colors.length > 0 && typeof i.config.colors[0] == "function" && (i.globals.colors = i.config.series.map(function(f, b) {
                        var m = i.config.colors[b];
                        return m || (m = i.config.colors[0]), typeof m == "function" ? (t.isColorFn = !0, m({
                            value: i.globals.axisCharts ? i.globals.series[b][0] ? i.globals.series[b][0] : 0 : i.globals.series[b],
                            seriesIndex: b,
                            dataPointIndex: b,
                            w: i
                        })) : m;
                    }))), i.globals.seriesColors.map(function(f, b) {
                        f && (i.globals.colors[b] = f);
                    }), i.config.theme.monochrome.enabled) {
                        var s = [], r = i.globals.series.length;
                        (this.isBarDistributed || this.isHeatmapDistributed) && (r = i.globals.series[0].length * i.globals.series.length);
                        for(var n = i.config.theme.monochrome.color, o = 1 / (r / i.config.theme.monochrome.shadeIntensity), h = i.config.theme.monochrome.shadeTo, c = 0, d = 0; d < r; d++){
                            var g = void 0;
                            h === "dark" ? (g = a.shadeColor(-1 * c, n), c += o) : (g = a.shadeColor(c, n), c += o), s.push(g);
                        }
                        i.globals.colors = s.slice();
                    }
                    var p = i.globals.colors.slice();
                    this.pushExtraColors(i.globals.colors), [
                        "fill",
                        "stroke"
                    ].forEach(function(f) {
                        i.config[f].colors === void 0 ? i.globals[f].colors = t.isColorFn ? i.config.colors : p : i.globals[f].colors = i.config[f].colors.slice(), t.pushExtraColors(i.globals[f].colors);
                    }), i.config.dataLabels.style.colors === void 0 ? i.globals.dataLabels.style.colors = p : i.globals.dataLabels.style.colors = i.config.dataLabels.style.colors.slice(), this.pushExtraColors(i.globals.dataLabels.style.colors, 50), i.config.plotOptions.radar.polygons.fill.colors === void 0 ? i.globals.radarPolygons.fill.colors = [
                        i.config.theme.mode === "dark" ? "#424242" : "none"
                    ] : i.globals.radarPolygons.fill.colors = i.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(i.globals.radarPolygons.fill.colors, 20), i.config.markers.colors === void 0 ? i.globals.markers.colors = p : i.globals.markers.colors = i.config.markers.colors.slice(), this.pushExtraColors(i.globals.markers.colors);
                }
            },
            {
                key: "pushExtraColors",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = this.w, s = t || a.globals.series.length;
                    if (i === null && (i = this.isBarDistributed || this.isHeatmapDistributed || a.config.chart.type === "heatmap" && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), e.length < s) for(var r = s - e.length, n = 0; n < r; n++)e.push(e[n]);
                }
            },
            {
                key: "updateThemeOptions",
                value: function(e) {
                    e.chart = e.chart || {}, e.tooltip = e.tooltip || {};
                    var t = e.theme.mode || "light", i = e.theme.palette ? e.theme.palette : t === "dark" ? "palette4" : "palette1", a = e.chart.foreColor ? e.chart.foreColor : t === "dark" ? "#f6f7f8" : "#373d3f";
                    return e.tooltip.theme = t, e.chart.foreColor = a, e.theme.palette = i, e;
                }
            },
            {
                key: "predefined",
                value: function() {
                    switch(this.w.config.theme.palette){
                        case "palette1":
                        default:
                            this.colors = [
                                "#008FFB",
                                "#00E396",
                                "#FEB019",
                                "#FF4560",
                                "#775DD0"
                            ];
                            break;
                        case "palette2":
                            this.colors = [
                                "#3f51b5",
                                "#03a9f4",
                                "#4caf50",
                                "#f9ce1d",
                                "#FF9800"
                            ];
                            break;
                        case "palette3":
                            this.colors = [
                                "#33b2df",
                                "#546E7A",
                                "#d4526e",
                                "#13d8aa",
                                "#A5978B"
                            ];
                            break;
                        case "palette4":
                            this.colors = [
                                "#4ecdc4",
                                "#c7f464",
                                "#81D4FA",
                                "#fd6a6a",
                                "#546E7A"
                            ];
                            break;
                        case "palette5":
                            this.colors = [
                                "#2b908f",
                                "#f9a3a4",
                                "#90ee7e",
                                "#fa4443",
                                "#69d2e7"
                            ];
                            break;
                        case "palette6":
                            this.colors = [
                                "#449DD1",
                                "#F86624",
                                "#EA3546",
                                "#662E9B",
                                "#C5D86D"
                            ];
                            break;
                        case "palette7":
                            this.colors = [
                                "#D7263D",
                                "#1B998B",
                                "#2E294E",
                                "#F46036",
                                "#E2C044"
                            ];
                            break;
                        case "palette8":
                            this.colors = [
                                "#662E9B",
                                "#F86624",
                                "#F9C80E",
                                "#EA3546",
                                "#43BCCD"
                            ];
                            break;
                        case "palette9":
                            this.colors = [
                                "#5C4742",
                                "#A5978B",
                                "#8D5B4C",
                                "#5A2A27",
                                "#C4BBAF"
                            ];
                            break;
                        case "palette10":
                            this.colors = [
                                "#A300D6",
                                "#7D02EB",
                                "#5653FE",
                                "#2983FF",
                                "#00B1F2"
                            ];
                    }
                    return this.colors;
                }
            }
        ]), y;
    }(), wt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "draw",
                value: function() {
                    this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
                }
            },
            {
                key: "drawTitleSubtitle",
                value: function(e) {
                    var t = this.w, i = e === "title" ? t.config.title : t.config.subtitle, a = t.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                    if (i.align === "left" ? (a = 10, r = "start") : i.align === "right" && (a = t.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, i.text !== void 0) {
                        var n = new M(this.ctx).drawText({
                            x: a,
                            y: s,
                            text: i.text,
                            textAnchor: r,
                            fontSize: i.style.fontSize,
                            fontFamily: i.style.fontFamily,
                            fontWeight: i.style.fontWeight,
                            foreColor: i.style.color,
                            opacity: 1
                        });
                        n.node.setAttribute("class", "apexcharts-".concat(e, "-text")), t.globals.dom.Paper.add(n);
                    }
                }
            }
        ]), y;
    }(), kt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "getTitleSubtitleCoords",
                value: function(e) {
                    var t = this.w, i = 0, a = 0, s = e === "title" ? t.config.title.floating : t.config.subtitle.floating, r = t.globals.dom.baseEl.querySelector(".apexcharts-".concat(e, "-text"));
                    if (r !== null && !s) {
                        var n = r.getBoundingClientRect();
                        i = n.width, a = t.globals.axisCharts ? n.height + 5 : n.height;
                    }
                    return {
                        width: i,
                        height: a
                    };
                }
            },
            {
                key: "getLegendsRect",
                value: function() {
                    var e = this.w, t = e.globals.dom.elLegendWrap;
                    e.config.legend.height || e.config.legend.position !== "top" && e.config.legend.position !== "bottom" || (t.style.maxHeight = e.globals.svgHeight / 2 + "px");
                    var i = Object.assign({}, P.getBoundingClientRect(t));
                    return t !== null && !e.config.legend.floating && e.config.legend.show ? this.dCtx.lgRect = {
                        x: i.x,
                        y: i.y,
                        height: i.height,
                        width: i.height === 0 ? 0 : i.width
                    } : this.dCtx.lgRect = {
                        x: 0,
                        y: 0,
                        height: 0,
                        width: 0
                    }, e.config.legend.position !== "left" && e.config.legend.position !== "right" || 1.5 * this.dCtx.lgRect.width > e.globals.svgWidth && (this.dCtx.lgRect.width = e.globals.svgWidth / 1.5), this.dCtx.lgRect;
                }
            },
            {
                key: "getLargestStringFromMultiArr",
                value: function(e, t) {
                    var i = e;
                    if (this.w.globals.isMultiLineX) {
                        var a = t.map(function(r, n) {
                            return Array.isArray(r) ? r.length : 1;
                        }), s = Math.max.apply(Math, J(a));
                        i = t[a.indexOf(s)];
                    }
                    return i;
                }
            }
        ]), y;
    }(), At = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "getxAxisLabelsCoords",
                value: function() {
                    var e, t = this.w, i = t.globals.labels.slice();
                    if (t.config.xaxis.convertedCatToNumeric && i.length === 0 && (i = t.globals.categoryLabels), t.globals.timescaleLabels.length > 0) {
                        var a = this.getxAxisTimeScaleLabelsCoords();
                        e = {
                            width: a.width,
                            height: a.height
                        }, t.globals.rotateXLabels = !1;
                    } else {
                        this.dCtx.lgWidthForSideLegends = t.config.legend.position !== "left" && t.config.legend.position !== "right" || t.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                        var s = t.globals.xLabelFormatter, r = P.getLargestStringFromArr(i), n = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                        t.globals.isBarHorizontal && (n = r = t.globals.yAxisScale[0].result.reduce(function(f, b) {
                            return f.length > b.length ? f : b;
                        }, 0));
                        var o = new re(this.dCtx.ctx), h = r;
                        r = o.xLabelFormat(s, r, h, {
                            i: void 0,
                            dateFormatter: new B(this.dCtx.ctx).formatDate,
                            w: t
                        }), n = o.xLabelFormat(s, n, h, {
                            i: void 0,
                            dateFormatter: new B(this.dCtx.ctx).formatDate,
                            w: t
                        }), (t.config.xaxis.convertedCatToNumeric && r === void 0 || String(r).trim() === "") && (n = r = "1");
                        var c = new M(this.dCtx.ctx), d = c.getTextRects(r, t.config.xaxis.labels.style.fontSize), g = d;
                        if (r !== n && (g = c.getTextRects(n, t.config.xaxis.labels.style.fontSize)), (e = {
                            width: d.width >= g.width ? d.width : g.width,
                            height: d.height >= g.height ? d.height : g.height
                        }).width * i.length > t.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && t.config.xaxis.labels.rotate !== 0 || t.config.xaxis.labels.rotateAlways) {
                            if (!t.globals.isBarHorizontal) {
                                t.globals.rotateXLabels = !0;
                                var p = function(f) {
                                    return c.getTextRects(f, t.config.xaxis.labels.style.fontSize, t.config.xaxis.labels.style.fontFamily, "rotate(".concat(t.config.xaxis.labels.rotate, " 0 0)"), !1);
                                };
                                d = p(r), r !== n && (g = p(n)), e.height = (d.height > g.height ? d.height : g.height) / 1.5, e.width = d.width > g.width ? d.width : g.width;
                            }
                        } else t.globals.rotateXLabels = !1;
                    }
                    return t.config.xaxis.labels.show || (e = {
                        width: 0,
                        height: 0
                    }), {
                        width: e.width,
                        height: e.height
                    };
                }
            },
            {
                key: "getxAxisGroupLabelsCoords",
                value: function() {
                    var e, t = this.w;
                    if (!t.globals.hasXaxisGroups) return {
                        width: 0,
                        height: 0
                    };
                    var i, a = ((e = t.config.xaxis.group.style) === null || e === void 0 ? void 0 : e.fontSize) || t.config.xaxis.labels.style.fontSize, s = t.globals.groups.map(function(d) {
                        return d.title;
                    }), r = P.getLargestStringFromArr(s), n = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), o = new M(this.dCtx.ctx), h = o.getTextRects(r, a), c = h;
                    return r !== n && (c = o.getTextRects(n, a)), i = {
                        width: h.width >= c.width ? h.width : c.width,
                        height: h.height >= c.height ? h.height : c.height
                    }, t.config.xaxis.labels.show || (i = {
                        width: 0,
                        height: 0
                    }), {
                        width: i.width,
                        height: i.height
                    };
                }
            },
            {
                key: "getxAxisTitleCoords",
                value: function() {
                    var e = this.w, t = 0, i = 0;
                    if (e.config.xaxis.title.text !== void 0) {
                        var a = new M(this.dCtx.ctx).getTextRects(e.config.xaxis.title.text, e.config.xaxis.title.style.fontSize);
                        t = a.width, i = a.height;
                    }
                    return {
                        width: t,
                        height: i
                    };
                }
            },
            {
                key: "getxAxisTimeScaleLabelsCoords",
                value: function() {
                    var e, t = this.w;
                    this.dCtx.timescaleLabels = t.globals.timescaleLabels.slice();
                    var i = this.dCtx.timescaleLabels.map(function(s) {
                        return s.value;
                    }), a = i.reduce(function(s, r) {
                        return s === void 0 ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : s.length > r.length ? s : r;
                    }, 0);
                    return 1.05 * (e = new M(this.dCtx.ctx).getTextRects(a, t.config.xaxis.labels.style.fontSize)).width * i.length > t.globals.gridWidth && t.config.xaxis.labels.rotate !== 0 && (t.globals.overlappingXLabels = !0), e;
                }
            },
            {
                key: "additionalPaddingXLabels",
                value: function(e) {
                    var t = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, n = e.width;
                    a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                    var o = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, h = function(c, d) {
                        s.yaxis.length > 1 && function(g) {
                            return a.collapsedSeriesIndices.indexOf(g) !== -1;
                        }(d) || function(g) {
                            if (t.dCtx.timescaleLabels && t.dCtx.timescaleLabels.length) {
                                var p = t.dCtx.timescaleLabels[0], f = t.dCtx.timescaleLabels[t.dCtx.timescaleLabels.length - 1].position + n / 1.75 - t.dCtx.yAxisWidthRight, b = p.position - n / 1.75 + t.dCtx.yAxisWidthLeft, m = i.config.legend.position === "right" && t.dCtx.lgRect.width > 0 ? t.dCtx.lgRect.width : 0;
                                f > a.svgWidth - a.translateX - m && (a.skipLastTimelinelabel = !0), b < -(g.show && !g.floating || s.chart.type !== "bar" && s.chart.type !== "candlestick" && s.chart.type !== "rangeBar" && s.chart.type !== "boxPlot" ? 10 : n / 1.75) && (a.skipFirstTimelinelabel = !0);
                            } else r === "datetime" ? t.dCtx.gridPad.right < n && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : r !== "datetime" && t.dCtx.gridPad.right < n / 2 - t.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && (i.config.xaxis.tickPlacement !== "between" || i.globals.isBarHorizontal) && (t.dCtx.xPadRight = n / 2 + 1);
                        }(c);
                    };
                    s.yaxis.forEach(function(c, d) {
                        o ? (t.dCtx.gridPad.left < n && (t.dCtx.xPadLeft = n / 2 + 1), t.dCtx.xPadRight = n / 2 + 1) : h(c, d);
                    });
                }
            }
        ]), y;
    }(), St = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "getyAxisLabelsCoords",
                value: function() {
                    var e = this, t = this.w, i = [], a = 10, s = new xe(this.dCtx.ctx);
                    return t.config.yaxis.map(function(r, n) {
                        var o = {
                            seriesIndex: n,
                            dataPointIndex: -1,
                            w: t
                        }, h = t.globals.yAxisScale[n], c = 0;
                        if (!s.isYAxisHidden(n) && r.labels.show && r.labels.minWidth !== void 0 && (c = r.labels.minWidth), !s.isYAxisHidden(n) && r.labels.show && h.result.length) {
                            var d = t.globals.yLabelFormatters[n], g = h.niceMin === Number.MIN_VALUE ? 0 : h.niceMin, p = h.result.reduce(function(u, x) {
                                var v, k;
                                return ((v = String(d(u, o))) === null || v === void 0 ? void 0 : v.length) > ((k = String(d(x, o))) === null || k === void 0 ? void 0 : k.length) ? u : x;
                            }, g), f = p = d(p, o);
                            if (p !== void 0 && p.length !== 0 || (p = h.niceMax), t.globals.isBarHorizontal) {
                                a = 0;
                                var b = t.globals.labels.slice();
                                p = P.getLargestStringFromArr(b), p = d(p, {
                                    seriesIndex: n,
                                    dataPointIndex: -1,
                                    w: t
                                }), f = e.dCtx.dimHelpers.getLargestStringFromMultiArr(p, b);
                            }
                            var m = new M(e.dCtx.ctx), w = "rotate(".concat(r.labels.rotate, " 0 0)"), A = m.getTextRects(p, r.labels.style.fontSize, r.labels.style.fontFamily, w, !1), l = A;
                            p !== f && (l = m.getTextRects(f, r.labels.style.fontSize, r.labels.style.fontFamily, w, !1)), i.push({
                                width: (c > l.width || c > A.width ? c : l.width > A.width ? l.width : A.width) + a,
                                height: l.height > A.height ? l.height : A.height
                            });
                        } else i.push({
                            width: 0,
                            height: 0
                        });
                    }), i;
                }
            },
            {
                key: "getyAxisTitleCoords",
                value: function() {
                    var e = this, t = this.w, i = [];
                    return t.config.yaxis.map(function(a, s) {
                        if (a.show && a.title.text !== void 0) {
                            var r = new M(e.dCtx.ctx), n = "rotate(".concat(a.title.rotate, " 0 0)"), o = r.getTextRects(a.title.text, a.title.style.fontSize, a.title.style.fontFamily, n, !1);
                            i.push({
                                width: o.width,
                                height: o.height
                            });
                        } else i.push({
                            width: 0,
                            height: 0
                        });
                    }), i;
                }
            },
            {
                key: "getTotalYAxisWidth",
                value: function() {
                    var e = this.w, t = 0, i = 0, a = 0, s = e.globals.yAxisScale.length > 1 ? 10 : 0, r = new xe(this.dCtx.ctx), n = function(o, h) {
                        var c = e.config.yaxis[h].floating, d = 0;
                        o.width > 0 && !c ? (d = o.width + s, function(g) {
                            return e.globals.ignoreYAxisIndexes.indexOf(g) > -1;
                        }(h) && (d = d - o.width - s)) : d = c || r.isYAxisHidden(h) ? 0 : 5, e.config.yaxis[h].opposite ? a += d : i += d, t += d;
                    };
                    return e.globals.yLabelsCoords.map(function(o, h) {
                        n(o, h);
                    }), e.globals.yTitleCoords.map(function(o, h) {
                        n(o, h);
                    }), e.globals.isBarHorizontal && !e.config.yaxis[0].floating && (t = e.globals.yLabelsCoords[0].width + e.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, t;
                }
            }
        ]), y;
    }(), Ct = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.dCtx = e;
        }
        return Y(y, [
            {
                key: "gridPadForColumnsInNumericAxis",
                value: function(e) {
                    var t = this.w;
                    if (t.globals.noData || t.globals.allSeriesCollapsed) return 0;
                    var i = function(c) {
                        return c === "bar" || c === "rangeBar" || c === "candlestick" || c === "boxPlot";
                    }, a = t.config.chart.type, s = 0, r = i(a) ? t.config.series.length : 1;
                    if (t.globals.comboBarCount > 0 && (r = t.globals.comboBarCount), t.globals.collapsedSeries.forEach(function(c) {
                        i(c.type) && (r -= 1);
                    }), t.config.chart.stacked && (r = 1), (i(a) || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && r > 0) {
                        var n, o, h = Math.abs(t.globals.initialMaxX - t.globals.initialMinX);
                        h <= 3 && (h = t.globals.dataPoints), n = h / e, t.globals.minXDiff && t.globals.minXDiff / n > 0 && (o = t.globals.minXDiff / n), o > e / 2 && (o /= 2), (s = o / r * parseInt(t.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), s = s / (r > 1 ? 1 : 1.5) + 5, t.globals.barPadForNumericAxis = s;
                    }
                    return s;
                }
            },
            {
                key: "gridPadFortitleSubtitle",
                value: function() {
                    var e = this, t = this.w, i = t.globals, a = this.dCtx.isSparkline || !t.globals.axisCharts ? 0 : 10;
                    [
                        "title",
                        "subtitle"
                    ].forEach(function(n) {
                        t.config[n].text !== void 0 ? a += t.config[n].margin : a += e.dCtx.isSparkline || !t.globals.axisCharts ? 0 : 5;
                    }), !t.config.legend.show || t.config.legend.position !== "bottom" || t.config.legend.floating || t.globals.axisCharts || (a += 10);
                    var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                    i.gridHeight = i.gridHeight - s.height - r.height - a, i.translateY = i.translateY + s.height + r.height + a;
                }
            },
            {
                key: "setGridXPosForDualYAxis",
                value: function(e, t) {
                    var i = this.w, a = new xe(this.dCtx.ctx);
                    i.config.yaxis.map(function(s, r) {
                        i.globals.ignoreYAxisIndexes.indexOf(r) !== -1 || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX = i.globals.translateX - (t[r].width + e[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                    });
                }
            }
        ]), y;
    }(), Ye = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new kt(this), this.dimYAxis = new St(this), this.dimXAxis = new At(this), this.dimGrid = new Ct(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
        }
        return Y(y, [
            {
                key: "plotCoords",
                value: function() {
                    var e = this, t = this.w, i = t.globals;
                    this.lgRect = this.dimHelpers.getLegendsRect(), this.isSparkline && ((t.config.markers.discrete.length > 0 || t.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(s) {
                        var r = Me(s, 2), n = r[0], o = r[1];
                        e.gridPad[n] = Math.max(o, e.w.globals.markers.largestSize / 1.5);
                    }), this.gridPad.top = Math.max(t.config.stroke.width / 2, this.gridPad.top), this.gridPad.bottom = Math.max(t.config.stroke.width / 2, this.gridPad.bottom)), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                    var a = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                    i.gridWidth = i.gridWidth - 2 * a, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (a > 0 ? a + 4 : 0), i.translateY = i.translateY + this.gridPad.top;
                }
            },
            {
                key: "setDimensionsForAxisCharts",
                value: function() {
                    var e = this, t = this.w, i = t.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                    t.globals.yLabelsCoords = [], t.globals.yTitleCoords = [], t.config.yaxis.map(function(p, f) {
                        t.globals.yLabelsCoords.push({
                            width: a[f].width,
                            index: f
                        }), t.globals.yTitleCoords.push({
                            width: s[f].width,
                            index: f
                        });
                    }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                    var r = this.dimXAxis.getxAxisLabelsCoords(), n = this.dimXAxis.getxAxisGroupLabelsCoords(), o = this.dimXAxis.getxAxisTitleCoords();
                    this.conditionalChecksForAxisCoords(r, o, n), i.translateXAxisY = t.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = t.globals.rotateXLabels && t.globals.isXNumeric && t.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, t.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(t.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + t.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + t.config.xaxis.labels.offsetX;
                    var h = this.yAxisWidth, c = this.xAxisHeight;
                    i.xAxisLabelsHeight = this.xAxisHeight - o.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                    var d = 10;
                    (t.config.chart.type === "radar" || this.isSparkline) && (h = 0, c = i.goldenPadding), this.isSparkline && (this.lgRect = {
                        height: 0,
                        width: 0
                    }), (this.isSparkline || t.config.chart.type === "treemap") && (h = 0, c = 0, d = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                    var g = function() {
                        i.translateX = h, i.gridHeight = i.svgHeight - e.lgRect.height - c - (e.isSparkline || t.config.chart.type === "treemap" ? 0 : t.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - h;
                    };
                    switch(t.config.xaxis.position === "top" && (d = i.xAxisHeight - t.config.xaxis.axisTicks.height - 5), t.config.legend.position){
                        case "bottom":
                            i.translateY = d, g();
                            break;
                        case "top":
                            i.translateY = this.lgRect.height + d, g();
                            break;
                        case "left":
                            i.translateY = d, i.translateX = this.lgRect.width + h, i.gridHeight = i.svgHeight - c - 12, i.gridWidth = i.svgWidth - this.lgRect.width - h;
                            break;
                        case "right":
                            i.translateY = d, i.translateX = h, i.gridHeight = i.svgHeight - c - 12, i.gridWidth = i.svgWidth - this.lgRect.width - h - 5;
                            break;
                        default:
                            throw new Error("Legend position not supported");
                    }
                    this.dimGrid.setGridXPosForDualYAxis(s, a), new Ne(this.ctx).setYAxisXPosition(a, s);
                }
            },
            {
                key: "setDimensionsForNonAxisCharts",
                value: function() {
                    var e = this.w, t = e.globals, i = e.config, a = 0;
                    e.config.legend.show && !e.config.legend.floating && (a = 20);
                    var s = i.chart.type === "pie" || i.chart.type === "polarArea" || i.chart.type === "donut" ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, n = i.plotOptions[s].offsetX;
                    if (!i.legend.show || i.legend.floating) return t.gridHeight = t.svgHeight - i.grid.padding.left + i.grid.padding.right, t.gridWidth = t.gridHeight, t.translateY = r, void (t.translateX = n + (t.svgWidth - t.gridWidth) / 2);
                    switch(i.legend.position){
                        case "bottom":
                            t.gridHeight = t.svgHeight - this.lgRect.height - t.goldenPadding, t.gridWidth = t.svgWidth, t.translateY = r - 10, t.translateX = n + (t.svgWidth - t.gridWidth) / 2;
                            break;
                        case "top":
                            t.gridHeight = t.svgHeight - this.lgRect.height - t.goldenPadding, t.gridWidth = t.svgWidth, t.translateY = this.lgRect.height + r + 10, t.translateX = n + (t.svgWidth - t.gridWidth) / 2;
                            break;
                        case "left":
                            t.gridWidth = t.svgWidth - this.lgRect.width - a, t.gridHeight = i.chart.height !== "auto" ? t.svgHeight : t.gridWidth, t.translateY = r, t.translateX = n + this.lgRect.width + a;
                            break;
                        case "right":
                            t.gridWidth = t.svgWidth - this.lgRect.width - a - 5, t.gridHeight = i.chart.height !== "auto" ? t.svgHeight : t.gridWidth, t.translateY = r, t.translateX = n + 10;
                            break;
                        default:
                            throw new Error("Legend position not supported");
                    }
                }
            },
            {
                key: "conditionalChecksForAxisCoords",
                value: function(e, t, i) {
                    var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + e.height + t.height, n = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, o = a.globals.rotateXLabels ? 22 : 10, h = a.globals.rotateXLabels && a.config.legend.position === "bottom" ? 10 : 0;
                    this.xAxisHeight = r * n + s * o + h, this.xAxisWidth = e.width, this.xAxisHeight - t.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                    var c = 0, d = 0;
                    a.config.yaxis.forEach(function(g) {
                        c += g.labels.minWidth, d += g.labels.maxWidth;
                    }), this.yAxisWidth < c && (this.yAxisWidth = c), this.yAxisWidth > d && (this.yAxisWidth = d);
                }
            }
        ]), y;
    }(), Lt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.lgCtx = e;
        }
        return Y(y, [
            {
                key: "getLegendStyles",
                value: function() {
                    var e, t, i, a = document.createElement("style");
                    a.setAttribute("type", "text/css");
                    var s = ((e = this.lgCtx.ctx) === null || e === void 0 || (t = e.opts) === null || t === void 0 || (i = t.chart) === null || i === void 0 ? void 0 : i.nonce) || this.w.config.chart.nonce;
                    s && a.setAttribute("nonce", s);
                    var r = document.createTextNode(`
      .apexcharts-legend {
        display: flex;
        overflow: auto;
        padding: 0 10px;
      }
      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {
        flex-wrap: wrap
      }
      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
        flex-direction: column;
        bottom: 0;
      }
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
        justify-content: flex-start;
      }
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
        justify-content: center;
      }
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
        justify-content: flex-end;
      }
      .apexcharts-legend-series {
        cursor: pointer;
        line-height: normal;
      }
      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{
        display: flex;
        align-items: center;
      }
      .apexcharts-legend-text {
        position: relative;
        font-size: 14px;
      }
      .apexcharts-legend-text *, .apexcharts-legend-marker * {
        pointer-events: none;
      }
      .apexcharts-legend-marker {
        position: relative;
        display: inline-block;
        cursor: pointer;
        margin-right: 3px;
        border-style: solid;
      }

      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{
        display: inline-block;
      }
      .apexcharts-legend-series.apexcharts-no-click {
        cursor: auto;
      }
      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {
        display: none !important;
      }
      .apexcharts-inactive-legend {
        opacity: 0.45;
      }`);
                    return a.appendChild(r), a;
                }
            },
            {
                key: "getLegendBBox",
                value: function() {
                    var e = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), t = e.width;
                    return {
                        clwh: e.height,
                        clww: t
                    };
                }
            },
            {
                key: "appendToForeignObject",
                value: function() {
                    this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
                }
            },
            {
                key: "toggleDataSeries",
                value: function(e, t) {
                    var i = this, a = this.w;
                    if (a.globals.axisCharts || a.config.chart.type === "radialBar") {
                        a.globals.resized = !0;
                        var s = null, r = null;
                        a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(e + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), t ? [
                            {
                                cs: a.globals.collapsedSeries,
                                csi: a.globals.collapsedSeriesIndices
                            },
                            {
                                cs: a.globals.ancillaryCollapsedSeries,
                                csi: a.globals.ancillaryCollapsedSeriesIndices
                            }
                        ].forEach(function(c) {
                            i.riseCollapsedSeries(c.cs, c.csi, r);
                        }) : this.hideSeries({
                            seriesEl: s,
                            realIndex: r
                        });
                    } else {
                        var n = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(e + 1, "'] path")), o = a.config.chart.type;
                        if (o === "pie" || o === "polarArea" || o === "donut") {
                            var h = a.config.plotOptions.pie.donut.labels;
                            new M(this.lgCtx.ctx).pathMouseDown(n.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(n.members[0].node, h);
                        }
                        n.fire("click");
                    }
                }
            },
            {
                key: "hideSeries",
                value: function(e) {
                    var t = e.seriesEl, i = e.realIndex, a = this.w, s = P.clone(a.config.series);
                    if (a.globals.axisCharts) {
                        var r = !1;
                        if (a.config.yaxis[i] && a.config.yaxis[i].show && a.config.yaxis[i].showAlways && (r = !0, a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (a.globals.ancillaryCollapsedSeries.push({
                            index: i,
                            data: s[i].data.slice(),
                            type: t.parentNode.className.baseVal.split("-")[1]
                        }), a.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                            a.globals.collapsedSeries.push({
                                index: i,
                                data: s[i].data.slice(),
                                type: t.parentNode.className.baseVal.split("-")[1]
                            }), a.globals.collapsedSeriesIndices.push(i);
                            var n = a.globals.risingSeries.indexOf(i);
                            a.globals.risingSeries.splice(n, 1);
                        }
                    } else a.globals.collapsedSeries.push({
                        index: i,
                        data: s[i]
                    }), a.globals.collapsedSeriesIndices.push(i);
                    for(var o = t.childNodes, h = 0; h < o.length; h++)o[h].classList.contains("apexcharts-series-markers-wrap") && (o[h].classList.contains("apexcharts-hide") ? o[h].classList.remove("apexcharts-hide") : o[h].classList.add("apexcharts-hide"));
                    a.globals.allSeriesCollapsed = a.globals.collapsedSeries.length === a.config.series.length, s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            },
            {
                key: "riseCollapsedSeries",
                value: function(e, t, i) {
                    var a = this.w, s = P.clone(a.config.series);
                    if (e.length > 0) {
                        for(var r = 0; r < e.length; r++)e[r].index === i && (a.globals.axisCharts ? (s[i].data = e[r].data.slice(), e.splice(r, 1), t.splice(r, 1), a.globals.risingSeries.push(i)) : (s[i] = e[r].data, e.splice(r, 1), t.splice(r, 1), a.globals.risingSeries.push(i)));
                        s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                    }
                }
            },
            {
                key: "_getSeriesBasedOnCollapsedState",
                value: function(e) {
                    var t = this.w;
                    return t.globals.axisCharts ? e.forEach(function(i, a) {
                        t.globals.collapsedSeriesIndices.indexOf(a) > -1 && (e[a].data = []);
                    }) : e.forEach(function(i, a) {
                        t.globals.collapsedSeriesIndices.indexOf(a) > -1 && (e[a] = 0);
                    }), e;
                }
            }
        ]), y;
    }(), Ke = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = this.w.config.chart.type === "bar" && this.w.config.plotOptions.bar.distributed && this.w.config.series.length === 1, this.legendHelpers = new Lt(this);
        }
        return Y(y, [
            {
                key: "init",
                value: function() {
                    var e = this.w, t = e.globals, i = e.config;
                    if ((i.legend.showForSingleSeries && t.series.length === 1 || this.isBarsDistributed || t.series.length > 1 || !t.axisCharts) && i.legend.show) {
                        for(; t.dom.elLegendWrap.firstChild;)t.dom.elLegendWrap.removeChild(t.dom.elLegendWrap.firstChild);
                        this.drawLegends(), P.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), i.legend.position === "bottom" || i.legend.position === "top" ? this.legendAlignHorizontal() : i.legend.position !== "right" && i.legend.position !== "left" || this.legendAlignVertical();
                    }
                }
            },
            {
                key: "drawLegends",
                value: function() {
                    var e = this, t = this.w, i = t.config.legend.fontFamily, a = t.globals.seriesNames, s = t.globals.colors.slice();
                    if (t.config.chart.type === "heatmap") {
                        var r = t.config.plotOptions.heatmap.colorScale.ranges;
                        a = r.map(function(T) {
                            return T.name ? T.name : T.from + " - " + T.to;
                        }), s = r.map(function(T) {
                            return T.color;
                        });
                    } else this.isBarsDistributed && (a = t.globals.labels.slice());
                    t.config.legend.customLegendItems.length && (a = t.config.legend.customLegendItems);
                    for(var n = t.globals.legendFormatter, o = t.config.legend.inverseOrder, h = o ? a.length - 1 : 0; o ? h >= 0 : h <= a.length - 1; o ? h-- : h++){
                        var c, d = n(a[h], {
                            seriesIndex: h,
                            w: t
                        }), g = !1, p = !1;
                        if (t.globals.collapsedSeries.length > 0) for(var f = 0; f < t.globals.collapsedSeries.length; f++)t.globals.collapsedSeries[f].index === h && (g = !0);
                        if (t.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var b = 0; b < t.globals.ancillaryCollapsedSeriesIndices.length; b++)t.globals.ancillaryCollapsedSeriesIndices[b] === h && (p = !0);
                        var m = document.createElement("span");
                        m.classList.add("apexcharts-legend-marker");
                        var w = t.config.legend.markers.offsetX, A = t.config.legend.markers.offsetY, l = t.config.legend.markers.height, u = t.config.legend.markers.width, x = t.config.legend.markers.strokeWidth, v = t.config.legend.markers.strokeColor, k = t.config.legend.markers.radius, S = m.style;
                        S.background = s[h], S.color = s[h], S.setProperty("background", s[h], "important"), t.config.legend.markers.fillColors && t.config.legend.markers.fillColors[h] && (S.background = t.config.legend.markers.fillColors[h]), t.globals.seriesColors[h] !== void 0 && (S.background = t.globals.seriesColors[h], S.color = t.globals.seriesColors[h]), S.height = Array.isArray(l) ? parseFloat(l[h]) + "px" : parseFloat(l) + "px", S.width = Array.isArray(u) ? parseFloat(u[h]) + "px" : parseFloat(u) + "px", S.left = (Array.isArray(w) ? parseFloat(w[h]) : parseFloat(w)) + "px", S.top = (Array.isArray(A) ? parseFloat(A[h]) : parseFloat(A)) + "px", S.borderWidth = Array.isArray(x) ? x[h] : x, S.borderColor = Array.isArray(v) ? v[h] : v, S.borderRadius = Array.isArray(k) ? parseFloat(k[h]) + "px" : parseFloat(k) + "px", t.config.legend.markers.customHTML && (Array.isArray(t.config.legend.markers.customHTML) ? t.config.legend.markers.customHTML[h] && (m.innerHTML = t.config.legend.markers.customHTML[h]()) : m.innerHTML = t.config.legend.markers.customHTML()), M.setAttrs(m, {
                            rel: h + 1,
                            "data:collapsed": g || p
                        }), (g || p) && m.classList.add("apexcharts-inactive-legend");
                        var C = document.createElement("div"), L = document.createElement("span");
                        L.classList.add("apexcharts-legend-text"), L.innerHTML = Array.isArray(d) ? d.join(" ") : d;
                        var I = t.config.legend.labels.useSeriesColors ? t.globals.colors[h] : Array.isArray(t.config.legend.labels.colors) ? (c = t.config.legend.labels.colors) === null || c === void 0 ? void 0 : c[h] : t.config.legend.labels.colors;
                        I || (I = t.config.chart.foreColor), L.style.color = I, L.style.fontSize = parseFloat(t.config.legend.fontSize) + "px", L.style.fontWeight = t.config.legend.fontWeight, L.style.fontFamily = i || t.config.chart.fontFamily, M.setAttrs(L, {
                            rel: h + 1,
                            i: h,
                            "data:default-text": encodeURIComponent(d),
                            "data:collapsed": g || p
                        }), C.appendChild(m), C.appendChild(L);
                        var z = new q(this.ctx);
                        t.config.legend.showForZeroSeries || z.getSeriesTotalByIndex(h) === 0 && z.seriesHaveSameValues(h) && !z.isSeriesNull(h) && t.globals.collapsedSeriesIndices.indexOf(h) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(h) === -1 && C.classList.add("apexcharts-hidden-zero-series"), t.config.legend.showForNullSeries || z.isSeriesNull(h) && t.globals.collapsedSeriesIndices.indexOf(h) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(h) === -1 && C.classList.add("apexcharts-hidden-null-series"), t.globals.dom.elLegendWrap.appendChild(C), t.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(t.config.legend.horizontalAlign)), t.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + t.config.legend.position), C.classList.add("apexcharts-legend-series"), C.style.margin = "".concat(t.config.legend.itemMargin.vertical, "px ").concat(t.config.legend.itemMargin.horizontal, "px"), t.globals.dom.elLegendWrap.style.width = t.config.legend.width ? t.config.legend.width + "px" : "", t.globals.dom.elLegendWrap.style.height = t.config.legend.height ? t.config.legend.height + "px" : "", M.setAttrs(C, {
                            rel: h + 1,
                            seriesName: P.escapeString(a[h]),
                            "data:collapsed": g || p
                        }), (g || p) && C.classList.add("apexcharts-inactive-legend"), t.config.legend.onItemClick.toggleDataSeries || C.classList.add("apexcharts-no-click");
                    }
                    t.globals.dom.elWrap.addEventListener("click", e.onLegendClick, !0), t.config.legend.onItemHover.highlightDataSeries && t.config.legend.customLegendItems.length === 0 && (t.globals.dom.elWrap.addEventListener("mousemove", e.onLegendHovered, !0), t.globals.dom.elWrap.addEventListener("mouseout", e.onLegendHovered, !0));
                }
            },
            {
                key: "setLegendWrapXY",
                value: function(e, t) {
                    var i = this.w, a = i.globals.dom.elLegendWrap, s = a.getBoundingClientRect(), r = 0, n = 0;
                    if (i.config.legend.position === "bottom") n += i.globals.svgHeight - s.height / 2;
                    else if (i.config.legend.position === "top") {
                        var o = new Ye(this.ctx), h = o.dimHelpers.getTitleSubtitleCoords("title").height, c = o.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                        n = n + (h > 0 ? h - 10 : 0) + (c > 0 ? c - 10 : 0);
                    }
                    a.style.position = "absolute", r = r + e + i.config.legend.offsetX, n = n + t + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = n + "px", i.config.legend.position === "bottom" ? (a.style.top = "auto", a.style.bottom = 5 - i.config.legend.offsetY + "px") : i.config.legend.position === "right" && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px"), [
                        "width",
                        "height"
                    ].forEach(function(d) {
                        a.style[d] && (a.style[d] = parseInt(i.config.legend[d], 10) + "px");
                    });
                }
            },
            {
                key: "legendAlignHorizontal",
                value: function() {
                    var e = this.w;
                    e.globals.dom.elLegendWrap.style.right = 0;
                    var t = this.legendHelpers.getLegendBBox(), i = new Ye(this.ctx), a = i.dimHelpers.getTitleSubtitleCoords("title"), s = i.dimHelpers.getTitleSubtitleCoords("subtitle"), r = 0;
                    e.config.legend.position === "bottom" ? r = -t.clwh / 1.8 : e.config.legend.position === "top" && (r = a.height + s.height + e.config.title.margin + e.config.subtitle.margin - 10), this.setLegendWrapXY(20, r);
                }
            },
            {
                key: "legendAlignVertical",
                value: function() {
                    var e = this.w, t = this.legendHelpers.getLegendBBox(), i = 0;
                    e.config.legend.position === "left" && (i = 20), e.config.legend.position === "right" && (i = e.globals.svgWidth - t.clww - 10), this.setLegendWrapXY(i, 20);
                }
            },
            {
                key: "onLegendHovered",
                value: function(e) {
                    var t = this.w, i = e.target.classList.contains("apexcharts-legend-series") || e.target.classList.contains("apexcharts-legend-text") || e.target.classList.contains("apexcharts-legend-marker");
                    if (t.config.chart.type === "heatmap" || this.isBarsDistributed) {
                        if (i) {
                            var a = parseInt(e.target.getAttribute("rel"), 10) - 1;
                            this.ctx.events.fireEvent("legendHover", [
                                this.ctx,
                                a,
                                this.w
                            ]), new te(this.ctx).highlightRangeInSeries(e, e.target);
                        }
                    } else !e.target.classList.contains("apexcharts-inactive-legend") && i && new te(this.ctx).toggleSeriesOnHover(e, e.target);
                }
            },
            {
                key: "onLegendClick",
                value: function(e) {
                    var t = this.w;
                    if (!t.config.legend.customLegendItems.length && (e.target.classList.contains("apexcharts-legend-series") || e.target.classList.contains("apexcharts-legend-text") || e.target.classList.contains("apexcharts-legend-marker"))) {
                        var i = parseInt(e.target.getAttribute("rel"), 10) - 1, a = e.target.getAttribute("data:collapsed") === "true", s = this.w.config.chart.events.legendClick;
                        typeof s == "function" && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                            this.ctx,
                            i,
                            this.w
                        ]);
                        var r = this.w.config.legend.markers.onClick;
                        typeof r == "function" && e.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                            this.ctx,
                            i,
                            this.w
                        ])), t.config.chart.type !== "treemap" && t.config.chart.type !== "heatmap" && !this.isBarsDistributed && t.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                    }
                }
            }
        ]), y;
    }(), et = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = t.globals.minX, this.maxX = t.globals.maxX;
        }
        return Y(y, [
            {
                key: "createToolbar",
                value: function() {
                    var e = this, t = this.w, i = function() {
                        return document.createElement("div");
                    }, a = i();
                    if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = t.config.chart.toolbar.offsetY + "px", a.style.right = 3 - t.config.chart.toolbar.offsetX + "px", t.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = t.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                    var r = [], n = function(d, g, p) {
                        var f = d.toLowerCase();
                        e.t[f] && t.config.chart.zoom.enabled && r.push({
                            el: g,
                            icon: typeof e.t[f] == "string" ? e.t[f] : p,
                            title: e.localeValues[d],
                            class: "apexcharts-".concat(f, "-icon")
                        });
                    };
                    n("zoomIn", this.elZoomIn, `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
</svg>
`), n("zoomOut", this.elZoomOut, `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
</svg>
`);
                    var o = function(d) {
                        e.t[d] && t.config.chart[d].enabled && r.push({
                            el: d === "zoom" ? e.elZoom : e.elSelection,
                            icon: typeof e.t[d] == "string" ? e.t[d] : d === "zoom" ? `<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
</svg>` : `<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>
</svg>`,
                            title: e.localeValues[d === "zoom" ? "selectionZoom" : "selection"],
                            class: t.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(d, "-icon")
                        });
                    };
                    o("zoom"), o("selection"), this.t.pan && t.config.chart.zoom.enabled && r.push({
                        el: this.elPan,
                        icon: typeof this.t.pan == "string" ? this.t.pan : `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <defs>
        <path d="M0 0h24v24H0z" id="a"/>
    </defs>
    <clipPath id="b">
        <use overflow="visible" xlink:href="#a"/>
    </clipPath>
    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>
</svg>`,
                        title: this.localeValues.pan,
                        class: t.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                    }), n("reset", this.elZoomReset, `<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
</svg>`), this.t.download && r.push({
                        el: this.elMenuIcon,
                        icon: typeof this.t.download == "string" ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                        title: this.localeValues.menu,
                        class: "apexcharts-menu-icon"
                    });
                    for(var h = 0; h < this.elCustomIcons.length; h++)r.push({
                        el: this.elCustomIcons[h],
                        icon: this.t.customIcons[h].icon,
                        title: this.t.customIcons[h].title,
                        index: this.t.customIcons[h].index,
                        class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[h].class
                    });
                    r.forEach(function(d, g) {
                        d.index && P.moveIndexInArray(r, g, d.index);
                    });
                    for(var c = 0; c < r.length; c++)M.setAttrs(r[c].el, {
                        class: r[c].class,
                        title: r[c].title
                    }), r[c].el.innerHTML = r[c].icon, a.appendChild(r[c].el);
                    this._createHamburgerMenu(a), t.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : t.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : t.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
                }
            },
            {
                key: "_createHamburgerMenu",
                value: function(e) {
                    this.elMenuItems = [], e.appendChild(this.elMenu), M.setAttrs(this.elMenu, {
                        class: "apexcharts-menu"
                    });
                    for(var t = [
                        {
                            name: "exportSVG",
                            title: this.localeValues.exportToSVG
                        },
                        {
                            name: "exportPNG",
                            title: this.localeValues.exportToPNG
                        },
                        {
                            name: "exportCSV",
                            title: this.localeValues.exportToCSV
                        }
                    ], i = 0; i < t.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = t[i].title, M.setAttrs(this.elMenuItems[i], {
                        class: "apexcharts-menu-item ".concat(t[i].name),
                        title: t[i].title
                    }), this.elMenu.appendChild(this.elMenuItems[i]);
                }
            },
            {
                key: "addToolbarEventListeners",
                value: function() {
                    var e = this;
                    this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(i) {
                        i.classList.contains("exportSVG") ? i.addEventListener("click", e.handleDownload.bind(e, "svg")) : i.classList.contains("exportPNG") ? i.addEventListener("click", e.handleDownload.bind(e, "png")) : i.classList.contains("exportCSV") && i.addEventListener("click", e.handleDownload.bind(e, "csv"));
                    });
                    for(var t = 0; t < this.t.customIcons.length; t++)this.elCustomIcons[t].addEventListener("click", this.t.customIcons[t].click.bind(this, this.ctx, this.ctx.w));
                }
            },
            {
                key: "toggleZoomSelection",
                value: function(e) {
                    this.ctx.getSyncedCharts().forEach(function(t) {
                        t.ctx.toolbar.toggleOtherControls();
                        var i = e === "selection" ? t.ctx.toolbar.elSelection : t.ctx.toolbar.elZoom, a = e === "selection" ? "selectionEnabled" : "zoomEnabled";
                        t.w.globals[a] = !t.w.globals[a], i.classList.contains(t.ctx.toolbar.selectedClass) ? i.classList.remove(t.ctx.toolbar.selectedClass) : i.classList.add(t.ctx.toolbar.selectedClass);
                    });
                }
            },
            {
                key: "getToolbarIconsReference",
                value: function() {
                    var e = this.w;
                    this.elZoom || (this.elZoom = e.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = e.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = e.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
                }
            },
            {
                key: "enableZoomPanFromToolbar",
                value: function(e) {
                    this.toggleOtherControls(), e === "pan" ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                    var t = e === "pan" ? this.elPan : this.elZoom, i = e === "pan" ? this.elZoom : this.elPan;
                    t && t.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
                }
            },
            {
                key: "togglePanning",
                value: function() {
                    this.ctx.getSyncedCharts().forEach(function(e) {
                        e.ctx.toolbar.toggleOtherControls(), e.w.globals.panEnabled = !e.w.globals.panEnabled, e.ctx.toolbar.elPan.classList.contains(e.ctx.toolbar.selectedClass) ? e.ctx.toolbar.elPan.classList.remove(e.ctx.toolbar.selectedClass) : e.ctx.toolbar.elPan.classList.add(e.ctx.toolbar.selectedClass);
                    });
                }
            },
            {
                key: "toggleOtherControls",
                value: function() {
                    var e = this, t = this.w;
                    t.globals.panEnabled = !1, t.globals.zoomEnabled = !1, t.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                        this.elPan,
                        this.elSelection,
                        this.elZoom
                    ].forEach(function(i) {
                        i && i.classList.remove(e.selectedClass);
                    });
                }
            },
            {
                key: "handleZoomIn",
                value: function() {
                    var e = this.w;
                    e.globals.isRangeBar && (this.minX = e.globals.minY, this.maxX = e.globals.maxY);
                    var t = (this.minX + this.maxX) / 2, i = (this.minX + t) / 2, a = (this.maxX + t) / 2, s = this._getNewMinXMaxX(i, a);
                    e.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            },
            {
                key: "handleZoomOut",
                value: function() {
                    var e = this.w;
                    if (e.globals.isRangeBar && (this.minX = e.globals.minY, this.maxX = e.globals.maxY), !(e.config.xaxis.type === "datetime" && new Date(this.minX).getUTCFullYear() < 1e3)) {
                        var t = (this.minX + this.maxX) / 2, i = this.minX - (t - this.minX), a = this.maxX - (t - this.maxX), s = this._getNewMinXMaxX(i, a);
                        e.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                    }
                }
            },
            {
                key: "_getNewMinXMaxX",
                value: function(e, t) {
                    var i = this.w.config.xaxis.convertedCatToNumeric;
                    return {
                        minX: i ? Math.floor(e) : e,
                        maxX: i ? Math.floor(t) : t
                    };
                }
            },
            {
                key: "zoomUpdateOptions",
                value: function(e, t) {
                    var i = this.w;
                    if (e !== void 0 || t !== void 0) {
                        if (!(i.config.xaxis.convertedCatToNumeric && (e < 1 && (e = 1, t = i.globals.dataPoints), t - e < 2))) {
                            var a = {
                                min: e,
                                max: t
                            }, s = this.getBeforeZoomRange(a);
                            s && (a = s.xaxis);
                            var r = {
                                xaxis: a
                            }, n = P.clone(i.globals.initialConfig.yaxis);
                            i.config.chart.zoom.autoScaleYaxis && (n = new we(this.ctx).autoScaleY(this.ctx, n, {
                                xaxis: a
                            })), i.config.chart.group || (r.yaxis = n), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, n);
                        }
                    } else this.handleZoomReset();
                }
            },
            {
                key: "zoomCallback",
                value: function(e, t) {
                    typeof this.ev.zoomed == "function" && this.ev.zoomed(this.ctx, {
                        xaxis: e,
                        yaxis: t
                    });
                }
            },
            {
                key: "getBeforeZoomRange",
                value: function(e, t) {
                    var i = null;
                    return typeof this.ev.beforeZoom == "function" && (i = this.ev.beforeZoom(this, {
                        xaxis: e,
                        yaxis: t
                    })), i;
                }
            },
            {
                key: "toggleMenu",
                value: function() {
                    var e = this;
                    window.setTimeout(function() {
                        e.elMenu.classList.contains("apexcharts-menu-open") ? e.elMenu.classList.remove("apexcharts-menu-open") : e.elMenu.classList.add("apexcharts-menu-open");
                    }, 0);
                }
            },
            {
                key: "handleDownload",
                value: function(e) {
                    var t = this.w, i = new Ee(this.ctx);
                    switch(e){
                        case "svg":
                            i.exportToSVG(this.ctx);
                            break;
                        case "png":
                            i.exportToPng(this.ctx);
                            break;
                        case "csv":
                            i.exportToCSV({
                                series: t.config.series,
                                columnDelimiter: t.config.chart.toolbar.export.csv.columnDelimiter
                            });
                    }
                }
            },
            {
                key: "handleZoomReset",
                value: function(e) {
                    this.ctx.getSyncedCharts().forEach(function(t) {
                        var i = t.w;
                        if (i.globals.lastXAxis.min = i.globals.initialConfig.xaxis.min, i.globals.lastXAxis.max = i.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), typeof i.config.chart.events.beforeResetZoom == "function") {
                            var a = i.config.chart.events.beforeResetZoom(t, i);
                            a && t.updateHelpers.revertDefaultAxisMinMax(a);
                        }
                        typeof i.config.chart.events.zoomed == "function" && t.ctx.toolbar.zoomCallback({
                            min: i.config.xaxis.min,
                            max: i.config.xaxis.max
                        }), i.globals.zoomed = !1;
                        var s = t.ctx.series.emptyCollapsedSeries(P.clone(i.globals.initialSeries));
                        t.updateHelpers._updateSeries(s, i.config.chart.animations.dynamicAnimation.enabled);
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
                }
            }
        ]), y;
    }(), Pt = function(y) {
        ge(t, et);
        var e = ue(t);
        function t(i) {
            var a;
            return F(this, t), (a = e.call(this, i)).ctx = i, a.w = i.w, a.dragged = !1, a.graphics = new M(a.ctx), a.eventList = [
                "mousedown",
                "mouseleave",
                "mousemove",
                "touchstart",
                "touchmove",
                "mouseup",
                "touchend"
            ], a.clientX = 0, a.clientY = 0, a.startX = 0, a.endX = 0, a.dragX = 0, a.startY = 0, a.endY = 0, a.dragY = 0, a.moveDirection = "none", a;
        }
        return Y(t, [
            {
                key: "init",
                value: function(i) {
                    var a = this, s = i.xyRatios, r = this.w, n = this;
                    this.xyRatios = s, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = r.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), r.globals.dom.elGraphical.add(this.zoomRect), r.globals.dom.elGraphical.add(this.selectionRect), r.config.chart.selection.type === "x" ? this.slDraggableRect = this.selectionRect.draggable({
                        minX: 0,
                        minY: 0,
                        maxX: r.globals.gridWidth,
                        maxY: r.globals.gridHeight
                    }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : r.config.chart.selection.type === "y" ? this.slDraggableRect = this.selectionRect.draggable({
                        minX: 0,
                        maxX: r.globals.gridWidth
                    }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = r.globals.dom.baseEl.querySelector("".concat(r.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(o) {
                        a.hoverArea.addEventListener(o, n.svgMouseEvents.bind(n, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
                }
            },
            {
                key: "svgMouseEvents",
                value: function(i, a) {
                    var s = this.w, r = this, n = this.ctx.toolbar, o = s.globals.zoomEnabled ? s.config.chart.zoom.type : s.config.chart.selection.type, h = s.config.chart.toolbar.autoSelected;
                    if (a.shiftKey ? (this.shiftWasPressed = !0, n.enableZoomPanFromToolbar(h === "pan" ? "zoom" : "pan")) : this.shiftWasPressed && (n.enableZoomPanFromToolbar(h), this.shiftWasPressed = !1), a.target) {
                        var c, d = a.target.classList;
                        if (a.target.parentNode && a.target.parentNode !== null && (c = a.target.parentNode.classList), !(d.contains("apexcharts-selection-rect") || d.contains("apexcharts-legend-marker") || d.contains("apexcharts-legend-text") || c && c.contains("apexcharts-toolbar"))) {
                            if (r.clientX = a.type === "touchmove" || a.type === "touchstart" ? a.touches[0].clientX : a.type === "touchend" ? a.changedTouches[0].clientX : a.clientX, r.clientY = a.type === "touchmove" || a.type === "touchstart" ? a.touches[0].clientY : a.type === "touchend" ? a.changedTouches[0].clientY : a.clientY, a.type === "mousedown" && a.which === 1) {
                                var g = r.gridRect.getBoundingClientRect();
                                r.startX = r.clientX - g.left, r.startY = r.clientY - g.top, r.dragged = !1, r.w.globals.mousedown = !0;
                            }
                            if ((a.type === "mousemove" && a.which === 1 || a.type === "touchmove") && (r.dragged = !0, s.globals.panEnabled ? (s.globals.selection = null, r.w.globals.mousedown && r.panDragging({
                                context: r,
                                zoomtype: o,
                                xyRatios: i
                            })) : (r.w.globals.mousedown && s.globals.zoomEnabled || r.w.globals.mousedown && s.globals.selectionEnabled) && (r.selection = r.selectionDrawing({
                                context: r,
                                zoomtype: o
                            }))), a.type === "mouseup" || a.type === "touchend" || a.type === "mouseleave") {
                                var p = r.gridRect.getBoundingClientRect();
                                r.w.globals.mousedown && (r.endX = r.clientX - p.left, r.endY = r.clientY - p.top, r.dragX = Math.abs(r.endX - r.startX), r.dragY = Math.abs(r.endY - r.startY), (s.globals.zoomEnabled || s.globals.selectionEnabled) && r.selectionDrawn({
                                    context: r,
                                    zoomtype: o
                                }), s.globals.panEnabled && s.config.xaxis.convertedCatToNumeric && r.delayedPanScrolled()), s.globals.zoomEnabled && r.hideSelectionRect(this.selectionRect), r.dragged = !1, r.w.globals.mousedown = !1;
                            }
                            this.makeSelectionRectDraggable();
                        }
                    }
                }
            },
            {
                key: "makeSelectionRectDraggable",
                value: function() {
                    var i = this.w;
                    if (this.selectionRect) {
                        var a = this.selectionRect.node.getBoundingClientRect();
                        a.width > 0 && a.height > 0 && this.slDraggableRect.selectize({
                            points: "l, r",
                            pointSize: 8,
                            pointType: "rect"
                        }).resize({
                            constraint: {
                                minX: 0,
                                minY: 0,
                                maxX: i.globals.gridWidth,
                                maxY: i.globals.gridHeight
                            }
                        }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                    }
                }
            },
            {
                key: "preselectedSelection",
                value: function() {
                    var i = this.w, a = this.xyRatios;
                    if (!i.globals.zoomEnabled) {
                        if (i.globals.selection !== void 0 && i.globals.selection !== null) this.drawSelectionRect(i.globals.selection);
                        else if (i.config.chart.selection.xaxis.min !== void 0 && i.config.chart.selection.xaxis.max !== void 0) {
                            var s = (i.config.chart.selection.xaxis.min - i.globals.minX) / a.xRatio, r = i.globals.gridWidth - (i.globals.maxX - i.config.chart.selection.xaxis.max) / a.xRatio - s;
                            i.globals.isRangeBar && (s = (i.config.chart.selection.xaxis.min - i.globals.yAxisScale[0].niceMin) / a.invertedYRatio, r = (i.config.chart.selection.xaxis.max - i.config.chart.selection.xaxis.min) / a.invertedYRatio);
                            var n = {
                                x: s,
                                y: 0,
                                width: r,
                                height: i.globals.gridHeight,
                                translateX: 0,
                                translateY: 0,
                                selectionEnabled: !0
                            };
                            this.drawSelectionRect(n), this.makeSelectionRectDraggable(), typeof i.config.chart.events.selection == "function" && i.config.chart.events.selection(this.ctx, {
                                xaxis: {
                                    min: i.config.chart.selection.xaxis.min,
                                    max: i.config.chart.selection.xaxis.max
                                },
                                yaxis: {}
                            });
                        }
                    }
                }
            },
            {
                key: "drawSelectionRect",
                value: function(i) {
                    var a = i.x, s = i.y, r = i.width, n = i.height, o = i.translateX, h = o === void 0 ? 0 : o, c = i.translateY, d = c === void 0 ? 0 : c, g = this.w, p = this.zoomRect, f = this.selectionRect;
                    if (this.dragged || g.globals.selection !== null) {
                        var b = {
                            transform: "translate(" + h + ", " + d + ")"
                        };
                        g.globals.zoomEnabled && this.dragged && (r < 0 && (r = 1), p.attr({
                            x: a,
                            y: s,
                            width: r,
                            height: n,
                            fill: g.config.chart.zoom.zoomedArea.fill.color,
                            "fill-opacity": g.config.chart.zoom.zoomedArea.fill.opacity,
                            stroke: g.config.chart.zoom.zoomedArea.stroke.color,
                            "stroke-width": g.config.chart.zoom.zoomedArea.stroke.width,
                            "stroke-opacity": g.config.chart.zoom.zoomedArea.stroke.opacity
                        }), M.setAttrs(p.node, b)), g.globals.selectionEnabled && (f.attr({
                            x: a,
                            y: s,
                            width: r > 0 ? r : 0,
                            height: n > 0 ? n : 0,
                            fill: g.config.chart.selection.fill.color,
                            "fill-opacity": g.config.chart.selection.fill.opacity,
                            stroke: g.config.chart.selection.stroke.color,
                            "stroke-width": g.config.chart.selection.stroke.width,
                            "stroke-dasharray": g.config.chart.selection.stroke.dashArray,
                            "stroke-opacity": g.config.chart.selection.stroke.opacity
                        }), M.setAttrs(f.node, b));
                    }
                }
            },
            {
                key: "hideSelectionRect",
                value: function(i) {
                    i && i.attr({
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    });
                }
            },
            {
                key: "selectionDrawing",
                value: function(i) {
                    var a = i.context, s = i.zoomtype, r = this.w, n = a, o = this.gridRect.getBoundingClientRect(), h = n.startX - 1, c = n.startY, d = !1, g = !1, p = n.clientX - o.left - h, f = n.clientY - o.top - c, b = {};
                    return Math.abs(p + h) > r.globals.gridWidth ? p = r.globals.gridWidth - h : n.clientX - o.left < 0 && (p = h), h > n.clientX - o.left && (d = !0, p = Math.abs(p)), c > n.clientY - o.top && (g = !0, f = Math.abs(f)), b = s === "x" ? {
                        x: d ? h - p : h,
                        y: 0,
                        width: p,
                        height: r.globals.gridHeight
                    } : s === "y" ? {
                        x: 0,
                        y: g ? c - f : c,
                        width: r.globals.gridWidth,
                        height: f
                    } : {
                        x: d ? h - p : h,
                        y: g ? c - f : c,
                        width: p,
                        height: f
                    }, n.drawSelectionRect(b), n.selectionDragging("resizing"), b;
                }
            },
            {
                key: "selectionDragging",
                value: function(i, a) {
                    var s = this, r = this.w, n = this.xyRatios, o = this.selectionRect, h = 0;
                    i === "resizing" && (h = 30);
                    var c = function(g) {
                        return parseFloat(o.node.getAttribute(g));
                    }, d = {
                        x: c("x"),
                        y: c("y"),
                        width: c("width"),
                        height: c("height")
                    };
                    r.globals.selection = d, typeof r.config.chart.events.selection == "function" && r.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                        var g, p, f, b, m = s.gridRect.getBoundingClientRect(), w = o.node.getBoundingClientRect();
                        r.globals.isRangeBar ? (g = r.globals.yAxisScale[0].niceMin + (w.left - m.left) * n.invertedYRatio, p = r.globals.yAxisScale[0].niceMin + (w.right - m.left) * n.invertedYRatio, f = 0, b = 1) : (g = r.globals.xAxisScale.niceMin + (w.left - m.left) * n.xRatio, p = r.globals.xAxisScale.niceMin + (w.right - m.left) * n.xRatio, f = r.globals.yAxisScale[0].niceMin + (m.bottom - w.bottom) * n.yRatio[0], b = r.globals.yAxisScale[0].niceMax - (w.top - m.top) * n.yRatio[0]);
                        var A = {
                            xaxis: {
                                min: g,
                                max: p
                            },
                            yaxis: {
                                min: f,
                                max: b
                            }
                        };
                        r.config.chart.events.selection(s.ctx, A), r.config.chart.brush.enabled && r.config.chart.events.brushScrolled !== void 0 && r.config.chart.events.brushScrolled(s.ctx, A);
                    }, h));
                }
            },
            {
                key: "selectionDrawn",
                value: function(i) {
                    var a = i.context, s = i.zoomtype, r = this.w, n = a, o = this.xyRatios, h = this.ctx.toolbar;
                    if (n.startX > n.endX) {
                        var c = n.startX;
                        n.startX = n.endX, n.endX = c;
                    }
                    if (n.startY > n.endY) {
                        var d = n.startY;
                        n.startY = n.endY, n.endY = d;
                    }
                    var g = void 0, p = void 0;
                    r.globals.isRangeBar ? (g = r.globals.yAxisScale[0].niceMin + n.startX * o.invertedYRatio, p = r.globals.yAxisScale[0].niceMin + n.endX * o.invertedYRatio) : (g = r.globals.xAxisScale.niceMin + n.startX * o.xRatio, p = r.globals.xAxisScale.niceMin + n.endX * o.xRatio);
                    var f = [], b = [];
                    if (r.config.yaxis.forEach(function(k, S) {
                        f.push(r.globals.yAxisScale[S].niceMax - o.yRatio[S] * n.startY), b.push(r.globals.yAxisScale[S].niceMax - o.yRatio[S] * n.endY);
                    }), n.dragged && (n.dragX > 10 || n.dragY > 10) && g !== p) {
                        if (r.globals.zoomEnabled) {
                            var m = P.clone(r.globals.initialConfig.yaxis), w = P.clone(r.globals.initialConfig.xaxis);
                            if (r.globals.zoomed = !0, r.config.xaxis.convertedCatToNumeric && (g = Math.floor(g), p = Math.floor(p), g < 1 && (g = 1, p = r.globals.dataPoints), p - g < 2 && (p = g + 1)), s !== "xy" && s !== "x" || (w = {
                                min: g,
                                max: p
                            }), s !== "xy" && s !== "y" || m.forEach(function(k, S) {
                                m[S].min = b[S], m[S].max = f[S];
                            }), r.config.chart.zoom.autoScaleYaxis) {
                                var A = new we(n.ctx);
                                m = A.autoScaleY(n.ctx, m, {
                                    xaxis: w
                                });
                            }
                            if (h) {
                                var l = h.getBeforeZoomRange(w, m);
                                l && (w = l.xaxis ? l.xaxis : w, m = l.yaxis ? l.yaxis : m);
                            }
                            var u = {
                                xaxis: w
                            };
                            r.config.chart.group || (u.yaxis = m), n.ctx.updateHelpers._updateOptions(u, !1, n.w.config.chart.animations.dynamicAnimation.enabled), typeof r.config.chart.events.zoomed == "function" && h.zoomCallback(w, m);
                        } else if (r.globals.selectionEnabled) {
                            var x, v = null;
                            x = {
                                min: g,
                                max: p
                            }, s !== "xy" && s !== "y" || (v = P.clone(r.config.yaxis)).forEach(function(k, S) {
                                v[S].min = b[S], v[S].max = f[S];
                            }), r.globals.selection = n.selection, typeof r.config.chart.events.selection == "function" && r.config.chart.events.selection(n.ctx, {
                                xaxis: x,
                                yaxis: v
                            });
                        }
                    }
                }
            },
            {
                key: "panDragging",
                value: function(i) {
                    var a = i.context, s = this.w, r = a;
                    if (s.globals.lastClientPosition.x !== void 0) {
                        var n = s.globals.lastClientPosition.x - r.clientX, o = s.globals.lastClientPosition.y - r.clientY;
                        Math.abs(n) > Math.abs(o) && n > 0 ? this.moveDirection = "left" : Math.abs(n) > Math.abs(o) && n < 0 ? this.moveDirection = "right" : Math.abs(o) > Math.abs(n) && o > 0 ? this.moveDirection = "up" : Math.abs(o) > Math.abs(n) && o < 0 && (this.moveDirection = "down");
                    }
                    s.globals.lastClientPosition = {
                        x: r.clientX,
                        y: r.clientY
                    };
                    var h = s.globals.isRangeBar ? s.globals.minY : s.globals.minX, c = s.globals.isRangeBar ? s.globals.maxY : s.globals.maxX;
                    s.config.xaxis.convertedCatToNumeric || r.panScrolled(h, c);
                }
            },
            {
                key: "delayedPanScrolled",
                value: function() {
                    var i = this.w, a = i.globals.minX, s = i.globals.maxX, r = (i.globals.maxX - i.globals.minX) / 2;
                    this.moveDirection === "left" ? (a = i.globals.minX + r, s = i.globals.maxX + r) : this.moveDirection === "right" && (a = i.globals.minX - r, s = i.globals.maxX - r), a = Math.floor(a), s = Math.floor(s), this.updateScrolledChart({
                        xaxis: {
                            min: a,
                            max: s
                        }
                    }, a, s);
                }
            },
            {
                key: "panScrolled",
                value: function(i, a) {
                    var s = this.w, r = this.xyRatios, n = P.clone(s.globals.initialConfig.yaxis), o = r.xRatio, h = s.globals.minX, c = s.globals.maxX;
                    s.globals.isRangeBar && (o = r.invertedYRatio, h = s.globals.minY, c = s.globals.maxY), this.moveDirection === "left" ? (i = h + s.globals.gridWidth / 15 * o, a = c + s.globals.gridWidth / 15 * o) : this.moveDirection === "right" && (i = h - s.globals.gridWidth / 15 * o, a = c - s.globals.gridWidth / 15 * o), s.globals.isRangeBar || (i < s.globals.initialMinX || a > s.globals.initialMaxX) && (i = h, a = c);
                    var d = {
                        min: i,
                        max: a
                    };
                    s.config.chart.zoom.autoScaleYaxis && (n = new we(this.ctx).autoScaleY(this.ctx, n, {
                        xaxis: d
                    }));
                    var g = {
                        xaxis: {
                            min: i,
                            max: a
                        }
                    };
                    s.config.chart.group || (g.yaxis = n), this.updateScrolledChart(g, i, a);
                }
            },
            {
                key: "updateScrolledChart",
                value: function(i, a, s) {
                    var r = this.w;
                    this.ctx.updateHelpers._updateOptions(i, !1, !1), typeof r.config.chart.events.scrolled == "function" && r.config.chart.events.scrolled(this.ctx, {
                        xaxis: {
                            min: a,
                            max: s
                        }
                    });
                }
            }
        ]), t;
    }(), tt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
        }
        return Y(y, [
            {
                key: "getNearestValues",
                value: function(e) {
                    var t = e.hoverArea, i = e.elGrid, a = e.clientX, s = e.clientY, r = this.w, n = i.getBoundingClientRect(), o = n.width, h = n.height, c = o / (r.globals.dataPoints - 1), d = h / r.globals.dataPoints, g = this.hasBars();
                    !r.globals.comboCharts && !g || r.config.xaxis.convertedCatToNumeric || (c = o / r.globals.dataPoints);
                    var p = a - n.left - r.globals.barPadForNumericAxis, f = s - n.top;
                    p < 0 || f < 0 || p > o || f > h ? (t.classList.remove("hovering-zoom"), t.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (t.classList.remove("hovering-pan"), t.classList.add("hovering-zoom")) : r.globals.panEnabled && (t.classList.remove("hovering-zoom"), t.classList.add("hovering-pan"));
                    var b = Math.round(p / c), m = Math.floor(f / d);
                    g && !r.config.xaxis.convertedCatToNumeric && (b = Math.ceil(p / c), b -= 1);
                    var w = null, A = null, l = r.globals.seriesXvalues.map(function(S) {
                        return S.filter(function(C) {
                            return P.isNumber(C);
                        });
                    }), u = r.globals.seriesYvalues.map(function(S) {
                        return S.filter(function(C) {
                            return P.isNumber(C);
                        });
                    });
                    if (r.globals.isXNumeric) {
                        var x = this.ttCtx.getElGrid().getBoundingClientRect(), v = p * (x.width / o), k = f * (x.height / h);
                        w = (A = this.closestInMultiArray(v, k, l, u)).index, b = A.j, w !== null && (l = r.globals.seriesXvalues[w], b = (A = this.closestInArray(v, l)).index);
                    }
                    return r.globals.capturedSeriesIndex = w === null ? -1 : w, (!b || b < 1) && (b = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = m : r.globals.capturedDataPointIndex = b, {
                        capturedSeries: w,
                        j: r.globals.isBarHorizontal ? m : b,
                        hoverX: p,
                        hoverY: f
                    };
                }
            },
            {
                key: "closestInMultiArray",
                value: function(e, t, i, a) {
                    var s = this.w, r = 0, n = null, o = -1;
                    s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : n = 0;
                    var h = i[r][0], c = Math.abs(e - h);
                    if (i.forEach(function(p) {
                        p.forEach(function(f, b) {
                            var m = Math.abs(e - f);
                            m <= c && (c = m, o = b);
                        });
                    }), o !== -1) {
                        var d = a[r][o], g = Math.abs(t - d);
                        n = r, a.forEach(function(p, f) {
                            var b = Math.abs(t - p[o]);
                            b <= g && (g = b, n = f);
                        });
                    }
                    return {
                        index: n,
                        j: o
                    };
                }
            },
            {
                key: "getFirstActiveXArray",
                value: function(e) {
                    for(var t = this.w, i = 0, a = e.map(function(r, n) {
                        return r.length > 0 ? n : -1;
                    }), s = 0; s < a.length; s++)if (a[s] !== -1 && t.globals.collapsedSeriesIndices.indexOf(s) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(s) === -1) {
                        i = a[s];
                        break;
                    }
                    return i;
                }
            },
            {
                key: "closestInArray",
                value: function(e, t) {
                    for(var i = t[0], a = null, s = Math.abs(e - i), r = 0; r < t.length; r++){
                        var n = Math.abs(e - t[r]);
                        n < s && (s = n, a = r);
                    }
                    return {
                        index: a
                    };
                }
            },
            {
                key: "isXoverlap",
                value: function(e) {
                    var t = [], i = this.w.globals.seriesX.filter(function(s) {
                        return s[0] !== void 0;
                    });
                    if (i.length > 0) for(var a = 0; a < i.length - 1; a++)i[a][e] !== void 0 && i[a + 1][e] !== void 0 && i[a][e] !== i[a + 1][e] && t.push("unEqual");
                    return t.length === 0;
                }
            },
            {
                key: "isInitialSeriesSameLen",
                value: function() {
                    for(var e = !0, t = this.w.globals.initialSeries, i = 0; i < t.length - 1; i++)if (t[i].data.length !== t[i + 1].data.length) {
                        e = !1;
                        break;
                    }
                    return e;
                }
            },
            {
                key: "getBarsHeight",
                value: function(e) {
                    return J(e).reduce(function(t, i) {
                        return t + i.getBBox().height;
                    }, 0);
                }
            },
            {
                key: "getElMarkers",
                value: function(e) {
                    return typeof e == "number" ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
                }
            },
            {
                key: "getAllMarkers",
                value: function() {
                    var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                    (e = J(e)).sort(function(i, a) {
                        var s = Number(i.getAttribute("data:realIndex")), r = Number(a.getAttribute("data:realIndex"));
                        return r < s ? 1 : r > s ? -1 : 0;
                    });
                    var t = [];
                    return e.forEach(function(i) {
                        t.push(i.querySelector(".apexcharts-marker"));
                    }), t;
                }
            },
            {
                key: "hasMarkers",
                value: function(e) {
                    return this.getElMarkers(e).length > 0;
                }
            },
            {
                key: "getElBars",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
                }
            },
            {
                key: "hasBars",
                value: function() {
                    return this.getElBars().length > 0;
                }
            },
            {
                key: "getHoverMarkerSize",
                value: function(e) {
                    var t = this.w, i = t.config.markers.hover.size;
                    return i === void 0 && (i = t.globals.markers.size[e] + t.config.markers.hover.sizeOffset), i;
                }
            },
            {
                key: "toggleAllTooltipSeriesGroups",
                value: function(e) {
                    var t = this.w, i = this.ttCtx;
                    i.allTooltipSeriesGroups.length === 0 && (i.allTooltipSeriesGroups = t.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                    for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)e === "enable" ? (a[s].classList.add("apexcharts-active"), a[s].style.display = t.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
                }
            }
        ]), y;
    }(), It = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new tt(e);
        }
        return Y(y, [
            {
                key: "drawSeriesTexts",
                value: function(e) {
                    var t = e.shared, i = t === void 0 || t, a = e.ttItems, s = e.i, r = s === void 0 ? 0 : s, n = e.j, o = n === void 0 ? null : n, h = e.y1, c = e.y2, d = e.e, g = this.w;
                    g.config.tooltip.custom !== void 0 ? this.handleCustomTooltip({
                        i: r,
                        j: o,
                        y1: h,
                        y2: c,
                        w: g
                    }) : this.toggleActiveInactiveSeries(i);
                    var p = this.getValuesToPrint({
                        i: r,
                        j: o
                    });
                    this.printLabels({
                        i: r,
                        j: o,
                        values: p,
                        ttItems: a,
                        shared: i,
                        e: d
                    });
                    var f = this.ttCtx.getElTooltip();
                    this.ttCtx.tooltipRect.ttWidth = f.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = f.getBoundingClientRect().height;
                }
            },
            {
                key: "printLabels",
                value: function(e) {
                    var t, i = this, a = e.i, s = e.j, r = e.values, n = e.ttItems, o = e.shared, h = e.e, c = this.w, d = [], g = function(x) {
                        return c.globals.seriesGoals[x] && c.globals.seriesGoals[x][s] && Array.isArray(c.globals.seriesGoals[x][s]);
                    }, p = r.xVal, f = r.zVal, b = r.xAxisTTVal, m = "", w = c.globals.colors[a];
                    s !== null && c.config.plotOptions.bar.distributed && (w = c.globals.colors[s]);
                    for(var A = function(x, v) {
                        var k = i.getFormatters(a);
                        m = i.getSeriesName({
                            fn: k.yLbTitleFormatter,
                            index: a,
                            seriesIndex: a,
                            j: s
                        }), c.config.chart.type === "treemap" && (m = k.yLbTitleFormatter(String(c.config.series[a].data[s].x), {
                            series: c.globals.series,
                            seriesIndex: a,
                            dataPointIndex: s,
                            w: c
                        }));
                        var S = c.config.tooltip.inverseOrder ? v : x;
                        if (c.globals.axisCharts) {
                            var C = function(z) {
                                var T, E, R, O;
                                return c.globals.isRangeData ? k.yLbFormatter((T = c.globals.seriesRangeStart) === null || T === void 0 || (E = T[z]) === null || E === void 0 ? void 0 : E[s], {
                                    series: c.globals.seriesRangeStart,
                                    seriesIndex: z,
                                    dataPointIndex: s,
                                    w: c
                                }) + " - " + k.yLbFormatter((R = c.globals.seriesRangeEnd) === null || R === void 0 || (O = R[z]) === null || O === void 0 ? void 0 : O[s], {
                                    series: c.globals.seriesRangeEnd,
                                    seriesIndex: z,
                                    dataPointIndex: s,
                                    w: c
                                }) : k.yLbFormatter(c.globals.series[z][s], {
                                    series: c.globals.series,
                                    seriesIndex: z,
                                    dataPointIndex: s,
                                    w: c
                                });
                            };
                            if (o) k = i.getFormatters(S), m = i.getSeriesName({
                                fn: k.yLbTitleFormatter,
                                index: S,
                                seriesIndex: a,
                                j: s
                            }), w = c.globals.colors[S], t = C(S), g(S) && (d = c.globals.seriesGoals[S][s].map(function(z) {
                                return {
                                    attrs: z,
                                    val: k.yLbFormatter(z.value, {
                                        seriesIndex: S,
                                        dataPointIndex: s,
                                        w: c
                                    })
                                };
                            }));
                            else {
                                var L, I = h == null || (L = h.target) === null || L === void 0 ? void 0 : L.getAttribute("fill");
                                I && (w = I.indexOf("url") !== -1 ? document.querySelector(I.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke") : I), t = C(a), g(a) && Array.isArray(c.globals.seriesGoals[a][s]) && (d = c.globals.seriesGoals[a][s].map(function(z) {
                                    return {
                                        attrs: z,
                                        val: k.yLbFormatter(z.value, {
                                            seriesIndex: a,
                                            dataPointIndex: s,
                                            w: c
                                        })
                                    };
                                }));
                            }
                        }
                        s === null && (t = k.yLbFormatter(c.globals.series[a], X(X({}, c), {}, {
                            seriesIndex: a,
                            dataPointIndex: a
                        }))), i.DOMHandling({
                            i: a,
                            t: S,
                            j: s,
                            ttItems: n,
                            values: {
                                val: t,
                                goalVals: d,
                                xVal: p,
                                xAxisTTVal: b,
                                zVal: f
                            },
                            seriesName: m,
                            shared: o,
                            pColor: w
                        });
                    }, l = 0, u = c.globals.series.length - 1; l < c.globals.series.length; l++, u--)A(l, u);
                }
            },
            {
                key: "getFormatters",
                value: function(e) {
                    var t, i = this.w, a = i.globals.yLabelFormatters[e];
                    return i.globals.ttVal !== void 0 ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[e] && i.globals.ttVal[e].formatter, t = i.globals.ttVal[e] && i.globals.ttVal[e].title && i.globals.ttVal[e].title.formatter) : (a = i.globals.ttVal.formatter, typeof i.globals.ttVal.title.formatter == "function" && (t = i.globals.ttVal.title.formatter)) : t = i.config.tooltip.y.title.formatter, typeof a != "function" && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(s) {
                        return s;
                    }), typeof t != "function" && (t = function(s) {
                        return s;
                    }), {
                        yLbFormatter: a,
                        yLbTitleFormatter: t
                    };
                }
            },
            {
                key: "getSeriesName",
                value: function(e) {
                    var t = e.fn, i = e.index, a = e.seriesIndex, s = e.j, r = this.w;
                    return t(String(r.globals.seriesNames[i]), {
                        series: r.globals.series,
                        seriesIndex: a,
                        dataPointIndex: s,
                        w: r
                    });
                }
            },
            {
                key: "DOMHandling",
                value: function(e) {
                    e.i;
                    var t = e.t, i = e.j, a = e.ttItems, s = e.values, r = e.seriesName, n = e.shared, o = e.pColor, h = this.w, c = this.ttCtx, d = s.val, g = s.goalVals, p = s.xVal, f = s.xAxisTTVal, b = s.zVal, m = null;
                    m = a[t].children, h.config.tooltip.fillSeriesColor && (a[t].style.backgroundColor = o, m[0].style.display = "none"), c.showTooltipTitle && (c.tooltipTitle === null && (c.tooltipTitle = h.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), c.tooltipTitle.innerHTML = p), c.isXAxisTooltipEnabled && (c.xaxisTooltipText.innerHTML = f !== "" ? f : p);
                    var w = a[t].querySelector(".apexcharts-tooltip-text-y-label");
                    w && (w.innerHTML = r || "");
                    var A = a[t].querySelector(".apexcharts-tooltip-text-y-value");
                    A && (A.innerHTML = d !== void 0 ? d : ""), m[0] && m[0].classList.contains("apexcharts-tooltip-marker") && (h.config.tooltip.marker.fillColors && Array.isArray(h.config.tooltip.marker.fillColors) && (o = h.config.tooltip.marker.fillColors[t]), m[0].style.backgroundColor = o), h.config.tooltip.marker.show || (m[0].style.display = "none");
                    var l = a[t].querySelector(".apexcharts-tooltip-text-goals-label"), u = a[t].querySelector(".apexcharts-tooltip-text-goals-value");
                    if (g.length && h.globals.seriesGoals[t]) {
                        var x = function() {
                            var S = "<div >", C = "<div>";
                            g.forEach(function(L, I) {
                                S += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(L.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(L.attrs.name, "</div>"), C += "<div>".concat(L.val, "</div>");
                            }), l.innerHTML = S + "</div>", u.innerHTML = C + "</div>";
                        };
                        n ? h.globals.seriesGoals[t][i] && Array.isArray(h.globals.seriesGoals[t][i]) ? x() : (l.innerHTML = "", u.innerHTML = "") : x();
                    } else l.innerHTML = "", u.innerHTML = "";
                    if (b !== null && (a[t].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = h.config.tooltip.z.title, a[t].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = b !== void 0 ? b : ""), n && m[0]) {
                        if (h.config.tooltip.hideEmptySeries) {
                            var v = a[t].querySelector(".apexcharts-tooltip-marker"), k = a[t].querySelector(".apexcharts-tooltip-text");
                            parseFloat(d) == 0 ? (v.style.display = "none", k.style.display = "none") : (v.style.display = "block", k.style.display = "block");
                        }
                        d == null || h.globals.ancillaryCollapsedSeriesIndices.indexOf(t) > -1 || h.globals.collapsedSeriesIndices.indexOf(t) > -1 ? m[0].parentNode.style.display = "none" : m[0].parentNode.style.display = h.config.tooltip.items.display;
                    }
                }
            },
            {
                key: "toggleActiveInactiveSeries",
                value: function(e) {
                    var t = this.w;
                    if (e) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                    else {
                        this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                        var i = t.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                        i && (i.classList.add("apexcharts-active"), i.style.display = t.config.tooltip.items.display);
                    }
                }
            },
            {
                key: "getValuesToPrint",
                value: function(e) {
                    var t = e.i, i = e.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", n = "", o = null, h = null, c = {
                        series: a.globals.series,
                        seriesIndex: t,
                        dataPointIndex: i,
                        w: a
                    }, d = a.globals.ttZFormatter;
                    i === null ? h = a.globals.series[t] : a.globals.isXNumeric && a.config.chart.type !== "treemap" ? (r = s[t][i], s[t].length === 0 && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = a.globals.labels[i] !== void 0 ? a.globals.labels[i] : "";
                    var g = r;
                    return a.globals.isXNumeric && a.config.xaxis.type === "datetime" ? r = new re(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, g, g, {
                        i: void 0,
                        dateFormatter: new B(this.ctx).formatDate,
                        w: this.w
                    }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](g, c) : a.globals.xLabelFormatter(g, c), a.config.tooltip.x.formatter !== void 0 && (r = a.globals.ttKeyFormatter(g, c)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[t].length > 0 && (o = d(a.globals.seriesZ[t][i], a)), n = typeof a.config.xaxis.tooltip.formatter == "function" ? a.globals.xaxisTooltipFormatter(g, c) : r, {
                        val: Array.isArray(h) ? h.join(" ") : h,
                        xVal: Array.isArray(r) ? r.join(" ") : r,
                        xAxisTTVal: Array.isArray(n) ? n.join(" ") : n,
                        zVal: o
                    };
                }
            },
            {
                key: "handleCustomTooltip",
                value: function(e) {
                    var t = e.i, i = e.j, a = e.y1, s = e.y2, r = e.w, n = this.ttCtx.getElTooltip(), o = r.config.tooltip.custom;
                    Array.isArray(o) && o[t] && (o = o[t]), n.innerHTML = o({
                        ctx: this.ctx,
                        series: r.globals.series,
                        seriesIndex: t,
                        dataPointIndex: i,
                        y1: a,
                        y2: s,
                        w: r
                    });
                }
            }
        ]), y;
    }(), it = function() {
        function y(e) {
            F(this, y), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
        }
        return Y(y, [
            {
                key: "moveXCrosshairs",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = e - i.xcrosshairsWidth / 2, n = a.globals.labels.slice().length;
                    if (t !== null && (r = a.globals.gridWidth / n * t), s === null || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                        var o = r;
                        a.config.xaxis.crosshairs.width !== "tickWidth" && a.config.xaxis.crosshairs.width !== "barWidth" || (o = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(o);
                    }
                }
            },
            {
                key: "moveYCrosshairs",
                value: function(e) {
                    var t = this.ttCtx;
                    t.ycrosshairs !== null && M.setAttrs(t.ycrosshairs, {
                        y1: e,
                        y2: e
                    }), t.ycrosshairsHidden !== null && M.setAttrs(t.ycrosshairsHidden, {
                        y1: e,
                        y2: e
                    });
                }
            },
            {
                key: "moveXAxisTooltip",
                value: function(e) {
                    var t = this.w, i = this.ttCtx;
                    if (i.xaxisTooltip !== null && i.xcrosshairsWidth !== 0) {
                        i.xaxisTooltip.classList.add("apexcharts-active");
                        var a = i.xaxisOffY + t.config.xaxis.tooltip.offsetY + t.globals.translateY + 1 + t.config.xaxis.offsetY;
                        if (e -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(e)) {
                            e += t.globals.translateX;
                            var s;
                            s = new M(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = e + "px", i.xaxisTooltip.style.top = a + "px";
                        }
                    }
                }
            },
            {
                key: "moveYAxisTooltip",
                value: function(e) {
                    var t = this.w, i = this.ttCtx;
                    i.yaxisTTEls === null && (i.yaxisTTEls = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = t.globals.translateY + a, r = i.yaxisTTEls[e].getBoundingClientRect().height, n = t.globals.translateYAxisX[e] - 2;
                    t.config.yaxis[e].opposite && (n -= 26), s -= r / 2, t.globals.ignoreYAxisIndexes.indexOf(e) === -1 ? (i.yaxisTTEls[e].classList.add("apexcharts-active"), i.yaxisTTEls[e].style.top = s + "px", i.yaxisTTEls[e].style.left = n + t.config.yaxis[e].tooltip.offsetX + "px") : i.yaxisTTEls[e].classList.remove("apexcharts-active");
                }
            },
            {
                key: "moveTooltip",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), n = s.tooltipRect, o = i !== null ? parseFloat(i) : 1, h = parseFloat(e) + o + 5, c = parseFloat(t) + o / 2;
                    if (h > a.globals.gridWidth / 2 && (h = h - n.ttWidth - o - 10), h > a.globals.gridWidth - n.ttWidth - 10 && (h = a.globals.gridWidth - n.ttWidth), h < -20 && (h = -20), a.config.tooltip.followCursor) {
                        var d = s.getElGrid().getBoundingClientRect();
                        (h = s.e.clientX - d.left) > a.globals.gridWidth / 2 && (h -= s.tooltipRect.ttWidth), (c = s.e.clientY + a.globals.translateY - d.top) > a.globals.gridHeight / 2 && (c -= s.tooltipRect.ttHeight);
                    } else a.globals.isBarHorizontal || n.ttHeight / 2 + c > a.globals.gridHeight && (c = a.globals.gridHeight - n.ttHeight + a.globals.translateY);
                    isNaN(h) || (h += a.globals.translateX, r.style.left = h + "px", r.style.top = c + "px");
                }
            },
            {
                key: "moveMarkers",
                value: function(e, t) {
                    var i = this.w, a = this.ttCtx;
                    if (i.globals.markers.size[e] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === t && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(t, s[r]));
                    else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(t, e);
                }
            },
            {
                key: "moveDynamicPointOnHover",
                value: function(e, t) {
                    var i, a, s = this.w, r = this.ttCtx, n = s.globals.pointsArray, o = r.tooltipUtil.getHoverMarkerSize(t), h = s.config.series[t].type;
                    if (!h || h !== "column" && h !== "candlestick" && h !== "boxPlot") {
                        i = n[t][e][0], a = n[t][e][1] ? n[t][e][1] : 0;
                        var c = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers circle"));
                        c && a < s.globals.gridHeight && a > 0 && (c.setAttribute("r", o), c.setAttribute("cx", i), c.setAttribute("cy", a)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, a, o);
                    }
                }
            },
            {
                key: "moveDynamicPointsOnHover",
                value: function(e) {
                    var t, i = this.ttCtx, a = i.w, s = 0, r = 0, n = a.globals.pointsArray;
                    t = new te(this.ctx).getActiveConfigSeriesIndex("asc", [
                        "line",
                        "area",
                        "scatter",
                        "bubble"
                    ]);
                    var o = i.tooltipUtil.getHoverMarkerSize(t);
                    n[t] && (s = n[t][e][0], r = n[t][e][1]);
                    var h = i.tooltipUtil.getAllMarkers();
                    if (h !== null) for(var c = 0; c < a.globals.series.length; c++){
                        var d = n[c];
                        if (a.globals.comboCharts && d === void 0 && h.splice(c, 0, null), d && d.length) {
                            var g = n[c][e][1], p = void 0;
                            if (h[c].setAttribute("cx", s), a.config.chart.type === "rangeArea" && !a.globals.comboCharts) {
                                var f = e + a.globals.series[c].length;
                                p = n[c][f][1], g -= Math.abs(g - p) / 2;
                            }
                            g !== null && !isNaN(g) && g < a.globals.gridHeight + o && g + o > 0 ? (h[c] && h[c].setAttribute("r", o), h[c] && h[c].setAttribute("cy", g)) : h[c] && h[c].setAttribute("r", 0);
                        }
                    }
                    this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, o);
                }
            },
            {
                key: "moveStickyTooltipOverBars",
                value: function(e, t) {
                    var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length, r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                    i.globals.isBarHorizontal && (r = new te(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                    var n = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(e, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(e, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(e, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(e, "']"));
                    n || typeof t != "number" || (n = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, "']")));
                    var o = n ? parseFloat(n.getAttribute("cx")) : 0, h = n ? parseFloat(n.getAttribute("cy")) : 0, c = n ? parseFloat(n.getAttribute("barWidth")) : 0, d = a.getElGrid().getBoundingClientRect(), g = n && (n.classList.contains("apexcharts-candlestick-area") || n.classList.contains("apexcharts-boxPlot-area"));
                    i.globals.isXNumeric ? (n && !g && (o -= s % 2 != 0 ? c / 2 : 0), n && g && i.globals.comboCharts && (o -= c / 2)) : i.globals.isBarHorizontal || (o = a.xAxisTicksPositions[e - 1] + a.dataPointsDividedWidth / 2, isNaN(o) && (o = a.xAxisTicksPositions[e] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? h -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? h = a.e.clientY - d.top - a.tooltipRect.ttHeight / 2 : h + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (h = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(o), a.fixedTooltip || this.moveTooltip(o, h || i.globals.gridHeight);
                }
            }
        ]), y;
    }(), Tt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new it(e);
        }
        return Y(y, [
            {
                key: "drawDynamicPoints",
                value: function() {
                    var e = this.w, t = new M(this.ctx), i = new Pe(this.ctx), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    a = J(a), e.config.chart.stacked && a.sort(function(d, g) {
                        return parseFloat(d.getAttribute("data:realIndex")) - parseFloat(g.getAttribute("data:realIndex"));
                    });
                    for(var s = 0; s < a.length; s++){
                        var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                        if (r !== null) {
                            var n = void 0, o = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                            e.config.chart.type !== "line" && e.config.chart.type !== "area" || e.globals.comboCharts || e.config.tooltip.intersect || (o += " no-pointer-events");
                            var h = i.getMarkerConfig({
                                cssClass: o,
                                seriesIndex: Number(r.getAttribute("data:realIndex"))
                            });
                            (n = t.drawMarker(0, 0, h)).node.setAttribute("default-marker-size", 0);
                            var c = document.createElementNS(e.globals.SVGNS, "g");
                            c.classList.add("apexcharts-series-markers"), c.appendChild(n.node), r.appendChild(c);
                        }
                    }
                }
            },
            {
                key: "enlargeCurrentPoint",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, s = this.w;
                    s.config.chart.type !== "bubble" && this.newPointSize(e, t);
                    var r = t.getAttribute("cx"), n = t.getAttribute("cy");
                    if (i !== null && a !== null && (r = i, n = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                        if (s.config.chart.type === "radar") {
                            var o = this.ttCtx.getElGrid().getBoundingClientRect();
                            r = this.ttCtx.e.clientX - o.left;
                        }
                        this.tooltipPosition.moveTooltip(r, n, s.config.markers.hover.size);
                    }
                }
            },
            {
                key: "enlargePoints",
                value: function(e) {
                    for(var t = this.w, i = this, a = this.ttCtx, s = e, r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), n = t.config.markers.hover.size, o = 0; o < r.length; o++){
                        var h = r[o].getAttribute("rel"), c = r[o].getAttribute("index");
                        if (n === void 0 && (n = t.globals.markers.size[c] + t.config.markers.hover.sizeOffset), s === parseInt(h, 10)) {
                            i.newPointSize(s, r[o]);
                            var d = r[o].getAttribute("cx"), g = r[o].getAttribute("cy");
                            i.tooltipPosition.moveXCrosshairs(d), a.fixedTooltip || i.tooltipPosition.moveTooltip(d, g, n);
                        } else i.oldPointSize(r[o]);
                    }
                }
            },
            {
                key: "newPointSize",
                value: function(e, t) {
                    var i = this.w, a = i.config.markers.hover.size, s = e === 0 ? t.parentNode.firstChild : t.parentNode.lastChild;
                    if (s.getAttribute("default-marker-size") !== "0") {
                        var r = parseInt(s.getAttribute("index"), 10);
                        a === void 0 && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0), s.setAttribute("r", a);
                    }
                }
            },
            {
                key: "oldPointSize",
                value: function(e) {
                    var t = parseFloat(e.getAttribute("default-marker-size"));
                    e.setAttribute("r", t);
                }
            },
            {
                key: "resetPointsSize",
                value: function() {
                    for(var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), t = 0; t < e.length; t++){
                        var i = parseFloat(e[t].getAttribute("default-marker-size"));
                        P.isNumber(i) && i >= 0 ? e[t].setAttribute("r", i) : e[t].setAttribute("r", 0);
                    }
                }
            }
        ]), y;
    }(), zt = function() {
        function y(e) {
            F(this, y), this.w = e.w;
            var t = this.w;
            this.ttCtx = e, this.isVerticalGroupedRangeBar = !t.globals.isBarHorizontal && t.config.chart.type === "rangeBar" && t.config.plotOptions.bar.rangeBarGroupRows;
        }
        return Y(y, [
            {
                key: "getAttr",
                value: function(e, t) {
                    return parseFloat(e.target.getAttribute(t));
                }
            },
            {
                key: "handleHeatTreeTooltip",
                value: function(e) {
                    var t = e.e, i = e.opt, a = e.x, s = e.y, r = e.type, n = this.ttCtx, o = this.w;
                    if (t.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                        var h = this.getAttr(t, "i"), c = this.getAttr(t, "j"), d = this.getAttr(t, "cx"), g = this.getAttr(t, "cy"), p = this.getAttr(t, "width"), f = this.getAttr(t, "height");
                        if (n.tooltipLabels.drawSeriesTexts({
                            ttItems: i.ttItems,
                            i: h,
                            j: c,
                            shared: !1,
                            e: t
                        }), o.globals.capturedSeriesIndex = h, o.globals.capturedDataPointIndex = c, a = d + n.tooltipRect.ttWidth / 2 + p, s = g + n.tooltipRect.ttHeight / 2 - f / 2, n.tooltipPosition.moveXCrosshairs(d + p / 2), a > o.globals.gridWidth / 2 && (a = d - n.tooltipRect.ttWidth / 2 + p), n.w.config.tooltip.followCursor) {
                            var b = o.globals.dom.elWrap.getBoundingClientRect();
                            a = o.globals.clientX - b.left - (a > o.globals.gridWidth / 2 ? n.tooltipRect.ttWidth : 0), s = o.globals.clientY - b.top - (s > o.globals.gridHeight / 2 ? n.tooltipRect.ttHeight : 0);
                        }
                    }
                    return {
                        x: a,
                        y: s
                    };
                }
            },
            {
                key: "handleMarkerTooltip",
                value: function(e) {
                    var t, i, a = e.e, s = e.opt, r = e.x, n = e.y, o = this.w, h = this.ttCtx;
                    if (a.target.classList.contains("apexcharts-marker")) {
                        var c = parseInt(s.paths.getAttribute("cx"), 10), d = parseInt(s.paths.getAttribute("cy"), 10), g = parseFloat(s.paths.getAttribute("val"));
                        if (i = parseInt(s.paths.getAttribute("rel"), 10), t = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, h.intersect) {
                            var p = P.findAncestor(s.paths, "apexcharts-series");
                            p && (t = parseInt(p.getAttribute("data:realIndex"), 10));
                        }
                        if (h.tooltipLabels.drawSeriesTexts({
                            ttItems: s.ttItems,
                            i: t,
                            j: i,
                            shared: !h.showOnIntersect && o.config.tooltip.shared,
                            e: a
                        }), a.type === "mouseup" && h.markerClick(a, t, i), o.globals.capturedSeriesIndex = t, o.globals.capturedDataPointIndex = i, r = c, n = d + o.globals.translateY - 1.4 * h.tooltipRect.ttHeight, h.w.config.tooltip.followCursor) {
                            var f = h.getElGrid().getBoundingClientRect();
                            n = h.e.clientY + o.globals.translateY - f.top;
                        }
                        g < 0 && (n = d), h.marker.enlargeCurrentPoint(i, s.paths, r, n);
                    }
                    return {
                        x: r,
                        y: n
                    };
                }
            },
            {
                key: "handleBarTooltip",
                value: function(e) {
                    var t, i, a = e.e, s = e.opt, r = this.w, n = this.ttCtx, o = n.getElTooltip(), h = 0, c = 0, d = 0, g = this.getBarTooltipXY({
                        e: a,
                        opt: s
                    });
                    t = g.i;
                    var p = g.barHeight, f = g.j;
                    r.globals.capturedSeriesIndex = t, r.globals.capturedDataPointIndex = f, r.globals.isBarHorizontal && n.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (c = g.x, d = g.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[t] : r.config.stroke.width, h = c) : r.globals.comboCharts || r.config.tooltip.shared || (h /= 2), isNaN(d) && (d = r.globals.svgHeight - n.tooltipRect.ttHeight);
                    var b = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), m = r.globals.isMultipleYAxis ? r.config.yaxis[b] && r.config.yaxis[b].reversed : r.config.yaxis[0].reversed;
                    if (c + n.tooltipRect.ttWidth > r.globals.gridWidth && !m ? c -= n.tooltipRect.ttWidth : c < 0 && (c = 0), n.w.config.tooltip.followCursor) {
                        var w = n.getElGrid().getBoundingClientRect();
                        d = n.e.clientY - w.top;
                    }
                    n.tooltip === null && (n.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? n.tooltipPosition.moveXCrosshairs(h + i / 2) : n.tooltipPosition.moveXCrosshairs(h)), !n.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && n.tooltipUtil.hasBars()) && (m && (c -= n.tooltipRect.ttWidth) < 0 && (c = 0), !m || r.globals.isBarHorizontal && n.tooltipUtil.hasBars() || (d = d + p - 2 * (r.globals.series[t][f] < 0 ? p : 0)), d = d + r.globals.translateY - n.tooltipRect.ttHeight / 2, o.style.left = c + r.globals.translateX + "px", o.style.top = d + "px");
                }
            },
            {
                key: "getBarTooltipXY",
                value: function(e) {
                    var t = this, i = e.e, a = e.opt, s = this.w, r = null, n = this.ttCtx, o = 0, h = 0, c = 0, d = 0, g = 0, p = i.target.classList;
                    if (p.contains("apexcharts-bar-area") || p.contains("apexcharts-candlestick-area") || p.contains("apexcharts-boxPlot-area") || p.contains("apexcharts-rangebar-area")) {
                        var f = i.target, b = f.getBoundingClientRect(), m = a.elGrid.getBoundingClientRect(), w = b.height;
                        g = b.height;
                        var A = b.width, l = parseInt(f.getAttribute("cx"), 10), u = parseInt(f.getAttribute("cy"), 10);
                        d = parseFloat(f.getAttribute("barWidth"));
                        var x = i.type === "touchmove" ? i.touches[0].clientX : i.clientX;
                        r = parseInt(f.getAttribute("j"), 10), o = parseInt(f.parentNode.getAttribute("rel"), 10) - 1;
                        var v = f.getAttribute("data-range-y1"), k = f.getAttribute("data-range-y2");
                        s.globals.comboCharts && (o = parseInt(f.parentNode.getAttribute("data:realIndex"), 10));
                        var S = function(L) {
                            return s.globals.isXNumeric ? l - A / 2 : t.isVerticalGroupedRangeBar ? l + A / 2 : l - n.dataPointsDividedWidth + A / 2;
                        }, C = function() {
                            return u - n.dataPointsDividedHeight + w / 2 - n.tooltipRect.ttHeight / 2;
                        };
                        n.tooltipLabels.drawSeriesTexts({
                            ttItems: a.ttItems,
                            i: o,
                            j: r,
                            y1: v ? parseInt(v, 10) : null,
                            y2: k ? parseInt(k, 10) : null,
                            shared: !n.showOnIntersect && s.config.tooltip.shared,
                            e: i
                        }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (h = x - m.left + 15, c = C()) : (h = S(), c = i.clientY - m.top - n.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((h = l) < n.xyRatios.baseLineInvertedY && (h = l - n.tooltipRect.ttWidth), c = C()) : (h = S(), c = u);
                    }
                    return {
                        x: h,
                        y: c,
                        barHeight: g,
                        barWidth: d,
                        i: o,
                        j: r
                    };
                }
            }
        ]), y;
    }(), Mt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.ttCtx = e;
        }
        return Y(y, [
            {
                key: "drawXaxisTooltip",
                value: function() {
                    var e = this.w, t = this.ttCtx, i = e.config.xaxis.position === "bottom";
                    t.xaxisOffY = i ? e.globals.gridHeight + 1 : -e.globals.xAxisHeight - e.config.xaxis.axisTicks.height + 3;
                    var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = e.globals.dom.elWrap;
                    t.isXAxisTooltipEnabled && e.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") === null && (t.xaxisTooltip = document.createElement("div"), t.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + e.config.tooltip.theme), s.appendChild(t.xaxisTooltip), t.xaxisTooltipText = document.createElement("div"), t.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), t.xaxisTooltipText.style.fontFamily = e.config.xaxis.tooltip.style.fontFamily || e.config.chart.fontFamily, t.xaxisTooltipText.style.fontSize = e.config.xaxis.tooltip.style.fontSize, t.xaxisTooltip.appendChild(t.xaxisTooltipText));
                }
            },
            {
                key: "drawYaxisTooltip",
                value: function() {
                    for(var e = this.w, t = this.ttCtx, i = function(s) {
                        var r = e.config.yaxis[s].opposite || e.config.yaxis[s].crosshairs.opposite;
                        t.yaxisOffX = r ? e.globals.gridWidth + 1 : 1;
                        var n = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(s, r ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                        e.globals.yAxisSameScaleIndices.map(function(h, c) {
                            h.map(function(d, g) {
                                g === s && (n += e.config.yaxis[g].show ? " " : " apexcharts-yaxistooltip-hidden");
                            });
                        });
                        var o = e.globals.dom.elWrap;
                        e.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(s)) === null && (t.yaxisTooltip = document.createElement("div"), t.yaxisTooltip.setAttribute("class", n + " apexcharts-theme-" + e.config.tooltip.theme), o.appendChild(t.yaxisTooltip), s === 0 && (t.yaxisTooltipText = []), t.yaxisTooltipText[s] = document.createElement("div"), t.yaxisTooltipText[s].classList.add("apexcharts-yaxistooltip-text"), t.yaxisTooltip.appendChild(t.yaxisTooltipText[s]));
                    }, a = 0; a < e.config.yaxis.length; a++)i(a);
                }
            },
            {
                key: "setXCrosshairWidth",
                value: function() {
                    var e = this.w, t = this.ttCtx, i = t.getElXCrosshairs();
                    if (t.xcrosshairsWidth = parseInt(e.config.xaxis.crosshairs.width, 10), e.globals.comboCharts) {
                        var a = e.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                        if (a !== null && e.config.xaxis.crosshairs.width === "barWidth") {
                            var s = parseFloat(a.getAttribute("barWidth"));
                            t.xcrosshairsWidth = s;
                        } else if (e.config.xaxis.crosshairs.width === "tickWidth") {
                            var r = e.globals.labels.length;
                            t.xcrosshairsWidth = e.globals.gridWidth / r;
                        }
                    } else if (e.config.xaxis.crosshairs.width === "tickWidth") {
                        var n = e.globals.labels.length;
                        t.xcrosshairsWidth = e.globals.gridWidth / n;
                    } else if (e.config.xaxis.crosshairs.width === "barWidth") {
                        var o = e.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                        if (o !== null) {
                            var h = parseFloat(o.getAttribute("barWidth"));
                            t.xcrosshairsWidth = h;
                        } else t.xcrosshairsWidth = 1;
                    }
                    e.globals.isBarHorizontal && (t.xcrosshairsWidth = 0), i !== null && t.xcrosshairsWidth > 0 && i.setAttribute("width", t.xcrosshairsWidth);
                }
            },
            {
                key: "handleYCrosshair",
                value: function() {
                    var e = this.w, t = this.ttCtx;
                    t.ycrosshairs = e.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), t.ycrosshairsHidden = e.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
                }
            },
            {
                key: "drawYaxisTooltipText",
                value: function(e, t, i) {
                    var a = this.ttCtx, s = this.w, r = s.globals.yLabelFormatters[e];
                    if (a.yaxisTooltips[e]) {
                        var n = a.getElGrid().getBoundingClientRect(), o = (t - n.top) * i.yRatio[e], h = s.globals.maxYArr[e] - s.globals.minYArr[e], c = s.globals.minYArr[e] + (h - o);
                        a.tooltipPosition.moveYCrosshairs(t - n.top), a.yaxisTooltipText[e].innerHTML = r(c), a.tooltipPosition.moveYAxisTooltip(e);
                    }
                }
            }
        ]), y;
    }(), at = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.tConfig = t.config.tooltip, this.tooltipUtil = new tt(this), this.tooltipLabels = new It(this), this.tooltipPosition = new it(this), this.marker = new Tt(this), this.intersect = new zt(this), this.axesTooltip = new Mt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !t.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
        }
        return Y(y, [
            {
                key: "getElTooltip",
                value: function(e) {
                    return e || (e = this), e.w.globals.dom.baseEl ? e.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
                }
            },
            {
                key: "getElXCrosshairs",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
                }
            },
            {
                key: "getElGrid",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
                }
            },
            {
                key: "drawTooltip",
                value: function(e) {
                    var t = this.w;
                    this.xyRatios = e, this.isXAxisTooltipEnabled = t.config.xaxis.tooltip.enabled && t.globals.axisCharts, this.yaxisTooltips = t.config.yaxis.map(function(r, n) {
                        return !!(r.show && r.tooltip.enabled && t.globals.axisCharts);
                    }), this.allTooltipSeriesGroups = [], t.globals.axisCharts || (this.showTooltipTitle = !1);
                    var i = document.createElement("div");
                    if (i.classList.add("apexcharts-tooltip"), t.config.tooltip.cssClass && i.classList.add(t.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), t.globals.dom.elWrap.appendChild(i), t.globals.axisCharts) {
                        this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                        var a = new Ie(this.ctx);
                        this.xAxisTicksPositions = a.getXAxisTicksPositions();
                    }
                    if (!t.globals.comboCharts && !this.tConfig.intersect && t.config.chart.type !== "rangeBar" || this.tConfig.shared || (this.showOnIntersect = !0), t.config.markers.size !== 0 && t.globals.markers.largestSize !== 0 || this.marker.drawDynamicPoints(this), t.globals.collapsedSeries.length !== t.globals.series.length) {
                        this.dataPointsDividedHeight = t.globals.gridHeight / t.globals.dataPoints, this.dataPointsDividedWidth = t.globals.gridWidth / t.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || t.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                        var s = t.globals.series.length;
                        (t.globals.xyCharts || t.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : t.globals.series.length), this.legendLabels = t.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                    }
                }
            },
            {
                key: "createTTElements",
                value: function(e) {
                    for(var t = this, i = this.w, a = [], s = this.getElTooltip(), r = function(o) {
                        var h = document.createElement("div");
                        h.classList.add("apexcharts-tooltip-series-group"), h.style.order = i.config.tooltip.inverseOrder ? e - o : o + 1, t.tConfig.shared && t.tConfig.enabledOnSeries && Array.isArray(t.tConfig.enabledOnSeries) && t.tConfig.enabledOnSeries.indexOf(o) < 0 && h.classList.add("apexcharts-tooltip-series-group-hidden");
                        var c = document.createElement("span");
                        c.classList.add("apexcharts-tooltip-marker"), c.style.backgroundColor = i.globals.colors[o], h.appendChild(c);
                        var d = document.createElement("div");
                        d.classList.add("apexcharts-tooltip-text"), d.style.fontFamily = t.tConfig.style.fontFamily || i.config.chart.fontFamily, d.style.fontSize = t.tConfig.style.fontSize, [
                            "y",
                            "goals",
                            "z"
                        ].forEach(function(g) {
                            var p = document.createElement("div");
                            p.classList.add("apexcharts-tooltip-".concat(g, "-group"));
                            var f = document.createElement("span");
                            f.classList.add("apexcharts-tooltip-text-".concat(g, "-label")), p.appendChild(f);
                            var b = document.createElement("span");
                            b.classList.add("apexcharts-tooltip-text-".concat(g, "-value")), p.appendChild(b), d.appendChild(p);
                        }), h.appendChild(d), s.appendChild(h), a.push(h);
                    }, n = 0; n < e; n++)r(n);
                    return a;
                }
            },
            {
                key: "addSVGEvents",
                value: function() {
                    var e = this.w, t = e.config.chart.type, i = this.getElTooltip(), a = !(t !== "bar" && t !== "candlestick" && t !== "boxPlot" && t !== "rangeBar"), s = t === "area" || t === "line" || t === "scatter" || t === "bubble" || t === "radar", r = e.globals.dom.Paper.node, n = this.getElGrid();
                    n && (this.seriesBound = n.getBoundingClientRect());
                    var o, h = [], c = [], d = {
                        hoverArea: r,
                        elGrid: n,
                        tooltipEl: i,
                        tooltipY: h,
                        tooltipX: c,
                        ttItems: this.ttItems
                    };
                    if (e.globals.axisCharts && (s ? o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : t !== "heatmap" && t !== "treemap" || (o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), o && o.length)) for(var g = 0; g < o.length; g++)h.push(o[g].getAttribute("cy")), c.push(o[g].getAttribute("cx"));
                    if (e.globals.xyCharts && !this.showOnIntersect || e.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                        r
                    ], d);
                    else if (a && !e.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(d);
                    else if (!e.globals.axisCharts || t === "heatmap" || t === "treemap") {
                        var p = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                        this.addPathsEventListeners(p, d);
                    }
                    if (this.showOnIntersect) {
                        var f = e.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                        f.length > 0 && this.addPathsEventListeners(f, d), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(d);
                    }
                }
            },
            {
                key: "drawFixedTooltipRect",
                value: function() {
                    var e = this.w, t = this.getElTooltip(), i = t.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, n = this.tConfig.fixed.offsetY, o = this.tConfig.fixed.position.toLowerCase();
                    return o.indexOf("right") > -1 && (r = r + e.globals.svgWidth - a + 10), o.indexOf("bottom") > -1 && (n = n + e.globals.svgHeight - s - 10), t.style.left = r + "px", t.style.top = n + "px", {
                        x: r,
                        y: n,
                        ttWidth: a,
                        ttHeight: s
                    };
                }
            },
            {
                key: "addDatapointEventsListeners",
                value: function(e) {
                    var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                    this.addPathsEventListeners(t, e);
                }
            },
            {
                key: "addPathsEventListeners",
                value: function(e, t) {
                    for(var i = this, a = function(r) {
                        var n = {
                            paths: e[r],
                            tooltipEl: t.tooltipEl,
                            tooltipY: t.tooltipY,
                            tooltipX: t.tooltipX,
                            elGrid: t.elGrid,
                            hoverArea: t.hoverArea,
                            ttItems: t.ttItems
                        };
                        [
                            "mousemove",
                            "mouseup",
                            "touchmove",
                            "mouseout",
                            "touchend"
                        ].map(function(o) {
                            return e[r].addEventListener(o, i.onSeriesHover.bind(i, n), {
                                capture: !1,
                                passive: !0
                            });
                        });
                    }, s = 0; s < e.length; s++)a(s);
                }
            },
            {
                key: "onSeriesHover",
                value: function(e, t) {
                    var i = this, a = Date.now() - this.lastHoverTime;
                    a >= 100 ? this.seriesHover(e, t) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                        i.seriesHover(e, t);
                    }, 100 - a));
                }
            },
            {
                key: "seriesHover",
                value: function(e, t) {
                    var i = this;
                    this.lastHoverTime = Date.now();
                    var a = [], s = this.w;
                    s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || s.globals.dataPoints === 0) || (a.length ? a.forEach(function(r) {
                        var n = i.getElTooltip(r), o = {
                            paths: e.paths,
                            tooltipEl: n,
                            tooltipY: e.tooltipY,
                            tooltipX: e.tooltipX,
                            elGrid: e.elGrid,
                            hoverArea: e.hoverArea,
                            ttItems: r.w.globals.tooltip.ttItems
                        };
                        r.w.globals.minX === i.w.globals.minX && r.w.globals.maxX === i.w.globals.maxX && r.w.globals.tooltip.seriesHoverByContext({
                            chartCtx: r,
                            ttCtx: r.w.globals.tooltip,
                            opt: o,
                            e: t
                        });
                    }) : this.seriesHoverByContext({
                        chartCtx: this.ctx,
                        ttCtx: this.w.globals.tooltip,
                        opt: e,
                        e: t
                    }));
                }
            },
            {
                key: "seriesHoverByContext",
                value: function(e) {
                    var t = e.chartCtx, i = e.ttCtx, a = e.opt, s = e.e, r = t.w, n = this.getElTooltip();
                    n && (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: n.getBoundingClientRect().width,
                        ttHeight: n.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared && this.tConfig.onDatasetHover.highlightDataSeries && new te(t).toggleSeriesOnHover(s, s.target.parentNode), i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }));
                }
            },
            {
                key: "axisChartsTooltips",
                value: function(e) {
                    var t, i, a = e.e, s = e.opt, r = this.w, n = s.elGrid.getBoundingClientRect(), o = a.type === "touchmove" ? a.touches[0].clientX : a.clientX, h = a.type === "touchmove" ? a.touches[0].clientY : a.clientY;
                    if (this.clientY = h, this.clientX = o, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, h < n.top || h > n.top + n.height) this.handleMouseOut(s);
                    else {
                        if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                            var c = parseInt(s.paths.getAttribute("index"), 10);
                            if (this.tConfig.enabledOnSeries.indexOf(c) < 0) return void this.handleMouseOut(s);
                        }
                        var d = this.getElTooltip(), g = this.getElXCrosshairs(), p = r.globals.xyCharts || r.config.chart.type === "bar" && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                        if (a.type === "mousemove" || a.type === "touchmove" || a.type === "mouseup") {
                            if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                            g !== null && g.classList.add("apexcharts-active");
                            var f = this.yaxisTooltips.filter(function(w) {
                                return w === !0;
                            });
                            if (this.ycrosshairs !== null && f.length && this.ycrosshairs.classList.add("apexcharts-active"), p && !this.showOnIntersect) this.handleStickyTooltip(a, o, h, s);
                            else if (r.config.chart.type === "heatmap" || r.config.chart.type === "treemap") {
                                var b = this.intersect.handleHeatTreeTooltip({
                                    e: a,
                                    opt: s,
                                    x: t,
                                    y: i,
                                    type: r.config.chart.type
                                });
                                t = b.x, i = b.y, d.style.left = t + "px", d.style.top = i + "px";
                            } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                                e: a,
                                opt: s
                            }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                                e: a,
                                opt: s,
                                x: t,
                                y: i
                            });
                            if (this.yaxisTooltips.length) for(var m = 0; m < r.config.yaxis.length; m++)this.axesTooltip.drawYaxisTooltipText(m, h, this.xyRatios);
                            s.tooltipEl.classList.add("apexcharts-active");
                        } else a.type !== "mouseout" && a.type !== "touchend" || this.handleMouseOut(s);
                    }
                }
            },
            {
                key: "nonAxisChartsTooltips",
                value: function(e) {
                    var t = e.e, i = e.opt, a = e.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), n = this.getElTooltip(), o = s.globals.dom.elWrap.getBoundingClientRect();
                    if (t.type === "mousemove" || t.type === "touchmove") {
                        n.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                            ttItems: i.ttItems,
                            i: parseInt(r, 10) - 1,
                            shared: !1
                        });
                        var h = s.globals.clientX - o.left - a.ttWidth / 2, c = s.globals.clientY - o.top - a.ttHeight - 10;
                        if (n.style.left = h + "px", n.style.top = c + "px", s.config.legend.tooltipHoverFormatter) {
                            var d = r - 1, g = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[d].getAttribute("data:default-text"), {
                                seriesIndex: d,
                                dataPointIndex: d,
                                w: s
                            });
                            this.legendLabels[d].innerHTML = g;
                        }
                    } else t.type !== "mouseout" && t.type !== "touchend" || (n.classList.remove("apexcharts-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(p) {
                        var f = p.getAttribute("data:default-text");
                        p.innerHTML = decodeURIComponent(f);
                    }));
                }
            },
            {
                key: "handleStickyTooltip",
                value: function(e, t, i, a) {
                    var s = this.w, r = this.tooltipUtil.getNearestValues({
                        context: this,
                        hoverArea: a.hoverArea,
                        elGrid: a.elGrid,
                        clientX: t,
                        clientY: i
                    }), n = r.j, o = r.capturedSeries;
                    s.globals.collapsedSeriesIndices.includes(o) && (o = null);
                    var h = a.elGrid.getBoundingClientRect();
                    if (r.hoverX < 0 || r.hoverX > h.width) this.handleMouseOut(a);
                    else if (o !== null) this.handleStickyCapturedSeries(e, o, a, n);
                    else if (this.tooltipUtil.isXoverlap(n) || s.globals.isBarHorizontal) {
                        var c = s.globals.series.findIndex(function(d, g) {
                            return !s.globals.collapsedSeriesIndices.includes(g);
                        });
                        this.create(e, this, c, n, a.ttItems);
                    }
                }
            },
            {
                key: "handleStickyCapturedSeries",
                value: function(e, t, i, a) {
                    var s = this.w;
                    if (!this.tConfig.shared && s.globals.series[t][a] === null) return void this.handleMouseOut(i);
                    if (s.globals.series[t][a] !== void 0) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(e, this, t, a, i.ttItems) : this.create(e, this, t, a, i.ttItems, !1);
                    else if (this.tooltipUtil.isXoverlap(a)) {
                        var r = s.globals.series.findIndex(function(n, o) {
                            return !s.globals.collapsedSeriesIndices.includes(o);
                        });
                        this.create(e, this, r, a, i.ttItems);
                    }
                }
            },
            {
                key: "deactivateHoverFilter",
                value: function() {
                    for(var e = this.w, t = new M(this.ctx), i = e.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)t.pathMouseLeave(i[a]);
                }
            },
            {
                key: "handleMouseOut",
                value: function(e) {
                    var t = this.w, i = this.getElXCrosshairs();
                    if (e.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), t.config.chart.type !== "bubble" && this.marker.resetPointsSize(), i !== null && i.classList.remove("apexcharts-active"), this.ycrosshairs !== null && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                        this.yaxisTTEls === null && (this.yaxisTTEls = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                        for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                    }
                    t.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(s) {
                        var r = s.getAttribute("data:default-text");
                        s.innerHTML = decodeURIComponent(r);
                    });
                }
            },
            {
                key: "markerClick",
                value: function(e, t, i) {
                    var a = this.w;
                    typeof a.config.chart.events.markerClick == "function" && a.config.chart.events.markerClick(e, this.ctx, {
                        seriesIndex: t,
                        dataPointIndex: i,
                        w: a
                    }), this.ctx.events.fireEvent("markerClick", [
                        e,
                        this.ctx,
                        {
                            seriesIndex: t,
                            dataPointIndex: i,
                            w: a
                        }
                    ]);
                }
            },
            {
                key: "create",
                value: function(e, t, i, a, s) {
                    var r, n, o, h, c, d, g, p, f, b, m, w, A, l, u, x, v = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, k = this.w, S = t;
                    e.type === "mouseup" && this.markerClick(e, i, a), v === null && (v = this.tConfig.shared);
                    var C = this.tooltipUtil.hasMarkers(i), L = this.tooltipUtil.getElBars();
                    if (k.config.legend.tooltipHoverFormatter) {
                        var I = k.config.legend.tooltipHoverFormatter, z = Array.from(this.legendLabels);
                        z.forEach(function(se) {
                            var K = se.getAttribute("data:default-text");
                            se.innerHTML = decodeURIComponent(K);
                        });
                        for(var T = 0; T < z.length; T++){
                            var E = z[T], R = parseInt(E.getAttribute("i"), 10), O = decodeURIComponent(E.getAttribute("data:default-text")), D = I(O, {
                                seriesIndex: v ? R : i,
                                dataPointIndex: a,
                                w: k
                            });
                            if (v) E.innerHTML = k.globals.collapsedSeriesIndices.indexOf(R) < 0 ? D : O;
                            else if (E.innerHTML = R === i ? D : O, i === R) break;
                        }
                    }
                    var W = X(X({
                        ttItems: s,
                        i: i,
                        j: a
                    }, ((r = k.globals.seriesRange) === null || r === void 0 || (n = r[i]) === null || n === void 0 || (o = n[a]) === null || o === void 0 || (h = o.y[0]) === null || h === void 0 ? void 0 : h.y1) !== void 0 && {
                        y1: (c = k.globals.seriesRange) === null || c === void 0 || (d = c[i]) === null || d === void 0 || (g = d[a]) === null || g === void 0 || (p = g.y[0]) === null || p === void 0 ? void 0 : p.y1
                    }), ((f = k.globals.seriesRange) === null || f === void 0 || (b = f[i]) === null || b === void 0 || (m = b[a]) === null || m === void 0 || (w = m.y[0]) === null || w === void 0 ? void 0 : w.y2) !== void 0 && {
                        y2: (A = k.globals.seriesRange) === null || A === void 0 || (l = A[i]) === null || l === void 0 || (u = l[a]) === null || u === void 0 || (x = u.y[0]) === null || x === void 0 ? void 0 : x.y2
                    });
                    if (v) {
                        if (S.tooltipLabels.drawSeriesTexts(X(X({}, W), {}, {
                            shared: !this.showOnIntersect && this.tConfig.shared
                        })), C) k.globals.markers.largestSize > 0 ? S.marker.enlargePoints(a) : S.tooltipPosition.moveDynamicPointsOnHover(a);
                        else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(L), this.barSeriesHeight > 0)) {
                            var N = new M(this.ctx), V = k.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(a, "']"));
                            this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(a, i);
                            for(var j = 0; j < V.length; j++)N.pathMouseEnter(V[j]);
                        }
                    } else S.tooltipLabels.drawSeriesTexts(X({
                        shared: !1
                    }, W)), this.tooltipUtil.hasBars() && S.tooltipPosition.moveStickyTooltipOverBars(a, i), C && S.tooltipPosition.moveMarkers(i, a);
                }
            }
        ]), y;
    }(), Xt = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
        }
        return Y(y, [
            {
                key: "handleBarDataLabels",
                value: function(e) {
                    var t = e.x, i = e.y, a = e.y1, s = e.y2, r = e.i, n = e.j, o = e.realIndex, h = e.groupIndex, c = e.series, d = e.barHeight, g = e.barWidth, p = e.barXPosition, f = e.barYPosition, b = e.visibleSeries, m = e.renderedPath, w = this.w, A = new M(this.barCtx.ctx), l = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[o] : this.barCtx.strokeWidth, u = t + parseFloat(g * b), x = i + parseFloat(d * b);
                    w.globals.isXNumeric && !w.globals.isBarHorizontal && (u = t + parseFloat(g * (b + 1)), x = i + parseFloat(d * (b + 1)) - l);
                    var v, k = null, S = t, C = i, L = {}, I = w.config.dataLabels, z = this.barCtx.barOptions.dataLabels, T = this.barCtx.barOptions.dataLabels.total;
                    f !== void 0 && this.barCtx.isRangeBar && (x = f, C = f), p !== void 0 && this.barCtx.isVerticalGroupedRangeBar && (u = p, S = p);
                    var E = I.offsetX, R = I.offsetY, O = {
                        width: 0,
                        height: 0
                    };
                    if (w.config.dataLabels.enabled) {
                        var D = this.barCtx.series[r][n];
                        O = A.getTextRects(w.globals.yLabelFormatters[0](D), parseFloat(I.style.fontSize));
                    }
                    var W = {
                        x: t,
                        y: i,
                        i: r,
                        j: n,
                        realIndex: o,
                        groupIndex: h || -1,
                        renderedPath: m,
                        bcx: u,
                        bcy: x,
                        barHeight: d,
                        barWidth: g,
                        textRects: O,
                        strokeWidth: l,
                        dataLabelsX: S,
                        dataLabelsY: C,
                        dataLabelsConfig: I,
                        barDataLabelsConfig: z,
                        barTotalDataLabelsConfig: T,
                        offX: E,
                        offY: R
                    };
                    return L = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(W) : this.calculateColumnsDataLabelsPosition(W), m.attr({
                        cy: L.bcy,
                        cx: L.bcx,
                        j: n,
                        val: c[r][n],
                        barHeight: d,
                        barWidth: g
                    }), v = this.drawCalculatedDataLabels({
                        x: L.dataLabelsX,
                        y: L.dataLabelsY,
                        val: this.barCtx.isRangeBar ? [
                            a,
                            s
                        ] : c[r][n],
                        i: o,
                        j: n,
                        barWidth: g,
                        barHeight: d,
                        textRects: O,
                        dataLabelsConfig: I
                    }), w.config.chart.stacked && T.enabled && (k = this.drawTotalDataLabels({
                        x: L.totalDataLabelsX,
                        y: L.totalDataLabelsY,
                        barWidth: g,
                        barHeight: d,
                        realIndex: o,
                        textAnchor: L.totalDataLabelsAnchor,
                        val: this.getStackedTotalDataLabel({
                            realIndex: o,
                            j: n
                        }),
                        dataLabelsConfig: I,
                        barTotalDataLabelsConfig: T
                    })), {
                        dataLabels: v,
                        totalDataLabels: k
                    };
                }
            },
            {
                key: "getStackedTotalDataLabel",
                value: function(e) {
                    var t = e.realIndex, i = e.j, a = this.w, s = this.barCtx.stackedSeriesTotals[i];
                    return this.totalFormatter && (s = this.totalFormatter(s, X(X({}, a), {}, {
                        seriesIndex: t,
                        dataPointIndex: i,
                        w: a
                    }))), s;
                }
            },
            {
                key: "calculateColumnsDataLabelsPosition",
                value: function(e) {
                    var t, i, a = this.w, s = e.i, r = e.j, n = e.realIndex, o = e.groupIndex, h = e.y, c = e.bcx, d = e.barWidth, g = e.barHeight, p = e.textRects, f = e.dataLabelsX, b = e.dataLabelsY, m = e.dataLabelsConfig, w = e.barDataLabelsConfig, A = e.barTotalDataLabelsConfig, l = e.strokeWidth, u = e.offX, x = e.offY;
                    g = Math.abs(g);
                    var v = a.config.plotOptions.bar.dataLabels.orientation === "vertical", k = this.barCtx.barHelpers.getZeroValueEncounters({
                        i: s,
                        j: r
                    }).zeroEncounters;
                    c = c - l / 2 + (o !== -1 ? o * d : 0);
                    var S = a.globals.gridWidth / a.globals.dataPoints;
                    this.barCtx.isVerticalGroupedRangeBar ? f += d / 2 : (f = a.globals.isXNumeric ? c - d / 2 + u : c - S + d / 2 + u, k > 0 && a.config.plotOptions.bar.hideZeroBarsWhenGrouped && (f -= d * k)), v && (f = f + p.height / 2 - l / 2 - 2);
                    var C = this.barCtx.series[s][r] < 0, L = h;
                    switch(this.barCtx.isReversed && (L = h - g + (C ? 2 * g : 0), h -= g), w.position){
                        case "center":
                            b = v ? C ? L - g / 2 + x : L + g / 2 - x : C ? L - g / 2 + p.height / 2 + x : L + g / 2 + p.height / 2 - x;
                            break;
                        case "bottom":
                            b = v ? C ? L - g + x : L + g - x : C ? L - g + p.height + l + x : L + g - p.height / 2 + l - x;
                            break;
                        case "top":
                            b = v ? C ? L + x : L - x : C ? L - p.height / 2 - x : L + p.height + x;
                    }
                    if (this.barCtx.lastActiveBarSerieIndex === n && A.enabled) {
                        var I = new M(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                            realIndex: n,
                            j: r
                        }), m.fontSize);
                        t = C ? L - I.height / 2 - x - A.offsetY + 18 : L + I.height + x + A.offsetY - 18, i = f + A.offsetX;
                    }
                    return a.config.chart.stacked || (b < 0 ? b = 0 + l : b + p.height / 3 > a.globals.gridHeight && (b = a.globals.gridHeight - l)), {
                        bcx: c,
                        bcy: h,
                        dataLabelsX: f,
                        dataLabelsY: b,
                        totalDataLabelsX: i,
                        totalDataLabelsY: t,
                        totalDataLabelsAnchor: "middle"
                    };
                }
            },
            {
                key: "calculateBarsDataLabelsPosition",
                value: function(e) {
                    var t = this.w, i = e.x, a = e.i, s = e.j, r = e.realIndex, n = e.groupIndex, o = e.bcy, h = e.barHeight, c = e.barWidth, d = e.textRects, g = e.dataLabelsX, p = e.strokeWidth, f = e.dataLabelsConfig, b = e.barDataLabelsConfig, m = e.barTotalDataLabelsConfig, w = e.offX, A = e.offY, l = t.globals.gridHeight / t.globals.dataPoints;
                    c = Math.abs(c);
                    var u, x, v = (o += n !== -1 ? n * h : 0) - (this.barCtx.isRangeBar ? 0 : l) + h / 2 + d.height / 2 + A - 3, k = "start", S = this.barCtx.series[a][s] < 0, C = i;
                    switch(this.barCtx.isReversed && (C = i + c - (S ? 2 * c : 0), i = t.globals.gridWidth - c), b.position){
                        case "center":
                            g = S ? C + c / 2 - w : Math.max(d.width / 2, C - c / 2) + w;
                            break;
                        case "bottom":
                            g = S ? C + c - p - Math.round(d.width / 2) - w : C - c + p + Math.round(d.width / 2) + w;
                            break;
                        case "top":
                            g = S ? C - p + Math.round(d.width / 2) - w : C - p - Math.round(d.width / 2) + w;
                    }
                    if (this.barCtx.lastActiveBarSerieIndex === r && m.enabled) {
                        var L = new M(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                            realIndex: r,
                            j: s
                        }), f.fontSize);
                        S ? (u = C - p + Math.round(L.width / 2) - w - m.offsetX - 15, k = "end") : u = C - p - Math.round(L.width / 2) + w + m.offsetX + 15, x = v + m.offsetY;
                    }
                    return t.config.chart.stacked || (g < 0 ? g = g + d.width + p : g + d.width / 2 > t.globals.gridWidth && (g = t.globals.gridWidth - d.width - p)), {
                        bcx: i,
                        bcy: o,
                        dataLabelsX: g,
                        dataLabelsY: v,
                        totalDataLabelsX: u,
                        totalDataLabelsY: x,
                        totalDataLabelsAnchor: k
                    };
                }
            },
            {
                key: "drawCalculatedDataLabels",
                value: function(e) {
                    var t = e.x, i = e.y, a = e.val, s = e.i, r = e.j, n = e.textRects, o = e.barHeight, h = e.barWidth, c = e.dataLabelsConfig, d = this.w, g = "rotate(0)";
                    d.config.plotOptions.bar.dataLabels.orientation === "vertical" && (g = "rotate(-90, ".concat(t, ", ").concat(i, ")"));
                    var p = new ye(this.barCtx.ctx), f = new M(this.barCtx.ctx), b = c.formatter, m = null, w = d.globals.collapsedSeriesIndices.indexOf(s) > -1;
                    if (c.enabled && !w) {
                        m = f.group({
                            class: "apexcharts-data-labels",
                            transform: g
                        });
                        var A = "";
                        a !== void 0 && (A = b(a, X(X({}, d), {}, {
                            seriesIndex: s,
                            dataPointIndex: r,
                            w: d
                        }))), !a && d.config.plotOptions.bar.hideZeroBarsWhenGrouped && (A = "");
                        var l = d.globals.series[s][r] < 0, u = d.config.plotOptions.bar.dataLabels.position;
                        d.config.plotOptions.bar.dataLabels.orientation === "vertical" && (u === "top" && (c.textAnchor = l ? "end" : "start"), u === "center" && (c.textAnchor = "middle"), u === "bottom" && (c.textAnchor = l ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && h < f.getTextRects(A, parseFloat(c.style.fontSize)).width && (A = ""), d.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(h) && (A = "") : n.height / 1.6 > Math.abs(o) && (A = ""));
                        var x = X({}, c);
                        this.barCtx.isHorizontal && a < 0 && (c.textAnchor === "start" ? x.textAnchor = "end" : c.textAnchor === "end" && (x.textAnchor = "start")), p.plotDataLabelsText({
                            x: t,
                            y: i,
                            text: A,
                            i: s,
                            j: r,
                            parent: m,
                            dataLabelsConfig: x,
                            alwaysDrawDataLabel: !0,
                            offsetCorrection: !0
                        });
                    }
                    return m;
                }
            },
            {
                key: "drawTotalDataLabels",
                value: function(e) {
                    var t, i = e.x, a = e.y, s = e.val, r = e.barWidth, n = e.barHeight, o = e.realIndex, h = e.textAnchor, c = e.barTotalDataLabelsConfig, d = this.w, g = new M(this.barCtx.ctx);
                    return c.enabled && i !== void 0 && a !== void 0 && this.barCtx.lastActiveBarSerieIndex === o && (t = g.drawText({
                        x: i - (!d.globals.isBarHorizontal && d.globals.seriesGroups.length ? r / d.globals.seriesGroups.length : 0),
                        y: a - (d.globals.isBarHorizontal && d.globals.seriesGroups.length ? n / d.globals.seriesGroups.length : 0),
                        foreColor: c.style.color,
                        text: s,
                        textAnchor: h,
                        fontFamily: c.style.fontFamily,
                        fontSize: c.style.fontSize,
                        fontWeight: c.style.fontWeight
                    })), t;
                }
            }
        ]), y;
    }(), Et = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.barCtx = e;
        }
        return Y(y, [
            {
                key: "initVariables",
                value: function(e) {
                    var t = this.w;
                    this.barCtx.series = e, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                    for(var i = 0; i < e.length; i++)if (e[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += e[i].length), t.globals.isXNumeric) for(var a = 0; a < e[i].length; a++)t.globals.seriesX[i][a] > t.globals.minX && t.globals.seriesX[i][a] < t.globals.maxX && this.barCtx.visibleItems++;
                    else this.barCtx.visibleItems = t.globals.dataPoints;
                    this.barCtx.seriesLen === 0 && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], t.globals.comboCharts || this.checkZeroSeries({
                        series: e
                    });
                }
            },
            {
                key: "initialPositions",
                value: function() {
                    var e, t, i, a, s, r, n, o, h = this.w, c = h.globals.dataPoints;
                    this.barCtx.isRangeBar && (c = h.globals.labels.length);
                    var d = this.barCtx.seriesLen;
                    if (h.config.plotOptions.bar.rangeBarGroupRows && (d = 1), this.barCtx.isHorizontal) s = (i = h.globals.gridHeight / c) / d, h.globals.isXNumeric && (s = (i = h.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, String(this.barCtx.barOptions.barHeight).indexOf("%") === -1 && (s = parseInt(this.barCtx.barOptions.barHeight, 10)), o = this.barCtx.baseLineInvertedY + h.globals.padHorizontal + (this.barCtx.isReversed ? h.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (o = h.globals.gridWidth / 2), t = (i - s * this.barCtx.seriesLen) / 2;
                    else {
                        if (a = h.globals.gridWidth / this.barCtx.visibleItems, h.config.xaxis.convertedCatToNumeric && (a = h.globals.gridWidth / h.globals.dataPoints), r = a / d * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, h.globals.isXNumeric) {
                            var g = this.barCtx.xRatio;
                            h.globals.minXDiff && h.globals.minXDiff !== 0.5 && h.globals.minXDiff / g > 0 && (a = h.globals.minXDiff / g), (r = a / d * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                        }
                        String(this.barCtx.barOptions.columnWidth).indexOf("%") === -1 && (r = parseInt(this.barCtx.barOptions.columnWidth, 10)), n = h.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? h.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), e = h.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                    }
                    return h.globals.barHeight = s, h.globals.barWidth = r, {
                        x: e,
                        y: t,
                        yDivision: i,
                        xDivision: a,
                        barHeight: s,
                        barWidth: r,
                        zeroH: n,
                        zeroW: o
                    };
                }
            },
            {
                key: "initializeStackedPrevVars",
                value: function(e) {
                    var t = e.w;
                    t.globals.hasSeriesGroups ? t.globals.seriesGroups.forEach(function(i) {
                        e[i] || (e[i] = {}), e[i].prevY = [], e[i].prevX = [], e[i].prevYF = [], e[i].prevXF = [], e[i].prevYVal = [], e[i].prevXVal = [];
                    }) : (e.prevY = [], e.prevX = [], e.prevYF = [], e.prevXF = [], e.prevYVal = [], e.prevXVal = []);
                }
            },
            {
                key: "initializeStackedXYVars",
                value: function(e) {
                    var t = e.w;
                    t.globals.hasSeriesGroups ? t.globals.seriesGroups.forEach(function(i) {
                        e[i] || (e[i] = {}), e[i].xArrj = [], e[i].xArrjF = [], e[i].xArrjVal = [], e[i].yArrj = [], e[i].yArrjF = [], e[i].yArrjVal = [];
                    }) : (e.xArrj = [], e.xArrjF = [], e.xArrjVal = [], e.yArrj = [], e.yArrjF = [], e.yArrjVal = []);
                }
            },
            {
                key: "getPathFillColor",
                value: function(e, t, i, a) {
                    var s, r, n, o, h = this.w, c = new ae(this.barCtx.ctx), d = null, g = this.barCtx.barOptions.distributed ? i : t;
                    return this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(p) {
                        e[t][i] >= p.from && e[t][i] <= p.to && (d = p.color);
                    }), h.config.series[t].data[i] && h.config.series[t].data[i].fillColor && (d = h.config.series[t].data[i].fillColor), c.fillPath({
                        seriesNumber: this.barCtx.barOptions.distributed ? g : a,
                        dataPointIndex: i,
                        color: d,
                        value: e[t][i],
                        fillConfig: (s = h.config.series[t].data[i]) === null || s === void 0 ? void 0 : s.fill,
                        fillType: (r = h.config.series[t].data[i]) !== null && r !== void 0 && (n = r.fill) !== null && n !== void 0 && n.type ? (o = h.config.series[t].data[i]) === null || o === void 0 ? void 0 : o.fill.type : Array.isArray(h.config.fill.type) ? h.config.fill.type[t] : h.config.fill.type
                    });
                }
            },
            {
                key: "getStrokeWidth",
                value: function(e, t, i) {
                    var a = 0, s = this.w;
                    return this.barCtx.series[e][t] === void 0 || this.barCtx.series[e][t] === null ? this.barCtx.isNullValue = !0 : this.barCtx.isNullValue = !1, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
                }
            },
            {
                key: "shouldApplyRadius",
                value: function(e) {
                    var t = this.w, i = !1;
                    return t.config.plotOptions.bar.borderRadius > 0 && (t.config.chart.stacked && t.config.plotOptions.bar.borderRadiusWhenStacked === "last" ? this.barCtx.lastActiveBarSerieIndex === e && (i = !0) : i = !0), i;
                }
            },
            {
                key: "barBackground",
                value: function(e) {
                    var t = e.j, i = e.i, a = e.x1, s = e.x2, r = e.y1, n = e.y2, o = e.elSeries, h = this.w, c = new M(this.barCtx.ctx), d = new te(this.barCtx.ctx).getActiveConfigSeriesIndex();
                    if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && d === i) {
                        t >= this.barCtx.barOptions.colors.backgroundBarColors.length && (t %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                        var g = this.barCtx.barOptions.colors.backgroundBarColors[t], p = c.drawRect(a !== void 0 ? a : 0, r !== void 0 ? r : 0, s !== void 0 ? s : h.globals.gridWidth, n !== void 0 ? n : h.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, g, this.barCtx.barOptions.colors.backgroundBarOpacity);
                        o.add(p), p.node.classList.add("apexcharts-backgroundBar");
                    }
                }
            },
            {
                key: "getColumnPaths",
                value: function(e) {
                    var t, i = e.barWidth, a = e.barXPosition, s = e.y1, r = e.y2, n = e.strokeWidth, o = e.seriesGroup, h = e.realIndex, c = e.i, d = e.j, g = e.w, p = new M(this.barCtx.ctx);
                    (n = Array.isArray(n) ? n[h] : n) || (n = 0);
                    var f = i, b = a;
                    (t = g.config.series[h].data[d]) !== null && t !== void 0 && t.columnWidthOffset && (b = a - g.config.series[h].data[d].columnWidthOffset / 2, f = i + g.config.series[h].data[d].columnWidthOffset);
                    var m = b, w = b + f;
                    s += 1e-3, r += 1e-3;
                    var A = p.move(m, s), l = p.move(m, s), u = p.line(w - n, s);
                    if (g.globals.previousPaths.length > 0 && (l = this.barCtx.getPreviousPath(h, d, !1)), A = A + p.line(m, r) + p.line(w - n, r) + p.line(w - n, s) + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), l = l + p.line(m, s) + u + u + u + u + u + p.line(m, s) + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), this.shouldApplyRadius(h) && (A = p.roundPathCorners(A, g.config.plotOptions.bar.borderRadius)), g.config.chart.stacked) {
                        var x = this.barCtx;
                        g.globals.hasSeriesGroups && o && (x = this.barCtx[o]), x.yArrj.push(r), x.yArrjF.push(Math.abs(s - r)), x.yArrjVal.push(this.barCtx.series[c][d]);
                    }
                    return {
                        pathTo: A,
                        pathFrom: l
                    };
                }
            },
            {
                key: "getBarpaths",
                value: function(e) {
                    var t, i = e.barYPosition, a = e.barHeight, s = e.x1, r = e.x2, n = e.strokeWidth, o = e.seriesGroup, h = e.realIndex, c = e.i, d = e.j, g = e.w, p = new M(this.barCtx.ctx);
                    (n = Array.isArray(n) ? n[h] : n) || (n = 0);
                    var f = i, b = a;
                    (t = g.config.series[h].data[d]) !== null && t !== void 0 && t.barHeightOffset && (f = i - g.config.series[h].data[d].barHeightOffset / 2, b = a + g.config.series[h].data[d].barHeightOffset);
                    var m = f, w = f + b;
                    s += 1e-3, r += 1e-3;
                    var A = p.move(s, m), l = p.move(s, m);
                    g.globals.previousPaths.length > 0 && (l = this.barCtx.getPreviousPath(h, d, !1));
                    var u = p.line(s, w - n);
                    if (A = A + p.line(r, m) + p.line(r, w - n) + u + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), l = l + p.line(s, m) + u + u + u + u + u + p.line(s, m) + (g.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z"), this.shouldApplyRadius(h) && (A = p.roundPathCorners(A, g.config.plotOptions.bar.borderRadius)), g.config.chart.stacked) {
                        var x = this.barCtx;
                        g.globals.hasSeriesGroups && o && (x = this.barCtx[o]), x.xArrj.push(r), x.xArrjF.push(Math.abs(s - r)), x.xArrjVal.push(this.barCtx.series[c][d]);
                    }
                    return {
                        pathTo: A,
                        pathFrom: l
                    };
                }
            },
            {
                key: "checkZeroSeries",
                value: function(e) {
                    for(var t = e.series, i = this.w, a = 0; a < t.length; a++){
                        for(var s = 0, r = 0; r < t[i.globals.maxValsInArrayIndex].length; r++)s += t[a][r];
                        s === 0 && this.barCtx.zeroSerieses.push(a);
                    }
                }
            },
            {
                key: "getXForValue",
                value: function(e, t) {
                    var i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2] ? t : null;
                    return e != null && (i = t + e / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? e / this.barCtx.invertedYRatio : 0)), i;
                }
            },
            {
                key: "getYForValue",
                value: function(e, t) {
                    var i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2] ? t : null;
                    return e != null && (i = t - e / this.barCtx.yRatio[this.barCtx.yaxisIndex] + 2 * (this.barCtx.isReversed ? e / this.barCtx.yRatio[this.barCtx.yaxisIndex] : 0)), i;
                }
            },
            {
                key: "getGoalValues",
                value: function(e, t, i, a, s) {
                    var r = this, n = this.w, o = [], h = function(g, p) {
                        var f;
                        o.push((ee(f = {}, e, e === "x" ? r.getXForValue(g, t, !1) : r.getYForValue(g, i, !1)), ee(f, "attrs", p), f));
                    };
                    if (n.globals.seriesGoals[a] && n.globals.seriesGoals[a][s] && Array.isArray(n.globals.seriesGoals[a][s]) && n.globals.seriesGoals[a][s].forEach(function(g) {
                        h(g.value, g);
                    }), this.barCtx.barOptions.isDumbbell && n.globals.seriesRange.length) {
                        var c = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : n.globals.colors, d = {
                            strokeHeight: e === "x" ? 0 : n.globals.markers.size[a],
                            strokeWidth: e === "x" ? n.globals.markers.size[a] : 0,
                            strokeDashArray: 0,
                            strokeLineCap: "round",
                            strokeColor: Array.isArray(c[a]) ? c[a][0] : c[a]
                        };
                        h(n.globals.seriesRangeStart[a][s], d), h(n.globals.seriesRangeEnd[a][s], X(X({}, d), {}, {
                            strokeColor: Array.isArray(c[a]) ? c[a][1] : c[a]
                        }));
                    }
                    return o;
                }
            },
            {
                key: "drawGoalLine",
                value: function(e) {
                    var t = e.barXPosition, i = e.barYPosition, a = e.goalX, s = e.goalY, r = e.barWidth, n = e.barHeight, o = new M(this.barCtx.ctx), h = o.group({
                        className: "apexcharts-bar-goals-groups"
                    });
                    h.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                        el: h.node
                    }), h.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                    var c = null;
                    return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(d) {
                        var g = d.attrs.strokeHeight !== void 0 ? d.attrs.strokeHeight : n / 2, p = i + g + n / 2;
                        c = o.drawLine(d.x, p - 2 * g, d.x, p, d.attrs.strokeColor ? d.attrs.strokeColor : void 0, d.attrs.strokeDashArray, d.attrs.strokeWidth ? d.attrs.strokeWidth : 2, d.attrs.strokeLineCap), h.add(c);
                    }) : Array.isArray(s) && s.forEach(function(d) {
                        var g = d.attrs.strokeWidth !== void 0 ? d.attrs.strokeWidth : r / 2, p = t + g + r / 2;
                        c = o.drawLine(p - 2 * g, d.y, p, d.y, d.attrs.strokeColor ? d.attrs.strokeColor : void 0, d.attrs.strokeDashArray, d.attrs.strokeHeight ? d.attrs.strokeHeight : 2, d.attrs.strokeLineCap), h.add(c);
                    }), h;
                }
            },
            {
                key: "drawBarShadow",
                value: function(e) {
                    var t = e.prevPaths, i = e.currPaths, a = e.color, s = this.w, r = t.x, n = t.x1, o = t.barYPosition, h = i.x, c = i.x1, d = i.barYPosition, g = o + i.barHeight, p = new M(this.barCtx.ctx), f = new P(), b = p.move(n, g) + p.line(r, g) + p.line(h, d) + p.line(c, d) + p.line(n, g) + (s.config.plotOptions.bar.borderRadiusApplication === "around" ? " Z" : " z");
                    return p.drawPath({
                        d: b,
                        fill: f.shadeColor(0.5, P.rgb2hex(a)),
                        stroke: "none",
                        strokeWidth: 0,
                        fillOpacity: 1,
                        classes: "apexcharts-bar-shadows"
                    });
                }
            },
            {
                key: "getZeroValueEncounters",
                value: function(e) {
                    var t = e.i, i = e.j, a = this.w, s = 0, r = 0;
                    return a.globals.seriesPercent.forEach(function(n, o) {
                        n[i] && s++, o < t && n[i] === 0 && r++;
                    }), {
                        nonZeroColumns: s,
                        zeroEncounters: r
                    };
                }
            }
        ]), y;
    }(), ke = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w;
            var i = this.w;
            this.barOptions = i.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = i.config.stroke.width, this.isNullValue = !1, this.isRangeBar = i.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !i.globals.isBarHorizontal && i.globals.seriesRange.length && i.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = t, this.xyRatios !== null && (this.xRatio = t.xRatio, this.yRatio = t.yRatio, this.invertedXRatio = t.invertedXRatio, this.invertedYRatio = t.invertedYRatio, this.baseLineY = t.baseLineY, this.baseLineInvertedY = t.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.pathArr = [];
            var a = new te(this.ctx);
            this.lastActiveBarSerieIndex = a.getActiveConfigSeriesIndex("desc", [
                "bar",
                "column"
            ]);
            var s = a.getBarSeriesIndices(), r = new q(this.ctx);
            this.stackedSeriesTotals = r.getStackedSeriesTotals(this.w.config.series.map(function(n, o) {
                return s.indexOf(o) === -1 ? o : -1;
            }).filter(function(n) {
                return n !== -1;
            })), this.barHelpers = new Et(this);
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e, t) {
                    var i = this.w, a = new M(this.ctx), s = new q(this.ctx, i);
                    e = s.getLogSeries(e), this.series = e, this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(e);
                    var r = a.group({
                        class: "apexcharts-bar-series apexcharts-plot-series"
                    });
                    i.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
                    for(var n = 0, o = 0; n < e.length; n++, o++){
                        var h, c, d, g, p = void 0, f = void 0, b = [], m = [], w = i.globals.comboCharts ? t[n] : n, A = a.group({
                            class: "apexcharts-series",
                            rel: n + 1,
                            seriesName: P.escapeString(i.globals.seriesNames[w]),
                            "data:realIndex": w
                        });
                        this.ctx.series.addCollapsedClassToSeries(A, w), e[n].length > 0 && (this.visibleI = this.visibleI + 1);
                        var l = 0, u = 0;
                        this.yRatio.length > 1 && (this.yaxisIndex = w), this.isReversed = i.config.yaxis[this.yaxisIndex] && i.config.yaxis[this.yaxisIndex].reversed;
                        var x = this.barHelpers.initialPositions();
                        f = x.y, l = x.barHeight, c = x.yDivision, g = x.zeroW, p = x.x, u = x.barWidth, h = x.xDivision, d = x.zeroH, this.horizontal || m.push(p + u / 2);
                        var v = a.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": w
                        });
                        i.globals.delayedElements.push({
                            el: v.node
                        }), v.node.classList.add("apexcharts-element-hidden");
                        var k = a.group({
                            class: "apexcharts-bar-goals-markers"
                        }), S = a.group({
                            class: "apexcharts-bar-shadows"
                        });
                        i.globals.delayedElements.push({
                            el: S.node
                        }), S.node.classList.add("apexcharts-element-hidden");
                        for(var C = 0; C < i.globals.dataPoints; C++){
                            var L = this.barHelpers.getStrokeWidth(n, C, w), I = null, z = {
                                indexes: {
                                    i: n,
                                    j: C,
                                    realIndex: w,
                                    bc: o
                                },
                                x: p,
                                y: f,
                                strokeWidth: L,
                                elSeries: A
                            };
                            this.isHorizontal ? (I = this.drawBarPaths(X(X({}, z), {}, {
                                barHeight: l,
                                zeroW: g,
                                yDivision: c
                            })), u = this.series[n][C] / this.invertedYRatio) : (I = this.drawColumnPaths(X(X({}, z), {}, {
                                xDivision: h,
                                barWidth: u,
                                zeroH: d
                            })), l = this.series[n][C] / this.yRatio[this.yaxisIndex]);
                            var T = this.barHelpers.getPathFillColor(e, n, C, w);
                            if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && C > 0) {
                                var E = this.barHelpers.drawBarShadow({
                                    color: typeof T == "string" && (T == null ? void 0 : T.indexOf("url")) === -1 ? T : P.hexToRgba(i.globals.colors[n]),
                                    prevPaths: this.pathArr[this.pathArr.length - 1],
                                    currPaths: I
                                });
                                E && S.add(E);
                            }
                            this.pathArr.push(I);
                            var R = this.barHelpers.drawGoalLine({
                                barXPosition: I.barXPosition,
                                barYPosition: I.barYPosition,
                                goalX: I.goalX,
                                goalY: I.goalY,
                                barHeight: l,
                                barWidth: u
                            });
                            R && k.add(R), f = I.y, p = I.x, C > 0 && m.push(p + u / 2), b.push(f), this.renderSeries({
                                realIndex: w,
                                pathFill: T,
                                j: C,
                                i: n,
                                pathFrom: I.pathFrom,
                                pathTo: I.pathTo,
                                strokeWidth: L,
                                elSeries: A,
                                x: p,
                                y: f,
                                series: e,
                                barHeight: I.barHeight ? I.barHeight : l,
                                barWidth: I.barWidth ? I.barWidth : u,
                                elDataLabelsWrap: v,
                                elGoalsMarkers: k,
                                elBarShadows: S,
                                visibleSeries: this.visibleI,
                                type: "bar"
                            });
                        }
                        i.globals.seriesXvalues[w] = m, i.globals.seriesYvalues[w] = b, r.add(A);
                    }
                    return r;
                }
            },
            {
                key: "renderSeries",
                value: function(e) {
                    var t = e.realIndex, i = e.pathFill, a = e.lineFill, s = e.j, r = e.i, n = e.groupIndex, o = e.pathFrom, h = e.pathTo, c = e.strokeWidth, d = e.elSeries, g = e.x, p = e.y, f = e.y1, b = e.y2, m = e.series, w = e.barHeight, A = e.barWidth, l = e.barXPosition, u = e.barYPosition, x = e.elDataLabelsWrap, v = e.elGoalsMarkers, k = e.elBarShadows, S = e.visibleSeries, C = e.type, L = this.w, I = new M(this.ctx);
                    a || (a = this.barOptions.distributed ? L.globals.stroke.colors[s] : L.globals.stroke.colors[t]), L.config.series[r].data[s] && L.config.series[r].data[s].strokeColor && (a = L.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                    var z = s / L.config.chart.animations.animateGradually.delay * (L.config.chart.animations.speed / L.globals.dataPoints) / 2.4, T = I.renderPaths({
                        i: r,
                        j: s,
                        realIndex: t,
                        pathFrom: o,
                        pathTo: h,
                        stroke: a,
                        strokeWidth: c,
                        strokeLineCap: L.config.stroke.lineCap,
                        fill: i,
                        animationDelay: z,
                        initialSpeed: L.config.chart.animations.speed,
                        dataChangeSpeed: L.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-".concat(C, "-area")
                    });
                    T.attr("clip-path", "url(#gridRectMask".concat(L.globals.cuid, ")"));
                    var E = L.config.forecastDataPoints;
                    E.count > 0 && s >= L.globals.dataPoints - E.count && (T.node.setAttribute("stroke-dasharray", E.dashArray), T.node.setAttribute("stroke-width", E.strokeWidth), T.node.setAttribute("fill-opacity", E.fillOpacity)), f !== void 0 && b !== void 0 && (T.attr("data-range-y1", f), T.attr("data-range-y2", b)), new Z(this.ctx).setSelectionFilter(T, t, s), d.add(T);
                    var R = new Xt(this).handleBarDataLabels({
                        x: g,
                        y: p,
                        y1: f,
                        y2: b,
                        i: r,
                        j: s,
                        series: m,
                        realIndex: t,
                        groupIndex: n,
                        barHeight: w,
                        barWidth: A,
                        barXPosition: l,
                        barYPosition: u,
                        renderedPath: T,
                        visibleSeries: S
                    });
                    return R.dataLabels !== null && x.add(R.dataLabels), R.totalDataLabels && x.add(R.totalDataLabels), d.add(x), v && d.add(v), k && d.add(k), d;
                }
            },
            {
                key: "drawBarPaths",
                value: function(e) {
                    var t, i = e.indexes, a = e.barHeight, s = e.strokeWidth, r = e.zeroW, n = e.x, o = e.y, h = e.yDivision, c = e.elSeries, d = this.w, g = i.i, p = i.j;
                    if (d.globals.isXNumeric) t = (o = (d.globals.seriesX[g][p] - d.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                    else if (d.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                        var f = 0, b = 0;
                        d.globals.seriesPercent.forEach(function(w, A) {
                            w[p] && f++, A < g && w[p] === 0 && b++;
                        }), f > 0 && (a = this.seriesLen * a / f), t = o + a * this.visibleI, t -= a * b;
                    } else t = o + a * this.visibleI;
                    this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[g][p], r) - r) / 2), n = this.barHelpers.getXForValue(this.series[g][p], r);
                    var m = this.barHelpers.getBarpaths({
                        barYPosition: t,
                        barHeight: a,
                        x1: r,
                        x2: n,
                        strokeWidth: s,
                        series: this.series,
                        realIndex: i.realIndex,
                        i: g,
                        j: p,
                        w: d
                    });
                    return d.globals.isXNumeric || (o += h), this.barHelpers.barBackground({
                        j: p,
                        i: g,
                        y1: t - a * this.visibleI,
                        y2: a * this.seriesLen,
                        elSeries: c
                    }), {
                        pathTo: m.pathTo,
                        pathFrom: m.pathFrom,
                        x1: r,
                        x: n,
                        y: o,
                        goalX: this.barHelpers.getGoalValues("x", r, null, g, p),
                        barYPosition: t,
                        barHeight: a
                    };
                }
            },
            {
                key: "drawColumnPaths",
                value: function(e) {
                    var t, i = e.indexes, a = e.x, s = e.y, r = e.xDivision, n = e.barWidth, o = e.zeroH, h = e.strokeWidth, c = e.elSeries, d = this.w, g = i.realIndex, p = i.i, f = i.j, b = i.bc;
                    if (d.globals.isXNumeric) {
                        var m = this.getBarXForNumericXAxis({
                            x: a,
                            j: f,
                            realIndex: g,
                            barWidth: n
                        });
                        a = m.x, t = m.barXPosition;
                    } else if (d.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                        var w = this.barHelpers.getZeroValueEncounters({
                            i: p,
                            j: f
                        }), A = w.nonZeroColumns, l = w.zeroEncounters;
                        A > 0 && (n = this.seriesLen * n / A), t = a + n * this.visibleI, t -= n * l;
                    } else t = a + n * this.visibleI;
                    s = this.barHelpers.getYForValue(this.series[p][f], o);
                    var u = this.barHelpers.getColumnPaths({
                        barXPosition: t,
                        barWidth: n,
                        y1: o,
                        y2: s,
                        strokeWidth: h,
                        series: this.series,
                        realIndex: i.realIndex,
                        i: p,
                        j: f,
                        w: d
                    });
                    return d.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                        bc: b,
                        j: f,
                        i: p,
                        x1: t - h / 2 - n * this.visibleI,
                        x2: n * this.seriesLen + h / 2,
                        elSeries: c
                    }), {
                        pathTo: u.pathTo,
                        pathFrom: u.pathFrom,
                        x: a,
                        y: s,
                        goalY: this.barHelpers.getGoalValues("y", null, o, p, f),
                        barXPosition: t,
                        barWidth: n
                    };
                }
            },
            {
                key: "getBarXForNumericXAxis",
                value: function(e) {
                    var t = e.x, i = e.barWidth, a = e.realIndex, s = e.j, r = this.w, n = a;
                    return r.globals.seriesX[a].length || (n = r.globals.maxValsInArrayIndex), r.globals.seriesX[n][s] && (t = (r.globals.seriesX[n][s] - r.globals.minX) / this.xRatio - i * this.seriesLen / 2), {
                        barXPosition: t + i * this.visibleI,
                        x: t
                    };
                }
            },
            {
                key: "getPreviousPath",
                value: function(e, t) {
                    for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                        var r = a.globals.previousPaths[s];
                        r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(e, 10) && a.globals.previousPaths[s].paths[t] !== void 0 && (i = a.globals.previousPaths[s].paths[t].d);
                    }
                    return i;
                }
            }
        ]), y;
    }(), st = function(y) {
        ge(t, ke);
        var e = ue(t);
        function t() {
            return F(this, t), e.apply(this, arguments);
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i, a) {
                    var s = this, r = this.w;
                    this.graphics = new M(this.ctx), this.bar = new ke(this.ctx, this.xyRatios);
                    var n = new q(this.ctx, r);
                    i = n.getLogSeries(i), this.yRatio = n.getLogYRatios(this.yRatio), this.barHelpers.initVariables(i), r.config.chart.stackType === "100%" && (i = r.globals.seriesPercent.slice()), this.series = i, this.barHelpers.initializeStackedPrevVars(this);
                    for(var o = this.graphics.group({
                        class: "apexcharts-bar-series apexcharts-plot-series"
                    }), h = 0, c = 0, d = function(f, b) {
                        var m = void 0, w = void 0, A = void 0, l = void 0, u = -1;
                        s.groupCtx = s, r.globals.seriesGroups.forEach(function(V, j) {
                            V.indexOf(r.config.series[f].name) > -1 && (u = j);
                        }), u !== -1 && (s.groupCtx = s[r.globals.seriesGroups[u]]);
                        var x = [], v = [], k = r.globals.comboCharts ? a[f] : f;
                        s.yRatio.length > 1 && (s.yaxisIndex = k), s.isReversed = r.config.yaxis[s.yaxisIndex] && r.config.yaxis[s.yaxisIndex].reversed;
                        var S = s.graphics.group({
                            class: "apexcharts-series",
                            seriesName: P.escapeString(r.globals.seriesNames[k]),
                            rel: f + 1,
                            "data:realIndex": k
                        });
                        s.ctx.series.addCollapsedClassToSeries(S, k);
                        var C = s.graphics.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": k
                        }), L = s.graphics.group({
                            class: "apexcharts-bar-goals-markers"
                        }), I = 0, z = 0, T = s.initialPositions(h, c, m, w, A, l);
                        c = T.y, I = T.barHeight, w = T.yDivision, l = T.zeroW, h = T.x, z = T.barWidth, m = T.xDivision, A = T.zeroH, r.globals.barHeight = I, r.globals.barWidth = z, s.barHelpers.initializeStackedXYVars(s), s.groupCtx.prevY.length === 1 && s.groupCtx.prevY[0].every(function(V) {
                            return isNaN(V);
                        }) && (s.groupCtx.prevY[0] = s.groupCtx.prevY[0].map(function(V) {
                            return A;
                        }), s.groupCtx.prevYF[0] = s.groupCtx.prevYF[0].map(function(V) {
                            return 0;
                        }));
                        for(var E = 0; E < r.globals.dataPoints; E++){
                            var R = s.barHelpers.getStrokeWidth(f, E, k), O = {
                                indexes: {
                                    i: f,
                                    j: E,
                                    realIndex: k,
                                    bc: b
                                },
                                strokeWidth: R,
                                x: h,
                                y: c,
                                elSeries: S,
                                groupIndex: u,
                                seriesGroup: r.globals.seriesGroups[u]
                            }, D = null;
                            s.isHorizontal ? (D = s.drawStackedBarPaths(X(X({}, O), {}, {
                                zeroW: l,
                                barHeight: I,
                                yDivision: w
                            })), z = s.series[f][E] / s.invertedYRatio) : (D = s.drawStackedColumnPaths(X(X({}, O), {}, {
                                xDivision: m,
                                barWidth: z,
                                zeroH: A
                            })), I = s.series[f][E] / s.yRatio[s.yaxisIndex]);
                            var W = s.barHelpers.drawGoalLine({
                                barXPosition: D.barXPosition,
                                barYPosition: D.barYPosition,
                                goalX: D.goalX,
                                goalY: D.goalY,
                                barHeight: I,
                                barWidth: z
                            });
                            W && L.add(W), c = D.y, h = D.x, x.push(h), v.push(c);
                            var N = s.barHelpers.getPathFillColor(i, f, E, k);
                            S = s.renderSeries({
                                realIndex: k,
                                pathFill: N,
                                j: E,
                                i: f,
                                groupIndex: u,
                                pathFrom: D.pathFrom,
                                pathTo: D.pathTo,
                                strokeWidth: R,
                                elSeries: S,
                                x: h,
                                y: c,
                                series: i,
                                barHeight: I,
                                barWidth: z,
                                elDataLabelsWrap: C,
                                elGoalsMarkers: L,
                                type: "bar",
                                visibleSeries: 0
                            });
                        }
                        r.globals.seriesXvalues[k] = x, r.globals.seriesYvalues[k] = v, s.groupCtx.prevY.push(s.groupCtx.yArrj), s.groupCtx.prevYF.push(s.groupCtx.yArrjF), s.groupCtx.prevYVal.push(s.groupCtx.yArrjVal), s.groupCtx.prevX.push(s.groupCtx.xArrj), s.groupCtx.prevXF.push(s.groupCtx.xArrjF), s.groupCtx.prevXVal.push(s.groupCtx.xArrjVal), o.add(S);
                    }, g = 0, p = 0; g < i.length; g++, p++)d(g, p);
                    return o;
                }
            },
            {
                key: "initialPositions",
                value: function(i, a, s, r, n, o) {
                    var h, c, d, g, p = this.w;
                    return this.isHorizontal ? (d = (d = r = p.globals.gridHeight / p.globals.dataPoints) * parseInt(p.config.plotOptions.bar.barHeight, 10) / 100, String(p.config.plotOptions.bar.barHeight).indexOf("%") === -1 && (d = parseInt(p.config.plotOptions.bar.barHeight, 10)), o = this.baseLineInvertedY + p.globals.padHorizontal + (this.isReversed ? p.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), a = (r - d) / 2) : (g = s = p.globals.gridWidth / p.globals.dataPoints, g = p.globals.isXNumeric && p.globals.dataPoints > 1 ? (s = p.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : g * parseInt(p.config.plotOptions.bar.columnWidth, 10) / 100, String(p.config.plotOptions.bar.columnWidth).indexOf("%") === -1 && (g = parseInt(p.config.plotOptions.bar.columnWidth, 10)), n = p.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? p.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), i = p.globals.padHorizontal + (s - g) / 2), {
                        x: i,
                        y: a,
                        yDivision: r,
                        xDivision: s,
                        barHeight: (h = p.globals.seriesGroups) !== null && h !== void 0 && h.length ? d / p.globals.seriesGroups.length : d,
                        barWidth: (c = p.globals.seriesGroups) !== null && c !== void 0 && c.length ? g / p.globals.seriesGroups.length : g,
                        zeroH: n,
                        zeroW: o
                    };
                }
            },
            {
                key: "drawStackedBarPaths",
                value: function(i) {
                    for(var a, s = i.indexes, r = i.barHeight, n = i.strokeWidth, o = i.zeroW, h = i.x, c = i.y, d = i.groupIndex, g = i.seriesGroup, p = i.yDivision, f = i.elSeries, b = this.w, m = c + (d !== -1 ? d * r : 0), w = s.i, A = s.j, l = 0, u = 0; u < this.groupCtx.prevXF.length; u++)l += this.groupCtx.prevXF[u][A];
                    var x = w;
                    if (g && (x = g.indexOf(b.config.series[w].name)), x > 0) {
                        var v = o;
                        this.groupCtx.prevXVal[x - 1][A] < 0 ? v = this.series[w][A] >= 0 ? this.groupCtx.prevX[x - 1][A] + l - 2 * (this.isReversed ? l : 0) : this.groupCtx.prevX[x - 1][A] : this.groupCtx.prevXVal[x - 1][A] >= 0 && (v = this.series[w][A] >= 0 ? this.groupCtx.prevX[x - 1][A] : this.groupCtx.prevX[x - 1][A] - l + 2 * (this.isReversed ? l : 0)), a = v;
                    } else a = o;
                    h = this.series[w][A] === null ? a : a + this.series[w][A] / this.invertedYRatio - 2 * (this.isReversed ? this.series[w][A] / this.invertedYRatio : 0);
                    var k = this.barHelpers.getBarpaths({
                        barYPosition: m,
                        barHeight: r,
                        x1: a,
                        x2: h,
                        strokeWidth: n,
                        series: this.series,
                        realIndex: s.realIndex,
                        seriesGroup: g,
                        i: w,
                        j: A,
                        w: b
                    });
                    return this.barHelpers.barBackground({
                        j: A,
                        i: w,
                        y1: m,
                        y2: r,
                        elSeries: f
                    }), c += p, {
                        pathTo: k.pathTo,
                        pathFrom: k.pathFrom,
                        goalX: this.barHelpers.getGoalValues("x", o, null, w, A),
                        barYPosition: m,
                        x: h,
                        y: c
                    };
                }
            },
            {
                key: "drawStackedColumnPaths",
                value: function(i) {
                    var a = i.indexes, s = i.x, r = i.y, n = i.xDivision, o = i.barWidth, h = i.zeroH, c = i.groupIndex, d = i.seriesGroup, g = i.elSeries, p = this.w, f = a.i, b = a.j, m = a.bc;
                    if (p.globals.isXNumeric) {
                        var w = p.globals.seriesX[f][b];
                        w || (w = 0), s = (w - p.globals.minX) / this.xRatio - o / 2, p.globals.seriesGroups.length && (s = (w - p.globals.minX) / this.xRatio - o / 2 * p.globals.seriesGroups.length);
                    }
                    for(var A, l = s + (c !== -1 ? c * o : 0), u = 0, x = 0; x < this.groupCtx.prevYF.length; x++)u += isNaN(this.groupCtx.prevYF[x][b]) ? 0 : this.groupCtx.prevYF[x][b];
                    var v = f;
                    if (d && (v = d.indexOf(p.config.series[f].name)), v > 0 && !p.globals.isXNumeric || v > 0 && p.globals.isXNumeric && p.globals.seriesX[f - 1][b] === p.globals.seriesX[f][b]) {
                        var k, S, C, L = Math.min(this.yRatio.length + 1, f + 1);
                        if (this.groupCtx.prevY[v - 1] !== void 0 && this.groupCtx.prevY[v - 1].length) for(var I = 1; I < L; I++){
                            var z;
                            if (!isNaN((z = this.groupCtx.prevY[v - I]) === null || z === void 0 ? void 0 : z[b])) {
                                C = this.groupCtx.prevY[v - I][b];
                                break;
                            }
                        }
                        for(var T = 1; T < L; T++){
                            var E, R;
                            if (((E = this.groupCtx.prevYVal[v - T]) === null || E === void 0 ? void 0 : E[b]) < 0) {
                                S = this.series[f][b] >= 0 ? C - u + 2 * (this.isReversed ? u : 0) : C;
                                break;
                            }
                            if (((R = this.groupCtx.prevYVal[v - T]) === null || R === void 0 ? void 0 : R[b]) >= 0) {
                                S = this.series[f][b] >= 0 ? C : C + u - 2 * (this.isReversed ? u : 0);
                                break;
                            }
                        }
                        S === void 0 && (S = p.globals.gridHeight), A = (k = this.groupCtx.prevYF[0]) !== null && k !== void 0 && k.every(function(D) {
                            return D === 0;
                        }) && this.groupCtx.prevYF.slice(1, v).every(function(D) {
                            return D.every(function(W) {
                                return isNaN(W);
                            });
                        }) ? h : S;
                    } else A = h;
                    r = this.series[f][b] ? A - this.series[f][b] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[f][b] / this.yRatio[this.yaxisIndex] : 0) : A;
                    var O = this.barHelpers.getColumnPaths({
                        barXPosition: l,
                        barWidth: o,
                        y1: A,
                        y2: r,
                        yRatio: this.yRatio[this.yaxisIndex],
                        strokeWidth: this.strokeWidth,
                        series: this.series,
                        seriesGroup: d,
                        realIndex: a.realIndex,
                        i: f,
                        j: b,
                        w: p
                    });
                    return this.barHelpers.barBackground({
                        bc: m,
                        j: b,
                        i: f,
                        x1: l,
                        x2: o,
                        elSeries: g
                    }), s += n, {
                        pathTo: O.pathTo,
                        pathFrom: O.pathFrom,
                        goalY: this.barHelpers.getGoalValues("y", null, h, f, b),
                        barXPosition: l,
                        x: p.globals.isXNumeric ? s - n : s,
                        y: r
                    };
                }
            }
        ]), t;
    }(), Be = function(y) {
        ge(t, ke);
        var e = ue(t);
        function t() {
            return F(this, t), e.apply(this, arguments);
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i, a, s) {
                    var r = this, n = this.w, o = new M(this.ctx), h = n.globals.comboCharts ? a : n.config.chart.type, c = new ae(this.ctx);
                    this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = n.config.plotOptions.bar.horizontal;
                    var d = new q(this.ctx, n);
                    i = d.getLogSeries(i), this.series = i, this.yRatio = d.getLogYRatios(this.yRatio), this.barHelpers.initVariables(i);
                    for(var g = o.group({
                        class: "apexcharts-".concat(h, "-series apexcharts-plot-series")
                    }), p = function(b) {
                        r.isBoxPlot = n.config.chart.type === "boxPlot" || n.config.series[b].type === "boxPlot";
                        var m, w, A, l, u = void 0, x = void 0, v = [], k = [], S = n.globals.comboCharts ? s[b] : b, C = o.group({
                            class: "apexcharts-series",
                            seriesName: P.escapeString(n.globals.seriesNames[S]),
                            rel: b + 1,
                            "data:realIndex": S
                        });
                        r.ctx.series.addCollapsedClassToSeries(C, S), i[b].length > 0 && (r.visibleI = r.visibleI + 1);
                        var L, I;
                        r.yRatio.length > 1 && (r.yaxisIndex = S);
                        var z = r.barHelpers.initialPositions();
                        x = z.y, L = z.barHeight, w = z.yDivision, l = z.zeroW, u = z.x, I = z.barWidth, m = z.xDivision, A = z.zeroH, k.push(u + I / 2);
                        for(var T = o.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": S
                        }), E = function(O) {
                            var D = r.barHelpers.getStrokeWidth(b, O, S), W = null, N = {
                                indexes: {
                                    i: b,
                                    j: O,
                                    realIndex: S
                                },
                                x: u,
                                y: x,
                                strokeWidth: D,
                                elSeries: C
                            };
                            W = r.isHorizontal ? r.drawHorizontalBoxPaths(X(X({}, N), {}, {
                                yDivision: w,
                                barHeight: L,
                                zeroW: l
                            })) : r.drawVerticalBoxPaths(X(X({}, N), {}, {
                                xDivision: m,
                                barWidth: I,
                                zeroH: A
                            })), x = W.y, u = W.x, O > 0 && k.push(u + I / 2), v.push(x), W.pathTo.forEach(function(V, j) {
                                var se = !r.isBoxPlot && r.candlestickOptions.wick.useFillColor ? W.color[j] : n.globals.stroke.colors[b], K = c.fillPath({
                                    seriesNumber: S,
                                    dataPointIndex: O,
                                    color: W.color[j],
                                    value: i[b][O]
                                });
                                r.renderSeries({
                                    realIndex: S,
                                    pathFill: K,
                                    lineFill: se,
                                    j: O,
                                    i: b,
                                    pathFrom: W.pathFrom,
                                    pathTo: V,
                                    strokeWidth: D,
                                    elSeries: C,
                                    x: u,
                                    y: x,
                                    series: i,
                                    barHeight: L,
                                    barWidth: I,
                                    elDataLabelsWrap: T,
                                    visibleSeries: r.visibleI,
                                    type: n.config.chart.type
                                });
                            });
                        }, R = 0; R < n.globals.dataPoints; R++)E(R);
                        n.globals.seriesXvalues[S] = k, n.globals.seriesYvalues[S] = v, g.add(C);
                    }, f = 0; f < i.length; f++)p(f);
                    return g;
                }
            },
            {
                key: "drawVerticalBoxPaths",
                value: function(i) {
                    var a = i.indexes, s = i.x;
                    i.y;
                    var r = i.xDivision, n = i.barWidth, o = i.zeroH, h = i.strokeWidth, c = this.w, d = new M(this.ctx), g = a.i, p = a.j, f = !0, b = c.config.plotOptions.candlestick.colors.upward, m = c.config.plotOptions.candlestick.colors.downward, w = "";
                    this.isBoxPlot && (w = [
                        this.boxOptions.colors.lower,
                        this.boxOptions.colors.upper
                    ]);
                    var A = this.yRatio[this.yaxisIndex], l = a.realIndex, u = this.getOHLCValue(l, p), x = o, v = o;
                    u.o > u.c && (f = !1);
                    var k = Math.min(u.o, u.c), S = Math.max(u.o, u.c), C = u.m;
                    c.globals.isXNumeric && (s = (c.globals.seriesX[l][p] - c.globals.minX) / this.xRatio - n / 2);
                    var L = s + n * this.visibleI;
                    this.series[g][p] === void 0 || this.series[g][p] === null ? (k = o, S = o) : (k = o - k / A, S = o - S / A, x = o - u.h / A, v = o - u.l / A, C = o - u.m / A);
                    var I = d.move(L, o), z = d.move(L + n / 2, k);
                    return c.globals.previousPaths.length > 0 && (z = this.getPreviousPath(l, p, !0)), I = this.isBoxPlot ? [
                        d.move(L, k) + d.line(L + n / 2, k) + d.line(L + n / 2, x) + d.line(L + n / 4, x) + d.line(L + n - n / 4, x) + d.line(L + n / 2, x) + d.line(L + n / 2, k) + d.line(L + n, k) + d.line(L + n, C) + d.line(L, C) + d.line(L, k + h / 2),
                        d.move(L, C) + d.line(L + n, C) + d.line(L + n, S) + d.line(L + n / 2, S) + d.line(L + n / 2, v) + d.line(L + n - n / 4, v) + d.line(L + n / 4, v) + d.line(L + n / 2, v) + d.line(L + n / 2, S) + d.line(L, S) + d.line(L, C) + "z"
                    ] : [
                        d.move(L, S) + d.line(L + n / 2, S) + d.line(L + n / 2, x) + d.line(L + n / 2, S) + d.line(L + n, S) + d.line(L + n, k) + d.line(L + n / 2, k) + d.line(L + n / 2, v) + d.line(L + n / 2, k) + d.line(L, k) + d.line(L, S - h / 2)
                    ], z += d.move(L, k), c.globals.isXNumeric || (s += r), {
                        pathTo: I,
                        pathFrom: z,
                        x: s,
                        y: S,
                        barXPosition: L,
                        color: this.isBoxPlot ? w : f ? [
                            b
                        ] : [
                            m
                        ]
                    };
                }
            },
            {
                key: "drawHorizontalBoxPaths",
                value: function(i) {
                    var a = i.indexes;
                    i.x;
                    var s = i.y, r = i.yDivision, n = i.barHeight, o = i.zeroW, h = i.strokeWidth, c = this.w, d = new M(this.ctx), g = a.i, p = a.j, f = this.boxOptions.colors.lower;
                    this.isBoxPlot && (f = [
                        this.boxOptions.colors.lower,
                        this.boxOptions.colors.upper
                    ]);
                    var b = this.invertedYRatio, m = a.realIndex, w = this.getOHLCValue(m, p), A = o, l = o, u = Math.min(w.o, w.c), x = Math.max(w.o, w.c), v = w.m;
                    c.globals.isXNumeric && (s = (c.globals.seriesX[m][p] - c.globals.minX) / this.invertedXRatio - n / 2);
                    var k = s + n * this.visibleI;
                    this.series[g][p] === void 0 || this.series[g][p] === null ? (u = o, x = o) : (u = o + u / b, x = o + x / b, A = o + w.h / b, l = o + w.l / b, v = o + w.m / b);
                    var S = d.move(o, k), C = d.move(u, k + n / 2);
                    return c.globals.previousPaths.length > 0 && (C = this.getPreviousPath(m, p, !0)), S = [
                        d.move(u, k) + d.line(u, k + n / 2) + d.line(A, k + n / 2) + d.line(A, k + n / 2 - n / 4) + d.line(A, k + n / 2 + n / 4) + d.line(A, k + n / 2) + d.line(u, k + n / 2) + d.line(u, k + n) + d.line(v, k + n) + d.line(v, k) + d.line(u + h / 2, k),
                        d.move(v, k) + d.line(v, k + n) + d.line(x, k + n) + d.line(x, k + n / 2) + d.line(l, k + n / 2) + d.line(l, k + n - n / 4) + d.line(l, k + n / 4) + d.line(l, k + n / 2) + d.line(x, k + n / 2) + d.line(x, k) + d.line(v, k) + "z"
                    ], C += d.move(u, k), c.globals.isXNumeric || (s += r), {
                        pathTo: S,
                        pathFrom: C,
                        x: x,
                        y: s,
                        barYPosition: k,
                        color: f
                    };
                }
            },
            {
                key: "getOHLCValue",
                value: function(i, a) {
                    var s = this.w;
                    return {
                        o: this.isBoxPlot ? s.globals.seriesCandleH[i][a] : s.globals.seriesCandleO[i][a],
                        h: this.isBoxPlot ? s.globals.seriesCandleO[i][a] : s.globals.seriesCandleH[i][a],
                        m: s.globals.seriesCandleM[i][a],
                        l: this.isBoxPlot ? s.globals.seriesCandleC[i][a] : s.globals.seriesCandleL[i][a],
                        c: this.isBoxPlot ? s.globals.seriesCandleL[i][a] : s.globals.seriesCandleC[i][a]
                    };
                }
            }
        ]), t;
    }(), rt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "checkColorRange",
                value: function() {
                    var e = this.w, t = !1, i = e.config.plotOptions[e.config.chart.type];
                    return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(a, s) {
                        a.from <= 0 && (t = !0);
                    }), t;
                }
            },
            {
                key: "getShadeColor",
                value: function(e, t, i, a) {
                    var s = this.w, r = 1, n = s.config.plotOptions[e].shadeIntensity, o = this.determineColor(e, t, i);
                    s.globals.hasNegs || a ? r = s.config.plotOptions[e].reverseNegativeShade ? o.percent < 0 ? o.percent / 100 * (1.25 * n) : (1 - o.percent / 100) * (1.25 * n) : o.percent <= 0 ? 1 - (1 + o.percent / 100) * n : (1 - o.percent / 100) * n : (r = 1 - o.percent / 100, e === "treemap" && (r = (1 - o.percent / 100) * (1.25 * n)));
                    var h = o.color, c = new P();
                    return s.config.plotOptions[e].enableShades && (h = this.w.config.theme.mode === "dark" ? P.hexToRgba(c.shadeColor(-1 * r, o.color), s.config.fill.opacity) : P.hexToRgba(c.shadeColor(r, o.color), s.config.fill.opacity)), {
                        color: h,
                        colorProps: o
                    };
                }
            },
            {
                key: "determineColor",
                value: function(e, t, i) {
                    var a = this.w, s = a.globals.series[t][i], r = a.config.plotOptions[e], n = r.colorScale.inverse ? i : t;
                    r.distributed && a.config.chart.type === "treemap" && (n = i);
                    var o = a.globals.colors[n], h = null, c = Math.min.apply(Math, J(a.globals.series[t])), d = Math.max.apply(Math, J(a.globals.series[t]));
                    r.distributed || e !== "heatmap" || (c = a.globals.minY, d = a.globals.maxY), r.colorScale.min !== void 0 && (c = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, d = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                    var g = Math.abs(d) + Math.abs(c), p = 100 * s / (g === 0 ? g - 1e-6 : g);
                    return r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(f, b) {
                        if (s >= f.from && s <= f.to) {
                            o = f.color, h = f.foreColor ? f.foreColor : null, c = f.from, d = f.to;
                            var m = Math.abs(d) + Math.abs(c);
                            p = 100 * s / (m === 0 ? m - 1e-6 : m);
                        }
                    }), {
                        color: o,
                        foreColor: h,
                        percent: p
                    };
                }
            },
            {
                key: "calculateDataLabels",
                value: function(e) {
                    var t = e.text, i = e.x, a = e.y, s = e.i, r = e.j, n = e.colorProps, o = e.fontSize, h = this.w.config.dataLabels, c = new M(this.ctx), d = new ye(this.ctx), g = null;
                    if (h.enabled) {
                        g = c.group({
                            class: "apexcharts-data-labels"
                        });
                        var p = h.offsetX, f = h.offsetY, b = i + p, m = a + parseFloat(h.style.fontSize) / 3 + f;
                        d.plotDataLabelsText({
                            x: b,
                            y: m,
                            text: t,
                            i: s,
                            j: r,
                            color: n.foreColor,
                            parent: g,
                            fontSize: o,
                            dataLabelsConfig: h
                        });
                    }
                    return g;
                }
            },
            {
                key: "addListeners",
                value: function(e) {
                    var t = new M(this.ctx);
                    e.node.addEventListener("mouseenter", t.pathMouseEnter.bind(this, e)), e.node.addEventListener("mouseleave", t.pathMouseLeave.bind(this, e)), e.node.addEventListener("mousedown", t.pathMouseDown.bind(this, e));
                }
            }
        ]), y;
    }(), Yt = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w, this.xRatio = t.xRatio, this.yRatio = t.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new rt(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this.w, i = new M(this.ctx), a = i.group({
                        class: "apexcharts-heatmap"
                    });
                    a.attr("clip-path", "url(#gridRectMask".concat(t.globals.cuid, ")"));
                    var s = t.globals.gridWidth / t.globals.dataPoints, r = t.globals.gridHeight / t.globals.series.length, n = 0, o = !1;
                    this.negRange = this.helpers.checkColorRange();
                    var h = e.slice();
                    t.config.yaxis[0].reversed && (o = !0, h.reverse());
                    for(var c = o ? 0 : h.length - 1; o ? c < h.length : c >= 0; o ? c++ : c--){
                        var d = i.group({
                            class: "apexcharts-series apexcharts-heatmap-series",
                            seriesName: P.escapeString(t.globals.seriesNames[c]),
                            rel: c + 1,
                            "data:realIndex": c
                        });
                        if (this.ctx.series.addCollapsedClassToSeries(d, c), t.config.chart.dropShadow.enabled) {
                            var g = t.config.chart.dropShadow;
                            new Z(this.ctx).dropShadow(d, g, c);
                        }
                        for(var p = 0, f = t.config.plotOptions.heatmap.shadeIntensity, b = 0; b < h[c].length; b++){
                            var m = this.helpers.getShadeColor(t.config.chart.type, c, b, this.negRange), w = m.color, A = m.colorProps;
                            t.config.fill.type === "image" && (w = new ae(this.ctx).fillPath({
                                seriesNumber: c,
                                dataPointIndex: b,
                                opacity: t.globals.hasNegs ? A.percent < 0 ? 1 - (1 + A.percent / 100) : f + A.percent / 100 : A.percent / 100,
                                patternID: P.randomId(),
                                width: t.config.fill.image.width ? t.config.fill.image.width : s,
                                height: t.config.fill.image.height ? t.config.fill.image.height : r
                            }));
                            var l = this.rectRadius, u = i.drawRect(p, n, s, r, l);
                            if (u.attr({
                                cx: p,
                                cy: n
                            }), u.node.classList.add("apexcharts-heatmap-rect"), d.add(u), u.attr({
                                fill: w,
                                i: c,
                                index: c,
                                j: b,
                                val: e[c][b],
                                "stroke-width": this.strokeWidth,
                                stroke: t.config.plotOptions.heatmap.useFillColorAsStroke ? w : t.globals.stroke.colors[0],
                                color: w
                            }), this.helpers.addListeners(u), t.config.chart.animations.enabled && !t.globals.dataChanged) {
                                var x = 1;
                                t.globals.resized || (x = t.config.chart.animations.speed), this.animateHeatMap(u, p, n, s, r, x);
                            }
                            if (t.globals.dataChanged) {
                                var v = 1;
                                if (this.dynamicAnim.enabled && t.globals.shouldAnimate) {
                                    v = this.dynamicAnim.speed;
                                    var k = t.globals.previousPaths[c] && t.globals.previousPaths[c][b] && t.globals.previousPaths[c][b].color;
                                    k || (k = "rgba(255, 255, 255, 0)"), this.animateHeatColor(u, P.isColorHex(k) ? k : P.rgb2hex(k), P.isColorHex(w) ? w : P.rgb2hex(w), v);
                                }
                            }
                            var S = (0, t.config.dataLabels.formatter)(t.globals.series[c][b], {
                                value: t.globals.series[c][b],
                                seriesIndex: c,
                                dataPointIndex: b,
                                w: t
                            }), C = this.helpers.calculateDataLabels({
                                text: S,
                                x: p + s / 2,
                                y: n + r / 2,
                                i: c,
                                j: b,
                                colorProps: A,
                                series: h
                            });
                            C !== null && d.add(C), p += s;
                        }
                        n += r, a.add(d);
                    }
                    var L = t.globals.yAxisScale[0].result.slice();
                    return t.config.yaxis[0].reversed ? L.unshift("") : L.push(""), t.globals.yAxisScale[0].result = L, a;
                }
            },
            {
                key: "animateHeatMap",
                value: function(e, t, i, a, s, r) {
                    var n = new de(this.ctx);
                    n.animateRect(e, {
                        x: t + a / 2,
                        y: i + s / 2,
                        width: 0,
                        height: 0
                    }, {
                        x: t,
                        y: i,
                        width: a,
                        height: s
                    }, r, function() {
                        n.animationCompleted(e);
                    });
                }
            },
            {
                key: "animateHeatColor",
                value: function(e, t, i, a) {
                    e.attr({
                        fill: t
                    }).animate(a).attr({
                        fill: i
                    });
                }
            }
        ]), y;
    }(), nt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "drawYAxisTexts",
                value: function(e, t, i, a) {
                    var s = this.w, r = s.config.yaxis[0], n = s.globals.yLabelFormatters[0];
                    return new M(this.ctx).drawText({
                        x: e + r.labels.offsetX,
                        y: t + r.labels.offsetY,
                        text: n(a, i),
                        textAnchor: "middle",
                        fontSize: r.labels.style.fontSize,
                        fontFamily: r.labels.style.fontFamily,
                        foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                    });
                }
            }
        ]), y;
    }(), ot = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
            var t = this.w;
            this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
                0
            ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = t.globals.stroke.colors !== void 0 ? t.globals.stroke.colors : t.globals.colors, this.defaultSize = Math.min(t.globals.gridWidth, t.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = t.globals.gridWidth / 2, t.config.chart.type === "radialBar" ? this.fullAngle = 360 : this.fullAngle = Math.abs(t.config.plotOptions.pie.endAngle - t.config.plotOptions.pie.startAngle), this.initialAngle = t.config.plotOptions.pie.startAngle % this.fullAngle, t.globals.radialSize = this.defaultSize / 2.05 - t.config.stroke.width - (t.config.chart.sparkline.enabled ? 0 : t.config.chart.dropShadow.blur), this.donutSize = t.globals.radialSize * parseInt(t.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx);
                    if (this.ret = a.group({
                        class: "apexcharts-pie"
                    }), i.globals.noData) return this.ret;
                    for(var s = 0, r = 0; r < e.length; r++)s += P.negToZero(e[r]);
                    var n = [], o = a.group();
                    s === 0 && (s = 1e-5), e.forEach(function(k) {
                        t.maxY = Math.max(t.maxY, k);
                    }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), i.config.grid.position === "back" && this.chartType === "polarArea" && this.drawPolarElements(this.ret);
                    for(var h = 0; h < e.length; h++){
                        var c = this.fullAngle * P.negToZero(e[h]) / s;
                        n.push(c), this.chartType === "polarArea" ? (n[h] = this.fullAngle / e.length, this.sliceSizes.push(i.globals.radialSize * e[h] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                    }
                    if (i.globals.dataChanged) {
                        for(var d, g = 0, p = 0; p < i.globals.previousPaths.length; p++)g += P.negToZero(i.globals.previousPaths[p]);
                        for(var f = 0; f < i.globals.previousPaths.length; f++)d = this.fullAngle * P.negToZero(i.globals.previousPaths[f]) / g, this.prevSectorAngleArr.push(d);
                    }
                    this.donutSize < 0 && (this.donutSize = 0);
                    var b = i.config.plotOptions.pie.customScale, m = i.globals.gridWidth / 2, w = i.globals.gridHeight / 2, A = m - i.globals.gridWidth / 2 * b, l = w - i.globals.gridHeight / 2 * b;
                    if (this.chartType === "donut") {
                        var u = a.drawCircle(this.donutSize);
                        u.attr({
                            cx: this.centerX,
                            cy: this.centerY,
                            fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                        }), o.add(u);
                    }
                    var x = this.drawArcs(n, e);
                    if (this.sliceLabels.forEach(function(k) {
                        x.add(k);
                    }), o.attr({
                        transform: "translate(".concat(A, ", ").concat(l, ") scale(").concat(b, ")")
                    }), o.add(x), this.ret.add(o), this.donutDataLabels.show) {
                        var v = this.renderInnerDataLabels(this.donutDataLabels, {
                            hollowSize: this.donutSize,
                            centerX: this.centerX,
                            centerY: this.centerY,
                            opacity: this.donutDataLabels.show,
                            translateX: A,
                            translateY: l
                        });
                        this.ret.add(v);
                    }
                    return i.config.grid.position === "front" && this.chartType === "polarArea" && this.drawPolarElements(this.ret), this.ret;
                }
            },
            {
                key: "drawArcs",
                value: function(e, t) {
                    var i = this.w, a = new Z(this.ctx), s = new M(this.ctx), r = new ae(this.ctx), n = s.group({
                        class: "apexcharts-slices"
                    }), o = this.initialAngle, h = this.initialAngle, c = this.initialAngle, d = this.initialAngle;
                    this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                    for(var g = 0; g < e.length; g++){
                        var p = s.group({
                            class: "apexcharts-series apexcharts-pie-series",
                            seriesName: P.escapeString(i.globals.seriesNames[g]),
                            rel: g + 1,
                            "data:realIndex": g
                        });
                        n.add(p), h = d, c = (o = c) + e[g], d = h + this.prevSectorAngleArr[g];
                        var f = c < o ? this.fullAngle + c - o : c - o, b = r.fillPath({
                            seriesNumber: g,
                            size: this.sliceSizes[g],
                            value: t[g]
                        }), m = this.getChangedPath(h, d), w = s.drawPath({
                            d: m,
                            stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[g] : this.lineColorArr,
                            strokeWidth: 0,
                            fill: b,
                            fillOpacity: i.config.fill.opacity,
                            classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(g)
                        });
                        if (w.attr({
                            index: 0,
                            j: g
                        }), a.setSelectionFilter(w, 0, g), i.config.chart.dropShadow.enabled) {
                            var A = i.config.chart.dropShadow;
                            a.dropShadow(w, A, g);
                        }
                        this.addListeners(w, this.donutDataLabels), M.setAttrs(w.node, {
                            "data:angle": f,
                            "data:startAngle": o,
                            "data:strokeWidth": this.strokeWidth,
                            "data:value": t[g]
                        });
                        var l = {
                            x: 0,
                            y: 0
                        };
                        this.chartType === "pie" || this.chartType === "polarArea" ? l = P.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (o + f / 2) % this.fullAngle) : this.chartType === "donut" && (l = P.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (o + f / 2) % this.fullAngle)), p.add(w);
                        var u = 0;
                        if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : ((u = f / this.fullAngle * i.config.chart.animations.speed) === 0 && (u = 1), this.animDur = u + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(w, {
                            size: this.sliceSizes[g],
                            endAngle: c,
                            startAngle: o,
                            prevStartAngle: h,
                            prevEndAngle: d,
                            animateStartingPos: !0,
                            i: g,
                            animBeginArr: this.animBeginArr,
                            shouldSetPrevPaths: !0,
                            dur: i.config.chart.animations.dynamicAnimation.speed
                        }) : this.animatePaths(w, {
                            size: this.sliceSizes[g],
                            endAngle: c,
                            startAngle: o,
                            i: g,
                            totalItems: e.length - 1,
                            animBeginArr: this.animBeginArr,
                            dur: u
                        }), i.config.plotOptions.pie.expandOnClick && this.chartType !== "polarArea" && w.click(this.pieClicked.bind(this, g)), i.globals.selectedDataPoints[0] !== void 0 && i.globals.selectedDataPoints[0].indexOf(g) > -1 && this.pieClicked(g), i.config.dataLabels.enabled) {
                            var x = l.x, v = l.y, k = 100 * f / this.fullAngle + "%";
                            if (f !== 0 && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < e[g]) {
                                var S = i.config.dataLabels.formatter;
                                S !== void 0 && (k = S(i.globals.seriesPercent[g][0], {
                                    seriesIndex: g,
                                    w: i
                                }));
                                var C = i.globals.dataLabels.style.colors[g], L = s.group({
                                    class: "apexcharts-datalabels"
                                }), I = s.drawText({
                                    x: x,
                                    y: v,
                                    text: k,
                                    textAnchor: "middle",
                                    fontSize: i.config.dataLabels.style.fontSize,
                                    fontFamily: i.config.dataLabels.style.fontFamily,
                                    fontWeight: i.config.dataLabels.style.fontWeight,
                                    foreColor: C
                                });
                                if (L.add(I), i.config.dataLabels.dropShadow.enabled) {
                                    var z = i.config.dataLabels.dropShadow;
                                    a.dropShadow(I, z);
                                }
                                I.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && i.globals.resized === !1 && (I.node.classList.add("apexcharts-pie-label-delay"), I.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(L);
                            }
                        }
                    }
                    return n;
                }
            },
            {
                key: "addListeners",
                value: function(e, t) {
                    var i = new M(this.ctx);
                    e.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, e)), e.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, e)), e.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, e.node, t)), e.node.addEventListener("mousedown", i.pathMouseDown.bind(this, e)), this.donutDataLabels.total.showAlways || (e.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, e.node, t)), e.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, e.node, t)));
                }
            },
            {
                key: "animatePaths",
                value: function(e, t) {
                    var i = this.w, a = t.endAngle < t.startAngle ? this.fullAngle + t.endAngle - t.startAngle : t.endAngle - t.startAngle, s = a, r = t.startAngle, n = t.startAngle;
                    t.prevStartAngle !== void 0 && t.prevEndAngle !== void 0 && (r = t.prevEndAngle, s = t.prevEndAngle < t.prevStartAngle ? this.fullAngle + t.prevEndAngle - t.prevStartAngle : t.prevEndAngle - t.prevStartAngle), t.i === i.config.series.length - 1 && (a + n > this.fullAngle ? t.endAngle = t.endAngle - (a + n) : a + n < this.fullAngle && (t.endAngle = t.endAngle + (this.fullAngle - (a + n)))), a === this.fullAngle && (a = this.fullAngle - 0.01), this.animateArc(e, r, n, a, s, t);
                }
            },
            {
                key: "animateArc",
                value: function(e, t, i, a, s, r) {
                    var n, o = this, h = this.w, c = new de(this.ctx), d = r.size;
                    (isNaN(t) || isNaN(s)) && (t = i, s = a, r.dur = 0);
                    var g = a, p = i, f = t < i ? this.fullAngle + t - i : t - i;
                    h.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (n = o.getPiePath({
                        me: o,
                        startAngle: r.prevStartAngle,
                        angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                        size: d
                    }), e.attr({
                        d: n
                    })), r.dur !== 0 ? e.animate(r.dur, h.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                        o.chartType !== "pie" && o.chartType !== "donut" && o.chartType !== "polarArea" || this.animate(h.config.chart.animations.dynamicAnimation.speed).attr({
                            "stroke-width": o.strokeWidth
                        }), r.i === h.config.series.length - 1 && c.animationCompleted(e);
                    }).during(function(b) {
                        g = f + (a - f) * b, r.animateStartingPos && (g = s + (a - s) * b, p = t - s + (i - (t - s)) * b), n = o.getPiePath({
                            me: o,
                            startAngle: p,
                            angle: g,
                            size: d
                        }), e.node.setAttribute("data:pathOrig", n), e.attr({
                            d: n
                        });
                    }) : (n = o.getPiePath({
                        me: o,
                        startAngle: p,
                        angle: a,
                        size: d
                    }), r.isTrack || (h.globals.animationEnded = !0), e.node.setAttribute("data:pathOrig", n), e.attr({
                        d: n,
                        "stroke-width": o.strokeWidth
                    }));
                }
            },
            {
                key: "pieClicked",
                value: function(e) {
                    var t, i = this.w, a = this, s = a.sliceSizes[e] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(e)).members[0];
                    if (r.attr("data:pieClicked") !== "true") {
                        var n = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                        Array.prototype.forEach.call(n, function(d) {
                            d.setAttribute("data:pieClicked", "false");
                            var g = d.getAttribute("data:pathOrig");
                            g && d.setAttribute("d", g);
                        }), r.attr("data:pieClicked", "true");
                        var o = parseInt(r.attr("data:startAngle"), 10), h = parseInt(r.attr("data:angle"), 10);
                        t = a.getPiePath({
                            me: a,
                            startAngle: o,
                            angle: h,
                            size: s
                        }), h !== 360 && r.plot(t);
                    } else {
                        r.attr({
                            "data:pieClicked": "false"
                        }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                        var c = r.attr("data:pathOrig");
                        r.attr({
                            d: c
                        });
                    }
                }
            },
            {
                key: "getChangedPath",
                value: function(e, t) {
                    var i = "";
                    return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                        me: this,
                        startAngle: e,
                        angle: t - e,
                        size: this.size
                    })), i;
                }
            },
            {
                key: "getPiePath",
                value: function(e) {
                    var t, i = e.me, a = e.startAngle, s = e.angle, r = e.size, n = new M(this.ctx), o = a, h = Math.PI * (o - 90) / 180, c = s + a;
                    Math.ceil(c) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (c = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - 0.01), Math.ceil(c) > this.fullAngle && (c -= this.fullAngle);
                    var d = Math.PI * (c - 90) / 180, g = i.centerX + r * Math.cos(h), p = i.centerY + r * Math.sin(h), f = i.centerX + r * Math.cos(d), b = i.centerY + r * Math.sin(d), m = P.polarToCartesian(i.centerX, i.centerY, i.donutSize, c), w = P.polarToCartesian(i.centerX, i.centerY, i.donutSize, o), A = s > 180 ? 1 : 0, l = [
                        "M",
                        g,
                        p,
                        "A",
                        r,
                        r,
                        0,
                        A,
                        1,
                        f,
                        b
                    ];
                    return t = i.chartType === "donut" ? [].concat(l, [
                        "L",
                        m.x,
                        m.y,
                        "A",
                        i.donutSize,
                        i.donutSize,
                        0,
                        A,
                        0,
                        w.x,
                        w.y,
                        "L",
                        g,
                        p,
                        "z"
                    ]).join(" ") : i.chartType === "pie" || i.chartType === "polarArea" ? [].concat(l, [
                        "L",
                        i.centerX,
                        i.centerY,
                        "L",
                        g,
                        p
                    ]).join(" ") : [].concat(l).join(" "), n.roundPathCorners(t, 2 * this.strokeWidth);
                }
            },
            {
                key: "drawPolarElements",
                value: function(e) {
                    var t = this.w, i = new we(this.ctx), a = new M(this.ctx), s = new nt(this.ctx), r = a.group(), n = a.group(), o = i.niceScale(0, Math.ceil(this.maxY), t.config.yaxis[0].tickAmount, 0, !0), h = o.result.reverse(), c = o.result.length;
                    this.maxY = o.niceMax;
                    for(var d = t.globals.radialSize, g = d / (c - 1), p = 0; p < c - 1; p++){
                        var f = a.drawCircle(d);
                        if (f.attr({
                            cx: this.centerX,
                            cy: this.centerY,
                            fill: "none",
                            "stroke-width": t.config.plotOptions.polarArea.rings.strokeWidth,
                            stroke: t.config.plotOptions.polarArea.rings.strokeColor
                        }), t.config.yaxis[0].show) {
                            var b = s.drawYAxisTexts(this.centerX, this.centerY - d + parseInt(t.config.yaxis[0].labels.style.fontSize, 10) / 2, p, h[p]);
                            n.add(b);
                        }
                        r.add(f), d -= g;
                    }
                    this.drawSpokes(e), e.add(r), e.add(n);
                }
            },
            {
                key: "renderInnerDataLabels",
                value: function(e, t) {
                    var i = this.w, a = new M(this.ctx), s = a.group({
                        class: "apexcharts-datalabels-group",
                        transform: "translate(".concat(t.translateX ? t.translateX : 0, ", ").concat(t.translateY ? t.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                    }), r = e.total.show;
                    s.node.style.opacity = t.opacity;
                    var n, o, h = t.centerX, c = t.centerY;
                    n = e.name.color === void 0 ? i.globals.colors[0] : e.name.color;
                    var d = e.name.fontSize, g = e.name.fontFamily, p = e.name.fontWeight;
                    o = e.value.color === void 0 ? i.config.chart.foreColor : e.value.color;
                    var f = e.value.formatter, b = "", m = "";
                    if (r ? (n = e.total.color, d = e.total.fontSize, g = e.total.fontFamily, p = e.total.fontWeight, m = e.total.label, b = e.total.formatter(i)) : i.globals.series.length === 1 && (b = f(i.globals.series[0], i), m = i.globals.seriesNames[0]), m && (m = e.name.formatter(m, e.total.show, i)), e.name.show) {
                        var w = a.drawText({
                            x: h,
                            y: c + parseFloat(e.name.offsetY),
                            text: m,
                            textAnchor: "middle",
                            foreColor: n,
                            fontSize: d,
                            fontWeight: p,
                            fontFamily: g
                        });
                        w.node.classList.add("apexcharts-datalabel-label"), s.add(w);
                    }
                    if (e.value.show) {
                        var A = e.name.show ? parseFloat(e.value.offsetY) + 16 : e.value.offsetY, l = a.drawText({
                            x: h,
                            y: c + A,
                            text: b,
                            textAnchor: "middle",
                            foreColor: o,
                            fontWeight: e.value.fontWeight,
                            fontSize: e.value.fontSize,
                            fontFamily: e.value.fontFamily
                        });
                        l.node.classList.add("apexcharts-datalabel-value"), s.add(l);
                    }
                    return s;
                }
            },
            {
                key: "printInnerLabels",
                value: function(e, t, i, a) {
                    var s, r = this.w;
                    a ? s = e.name.color === void 0 ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : e.name.color : r.globals.series.length > 1 && e.total.show && (s = e.total.color);
                    var n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                    i = (0, e.value.formatter)(i, r), a || typeof e.total.formatter != "function" || (i = e.total.formatter(r));
                    var h = t === e.total.label;
                    t = e.name.formatter(t, h, r), n !== null && (n.textContent = t), o !== null && (o.textContent = i), n !== null && (n.style.fill = s);
                }
            },
            {
                key: "printDataLabelsInner",
                value: function(e, t) {
                    var i = this.w, a = e.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(e.parentNode.getAttribute("rel"), 10) - 1];
                    i.globals.series.length > 1 && this.printInnerLabels(t, s, a, e);
                    var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                    r !== null && (r.style.opacity = 1);
                }
            },
            {
                key: "drawSpokes",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                    if (s.strokeWidth !== 0) {
                        for(var r = [], n = 360 / i.globals.series.length, o = 0; o < i.globals.series.length; o++)r.push(P.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + n * o));
                        r.forEach(function(h, c) {
                            var d = a.drawLine(h.x, h.y, t.centerX, t.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[c] : s.connectorColors);
                            e.add(d);
                        });
                    }
                }
            },
            {
                key: "revertDataLabelsInner",
                value: function(e, t, i) {
                    var a = this, s = this.w, r = s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"), n = !1, o = s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"), h = function(g) {
                        var p = g.makeSliceOut, f = g.printLabel;
                        Array.prototype.forEach.call(o, function(b) {
                            b.getAttribute("data:pieClicked") === "true" && (p && (n = !0), f && a.printDataLabelsInner(b, t));
                        });
                    };
                    if (h({
                        makeSliceOut: !0,
                        printLabel: !1
                    }), t.total.show && s.globals.series.length > 1) n && !t.total.showAlways ? h({
                        makeSliceOut: !1,
                        printLabel: !0
                    }) : this.printInnerLabels(t, t.total.label, t.total.formatter(s));
                    else if (h({
                        makeSliceOut: !1,
                        printLabel: !0
                    }), !n) {
                        if (s.globals.selectedDataPoints.length && s.globals.series.length > 1) {
                            if (s.globals.selectedDataPoints[0].length > 0) {
                                var c = s.globals.selectedDataPoints[0], d = s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(c));
                                this.printDataLabelsInner(d, t);
                            } else r && s.globals.selectedDataPoints.length && s.globals.selectedDataPoints[0].length === 0 && (r.style.opacity = 0);
                        } else r && s.globals.series.length > 1 && (r.style.opacity = 0);
                    }
                }
            }
        ]), y;
    }(), Ft = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
            var t = this.w;
            this.graphics = new M(this.ctx), this.lineColorArr = t.globals.stroke.colors !== void 0 ? t.globals.stroke.colors : t.globals.colors, this.defaultSize = t.globals.svgHeight < t.globals.svgWidth ? t.globals.gridHeight + 1.5 * t.globals.goldenPadding : t.globals.gridWidth, this.isLog = t.config.yaxis[0].logarithmic, this.coreUtils = new q(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(t.globals.maxY, 0) : t.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : t.globals.minY, this.polygons = t.config.plotOptions.radar.polygons, this.strokeWidth = t.config.stroke.show ? t.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - t.config.chart.dropShadow.blur, t.config.xaxis.labels.show && (this.size = this.size - t.globals.xAxisLabelsWidth / 1.75), t.config.plotOptions.radar.size !== void 0 && (this.size = t.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this, i = this.w, a = new ae(this.ctx), s = [], r = new ye(this.ctx);
                    e.length && (this.dataPointsLen = e[i.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                    var n = i.globals.gridWidth / 2, o = i.globals.gridHeight / 2, h = n + i.config.plotOptions.radar.offsetX, c = o + i.config.plotOptions.radar.offsetY, d = this.graphics.group({
                        class: "apexcharts-radar-series apexcharts-plot-series",
                        transform: "translate(".concat(h || 0, ", ").concat(c || 0, ")")
                    }), g = [], p = null, f = null;
                    if (this.yaxisLabels = this.graphics.group({
                        class: "apexcharts-yaxis"
                    }), e.forEach(function(m, w) {
                        var A = m.length === i.globals.dataPoints, l = t.graphics.group().attr({
                            class: "apexcharts-series",
                            "data:longestSeries": A,
                            seriesName: P.escapeString(i.globals.seriesNames[w]),
                            rel: w + 1,
                            "data:realIndex": w
                        });
                        t.dataRadiusOfPercent[w] = [], t.dataRadius[w] = [], t.angleArr[w] = [], m.forEach(function(T, E) {
                            var R = Math.abs(t.maxValue - t.minValue);
                            T += Math.abs(t.minValue), t.isLog && (T = t.coreUtils.getLogVal(T, 0)), t.dataRadiusOfPercent[w][E] = T / R, t.dataRadius[w][E] = t.dataRadiusOfPercent[w][E] * t.size, t.angleArr[w][E] = E * t.disAngle;
                        }), g = t.getDataPointsPos(t.dataRadius[w], t.angleArr[w]);
                        var u = t.createPaths(g, {
                            x: 0,
                            y: 0
                        });
                        p = t.graphics.group({
                            class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                        }), f = t.graphics.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": w
                        }), i.globals.delayedElements.push({
                            el: p.node,
                            index: w
                        });
                        var x = {
                            i: w,
                            realIndex: w,
                            animationDelay: w,
                            initialSpeed: i.config.chart.animations.speed,
                            dataChangeSpeed: i.config.chart.animations.dynamicAnimation.speed,
                            className: "apexcharts-radar",
                            shouldClipToGrid: !1,
                            bindEventsOnPaths: !1,
                            stroke: i.globals.stroke.colors[w],
                            strokeLineCap: i.config.stroke.lineCap
                        }, v = null;
                        i.globals.previousPaths.length > 0 && (v = t.getPreviousPath(w));
                        for(var k = 0; k < u.linePathsTo.length; k++){
                            var S = t.graphics.renderPaths(X(X({}, x), {}, {
                                pathFrom: v === null ? u.linePathsFrom[k] : v,
                                pathTo: u.linePathsTo[k],
                                strokeWidth: Array.isArray(t.strokeWidth) ? t.strokeWidth[w] : t.strokeWidth,
                                fill: "none",
                                drawShadow: !1
                            }));
                            l.add(S);
                            var C = a.fillPath({
                                seriesNumber: w
                            }), L = t.graphics.renderPaths(X(X({}, x), {}, {
                                pathFrom: v === null ? u.areaPathsFrom[k] : v,
                                pathTo: u.areaPathsTo[k],
                                strokeWidth: 0,
                                fill: C,
                                drawShadow: !1
                            }));
                            if (i.config.chart.dropShadow.enabled) {
                                var I = new Z(t.ctx), z = i.config.chart.dropShadow;
                                I.dropShadow(L, Object.assign({}, z, {
                                    noUserSpaceOnUse: !0
                                }), w);
                            }
                            l.add(L);
                        }
                        m.forEach(function(T, E) {
                            var R = new Pe(t.ctx).getMarkerConfig({
                                cssClass: "apexcharts-marker",
                                seriesIndex: w,
                                dataPointIndex: E
                            }), O = t.graphics.drawMarker(g[E].x, g[E].y, R);
                            O.attr("rel", E), O.attr("j", E), O.attr("index", w), O.node.setAttribute("default-marker-size", R.pSize);
                            var D = t.graphics.group({
                                class: "apexcharts-series-markers"
                            });
                            D && D.add(O), p.add(D), l.add(p);
                            var W = i.config.dataLabels;
                            if (W.enabled) {
                                var N = W.formatter(i.globals.series[w][E], {
                                    seriesIndex: w,
                                    dataPointIndex: E,
                                    w: i
                                });
                                r.plotDataLabelsText({
                                    x: g[E].x,
                                    y: g[E].y,
                                    text: N,
                                    textAnchor: "middle",
                                    i: w,
                                    j: w,
                                    parent: f,
                                    offsetCorrection: !1,
                                    dataLabelsConfig: X({}, W)
                                });
                            }
                            l.add(f);
                        }), s.push(l);
                    }), this.drawPolygons({
                        parent: d
                    }), i.config.xaxis.labels.show) {
                        var b = this.drawXAxisTexts();
                        d.add(b);
                    }
                    return s.forEach(function(m) {
                        d.add(m);
                    }), d.add(this.yaxisLabels), d;
                }
            },
            {
                key: "drawPolygons",
                value: function(e) {
                    for(var t = this, i = this.w, a = e.parent, s = new nt(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), n = r.length, o = [], h = this.size / (n - 1), c = 0; c < n; c++)o[c] = h * c;
                    o.reverse();
                    var d = [], g = [];
                    o.forEach(function(p, f) {
                        var b = P.getPolygonPos(p, t.dataPointsLen), m = "";
                        b.forEach(function(w, A) {
                            if (f === 0) {
                                var l = t.graphics.drawLine(w.x, w.y, 0, 0, Array.isArray(t.polygons.connectorColors) ? t.polygons.connectorColors[A] : t.polygons.connectorColors);
                                g.push(l);
                            }
                            A === 0 && t.yaxisLabelsTextsPos.push({
                                x: w.x,
                                y: w.y
                            }), m += w.x + "," + w.y + " ";
                        }), d.push(m);
                    }), d.forEach(function(p, f) {
                        var b = t.polygons.strokeColors, m = t.polygons.strokeWidth, w = t.graphics.drawPolygon(p, Array.isArray(b) ? b[f] : b, Array.isArray(m) ? m[f] : m, i.globals.radarPolygons.fill.colors[f]);
                        a.add(w);
                    }), g.forEach(function(p) {
                        a.add(p);
                    }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(p, f) {
                        var b = s.drawYAxisTexts(p.x, p.y, f, r[f]);
                        t.yaxisLabels.add(b);
                    });
                }
            },
            {
                key: "drawXAxisTexts",
                value: function() {
                    var e = this, t = this.w, i = t.config.xaxis.labels, a = this.graphics.group({
                        class: "apexcharts-xaxis"
                    }), s = P.getPolygonPos(this.size, this.dataPointsLen);
                    return t.globals.labels.forEach(function(r, n) {
                        var o = t.config.xaxis.labels.formatter, h = new ye(e.ctx);
                        if (s[n]) {
                            var c = e.getTextPos(s[n], e.size), d = o(r, {
                                seriesIndex: -1,
                                dataPointIndex: n,
                                w: t
                            });
                            h.plotDataLabelsText({
                                x: c.newX,
                                y: c.newY,
                                text: d,
                                textAnchor: c.textAnchor,
                                i: n,
                                j: n,
                                parent: a,
                                color: Array.isArray(i.style.colors) && i.style.colors[n] ? i.style.colors[n] : "#a8a8a8",
                                dataLabelsConfig: X({
                                    textAnchor: c.textAnchor,
                                    dropShadow: {
                                        enabled: !1
                                    }
                                }, i),
                                offsetCorrection: !1
                            });
                        }
                    }), a;
                }
            },
            {
                key: "createPaths",
                value: function(e, t) {
                    var i = this, a = [], s = [], r = [], n = [];
                    if (e.length) {
                        s = [
                            this.graphics.move(t.x, t.y)
                        ], n = [
                            this.graphics.move(t.x, t.y)
                        ];
                        var o = this.graphics.move(e[0].x, e[0].y), h = this.graphics.move(e[0].x, e[0].y);
                        e.forEach(function(c, d) {
                            o += i.graphics.line(c.x, c.y), h += i.graphics.line(c.x, c.y), d === e.length - 1 && (o += "Z", h += "Z");
                        }), a.push(o), r.push(h);
                    }
                    return {
                        linePathsFrom: s,
                        linePathsTo: a,
                        areaPathsFrom: n,
                        areaPathsTo: r
                    };
                }
            },
            {
                key: "getTextPos",
                value: function(e, t) {
                    var i = "middle", a = e.x, s = e.y;
                    return Math.abs(e.x) >= 10 ? e.x > 0 ? (i = "start", a += 10) : e.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(e.y) >= t - 10 && (e.y < 0 ? s -= 10 : e.y > 0 && (s += 10)), {
                        textAnchor: i,
                        newX: a,
                        newY: s
                    };
                }
            },
            {
                key: "getPreviousPath",
                value: function(e) {
                    for(var t = this.w, i = null, a = 0; a < t.globals.previousPaths.length; a++){
                        var s = t.globals.previousPaths[a];
                        s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(e, 10) && t.globals.previousPaths[a].paths[0] !== void 0 && (i = t.globals.previousPaths[a].paths[0].d);
                    }
                    return i;
                }
            },
            {
                key: "getDataPointsPos",
                value: function(e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.dataPointsLen;
                    e = e || [], t = t || [];
                    for(var a = [], s = 0; s < i; s++){
                        var r = {};
                        r.x = e[s] * Math.sin(t[s]), r.y = -e[s] * Math.cos(t[s]), a.push(r);
                    }
                    return a;
                }
            }
        ]), y;
    }(), Rt = function(y) {
        ge(t, ot);
        var e = ue(t);
        function t(i) {
            var a;
            F(this, t), (a = e.call(this, i)).ctx = i, a.w = i.w, a.animBeginArr = [
                0
            ], a.animDur = 0;
            var s = a.w;
            return a.startAngle = s.config.plotOptions.radialBar.startAngle, a.endAngle = s.config.plotOptions.radialBar.endAngle, a.totalAngle = Math.abs(s.config.plotOptions.radialBar.endAngle - s.config.plotOptions.radialBar.startAngle), a.trackStartAngle = s.config.plotOptions.radialBar.track.startAngle, a.trackEndAngle = s.config.plotOptions.radialBar.track.endAngle, a.barLabels = a.w.config.plotOptions.radialBar.barLabels, a.donutDataLabels = a.w.config.plotOptions.radialBar.dataLabels, a.radialDataLabels = a.donutDataLabels, a.trackStartAngle || (a.trackStartAngle = a.startAngle), a.trackEndAngle || (a.trackEndAngle = a.endAngle), a.endAngle === 360 && (a.endAngle = 359.99), a.margin = parseInt(s.config.plotOptions.radialBar.track.margin, 10), a.onBarLabelClick = a.onBarLabelClick.bind(ze(a)), a;
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i) {
                    var a = this.w, s = new M(this.ctx), r = s.group({
                        class: "apexcharts-radialbar"
                    });
                    if (a.globals.noData) return r;
                    var n = s.group(), o = this.defaultSize / 2, h = a.globals.gridWidth / 2, c = this.defaultSize / 2.05;
                    a.config.chart.sparkline.enabled || (c = c - a.config.stroke.width - a.config.chart.dropShadow.blur);
                    var d = a.globals.fill.colors;
                    if (a.config.plotOptions.radialBar.track.show) {
                        var g = this.drawTracks({
                            size: c,
                            centerX: h,
                            centerY: o,
                            colorArr: d,
                            series: i
                        });
                        n.add(g);
                    }
                    var p = this.drawArcs({
                        size: c,
                        centerX: h,
                        centerY: o,
                        colorArr: d,
                        series: i
                    }), f = 360;
                    a.config.plotOptions.radialBar.startAngle < 0 && (f = this.totalAngle);
                    var b = (360 - f) / 360;
                    if (a.globals.radialSize = c - c * b, this.radialDataLabels.value.show) {
                        var m = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                        a.globals.radialSize += m * b;
                    }
                    return n.add(p.g), a.config.plotOptions.radialBar.hollow.position === "front" && (p.g.add(p.elHollow), p.dataLabels && p.g.add(p.dataLabels)), r.add(n), r;
                }
            },
            {
                key: "drawTracks",
                value: function(i) {
                    var a = this.w, s = new M(this.ctx), r = s.group({
                        class: "apexcharts-tracks"
                    }), n = new Z(this.ctx), o = new ae(this.ctx), h = this.getStrokeWidth(i);
                    i.size = i.size - h / 2;
                    for(var c = 0; c < i.series.length; c++){
                        var d = s.group({
                            class: "apexcharts-radialbar-track apexcharts-track"
                        });
                        r.add(d), d.attr({
                            rel: c + 1
                        }), i.size = i.size - h - this.margin;
                        var g = a.config.plotOptions.radialBar.track, p = o.fillPath({
                            seriesNumber: 0,
                            size: i.size,
                            fillColors: Array.isArray(g.background) ? g.background[c] : g.background,
                            solid: !0
                        }), f = this.trackStartAngle, b = this.trackEndAngle;
                        Math.abs(b) + Math.abs(f) >= 360 && (b = 360 - Math.abs(this.startAngle) - 0.1);
                        var m = s.drawPath({
                            d: "",
                            stroke: p,
                            strokeWidth: h * parseInt(g.strokeWidth, 10) / 100,
                            fill: "none",
                            strokeOpacity: g.opacity,
                            classes: "apexcharts-radialbar-area"
                        });
                        if (g.dropShadow.enabled) {
                            var w = g.dropShadow;
                            n.dropShadow(m, w);
                        }
                        d.add(m), m.attr("id", "apexcharts-radialbarTrack-" + c), this.animatePaths(m, {
                            centerX: i.centerX,
                            centerY: i.centerY,
                            endAngle: b,
                            startAngle: f,
                            size: i.size,
                            i: c,
                            totalItems: 2,
                            animBeginArr: 0,
                            dur: 0,
                            isTrack: !0,
                            easing: a.globals.easing
                        });
                    }
                    return r;
                }
            },
            {
                key: "drawArcs",
                value: function(i) {
                    var a = this.w, s = new M(this.ctx), r = new ae(this.ctx), n = new Z(this.ctx), o = s.group(), h = this.getStrokeWidth(i);
                    i.size = i.size - h / 2;
                    var c = a.config.plotOptions.radialBar.hollow.background, d = i.size - h * i.series.length - this.margin * i.series.length - h * parseInt(a.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, g = d - a.config.plotOptions.radialBar.hollow.margin;
                    a.config.plotOptions.radialBar.hollow.image !== void 0 && (c = this.drawHollowImage(i, o, d, c));
                    var p = this.drawHollow({
                        size: g,
                        centerX: i.centerX,
                        centerY: i.centerY,
                        fill: c || "transparent"
                    });
                    if (a.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                        var f = a.config.plotOptions.radialBar.hollow.dropShadow;
                        n.dropShadow(p, f);
                    }
                    var b = 1;
                    !this.radialDataLabels.total.show && a.globals.series.length > 1 && (b = 0);
                    var m = null;
                    this.radialDataLabels.show && (m = this.renderInnerDataLabels(this.radialDataLabels, {
                        hollowSize: d,
                        centerX: i.centerX,
                        centerY: i.centerY,
                        opacity: b
                    })), a.config.plotOptions.radialBar.hollow.position === "back" && (o.add(p), m && o.add(m));
                    var w = !1;
                    a.config.plotOptions.radialBar.inverseOrder && (w = !0);
                    for(var A = w ? i.series.length - 1 : 0; w ? A >= 0 : A < i.series.length; w ? A-- : A++){
                        var l = s.group({
                            class: "apexcharts-series apexcharts-radial-series",
                            seriesName: P.escapeString(a.globals.seriesNames[A])
                        });
                        o.add(l), l.attr({
                            rel: A + 1,
                            "data:realIndex": A
                        }), this.ctx.series.addCollapsedClassToSeries(l, A), i.size = i.size - h - this.margin;
                        var u = r.fillPath({
                            seriesNumber: A,
                            size: i.size,
                            value: i.series[A]
                        }), x = this.startAngle, v = void 0, k = P.negToZero(i.series[A] > 100 ? 100 : i.series[A]) / 100, S = Math.round(this.totalAngle * k) + this.startAngle, C = void 0;
                        a.globals.dataChanged && (v = this.startAngle, C = Math.round(this.totalAngle * P.negToZero(a.globals.previousPaths[A]) / 100) + v), Math.abs(S) + Math.abs(x) >= 360 && (S -= 0.01), Math.abs(C) + Math.abs(v) >= 360 && (C -= 0.01);
                        var L = S - x, I = Array.isArray(a.config.stroke.dashArray) ? a.config.stroke.dashArray[A] : a.config.stroke.dashArray, z = s.drawPath({
                            d: "",
                            stroke: u,
                            strokeWidth: h,
                            fill: "none",
                            fillOpacity: a.config.fill.opacity,
                            classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + A,
                            strokeDashArray: I
                        });
                        if (M.setAttrs(z.node, {
                            "data:angle": L,
                            "data:value": i.series[A]
                        }), a.config.chart.dropShadow.enabled) {
                            var T = a.config.chart.dropShadow;
                            n.dropShadow(z, T, A);
                        }
                        if (n.setSelectionFilter(z, 0, A), this.addListeners(z, this.radialDataLabels), l.add(z), z.attr({
                            index: 0,
                            j: A
                        }), this.barLabels.enabled) {
                            var E = P.polarToCartesian(i.centerX, i.centerY, i.size, x), R = this.barLabels.formatter(a.globals.seriesNames[A], {
                                seriesIndex: A,
                                w: a
                            }), O = [
                                "apexcharts-radialbar-label"
                            ];
                            this.barLabels.onClick || O.push("apexcharts-no-click");
                            var D = this.barLabels.useSeriesColors ? a.globals.colors[A] : a.config.chart.foreColor;
                            D || (D = a.config.chart.foreColor);
                            var W = E.x - this.barLabels.margin, N = E.y, V = s.drawText({
                                x: W,
                                y: N,
                                text: R,
                                textAnchor: "end",
                                dominantBaseline: "middle",
                                fontFamily: this.barLabels.fontFamily,
                                fontWeight: this.barLabels.fontWeight,
                                fontSize: this.barLabels.fontSize,
                                foreColor: D,
                                cssClass: O.join(" ")
                            });
                            V.on("click", this.onBarLabelClick), V.attr({
                                rel: A + 1
                            }), x !== 0 && V.attr({
                                "transform-origin": "".concat(W, " ").concat(N),
                                transform: "rotate(".concat(x, " 0 0)")
                            }), l.add(V);
                        }
                        var j = 0;
                        !this.initialAnim || a.globals.resized || a.globals.dataChanged || (j = a.config.chart.animations.speed), a.globals.dataChanged && (j = a.config.chart.animations.dynamicAnimation.speed), this.animDur = j / (1.2 * i.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(z, {
                            centerX: i.centerX,
                            centerY: i.centerY,
                            endAngle: S,
                            startAngle: x,
                            prevEndAngle: C,
                            prevStartAngle: v,
                            size: i.size,
                            i: A,
                            totalItems: 2,
                            animBeginArr: this.animBeginArr,
                            dur: j,
                            shouldSetPrevPaths: !0,
                            easing: a.globals.easing
                        });
                    }
                    return {
                        g: o,
                        elHollow: p,
                        dataLabels: m
                    };
                }
            },
            {
                key: "drawHollow",
                value: function(i) {
                    var a = new M(this.ctx).drawCircle(2 * i.size);
                    return a.attr({
                        class: "apexcharts-radialbar-hollow",
                        cx: i.centerX,
                        cy: i.centerY,
                        r: i.size,
                        fill: i.fill
                    }), a;
                }
            },
            {
                key: "drawHollowImage",
                value: function(i, a, s, r) {
                    var n = this.w, o = new ae(this.ctx), h = P.randomId(), c = n.config.plotOptions.radialBar.hollow.image;
                    if (n.config.plotOptions.radialBar.hollow.imageClipped) o.clippedImgArea({
                        width: s,
                        height: s,
                        image: c,
                        patternID: "pattern".concat(n.globals.cuid).concat(h)
                    }), r = "url(#pattern".concat(n.globals.cuid).concat(h, ")");
                    else {
                        var d = n.config.plotOptions.radialBar.hollow.imageWidth, g = n.config.plotOptions.radialBar.hollow.imageHeight;
                        if (d === void 0 && g === void 0) {
                            var p = n.globals.dom.Paper.image(c).loaded(function(b) {
                                this.move(i.centerX - b.width / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetX, i.centerY - b.height / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetY);
                            });
                            a.add(p);
                        } else {
                            var f = n.globals.dom.Paper.image(c).loaded(function(b) {
                                this.move(i.centerX - d / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetX, i.centerY - g / 2 + n.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(d, g);
                            });
                            a.add(f);
                        }
                    }
                    return r;
                }
            },
            {
                key: "getStrokeWidth",
                value: function(i) {
                    var a = this.w;
                    return i.size * (100 - parseInt(a.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (i.series.length + 1) - this.margin;
                }
            },
            {
                key: "onBarLabelClick",
                value: function(i) {
                    var a = parseInt(i.target.getAttribute("rel"), 10) - 1, s = this.barLabels.onClick, r = this.w;
                    s && s(r.globals.seriesNames[a], {
                        w: r,
                        seriesIndex: a
                    });
                }
            }
        ]), t;
    }(), Ot = function(y) {
        ge(t, ke);
        var e = ue(t);
        function t() {
            return F(this, t), e.apply(this, arguments);
        }
        return Y(t, [
            {
                key: "draw",
                value: function(i, a) {
                    var s = this.w, r = new M(this.ctx);
                    this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = i, this.seriesRangeStart = s.globals.seriesRangeStart, this.seriesRangeEnd = s.globals.seriesRangeEnd, this.barHelpers.initVariables(i);
                    for(var n = r.group({
                        class: "apexcharts-rangebar-series apexcharts-plot-series"
                    }), o = 0; o < i.length; o++){
                        var h, c, d, g, p = void 0, f = void 0, b = s.globals.comboCharts ? a[o] : o, m = r.group({
                            class: "apexcharts-series",
                            seriesName: P.escapeString(s.globals.seriesNames[b]),
                            rel: o + 1,
                            "data:realIndex": b
                        });
                        this.ctx.series.addCollapsedClassToSeries(m, b), i[o].length > 0 && (this.visibleI = this.visibleI + 1);
                        var w = 0, A = 0;
                        this.yRatio.length > 1 && (this.yaxisIndex = b);
                        var l = this.barHelpers.initialPositions();
                        f = l.y, g = l.zeroW, p = l.x, A = l.barWidth, w = l.barHeight, h = l.xDivision, c = l.yDivision, d = l.zeroH;
                        for(var u = r.group({
                            class: "apexcharts-datalabels",
                            "data:realIndex": b
                        }), x = r.group({
                            class: "apexcharts-rangebar-goals-markers"
                        }), v = 0; v < s.globals.dataPoints; v++){
                            var k, S = this.barHelpers.getStrokeWidth(o, v, b), C = this.seriesRangeStart[o][v], L = this.seriesRangeEnd[o][v], I = null, z = null, T = null, E = {
                                x: p,
                                y: f,
                                strokeWidth: S,
                                elSeries: m
                            }, R = this.seriesLen;
                            if (s.config.plotOptions.bar.rangeBarGroupRows && (R = 1), s.config.series[o].data[v] === void 0) break;
                            if (this.isHorizontal) {
                                T = f + w * this.visibleI;
                                var O = (c - w * R) / 2;
                                if (s.config.series[o].data[v].x) {
                                    var D = this.detectOverlappingBars({
                                        i: o,
                                        j: v,
                                        barYPosition: T,
                                        srty: O,
                                        barHeight: w,
                                        yDivision: c,
                                        initPositions: l
                                    });
                                    w = D.barHeight, T = D.barYPosition;
                                }
                                A = (I = this.drawRangeBarPaths(X({
                                    indexes: {
                                        i: o,
                                        j: v,
                                        realIndex: b
                                    },
                                    barHeight: w,
                                    barYPosition: T,
                                    zeroW: g,
                                    yDivision: c,
                                    y1: C,
                                    y2: L
                                }, E))).barWidth;
                            } else {
                                s.globals.isXNumeric && (p = (s.globals.seriesX[o][v] - s.globals.minX) / this.xRatio - A / 2), z = p + A * this.visibleI;
                                var W = (h - A * R) / 2;
                                if (s.config.series[o].data[v].x) {
                                    var N = this.detectOverlappingBars({
                                        i: o,
                                        j: v,
                                        barXPosition: z,
                                        srtx: W,
                                        barWidth: A,
                                        xDivision: h,
                                        initPositions: l
                                    });
                                    A = N.barWidth, z = N.barXPosition;
                                }
                                w = (I = this.drawRangeColumnPaths(X({
                                    indexes: {
                                        i: o,
                                        j: v,
                                        realIndex: b
                                    },
                                    barWidth: A,
                                    barXPosition: z,
                                    zeroH: d,
                                    xDivision: h
                                }, E))).barHeight;
                            }
                            var V = this.barHelpers.drawGoalLine({
                                barXPosition: I.barXPosition,
                                barYPosition: T,
                                goalX: I.goalX,
                                goalY: I.goalY,
                                barHeight: w,
                                barWidth: A
                            });
                            V && x.add(V), f = I.y, p = I.x;
                            var j = this.barHelpers.getPathFillColor(i, o, v, b), se = s.globals.stroke.colors[b];
                            this.renderSeries((ee(k = {
                                realIndex: b,
                                pathFill: j,
                                lineFill: se,
                                j: v,
                                i: o,
                                x: p,
                                y: f,
                                y1: C,
                                y2: L,
                                pathFrom: I.pathFrom,
                                pathTo: I.pathTo,
                                strokeWidth: S,
                                elSeries: m,
                                series: i,
                                barHeight: w,
                                barWidth: A,
                                barXPosition: z,
                                barYPosition: T
                            }, "barWidth", A), ee(k, "elDataLabelsWrap", u), ee(k, "elGoalsMarkers", x), ee(k, "visibleSeries", this.visibleI), ee(k, "type", "rangebar"), k));
                        }
                        n.add(m);
                    }
                    return n;
                }
            },
            {
                key: "detectOverlappingBars",
                value: function(i) {
                    var a = i.i, s = i.j, r = i.barYPosition, n = i.barXPosition, o = i.srty, h = i.srtx, c = i.barHeight, d = i.barWidth, g = i.yDivision, p = i.xDivision, f = i.initPositions, b = this.w, m = [], w = b.config.series[a].data[s].rangeName, A = b.config.series[a].data[s].x, l = Array.isArray(A) ? A.join(" ") : A, u = b.globals.labels.map(function(v) {
                        return Array.isArray(v) ? v.join(" ") : v;
                    }).indexOf(l), x = b.globals.seriesRange[a].findIndex(function(v) {
                        return v.x === l && v.overlaps.length > 0;
                    });
                    return this.isHorizontal ? (r = b.config.plotOptions.bar.rangeBarGroupRows ? o + g * u : o + c * this.visibleI + g * u, x > -1 && !b.config.plotOptions.bar.rangeBarOverlap && (m = b.globals.seriesRange[a][x].overlaps).indexOf(w) > -1 && (r = (c = f.barHeight / m.length) * this.visibleI + g * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + c * (this.visibleI + m.indexOf(w)) + g * u)) : (u > -1 && (n = b.config.plotOptions.bar.rangeBarGroupRows ? h + p * u : h + d * this.visibleI + p * u), x > -1 && !b.config.plotOptions.bar.rangeBarOverlap && (m = b.globals.seriesRange[a][x].overlaps).indexOf(w) > -1 && (n = (d = f.barWidth / m.length) * this.visibleI + p * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + d * (this.visibleI + m.indexOf(w)) + p * u)), {
                        barYPosition: r,
                        barXPosition: n,
                        barHeight: c,
                        barWidth: d
                    };
                }
            },
            {
                key: "drawRangeColumnPaths",
                value: function(i) {
                    var a = i.indexes, s = i.x, r = i.xDivision, n = i.barWidth, o = i.barXPosition, h = i.zeroH, c = this.w, d = a.i, g = a.j, p = this.yRatio[this.yaxisIndex], f = a.realIndex, b = this.getRangeValue(f, g), m = Math.min(b.start, b.end), w = Math.max(b.start, b.end);
                    this.series[d][g] === void 0 || this.series[d][g] === null ? m = h : (m = h - m / p, w = h - w / p);
                    var A = Math.abs(w - m), l = this.barHelpers.getColumnPaths({
                        barXPosition: o,
                        barWidth: n,
                        y1: m,
                        y2: w,
                        strokeWidth: this.strokeWidth,
                        series: this.seriesRangeEnd,
                        realIndex: a.realIndex,
                        i: f,
                        j: g,
                        w: c
                    });
                    if (c.globals.isXNumeric) {
                        var u = this.getBarXForNumericXAxis({
                            x: s,
                            j: g,
                            realIndex: f,
                            barWidth: n
                        });
                        s = u.x, o = u.barXPosition;
                    } else s += r;
                    return {
                        pathTo: l.pathTo,
                        pathFrom: l.pathFrom,
                        barHeight: A,
                        x: s,
                        y: w,
                        goalY: this.barHelpers.getGoalValues("y", null, h, d, g),
                        barXPosition: o
                    };
                }
            },
            {
                key: "drawRangeBarPaths",
                value: function(i) {
                    var a = i.indexes, s = i.y, r = i.y1, n = i.y2, o = i.yDivision, h = i.barHeight, c = i.barYPosition, d = i.zeroW, g = this.w, p = d + r / this.invertedYRatio, f = d + n / this.invertedYRatio, b = Math.abs(f - p), m = this.barHelpers.getBarpaths({
                        barYPosition: c,
                        barHeight: h,
                        x1: p,
                        x2: f,
                        strokeWidth: this.strokeWidth,
                        series: this.seriesRangeEnd,
                        i: a.realIndex,
                        realIndex: a.realIndex,
                        j: a.j,
                        w: g
                    });
                    return g.globals.isXNumeric || (s += o), {
                        pathTo: m.pathTo,
                        pathFrom: m.pathFrom,
                        barWidth: b,
                        x: f,
                        goalX: this.barHelpers.getGoalValues("x", d, null, a.realIndex, a.j),
                        y: s
                    };
                }
            },
            {
                key: "getRangeValue",
                value: function(i, a) {
                    var s = this.w;
                    return {
                        start: s.globals.seriesRangeStart[i][a],
                        end: s.globals.seriesRangeEnd[i][a]
                    };
                }
            }
        ]), t;
    }(), Ht = function() {
        function y(e) {
            F(this, y), this.w = e.w, this.lineCtx = e;
        }
        return Y(y, [
            {
                key: "sameValueSeriesFix",
                value: function(e, t) {
                    var i = this.w;
                    if ((i.config.fill.type === "gradient" || i.config.fill.type[e] === "gradient") && new q(this.lineCtx.ctx, i).seriesHaveSameValues(e)) {
                        var a = t[e].slice();
                        a[a.length - 1] = a[a.length - 1] + 1e-6, t[e] = a;
                    }
                    return t;
                }
            },
            {
                key: "calculatePoints",
                value: function(e) {
                    var t = e.series, i = e.realIndex, a = e.x, s = e.y, r = e.i, n = e.j, o = e.prevY, h = this.w, c = [], d = [];
                    if (n === 0) {
                        var g = this.lineCtx.categoryAxisCorrection + h.config.markers.offsetX;
                        h.globals.isXNumeric && (g = (h.globals.seriesX[i][0] - h.globals.minX) / this.lineCtx.xRatio + h.config.markers.offsetX), c.push(g), d.push(P.isNumber(t[r][0]) ? o + h.config.markers.offsetY : null), c.push(a + h.config.markers.offsetX), d.push(P.isNumber(t[r][n + 1]) ? s + h.config.markers.offsetY : null);
                    } else c.push(a + h.config.markers.offsetX), d.push(P.isNumber(t[r][n + 1]) ? s + h.config.markers.offsetY : null);
                    return {
                        x: c,
                        y: d
                    };
                }
            },
            {
                key: "checkPreviousPaths",
                value: function(e) {
                    for(var t = e.pathFromLine, i = e.pathFromArea, a = e.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                        var n = s.globals.previousPaths[r];
                        (n.type === "line" || n.type === "area") && n.paths.length > 0 && parseInt(n.realIndex, 10) === parseInt(a, 10) && (n.type === "line" ? (this.lineCtx.appendPathFrom = !1, t = s.globals.previousPaths[r].paths[0].d) : n.type === "area" && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (t = s.globals.previousPaths[r].paths[1].d)));
                    }
                    return {
                        pathFromLine: t,
                        pathFromArea: i
                    };
                }
            },
            {
                key: "determineFirstPrevY",
                value: function(e) {
                    var t, i, a = e.i, s = e.series, r = e.prevY, n = e.lineYPosition, o = this.w, h = o.config.chart.stacked && !o.globals.comboCharts || o.config.chart.stacked && o.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || ((t = this.w.config.series[a]) === null || t === void 0 ? void 0 : t.type) === "bar");
                    if (((i = s[a]) === null || i === void 0 ? void 0 : i[0]) !== void 0) r = (n = h && a > 0 ? this.lineCtx.prevSeriesY[a - 1][0] : this.lineCtx.zeroY) - s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                    else if (h && a > 0 && s[a][0] === void 0) {
                        for(var c = a - 1; c >= 0; c--)if (s[c][0] !== null && s[c][0] !== void 0) {
                            r = n = this.lineCtx.prevSeriesY[c][0];
                            break;
                        }
                    }
                    return {
                        prevY: r,
                        lineYPosition: n
                    };
                }
            }
        ]), y;
    }(), Dt = function(y) {
        for(var e, t, i, a, s = function(c) {
            for(var d = [], g = c[0], p = c[1], f = d[0] = Ve(g, p), b = 1, m = c.length - 1; b < m; b++)g = p, p = c[b + 1], d[b] = 0.5 * (f + (f = Ve(g, p)));
            return d[b] = f, d;
        }(y), r = y.length - 1, n = [], o = 0; o < r; o++)i = Ve(y[o], y[o + 1]), Math.abs(i) < 1e-6 ? s[o] = s[o + 1] = 0 : (a = (e = s[o] / i) * e + (t = s[o + 1] / i) * t) > 9 && (a = 3 * i / Math.sqrt(a), s[o] = a * e, s[o + 1] = a * t);
        for(var h = 0; h <= r; h++)a = (y[Math.min(r, h + 1)][0] - y[Math.max(0, h - 1)][0]) / (6 * (1 + s[h] * s[h])), n.push([
            a || 0,
            s[h] * a || 0
        ]);
        return n;
    }, Ge = function(y) {
        for(var e = "", t = 0; t < y.length; t++){
            var i = y[t], a = i.length;
            a > 4 ? (e += "C".concat(i[0], ", ").concat(i[1]), e += ", ".concat(i[2], ", ").concat(i[3]), e += ", ".concat(i[4], ", ").concat(i[5])) : a > 2 && (e += "S".concat(i[0], ", ").concat(i[1]), e += ", ".concat(i[2], ", ").concat(i[3]));
        }
        return e;
    }, lt = function(y) {
        var e = Dt(y), t = y[1], i = y[0], a = [], s = e[1], r = e[0];
        a.push(i, [
            i[0] + r[0],
            i[1] + r[1],
            t[0] - s[0],
            t[1] - s[1],
            t[0],
            t[1]
        ]);
        for(var n = 2, o = e.length; n < o; n++){
            var h = y[n], c = e[n];
            a.push([
                h[0] - c[0],
                h[1] - c[1],
                h[0],
                h[1]
            ]);
        }
        return a;
    };
    function Ve(y, e) {
        return (e[1] - y[1]) / (e[0] - y[0]);
    }
    var je = function() {
        function y(e, t, i) {
            F(this, y), this.ctx = e, this.w = e.w, this.xyRatios = t, this.pointsChart = !(this.w.config.chart.type !== "bubble" && this.w.config.chart.type !== "scatter") || i, this.scatter = new $e(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new Ht(this), this.markers = new Pe(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e, t, i, a) {
                    var s, r = this.w, n = new M(this.ctx), o = r.globals.comboCharts ? t : r.config.chart.type, h = n.group({
                        class: "apexcharts-".concat(o, "-series apexcharts-plot-series")
                    }), c = new q(this.ctx, r);
                    this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, e = c.getLogSeries(e), this.yRatio = c.getLogYRatios(this.yRatio);
                    for(var d = [], g = 0; g < e.length; g++){
                        e = this.lineHelpers.sameValueSeriesFix(g, e);
                        var p = r.globals.comboCharts ? i[g] : g;
                        this._initSerieVariables(e, g, p);
                        var f = [], b = [], m = [], w = r.globals.padHorizontal + this.categoryAxisCorrection;
                        this.ctx.series.addCollapsedClassToSeries(this.elSeries, p), r.globals.isXNumeric && r.globals.seriesX.length > 0 && (w = (r.globals.seriesX[p][0] - r.globals.minX) / this.xRatio), m.push(w);
                        var A, l = w, u = void 0, x = l, v = this.zeroY, k = this.zeroY;
                        v = this.lineHelpers.determineFirstPrevY({
                            i: g,
                            series: e,
                            prevY: v,
                            lineYPosition: 0
                        }).prevY, r.config.stroke.curve === "monotonCubic" && e[g][0] === null ? f.push(null) : f.push(v), A = v, o === "rangeArea" && (u = k = this.lineHelpers.determineFirstPrevY({
                            i: g,
                            series: a,
                            prevY: k,
                            lineYPosition: 0
                        }).prevY, b.push(k));
                        var S = {
                            type: o,
                            series: e,
                            realIndex: p,
                            i: g,
                            x: w,
                            y: 1,
                            pX: l,
                            pY: A,
                            pathsFrom: this._calculatePathsFrom({
                                type: o,
                                series: e,
                                i: g,
                                realIndex: p,
                                prevX: x,
                                prevY: v,
                                prevY2: k
                            }),
                            linePaths: [],
                            areaPaths: [],
                            seriesIndex: i,
                            lineYPosition: 0,
                            xArrj: m,
                            yArrj: f,
                            y2Arrj: b,
                            seriesRangeEnd: a
                        }, C = this._iterateOverDataPoints(X(X({}, S), {}, {
                            iterations: o === "rangeArea" ? e[g].length - 1 : void 0,
                            isRangeStart: !0
                        }));
                        if (o === "rangeArea") {
                            var L = this._calculatePathsFrom({
                                series: a,
                                i: g,
                                realIndex: p,
                                prevX: x,
                                prevY: k
                            }), I = this._iterateOverDataPoints(X(X({}, S), {}, {
                                series: a,
                                pY: u,
                                pathsFrom: L,
                                iterations: a[g].length - 1,
                                isRangeStart: !1
                            }));
                            C.linePaths[0] = I.linePath + C.linePath, C.pathFromLine = I.pathFromLine + C.pathFromLine;
                        }
                        this._handlePaths({
                            type: o,
                            realIndex: p,
                            i: g,
                            paths: C
                        }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), d.push(this.elSeries);
                    }
                    if (((s = r.config.series[0]) === null || s === void 0 ? void 0 : s.zIndex) !== void 0 && d.sort(function(E, R) {
                        return Number(E.node.getAttribute("zIndex")) - Number(R.node.getAttribute("zIndex"));
                    }), r.config.chart.stacked) for(var z = d.length; z > 0; z--)h.add(d[z - 1]);
                    else for(var T = 0; T < d.length; T++)h.add(d[T]);
                    return h;
                }
            },
            {
                key: "_initSerieVariables",
                value: function(e, t, i) {
                    var a = this.w, s = new M(this.ctx);
                    this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - (a.config.xaxis.tickPlacement === "on" ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || a.config.plotOptions.area.fillTo === "end") && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                        class: "apexcharts-series",
                        zIndex: a.config.series[i].zIndex !== void 0 ? a.config.series[i].zIndex : i,
                        seriesName: P.escapeString(a.globals.seriesNames[i])
                    }), this.elPointsMain = s.group({
                        class: "apexcharts-series-markers-wrap",
                        "data:realIndex": i
                    }), this.elDataLabelsWrap = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": i
                    });
                    var r = e[t].length === a.globals.dataPoints;
                    this.elSeries.attr({
                        "data:longestSeries": r,
                        rel: t + 1,
                        "data:realIndex": i
                    }), this.appendPathFrom = !0;
                }
            },
            {
                key: "_calculatePathsFrom",
                value: function(e) {
                    var t, i, a, s, r = e.type, n = e.series, o = e.i, h = e.realIndex, c = e.prevX, d = e.prevY, g = e.prevY2, p = this.w, f = new M(this.ctx);
                    if (n[o][0] === null) {
                        for(var b = 0; b < n[o].length; b++)if (n[o][b] !== null) {
                            c = this.xDivision * b, d = this.zeroY - n[o][b] / this.yRatio[this.yaxisIndex], t = f.move(c, d), i = f.move(c, this.areaBottomY);
                            break;
                        }
                    } else t = f.move(c, d), r === "rangeArea" && (t = f.move(c, g) + f.line(c, d)), i = f.move(c, this.areaBottomY) + f.line(c, d);
                    if (a = f.move(-1, this.zeroY) + f.line(-1, this.zeroY), s = f.move(-1, this.zeroY) + f.line(-1, this.zeroY), p.globals.previousPaths.length > 0) {
                        var m = this.lineHelpers.checkPreviousPaths({
                            pathFromLine: a,
                            pathFromArea: s,
                            realIndex: h
                        });
                        a = m.pathFromLine, s = m.pathFromArea;
                    }
                    return {
                        prevX: c,
                        prevY: d,
                        linePath: t,
                        areaPath: i,
                        pathFromLine: a,
                        pathFromArea: s
                    };
                }
            },
            {
                key: "_handlePaths",
                value: function(e) {
                    var t = e.type, i = e.realIndex, a = e.i, s = e.paths, r = this.w, n = new M(this.ctx), o = new ae(this.ctx);
                    this.prevSeriesY.push(s.yArrj), r.globals.seriesXvalues[i] = s.xArrj, r.globals.seriesYvalues[i] = s.yArrj;
                    var h = r.config.forecastDataPoints;
                    if (h.count > 0 && t !== "rangeArea") {
                        var c = r.globals.seriesXvalues[i][r.globals.seriesXvalues[i].length - h.count - 1], d = n.drawRect(c, 0, r.globals.gridWidth, r.globals.gridHeight, 0);
                        r.globals.dom.elForecastMask.appendChild(d.node);
                        var g = n.drawRect(0, 0, c, r.globals.gridHeight, 0);
                        r.globals.dom.elNonForecastMask.appendChild(g.node);
                    }
                    this.pointsChart || r.globals.delayedElements.push({
                        el: this.elPointsMain.node,
                        index: i
                    });
                    var p = {
                        i: a,
                        realIndex: i,
                        animationDelay: a,
                        initialSpeed: r.config.chart.animations.speed,
                        dataChangeSpeed: r.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-".concat(t)
                    };
                    if (t === "area") for(var f = o.fillPath({
                        seriesNumber: i
                    }), b = 0; b < s.areaPaths.length; b++){
                        var m = n.renderPaths(X(X({}, p), {}, {
                            pathFrom: s.pathFromArea,
                            pathTo: s.areaPaths[b],
                            stroke: "none",
                            strokeWidth: 0,
                            strokeLineCap: null,
                            fill: f
                        }));
                        this.elSeries.add(m);
                    }
                    if (r.config.stroke.show && !this.pointsChart) {
                        var w = null;
                        if (t === "line") w = o.fillPath({
                            seriesNumber: i,
                            i: a
                        });
                        else if (r.config.stroke.fill.type === "solid") w = r.globals.stroke.colors[i];
                        else {
                            var A = r.config.fill;
                            r.config.fill = r.config.stroke.fill, w = o.fillPath({
                                seriesNumber: i,
                                i: a
                            }), r.config.fill = A;
                        }
                        for(var l = 0; l < s.linePaths.length; l++){
                            var u = w;
                            t === "rangeArea" && (u = o.fillPath({
                                seriesNumber: i
                            }));
                            var x = X(X({}, p), {}, {
                                pathFrom: s.pathFromLine,
                                pathTo: s.linePaths[l],
                                stroke: w,
                                strokeWidth: this.strokeWidth,
                                strokeLineCap: r.config.stroke.lineCap,
                                fill: t === "rangeArea" ? u : "none"
                            }), v = n.renderPaths(x);
                            if (this.elSeries.add(v), v.attr("fill-rule", "evenodd"), h.count > 0 && t !== "rangeArea") {
                                var k = n.renderPaths(x);
                                k.node.setAttribute("stroke-dasharray", h.dashArray), h.strokeWidth && k.node.setAttribute("stroke-width", h.strokeWidth), this.elSeries.add(k), k.attr("clip-path", "url(#forecastMask".concat(r.globals.cuid, ")")), v.attr("clip-path", "url(#nonForecastMask".concat(r.globals.cuid, ")"));
                            }
                        }
                    }
                }
            },
            {
                key: "_iterateOverDataPoints",
                value: function(e) {
                    var t, i = this, a = e.type, s = e.series, r = e.iterations, n = e.realIndex, o = e.i, h = e.x, c = e.y, d = e.pX, g = e.pY, p = e.pathsFrom, f = e.linePaths, b = e.areaPaths, m = e.seriesIndex, w = e.lineYPosition, A = e.xArrj, l = e.yArrj, u = e.y2Arrj, x = e.isRangeStart, v = e.seriesRangeEnd, k = this.w, S = new M(this.ctx), C = this.yRatio, L = p.prevY, I = p.linePath, z = p.areaPath, T = p.pathFromLine, E = p.pathFromArea, R = P.isNumber(k.globals.minYArr[n]) ? k.globals.minYArr[n] : k.globals.minY;
                    r || (r = k.globals.dataPoints > 1 ? k.globals.dataPoints - 1 : k.globals.dataPoints);
                    for(var O = function(le, he) {
                        return he - le / C[i.yaxisIndex] + 2 * (i.isReversed ? le / C[i.yaxisIndex] : 0);
                    }, D = c, W = k.config.chart.stacked && !k.globals.comboCharts || k.config.chart.stacked && k.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || ((t = this.w.config.series[n]) === null || t === void 0 ? void 0 : t.type) === "bar"), N = 0; N < r; N++){
                        var V = s[o][N + 1] === void 0 || s[o][N + 1] === null;
                        if (k.globals.isXNumeric) {
                            var j = k.globals.seriesX[n][N + 1];
                            k.globals.seriesX[n][N + 1] === void 0 && (j = k.globals.seriesX[n][r - 1]), h = (j - k.globals.minX) / this.xRatio;
                        } else h += this.xDivision;
                        W ? o > 0 && k.globals.collapsedSeries.length < k.config.series.length - 1 ? w = this.prevSeriesY[function(le) {
                            for(var he = le, $ = 0; $ < k.globals.series.length; $++)if (k.globals.collapsedSeriesIndices.indexOf(le) > -1) {
                                he--;
                                break;
                            }
                            return he >= 0 ? he : 0;
                        }(o - 1)][N + 1] : w = this.zeroY : w = this.zeroY, V ? c = O(R, w) : (c = O(s[o][N + 1], w), a === "rangeArea" && (D = O(v[o][N + 1], w))), A.push(h), V && k.config.stroke.curve === "smooth" ? l.push(null) : l.push(c), u.push(D);
                        var se = this.lineHelpers.calculatePoints({
                            series: s,
                            x: h,
                            y: c,
                            realIndex: n,
                            i: o,
                            j: N,
                            prevY: L
                        }), K = this._createPaths({
                            type: a,
                            series: s,
                            i: o,
                            realIndex: n,
                            j: N,
                            x: h,
                            y: c,
                            y2: D,
                            xArrj: A,
                            yArrj: l,
                            y2Arrj: u,
                            pX: d,
                            pY: g,
                            linePath: I,
                            areaPath: z,
                            linePaths: f,
                            areaPaths: b,
                            seriesIndex: m,
                            isRangeStart: x
                        });
                        b = K.areaPaths, f = K.linePaths, d = K.pX, g = K.pY, z = K.areaPath, I = K.linePath, !this.appendPathFrom || k.config.stroke.curve === "monotoneCubic" && a === "rangeArea" || (T += S.line(h, this.zeroY), E += S.line(h, this.zeroY)), this.handleNullDataPoints(s, se, o, N, n), this._handleMarkersAndLabels({
                            type: a,
                            pointsPos: se,
                            i: o,
                            j: N,
                            realIndex: n,
                            isRangeStart: x
                        });
                    }
                    return {
                        yArrj: l,
                        xArrj: A,
                        pathFromArea: E,
                        areaPaths: b,
                        pathFromLine: T,
                        linePaths: f,
                        linePath: I,
                        areaPath: z
                    };
                }
            },
            {
                key: "_handleMarkersAndLabels",
                value: function(e) {
                    var t = e.type, i = e.pointsPos, a = e.isRangeStart, s = e.i, r = e.j, n = e.realIndex, o = this.w, h = new ye(this.ctx);
                    if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                        realIndex: n,
                        pointsPos: i,
                        zRatio: this.zRatio,
                        elParent: this.elPointsMain
                    });
                    else {
                        o.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                        var c = this.markers.plotChartMarkers(i, n, r + 1);
                        c !== null && this.elPointsMain.add(c);
                    }
                    var d = h.drawDataLabel({
                        type: t,
                        isRangeStart: a,
                        pos: i,
                        i: n,
                        j: r + 1
                    });
                    d !== null && this.elDataLabelsWrap.add(d);
                }
            },
            {
                key: "_createPaths",
                value: function(e) {
                    var t = e.type, i = e.series, a = e.i, s = e.realIndex, r = e.j, n = e.x, o = e.y, h = e.xArrj, c = e.yArrj, d = e.y2, g = e.y2Arrj, p = e.pX, f = e.pY, b = e.linePath, m = e.areaPath, w = e.linePaths, A = e.areaPaths, l = e.seriesIndex, u = e.isRangeStart, x = this.w, v = new M(this.ctx), k = x.config.stroke.curve, S = this.areaBottomY;
                    if (Array.isArray(x.config.stroke.curve) && (k = Array.isArray(l) ? x.config.stroke.curve[l[a]] : x.config.stroke.curve[a]), t === "rangeArea" && (x.globals.hasNullValues || x.config.forecastDataPoints.count > 0) && k === "monotoneCubic" && (k = "straight"), k === "monotoneCubic") {
                        var C = t === "rangeArea" ? h.length === x.globals.dataPoints : r === i[a].length - 2, L = h.map(function(W, N) {
                            return [
                                h[N],
                                c[N]
                            ];
                        }).filter(function(W) {
                            return W[1] !== null;
                        });
                        if (C && L.length > 1) {
                            var I = lt(L);
                            if (b += Ge(I), i[a][0] === null ? m = b : m += Ge(I), t === "rangeArea" && u) {
                                b += v.line(h[h.length - 1], g[g.length - 1]);
                                var z = h.slice().reverse(), T = g.slice().reverse(), E = z.map(function(W, N) {
                                    return [
                                        z[N],
                                        T[N]
                                    ];
                                }), R = lt(E);
                                m = b += Ge(R);
                            } else m += v.line(L[L.length - 1][0], S) + v.line(L[0][0], S) + v.move(L[0][0], L[0][1]) + "z";
                            w.push(b), A.push(m);
                        }
                    } else if (k === "smooth") {
                        var O = 0.35 * (n - p);
                        x.globals.hasNullValues ? (i[a][r] !== null && (i[a][r + 1] !== null ? (b = v.move(p, f) + v.curve(p + O, f, n - O, o, n + 1, o), m = v.move(p + 1, f) + v.curve(p + O, f, n - O, o, n + 1, o) + v.line(n, S) + v.line(p, S) + "z") : (b = v.move(p, f), m = v.move(p, f) + "z")), w.push(b), A.push(m)) : (b += v.curve(p + O, f, n - O, o, n, o), m += v.curve(p + O, f, n - O, o, n, o)), p = n, f = o, r === i[a].length - 2 && (m = m + v.curve(p, f, n, o, n, S) + v.move(n, o) + "z", t === "rangeArea" && u ? b = b + v.curve(p, f, n, o, n, d) + v.move(n, d) + "z" : x.globals.hasNullValues || (w.push(b), A.push(m)));
                    } else {
                        if (i[a][r + 1] === null) {
                            b += v.move(n, o);
                            var D = x.globals.isXNumeric ? (x.globals.seriesX[s][r] - x.globals.minX) / this.xRatio : n - this.xDivision;
                            m = m + v.line(D, S) + v.move(n, o) + "z";
                        }
                        i[a][r] === null && (b += v.move(n, o), m += v.move(n, S)), k === "stepline" ? (b = b + v.line(n, null, "H") + v.line(null, o, "V"), m = m + v.line(n, null, "H") + v.line(null, o, "V")) : k === "straight" && (b += v.line(n, o), m += v.line(n, o)), r === i[a].length - 2 && (m = m + v.line(n, S) + v.move(n, o) + "z", t === "rangeArea" && u ? b = b + v.line(n, d) + v.move(n, d) + "z" : (w.push(b), A.push(m)));
                    }
                    return {
                        linePaths: w,
                        areaPaths: A,
                        pX: p,
                        pY: f,
                        linePath: b,
                        areaPath: m
                    };
                }
            },
            {
                key: "handleNullDataPoints",
                value: function(e, t, i, a, s) {
                    var r = this.w;
                    if (e[i][a] === null && r.config.markers.showNullDataPoints || e[i].length === 1) {
                        var n = this.markers.plotChartMarkers(t, s, a + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                        n !== null && this.elPointsMain.add(n);
                    }
                }
            }
        ]), y;
    }();
    window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
        function y(n, o, h, c) {
            this.xoffset = n, this.yoffset = o, this.height = c, this.width = h, this.shortestEdge = function() {
                return Math.min(this.height, this.width);
            }, this.getCoordinates = function(d) {
                var g, p = [], f = this.xoffset, b = this.yoffset, m = s(d) / this.height, w = s(d) / this.width;
                if (this.width >= this.height) for(g = 0; g < d.length; g++)p.push([
                    f,
                    b,
                    f + m,
                    b + d[g] / m
                ]), b += d[g] / m;
                else for(g = 0; g < d.length; g++)p.push([
                    f,
                    b,
                    f + d[g] / w,
                    b + w
                ]), f += d[g] / w;
                return p;
            }, this.cutArea = function(d) {
                var g;
                if (this.width >= this.height) {
                    var p = d / this.height, f = this.width - p;
                    g = new y(this.xoffset + p, this.yoffset, f, this.height);
                } else {
                    var b = d / this.width, m = this.height - b;
                    g = new y(this.xoffset, this.yoffset + b, this.width, m);
                }
                return g;
            };
        }
        function e(n, o, h, c, d) {
            c = c === void 0 ? 0 : c, d = d === void 0 ? 0 : d;
            var g = t(function(p, f) {
                var b, m = [], w = f / s(p);
                for(b = 0; b < p.length; b++)m[b] = p[b] * w;
                return m;
            }(n, o * h), [], new y(c, d, o, h), []);
            return function(p) {
                var f, b, m = [];
                for(f = 0; f < p.length; f++)for(b = 0; b < p[f].length; b++)m.push(p[f][b]);
                return m;
            }(g);
        }
        function t(n, o, h, c) {
            var d, g, p;
            if (n.length !== 0) return d = h.shortestEdge(), function(f, b, m) {
                var w;
                if (f.length === 0) return !0;
                (w = f.slice()).push(b);
                var A = i(f, m), l = i(w, m);
                return A >= l;
            }(o, g = n[0], d) ? (o.push(g), t(n.slice(1), o, h, c)) : (p = h.cutArea(s(o), c), c.push(h.getCoordinates(o)), t(n, [], p, c)), c;
            c.push(h.getCoordinates(o));
        }
        function i(n, o) {
            var h = Math.min.apply(Math, n), c = Math.max.apply(Math, n), d = s(n);
            return Math.max(Math.pow(o, 2) * c / Math.pow(d, 2), Math.pow(d, 2) / (Math.pow(o, 2) * h));
        }
        function a(n) {
            return n && n.constructor === Array;
        }
        function s(n) {
            var o, h = 0;
            for(o = 0; o < n.length; o++)h += n[o];
            return h;
        }
        function r(n) {
            var o, h = 0;
            if (a(n[0])) for(o = 0; o < n.length; o++)h += r(n[o]);
            else h = s(n);
            return h;
        }
        return function n(o, h, c, d, g) {
            d = d === void 0 ? 0 : d, g = g === void 0 ? 0 : g;
            var p, f, b = [], m = [];
            if (a(o[0])) {
                for(f = 0; f < o.length; f++)b[f] = r(o[f]);
                for(p = e(b, h, c, d, g), f = 0; f < o.length; f++)m.push(n(o[f], p[f][2] - p[f][0], p[f][3] - p[f][1], p[f][0], p[f][1]));
            } else m = e(o, h, c, d, g);
            return m;
        };
    }();
    var be, Fe, Nt = function() {
        function y(e, t) {
            F(this, y), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new rt(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
        }
        return Y(y, [
            {
                key: "draw",
                value: function(e) {
                    var t = this, i = this.w, a = new M(this.ctx), s = new ae(this.ctx), r = a.group({
                        class: "apexcharts-treemap"
                    });
                    if (i.globals.noData) return r;
                    var n = [];
                    return e.forEach(function(o) {
                        var h = o.map(function(c) {
                            return Math.abs(c);
                        });
                        n.push(h);
                    }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(o, h) {
                        o.data.forEach(function(c) {
                            Array.isArray(t.labels[h]) || (t.labels[h] = []), t.labels[h].push(c.x);
                        });
                    }), window.TreemapSquared.generate(n, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, h) {
                        var c = a.group({
                            class: "apexcharts-series apexcharts-treemap-series",
                            seriesName: P.escapeString(i.globals.seriesNames[h]),
                            rel: h + 1,
                            "data:realIndex": h
                        });
                        if (i.config.chart.dropShadow.enabled) {
                            var d = i.config.chart.dropShadow;
                            new Z(t.ctx).dropShadow(r, d, h);
                        }
                        var g = a.group({
                            class: "apexcharts-data-labels"
                        });
                        o.forEach(function(p, f) {
                            var b = p[0], m = p[1], w = p[2], A = p[3], l = a.drawRect(b, m, w - b, A - m, i.config.plotOptions.treemap.borderRadius, "#fff", 1, t.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? x : i.globals.stroke.colors[h]);
                            l.attr({
                                cx: b,
                                cy: m,
                                index: h,
                                i: h,
                                j: f,
                                width: w - b,
                                height: A - m
                            });
                            var u = t.helpers.getShadeColor(i.config.chart.type, h, f, t.negRange), x = u.color;
                            i.config.series[h].data[f] !== void 0 && i.config.series[h].data[f].fillColor && (x = i.config.series[h].data[f].fillColor);
                            var v = s.fillPath({
                                color: x,
                                seriesNumber: h,
                                dataPointIndex: f
                            });
                            l.node.classList.add("apexcharts-treemap-rect"), l.attr({
                                fill: v
                            }), t.helpers.addListeners(l);
                            var k = {
                                x: b + (w - b) / 2,
                                y: m + (A - m) / 2,
                                width: 0,
                                height: 0
                            }, S = {
                                x: b,
                                y: m,
                                width: w - b,
                                height: A - m
                            };
                            if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                                var C = 1;
                                i.globals.resized || (C = i.config.chart.animations.speed), t.animateTreemap(l, k, S, C);
                            }
                            if (i.globals.dataChanged) {
                                var L = 1;
                                t.dynamicAnim.enabled && i.globals.shouldAnimate && (L = t.dynamicAnim.speed, i.globals.previousPaths[h] && i.globals.previousPaths[h][f] && i.globals.previousPaths[h][f].rect && (k = i.globals.previousPaths[h][f].rect), t.animateTreemap(l, k, S, L));
                            }
                            var I = t.getFontSize(p), z = i.config.dataLabels.formatter(t.labels[h][f], {
                                value: i.globals.series[h][f],
                                seriesIndex: h,
                                dataPointIndex: f,
                                w: i
                            });
                            i.config.plotOptions.treemap.dataLabels.format === "truncate" && (I = parseInt(i.config.dataLabels.style.fontSize, 10), z = t.truncateLabels(z, I, b, m, w, A));
                            var T = t.helpers.calculateDataLabels({
                                text: z,
                                x: (b + w) / 2,
                                y: (m + A) / 2 + t.strokeWidth / 2 + I / 3,
                                i: h,
                                j: f,
                                colorProps: u,
                                fontSize: I,
                                series: e
                            });
                            i.config.dataLabels.enabled && T && t.rotateToFitLabel(T, I, z, b, m, w, A), c.add(l), T !== null && c.add(T);
                        }), c.add(g), r.add(c);
                    }), r;
                }
            },
            {
                key: "getFontSize",
                value: function(e) {
                    var t = this.w, i, a, s, r, n = function o(h) {
                        var c, d = 0;
                        if (Array.isArray(h[0])) for(c = 0; c < h.length; c++)d += o(h[c]);
                        else for(c = 0; c < h.length; c++)d += h[c].length;
                        return d;
                    }(this.labels) / function o(h) {
                        var c, d = 0;
                        if (Array.isArray(h[0])) for(c = 0; c < h.length; c++)d += o(h[c]);
                        else for(c = 0; c < h.length; c++)d += 1;
                        return d;
                    }(this.labels);
                    return i = e[2] - e[0], a = e[3] - e[1], s = i * a, r = Math.pow(s, 0.5), Math.min(r / n, parseInt(t.config.dataLabels.style.fontSize, 10));
                }
            },
            {
                key: "rotateToFitLabel",
                value: function(e, t, i, a, s, r, n) {
                    var o = new M(this.ctx), h = o.getTextRects(i, t);
                    if (h.width + this.w.config.stroke.width + 5 > r - a && h.width <= n - s) {
                        var c = o.rotateAroundCenter(e.node);
                        e.node.setAttribute("transform", "rotate(-90 ".concat(c.x, " ").concat(c.y, ") translate(").concat(h.height / 3, ")"));
                    }
                }
            },
            {
                key: "truncateLabels",
                value: function(e, t, i, a, s, r) {
                    var n = new M(this.ctx), o = n.getTextRects(e, t).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, h = n.getTextBasedOnMaxWidth({
                        text: e,
                        maxWidth: o,
                        fontSize: t
                    });
                    return e.length !== h.length && o / t < 5 ? "" : h;
                }
            },
            {
                key: "animateTreemap",
                value: function(e, t, i, a) {
                    var s = new de(this.ctx);
                    s.animateRect(e, {
                        x: t.x,
                        y: t.y,
                        width: t.width,
                        height: t.height
                    }, {
                        x: i.x,
                        y: i.y,
                        width: i.width,
                        height: i.height
                    }, a, function() {
                        s.animationCompleted(e);
                    });
                }
            }
        ]), y;
    }(), Wt = 86400, Bt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
        }
        return Y(y, [
            {
                key: "calculateTimeScaleTicks",
                value: function(e, t) {
                    var i = this, a = this.w;
                    if (a.globals.allSeriesCollapsed) return a.globals.labels = [], a.globals.timescaleLabels = [], [];
                    var s = new B(this.ctx), r = (t - e) / 864e5;
                    this.determineInterval(r), a.globals.disableZoomIn = !1, a.globals.disableZoomOut = !1, r < 11574074074074075e-20 ? a.globals.disableZoomIn = !0 : r > 5e4 && (a.globals.disableZoomOut = !0);
                    var n = s.getTimeUnitsfromTimestamp(e, t, this.utc), o = a.globals.gridWidth / r, h = o / 24, c = h / 60, d = c / 60, g = Math.floor(24 * r), p = Math.floor(1440 * r), f = Math.floor(r * Wt), b = Math.floor(r), m = Math.floor(r / 30), w = Math.floor(r / 365), A = {
                        minMillisecond: n.minMillisecond,
                        minSecond: n.minSecond,
                        minMinute: n.minMinute,
                        minHour: n.minHour,
                        minDate: n.minDate,
                        minMonth: n.minMonth,
                        minYear: n.minYear
                    }, l = {
                        firstVal: A,
                        currentMillisecond: A.minMillisecond,
                        currentSecond: A.minSecond,
                        currentMinute: A.minMinute,
                        currentHour: A.minHour,
                        currentMonthDate: A.minDate,
                        currentDate: A.minDate,
                        currentMonth: A.minMonth,
                        currentYear: A.minYear,
                        daysWidthOnXAxis: o,
                        hoursWidthOnXAxis: h,
                        minutesWidthOnXAxis: c,
                        secondsWidthOnXAxis: d,
                        numberOfSeconds: f,
                        numberOfMinutes: p,
                        numberOfHours: g,
                        numberOfDays: b,
                        numberOfMonths: m,
                        numberOfYears: w
                    };
                    switch(this.tickInterval){
                        case "years":
                            this.generateYearScale(l);
                            break;
                        case "months":
                        case "half_year":
                            this.generateMonthScale(l);
                            break;
                        case "months_days":
                        case "months_fortnight":
                        case "days":
                        case "week_days":
                            this.generateDayScale(l);
                            break;
                        case "hours":
                            this.generateHourScale(l);
                            break;
                        case "minutes_fives":
                        case "minutes":
                            this.generateMinuteScale(l);
                            break;
                        case "seconds_tens":
                        case "seconds_fives":
                        case "seconds":
                            this.generateSecondScale(l);
                    }
                    var u = this.timeScaleArray.map(function(x) {
                        var v = {
                            position: x.position,
                            unit: x.unit,
                            year: x.year,
                            day: x.day ? x.day : 1,
                            hour: x.hour ? x.hour : 0,
                            month: x.month + 1
                        };
                        return x.unit === "month" ? X(X({}, v), {}, {
                            day: 1,
                            value: x.value + 1
                        }) : x.unit === "day" || x.unit === "hour" ? X(X({}, v), {}, {
                            value: x.value
                        }) : x.unit === "minute" ? X(X({}, v), {}, {
                            value: x.value,
                            minute: x.value
                        }) : x.unit === "second" ? X(X({}, v), {}, {
                            value: x.value,
                            minute: x.minute,
                            second: x.second
                        }) : x;
                    });
                    return u.filter(function(x) {
                        var v = 1, k = Math.ceil(a.globals.gridWidth / 120), S = x.value;
                        a.config.xaxis.tickAmount !== void 0 && (k = a.config.xaxis.tickAmount), u.length > k && (v = Math.floor(u.length / k));
                        var C = !1, L = !1;
                        switch(i.tickInterval){
                            case "years":
                                x.unit === "year" && (C = !0);
                                break;
                            case "half_year":
                                v = 7, x.unit === "year" && (C = !0);
                                break;
                            case "months":
                                v = 1, x.unit === "year" && (C = !0);
                                break;
                            case "months_fortnight":
                                v = 15, x.unit !== "year" && x.unit !== "month" || (C = !0), S === 30 && (L = !0);
                                break;
                            case "months_days":
                                v = 10, x.unit === "month" && (C = !0), S === 30 && (L = !0);
                                break;
                            case "week_days":
                                v = 8, x.unit === "month" && (C = !0);
                                break;
                            case "days":
                                v = 1, x.unit === "month" && (C = !0);
                                break;
                            case "hours":
                                x.unit === "day" && (C = !0);
                                break;
                            case "minutes_fives":
                            case "seconds_fives":
                                S % 5 != 0 && (L = !0);
                                break;
                            case "seconds_tens":
                                S % 10 != 0 && (L = !0);
                        }
                        if (i.tickInterval === "hours" || i.tickInterval === "minutes_fives" || i.tickInterval === "seconds_tens" || i.tickInterval === "seconds_fives") {
                            if (!L) return !0;
                        } else if ((S % v == 0 || C) && !L) return !0;
                    });
                }
            },
            {
                key: "recalcDimensionsBasedOnFormat",
                value: function(e, t) {
                    var i = this.w, a = this.formatDates(e), s = this.removeOverlappingTS(a);
                    i.globals.timescaleLabels = s.slice(), new Ye(this.ctx).plotCoords();
                }
            },
            {
                key: "determineInterval",
                value: function(e) {
                    var t = 24 * e, i = 60 * t;
                    switch(!0){
                        case e / 365 > 5:
                            this.tickInterval = "years";
                            break;
                        case e > 800:
                            this.tickInterval = "half_year";
                            break;
                        case e > 180:
                            this.tickInterval = "months";
                            break;
                        case e > 90:
                            this.tickInterval = "months_fortnight";
                            break;
                        case e > 60:
                            this.tickInterval = "months_days";
                            break;
                        case e > 30:
                            this.tickInterval = "week_days";
                            break;
                        case e > 2:
                            this.tickInterval = "days";
                            break;
                        case t > 2.4:
                            this.tickInterval = "hours";
                            break;
                        case i > 15:
                            this.tickInterval = "minutes_fives";
                            break;
                        case i > 5:
                            this.tickInterval = "minutes";
                            break;
                        case i > 1:
                            this.tickInterval = "seconds_tens";
                            break;
                        case 60 * i > 20:
                            this.tickInterval = "seconds_fives";
                            break;
                        default:
                            this.tickInterval = "seconds";
                    }
                }
            },
            {
                key: "generateYearScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentMonth, a = e.currentYear, s = e.daysWidthOnXAxis, r = e.numberOfYears, n = t.minYear, o = 0, h = new B(this.ctx), c = "year";
                    if (t.minDate > 1 || t.minMonth > 0) {
                        var d = h.determineRemainingDaysOfYear(t.minYear, t.minMonth, t.minDate);
                        o = (h.determineDaysOfYear(t.minYear) - d + 1) * s, n = t.minYear + 1, this.timeScaleArray.push({
                            position: o,
                            value: n,
                            unit: c,
                            year: n,
                            month: P.monthMod(i + 1)
                        });
                    } else t.minDate === 1 && t.minMonth === 0 && this.timeScaleArray.push({
                        position: o,
                        value: n,
                        unit: c,
                        year: a,
                        month: P.monthMod(i + 1)
                    });
                    for(var g = n, p = o, f = 0; f < r; f++)g++, p = h.determineDaysOfYear(g - 1) * s + p, this.timeScaleArray.push({
                        position: p,
                        value: g,
                        unit: c,
                        year: g,
                        month: 1
                    });
                }
            },
            {
                key: "generateMonthScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentMonthDate, a = e.currentMonth, s = e.currentYear, r = e.daysWidthOnXAxis, n = e.numberOfMonths, o = a, h = 0, c = new B(this.ctx), d = "month", g = 0;
                    if (t.minDate > 1) {
                        h = (c.determineDaysOfMonths(a + 1, t.minYear) - i + 1) * r, o = P.monthMod(a + 1);
                        var p = s + g, f = P.monthMod(o), b = o;
                        o === 0 && (d = "year", b = p, f = 1, p += g += 1), this.timeScaleArray.push({
                            position: h,
                            value: b,
                            unit: d,
                            year: p,
                            month: f
                        });
                    } else this.timeScaleArray.push({
                        position: h,
                        value: o,
                        unit: d,
                        year: s,
                        month: P.monthMod(a)
                    });
                    for(var m = o + 1, w = h, A = 0, l = 1; A < n; A++, l++){
                        (m = P.monthMod(m)) === 0 ? (d = "year", g += 1) : d = "month";
                        var u = this._getYear(s, m, g);
                        w = c.determineDaysOfMonths(m, u) * r + w;
                        var x = m === 0 ? u : m;
                        this.timeScaleArray.push({
                            position: w,
                            value: x,
                            unit: d,
                            year: u,
                            month: m === 0 ? 1 : m
                        }), m++;
                    }
                }
            },
            {
                key: "generateDayScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentMonth, a = e.currentYear, s = e.hoursWidthOnXAxis, r = e.numberOfDays, n = new B(this.ctx), o = "day", h = t.minDate + 1, c = h, d = function(l, u, x) {
                        return l > n.determineDaysOfMonths(u + 1, x) && (c = 1, o = "month", p = u += 1), u;
                    }, g = (24 - t.minHour) * s, p = h, f = d(c, i, a);
                    t.minHour === 0 && t.minDate === 1 ? (g = 0, p = P.monthMod(t.minMonth), o = "month", c = t.minDate) : t.minDate !== 1 && t.minHour === 0 && t.minMinute === 0 && (g = 0, h = t.minDate, p = h, f = d(c = h, i, a)), this.timeScaleArray.push({
                        position: g,
                        value: p,
                        unit: o,
                        year: this._getYear(a, f, 0),
                        month: P.monthMod(f),
                        day: c
                    });
                    for(var b = g, m = 0; m < r; m++){
                        o = "day", f = d(c += 1, f, this._getYear(a, f, 0));
                        var w = this._getYear(a, f, 0);
                        b = 24 * s + b;
                        var A = c === 1 ? P.monthMod(f) : c;
                        this.timeScaleArray.push({
                            position: b,
                            value: A,
                            unit: o,
                            year: w,
                            month: P.monthMod(f),
                            day: A
                        });
                    }
                }
            },
            {
                key: "generateHourScale",
                value: function(e) {
                    var t = e.firstVal, i = e.currentDate, a = e.currentMonth, s = e.currentYear, r = e.minutesWidthOnXAxis, n = e.numberOfHours, o = new B(this.ctx), h = "hour", c = function(v, k) {
                        return v > o.determineDaysOfMonths(k + 1, s) && (m = 1, k += 1), {
                            month: k,
                            date: m
                        };
                    }, d = function(v, k) {
                        return v > o.determineDaysOfMonths(k + 1, s) ? k += 1 : k;
                    }, g = 60 - (t.minMinute + t.minSecond / 60), p = g * r, f = t.minHour + 1, b = f;
                    g === 60 && (p = 0, b = f = t.minHour);
                    var m = i;
                    b >= 24 && (b = 0, m += 1, h = "day");
                    var w = c(m, a).month;
                    w = d(m, w), this.timeScaleArray.push({
                        position: p,
                        value: f,
                        unit: h,
                        day: m,
                        hour: b,
                        year: s,
                        month: P.monthMod(w)
                    }), b++;
                    for(var A = p, l = 0; l < n; l++){
                        h = "hour", b >= 24 && (b = 0, h = "day", w = c(m += 1, w).month, w = d(m, w));
                        var u = this._getYear(s, w, 0);
                        A = 60 * r + A;
                        var x = b === 0 ? m : b;
                        this.timeScaleArray.push({
                            position: A,
                            value: x,
                            unit: h,
                            hour: b,
                            day: m,
                            year: u,
                            month: P.monthMod(w)
                        }), b++;
                    }
                }
            },
            {
                key: "generateMinuteScale",
                value: function(e) {
                    for(var t = e.currentMillisecond, i = e.currentSecond, a = e.currentMinute, s = e.currentHour, r = e.currentDate, n = e.currentMonth, o = e.currentYear, h = e.minutesWidthOnXAxis, c = e.secondsWidthOnXAxis, d = e.numberOfMinutes, g = a + 1, p = r, f = n, b = o, m = s, w = (60 - i - t / 1e3) * c, A = 0; A < d; A++)g >= 60 && (g = 0, (m += 1) === 24 && (m = 0)), this.timeScaleArray.push({
                        position: w,
                        value: g,
                        unit: "minute",
                        hour: m,
                        minute: g,
                        day: p,
                        year: this._getYear(b, f, 0),
                        month: P.monthMod(f)
                    }), w += h, g++;
                }
            },
            {
                key: "generateSecondScale",
                value: function(e) {
                    for(var t = e.currentMillisecond, i = e.currentSecond, a = e.currentMinute, s = e.currentHour, r = e.currentDate, n = e.currentMonth, o = e.currentYear, h = e.secondsWidthOnXAxis, c = e.numberOfSeconds, d = i + 1, g = a, p = r, f = n, b = o, m = s, w = (1e3 - t) / 1e3 * h, A = 0; A < c; A++)d >= 60 && (d = 0, ++g >= 60 && (g = 0, ++m === 24 && (m = 0))), this.timeScaleArray.push({
                        position: w,
                        value: d,
                        unit: "second",
                        hour: m,
                        minute: g,
                        second: d,
                        day: p,
                        year: this._getYear(b, f, 0),
                        month: P.monthMod(f)
                    }), w += h, d++;
                }
            },
            {
                key: "createRawDateString",
                value: function(e, t) {
                    var i = e.year;
                    return e.month === 0 && (e.month = 1), i += "-" + ("0" + e.month.toString()).slice(-2), e.unit === "day" ? i += e.unit === "day" ? "-" + ("0" + t).slice(-2) : "-01" : i += "-" + ("0" + (e.day ? e.day : "1")).slice(-2), e.unit === "hour" ? i += e.unit === "hour" ? "T" + ("0" + t).slice(-2) : "T00" : i += "T" + ("0" + (e.hour ? e.hour : "0")).slice(-2), e.unit === "minute" ? i += ":" + ("0" + t).slice(-2) : i += ":" + (e.minute ? ("0" + e.minute).slice(-2) : "00"), e.unit === "second" ? i += ":" + ("0" + t).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
                }
            },
            {
                key: "formatDates",
                value: function(e) {
                    var t = this, i = this.w;
                    return e.map(function(a) {
                        var s = a.value.toString(), r = new B(t.ctx), n = t.createRawDateString(a, s), o = r.getDate(r.parseDate(n));
                        if (t.utc || (o = r.getDate(r.parseDateWithTimezone(n))), i.config.xaxis.labels.format === void 0) {
                            var h = "dd MMM", c = i.config.xaxis.labels.datetimeFormatter;
                            a.unit === "year" && (h = c.year), a.unit === "month" && (h = c.month), a.unit === "day" && (h = c.day), a.unit === "hour" && (h = c.hour), a.unit === "minute" && (h = c.minute), a.unit === "second" && (h = c.second), s = r.formatDate(o, h);
                        } else s = r.formatDate(o, i.config.xaxis.labels.format);
                        return {
                            dateString: n,
                            position: a.position,
                            value: s,
                            unit: a.unit,
                            year: a.year,
                            month: a.month
                        };
                    });
                }
            },
            {
                key: "removeOverlappingTS",
                value: function(e) {
                    var t, i = this, a = new M(this.ctx), s = !1;
                    e.length > 0 && e[0].value && e.every(function(o) {
                        return o.value.length === e[0].value.length;
                    }) && (s = !0, t = a.getTextRects(e[0].value).width);
                    var r = 0, n = e.map(function(o, h) {
                        if (h > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                            var c = s ? t : a.getTextRects(e[r].value).width, d = e[r].position;
                            return o.position > d + c + 10 ? (r = h, o) : null;
                        }
                        return o;
                    });
                    return n = n.filter(function(o) {
                        return o !== null;
                    });
                }
            },
            {
                key: "_getYear",
                value: function(e, t, i) {
                    return e + Math.floor(t / 12) + i;
                }
            }
        ]), y;
    }(), Gt = function() {
        function y(e, t) {
            F(this, y), this.ctx = t, this.w = t.w, this.el = e;
        }
        return Y(y, [
            {
                key: "setupElements",
                value: function() {
                    var e = this.w.globals, t = this.w.config, i = t.chart.type;
                    e.axisCharts = [
                        "line",
                        "area",
                        "bar",
                        "rangeBar",
                        "rangeArea",
                        "candlestick",
                        "boxPlot",
                        "scatter",
                        "bubble",
                        "radar",
                        "heatmap",
                        "treemap"
                    ].indexOf(i) > -1, e.xyCharts = [
                        "line",
                        "area",
                        "bar",
                        "rangeBar",
                        "rangeArea",
                        "candlestick",
                        "boxPlot",
                        "scatter",
                        "bubble"
                    ].indexOf(i) > -1, e.isBarHorizontal = (t.chart.type === "bar" || t.chart.type === "rangeBar" || t.chart.type === "boxPlot") && t.plotOptions.bar.horizontal, e.chartClass = ".apexcharts" + e.chartID, e.dom.baseEl = this.el, e.dom.elWrap = document.createElement("div"), M.setAttrs(e.dom.elWrap, {
                        id: e.chartClass.substring(1),
                        class: "apexcharts-canvas " + e.chartClass.substring(1)
                    }), this.el.appendChild(e.dom.elWrap), e.dom.Paper = new window.SVG.Doc(e.dom.elWrap), e.dom.Paper.attr({
                        class: "apexcharts-svg",
                        "xmlns:data": "ApexChartsNS",
                        transform: "translate(".concat(t.chart.offsetX, ", ").concat(t.chart.offsetY, ")")
                    }), e.dom.Paper.node.style.background = t.theme.mode !== "dark" || t.chart.background ? t.chart.background : "rgba(0, 0, 0, 0.8)", this.setSVGDimensions(), e.dom.elLegendForeign = document.createElementNS(e.SVGNS, "foreignObject"), M.setAttrs(e.dom.elLegendForeign, {
                        x: 0,
                        y: 0,
                        width: e.svgWidth,
                        height: e.svgHeight
                    }), e.dom.elLegendWrap = document.createElement("div"), e.dom.elLegendWrap.classList.add("apexcharts-legend"), e.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), e.dom.elLegendForeign.appendChild(e.dom.elLegendWrap), e.dom.Paper.node.appendChild(e.dom.elLegendForeign), e.dom.elGraphical = e.dom.Paper.group().attr({
                        class: "apexcharts-inner apexcharts-graphical"
                    }), e.dom.elDefs = e.dom.Paper.defs(), e.dom.Paper.add(e.dom.elGraphical), e.dom.elGraphical.add(e.dom.elDefs);
                }
            },
            {
                key: "plotChartType",
                value: function(e, t) {
                    var i = this.w, a = i.config, s = i.globals, r = {
                        series: [],
                        i: []
                    }, n = {
                        series: [],
                        i: []
                    }, o = {
                        series: [],
                        i: []
                    }, h = {
                        series: [],
                        i: []
                    }, c = {
                        series: [],
                        i: []
                    }, d = {
                        series: [],
                        i: []
                    }, g = {
                        series: [],
                        i: []
                    }, p = {
                        series: [],
                        i: []
                    }, f = {
                        series: [],
                        seriesRangeEnd: [],
                        i: []
                    };
                    s.series.map(function(k, S) {
                        var C = 0;
                        e[S].type !== void 0 ? (e[S].type === "column" || e[S].type === "bar" ? (s.series.length > 1 && a.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), c.series.push(k), c.i.push(S), C++, i.globals.columnSeries = c.series) : e[S].type === "area" ? (n.series.push(k), n.i.push(S), C++) : e[S].type === "line" ? (r.series.push(k), r.i.push(S), C++) : e[S].type === "scatter" ? (o.series.push(k), o.i.push(S)) : e[S].type === "bubble" ? (h.series.push(k), h.i.push(S), C++) : e[S].type === "candlestick" ? (d.series.push(k), d.i.push(S), C++) : e[S].type === "boxPlot" ? (g.series.push(k), g.i.push(S), C++) : e[S].type === "rangeBar" ? (p.series.push(k), p.i.push(S), C++) : e[S].type === "rangeArea" ? (f.series.push(s.seriesRangeStart[S]), f.seriesRangeEnd.push(s.seriesRangeEnd[S]), f.i.push(S), C++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble/candlestick/boxPlot/rangeBar/rangeArea"), C > 1 && (s.comboCharts = !0)) : (r.series.push(k), r.i.push(S));
                    });
                    var b = new je(this.ctx, t), m = new Be(this.ctx, t);
                    this.ctx.pie = new ot(this.ctx);
                    var w = new Rt(this.ctx);
                    this.ctx.rangeBar = new Ot(this.ctx, t);
                    var A = new Ft(this.ctx), l = [];
                    if (s.comboCharts) {
                        if (n.series.length > 0 && l.push(b.draw(n.series, "area", n.i)), c.series.length > 0) {
                            if (i.config.chart.stacked) {
                                var u = new st(this.ctx, t);
                                l.push(u.draw(c.series, c.i));
                            } else this.ctx.bar = new ke(this.ctx, t), l.push(this.ctx.bar.draw(c.series, c.i));
                        }
                        if (f.series.length > 0 && l.push(b.draw(f.series, "rangeArea", f.i, f.seriesRangeEnd)), r.series.length > 0 && l.push(b.draw(r.series, "line", r.i)), d.series.length > 0 && l.push(m.draw(d.series, "candlestick", d.i)), g.series.length > 0 && l.push(m.draw(g.series, "boxPlot", g.i)), p.series.length > 0 && l.push(this.ctx.rangeBar.draw(p.series, p.i)), o.series.length > 0) {
                            var x = new je(this.ctx, t, !0);
                            l.push(x.draw(o.series, "scatter", o.i));
                        }
                        if (h.series.length > 0) {
                            var v = new je(this.ctx, t, !0);
                            l.push(v.draw(h.series, "bubble", h.i));
                        }
                    } else switch(a.chart.type){
                        case "line":
                            l = b.draw(s.series, "line");
                            break;
                        case "area":
                            l = b.draw(s.series, "area");
                            break;
                        case "bar":
                            a.chart.stacked ? l = new st(this.ctx, t).draw(s.series) : (this.ctx.bar = new ke(this.ctx, t), l = this.ctx.bar.draw(s.series));
                            break;
                        case "candlestick":
                            l = new Be(this.ctx, t).draw(s.series, "candlestick");
                            break;
                        case "boxPlot":
                            l = new Be(this.ctx, t).draw(s.series, a.chart.type);
                            break;
                        case "rangeBar":
                            l = this.ctx.rangeBar.draw(s.series);
                            break;
                        case "rangeArea":
                            l = b.draw(s.seriesRangeStart, "rangeArea", void 0, s.seriesRangeEnd);
                            break;
                        case "heatmap":
                            l = new Yt(this.ctx, t).draw(s.series);
                            break;
                        case "treemap":
                            l = new Nt(this.ctx, t).draw(s.series);
                            break;
                        case "pie":
                        case "donut":
                        case "polarArea":
                            l = this.ctx.pie.draw(s.series);
                            break;
                        case "radialBar":
                            l = w.draw(s.series);
                            break;
                        case "radar":
                            l = A.draw(s.series);
                            break;
                        default:
                            l = b.draw(s.series);
                    }
                    return l;
                }
            },
            {
                key: "setSVGDimensions",
                value: function() {
                    var e = this.w.globals, t = this.w.config;
                    e.svgWidth = t.chart.width, e.svgHeight = t.chart.height;
                    var i = P.getDimensions(this.el), a = t.chart.width.toString().split(/[0-9]+/g).pop();
                    a === "%" ? P.isNumber(i[0]) && (i[0].width === 0 && (i = P.getDimensions(this.el.parentNode)), e.svgWidth = i[0] * parseInt(t.chart.width, 10) / 100) : a !== "px" && a !== "" || (e.svgWidth = parseInt(t.chart.width, 10));
                    var s = t.chart.height.toString().split(/[0-9]+/g).pop();
                    if (e.svgHeight !== "auto" && e.svgHeight !== "") {
                        if (s === "%") {
                            var r = P.getDimensions(this.el.parentNode);
                            e.svgHeight = r[1] * parseInt(t.chart.height, 10) / 100;
                        } else e.svgHeight = parseInt(t.chart.height, 10);
                    } else e.axisCharts ? e.svgHeight = e.svgWidth / 1.61 : e.svgHeight = e.svgWidth / 1.2;
                    if (e.svgWidth < 0 && (e.svgWidth = 0), e.svgHeight < 0 && (e.svgHeight = 0), M.setAttrs(e.dom.Paper.node, {
                        width: e.svgWidth,
                        height: e.svgHeight
                    }), s !== "%") {
                        var n = t.chart.sparkline.enabled ? 0 : e.axisCharts ? t.chart.parentHeightOffset : 0;
                        e.dom.Paper.node.parentNode.parentNode.style.minHeight = e.svgHeight + n + "px";
                    }
                    e.dom.elWrap.style.width = e.svgWidth + "px", e.dom.elWrap.style.height = e.svgHeight + "px";
                }
            },
            {
                key: "shiftGraphPosition",
                value: function() {
                    var e = this.w.globals, t = e.translateY, i = {
                        transform: "translate(" + e.translateX + ", " + t + ")"
                    };
                    M.setAttrs(e.dom.elGraphical.node, i);
                }
            },
            {
                key: "resizeNonAxisCharts",
                value: function() {
                    var e = this.w, t = e.globals, i = 0, a = e.config.chart.sparkline.enabled ? 1 : 15;
                    a += e.config.grid.padding.bottom, e.config.legend.position !== "top" && e.config.legend.position !== "bottom" || !e.config.legend.show || e.config.legend.floating || (i = new Ke(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                    var s = e.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * e.globals.radialSize;
                    if (s && !e.config.chart.sparkline.enabled && e.config.plotOptions.radialBar.startAngle !== 0) {
                        var n = P.getBoundingClientRect(s);
                        r = n.bottom;
                        var o = n.bottom - n.top;
                        r = Math.max(2.05 * e.globals.radialSize, o);
                    }
                    var h = r + t.translateY + i + a;
                    t.dom.elLegendForeign && t.dom.elLegendForeign.setAttribute("height", h), e.config.chart.height && String(e.config.chart.height).indexOf("%") > 0 || (t.dom.elWrap.style.height = h + "px", M.setAttrs(t.dom.Paper.node, {
                        height: h
                    }), t.dom.Paper.node.parentNode.parentNode.style.minHeight = h + "px");
                }
            },
            {
                key: "coreCalculations",
                value: function() {
                    new De(this.ctx).init();
                }
            },
            {
                key: "resetGlobals",
                value: function() {
                    var e = this, t = function() {
                        return e.w.config.series.map(function(s) {
                            return [];
                        });
                    }, i = new Ze(), a = this.w.globals;
                    i.initGlobalVars(a), a.seriesXvalues = t(), a.seriesYvalues = t();
                }
            },
            {
                key: "isMultipleY",
                value: function() {
                    if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0;
                }
            },
            {
                key: "xySettings",
                value: function() {
                    var e = null, t = this.w;
                    if (t.globals.axisCharts) {
                        if (t.config.xaxis.crosshairs.position === "back" && new We(this.ctx).drawXCrosshairs(), t.config.yaxis[0].crosshairs.position === "back" && new We(this.ctx).drawYCrosshairs(), t.config.xaxis.type === "datetime" && t.config.xaxis.labels.formatter === void 0) {
                            this.ctx.timeScale = new Bt(this.ctx);
                            var i = [];
                            isFinite(t.globals.minX) && isFinite(t.globals.maxX) && !t.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minX, t.globals.maxX) : t.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minY, t.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                        }
                        e = new q(this.ctx).getCalculatedRatios();
                    }
                    return e;
                }
            },
            {
                key: "updateSourceChart",
                value: function(e) {
                    this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                        chart: {
                            selection: {
                                xaxis: {
                                    min: e.w.globals.minX,
                                    max: e.w.globals.maxX
                                }
                            }
                        }
                    }, !1, !1);
                }
            },
            {
                key: "setupBrushHandler",
                value: function() {
                    var e = this, t = this.w;
                    if (t.config.chart.brush.enabled && typeof t.config.chart.events.selection != "function") {
                        var i = Array.isArray(t.config.chart.brush.targets) ? t.config.chart.brush.targets : [
                            t.config.chart.brush.target
                        ];
                        i.forEach(function(a) {
                            var s = ApexCharts.getChartByID(a);
                            s.w.globals.brushSource = e.ctx, typeof s.w.config.chart.events.zoomed != "function" && (s.w.config.chart.events.zoomed = function() {
                                e.updateSourceChart(s);
                            }), typeof s.w.config.chart.events.scrolled != "function" && (s.w.config.chart.events.scrolled = function() {
                                e.updateSourceChart(s);
                            });
                        }), t.config.chart.events.selection = function(a, s) {
                            i.forEach(function(r) {
                                var n = ApexCharts.getChartByID(r), o = P.clone(t.config.yaxis);
                                if (t.config.chart.brush.autoScaleYaxis && n.w.globals.series.length === 1) {
                                    var h = new we(n);
                                    o = h.autoScaleY(n, o, s);
                                }
                                var c = n.w.config.yaxis.reduce(function(d, g, p) {
                                    return [].concat(J(d), [
                                        X(X({}, n.w.config.yaxis[p]), {}, {
                                            min: o[0].min,
                                            max: o[0].max
                                        })
                                    ]);
                                }, []);
                                n.ctx.updateHelpers._updateOptions({
                                    xaxis: {
                                        min: s.xaxis.min,
                                        max: s.xaxis.max
                                    },
                                    yaxis: c
                                }, !1, !1, !1, !1);
                            });
                        };
                    }
                }
            }
        ]), y;
    }(), Vt = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "_updateOptions",
                value: function(e) {
                    var t = this, i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], a = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], s = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], r = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
                    return new Promise(function(n) {
                        var o = [
                            t.ctx
                        ];
                        s && (o = t.ctx.getSyncedCharts()), t.ctx.w.globals.isExecCalled && (o = [
                            t.ctx
                        ], t.ctx.w.globals.isExecCalled = !1), o.forEach(function(h, c) {
                            var d = h.w;
                            if (d.globals.shouldAnimate = a, i || (d.globals.resized = !0, d.globals.dataChanged = !0, a && h.series.getPreviousPaths()), e && U(e) === "object" && (h.config = new Le(e), e = q.extendArrayProps(h.config, e, d), h.w.globals.chartID !== t.ctx.w.globals.chartID && delete e.series, d.config = P.extend(d.config, e), r && (d.globals.lastXAxis = e.xaxis ? P.clone(e.xaxis) : [], d.globals.lastYAxis = e.yaxis ? P.clone(e.yaxis) : [], d.globals.initialConfig = P.extend({}, d.config), d.globals.initialSeries = P.clone(d.config.series), e.series))) {
                                for(var g = 0; g < d.globals.collapsedSeriesIndices.length; g++){
                                    var p = d.config.series[d.globals.collapsedSeriesIndices[g]];
                                    d.globals.collapsedSeries[g].data = d.globals.axisCharts ? p.data.slice() : p;
                                }
                                for(var f = 0; f < d.globals.ancillaryCollapsedSeriesIndices.length; f++){
                                    var b = d.config.series[d.globals.ancillaryCollapsedSeriesIndices[f]];
                                    d.globals.ancillaryCollapsedSeries[f].data = d.globals.axisCharts ? b.data.slice() : b;
                                }
                                h.series.emptyCollapsedSeries(d.config.series);
                            }
                            return h.update(e).then(function() {
                                c === o.length - 1 && n(h);
                            });
                        });
                    });
                }
            },
            {
                key: "_updateSeries",
                value: function(e, t) {
                    var i = this, a = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
                    return new Promise(function(s) {
                        var r, n = i.w;
                        return n.globals.shouldAnimate = t, n.globals.dataChanged = !0, t && i.ctx.series.getPreviousPaths(), n.globals.axisCharts ? ((r = e.map(function(o, h) {
                            return i._extendSeries(o, h);
                        })).length === 0 && (r = [
                            {
                                data: []
                            }
                        ]), n.config.series = r) : n.config.series = e.slice(), a && (n.globals.initialConfig.series = P.clone(n.config.series), n.globals.initialSeries = P.clone(n.config.series)), i.ctx.update().then(function() {
                            s(i.ctx);
                        });
                    });
                }
            },
            {
                key: "_extendSeries",
                value: function(e, t) {
                    var i = this.w, a = i.config.series[t];
                    return X(X({}, i.config.series[t]), {}, {
                        name: e.name ? e.name : a == null ? void 0 : a.name,
                        color: e.color ? e.color : a == null ? void 0 : a.color,
                        type: e.type ? e.type : a == null ? void 0 : a.type,
                        group: e.group ? e.group : a == null ? void 0 : a.group,
                        data: e.data ? e.data : a == null ? void 0 : a.data,
                        zIndex: e.zIndex !== void 0 ? e.zIndex : t
                    });
                }
            },
            {
                key: "toggleDataPointSelection",
                value: function(e, t) {
                    var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(e, "']");
                    return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "'], ").concat(s, " circle[j='").concat(t, "'], ").concat(s, " rect[j='").concat(t, "']")).members[0] : t === void 0 && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "']")).members[0], i.config.chart.type !== "pie" && i.config.chart.type !== "polarArea" && i.config.chart.type !== "donut" || this.ctx.pie.pieClicked(e)), a ? (new M(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
                }
            },
            {
                key: "forceXAxisUpdate",
                value: function(e) {
                    var t = this.w;
                    if ([
                        "min",
                        "max"
                    ].forEach(function(a) {
                        e.xaxis[a] !== void 0 && (t.config.xaxis[a] = e.xaxis[a], t.globals.lastXAxis[a] = e.xaxis[a]);
                    }), e.xaxis.categories && e.xaxis.categories.length && (t.config.xaxis.categories = e.xaxis.categories), t.config.xaxis.convertedCatToNumeric) {
                        var i = new oe(e);
                        e = i.convertCatToNumericXaxis(e, this.ctx);
                    }
                    return e;
                }
            },
            {
                key: "forceYAxisUpdate",
                value: function(e) {
                    return e.chart && e.chart.stacked && e.chart.stackType === "100%" && (Array.isArray(e.yaxis) ? e.yaxis.forEach(function(t, i) {
                        e.yaxis[i].min = 0, e.yaxis[i].max = 100;
                    }) : (e.yaxis.min = 0, e.yaxis.max = 100)), e;
                }
            },
            {
                key: "revertDefaultAxisMinMax",
                value: function(e) {
                    var t = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                    e && e.xaxis && (a = e.xaxis), e && e.yaxis && (s = e.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                    var r = function(n) {
                        s[n] !== void 0 && (i.config.yaxis[n].min = s[n].min, i.config.yaxis[n].max = s[n].max);
                    };
                    i.config.yaxis.map(function(n, o) {
                        i.globals.zoomed || s[o] !== void 0 ? r(o) : t.ctx.opts.yaxis[o] !== void 0 && (n.min = t.ctx.opts.yaxis[o].min, n.max = t.ctx.opts.yaxis[o].max);
                    });
                }
            }
        ]), y;
    }();
    be = typeof window < "u" ? window : void 0, Fe = function(y, e) {
        var t = (this !== void 0 ? this : y).SVG = function(l) {
            if (t.supported) return l = new t.Doc(l), t.parser.draw || t.prepare(), l;
        };
        if (t.ns = "http://www.w3.org/2000/svg", t.xmlns = "http://www.w3.org/2000/xmlns/", t.xlink = "http://www.w3.org/1999/xlink", t.svgjs = "http://svgjs.dev", t.supported = !0, !t.supported) return !1;
        t.did = 1e3, t.eid = function(l) {
            return "Svgjs" + c(l) + t.did++;
        }, t.create = function(l) {
            var u = e.createElementNS(this.ns, l);
            return u.setAttribute("id", this.eid(l)), u;
        }, t.extend = function() {
            var l, u;
            u = (l = [].slice.call(arguments)).pop();
            for(var x = l.length - 1; x >= 0; x--)if (l[x]) for(var v in u)l[x].prototype[v] = u[v];
            t.Set && t.Set.inherit && t.Set.inherit();
        }, t.invent = function(l) {
            var u = typeof l.create == "function" ? l.create : function() {
                this.constructor.call(this, t.create(l.create));
            };
            return l.inherit && (u.prototype = new l.inherit()), l.extend && t.extend(u, l.extend), l.construct && t.extend(l.parent || t.Container, l.construct), u;
        }, t.adopt = function(l) {
            var u;
            return l ? l.instance ? l.instance : ((u = l.nodeName == "svg" ? l.parentNode instanceof y.SVGElement ? new t.Nested() : new t.Doc() : l.nodeName == "linearGradient" ? new t.Gradient("linear") : l.nodeName == "radialGradient" ? new t.Gradient("radial") : t[c(l.nodeName)] ? new t[c(l.nodeName)]() : new t.Element(l)).type = l.nodeName, u.node = l, l.instance = u, u instanceof t.Doc && u.namespace().defs(), u.setData(JSON.parse(l.getAttribute("svgjs:data")) || {}), u) : null;
        }, t.prepare = function() {
            var l = e.getElementsByTagName("body")[0], u = (l ? new t.Doc(l) : t.adopt(e.documentElement).nested()).size(2, 0);
            t.parser = {
                body: l || e.documentElement,
                draw: u.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
                poly: u.polyline().node,
                path: u.path().node,
                native: t.create("svg")
            };
        }, t.parser = {
            native: t.create("svg")
        }, e.addEventListener("DOMContentLoaded", function() {
            t.parser.draw || t.prepare();
        }, !1), t.regex = {
            numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
            hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
            rgb: /rgb\((\d+),(\d+),(\d+)\)/,
            reference: /#([a-z0-9\-_]+)/i,
            transforms: /\)\s*,?\s*/,
            whitespace: /\s/g,
            isHex: /^#[a-f0-9]{3,6}$/i,
            isRgb: /^rgb\(/,
            isCss: /[^:]+:[^;]+;?/,
            isBlank: /^(\s+)?$/,
            isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
            isPercent: /^-?[\d\.]+%$/,
            isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
            delimiter: /[\s,]+/,
            hyphen: /([^e])\-/gi,
            pathLetters: /[MLHVCSQTAZ]/gi,
            isPathLetter: /[MLHVCSQTAZ]/i,
            numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
            dots: /\./g
        }, t.utils = {
            map: function(l, u) {
                for(var x = l.length, v = [], k = 0; k < x; k++)v.push(u(l[k]));
                return v;
            },
            filter: function(l, u) {
                for(var x = l.length, v = [], k = 0; k < x; k++)u(l[k]) && v.push(l[k]);
                return v;
            },
            filterSVGElements: function(l) {
                return this.filter(l, function(u) {
                    return u instanceof y.SVGElement;
                });
            }
        }, t.defaults = {
            attrs: {
                "fill-opacity": 1,
                "stroke-opacity": 1,
                "stroke-width": 0,
                "stroke-linejoin": "miter",
                "stroke-linecap": "butt",
                fill: "#000000",
                stroke: "#000000",
                opacity: 1,
                x: 0,
                y: 0,
                cx: 0,
                cy: 0,
                width: 0,
                height: 0,
                r: 0,
                rx: 0,
                ry: 0,
                offset: 0,
                "stop-opacity": 1,
                "stop-color": "#000000",
                "font-size": 16,
                "font-family": "Helvetica, Arial, sans-serif",
                "text-anchor": "start"
            }
        }, t.Color = function(l) {
            var u, x;
            this.r = 0, this.g = 0, this.b = 0, l && (typeof l == "string" ? t.regex.isRgb.test(l) ? (u = t.regex.rgb.exec(l.replace(t.regex.whitespace, "")), this.r = parseInt(u[1]), this.g = parseInt(u[2]), this.b = parseInt(u[3])) : t.regex.isHex.test(l) && (u = t.regex.hex.exec((x = l).length == 4 ? [
                "#",
                x.substring(1, 2),
                x.substring(1, 2),
                x.substring(2, 3),
                x.substring(2, 3),
                x.substring(3, 4),
                x.substring(3, 4)
            ].join("") : x), this.r = parseInt(u[1], 16), this.g = parseInt(u[2], 16), this.b = parseInt(u[3], 16)) : U(l) === "object" && (this.r = l.r, this.g = l.g, this.b = l.b));
        }, t.extend(t.Color, {
            toString: function() {
                return this.toHex();
            },
            toHex: function() {
                return "#" + d(this.r) + d(this.g) + d(this.b);
            },
            toRgb: function() {
                return "rgb(" + [
                    this.r,
                    this.g,
                    this.b
                ].join() + ")";
            },
            brightness: function() {
                return this.r / 255 * 0.3 + this.g / 255 * 0.59 + this.b / 255 * 0.11;
            },
            morph: function(l) {
                return this.destination = new t.Color(l), this;
            },
            at: function(l) {
                return this.destination ? (l = l < 0 ? 0 : l > 1 ? 1 : l, new t.Color({
                    r: ~~(this.r + (this.destination.r - this.r) * l),
                    g: ~~(this.g + (this.destination.g - this.g) * l),
                    b: ~~(this.b + (this.destination.b - this.b) * l)
                })) : this;
            }
        }), t.Color.test = function(l) {
            return l += "", t.regex.isHex.test(l) || t.regex.isRgb.test(l);
        }, t.Color.isRgb = function(l) {
            return l && typeof l.r == "number" && typeof l.g == "number" && typeof l.b == "number";
        }, t.Color.isColor = function(l) {
            return t.Color.isRgb(l) || t.Color.test(l);
        }, t.Array = function(l, u) {
            (l = (l || []).valueOf()).length == 0 && u && (l = u.valueOf()), this.value = this.parse(l);
        }, t.extend(t.Array, {
            toString: function() {
                return this.value.join(" ");
            },
            valueOf: function() {
                return this.value;
            },
            parse: function(l) {
                return l = l.valueOf(), Array.isArray(l) ? l : this.split(l);
            }
        }), t.PointArray = function(l, u) {
            t.Array.call(this, l, u || [
                [
                    0,
                    0
                ]
            ]);
        }, t.PointArray.prototype = new t.Array(), t.PointArray.prototype.constructor = t.PointArray;
        for(var i = {
            M: function(l, u, x) {
                return u.x = x.x = l[0], u.y = x.y = l[1], [
                    "M",
                    u.x,
                    u.y
                ];
            },
            L: function(l, u) {
                return u.x = l[0], u.y = l[1], [
                    "L",
                    l[0],
                    l[1]
                ];
            },
            H: function(l, u) {
                return u.x = l[0], [
                    "H",
                    l[0]
                ];
            },
            V: function(l, u) {
                return u.y = l[0], [
                    "V",
                    l[0]
                ];
            },
            C: function(l, u) {
                return u.x = l[4], u.y = l[5], [
                    "C",
                    l[0],
                    l[1],
                    l[2],
                    l[3],
                    l[4],
                    l[5]
                ];
            },
            Q: function(l, u) {
                return u.x = l[2], u.y = l[3], [
                    "Q",
                    l[0],
                    l[1],
                    l[2],
                    l[3]
                ];
            },
            S: function(l, u) {
                return u.x = l[2], u.y = l[3], [
                    "S",
                    l[0],
                    l[1],
                    l[2],
                    l[3]
                ];
            },
            Z: function(l, u, x) {
                return u.x = x.x, u.y = x.y, [
                    "Z"
                ];
            }
        }, a = "mlhvqtcsaz".split(""), s = 0, r = a.length; s < r; ++s)i[a[s]] = function(l) {
            return function(u, x, v) {
                if (l == "H") u[0] = u[0] + x.x;
                else if (l == "V") u[0] = u[0] + x.y;
                else if (l == "A") u[5] = u[5] + x.x, u[6] = u[6] + x.y;
                else for(var k = 0, S = u.length; k < S; ++k)u[k] = u[k] + (k % 2 ? x.y : x.x);
                if (i && typeof i[l] == "function") return i[l](u, x, v);
            };
        }(a[s].toUpperCase());
        t.PathArray = function(l, u) {
            t.Array.call(this, l, u || [
                [
                    "M",
                    0,
                    0
                ]
            ]);
        }, t.PathArray.prototype = new t.Array(), t.PathArray.prototype.constructor = t.PathArray, t.extend(t.PathArray, {
            toString: function() {
                return function(l) {
                    for(var u = 0, x = l.length, v = ""; u < x; u++)v += l[u][0], l[u][1] != null && (v += l[u][1], l[u][2] != null && (v += " ", v += l[u][2], l[u][3] != null && (v += " ", v += l[u][3], v += " ", v += l[u][4], l[u][5] != null && (v += " ", v += l[u][5], v += " ", v += l[u][6], l[u][7] != null && (v += " ", v += l[u][7])))));
                    return v + " ";
                }(this.value);
            },
            move: function(l, u) {
                var x = this.bbox();
                return x.x, x.y, this;
            },
            at: function(l) {
                if (!this.destination) return this;
                for(var u = this.value, x = this.destination.value, v = [], k = new t.PathArray(), S = 0, C = u.length; S < C; S++){
                    v[S] = [
                        u[S][0]
                    ];
                    for(var L = 1, I = u[S].length; L < I; L++)v[S][L] = u[S][L] + (x[S][L] - u[S][L]) * l;
                    v[S][0] === "A" && (v[S][4] = +(v[S][4] != 0), v[S][5] = +(v[S][5] != 0));
                }
                return k.value = v, k;
            },
            parse: function(l) {
                if (l instanceof t.PathArray) return l.valueOf();
                var u, x = {
                    M: 2,
                    L: 2,
                    H: 1,
                    V: 1,
                    C: 6,
                    S: 4,
                    Q: 4,
                    T: 2,
                    A: 7,
                    Z: 0
                };
                l = typeof l == "string" ? l.replace(t.regex.numbersWithDots, o).replace(t.regex.pathLetters, " $& ").replace(t.regex.hyphen, "$1 -").trim().split(t.regex.delimiter) : l.reduce(function(I, z) {
                    return [].concat.call(I, z);
                }, []);
                var v = [], k = new t.Point(), S = new t.Point(), C = 0, L = l.length;
                do t.regex.isPathLetter.test(l[C]) ? (u = l[C], ++C) : u == "M" ? u = "L" : u == "m" && (u = "l"), v.push(i[u].call(null, l.slice(C, C += x[u.toUpperCase()]).map(parseFloat), k, S));
                while (L > C);
                return v;
            },
            bbox: function() {
                return t.parser.draw || t.prepare(), t.parser.path.setAttribute("d", this.toString()), t.parser.path.getBBox();
            }
        }), t.Number = t.invent({
            create: function(l, u) {
                this.value = 0, this.unit = u || "", typeof l == "number" ? this.value = isNaN(l) ? 0 : isFinite(l) ? l : l < 0 ? -340000000000000000000000000000000000000 : 34e37 : typeof l == "string" ? (u = l.match(t.regex.numberAndUnit)) && (this.value = parseFloat(u[1]), u[5] == "%" ? this.value /= 100 : u[5] == "s" && (this.value *= 1e3), this.unit = u[5]) : l instanceof t.Number && (this.value = l.valueOf(), this.unit = l.unit);
            },
            extend: {
                toString: function() {
                    return (this.unit == "%" ? ~~(1e8 * this.value) / 1e6 : this.unit == "s" ? this.value / 1e3 : this.value) + this.unit;
                },
                toJSON: function() {
                    return this.toString();
                },
                valueOf: function() {
                    return this.value;
                },
                plus: function(l) {
                    return l = new t.Number(l), new t.Number(this + l, this.unit || l.unit);
                },
                minus: function(l) {
                    return l = new t.Number(l), new t.Number(this - l, this.unit || l.unit);
                },
                times: function(l) {
                    return l = new t.Number(l), new t.Number(this * l, this.unit || l.unit);
                },
                divide: function(l) {
                    return l = new t.Number(l), new t.Number(this / l, this.unit || l.unit);
                },
                to: function(l) {
                    var u = new t.Number(this);
                    return typeof l == "string" && (u.unit = l), u;
                },
                morph: function(l) {
                    return this.destination = new t.Number(l), l.relative && (this.destination.value += this.value), this;
                },
                at: function(l) {
                    return this.destination ? new t.Number(this.destination).minus(this).times(l).plus(this) : this;
                }
            }
        }), t.Element = t.invent({
            create: function(l) {
                this._stroke = t.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = l) && (this.type = l.nodeName, this.node.instance = this, this._stroke = l.getAttribute("stroke") || this._stroke);
            },
            extend: {
                x: function(l) {
                    return this.attr("x", l);
                },
                y: function(l) {
                    return this.attr("y", l);
                },
                cx: function(l) {
                    return l == null ? this.x() + this.width() / 2 : this.x(l - this.width() / 2);
                },
                cy: function(l) {
                    return l == null ? this.y() + this.height() / 2 : this.y(l - this.height() / 2);
                },
                move: function(l, u) {
                    return this.x(l).y(u);
                },
                center: function(l, u) {
                    return this.cx(l).cy(u);
                },
                width: function(l) {
                    return this.attr("width", l);
                },
                height: function(l) {
                    return this.attr("height", l);
                },
                size: function(l, u) {
                    var x = g(this, l, u);
                    return this.width(new t.Number(x.width)).height(new t.Number(x.height));
                },
                clone: function(l) {
                    this.writeDataToDom();
                    var u = b(this.node.cloneNode(!0));
                    return l ? l.add(u) : this.after(u), u;
                },
                remove: function() {
                    return this.parent() && this.parent().removeElement(this), this;
                },
                replace: function(l) {
                    return this.after(l).remove(), l;
                },
                addTo: function(l) {
                    return l.put(this);
                },
                putIn: function(l) {
                    return l.add(this);
                },
                id: function(l) {
                    return this.attr("id", l);
                },
                show: function() {
                    return this.style("display", "");
                },
                hide: function() {
                    return this.style("display", "none");
                },
                visible: function() {
                    return this.style("display") != "none";
                },
                toString: function() {
                    return this.attr("id");
                },
                classes: function() {
                    var l = this.attr("class");
                    return l == null ? [] : l.trim().split(t.regex.delimiter);
                },
                hasClass: function(l) {
                    return this.classes().indexOf(l) != -1;
                },
                addClass: function(l) {
                    if (!this.hasClass(l)) {
                        var u = this.classes();
                        u.push(l), this.attr("class", u.join(" "));
                    }
                    return this;
                },
                removeClass: function(l) {
                    return this.hasClass(l) && this.attr("class", this.classes().filter(function(u) {
                        return u != l;
                    }).join(" ")), this;
                },
                toggleClass: function(l) {
                    return this.hasClass(l) ? this.removeClass(l) : this.addClass(l);
                },
                reference: function(l) {
                    return t.get(this.attr(l));
                },
                parent: function(l) {
                    var u = this;
                    if (!u.node.parentNode) return null;
                    if (u = t.adopt(u.node.parentNode), !l) return u;
                    for(; u && u.node instanceof y.SVGElement;){
                        if (typeof l == "string" ? u.matches(l) : u instanceof l) return u;
                        if (!u.node.parentNode || u.node.parentNode.nodeName == "#document") return null;
                        u = t.adopt(u.node.parentNode);
                    }
                },
                doc: function() {
                    return this instanceof t.Doc ? this : this.parent(t.Doc);
                },
                parents: function(l) {
                    var u = [], x = this;
                    do {
                        if (!(x = x.parent(l)) || !x.node) break;
                        u.push(x);
                    }while (x.parent);
                    return u;
                },
                matches: function(l) {
                    return function(u, x) {
                        return (u.matches || u.matchesSelector || u.msMatchesSelector || u.mozMatchesSelector || u.webkitMatchesSelector || u.oMatchesSelector).call(u, x);
                    }(this.node, l);
                },
                native: function() {
                    return this.node;
                },
                svg: function(l) {
                    var u = e.createElement("svg");
                    if (!(l && this instanceof t.Parent)) return u.appendChild(l = e.createElement("svg")), this.writeDataToDom(), l.appendChild(this.node.cloneNode(!0)), u.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                    u.innerHTML = "<svg>" + l.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                    for(var x = 0, v = u.firstChild.childNodes.length; x < v; x++)this.node.appendChild(u.firstChild.firstChild);
                    return this;
                },
                writeDataToDom: function() {
                    return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                        this.writeDataToDom();
                    }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
                },
                setData: function(l) {
                    return this.dom = l, this;
                },
                is: function(l) {
                    return function(u, x) {
                        return u instanceof x;
                    }(this, l);
                }
            }
        }), t.easing = {
            "-": function(l) {
                return l;
            },
            "<>": function(l) {
                return -Math.cos(l * Math.PI) / 2 + 0.5;
            },
            ">": function(l) {
                return Math.sin(l * Math.PI / 2);
            },
            "<": function(l) {
                return 1 - Math.cos(l * Math.PI / 2);
            }
        }, t.morph = function(l) {
            return function(u, x) {
                return new t.MorphObj(u, x).at(l);
            };
        }, t.Situation = t.invent({
            create: function(l) {
                this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new t.Number(l.duration).valueOf(), this.delay = new t.Number(l.delay).valueOf(), this.start = +/* @__PURE__ */ new Date() + this.delay, this.finish = this.start + this.duration, this.ease = l.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
            }
        }), t.FX = t.invent({
            create: function(l) {
                this._target = l, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
            },
            extend: {
                animate: function(l, u, x) {
                    U(l) === "object" && (u = l.ease, x = l.delay, l = l.duration);
                    var v = new t.Situation({
                        duration: l || 1e3,
                        delay: x || 0,
                        ease: t.easing[u || "-"] || u
                    });
                    return this.queue(v), this;
                },
                target: function(l) {
                    return l && l instanceof t.Element ? (this._target = l, this) : this._target;
                },
                timeToAbsPos: function(l) {
                    return (l - this.situation.start) / (this.situation.duration / this._speed);
                },
                absPosToTime: function(l) {
                    return this.situation.duration / this._speed * l + this.situation.start;
                },
                startAnimFrame: function() {
                    this.stopAnimFrame(), this.animationFrame = y.requestAnimationFrame((function() {
                        this.step();
                    }).bind(this));
                },
                stopAnimFrame: function() {
                    y.cancelAnimationFrame(this.animationFrame);
                },
                start: function() {
                    return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
                },
                startCurrent: function() {
                    return this.situation.start = +/* @__PURE__ */ new Date() + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
                },
                queue: function(l) {
                    return (typeof l == "function" || l instanceof t.Situation) && this.situations.push(l), this.situation || (this.situation = this.situations.shift()), this;
                },
                dequeue: function() {
                    return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof t.Situation ? this.start() : this.situation.call(this)), this;
                },
                initAnimations: function() {
                    var l, u = this.situation;
                    if (u.init) return this;
                    for(var x in u.animations){
                        l = this.target()[x](), Array.isArray(l) || (l = [
                            l
                        ]), Array.isArray(u.animations[x]) || (u.animations[x] = [
                            u.animations[x]
                        ]);
                        for(var v = l.length; v--;)u.animations[x][v] instanceof t.Number && (l[v] = new t.Number(l[v])), u.animations[x][v] = l[v].morph(u.animations[x][v]);
                    }
                    for(var x in u.attrs)u.attrs[x] = new t.MorphObj(this.target().attr(x), u.attrs[x]);
                    for(var x in u.styles)u.styles[x] = new t.MorphObj(this.target().style(x), u.styles[x]);
                    return u.initialTransformation = this.target().matrixify(), u.init = !0, this;
                },
                clearQueue: function() {
                    return this.situations = [], this;
                },
                clearCurrent: function() {
                    return this.situation = null, this;
                },
                stop: function(l, u) {
                    var x = this.active;
                    return this.active = !1, u && this.clearQueue(), l && this.situation && (!x && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
                },
                after: function(l) {
                    var u = this.last();
                    return this.target().on("finished.fx", function x(v) {
                        v.detail.situation == u && (l.call(this, u), this.off("finished.fx", x));
                    }), this._callStart();
                },
                during: function(l) {
                    var u = this.last(), x = function(v) {
                        v.detail.situation == u && l.call(this, v.detail.pos, t.morph(v.detail.pos), v.detail.eased, u);
                    };
                    return this.target().off("during.fx", x).on("during.fx", x), this.after(function() {
                        this.off("during.fx", x);
                    }), this._callStart();
                },
                afterAll: function(l) {
                    var u = function x(v) {
                        l.call(this), this.off("allfinished.fx", x);
                    };
                    return this.target().off("allfinished.fx", u).on("allfinished.fx", u), this._callStart();
                },
                last: function() {
                    return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
                },
                add: function(l, u, x) {
                    return this.last()[x || "animations"][l] = u, this._callStart();
                },
                step: function(l) {
                    var u, x, v;
                    l || (this.absPos = this.timeToAbsPos(+/* @__PURE__ */ new Date())), this.situation.loops !== !1 ? (u = Math.max(this.absPos, 0), x = Math.floor(u), this.situation.loops === !0 || x < this.situation.loops ? (this.pos = u - x, v = this.situation.loop, this.situation.loop = x) : (this.absPos = this.situation.loops, this.pos = 1, v = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != !!((this.situation.loop - v) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                    var k = this.situation.ease(this.pos);
                    for(var S in this.situation.once)S > this.lastPos && S <= k && (this.situation.once[S].call(this.target(), this.pos, k), delete this.situation.once[S]);
                    return this.active && this.target().fire("during", {
                        pos: this.pos,
                        eased: k,
                        fx: this,
                        situation: this.situation
                    }), this.situation ? (this.eachAt(), this.pos == 1 && !this.situation.reversed || this.situation.reversed && this.pos == 0 ? (this.stopAnimFrame(), this.target().fire("finished", {
                        fx: this,
                        situation: this.situation
                    }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = k, this) : this;
                },
                eachAt: function() {
                    var l, u = this, x = this.target(), v = this.situation;
                    for(var k in v.animations)l = [].concat(v.animations[k]).map(function(L) {
                        return typeof L != "string" && L.at ? L.at(v.ease(u.pos), u.pos) : L;
                    }), x[k].apply(x, l);
                    for(var k in v.attrs)l = [
                        k
                    ].concat(v.attrs[k]).map(function(I) {
                        return typeof I != "string" && I.at ? I.at(v.ease(u.pos), u.pos) : I;
                    }), x.attr.apply(x, l);
                    for(var k in v.styles)l = [
                        k
                    ].concat(v.styles[k]).map(function(I) {
                        return typeof I != "string" && I.at ? I.at(v.ease(u.pos), u.pos) : I;
                    }), x.style.apply(x, l);
                    if (v.transforms.length) {
                        l = v.initialTransformation, k = 0;
                        for(var S = v.transforms.length; k < S; k++){
                            var C = v.transforms[k];
                            C instanceof t.Matrix ? l = C.relative ? l.multiply(new t.Matrix().morph(C).at(v.ease(this.pos))) : l.morph(C).at(v.ease(this.pos)) : (C.relative || C.undo(l.extract()), l = l.multiply(C.at(v.ease(this.pos))));
                        }
                        x.matrix(l);
                    }
                    return this;
                },
                once: function(l, u, x) {
                    var v = this.last();
                    return x || (l = v.ease(l)), v.once[l] = u, this;
                },
                _callStart: function() {
                    return setTimeout((function() {
                        this.start();
                    }).bind(this), 0), this;
                }
            },
            parent: t.Element,
            construct: {
                animate: function(l, u, x) {
                    return (this.fx || (this.fx = new t.FX(this))).animate(l, u, x);
                },
                delay: function(l) {
                    return (this.fx || (this.fx = new t.FX(this))).delay(l);
                },
                stop: function(l, u) {
                    return this.fx && this.fx.stop(l, u), this;
                },
                finish: function() {
                    return this.fx && this.fx.finish(), this;
                }
            }
        }), t.MorphObj = t.invent({
            create: function(l, u) {
                return t.Color.isColor(u) ? new t.Color(l).morph(u) : t.regex.delimiter.test(l) ? t.regex.pathLetters.test(l) ? new t.PathArray(l).morph(u) : new t.Array(l).morph(u) : t.regex.numberAndUnit.test(u) ? new t.Number(l).morph(u) : (this.value = l, void (this.destination = u));
            },
            extend: {
                at: function(l, u) {
                    return u < 1 ? this.value : this.destination;
                },
                valueOf: function() {
                    return this.value;
                }
            }
        }), t.extend(t.FX, {
            attr: function(l, u, x) {
                if (U(l) === "object") for(var v in l)this.attr(v, l[v]);
                else this.add(l, u, "attrs");
                return this;
            },
            plot: function(l, u, x, v) {
                return arguments.length == 4 ? this.plot([
                    l,
                    u,
                    x,
                    v
                ]) : this.add("plot", new (this.target()).morphArray(l));
            }
        }), t.Box = t.invent({
            create: function(l, u, x, v) {
                if (!(U(l) !== "object" || l instanceof t.Element)) return t.Box.call(this, l.left != null ? l.left : l.x, l.top != null ? l.top : l.y, l.width, l.height);
                var k;
                arguments.length == 4 && (this.x = l, this.y = u, this.width = x, this.height = v), (k = this).x == null && (k.x = 0, k.y = 0, k.width = 0, k.height = 0), k.w = k.width, k.h = k.height, k.x2 = k.x + k.width, k.y2 = k.y + k.height, k.cx = k.x + k.width / 2, k.cy = k.y + k.height / 2;
            }
        }), t.BBox = t.invent({
            create: function(l) {
                if (t.Box.apply(this, [].slice.call(arguments)), l instanceof t.Element) {
                    var u;
                    try {
                        if (!e.documentElement.contains) {
                            for(var x = l.node; x.parentNode;)x = x.parentNode;
                            if (x != e) throw new Error("Element not in the dom");
                        }
                        u = l.node.getBBox();
                    } catch  {
                        if (l instanceof t.Shape) {
                            t.parser.draw || t.prepare();
                            var v = l.clone(t.parser.draw.instance).show();
                            v && v.node && typeof v.node.getBBox == "function" && (u = v.node.getBBox()), v && typeof v.remove == "function" && v.remove();
                        } else u = {
                            x: l.node.clientLeft,
                            y: l.node.clientTop,
                            width: l.node.clientWidth,
                            height: l.node.clientHeight
                        };
                    }
                    t.Box.call(this, u);
                }
            },
            inherit: t.Box,
            parent: t.Element,
            construct: {
                bbox: function() {
                    return new t.BBox(this);
                }
            }
        }), t.BBox.prototype.constructor = t.BBox, t.Matrix = t.invent({
            create: function(l) {
                var u = f([
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ]);
                l = l === null ? u : l instanceof t.Element ? l.matrixify() : typeof l == "string" ? f(l.split(t.regex.delimiter).map(parseFloat)) : arguments.length == 6 ? f([].slice.call(arguments)) : Array.isArray(l) ? f(l) : l && U(l) === "object" ? l : u;
                for(var x = w.length - 1; x >= 0; --x)this[w[x]] = l[w[x]] != null ? l[w[x]] : u[w[x]];
            },
            extend: {
                extract: function() {
                    var l = p(this, 0, 1);
                    p(this, 1, 0);
                    var u = 180 / Math.PI * Math.atan2(l.y, l.x) - 90;
                    return {
                        x: this.e,
                        y: this.f,
                        transformedX: (this.e * Math.cos(u * Math.PI / 180) + this.f * Math.sin(u * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                        transformedY: (this.f * Math.cos(u * Math.PI / 180) + this.e * Math.sin(-u * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                        rotation: u,
                        a: this.a,
                        b: this.b,
                        c: this.c,
                        d: this.d,
                        e: this.e,
                        f: this.f,
                        matrix: new t.Matrix(this)
                    };
                },
                clone: function() {
                    return new t.Matrix(this);
                },
                morph: function(l) {
                    return this.destination = new t.Matrix(l), this;
                },
                multiply: function(l) {
                    return new t.Matrix(this.native().multiply((function(u) {
                        return u instanceof t.Matrix || (u = new t.Matrix(u)), u;
                    })(l).native()));
                },
                inverse: function() {
                    return new t.Matrix(this.native().inverse());
                },
                translate: function(l, u) {
                    return new t.Matrix(this.native().translate(l || 0, u || 0));
                },
                native: function() {
                    for(var l = t.parser.native.createSVGMatrix(), u = w.length - 1; u >= 0; u--)l[w[u]] = this[w[u]];
                    return l;
                },
                toString: function() {
                    return "matrix(" + m(this.a) + "," + m(this.b) + "," + m(this.c) + "," + m(this.d) + "," + m(this.e) + "," + m(this.f) + ")";
                }
            },
            parent: t.Element,
            construct: {
                ctm: function() {
                    return new t.Matrix(this.node.getCTM());
                },
                screenCTM: function() {
                    if (this instanceof t.Nested) {
                        var l = this.rect(1, 1), u = l.node.getScreenCTM();
                        return l.remove(), new t.Matrix(u);
                    }
                    return new t.Matrix(this.node.getScreenCTM());
                }
            }
        }), t.Point = t.invent({
            create: function(l, u) {
                var x;
                x = Array.isArray(l) ? {
                    x: l[0],
                    y: l[1]
                } : U(l) === "object" ? {
                    x: l.x,
                    y: l.y
                } : l != null ? {
                    x: l,
                    y: u ?? l
                } : {
                    x: 0,
                    y: 0
                }, this.x = x.x, this.y = x.y;
            },
            extend: {
                clone: function() {
                    return new t.Point(this);
                },
                morph: function(l, u) {
                    return this.destination = new t.Point(l, u), this;
                }
            }
        }), t.extend(t.Element, {
            point: function(l, u) {
                return new t.Point(l, u).transform(this.screenCTM().inverse());
            }
        }), t.extend(t.Element, {
            attr: function(l, u, x) {
                if (l == null) {
                    for(l = {}, x = (u = this.node.attributes).length - 1; x >= 0; x--)l[u[x].nodeName] = t.regex.isNumber.test(u[x].nodeValue) ? parseFloat(u[x].nodeValue) : u[x].nodeValue;
                    return l;
                }
                if (U(l) === "object") for(var v in l)this.attr(v, l[v]);
                else if (u === null) this.node.removeAttribute(l);
                else {
                    if (u == null) return (u = this.node.getAttribute(l)) == null ? t.defaults.attrs[l] : t.regex.isNumber.test(u) ? parseFloat(u) : u;
                    l == "stroke-width" ? this.attr("stroke", parseFloat(u) > 0 ? this._stroke : null) : l == "stroke" && (this._stroke = u), l != "fill" && l != "stroke" || (t.regex.isImage.test(u) && (u = this.doc().defs().image(u, 0, 0)), u instanceof t.Image && (u = this.doc().defs().pattern(0, 0, function() {
                        this.add(u);
                    }))), typeof u == "number" ? u = new t.Number(u) : t.Color.isColor(u) ? u = new t.Color(u) : Array.isArray(u) && (u = new t.Array(u)), l == "leading" ? this.leading && this.leading(u) : typeof x == "string" ? this.node.setAttributeNS(x, l, u.toString()) : this.node.setAttribute(l, u.toString()), !this.rebuild || l != "font-size" && l != "x" || this.rebuild(l, u);
                }
                return this;
            }
        }), t.extend(t.Element, {
            transform: function(l, u) {
                var x;
                return U(l) !== "object" ? (x = new t.Matrix(this).extract(), typeof l == "string" ? x[l] : x) : (x = new t.Matrix(this), u = !!u || !!l.relative, l.a != null && (x = u ? x.multiply(new t.Matrix(l)) : new t.Matrix(l)), this.attr("transform", x));
            }
        }), t.extend(t.Element, {
            untransform: function() {
                return this.attr("transform", null);
            },
            matrixify: function() {
                return (this.attr("transform") || "").split(t.regex.transforms).slice(0, -1).map(function(l) {
                    var u = l.trim().split("(");
                    return [
                        u[0],
                        u[1].split(t.regex.delimiter).map(function(x) {
                            return parseFloat(x);
                        })
                    ];
                }).reduce(function(l, u) {
                    return u[0] == "matrix" ? l.multiply(f(u[1])) : l[u[0]].apply(l, u[1]);
                }, new t.Matrix());
            },
            toParent: function(l) {
                if (this == l) return this;
                var u = this.screenCTM(), x = l.screenCTM().inverse();
                return this.addTo(l).untransform().transform(x.multiply(u)), this;
            },
            toDoc: function() {
                return this.toParent(this.doc());
            }
        }), t.Transformation = t.invent({
            create: function(l, u) {
                if (arguments.length > 1 && typeof u != "boolean") return this.constructor.call(this, [].slice.call(arguments));
                if (Array.isArray(l)) for(var x = 0, v = this.arguments.length; x < v; ++x)this[this.arguments[x]] = l[x];
                else if (l && U(l) === "object") for(x = 0, v = this.arguments.length; x < v; ++x)this[this.arguments[x]] = l[this.arguments[x]];
                this.inversed = !1, u === !0 && (this.inversed = !0);
            }
        }), t.Translate = t.invent({
            parent: t.Matrix,
            inherit: t.Transformation,
            create: function(l, u) {
                this.constructor.apply(this, [].slice.call(arguments));
            },
            extend: {
                arguments: [
                    "transformedX",
                    "transformedY"
                ],
                method: "translate"
            }
        }), t.extend(t.Element, {
            style: function(l, u) {
                if (arguments.length == 0) return this.node.style.cssText || "";
                if (arguments.length < 2) {
                    if (U(l) === "object") for(var x in l)this.style(x, l[x]);
                    else {
                        if (!t.regex.isCss.test(l)) return this.node.style[h(l)];
                        for(l = l.split(/\s*;\s*/).filter(function(v) {
                            return !!v;
                        }).map(function(v) {
                            return v.split(/\s*:\s*/);
                        }); u = l.pop();)this.style(u[0], u[1]);
                    }
                } else this.node.style[h(l)] = u === null || t.regex.isBlank.test(u) ? "" : u;
                return this;
            }
        }), t.Parent = t.invent({
            create: function(l) {
                this.constructor.call(this, l);
            },
            inherit: t.Element,
            extend: {
                children: function() {
                    return t.utils.map(t.utils.filterSVGElements(this.node.childNodes), function(l) {
                        return t.adopt(l);
                    });
                },
                add: function(l, u) {
                    return u == null ? this.node.appendChild(l.node) : l.node != this.node.childNodes[u] && this.node.insertBefore(l.node, this.node.childNodes[u]), this;
                },
                put: function(l, u) {
                    return this.add(l, u), l;
                },
                has: function(l) {
                    return this.index(l) >= 0;
                },
                index: function(l) {
                    return [].slice.call(this.node.childNodes).indexOf(l.node);
                },
                get: function(l) {
                    return t.adopt(this.node.childNodes[l]);
                },
                first: function() {
                    return this.get(0);
                },
                last: function() {
                    return this.get(this.node.childNodes.length - 1);
                },
                each: function(l, u) {
                    for(var x = this.children(), v = 0, k = x.length; v < k; v++)x[v] instanceof t.Element && l.apply(x[v], [
                        v,
                        x
                    ]), u && x[v] instanceof t.Container && x[v].each(l, u);
                    return this;
                },
                removeElement: function(l) {
                    return this.node.removeChild(l.node), this;
                },
                clear: function() {
                    for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                    return delete this._defs, this;
                },
                defs: function() {
                    return this.doc().defs();
                }
            }
        }), t.extend(t.Parent, {
            ungroup: function(l, u) {
                return u === 0 || this instanceof t.Defs || this.node == t.parser.draw || (l = l || (this instanceof t.Doc ? this : this.parent(t.Parent)), u = u || 1 / 0, this.each(function() {
                    return this instanceof t.Defs ? this : this instanceof t.Parent ? this.ungroup(l, u - 1) : this.toParent(l);
                }), this.node.firstChild || this.remove()), this;
            },
            flatten: function(l, u) {
                return this.ungroup(l, u);
            }
        }), t.Container = t.invent({
            create: function(l) {
                this.constructor.call(this, l);
            },
            inherit: t.Parent
        }), t.ViewBox = t.invent({
            parent: t.Container,
            construct: {}
        }), [
            "click",
            "dblclick",
            "mousedown",
            "mouseup",
            "mouseover",
            "mouseout",
            "mousemove",
            "touchstart",
            "touchmove",
            "touchleave",
            "touchend",
            "touchcancel"
        ].forEach(function(l) {
            t.Element.prototype[l] = function(u) {
                return t.on(this.node, l, u), this;
            };
        }), t.listeners = [], t.handlerMap = [], t.listenerId = 0, t.on = function(l, u, x, v, k) {
            var S = x.bind(v || l.instance || l), C = (t.handlerMap.indexOf(l) + 1 || t.handlerMap.push(l)) - 1, L = u.split(".")[0], I = u.split(".")[1] || "*";
            t.listeners[C] = t.listeners[C] || {}, t.listeners[C][L] = t.listeners[C][L] || {}, t.listeners[C][L][I] = t.listeners[C][L][I] || {}, x._svgjsListenerId || (x._svgjsListenerId = ++t.listenerId), t.listeners[C][L][I][x._svgjsListenerId] = S, l.addEventListener(L, S, k || {
                passive: !0
            });
        }, t.off = function(l, u, x) {
            var v = t.handlerMap.indexOf(l), k = u && u.split(".")[0], S = u && u.split(".")[1], C = "";
            if (v != -1) {
                if (x) {
                    if (typeof x == "function" && (x = x._svgjsListenerId), !x) return;
                    t.listeners[v][k] && t.listeners[v][k][S || "*"] && (l.removeEventListener(k, t.listeners[v][k][S || "*"][x], !1), delete t.listeners[v][k][S || "*"][x]);
                } else if (S && k) {
                    if (t.listeners[v][k] && t.listeners[v][k][S]) {
                        for(var L in t.listeners[v][k][S])t.off(l, [
                            k,
                            S
                        ].join("."), L);
                        delete t.listeners[v][k][S];
                    }
                } else if (S) for(var I in t.listeners[v])for(var C in t.listeners[v][I])S === C && t.off(l, [
                    I,
                    S
                ].join("."));
                else if (k) {
                    if (t.listeners[v][k]) {
                        for(var C in t.listeners[v][k])t.off(l, [
                            k,
                            C
                        ].join("."));
                        delete t.listeners[v][k];
                    }
                } else {
                    for(var I in t.listeners[v])t.off(l, I);
                    delete t.listeners[v], delete t.handlerMap[v];
                }
            }
        }, t.extend(t.Element, {
            on: function(l, u, x, v) {
                return t.on(this.node, l, u, x, v), this;
            },
            off: function(l, u) {
                return t.off(this.node, l, u), this;
            },
            fire: function(l, u) {
                return l instanceof y.Event ? this.node.dispatchEvent(l) : this.node.dispatchEvent(l = new t.CustomEvent(l, {
                    detail: u,
                    cancelable: !0
                })), this._event = l, this;
            },
            event: function() {
                return this._event;
            }
        }), t.Defs = t.invent({
            create: "defs",
            inherit: t.Container
        }), t.G = t.invent({
            create: "g",
            inherit: t.Container,
            extend: {
                x: function(l) {
                    return l == null ? this.transform("x") : this.transform({
                        x: l - this.x()
                    }, !0);
                }
            },
            construct: {
                group: function() {
                    return this.put(new t.G());
                }
            }
        }), t.Doc = t.invent({
            create: function(l) {
                l && ((l = typeof l == "string" ? e.getElementById(l) : l).nodeName == "svg" ? this.constructor.call(this, l) : (this.constructor.call(this, t.create("svg")), l.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
            },
            inherit: t.Container,
            extend: {
                namespace: function() {
                    return this.attr({
                        xmlns: t.ns,
                        version: "1.1"
                    }).attr("xmlns:xlink", t.xlink, t.xmlns).attr("xmlns:svgjs", t.svgjs, t.xmlns);
                },
                defs: function() {
                    var l;
                    return this._defs || ((l = this.node.getElementsByTagName("defs")[0]) ? this._defs = t.adopt(l) : this._defs = new t.Defs(), this.node.appendChild(this._defs.node)), this._defs;
                },
                parent: function() {
                    return this.node.parentNode && this.node.parentNode.nodeName != "#document" ? this.node.parentNode : null;
                },
                remove: function() {
                    return this.parent() && this.parent().removeChild(this.node), this;
                },
                clear: function() {
                    for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                    return delete this._defs, t.parser.draw && !t.parser.draw.parentNode && this.node.appendChild(t.parser.draw), this;
                },
                clone: function(l) {
                    this.writeDataToDom();
                    var u = this.node, x = b(u.cloneNode(!0));
                    return l ? (l.node || l).appendChild(x.node) : u.parentNode.insertBefore(x.node, u.nextSibling), x;
                }
            }
        }), t.extend(t.Element, {}), t.Gradient = t.invent({
            create: function(l) {
                this.constructor.call(this, t.create(l + "Gradient")), this.type = l;
            },
            inherit: t.Container,
            extend: {
                at: function(l, u, x) {
                    return this.put(new t.Stop()).update(l, u, x);
                },
                update: function(l) {
                    return this.clear(), typeof l == "function" && l.call(this, this), this;
                },
                fill: function() {
                    return "url(#" + this.id() + ")";
                },
                toString: function() {
                    return this.fill();
                },
                attr: function(l, u, x) {
                    return l == "transform" && (l = "gradientTransform"), t.Container.prototype.attr.call(this, l, u, x);
                }
            },
            construct: {
                gradient: function(l, u) {
                    return this.defs().gradient(l, u);
                }
            }
        }), t.extend(t.Gradient, t.FX, {
            from: function(l, u) {
                return (this._target || this).type == "radial" ? this.attr({
                    fx: new t.Number(l),
                    fy: new t.Number(u)
                }) : this.attr({
                    x1: new t.Number(l),
                    y1: new t.Number(u)
                });
            },
            to: function(l, u) {
                return (this._target || this).type == "radial" ? this.attr({
                    cx: new t.Number(l),
                    cy: new t.Number(u)
                }) : this.attr({
                    x2: new t.Number(l),
                    y2: new t.Number(u)
                });
            }
        }), t.extend(t.Defs, {
            gradient: function(l, u) {
                return this.put(new t.Gradient(l)).update(u);
            }
        }), t.Stop = t.invent({
            create: "stop",
            inherit: t.Element,
            extend: {
                update: function(l) {
                    return (typeof l == "number" || l instanceof t.Number) && (l = {
                        offset: arguments[0],
                        color: arguments[1],
                        opacity: arguments[2]
                    }), l.opacity != null && this.attr("stop-opacity", l.opacity), l.color != null && this.attr("stop-color", l.color), l.offset != null && this.attr("offset", new t.Number(l.offset)), this;
                }
            }
        }), t.Pattern = t.invent({
            create: "pattern",
            inherit: t.Container,
            extend: {
                fill: function() {
                    return "url(#" + this.id() + ")";
                },
                update: function(l) {
                    return this.clear(), typeof l == "function" && l.call(this, this), this;
                },
                toString: function() {
                    return this.fill();
                },
                attr: function(l, u, x) {
                    return l == "transform" && (l = "patternTransform"), t.Container.prototype.attr.call(this, l, u, x);
                }
            },
            construct: {
                pattern: function(l, u, x) {
                    return this.defs().pattern(l, u, x);
                }
            }
        }), t.extend(t.Defs, {
            pattern: function(l, u, x) {
                return this.put(new t.Pattern()).update(x).attr({
                    x: 0,
                    y: 0,
                    width: l,
                    height: u,
                    patternUnits: "userSpaceOnUse"
                });
            }
        }), t.Shape = t.invent({
            create: function(l) {
                this.constructor.call(this, l);
            },
            inherit: t.Element
        }), t.Symbol = t.invent({
            create: "symbol",
            inherit: t.Container,
            construct: {
                symbol: function() {
                    return this.put(new t.Symbol());
                }
            }
        }), t.Use = t.invent({
            create: "use",
            inherit: t.Shape,
            extend: {
                element: function(l, u) {
                    return this.attr("href", (u || "") + "#" + l, t.xlink);
                }
            },
            construct: {
                use: function(l, u) {
                    return this.put(new t.Use()).element(l, u);
                }
            }
        }), t.Rect = t.invent({
            create: "rect",
            inherit: t.Shape,
            construct: {
                rect: function(l, u) {
                    return this.put(new t.Rect()).size(l, u);
                }
            }
        }), t.Circle = t.invent({
            create: "circle",
            inherit: t.Shape,
            construct: {
                circle: function(l) {
                    return this.put(new t.Circle()).rx(new t.Number(l).divide(2)).move(0, 0);
                }
            }
        }), t.extend(t.Circle, t.FX, {
            rx: function(l) {
                return this.attr("r", l);
            },
            ry: function(l) {
                return this.rx(l);
            }
        }), t.Ellipse = t.invent({
            create: "ellipse",
            inherit: t.Shape,
            construct: {
                ellipse: function(l, u) {
                    return this.put(new t.Ellipse()).size(l, u).move(0, 0);
                }
            }
        }), t.extend(t.Ellipse, t.Rect, t.FX, {
            rx: function(l) {
                return this.attr("rx", l);
            },
            ry: function(l) {
                return this.attr("ry", l);
            }
        }), t.extend(t.Circle, t.Ellipse, {
            x: function(l) {
                return l == null ? this.cx() - this.rx() : this.cx(l + this.rx());
            },
            y: function(l) {
                return l == null ? this.cy() - this.ry() : this.cy(l + this.ry());
            },
            cx: function(l) {
                return l == null ? this.attr("cx") : this.attr("cx", l);
            },
            cy: function(l) {
                return l == null ? this.attr("cy") : this.attr("cy", l);
            },
            width: function(l) {
                return l == null ? 2 * this.rx() : this.rx(new t.Number(l).divide(2));
            },
            height: function(l) {
                return l == null ? 2 * this.ry() : this.ry(new t.Number(l).divide(2));
            },
            size: function(l, u) {
                var x = g(this, l, u);
                return this.rx(new t.Number(x.width).divide(2)).ry(new t.Number(x.height).divide(2));
            }
        }), t.Line = t.invent({
            create: "line",
            inherit: t.Shape,
            extend: {
                array: function() {
                    return new t.PointArray([
                        [
                            this.attr("x1"),
                            this.attr("y1")
                        ],
                        [
                            this.attr("x2"),
                            this.attr("y2")
                        ]
                    ]);
                },
                plot: function(l, u, x, v) {
                    return l == null ? this.array() : (l = u !== void 0 ? {
                        x1: l,
                        y1: u,
                        x2: x,
                        y2: v
                    } : new t.PointArray(l).toLine(), this.attr(l));
                },
                move: function(l, u) {
                    return this.attr(this.array().move(l, u).toLine());
                },
                size: function(l, u) {
                    var x = g(this, l, u);
                    return this.attr(this.array().size(x.width, x.height).toLine());
                }
            },
            construct: {
                line: function(l, u, x, v) {
                    return t.Line.prototype.plot.apply(this.put(new t.Line()), l != null ? [
                        l,
                        u,
                        x,
                        v
                    ] : [
                        0,
                        0,
                        0,
                        0
                    ]);
                }
            }
        }), t.Polyline = t.invent({
            create: "polyline",
            inherit: t.Shape,
            construct: {
                polyline: function(l) {
                    return this.put(new t.Polyline()).plot(l || new t.PointArray());
                }
            }
        }), t.Polygon = t.invent({
            create: "polygon",
            inherit: t.Shape,
            construct: {
                polygon: function(l) {
                    return this.put(new t.Polygon()).plot(l || new t.PointArray());
                }
            }
        }), t.extend(t.Polyline, t.Polygon, {
            array: function() {
                return this._array || (this._array = new t.PointArray(this.attr("points")));
            },
            plot: function(l) {
                return l == null ? this.array() : this.clear().attr("points", typeof l == "string" ? l : this._array = new t.PointArray(l));
            },
            clear: function() {
                return delete this._array, this;
            },
            move: function(l, u) {
                return this.attr("points", this.array().move(l, u));
            },
            size: function(l, u) {
                var x = g(this, l, u);
                return this.attr("points", this.array().size(x.width, x.height));
            }
        }), t.extend(t.Line, t.Polyline, t.Polygon, {
            morphArray: t.PointArray,
            x: function(l) {
                return l == null ? this.bbox().x : this.move(l, this.bbox().y);
            },
            y: function(l) {
                return l == null ? this.bbox().y : this.move(this.bbox().x, l);
            },
            width: function(l) {
                var u = this.bbox();
                return l == null ? u.width : this.size(l, u.height);
            },
            height: function(l) {
                var u = this.bbox();
                return l == null ? u.height : this.size(u.width, l);
            }
        }), t.Path = t.invent({
            create: "path",
            inherit: t.Shape,
            extend: {
                morphArray: t.PathArray,
                array: function() {
                    return this._array || (this._array = new t.PathArray(this.attr("d")));
                },
                plot: function(l) {
                    return l == null ? this.array() : this.clear().attr("d", typeof l == "string" ? l : this._array = new t.PathArray(l));
                },
                clear: function() {
                    return delete this._array, this;
                }
            },
            construct: {
                path: function(l) {
                    return this.put(new t.Path()).plot(l || new t.PathArray());
                }
            }
        }), t.Image = t.invent({
            create: "image",
            inherit: t.Shape,
            extend: {
                load: function(l) {
                    if (!l) return this;
                    var u = this, x = new y.Image();
                    return t.on(x, "load", function() {
                        t.off(x);
                        var v = u.parent(t.Pattern);
                        v !== null && (u.width() == 0 && u.height() == 0 && u.size(x.width, x.height), v && v.width() == 0 && v.height() == 0 && v.size(u.width(), u.height()), typeof u._loaded == "function" && u._loaded.call(u, {
                            width: x.width,
                            height: x.height,
                            ratio: x.width / x.height,
                            url: l
                        }));
                    }), t.on(x, "error", function(v) {
                        t.off(x), typeof u._error == "function" && u._error.call(u, v);
                    }), this.attr("href", x.src = this.src = l, t.xlink);
                },
                loaded: function(l) {
                    return this._loaded = l, this;
                },
                error: function(l) {
                    return this._error = l, this;
                }
            },
            construct: {
                image: function(l, u, x) {
                    return this.put(new t.Image()).load(l).size(u || 0, x || u || 0);
                }
            }
        }), t.Text = t.invent({
            create: function() {
                this.constructor.call(this, t.create("text")), this.dom.leading = new t.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", t.defaults.attrs["font-family"]);
            },
            inherit: t.Shape,
            extend: {
                x: function(l) {
                    return l == null ? this.attr("x") : this.attr("x", l);
                },
                text: function(l) {
                    if (l === void 0) {
                        l = "";
                        for(var u = this.node.childNodes, x = 0, v = u.length; x < v; ++x)x != 0 && u[x].nodeType != 3 && t.adopt(u[x]).dom.newLined == 1 && (l += `
`), l += u[x].textContent;
                        return l;
                    }
                    if (this.clear().build(!0), typeof l == "function") l.call(this, this);
                    else {
                        x = 0;
                        for(var k = (l = l.split(`
`)).length; x < k; x++)this.tspan(l[x]).newLine();
                    }
                    return this.build(!1).rebuild();
                },
                size: function(l) {
                    return this.attr("font-size", l).rebuild();
                },
                leading: function(l) {
                    return l == null ? this.dom.leading : (this.dom.leading = new t.Number(l), this.rebuild());
                },
                lines: function() {
                    var l = (this.textPath && this.textPath() || this).node, u = t.utils.map(t.utils.filterSVGElements(l.childNodes), function(x) {
                        return t.adopt(x);
                    });
                    return new t.Set(u);
                },
                rebuild: function(l) {
                    if (typeof l == "boolean" && (this._rebuild = l), this._rebuild) {
                        var u = this, x = 0, v = this.dom.leading * new t.Number(this.attr("font-size"));
                        this.lines().each(function() {
                            this.dom.newLined && (u.textPath() || this.attr("x", u.attr("x")), this.text() == `
` ? x += v : (this.attr("dy", v + x), x = 0));
                        }), this.fire("rebuild");
                    }
                    return this;
                },
                build: function(l) {
                    return this._build = !!l, this;
                },
                setData: function(l) {
                    return this.dom = l, this.dom.leading = new t.Number(l.leading || 1.3), this;
                }
            },
            construct: {
                text: function(l) {
                    return this.put(new t.Text()).text(l);
                },
                plain: function(l) {
                    return this.put(new t.Text()).plain(l);
                }
            }
        }), t.Tspan = t.invent({
            create: "tspan",
            inherit: t.Shape,
            extend: {
                text: function(l) {
                    return l == null ? this.node.textContent + (this.dom.newLined ? `
` : "") : (typeof l == "function" ? l.call(this, this) : this.plain(l), this);
                },
                dx: function(l) {
                    return this.attr("dx", l);
                },
                dy: function(l) {
                    return this.attr("dy", l);
                },
                newLine: function() {
                    var l = this.parent(t.Text);
                    return this.dom.newLined = !0, this.dy(l.dom.leading * l.attr("font-size")).attr("x", l.x());
                }
            }
        }), t.extend(t.Text, t.Tspan, {
            plain: function(l) {
                return this._build === !1 && this.clear(), this.node.appendChild(e.createTextNode(l)), this;
            },
            tspan: function(l) {
                var u = (this.textPath && this.textPath() || this).node, x = new t.Tspan();
                return this._build === !1 && this.clear(), u.appendChild(x.node), x.text(l);
            },
            clear: function() {
                for(var l = (this.textPath && this.textPath() || this).node; l.hasChildNodes();)l.removeChild(l.lastChild);
                return this;
            },
            length: function() {
                return this.node.getComputedTextLength();
            }
        }), t.TextPath = t.invent({
            create: "textPath",
            inherit: t.Parent,
            parent: t.Text,
            construct: {
                morphArray: t.PathArray,
                array: function() {
                    var l = this.track();
                    return l ? l.array() : null;
                },
                plot: function(l) {
                    var u = this.track(), x = null;
                    return u && (x = u.plot(l)), l == null ? x : this;
                },
                track: function() {
                    var l = this.textPath();
                    if (l) return l.reference("href");
                },
                textPath: function() {
                    if (this.node.firstChild && this.node.firstChild.nodeName == "textPath") return t.adopt(this.node.firstChild);
                }
            }
        }), t.Nested = t.invent({
            create: function() {
                this.constructor.call(this, t.create("svg")), this.style("overflow", "visible");
            },
            inherit: t.Container,
            construct: {
                nested: function() {
                    return this.put(new t.Nested());
                }
            }
        });
        var n = {
            stroke: [
                "color",
                "width",
                "opacity",
                "linecap",
                "linejoin",
                "miterlimit",
                "dasharray",
                "dashoffset"
            ],
            fill: [
                "color",
                "opacity",
                "rule"
            ],
            prefix: function(l, u) {
                return u == "color" ? l : l + "-" + u;
            }
        };
        function o(l, u, x, v) {
            return x + v.replace(t.regex.dots, " .");
        }
        function h(l) {
            return l.toLowerCase().replace(/-(.)/g, function(u, x) {
                return x.toUpperCase();
            });
        }
        function c(l) {
            return l.charAt(0).toUpperCase() + l.slice(1);
        }
        function d(l) {
            var u = l.toString(16);
            return u.length == 1 ? "0" + u : u;
        }
        function g(l, u, x) {
            if (u == null || x == null) {
                var v = l.bbox();
                u == null ? u = v.width / v.height * x : x == null && (x = v.height / v.width * u);
            }
            return {
                width: u,
                height: x
            };
        }
        function p(l, u, x) {
            return {
                x: u * l.a + x * l.c + 0,
                y: u * l.b + x * l.d + 0
            };
        }
        function f(l) {
            return {
                a: l[0],
                b: l[1],
                c: l[2],
                d: l[3],
                e: l[4],
                f: l[5]
            };
        }
        function b(l) {
            for(var u = l.childNodes.length - 1; u >= 0; u--)l.childNodes[u] instanceof y.SVGElement && b(l.childNodes[u]);
            return t.adopt(l).id(t.eid(l.nodeName));
        }
        function m(l) {
            return Math.abs(l) > 1e-37 ? l : 0;
        }
        [
            "fill",
            "stroke"
        ].forEach(function(l) {
            var u = {};
            u[l] = function(x) {
                if (x === void 0) return this;
                if (typeof x == "string" || t.Color.isRgb(x) || x && typeof x.fill == "function") this.attr(l, x);
                else for(var v = n[l].length - 1; v >= 0; v--)x[n[l][v]] != null && this.attr(n.prefix(l, n[l][v]), x[n[l][v]]);
                return this;
            }, t.extend(t.Element, t.FX, u);
        }), t.extend(t.Element, t.FX, {
            translate: function(l, u) {
                return this.transform({
                    x: l,
                    y: u
                });
            },
            matrix: function(l) {
                return this.attr("transform", new t.Matrix(arguments.length == 6 ? [].slice.call(arguments) : l));
            },
            opacity: function(l) {
                return this.attr("opacity", l);
            },
            dx: function(l) {
                return this.x(new t.Number(l).plus(this instanceof t.FX ? 0 : this.x()), !0);
            },
            dy: function(l) {
                return this.y(new t.Number(l).plus(this instanceof t.FX ? 0 : this.y()), !0);
            }
        }), t.extend(t.Path, {
            length: function() {
                return this.node.getTotalLength();
            },
            pointAt: function(l) {
                return this.node.getPointAtLength(l);
            }
        }), t.Set = t.invent({
            create: function(l) {
                Array.isArray(l) ? this.members = l : this.clear();
            },
            extend: {
                add: function() {
                    for(var l = [].slice.call(arguments), u = 0, x = l.length; u < x; u++)this.members.push(l[u]);
                    return this;
                },
                remove: function(l) {
                    var u = this.index(l);
                    return u > -1 && this.members.splice(u, 1), this;
                },
                each: function(l) {
                    for(var u = 0, x = this.members.length; u < x; u++)l.apply(this.members[u], [
                        u,
                        this.members
                    ]);
                    return this;
                },
                clear: function() {
                    return this.members = [], this;
                },
                length: function() {
                    return this.members.length;
                },
                has: function(l) {
                    return this.index(l) >= 0;
                },
                index: function(l) {
                    return this.members.indexOf(l);
                },
                get: function(l) {
                    return this.members[l];
                },
                first: function() {
                    return this.get(0);
                },
                last: function() {
                    return this.get(this.members.length - 1);
                },
                valueOf: function() {
                    return this.members;
                }
            },
            construct: {
                set: function(l) {
                    return new t.Set(l);
                }
            }
        }), t.FX.Set = t.invent({
            create: function(l) {
                this.set = l;
            }
        }), t.Set.inherit = function() {
            var l = [];
            for(var u in t.Shape.prototype)typeof t.Shape.prototype[u] == "function" && typeof t.Set.prototype[u] != "function" && l.push(u);
            for(var u in l.forEach(function(v) {
                t.Set.prototype[v] = function() {
                    for(var k = 0, S = this.members.length; k < S; k++)this.members[k] && typeof this.members[k][v] == "function" && this.members[k][v].apply(this.members[k], arguments);
                    return v == "animate" ? this.fx || (this.fx = new t.FX.Set(this)) : this;
                };
            }), l = [], t.FX.prototype)typeof t.FX.prototype[u] == "function" && typeof t.FX.Set.prototype[u] != "function" && l.push(u);
            l.forEach(function(x) {
                t.FX.Set.prototype[x] = function() {
                    for(var v = 0, k = this.set.members.length; v < k; v++)this.set.members[v].fx[x].apply(this.set.members[v].fx, arguments);
                    return this;
                };
            });
        }, t.extend(t.Element, {}), t.extend(t.Element, {
            remember: function(l, u) {
                if (U(arguments[0]) === "object") for(var x in l)this.remember(x, l[x]);
                else {
                    if (arguments.length == 1) return this.memory()[l];
                    this.memory()[l] = u;
                }
                return this;
            },
            forget: function() {
                if (arguments.length == 0) this._memory = {};
                else for(var l = arguments.length - 1; l >= 0; l--)delete this.memory()[arguments[l]];
                return this;
            },
            memory: function() {
                return this._memory || (this._memory = {});
            }
        }), t.get = function(l) {
            var u = e.getElementById(function(x) {
                var v = (x || "").toString().match(t.regex.reference);
                if (v) return v[1];
            }(l) || l);
            return t.adopt(u);
        }, t.select = function(l, u) {
            return new t.Set(t.utils.map((u || e).querySelectorAll(l), function(x) {
                return t.adopt(x);
            }));
        }, t.extend(t.Parent, {
            select: function(l) {
                return t.select(l, this.node);
            }
        });
        var w = "abcdef".split("");
        if (typeof y.CustomEvent != "function") {
            var A = function(l, u) {
                u = u || {
                    bubbles: !1,
                    cancelable: !1,
                    detail: void 0
                };
                var x = e.createEvent("CustomEvent");
                return x.initCustomEvent(l, u.bubbles, u.cancelable, u.detail), x;
            };
            A.prototype = y.Event.prototype, t.CustomEvent = A;
        } else t.CustomEvent = y.CustomEvent;
        return t;
    }, U(Re) === "object" ? _.exports = be.document ? Fe(be, be.document) : function(y) {
        return Fe(y, y.document);
    } : be.SVG = Fe(be, be.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
  * https://github.com/wout/svg.filter.js
  * Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
        SVG.Filter = SVG.invent({
            create: "filter",
            inherit: SVG.Parent,
            extend: {
                source: "SourceGraphic",
                sourceAlpha: "SourceAlpha",
                background: "BackgroundImage",
                backgroundAlpha: "BackgroundAlpha",
                fill: "FillPaint",
                stroke: "StrokePaint",
                autoSetIn: !0,
                put: function(r, n) {
                    return this.add(r, n), !r.attr("in") && this.autoSetIn && r.attr("in", this.source), r.attr("result") || r.attr("result", r), r;
                },
                blend: function(r, n, o) {
                    return this.put(new SVG.BlendEffect(r, n, o));
                },
                colorMatrix: function(r, n) {
                    return this.put(new SVG.ColorMatrixEffect(r, n));
                },
                convolveMatrix: function(r) {
                    return this.put(new SVG.ConvolveMatrixEffect(r));
                },
                componentTransfer: function(r) {
                    return this.put(new SVG.ComponentTransferEffect(r));
                },
                composite: function(r, n, o) {
                    return this.put(new SVG.CompositeEffect(r, n, o));
                },
                flood: function(r, n) {
                    return this.put(new SVG.FloodEffect(r, n));
                },
                offset: function(r, n) {
                    return this.put(new SVG.OffsetEffect(r, n));
                },
                image: function(r) {
                    return this.put(new SVG.ImageEffect(r));
                },
                merge: function() {
                    var r = [
                        void 0
                    ];
                    for(var n in arguments)r.push(arguments[n]);
                    return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, r))());
                },
                gaussianBlur: function(r, n) {
                    return this.put(new SVG.GaussianBlurEffect(r, n));
                },
                morphology: function(r, n) {
                    return this.put(new SVG.MorphologyEffect(r, n));
                },
                diffuseLighting: function(r, n, o) {
                    return this.put(new SVG.DiffuseLightingEffect(r, n, o));
                },
                displacementMap: function(r, n, o, h, c) {
                    return this.put(new SVG.DisplacementMapEffect(r, n, o, h, c));
                },
                specularLighting: function(r, n, o, h) {
                    return this.put(new SVG.SpecularLightingEffect(r, n, o, h));
                },
                tile: function() {
                    return this.put(new SVG.TileEffect());
                },
                turbulence: function(r, n, o, h, c) {
                    return this.put(new SVG.TurbulenceEffect(r, n, o, h, c));
                },
                toString: function() {
                    return "url(#" + this.attr("id") + ")";
                }
            }
        }), SVG.extend(SVG.Defs, {
            filter: function(r) {
                var n = this.put(new SVG.Filter());
                return typeof r == "function" && r.call(n, n), n;
            }
        }), SVG.extend(SVG.Container, {
            filter: function(r) {
                return this.defs().filter(r);
            }
        }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
            filter: function(r) {
                return this.filterer = r instanceof SVG.Element ? r : this.doc().filter(r), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
            },
            unfilter: function(r) {
                return this.filterer && r === !0 && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
            }
        }), SVG.Effect = SVG.invent({
            create: function() {
                this.constructor.call(this);
            },
            inherit: SVG.Element,
            extend: {
                in: function(r) {
                    return r == null ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", r);
                },
                result: function(r) {
                    return r == null ? this.attr("result") : this.attr("result", r);
                },
                toString: function() {
                    return this.result();
                }
            }
        }), SVG.ParentEffect = SVG.invent({
            create: function() {
                this.constructor.call(this);
            },
            inherit: SVG.Parent,
            extend: {
                in: function(r) {
                    return r == null ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", r);
                },
                result: function(r) {
                    return r == null ? this.attr("result") : this.attr("result", r);
                },
                toString: function() {
                    return this.result();
                }
            }
        });
        var y = {
            blend: function(r, n) {
                return this.parent() && this.parent().blend(this, r, n);
            },
            colorMatrix: function(r, n) {
                return this.parent() && this.parent().colorMatrix(r, n).in(this);
            },
            convolveMatrix: function(r) {
                return this.parent() && this.parent().convolveMatrix(r).in(this);
            },
            componentTransfer: function(r) {
                return this.parent() && this.parent().componentTransfer(r).in(this);
            },
            composite: function(r, n) {
                return this.parent() && this.parent().composite(this, r, n);
            },
            flood: function(r, n) {
                return this.parent() && this.parent().flood(r, n);
            },
            offset: function(r, n) {
                return this.parent() && this.parent().offset(r, n).in(this);
            },
            image: function(r) {
                return this.parent() && this.parent().image(r);
            },
            merge: function() {
                return this.parent() && this.parent().merge.apply(this.parent(), [
                    this
                ].concat(arguments));
            },
            gaussianBlur: function(r, n) {
                return this.parent() && this.parent().gaussianBlur(r, n).in(this);
            },
            morphology: function(r, n) {
                return this.parent() && this.parent().morphology(r, n).in(this);
            },
            diffuseLighting: function(r, n, o) {
                return this.parent() && this.parent().diffuseLighting(r, n, o).in(this);
            },
            displacementMap: function(r, n, o, h) {
                return this.parent() && this.parent().displacementMap(this, r, n, o, h);
            },
            specularLighting: function(r, n, o, h) {
                return this.parent() && this.parent().specularLighting(r, n, o, h).in(this);
            },
            tile: function() {
                return this.parent() && this.parent().tile().in(this);
            },
            turbulence: function(r, n, o, h, c) {
                return this.parent() && this.parent().turbulence(r, n, o, h, c).in(this);
            }
        };
        SVG.extend(SVG.Effect, y), SVG.extend(SVG.ParentEffect, y), SVG.ChildEffect = SVG.invent({
            create: function() {
                this.constructor.call(this);
            },
            inherit: SVG.Element,
            extend: {
                in: function(r) {
                    this.attr("in", r);
                }
            }
        });
        var e = {
            blend: function(r, n, o) {
                this.attr({
                    in: r,
                    in2: n,
                    mode: o || "normal"
                });
            },
            colorMatrix: function(r, n) {
                r == "matrix" && (n = a(n)), this.attr({
                    type: r,
                    values: n === void 0 ? null : n
                });
            },
            convolveMatrix: function(r) {
                r = a(r), this.attr({
                    order: Math.sqrt(r.split(" ").length),
                    kernelMatrix: r
                });
            },
            composite: function(r, n, o) {
                this.attr({
                    in: r,
                    in2: n,
                    operator: o
                });
            },
            flood: function(r, n) {
                this.attr("flood-color", r), n != null && this.attr("flood-opacity", n);
            },
            offset: function(r, n) {
                this.attr({
                    dx: r,
                    dy: n
                });
            },
            image: function(r) {
                this.attr("href", r, SVG.xlink);
            },
            displacementMap: function(r, n, o, h, c) {
                this.attr({
                    in: r,
                    in2: n,
                    scale: o,
                    xChannelSelector: h,
                    yChannelSelector: c
                });
            },
            gaussianBlur: function(r, n) {
                r != null || n != null ? this.attr("stdDeviation", function(o) {
                    if (!Array.isArray(o)) return o;
                    for(var h = 0, c = o.length, d = []; h < c; h++)d.push(o[h]);
                    return d.join(" ");
                }(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
            },
            morphology: function(r, n) {
                this.attr({
                    operator: r,
                    radius: n
                });
            },
            tile: function() {},
            turbulence: function(r, n, o, h, c) {
                this.attr({
                    numOctaves: n,
                    seed: o,
                    stitchTiles: h,
                    baseFrequency: r,
                    type: c
                });
            }
        }, t = {
            merge: function() {
                var r;
                if (arguments[0] instanceof SVG.Set) {
                    var n = this;
                    arguments[0].each(function(h) {
                        this instanceof SVG.MergeNode ? n.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && n.put(new SVG.MergeNode(this));
                    });
                } else {
                    r = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                    for(var o = 0; o < r.length; o++)r[o] instanceof SVG.MergeNode ? this.put(r[o]) : this.put(new SVG.MergeNode(r[o]));
                }
            },
            componentTransfer: function(r) {
                if (this.rgb = new SVG.Set(), [
                    "r",
                    "g",
                    "b",
                    "a"
                ].forEach((function(o) {
                    this[o] = new SVG["Func" + o.toUpperCase()]("identity"), this.rgb.add(this[o]), this.node.appendChild(this[o].node);
                }).bind(this)), r) for(var n in r.rgb && ([
                    "r",
                    "g",
                    "b"
                ].forEach((function(o) {
                    this[o].attr(r.rgb);
                }).bind(this)), delete r.rgb), r)this[n].attr(r[n]);
            },
            diffuseLighting: function(r, n, o) {
                this.attr({
                    surfaceScale: r,
                    diffuseConstant: n,
                    kernelUnitLength: o
                });
            },
            specularLighting: function(r, n, o, h) {
                this.attr({
                    surfaceScale: r,
                    diffuseConstant: n,
                    specularExponent: o,
                    kernelUnitLength: h
                });
            }
        }, i = {
            distantLight: function(r, n) {
                this.attr({
                    azimuth: r,
                    elevation: n
                });
            },
            pointLight: function(r, n, o) {
                this.attr({
                    x: r,
                    y: n,
                    z: o
                });
            },
            spotLight: function(r, n, o, h, c, d) {
                this.attr({
                    x: r,
                    y: n,
                    z: o,
                    pointsAtX: h,
                    pointsAtY: c,
                    pointsAtZ: d
                });
            },
            mergeNode: function(r) {
                this.attr("in", r);
            }
        };
        function a(r) {
            return Array.isArray(r) && (r = new SVG.Array(r)), r.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
        }
        function s() {
            var r = function() {};
            for(var n in typeof arguments[arguments.length - 1] == "function" && (r = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var o in arguments[n])r(arguments[n][o], o, arguments[n]);
        }
        [
            "r",
            "g",
            "b",
            "a"
        ].forEach(function(r) {
            i["Func" + r.toUpperCase()] = function(n) {
                switch(this.attr("type", n), n){
                    case "table":
                        this.attr("tableValues", arguments[1]);
                        break;
                    case "linear":
                        this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                        break;
                    case "gamma":
                        this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
                }
            };
        }), s(e, function(r, n) {
            var o = n.charAt(0).toUpperCase() + n.slice(1);
            SVG[o + "Effect"] = SVG.invent({
                create: function() {
                    this.constructor.call(this, SVG.create("fe" + o)), r.apply(this, arguments), this.result(this.attr("id") + "Out");
                },
                inherit: SVG.Effect,
                extend: {}
            });
        }), s(t, function(r, n) {
            var o = n.charAt(0).toUpperCase() + n.slice(1);
            SVG[o + "Effect"] = SVG.invent({
                create: function() {
                    this.constructor.call(this, SVG.create("fe" + o)), r.apply(this, arguments), this.result(this.attr("id") + "Out");
                },
                inherit: SVG.ParentEffect,
                extend: {}
            });
        }), s(i, function(r, n) {
            var o = n.charAt(0).toUpperCase() + n.slice(1);
            SVG[o] = SVG.invent({
                create: function() {
                    this.constructor.call(this, SVG.create("fe" + o)), r.apply(this, arguments);
                },
                inherit: SVG.ChildEffect,
                extend: {}
            });
        }), SVG.extend(SVG.MergeEffect, {
            in: function(r) {
                return r instanceof SVG.MergeNode ? this.add(r, 0) : this.add(new SVG.MergeNode(r), 0), this;
            }
        }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
            in2: function(r) {
                return r == null ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", r);
            }
        }), SVG.filter = {
            sepiatone: [
                0.343,
                0.669,
                0.119,
                0,
                0,
                0.249,
                0.626,
                0.13,
                0,
                0,
                0.172,
                0.334,
                0.111,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        };
    }).call(void 0), function() {
        function y(s, r, n, o, h, c, d) {
            for(var g = s.slice(r, n || d), p = o.slice(h, c || d), f = 0, b = {
                pos: [
                    0,
                    0
                ],
                start: [
                    0,
                    0
                ]
            }, m = {
                pos: [
                    0,
                    0
                ],
                start: [
                    0,
                    0
                ]
            }; g[f] = e.call(b, g[f]), p[f] = e.call(m, p[f]), g[f][0] != p[f][0] || g[f][0] == "M" || g[f][0] == "A" && (g[f][4] != p[f][4] || g[f][5] != p[f][5]) ? (Array.prototype.splice.apply(g, [
                f,
                1
            ].concat(i.call(b, g[f]))), Array.prototype.splice.apply(p, [
                f,
                1
            ].concat(i.call(m, p[f])))) : (g[f] = t.call(b, g[f]), p[f] = t.call(m, p[f])), !(++f == g.length && f == p.length);)f == g.length && g.push([
                "C",
                b.pos[0],
                b.pos[1],
                b.pos[0],
                b.pos[1],
                b.pos[0],
                b.pos[1]
            ]), f == p.length && p.push([
                "C",
                m.pos[0],
                m.pos[1],
                m.pos[0],
                m.pos[1],
                m.pos[0],
                m.pos[1]
            ]);
            return {
                start: g,
                dest: p
            };
        }
        function e(s) {
            switch(s[0]){
                case "z":
                case "Z":
                    s[0] = "L", s[1] = this.start[0], s[2] = this.start[1];
                    break;
                case "H":
                    s[0] = "L", s[2] = this.pos[1];
                    break;
                case "V":
                    s[0] = "L", s[2] = s[1], s[1] = this.pos[0];
                    break;
                case "T":
                    s[0] = "Q", s[3] = s[1], s[4] = s[2], s[1] = this.reflection[1], s[2] = this.reflection[0];
                    break;
                case "S":
                    s[0] = "C", s[6] = s[4], s[5] = s[3], s[4] = s[2], s[3] = s[1], s[2] = this.reflection[1], s[1] = this.reflection[0];
            }
            return s;
        }
        function t(s) {
            var r = s.length;
            return this.pos = [
                s[r - 2],
                s[r - 1]
            ], "SCQT".indexOf(s[0]) != -1 && (this.reflection = [
                2 * this.pos[0] - s[r - 4],
                2 * this.pos[1] - s[r - 3]
            ]), s;
        }
        function i(s) {
            var r = [
                s
            ];
            switch(s[0]){
                case "M":
                    return this.pos = this.start = [
                        s[1],
                        s[2]
                    ], r;
                case "L":
                    s[5] = s[3] = s[1], s[6] = s[4] = s[2], s[1] = this.pos[0], s[2] = this.pos[1];
                    break;
                case "Q":
                    s[6] = s[4], s[5] = s[3], s[4] = 1 * s[4] / 3 + 2 * s[2] / 3, s[3] = 1 * s[3] / 3 + 2 * s[1] / 3, s[2] = 1 * this.pos[1] / 3 + 2 * s[2] / 3, s[1] = 1 * this.pos[0] / 3 + 2 * s[1] / 3;
                    break;
                case "A":
                    r = function(n, o) {
                        var h, c, d, g, p, f, b, m, w, A, l, u, x, v, k, S, C, L, I, z, T, E, R, O, D, W, N = Math.abs(o[1]), V = Math.abs(o[2]), j = o[3] % 360, se = o[4], K = o[5], le = o[6], he = o[7], $ = new SVG.Point(n), Q = new SVG.Point(le, he), dt = [];
                        if (N === 0 || V === 0 || $.x === Q.x && $.y === Q.y) return [
                            [
                                "C",
                                $.x,
                                $.y,
                                Q.x,
                                Q.y,
                                Q.x,
                                Q.y
                            ]
                        ];
                        for(h = new SVG.Point(($.x - Q.x) / 2, ($.y - Q.y) / 2).transform(new SVG.Matrix().rotate(j)), (c = h.x * h.x / (N * N) + h.y * h.y / (V * V)) > 1 && (N *= c = Math.sqrt(c), V *= c), d = new SVG.Matrix().rotate(j).scale(1 / N, 1 / V).rotate(-j), $ = $.transform(d), Q = Q.transform(d), g = [
                            Q.x - $.x,
                            Q.y - $.y
                        ], f = g[0] * g[0] + g[1] * g[1], p = Math.sqrt(f), g[0] /= p, g[1] /= p, b = f < 4 ? Math.sqrt(1 - f / 4) : 0, se === K && (b *= -1), m = new SVG.Point((Q.x + $.x) / 2 + b * -g[1], (Q.y + $.y) / 2 + b * g[0]), w = new SVG.Point($.x - m.x, $.y - m.y), A = new SVG.Point(Q.x - m.x, Q.y - m.y), l = Math.acos(w.x / Math.sqrt(w.x * w.x + w.y * w.y)), w.y < 0 && (l *= -1), u = Math.acos(A.x / Math.sqrt(A.x * A.x + A.y * A.y)), A.y < 0 && (u *= -1), K && l > u && (u += 2 * Math.PI), !K && l < u && (u -= 2 * Math.PI), v = Math.ceil(2 * Math.abs(l - u) / Math.PI), S = [], C = l, x = (u - l) / v, k = 4 * Math.tan(x / 4) / 3, T = 0; T <= v; T++)I = Math.cos(C), L = Math.sin(C), z = new SVG.Point(m.x + I, m.y + L), S[T] = [
                            new SVG.Point(z.x + k * L, z.y - k * I),
                            z,
                            new SVG.Point(z.x - k * L, z.y + k * I)
                        ], C += x;
                        for(S[0][0] = S[0][1].clone(), S[S.length - 1][2] = S[S.length - 1][1].clone(), d = new SVG.Matrix().rotate(j).scale(N, V).rotate(-j), T = 0, E = S.length; T < E; T++)S[T][0] = S[T][0].transform(d), S[T][1] = S[T][1].transform(d), S[T][2] = S[T][2].transform(d);
                        for(T = 1, E = S.length; T < E; T++)R = (z = S[T - 1][2]).x, O = z.y, D = (z = S[T][0]).x, W = z.y, le = (z = S[T][1]).x, he = z.y, dt.push([
                            "C",
                            R,
                            O,
                            D,
                            W,
                            le,
                            he
                        ]);
                        return dt;
                    }(this.pos, s), s = r[0];
            }
            return s[0] = "C", this.pos = [
                s[5],
                s[6]
            ], this.reflection = [
                2 * s[5] - s[3],
                2 * s[6] - s[4]
            ], r;
        }
        function a(s, r) {
            if (r === !1) return !1;
            for(var n = r, o = s.length; n < o; ++n)if (s[n][0] == "M") return n;
            return !1;
        }
        SVG.extend(SVG.PathArray, {
            morph: function(s) {
                for(var r = this.value, n = this.parse(s), o = 0, h = 0, c = !1, d = !1; o !== !1 || h !== !1;){
                    var g;
                    c = a(r, o !== !1 && o + 1), d = a(n, h !== !1 && h + 1), o === !1 && (o = (g = new SVG.PathArray(p.start).bbox()).height == 0 || g.width == 0 ? r.push(r[0]) - 1 : r.push([
                        "M",
                        g.x + g.width / 2,
                        g.y + g.height / 2
                    ]) - 1), h === !1 && (h = (g = new SVG.PathArray(p.dest).bbox()).height == 0 || g.width == 0 ? n.push(n[0]) - 1 : n.push([
                        "M",
                        g.x + g.width / 2,
                        g.y + g.height / 2
                    ]) - 1);
                    var p = y(r, o, c, n, h, d);
                    r = r.slice(0, o).concat(p.start, c === !1 ? [] : r.slice(c)), n = n.slice(0, h).concat(p.dest, d === !1 ? [] : n.slice(d)), o = c !== !1 && o + p.start.length, h = d !== !1 && h + p.dest.length;
                }
                return this.value = r, this.destination = new SVG.PathArray(), this.destination.value = n, this;
            }
        });
    }(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
  * https://github.com/svgdotjs/svg.draggable.js
  * Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
        function y(e) {
            e.remember("_draggable", this), this.el = e;
        }
        y.prototype.init = function(e, t) {
            var i = this;
            this.constraint = e, this.value = t, this.el.on("mousedown.drag", function(a) {
                i.start(a);
            }), this.el.on("touchstart.drag", function(a) {
                i.start(a);
            });
        }, y.prototype.transformPoint = function(e, t) {
            var i = (e = e || window.event).changedTouches && e.changedTouches[0] || e;
            return this.p.x = i.clientX - (t || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
        }, y.prototype.getBBox = function() {
            var e = this.el.bbox();
            return this.el instanceof SVG.Nested && (e = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (e.x = this.el.x(), e.y = this.el.y()), e;
        }, y.prototype.start = function(e) {
            if (e.type != "click" && e.type != "mousedown" && e.type != "mousemove" || (e.which || e.buttons) == 1) {
                var t = this;
                if (this.el.fire("beforedrag", {
                    event: e,
                    handler: this
                }), !this.el.event().defaultPrevented) {
                    e.preventDefault(), e.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                    var i, a = this.getBBox();
                    if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                        case "middle":
                            i /= 2;
                            break;
                        case "start":
                            i = 0;
                    }
                    this.startPoints = {
                        point: this.transformPoint(e, i),
                        box: a,
                        transform: this.el.transform()
                    }, SVG.on(window, "mousemove.drag", function(s) {
                        t.drag(s);
                    }), SVG.on(window, "touchmove.drag", function(s) {
                        t.drag(s);
                    }), SVG.on(window, "mouseup.drag", function(s) {
                        t.end(s);
                    }), SVG.on(window, "touchend.drag", function(s) {
                        t.end(s);
                    }), this.el.fire("dragstart", {
                        event: e,
                        p: this.startPoints.point,
                        m: this.m,
                        handler: this
                    });
                }
            }
        }, y.prototype.drag = function(e) {
            var t = this.getBBox(), i = this.transformPoint(e), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, n = i.x - this.startPoints.point.x, o = i.y - this.startPoints.point.y;
            if (this.el.fire("dragmove", {
                event: e,
                p: i,
                m: this.m,
                handler: this
            }), this.el.event().defaultPrevented) return i;
            if (typeof r == "function") {
                var h = r.call(this.el, a, s, this.m);
                typeof h == "boolean" && (h = {
                    x: h,
                    y: h
                }), h.x === !0 ? this.el.x(a) : h.x !== !1 && this.el.x(h.x), h.y === !0 ? this.el.y(s) : h.y !== !1 && this.el.y(h.y);
            } else typeof r == "object" && (r.minX != null && a < r.minX ? n = (a = r.minX) - this.startPoints.box.x : r.maxX != null && a > r.maxX - t.width && (n = (a = r.maxX - t.width) - this.startPoints.box.x), r.minY != null && s < r.minY ? o = (s = r.minY) - this.startPoints.box.y : r.maxY != null && s > r.maxY - t.height && (o = (s = r.maxY - t.height) - this.startPoints.box.y), r.snapToGrid != null && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, n -= n % r.snapToGrid, o -= o % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
                x: n,
                y: o
            }, !0) : this.el.move(a, s));
            return i;
        }, y.prototype.end = function(e) {
            var t = this.drag(e);
            this.el.fire("dragend", {
                event: e,
                p: t,
                m: this.m,
                handler: this
            }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
        }, SVG.extend(SVG.Element, {
            draggable: function(e, t) {
                typeof e != "function" && typeof e != "object" || (t = e, e = !0);
                var i = this.remember("_draggable") || new y(this);
                return (e = e === void 0 || e) ? i.init(t || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
            }
        });
    }).call(void 0), function() {
        function y(e) {
            this.el = e, e.remember("_selectHandler", this), this.pointSelection = {
                isSelected: !1
            }, this.rectSelection = {
                isSelected: !1
            }, this.pointsList = {
                lt: [
                    0,
                    0
                ],
                rt: [
                    "width",
                    0
                ],
                rb: [
                    "width",
                    "height"
                ],
                lb: [
                    0,
                    "height"
                ],
                t: [
                    "width",
                    0
                ],
                r: [
                    "width",
                    "height"
                ],
                b: [
                    "width",
                    "height"
                ],
                l: [
                    0,
                    "height"
                ]
            }, this.pointCoord = function(t, i, a) {
                var s = typeof t != "string" ? t : i[t];
                return a ? s / 2 : s;
            }, this.pointCoords = function(t, i) {
                var a = this.pointsList[t];
                return {
                    x: this.pointCoord(a[0], i, t === "t" || t === "b"),
                    y: this.pointCoord(a[1], i, t === "r" || t === "l")
                };
            };
        }
        y.prototype.init = function(e, t) {
            var i = this.el.bbox();
            this.options = {};
            var a = this.el.selectize.defaults.points;
            for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], t[s] !== void 0 && (this.options[s] = t[s]);
            var r = [
                "points",
                "pointsExclude"
            ];
            for(var s in r){
                var n = this.options[r[s]];
                typeof n == "string" ? n = n.length > 0 ? n.split(/\s*,\s*/i) : [] : typeof n == "boolean" && r[s] === "points" && (n = n ? a : []), this.options[r[s]] = n;
            }
            this.options.points = [
                a,
                this.options.points
            ].reduce(function(o, h) {
                return o.filter(function(c) {
                    return h.indexOf(c) > -1;
                });
            }), this.options.points = [
                this.options.points,
                this.options.pointsExclude
            ].reduce(function(o, h) {
                return o.filter(function(c) {
                    return h.indexOf(c) < 0;
                });
            }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && [
                "line",
                "polyline",
                "polygon"
            ].indexOf(this.el.type) !== -1 ? this.selectPoints(e) : this.selectRect(e), this.observe(), this.cleanup();
        }, y.prototype.selectPoints = function(e) {
            return this.pointSelection.isSelected = e, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
        }, y.prototype.getPointArray = function() {
            var e = this.el.bbox();
            return this.el.array().valueOf().map(function(t) {
                return [
                    t[0] - e.x,
                    t[1] - e.y
                ];
            });
        }, y.prototype.drawPoints = function() {
            for(var e = this, t = this.getPointArray(), i = 0, a = t.length; i < a; ++i){
                var s = function(n) {
                    return function(o) {
                        (o = o || window.event).preventDefault ? o.preventDefault() : o.returnValue = !1, o.stopPropagation();
                        var h = o.pageX || o.touches[0].pageX, c = o.pageY || o.touches[0].pageY;
                        e.el.fire("point", {
                            x: h,
                            y: c,
                            i: n,
                            event: o
                        });
                    };
                }(i), r = this.drawPoint(t[i][0], t[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
                this.pointSelection.set.add(r);
            }
        }, y.prototype.drawPoint = function(e, t) {
            var i = this.options.pointType;
            switch(i){
                case "circle":
                    return this.drawCircle(e, t);
                case "rect":
                    return this.drawRect(e, t);
                default:
                    if (typeof i == "function") return i.call(this, e, t);
                    throw new Error("Unknown " + i + " point type!");
            }
        }, y.prototype.drawCircle = function(e, t) {
            return this.nested.circle(this.options.pointSize).center(e, t);
        }, y.prototype.drawRect = function(e, t) {
            return this.nested.rect(this.options.pointSize, this.options.pointSize).center(e, t);
        }, y.prototype.updatePointSelection = function() {
            var e = this.getPointArray();
            this.pointSelection.set.each(function(t) {
                this.cx() === e[t][0] && this.cy() === e[t][1] || this.center(e[t][0], e[t][1]);
            });
        }, y.prototype.updateRectSelection = function() {
            var e = this, t = this.el.bbox();
            if (this.rectSelection.set.get(0).attr({
                width: t.width,
                height: t.height
            }), this.options.points.length && this.options.points.map(function(a, s) {
                var r = e.pointCoords(a, t);
                e.rectSelection.set.get(s + 1).center(r.x, r.y);
            }), this.options.rotationPoint) {
                var i = this.rectSelection.set.length();
                this.rectSelection.set.get(i - 1).center(t.width / 2, 20);
            }
        }, y.prototype.selectRect = function(e) {
            var t = this, i = this.el.bbox();
            function a(n) {
                return function(o) {
                    (o = o || window.event).preventDefault ? o.preventDefault() : o.returnValue = !1, o.stopPropagation();
                    var h = o.pageX || o.touches[0].pageX, c = o.pageY || o.touches[0].pageY;
                    t.el.fire(n, {
                        x: h,
                        y: c,
                        event: o
                    });
                };
            }
            if (this.rectSelection.isSelected = e, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2 && (this.options.points.map(function(n, o) {
                var h = t.pointCoords(n, i), c = t.drawPoint(h.x, h.y).attr("class", t.options.classPoints + "_" + n).on("mousedown", a(n)).on("touchstart", a(n));
                t.rectSelection.set.add(c);
            }), this.rectSelection.set.each(function() {
                this.addClass(t.options.classPoints);
            })), this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
                var s = function(n) {
                    (n = n || window.event).preventDefault ? n.preventDefault() : n.returnValue = !1, n.stopPropagation();
                    var o = n.pageX || n.touches[0].pageX, h = n.pageY || n.touches[0].pageY;
                    t.el.fire("rot", {
                        x: o,
                        y: h,
                        event: n
                    });
                }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
                this.rectSelection.set.add(r);
            }
        }, y.prototype.handler = function() {
            var e = this.el.bbox();
            this.nested.matrix(new SVG.Matrix(this.el).translate(e.x, e.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
        }, y.prototype.observe = function() {
            var e = this;
            if (MutationObserver) {
                if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                    e.handler();
                }), this.observerInst.observe(this.el.node, {
                    attributes: !0
                });
                else try {
                    this.observerInst.disconnect(), delete this.observerInst;
                } catch  {}
            } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
                e.handler();
            });
        }, y.prototype.cleanup = function() {
            !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
                this.remove();
            }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
                this.remove();
            }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
        }, SVG.extend(SVG.Element, {
            selectize: function(e, t) {
                return typeof e == "object" && (t = e, e = !0), (this.remember("_selectHandler") || new y(this)).init(e === void 0 || e, t || {}), this;
            }
        }), SVG.Element.prototype.selectize.defaults = {
            points: [
                "lt",
                "rt",
                "rb",
                "lb",
                "t",
                "r",
                "b",
                "l"
            ],
            pointsExclude: [],
            classRect: "svg_select_boundingRect",
            classPoints: "svg_select_points",
            pointSize: 7,
            rotationPoint: !0,
            deepSelect: !1,
            pointType: "circle"
        };
    }(), function() {
        (function() {
            function y(e) {
                e.remember("_resizeHandler", this), this.el = e, this.parameters = {}, this.lastUpdateCall = null, this.p = e.doc().node.createSVGPoint();
            }
            y.prototype.transformPoint = function(e, t, i) {
                return this.p.x = e - (this.offset.x - window.pageXOffset), this.p.y = t - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
            }, y.prototype._extractPosition = function(e) {
                return {
                    x: e.clientX != null ? e.clientX : e.touches[0].clientX,
                    y: e.clientY != null ? e.clientY : e.touches[0].clientY
                };
            }, y.prototype.init = function(e) {
                var t = this;
                if (this.stop(), e !== "stop") {
                    for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], e[i] !== void 0 && (this.options[i] = e[i]);
                    this.el.on("lt.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("rt.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("rb.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("lb.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("t.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("r.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("b.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("l.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("rot.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.el.on("point.resize", function(a) {
                        t.resize(a || window.event);
                    }), this.update();
                }
            }, y.prototype.stop = function() {
                return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
            }, y.prototype.resize = function(e) {
                var t = this;
                this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                };
                var i = this._extractPosition(e.detail.event);
                if (this.parameters = {
                    type: this.el.type,
                    p: this.transformPoint(i.x, i.y),
                    x: e.detail.x,
                    y: e.detail.y,
                    box: this.el.bbox(),
                    rotation: this.el.transform().rotation
                }, this.el.type === "text" && (this.parameters.fontSize = this.el.attr()["font-size"]), e.detail.i !== void 0) {
                    var a = this.el.array().valueOf();
                    this.parameters.i = e.detail.i, this.parameters.pointCoords = [
                        a[e.detail.i][0],
                        a[e.detail.i][1]
                    ];
                }
                switch(e.type){
                    case "lt":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r);
                            if (this.parameters.box.width - n[0] > 0 && this.parameters.box.height - n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x + n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - n[0]);
                                n = this.checkAspectRatio(n), this.el.move(this.parameters.box.x + n[0], this.parameters.box.y + n[1]).size(this.parameters.box.width - n[0], this.parameters.box.height - n[1]);
                            }
                        };
                        break;
                    case "rt":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 2);
                            if (this.parameters.box.width + n[0] > 0 && this.parameters.box.height - n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x - n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + n[0]);
                                n = this.checkAspectRatio(n, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + n[1]).size(this.parameters.box.width + n[0], this.parameters.box.height - n[1]);
                            }
                        };
                        break;
                    case "rb":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 0);
                            if (this.parameters.box.width + n[0] > 0 && this.parameters.box.height + n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x - n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + n[0]);
                                n = this.checkAspectRatio(n), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + n[0], this.parameters.box.height + n[1]);
                            }
                        };
                        break;
                    case "lb":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 1);
                            if (this.parameters.box.width - n[0] > 0 && this.parameters.box.height + n[1] > 0) {
                                if (this.parameters.type === "text") return this.el.move(this.parameters.box.x + n[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - n[0]);
                                n = this.checkAspectRatio(n, !0), this.el.move(this.parameters.box.x + n[0], this.parameters.box.y).size(this.parameters.box.width - n[0], this.parameters.box.height + n[1]);
                            }
                        };
                        break;
                    case "t":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 2);
                            if (this.parameters.box.height - n[1] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x, this.parameters.box.y + n[1]).height(this.parameters.box.height - n[1]);
                            }
                        };
                        break;
                    case "r":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 0);
                            if (this.parameters.box.width + n[0] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + n[0]);
                            }
                        };
                        break;
                    case "b":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 0);
                            if (this.parameters.box.height + n[1] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + n[1]);
                            }
                        };
                        break;
                    case "l":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, 1);
                            if (this.parameters.box.width - n[0] > 0) {
                                if (this.parameters.type === "text") return;
                                this.el.move(this.parameters.box.x + n[0], this.parameters.box.y).width(this.parameters.box.width - n[0]);
                            }
                        };
                        break;
                    case "rot":
                        this.calc = function(s, r) {
                            var n = s + this.parameters.p.x, o = r + this.parameters.p.y, h = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), c = Math.atan2(o - this.parameters.box.y - this.parameters.box.height / 2, n - this.parameters.box.x - this.parameters.box.width / 2), d = this.parameters.rotation + 180 * (c - h) / Math.PI + this.options.snapToAngle / 2;
                            this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(d - d % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                        };
                        break;
                    case "point":
                        this.calc = function(s, r) {
                            var n = this.snapToGrid(s, r, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), o = this.el.array().valueOf();
                            o[this.parameters.i][0] = this.parameters.pointCoords[0] + n[0], o[this.parameters.i][1] = this.parameters.pointCoords[1] + n[1], this.el.plot(o);
                        };
                }
                this.el.fire("resizestart", {
                    dx: this.parameters.x,
                    dy: this.parameters.y,
                    event: e
                }), SVG.on(window, "touchmove.resize", function(s) {
                    t.update(s || window.event);
                }), SVG.on(window, "touchend.resize", function() {
                    t.done();
                }), SVG.on(window, "mousemove.resize", function(s) {
                    t.update(s || window.event);
                }), SVG.on(window, "mouseup.resize", function() {
                    t.done();
                });
            }, y.prototype.update = function(e) {
                if (e) {
                    var t = this._extractPosition(e), i = this.transformPoint(t.x, t.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                    this.lastUpdateCall = [
                        a,
                        s
                    ], this.calc(a, s), this.el.fire("resizing", {
                        dx: a,
                        dy: s,
                        event: e
                    });
                } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
            }, y.prototype.done = function() {
                this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
            }, y.prototype.snapToGrid = function(e, t, i, a) {
                var s;
                return a !== void 0 ? s = [
                    (i + e) % this.options.snapToGrid,
                    (a + t) % this.options.snapToGrid
                ] : (i = i ?? 3, s = [
                    (this.parameters.box.x + e + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                    (this.parameters.box.y + t + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
                ]), e < 0 && (s[0] -= this.options.snapToGrid), t < 0 && (s[1] -= this.options.snapToGrid), e -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), t -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(e, t, i, a);
            }, y.prototype.constraintToBox = function(e, t, i, a) {
                var s, r, n = this.options.constraint || {};
                return a !== void 0 ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), n.minX !== void 0 && s + e < n.minX && (e = n.minX - s), n.maxX !== void 0 && s + e > n.maxX && (e = n.maxX - s), n.minY !== void 0 && r + t < n.minY && (t = n.minY - r), n.maxY !== void 0 && r + t > n.maxY && (t = n.maxY - r), [
                    e,
                    t
                ];
            }, y.prototype.checkAspectRatio = function(e, t) {
                if (!this.options.saveAspectRatio) return e;
                var i = e.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + e[0], r = this.parameters.box.height - e[1], n = s / r;
                return n < a ? (i[1] = s / a - this.parameters.box.height, t && (i[1] = -i[1])) : n > a && (i[0] = this.parameters.box.width - r * a, t && (i[0] = -i[0])), i;
            }, SVG.extend(SVG.Element, {
                resize: function(e) {
                    return (this.remember("_resizeHandler") || new y(this)).init(e || {}), this;
                }
            }), SVG.Element.prototype.resize.defaults = {
                snapToAngle: 0.1,
                snapToGrid: 1,
                constraint: {},
                saveAspectRatio: !1
            };
        }).call(this);
    }(), window.Apex === void 0 && (window.Apex = {});
    var ht = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "initModules",
                value: function() {
                    this.ctx.publicMethods = [
                        "updateOptions",
                        "updateSeries",
                        "appendData",
                        "appendSeries",
                        "isSeriesHidden",
                        "toggleSeries",
                        "showSeries",
                        "hideSeries",
                        "setLocale",
                        "resetSeries",
                        "zoomX",
                        "toggleDataPointSelection",
                        "dataURI",
                        "exportToCSV",
                        "addXaxisAnnotation",
                        "addYaxisAnnotation",
                        "addPointAnnotation",
                        "clearAnnotations",
                        "removeAnnotation",
                        "paper",
                        "destroy"
                    ], this.ctx.eventList = [
                        "click",
                        "mousedown",
                        "mousemove",
                        "mouseleave",
                        "touchstart",
                        "touchmove",
                        "touchleave",
                        "mouseup",
                        "touchend"
                    ], this.ctx.animations = new de(this.ctx), this.ctx.axes = new mt(this.ctx), this.ctx.core = new Gt(this.ctx.el, this.ctx), this.ctx.config = new Le({}), this.ctx.data = new Je(this.ctx), this.ctx.grid = new Qe(this.ctx), this.ctx.graphics = new M(this.ctx), this.ctx.coreUtils = new q(this.ctx), this.ctx.crosshairs = new We(this.ctx), this.ctx.events = new xt(this.ctx), this.ctx.exports = new Ee(this.ctx), this.ctx.localization = new bt(this.ctx), this.ctx.options = new G(), this.ctx.responsive = new vt(this.ctx), this.ctx.series = new te(this.ctx), this.ctx.theme = new yt(this.ctx), this.ctx.formatters = new re(this.ctx), this.ctx.titleSubtitle = new wt(this.ctx), this.ctx.legend = new Ke(this.ctx), this.ctx.toolbar = new et(this.ctx), this.ctx.tooltip = new at(this.ctx), this.ctx.dimensions = new Ye(this.ctx), this.ctx.updateHelpers = new Vt(this.ctx), this.ctx.zoomPanSelection = new Pt(this.ctx), this.ctx.w.globals.tooltip = new at(this.ctx);
                }
            }
        ]), y;
    }(), ct = function() {
        function y(e) {
            F(this, y), this.ctx = e, this.w = e.w;
        }
        return Y(y, [
            {
                key: "clear",
                value: function(e) {
                    var t = e.isUpdating;
                    this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                        isUpdating: t
                    });
                }
            },
            {
                key: "killSVG",
                value: function(e) {
                    e.each(function(t, i) {
                        this.removeClass("*"), this.off(), this.stop();
                    }, !0), e.ungroup(), e.clear();
                }
            },
            {
                key: "clearDomElements",
                value: function(e) {
                    var t = this, i = e.isUpdating, a = this.w.globals.dom.Paper.node;
                    a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                    var s = this.w.globals.dom.baseEl;
                    s && this.ctx.eventList.forEach(function(n) {
                        s.removeEventListener(n, t.ctx.events.documentEvent);
                    });
                    var r = this.w.globals.dom;
                    if (this.ctx.el !== null) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                    this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
                }
            }
        ]), y;
    }(), _e = /* @__PURE__ */ new WeakMap(), jt = function() {
        function y(e, t) {
            F(this, y), this.opts = t, this.ctx = this, this.w = new ft(t).init(), this.el = e, this.w.globals.cuid = P.randomId(), this.w.globals.chartID = this.w.config.chart.id ? P.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new ht(this).initModules(), this.create = P.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
        }
        return Y(y, [
            {
                key: "render",
                value: function() {
                    var e = this;
                    return new Promise(function(t, i) {
                        if (e.el !== null) {
                            Apex._chartInstances === void 0 && (Apex._chartInstances = []), e.w.config.chart.id && Apex._chartInstances.push({
                                id: e.w.globals.chartID,
                                group: e.w.config.chart.group,
                                chart: e
                            }), e.setLocale(e.w.config.chart.defaultLocale);
                            var a = e.w.config.chart.events.beforeMount;
                            if (typeof a == "function" && a(e, e.w), e.events.fireEvent("beforeMount", [
                                e,
                                e.w
                            ]), window.addEventListener("resize", e.windowResizeHandler), function(g, p) {
                                var f = !1;
                                if (g.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                    var b = g.getBoundingClientRect();
                                    g.style.display !== "none" && b.width !== 0 || (f = !0);
                                }
                                var m = new ResizeObserver(function(w) {
                                    f && p.call(g, w), f = !0;
                                });
                                g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(g.children).forEach(function(w) {
                                    return m.observe(w);
                                }) : m.observe(g), _e.set(p, m);
                            }(e.el.parentNode, e.parentResizeHandler), !e.css) {
                                var s = e.el.getRootNode && e.el.getRootNode(), r = P.is("ShadowRoot", s), n = e.el.ownerDocument, o = n.getElementById("apexcharts-css");
                                if (r || !o) {
                                    var h;
                                    e.css = document.createElement("style"), e.css.id = "apexcharts-css", e.css.textContent = `@keyframes opaque {
  0% {
      opacity: 0
  }

  to {
      opacity: 1
  }
}

@keyframes resizeanim {
  0%,to {
      opacity: 0
  }
}

.apexcharts-canvas {
  position: relative;
  user-select: none
}

.apexcharts-canvas ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px
}

.apexcharts-canvas ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0,0,0,.5);
  box-shadow: 0 0 1px rgba(255,255,255,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5)
}

.apexcharts-inner {
  position: relative
}

.apexcharts-text tspan {
  font-family: inherit
}

.legend-mouseover-inactive {
  transition: .15s ease all;
  opacity: .2
}

.apexcharts-legend-text {
  padding-left: 15px;
  margin-left: -15px;
}

.apexcharts-series-collapsed {
  opacity: 0
}

.apexcharts-tooltip {
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px #999;
  cursor: default;
  font-size: 14px;
  left: 62px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: .15s ease all
}

.apexcharts-tooltip.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-tooltip.apexcharts-theme-light {
  border: 1px solid #e3e3e3;
  background: rgba(255,255,255,.96)
}

.apexcharts-tooltip.apexcharts-theme-dark {
  color: #fff;
  background: rgba(30,30,30,.8)
}

.apexcharts-tooltip * {
  font-family: inherit
}

.apexcharts-tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px
}

.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  background: #eceff1;
  border-bottom: 1px solid #ddd
}

.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {
  background: rgba(0,0,0,.7);
  border-bottom: 1px solid #333
}

.apexcharts-tooltip-text-goals-value,.apexcharts-tooltip-text-y-value,.apexcharts-tooltip-text-z-value {
  display: inline-block;
  margin-left: 5px;
  font-weight: 600
}

.apexcharts-tooltip-text-goals-label:empty,.apexcharts-tooltip-text-goals-value:empty,.apexcharts-tooltip-text-y-label:empty,.apexcharts-tooltip-text-y-value:empty,.apexcharts-tooltip-text-z-value:empty,.apexcharts-tooltip-title:empty {
  display: none
}

.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {
  padding: 6px 0 5px
}

.apexcharts-tooltip-goals-group,.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {
  display: flex
}

.apexcharts-tooltip-text-goals-label:not(:empty),.apexcharts-tooltip-text-goals-value:not(:empty) {
  margin-top: -6px
}

.apexcharts-tooltip-marker {
  width: 12px;
  height: 12px;
  position: relative;
  top: 0;
  margin-right: 10px;
  border-radius: 50%
}

.apexcharts-tooltip-series-group {
  padding: 0 10px;
  display: none;
  text-align: left;
  justify-content: left;
  align-items: center
}

.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {
  opacity: 1
}

.apexcharts-tooltip-series-group.apexcharts-active,.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 4px
}

.apexcharts-tooltip-series-group-hidden {
  opacity: 0;
  height: 0;
  line-height: 0;
  padding: 0!important
}

.apexcharts-tooltip-y-group {
  padding: 6px 0 5px
}

.apexcharts-custom-tooltip,.apexcharts-tooltip-box {
  padding: 4px 8px
}

.apexcharts-tooltip-boxPlot {
  display: flex;
  flex-direction: column-reverse
}

.apexcharts-tooltip-box>div {
  margin: 4px 0
}

.apexcharts-tooltip-box span.value {
  font-weight: 700
}

.apexcharts-tooltip-rangebar {
  padding: 5px 8px
}

.apexcharts-tooltip-rangebar .category {
  font-weight: 600;
  color: #777
}

.apexcharts-tooltip-rangebar .series-name {
  font-weight: 700;
  display: block;
  margin-bottom: 5px
}

.apexcharts-xaxistooltip,.apexcharts-yaxistooltip {
  opacity: 0;
  pointer-events: none;
  color: #373d3f;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
  background: #eceff1;
  border: 1px solid #90a4ae
}

.apexcharts-xaxistooltip {
  padding: 9px 10px;
  transition: .15s ease all
}

.apexcharts-xaxistooltip.apexcharts-theme-dark {
  background: rgba(0,0,0,.7);
  border: 1px solid rgba(0,0,0,.5);
  color: #fff
}

.apexcharts-xaxistooltip:after,.apexcharts-xaxistooltip:before {
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none
}

.apexcharts-xaxistooltip:after {
  border-color: transparent;
  border-width: 6px;
  margin-left: -6px
}

.apexcharts-xaxistooltip:before {
  border-color: transparent;
  border-width: 7px;
  margin-left: -7px
}

.apexcharts-xaxistooltip-bottom:after,.apexcharts-xaxistooltip-bottom:before {
  bottom: 100%
}

.apexcharts-xaxistooltip-top:after,.apexcharts-xaxistooltip-top:before {
  top: 100%
}

.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: #eceff1
}

.apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: #90a4ae
}

.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {
  border-bottom-color: rgba(0,0,0,.5)
}

.apexcharts-xaxistooltip-top:after {
  border-top-color: #eceff1
}

.apexcharts-xaxistooltip-top:before {
  border-top-color: #90a4ae
}

.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {
  border-top-color: rgba(0,0,0,.5)
}

.apexcharts-xaxistooltip.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-yaxistooltip {
  padding: 4px 10px
}

.apexcharts-yaxistooltip.apexcharts-theme-dark {
  background: rgba(0,0,0,.7);
  border: 1px solid rgba(0,0,0,.5);
  color: #fff
}

.apexcharts-yaxistooltip:after,.apexcharts-yaxistooltip:before {
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none
}

.apexcharts-yaxistooltip:after {
  border-color: transparent;
  border-width: 6px;
  margin-top: -6px
}

.apexcharts-yaxistooltip:before {
  border-color: transparent;
  border-width: 7px;
  margin-top: -7px
}

.apexcharts-yaxistooltip-left:after,.apexcharts-yaxistooltip-left:before {
  left: 100%
}

.apexcharts-yaxistooltip-right:after,.apexcharts-yaxistooltip-right:before {
  right: 100%
}

.apexcharts-yaxistooltip-left:after {
  border-left-color: #eceff1
}

.apexcharts-yaxistooltip-left:before {
  border-left-color: #90a4ae
}

.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {
  border-left-color: rgba(0,0,0,.5)
}

.apexcharts-yaxistooltip-right:after {
  border-right-color: #eceff1
}

.apexcharts-yaxistooltip-right:before {
  border-right-color: #90a4ae
}

.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {
  border-right-color: rgba(0,0,0,.5)
}

.apexcharts-yaxistooltip.apexcharts-active {
  opacity: 1
}

.apexcharts-yaxistooltip-hidden {
  display: none
}

.apexcharts-xcrosshairs,.apexcharts-ycrosshairs {
  pointer-events: none;
  opacity: 0;
  transition: .15s ease all
}

.apexcharts-xcrosshairs.apexcharts-active,.apexcharts-ycrosshairs.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-ycrosshairs-hidden {
  opacity: 0
}

.apexcharts-selection-rect {
  cursor: move
}

.svg_select_boundingRect,.svg_select_points_rot {
  pointer-events: none;
  opacity: 0;
  visibility: hidden
}

.apexcharts-selection-rect+g .svg_select_boundingRect,.apexcharts-selection-rect+g .svg_select_points_rot {
  opacity: 0;
  visibility: hidden
}

.apexcharts-selection-rect+g .svg_select_points_l,.apexcharts-selection-rect+g .svg_select_points_r {
  cursor: ew-resize;
  opacity: 1;
  visibility: visible
}

.svg_select_points {
  fill: #efefef;
  stroke: #333;
  rx: 2
}

.apexcharts-svg.apexcharts-zoomable.hovering-zoom {
  cursor: crosshair
}

.apexcharts-svg.apexcharts-zoomable.hovering-pan {
  cursor: move
}

.apexcharts-menu-icon,.apexcharts-pan-icon,.apexcharts-reset-icon,.apexcharts-selection-icon,.apexcharts-toolbar-custom-icon,.apexcharts-zoom-icon,.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
  line-height: 24px;
  color: #6e8192;
  text-align: center
}

.apexcharts-menu-icon svg,.apexcharts-reset-icon svg,.apexcharts-zoom-icon svg,.apexcharts-zoomin-icon svg,.apexcharts-zoomout-icon svg {
  fill: #6e8192
}

.apexcharts-selection-icon svg {
  fill: #444;
  transform: scale(.76)
}

.apexcharts-theme-dark .apexcharts-menu-icon svg,.apexcharts-theme-dark .apexcharts-pan-icon svg,.apexcharts-theme-dark .apexcharts-reset-icon svg,.apexcharts-theme-dark .apexcharts-selection-icon svg,.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,.apexcharts-theme-dark .apexcharts-zoom-icon svg,.apexcharts-theme-dark .apexcharts-zoomin-icon svg,.apexcharts-theme-dark .apexcharts-zoomout-icon svg {
  fill: #f3f4f5
}

.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {
  fill: #008ffb
}

.apexcharts-theme-light .apexcharts-menu-icon:hover svg,.apexcharts-theme-light .apexcharts-reset-icon:hover svg,.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {
  fill: #333
}

.apexcharts-menu-icon,.apexcharts-selection-icon {
  position: relative
}

.apexcharts-reset-icon {
  margin-left: 5px
}

.apexcharts-menu-icon,.apexcharts-reset-icon,.apexcharts-zoom-icon {
  transform: scale(.85)
}

.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {
  transform: scale(.7)
}

.apexcharts-zoomout-icon {
  margin-right: 3px
}

.apexcharts-pan-icon {
  transform: scale(.62);
  position: relative;
  left: 1px;
  top: 0
}

.apexcharts-pan-icon svg {
  fill: #fff;
  stroke: #6e8192;
  stroke-width: 2
}

.apexcharts-pan-icon.apexcharts-selected svg {
  stroke: #008ffb
}

.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {
  stroke: #333
}

.apexcharts-toolbar {
  position: absolute;
  z-index: 11;
  max-width: 176px;
  text-align: right;
  border-radius: 3px;
  padding: 0 6px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.apexcharts-menu {
  background: #fff;
  position: absolute;
  top: 100%;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px;
  right: 10px;
  opacity: 0;
  min-width: 110px;
  transition: .15s ease all;
  pointer-events: none
}

.apexcharts-menu.apexcharts-menu-open {
  opacity: 1;
  pointer-events: all;
  transition: .15s ease all
}

.apexcharts-menu-item {
  padding: 6px 7px;
  font-size: 12px;
  cursor: pointer
}

.apexcharts-theme-light .apexcharts-menu-item:hover {
  background: #eee
}

.apexcharts-theme-dark .apexcharts-menu {
  background: rgba(0,0,0,.7);
  color: #fff
}

@media screen and (min-width:768px) {
  .apexcharts-canvas:hover .apexcharts-toolbar {
      opacity: 1
  }
}

.apexcharts-canvas .apexcharts-element-hidden,.apexcharts-datalabel.apexcharts-element-hidden,.apexcharts-hide .apexcharts-series-points {
  opacity: 0
}

.apexcharts-hidden-element-shown {
  opacity: 1;
  transition: 0.25s ease all;
}
.apexcharts-datalabel,.apexcharts-datalabel-label,.apexcharts-datalabel-value,.apexcharts-datalabels,.apexcharts-pie-label {
  cursor: default;
  pointer-events: none
}

.apexcharts-pie-label-delay {
  opacity: 0;
  animation-name: opaque;
  animation-duration: .3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease
}

.apexcharts-radialbar-label {
  cursor: pointer;
}

.apexcharts-annotation-rect,.apexcharts-area-series .apexcharts-area,.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-gridline,.apexcharts-line,.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-point-annotation-label,.apexcharts-radar-series path,.apexcharts-radar-series polygon,.apexcharts-toolbar svg,.apexcharts-tooltip .apexcharts-marker,.apexcharts-xaxis-annotation-label,.apexcharts-yaxis-annotation-label,.apexcharts-zoom-rect {
  pointer-events: none
}

.apexcharts-marker {
  transition: .15s ease all
}

.resize-triggers {
  animation: 1ms resizeanim;
  visibility: hidden;
  opacity: 0;
  height: 100%;
  width: 100%;
  overflow: hidden
}

.contract-trigger:before,.resize-triggers,.resize-triggers>div {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0
}

.resize-triggers>div {
  height: 100%;
  width: 100%;
  background: #eee;
  overflow: auto
}

.contract-trigger:before {
  overflow: hidden;
  width: 200%;
  height: 200%
}

.apexcharts-bar-goals-markers{
  pointer-events: none
}

.apexcharts-bar-shadows{
  pointer-events: none
}

.apexcharts-rangebar-goals-markers{
  pointer-events: none
}`;
                                    var c = ((h = e.opts.chart) === null || h === void 0 ? void 0 : h.nonce) || e.w.config.chart.nonce;
                                    c && e.css.setAttribute("nonce", c), r ? s.prepend(e.css) : n.head.appendChild(e.css);
                                }
                            }
                            var d = e.create(e.w.config.series, {});
                            if (!d) return t(e);
                            e.mount(d).then(function() {
                                typeof e.w.config.chart.events.mounted == "function" && e.w.config.chart.events.mounted(e, e.w), e.events.fireEvent("mounted", [
                                    e,
                                    e.w
                                ]), t(d);
                            }).catch(function(g) {
                                i(g);
                            });
                        } else i(new Error("Element not found"));
                    });
                }
            },
            {
                key: "create",
                value: function(e, t) {
                    var i = this.w;
                    new ht(this).initModules();
                    var a = this.w.globals;
                    if (a.noData = !1, a.animationEnded = !1, this.responsive.checkResponsiveConfig(t), i.config.xaxis.convertedCatToNumeric && new oe(i.config).convertCatToNumericXaxis(i.config, this.ctx), this.el === null || (this.core.setupElements(), i.config.chart.type === "treemap" && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), a.svgWidth === 0)) return a.animationEnded = !0, null;
                    var s = q.checkComboSeries(e);
                    a.comboCharts = s.comboCharts, a.comboBarCount = s.comboBarCount;
                    var r = e.every(function(c) {
                        return c.data && c.data.length === 0;
                    });
                    (e.length === 0 || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(e), this.theme.init(), new Pe(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), a.noData && a.collapsedSeries.length !== a.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), a.axisCharts && (this.core.coreCalculations(), i.config.xaxis.type !== "category" && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), new q(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                    var n = this.core.xySettings();
                    this.grid.createGridMask();
                    var o = this.core.plotChartType(e, n), h = new ye(this);
                    return h.bringForward(), i.config.dataLabels.background.enabled && h.dataLabelsBackground(), this.core.shiftGraphPosition(), {
                        elGraph: o,
                        xyRatios: n,
                        dimensions: {
                            plot: {
                                left: i.globals.translateX,
                                top: i.globals.translateY,
                                width: i.globals.gridWidth,
                                height: i.globals.gridHeight
                            }
                        }
                    };
                }
            },
            {
                key: "mount",
                value: function() {
                    var e = this, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, i = this, a = i.w;
                    return new Promise(function(s, r) {
                        if (i.el === null) return r(new Error("Not enough data to display or target element not found"));
                        (t === null || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new Qe(i);
                        var n, o, h = i.grid.drawGrid();
                        if (i.annotations = new ie(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), a.config.grid.position === "back" && (h && a.globals.dom.elGraphical.add(h.el), h != null && (n = h.elGridBorders) !== null && n !== void 0 && n.node && a.globals.dom.elGraphical.add(h.elGridBorders)), Array.isArray(t.elGraph)) for(var c = 0; c < t.elGraph.length; c++)a.globals.dom.elGraphical.add(t.elGraph[c]);
                        else a.globals.dom.elGraphical.add(t.elGraph);
                        a.config.grid.position === "front" && (h && a.globals.dom.elGraphical.add(h.el), h != null && (o = h.elGridBorders) !== null && o !== void 0 && o.node && a.globals.dom.elGraphical.add(h.elGridBorders)), a.config.xaxis.crosshairs.position === "front" && i.crosshairs.drawXCrosshairs(), a.config.yaxis[0].crosshairs.position === "front" && i.crosshairs.drawYCrosshairs(), a.config.chart.type !== "treemap" && i.axes.drawAxis(a.config.chart.type, h);
                        var d = new Ie(e.ctx, h), g = new Ne(e.ctx, h);
                        if (h !== null && (d.xAxisLabelCorrections(h.xAxisTickWidth), g.setYAxisTextAlignments(), a.config.yaxis.map(function(f, b) {
                            a.globals.ignoreYAxisIndexes.indexOf(b) === -1 && g.yAxisTitleRotate(b, f.opposite);
                        })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                            if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(t.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                                xyRatios: t.xyRatios
                            });
                            else {
                                var p = a.config.chart.toolbar.tools;
                                [
                                    "zoom",
                                    "zoomin",
                                    "zoomout",
                                    "selection",
                                    "pan",
                                    "reset"
                                ].forEach(function(f) {
                                    p[f] = !1;
                                });
                            }
                            a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                        }
                        a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(f) {
                            f.method(f.params, !1, f.context);
                        }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    var e, t;
                    window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, e = this.parentResizeHandler, (t = _e.get(e)) && (t.disconnect(), _e.delete(e));
                    var i = this.w.config.chart.id;
                    i && Apex._chartInstances.forEach(function(a, s) {
                        a.id === P.escapeString(i) && Apex._chartInstances.splice(s, 1);
                    }), new ct(this.ctx).clear({
                        isUpdating: !1
                    });
                }
            },
            {
                key: "updateOptions",
                value: function(e) {
                    var t = this, i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], a = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], s = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], r = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], n = this.w;
                    return n.globals.selection = void 0, e.series && (this.series.resetSeries(!1, !0, !1), e.series.length && e.series[0].data && (e.series = e.series.map(function(o, h) {
                        return t.updateHelpers._extendSeries(o, h);
                    })), this.updateHelpers.revertDefaultAxisMinMax()), e.xaxis && (e = this.updateHelpers.forceXAxisUpdate(e)), e.yaxis && (e = this.updateHelpers.forceYAxisUpdate(e)), n.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), e.theme && (e = this.theme.updateThemeOptions(e)), this.updateHelpers._updateOptions(e, i, a, s, r);
                }
            },
            {
                key: "updateSeries",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
                    return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(e, t, i);
                }
            },
            {
                key: "appendSeries",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], a = this.w.config.series.slice();
                    return a.push(e), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, t, i);
                }
            },
            {
                key: "appendData",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = this;
                    i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                    for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (e[s] !== null && e[s] !== void 0) for(var r = 0; r < e[s].data.length; r++)a[s].data.push(e[s].data[r]);
                    return i.w.config.series = a, t && (i.w.globals.initialSeries = P.clone(i.w.config.series)), this.update();
                }
            },
            {
                key: "update",
                value: function(e) {
                    var t = this;
                    return new Promise(function(i, a) {
                        new ct(t.ctx).clear({
                            isUpdating: !0
                        });
                        var s = t.create(t.w.config.series, e);
                        if (!s) return i(t);
                        t.mount(s).then(function() {
                            typeof t.w.config.chart.events.updated == "function" && t.w.config.chart.events.updated(t, t.w), t.events.fireEvent("updated", [
                                t,
                                t.w
                            ]), t.w.globals.isDirty = !0, i(t);
                        }).catch(function(r) {
                            a(r);
                        });
                    });
                }
            },
            {
                key: "getSyncedCharts",
                value: function() {
                    var e = this.getGroupedCharts(), t = [
                        this
                    ];
                    return e.length && (t = [], e.forEach(function(i) {
                        t.push(i);
                    })), t;
                }
            },
            {
                key: "getGroupedCharts",
                value: function() {
                    var e = this;
                    return Apex._chartInstances.filter(function(t) {
                        if (t.group) return !0;
                    }).map(function(t) {
                        return e.w.config.chart.group === t.group ? t.chart : e;
                    });
                }
            },
            {
                key: "toggleSeries",
                value: function(e) {
                    return this.series.toggleSeries(e);
                }
            },
            {
                key: "highlightSeriesOnLegendHover",
                value: function(e, t) {
                    return this.series.toggleSeriesOnHover(e, t);
                }
            },
            {
                key: "showSeries",
                value: function(e) {
                    this.series.showSeries(e);
                }
            },
            {
                key: "hideSeries",
                value: function(e) {
                    this.series.hideSeries(e);
                }
            },
            {
                key: "isSeriesHidden",
                value: function(e) {
                    this.series.isSeriesHidden(e);
                }
            },
            {
                key: "resetSeries",
                value: function() {
                    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
                    this.series.resetSeries(e, t);
                }
            },
            {
                key: "addEventListener",
                value: function(e, t) {
                    this.events.addEventListener(e, t);
                }
            },
            {
                key: "removeEventListener",
                value: function(e, t) {
                    this.events.removeEventListener(e, t);
                }
            },
            {
                key: "addXaxisAnnotation",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, a = this;
                    i && (a = i), a.annotations.addXaxisAnnotationExternal(e, t, a);
                }
            },
            {
                key: "addYaxisAnnotation",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, a = this;
                    i && (a = i), a.annotations.addYaxisAnnotationExternal(e, t, a);
                }
            },
            {
                key: "addPointAnnotation",
                value: function(e) {
                    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, a = this;
                    i && (a = i), a.annotations.addPointAnnotationExternal(e, t, a);
                }
            },
            {
                key: "clearAnnotations",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, t = this;
                    e && (t = e), t.annotations.clearAnnotations(t);
                }
            },
            {
                key: "removeAnnotation",
                value: function(e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, i = this;
                    t && (i = t), i.annotations.removeAnnotation(i, e);
                }
            },
            {
                key: "getChartArea",
                value: function() {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
                }
            },
            {
                key: "getSeriesTotalXRange",
                value: function(e, t) {
                    return this.coreUtils.getSeriesTotalsXRange(e, t);
                }
            },
            {
                key: "getHighestValueInSeries",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    return new De(this.ctx).getMinYMaxY(e).highestY;
                }
            },
            {
                key: "getLowestValueInSeries",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    return new De(this.ctx).getMinYMaxY(e).lowestY;
                }
            },
            {
                key: "getSeriesTotal",
                value: function() {
                    return this.w.globals.seriesTotals;
                }
            },
            {
                key: "toggleDataPointSelection",
                value: function(e, t) {
                    return this.updateHelpers.toggleDataPointSelection(e, t);
                }
            },
            {
                key: "zoomX",
                value: function(e, t) {
                    this.ctx.toolbar.zoomUpdateOptions(e, t);
                }
            },
            {
                key: "setLocale",
                value: function(e) {
                    this.localization.setCurrentLocaleValues(e);
                }
            },
            {
                key: "dataURI",
                value: function(e) {
                    return new Ee(this.ctx).dataURI(e);
                }
            },
            {
                key: "exportToCSV",
                value: function() {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    return new Ee(this.ctx).exportToCSV(e);
                }
            },
            {
                key: "paper",
                value: function() {
                    return this.w.globals.dom.Paper;
                }
            },
            {
                key: "_parentResizeCallback",
                value: function() {
                    this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
                }
            },
            {
                key: "_windowResize",
                value: function() {
                    var e = this;
                    clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                        e.w.globals.resized = !0, e.w.globals.dataChanged = !1, e.ctx.update();
                    }, 150);
                }
            },
            {
                key: "_windowResizeHandler",
                value: function() {
                    var e = this.w.config.chart.redrawOnWindowResize;
                    typeof e == "function" && (e = e()), e && this._windowResize();
                }
            }
        ], [
            {
                key: "getChartByID",
                value: function(e) {
                    var t = P.escapeString(e);
                    if (Apex._chartInstances) {
                        var i = Apex._chartInstances.filter(function(a) {
                            return a.id === t;
                        })[0];
                        return i && i.chart;
                    }
                }
            },
            {
                key: "initOnLoad",
                value: function() {
                    for(var e = document.querySelectorAll("[data-apexcharts]"), t = 0; t < e.length; t++)new y(e[t], JSON.parse(e[t].getAttribute("data-options"))).render();
                }
            },
            {
                key: "exec",
                value: function(e, t) {
                    var i = this.getChartByID(e);
                    if (i) {
                        i.w.globals.isExecCalled = !0;
                        var a = null;
                        if (i.publicMethods.indexOf(t) !== -1) {
                            for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), n = 2; n < s; n++)r[n - 2] = arguments[n];
                            a = i[t].apply(i, r);
                        }
                        return a;
                    }
                }
            },
            {
                key: "merge",
                value: function(e, t) {
                    return P.extend(e, t);
                }
            }
        ]), y;
    }();
    _.exports = jt;
})($a0ff767aa05ebc8a$var$Ue, $a0ff767aa05ebc8a$var$Ue.exports);
var $a0ff767aa05ebc8a$var$ti = $a0ff767aa05ebc8a$var$Ue.exports;
const $a0ff767aa05ebc8a$var$ut = /* @__PURE__ */ $a0ff767aa05ebc8a$var$ei($a0ff767aa05ebc8a$var$ti), $a0ff767aa05ebc8a$var$pt = [
    "animationEnd",
    "beforeMount",
    "mounted",
    "updated",
    "click",
    "mouseMove",
    "mouseLeave",
    "legendClick",
    "markerClick",
    "selection",
    "dataPointSelection",
    "dataPointMouseEnter",
    "dataPointMouseLeave",
    "beforeZoom",
    "beforeResetZoom",
    "zoomed",
    "scrolled",
    "brushScrolled"
], $a0ff767aa05ebc8a$export$2e2bcd8739ae039 = (0, $TusQn.defineComponent)({
    name: "apexchart",
    props: {
        options: {
            type: Object
        },
        type: {
            type: String
        },
        series: {
            type: Array,
            required: !0
        },
        width: {
            default: "100%"
        },
        height: {
            default: "auto"
        }
    },
    // events emitted by this component
    emits: $a0ff767aa05ebc8a$var$pt,
    setup (_, { emit: Re }) {
        const Ae = (0, $01W3b.ref)(null), X = (0, $01W3b.ref)(null), U = (H)=>H && typeof H == "object" && !Array.isArray(H) && H != null, F = (H, G)=>{
            typeof Object.assign != "function" && function() {
                Object.assign = function(B) {
                    if (B == null) throw new TypeError("Cannot convert undefined or null to object");
                    let re = Object(B);
                    for(let fe = 1; fe < arguments.length; fe++){
                        let ne = arguments[fe];
                        if (ne != null) for(let oe in ne)ne.hasOwnProperty(oe) && (re[oe] = ne[oe]);
                    }
                    return re;
                };
            }();
            let ie = Object.assign({}, H);
            return U(H) && U(G) && Object.keys(G).forEach((B)=>{
                U(G[B]) ? B in H ? ie[B] = F(H[B], G[B]) : Object.assign(ie, {
                    [B]: G[B]
                }) : Object.assign(ie, {
                    [B]: G[B]
                });
            }), ie;
        }, ce = async ()=>{
            if (await (0, $TusQn.nextTick)(), X.value) return;
            const H = {
                chart: {
                    type: _.type || _.options.chart.type || "line",
                    height: _.height,
                    width: _.width,
                    events: {}
                },
                series: _.series
            };
            $a0ff767aa05ebc8a$var$pt.forEach((ie)=>{
                let B = (...re)=>Re(ie, ...re);
                H.chart.events[ie] = B;
            });
            const G = F(_.options, H);
            return X.value = new $a0ff767aa05ebc8a$var$ut(Ae.value, G), X.value.render();
        }, Y = ()=>(ee(), ce()), ee = ()=>{
            X.value.destroy();
        }, ge = (H, G)=>X.value.updateSeries(H, G), me = (H, G, ie, B)=>X.value.updateOptions(H, G, ie, B), Se = (H)=>X.value.toggleSeries(H), ze = (H)=>{
            X.value.showSeries(H);
        }, ue = (H)=>{
            X.value.hideSeries(H);
        }, Me = (H, G)=>X.value.appendSeries(H, G), J = ()=>{
            X.value.resetSeries();
        }, Xe = (H, G)=>{
            X.value.toggleDataPointSelection(H, G);
        }, Ce = (H)=>X.value.appendData(H), P = (H, G)=>X.value.zoomX(H, G), de = (H)=>X.value.dataURI(H), Z = (H)=>X.value.setLocale(H), M = (H, G)=>{
            X.value.addXaxisAnnotation(H, G);
        }, q = (H, G)=>{
            X.value.addYaxisAnnotation(H, G);
        }, ve = (H, G)=>{
            X.value.addPointAnnotation(H, G);
        }, Oe = (H, G)=>{
            X.value.removeAnnotation(H, G);
        }, He = ()=>{
            X.value.clearAnnotations();
        };
        (0, $TusQn.onBeforeMount)(()=>{
            window.ApexCharts = $a0ff767aa05ebc8a$var$ut;
        }), (0, $TusQn.onMounted)(()=>{
            Ae.value = (0, $TusQn.getCurrentInstance)().proxy.$el, ce();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            X.value && ee();
        });
        const pe = (0, $01W3b.toRefs)(_);
        return (0, $TusQn.watch)(pe.options, ()=>{
            !X.value && _.options ? ce() : X.value.updateOptions(_.options);
        }), (0, $TusQn.watch)(pe.series, ()=>{
            !X.value && _.series ? ce() : X.value.updateSeries(_.series);
        }, {
            deep: !0
        }), (0, $TusQn.watch)(pe.type, ()=>{
            Y();
        }), (0, $TusQn.watch)(pe.width, ()=>{
            Y();
        }), (0, $TusQn.watch)(pe.height, ()=>{
            Y();
        }), {
            chart: X,
            init: ce,
            refresh: Y,
            destroy: ee,
            updateOptions: me,
            updateSeries: ge,
            toggleSeries: Se,
            showSeries: ze,
            hideSeries: ue,
            resetSeries: J,
            zoomX: P,
            toggleDataPointSelection: Xe,
            appendData: Ce,
            appendSeries: Me,
            addXaxisAnnotation: M,
            addYaxisAnnotation: q,
            addPointAnnotation: ve,
            removeAnnotation: Oe,
            clearAnnotations: He,
            setLocale: Z,
            dataURI: de
        };
    },
    render () {
        return (0, $TusQn.h)("div", {
            class: "vue-apexcharts"
        });
    }
}), $a0ff767aa05ebc8a$var$ii = (_)=>{
    _.component($a0ff767aa05ebc8a$export$2e2bcd8739ae039.name, $a0ff767aa05ebc8a$export$2e2bcd8739ae039);
};
$a0ff767aa05ebc8a$export$2e2bcd8739ae039.install = $a0ff767aa05ebc8a$var$ii;



var $h8ls9 = parcelRequire("h8ls9");
var $68a9b4b77dd6865e$exports = {};
$68a9b4b77dd6865e$exports = JSON.parse('{"noAssignedModeling":"","modelings":"","pleaseSignIn":"","email":"","enterLogin":"","signIn":"","password":"","enterPassword":"","filterByName":"","settings":"","logout":"","home":"","users":"","areas":"","modelingName":"","passwordChange":"","close":"","confirm":"","userDelete":"","wannaDeleteThisUser":"","delete":"","userCreation":"","create":"","name":"","enterUserName":"","loginName":"","role":"","chooseRole":"","projectadmin":"","viewer":"","admin":"","team":"","teamName":"","group":"","groups":"","chooseGroup":"","choose":"","groupCreation":"","enterGroupName":"","groupDetail":"","save":"","userDetail":"","string":"","integer":"","decimal":"","dateTime":"","boolean":"","column":"","dataType":"","row":"","tableName":"","import":"","dataSpaces":"","noAssignedDataSpace":"","dataspaces":"","dataSpaceName":"","dataSpaceCreation":"","dataSpaceDetail":"","wannaDeleteThisDataSpace":"","dataSpaceDelete":"","allDataWillBeLost":"","tables":"","batches":"","tablesInDataSpace":"","batchesInDataSpace":"","searchTable":"","noTables":"","tableDetail":"","structure":"","dataPreview":"","noData":"","confirmDeleteTable":"","importCsv":"","file":"","delimiter":"","semicolon":"","comma":"","tab":"","columns":"","importing":"","newBatch":"","editBatch":"","noBatches":"","confirmDeleteBatch":"","batchName":"","batchNamePlaceholder":"","createBatch":"","batchType":"","dataLoadMethod":"","typeCopy":"","typeCopyDesc":"","typeAggregation":"","typeAggregationDesc":"","typeCsd":"","typeCsdDesc":"","output":"","input":"","inputs":"","transformation":"","copy":"","aggregation":"","inputTable":"","outputTable":"","outputTableName":"","selectTable":"","outputIdName":"","outputFromName":"","outputToName":"","inputIdName":"","inputFromName":"","inputToName":"","includeColumns":"","addColumn":"","alias":"","function":"","selectFunction":"","groupBy":"","aggregateColumns":"","transformationSteps":"","stepTable":"","stepColumns":"","addStep":"","addInput":"","addTable":"","expressions":"","expression":"","addExpression":"","expressionPlaceholder":"","moveUp":"","moveDown":"","run":"","runDataBatch":"","areYouSureYouWantToRunThisDataBatch":"","running":"","batchRunSuccessful":"","batchRunUnsuccessful":"","tableAlreadyExists":"","unknownError":"","type":"","status":"","origin":"","source":"","rows":"","size":"","created":"","cancel":"","edit":"","back":"","continue":"","loading":"","lastRun":"","duration":"","saveAndRun":"","addGroupBy":"","transformations":"","transformationTable":"","addTransformation":"","creationType":"","createdBy":"","createdDate":"","export":"","detail":"","recreateTable":"","copyBatch":"","newBatchName":"","copying":"","batchCopySuccessful":"","deleteBatch":"","deleting":"","batchDeleteSuccessful":""}');


var $dbe0ca9f329339a9$exports = {};
$dbe0ca9f329339a9$exports = JSON.parse('{"noAssignedModeling":"No assigned project","modelings":"projects","pleaseSignIn":"Please sign in","email":"Email","enterLogin":"Enter UserName","signIn":"Sign in","password":"Password","enterPassword":"Enter password","filterByName":"Filter by name","settings":"Settings","logout":"Logout","home":"Home","users":"Users","areas":"Areas","modelingName":"Project name","passwordChange":"Password change","close":"Close","confirm":"Confirm","userDelete":"Delete user","wannaDeleteThisUser":"Are you sure you want to delete this user?","delete":"Delete","userCreation":"User creation","create":"Create","name":"Name","enterUserName":"Enter user name","loginName":"Login name","role":"Role","chooseRole":"Choose role","projectadmin":"Project Admin","viewer":"Viewer","admin":"Admin","team":"Team","teamName":"Team name","group":"Group","groups":"Groups","chooseGroup":"Choose group","choose":"Choose","groupCreation":"Group creation","enterGroupName":"Enter group name","groupDetail":"Group detail","save":"Save","userDetail":"User detail","string":"String","integer":"Integer","decimal":"Decimal","dateTime":"Date time","boolean":"Boolean","column":"Column","dataType":"Data type","row":"Row","tableName":"Table name","import":"Import","dataSpaces":"Dataspaces","noAssignedDataSpace":"No assigned dataspace","dataspaces":"Dataspaces","dataSpaceName":"Dataspace name","dataSpaceCreation":"Dataspace creation","dataSpaceDetail":"Dataspace detail","wannaDeleteThisDataSpace":"Are you sure you want to delete this dataspace?","dataSpaceDelete":"Delete dataspace","allDataWillBeLost":"All data will be lost.","tables":"Tables","batches":"Batches","tablesInDataSpace":"Tables in dataspace","batchesInDataSpace":"Batches in dataspace","searchTable":"Search table","noTables":"No tables","tableDetail":"Table detail","structure":"Structure","dataPreview":"Data preview","noData":"No data","confirmDeleteTable":"Are you sure you want to delete this table?","importCsv":"Import CSV","file":"File","delimiter":"Delimiter","semicolon":"Semicolon","comma":"Comma","tab":"Tab","columns":"Columns","importing":"Importing","newBatch":"New batch","editBatch":"Edit batch","noBatches":"No batches","confirmDeleteBatch":"Are you sure you want to delete this batch?","batchName":"Batch name","batchNamePlaceholder":"Enter batch name","createBatch":"Create batch","batchType":"Batch type","dataLoadMethod":"Data load method","typeCopy":"Copy","typeCopyDesc":"Copies the input table without changes.","typeAggregation":"Aggregation","typeAggregationDesc":"Groups rows and aggregates the selected columns.","typeCsd":"CSD","typeCsdDesc":"Splits data into elementary segments across multiple input tables.","output":"Output","input":"Input","inputs":"Inputs","transformation":"Transformation","copy":"Copy","aggregation":"Aggregation","inputTable":"Input table","outputTable":"Output table","outputTableName":"Output table name","selectTable":"Select table","outputIdName":"Output ID column","outputFromName":"Output FROM column","outputToName":"Output TO column","inputIdName":"Input ID column","inputFromName":"Input FROM column","inputToName":"Input TO column","includeColumns":"Include columns","addColumn":"Add column","alias":"Alias","function":"Function","selectFunction":"Select function","groupBy":"Group by","aggregateColumns":"Aggregate columns","transformationSteps":"Transformation steps","stepTable":"Step table","stepColumns":"Step columns","addStep":"Add step","addInput":"Add input","addTable":"Add table","expressions":"Expressions","expression":"Expression","addExpression":"Add expression","expressionPlaceholder":"e.g. [ColumnA] + [ColumnB]","moveUp":"Move up","moveDown":"Move down","run":"Run","runDataBatch":"Run batch","areYouSureYouWantToRunThisDataBatch":"Are you sure you want to run this batch?","running":"Running","batchRunSuccessful":"Batch completed successfully","batchRunUnsuccessful":"Batch run failed","tableAlreadyExists":"Table already exists","unknownError":"Unknown error","type":"Type","status":"Status","origin":"Origin","source":"Source","rows":"Rows","size":"Size","created":"Created","cancel":"Cancel","edit":"Edit","back":"Back","continue":"Continue","loading":"Loading","lastRun":"Last run","duration":"Duration","saveAndRun":"Save and run","addGroupBy":"Add group by","transformations":"Transformations","transformationTable":"Transformation table","addTransformation":"Add transformation","creationType":"Creation type","createdBy":"Created by","createdDate":"Created date","export":"Export","detail":"Detail","recreateTable":"Recreate table","copyBatch":"Copy batch","newBatchName":"New batch name","copying":"Copying","batchCopySuccessful":"Batch copied successfully","deleteBatch":"Delete batch","deleting":"Deleting","batchDeleteSuccessful":"Batch deleted successfully"}');


var $b27a1531d0f920dc$exports = {};
$b27a1531d0f920dc$exports = JSON.parse('{"noAssignedModeling":"Kein Projekt ausgew\xe4hlt","modelings":"Projekte","pleaseSignIn":"Bitte anmelden","email":"Email","enterLogin":"Eingabe Benutzername","signIn":"anmelden","password":"Passwort","enterPassword":"Eingabe Passwort","filterByName":"Filter nach Name","settings":"Einstellungen","logout":"Logout","home":"\xdcbersicht","users":"Nutzer","areas":"Gebiete","modelingName":"Projektname","passwordChange":"Passwort \xe4ndern","close":"Schlie\xdfen","confirm":"Best\xe4tigen","userDelete":"Nutzer l\xf6schen","wannaDeleteThisUser":"Wollen Sie den Nutzer l\xf6schen?","delete":"L\xf6schen","userCreation":"Nutzer anlegen","create":"Anlegen","name":"Name","enterUserName":"Eingabe Benutzername","loginName":"Benutzername","role":"Rolle","chooseRole":"Rolle ausw\xe4hlen","projectadmin":"Projekt Admin","viewer":"Betrachter","admin":"Admin","team":"Team","teamName":"Teambezeichnung","group":"Gruppe","groups":"Gruppen","chooseGroup":"Gruppe ausw\xe4hlen","choose":"Ausw\xe4hlen","groupCreation":"Gruppe anlegen","enterGroupName":"Eingabe Gruppenbezeichnung","groupDetail":"Gruppe Details","save":"Speichern","userDetail":"Nutzer Details","string":"Text","integer":"Ganzzahl","decimal":"Dezimalzahl","dateTime":"Datum/Uhrzeit","boolean":"Wahr/Falsch (Boolean)","column":"Spalte","dataType":"Datentyp","row":"Zeile","tableName":"Tabellenname","import":"Import","dataSpaces":"Projekte","noAssignedDataSpace":"Kein Projekt ausgew\xe4hlt","dataspaces":"Projekte","dataSpaceName":"Projektname","dataSpaceCreation":"Projekt anlegen","dataSpaceDetail":"Projekt Details","wannaDeleteThisDataSpace":"Wollen Sie das Projekt l\xf6schen?","dataSpaceDelete":"Projekt l\xf6schen","allDataWillBeLost":"Alle Daten werden gel\xf6scht","tables":"Tabellen","batches":"Prozesse","tablesInDataSpace":"Tabellen in Projekt","batchesInDataSpace":"Prozesse in Projekt","searchTable":"Tabellensuche","noTables":"Keine Tabelle","tableDetail":"Tabellen Details","structure":"Struktur","dataPreview":"Daten Vorschau","noData":"Keine Daten","confirmDeleteTable":"Best\xe4tigung Tabelle l\xf6schen","importCsv":"Import CSV","file":"Datei","delimiter":"Trennzeichen","semicolon":"Strichpunkt","comma":"Komma","tab":"Tab","columns":"Spalten","importing":"Importieren","newBatch":"Neuer Prozess","editBatch":"Prozess bearbeiten","noBatches":"Keine Prozesse","confirmDeleteBatch":"Best\xe4tigung Prozess l\xf6schen","batchName":"Prozessname","batchNamePlaceholder":"Platzhalter Prozessname","createBatch":"Prozess anlegen","batchType":"Prozesstyp","dataLoadMethod":"Prozesstyp","typeCopy":"Datentransfer","typeCopyDesc":"Abschnitte vorhanden, Datenspalten werden erzeugt","typeAggregation":"Datengruppierung","typeAggregationDesc":"Datenaggregierung zu definierten Gruppen","typeCsd":"KGN","typeCsdDesc":"Abschnittsbildung durch Kleinstes Gemeinsames Nenner Verfahren","output":"Ausgabe","input":"Eingabe","inputs":"Eingaben","transformation":"Transformation","copy":"Kopie","aggregation":"Datengruppierung","inputTable":"Eingangstabelle","outputTable":"Ergebnistabelle","outputTableName":"Name Ergebnistabelle","selectTable":"Tabelle w\xe4hlen","outputIdName":"Ergebnistabelle Spalte ID","outputFromName":"Ergebnistabelle Spalte Von","outputToName":"Ergebnistabelle Spalte Bis","inputIdName":"Eingangstabelle Spalte ID","inputFromName":"Eingangstabelle Spalte Von","inputToName":"Eingangstabelle Spalte Bis","includeColumns":"Auswahl Spalten","addColumn":"Spalte hinzuf\xfcgen","alias":"Alias","function":"Typ","selectFunction":"Auswahl Typ","groupBy":"Gruppierung nach","aggregateColumns":"Spalten Gruppe","transformationSteps":"Transformationsschritte","stepTable":"Schritt Tabelle","stepColumns":"Schritt Spalten","addStep":"Schritt hinzuf\xfcgen","addInput":"Eingabe hinzuf\xfcgen","addTable":"Tabelle hinzuf\xfcgen","expressions":"Formeln","expression":"Formel","addExpression":"Formel hinzuf\xfcgen","expressionPlaceholder":"Platzhalter Formel","moveUp":"hinauf","moveDown":"hinunter","run":"Ausf\xfchren","runDataBatch":"Prozess ausf\xfchren","areYouSureYouWantToRunThisDataBatch":"Wollen Sie den Prozess ausf\xfchren?","running":"Wird ausgef\xfchrt","batchRunSuccessful":"Prozess erfolgreich ausgef\xfchrt","batchRunUnsuccessful":"Prozess NICHT erfolgreich ausgef\xfchrt","tableAlreadyExists":"Tabelle existiert bereits","unknownError":"Unbekannter Fehler","type":"Typ","status":"Status","origin":"Ursprung","source":"Quelle","rows":"Zeilen","size":"Gr\xf6\xdfe","created":"Erstellt","cancel":"Abbrechen","edit":"Bearbeiten","back":"Zur\xfcck","continue":"Fortsetzen","loading":"Laden","lastRun":"Letzte Ausf\xfchrung","duration":"Dauer","saveAndRun":"Speichern und ausf\xfchren","addGroupBy":"Gruppierung hinzuf\xfcgen","transformations":"Transformationen","transformationTable":"Transformationstabelle","addTransformation":"Transformation hinzuf\xfcgen","creationType":"Typ","createdBy":"Erstellt von","createdDate":"Datum","export":"Export","detail":"Detail"}');


/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ /*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $fbd1e3bc010bc8c2$export$620a268685f0ac45 = typeof window !== "undefined";
let $fbd1e3bc010bc8c2$export$bf7f2fce5c1cf636;
let $fbd1e3bc010bc8c2$export$83602b44513dc228;
var $fbd1e3bc010bc8c2$var$tag, $fbd1e3bc010bc8c2$var$name, $fbd1e3bc010bc8c2$var$startTag, $fbd1e3bc010bc8c2$var$endTag;
const $fbd1e3bc010bc8c2$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $fbd1e3bc010bc8c2$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($fbd1e3bc010bc8c2$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
const $fbd1e3bc010bc8c2$export$cd133c5e04906ece = (name, shareable = false)=>!shareable ? Symbol(name) : Symbol.for(name);
const $fbd1e3bc010bc8c2$export$5024ef1f92c9a364 = (locale, key, source)=>$fbd1e3bc010bc8c2$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $fbd1e3bc010bc8c2$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const $fbd1e3bc010bc8c2$export$7e4aa119212bc614 = (val)=>typeof val === "number" && isFinite(val);
const $fbd1e3bc010bc8c2$export$871608497c498473 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === "[object Date]";
const $fbd1e3bc010bc8c2$export$49841c62b9eff15 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === "[object RegExp]";
const $fbd1e3bc010bc8c2$export$83b788b1a3698c03 = (val)=>$fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
const $fbd1e3bc010bc8c2$export$e6e34fd1f2686227 = Object.assign;
let $fbd1e3bc010bc8c2$var$_globalThis;
const $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $fbd1e3bc010bc8c2$var$_globalThis || ($fbd1e3bc010bc8c2$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
function $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const $fbd1e3bc010bc8c2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3(obj, key) {
    return $fbd1e3bc010bc8c2$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $fbd1e3bc010bc8c2$export$43bee75e5e14138e = Array.isArray;
const $fbd1e3bc010bc8c2$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fbd1e3bc010bc8c2$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $fbd1e3bc010bc8c2$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$4369c812aac99591 = (val)=>{
    return $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.then) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.catch);
};
const $fbd1e3bc010bc8c2$export$830c053460e5ddf6 = Object.prototype.toString;
const $fbd1e3bc010bc8c2$export$1dccc787cc36538b = (value)=>$fbd1e3bc010bc8c2$export$830c053460e5ddf6.call(value);
const $fbd1e3bc010bc8c2$export$53b83ca8eaab0383 = (val)=>{
    if (!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val)) return false;
    const proto = Object.getPrototypeOf(val);
    return proto === null || proto.constructor === Object;
};
// for converting list and named values to displayed strings.
const $fbd1e3bc010bc8c2$export$b5b1545233b45293 = (val)=>{
    return val == null ? "" : $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val) || $fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && val.toString === $fbd1e3bc010bc8c2$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
function $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd(items, separator = "") {
    return items.reduce((str, item, index)=>index === 0 ? str + item : str + separator + item, "");
}
const $fbd1e3bc010bc8c2$var$RANGE = 2;
function $fbd1e3bc010bc8c2$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $fbd1e3bc010bc8c2$var$RANGE; j <= i + $fbd1e3bc010bc8c2$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $fbd1e3bc010bc8c2$export$47db5deb603dfca1(code) {
    let current = code;
    return ()=>++current;
}
function $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $fbd1e3bc010bc8c2$var$hasWarned = {};
function $fbd1e3bc010bc8c2$export$5b28268982f175ba(msg) {
    if (!$fbd1e3bc010bc8c2$var$hasWarned[msg]) {
        $fbd1e3bc010bc8c2$var$hasWarned[msg] = true;
        $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg);
    }
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get("*") || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}
const $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray = (val)=>!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) || $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $fbd1e3bc010bc8c2$export$6c40052bed430212(src, des) {
    // src and des should both be objects, and none of them can be a array
    if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des)) throw new Error("Invalid value");
    const stack = [
        {
            src: src,
            des: des
        }
    ];
    while(stack.length){
        const { src: src, des: des } = stack.pop();
        Object.keys(src).forEach((key)=>{
            if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src[key]) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des[key])) // replace with src[key] when:
            // src[key] or des[key] is not an object, or
            // src[key] or des[key] is an array
            des[key] = src[key];
            else // src[key] and des[key] are both objects, merge them
            stack.push({
                src: src[key],
                des: des[key]
            });
        });
    }
}


/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */ 
const $b46efaa99568cb1e$export$7119efed969a17d8 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $b46efaa99568cb1e$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $b46efaa99568cb1e$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $b46efaa99568cb1e$export$21499b937901db8a = {
    USE_MODULO_SYNTAX: 1,
    __EXTEND_POINT__: 2
};
/** @internal */ const $b46efaa99568cb1e$export$a9ce0120dbc716f9 = {
    [$b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX]: `Use modulo before '{{0}}'.`
};
function $b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, ...args) {
    const msg = code;
    const message = {
        message: String(msg),
        code: code
    };
    if (loc) message.location = loc;
    return message;
}
const $b46efaa99568cb1e$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 17
};
/** @internal */ const $b46efaa99568cb1e$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $b46efaa99568cb1e$export$ad0eb2c702f03471(error) {
    throw error;
}
// eslint-disable-next-line no-useless-escape
const $b46efaa99568cb1e$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $b46efaa99568cb1e$export$6de85467cbd6ae39 = (source)=>$b46efaa99568cb1e$var$RE_HTML_TAG.test(source);
const $b46efaa99568cb1e$var$CHAR_SP = " ";
const $b46efaa99568cb1e$var$CHAR_CR = "\r";
const $b46efaa99568cb1e$var$CHAR_LF = "\n";
const $b46efaa99568cb1e$var$CHAR_LS = String.fromCharCode(0x2028);
const $b46efaa99568cb1e$var$CHAR_PS = String.fromCharCode(0x2029);
function $b46efaa99568cb1e$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_CR && _buf[index + 1] === $b46efaa99568cb1e$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $b46efaa99568cb1e$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $b46efaa99568cb1e$var$EOF = undefined;
const $b46efaa99568cb1e$var$DOT = ".";
const $b46efaa99568cb1e$var$LITERAL_DELIMITER = "'";
const $b46efaa99568cb1e$var$ERROR_DOMAIN$3 = "tokenizer";
function $b46efaa99568cb1e$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $b46efaa99568cb1e$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$b46efaa99568cb1e$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* TokenTypes.EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* TokenTypes.EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(ctx.startLoc, pos) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$var$ERROR_DOMAIN$3,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $b46efaa99568cb1e$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 14 /* TokenTypes.EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    }
    function peekSpaces(scnr) {
        let buf = "";
        while(scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_SP || scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $b46efaa99568cb1e$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 12 /* TokenTypes.LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 10 /* TokenTypes.LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* TokenChars.LinkedAlias */  || ch === "%" /* TokenChars.Modulo */  || ch === "|" /* TokenChars.Pipe */  || ch === ":" /* TokenChars.LinkedDelimiter */  || ch === "." /* TokenChars.LinkedDot */  || ch === $b46efaa99568cb1e$var$CHAR_SP || !ch) return false;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isTextStart(scnr, false);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* TokenChars.Modulo */  && scnr.peek() === "{" /* TokenChars.BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = "", detectModulo = false)=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return prev === "%" /* TokenChars.Modulo */  ? false : hasSpace;
            else if (ch === "@" /* TokenChars.LinkedAlias */  || !ch) return prev === "%" /* TokenChars.Modulo */  ? true : hasSpace;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* TokenChars.Modulo */ , true);
            } else if (ch === "|" /* TokenChars.Pipe */ ) return prev === "%" /* TokenChars.Modulo */  || detectModulo ? true : !(prev === $b46efaa99568cb1e$var$CHAR_SP || prev === $b46efaa99568cb1e$var$CHAR_LF);
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_SP, detectModulo);
            } else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_LF, detectModulo);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $b46efaa99568cb1e$var$EOF) return $b46efaa99568cb1e$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 // $
        ;
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 || // $
        cc === 45 // -
        ;
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57 || // 0-9
        cc >= 65 && cc <= 70 || // A-F
        cc >= 97 && cc <= 102; // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = "";
        let num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* TokenChars.Modulo */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* TokenChars.Modulo */ ;
    }
    function readText(scnr) {
        let buf = "";
        // eslint-disable-next-line no-constant-condition
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "}" /* TokenChars.BraceRight */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || !ch) break;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $b46efaa99568cb1e$var$CHAR_SP || ch === $b46efaa99568cb1e$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let name = "";
        while(ch = takeNamedIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function isLiteral(ch) {
        return ch !== $b46efaa99568cb1e$var$LITERAL_DELIMITER && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = "";
        let literal = "";
        while(ch = takeChar(scnr, isLiteral))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $b46efaa99568cb1e$var$CHAR_LF || current === $b46efaa99568cb1e$var$EOF) {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = "";
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return ch !== "{" /* TokenChars.BraceLeft */  && ch !== "}" /* TokenChars.BraceRight */  && ch !== $b46efaa99568cb1e$var$CHAR_SP && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let identifiers = "";
        while(ch = takeChar(scnr, isInvalidIdentifier))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = "";
        let name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "%" /* TokenChars.Modulo */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === "(" /* TokenChars.ParenLeft */  || ch === ")" /* TokenChars.ParenRight */  || !ch) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn("");
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                if (context.braceNest >= 1) emitError($b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */ , "{" /* TokenChars.BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* TokenTypes.BraceLeft */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* TokenChars.LinkedAlias */ :
                if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                {
                    let validNamedIdentifier = true;
                    let validListIdentifier = true;
                    let validLiteral = true;
                    if (isPluralStart(scnr)) {
                        if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    if (context.braceNest > 0 && (context.currentType === 5 /* TokenTypes.Named */  || context.currentType === 6 /* TokenTypes.List */  || context.currentType === 7 /* TokenTypes.Literal */ )) {
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        context.braceNest = 0;
                        return readToken(scnr, context);
                    }
                    if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                        token = getToken(context, 5 /* TokenTypes.Named */ , readNamedIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                        token = getToken(context, 6 /* TokenTypes.List */ , readListIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validLiteral = isLiteralStart(scnr, context)) {
                        token = getToken(context, 7 /* TokenTypes.Literal */ , readLiteral(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                        // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                        token = getToken(context, 13 /* TokenTypes.InvalidPlace */ , readInvalidIdentifier(scnr));
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                        skipSpaces(scnr);
                        return token;
                    }
                    break;
                }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 9 /* TokenTypes.LinkedDot */  || currentType === 12 /* TokenTypes.LinkedModifier */  || currentType === 10 /* TokenTypes.LinkedDelimiter */ ) && (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$CHAR_SP)) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* TokenChars.LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* TokenTypes.LinkedAlias */ , "@" /* TokenChars.LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDot */ , "." /* TokenChars.LinkedDot */ );
            case ":" /* TokenChars.LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* TokenTypes.LinkedDelimiter */ , ":" /* TokenChars.LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* TokenTypes.LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* TokenTypes.LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* TokenTypes.LinkedAlias */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 14 /* TokenTypes.EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */ :
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
            case "@" /* TokenChars.LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                {
                    if (isPluralStart(scnr)) {
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    const { isModulo: isModulo, hasSpace: hasSpace } = detectModuloStart(scnr);
                    if (isModulo) return hasSpace ? getToken(context, 0 /* TokenTypes.Text */ , readText(scnr)) : getToken(context, 4 /* TokenTypes.Modulo */ , readModulo(scnr));
                    if (isTextStart(scnr)) return getToken(context, 0 /* TokenTypes.Text */ , readText(scnr));
                    break;
                }
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $b46efaa99568cb1e$var$EOF) return getToken(_context, 14 /* TokenTypes.EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $b46efaa99568cb1e$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $b46efaa99568cb1e$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $b46efaa99568cb1e$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $b46efaa99568cb1e$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError, onWarn: onWarn } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function emitWarn(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onWarn) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            onWarn($b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, args));
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type
        };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = {
                start: loc,
                end: loc
            };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (type) node.type = type;
        if (location) {
            node.end = offset;
            if (node.loc) node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key, modulo) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */ , offset, loc);
        node.key = key;
        if (modulo === true) node.modulo = true;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */ , offset, loc);
        node.value = value.replace($b46efaa99568cb1e$var$KNOWN_ESCAPES, $b46efaa99568cb1e$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* TokenTypes.LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* TokenTypes.LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* TokenTypes.LinkedDelimiter */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* TokenTypes.LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* TokenTypes.Named */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* TokenTypes.List */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* TokenTypes.Literal */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                {
                    // empty key
                    emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                    const nextContext = tokenizer.context();
                    const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */ , nextContext.offset, nextContext.startLoc);
                    emptyLinkedKeyNode.value = "";
                    endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                    linkedNode.key = emptyLinkedKeyNode;
                    endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                    return {
                        nextConsumeToken: token,
                        node: linkedNode
                    };
                }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        let modulo = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* TokenTypes.Text */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* TokenTypes.List */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 4 /* TokenTypes.Modulo */ :
                    modulo = true;
                    break;
                case 5 /* TokenTypes.Named */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || "", !!modulo));
                    if (modulo) {
                        emitWarn(tokenizer, $b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                        modulo = null;
                    }
                    break;
                case 7 /* TokenTypes.Literal */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* TokenTypes.LinkedAlias */ :
                    {
                        const parsed = parseLinked(tokenizer);
                        node.items.push(parsed.node);
                        nextToken = parsed.nextConsumeToken || null;
                        break;
                    }
            }
        }while (context.currentType !== 14 /* TokenTypes.EOF */  && context.currentType !== 1 /* TokenTypes.Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* TokenTypes.EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* TokenTypes.EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $b46efaa99568cb1e$var$createTokenizer(source, (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) node.cacheKey = options.onCacheKey(source);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* TokenTypes.EOF */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $b46efaa99568cb1e$var$getTokenCaption(token) {
    if (token.type === 14 /* TokenTypes.EOF */ ) return "EOF";
    const name = (token.value || "").replace(/\r?\n/gu, "\\n");
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $b46efaa99568cb1e$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $b46efaa99568cb1e$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$b46efaa99568cb1e$var$traverseNode(nodes[i], transformer);
}
function $b46efaa99568cb1e$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */ );
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$traverseNode(linked.key, transformer);
                transformer.helper("linked" /* HelperNameMap.LINKED */ );
                transformer.helper("type" /* HelperNameMap.TYPE */ );
                break;
            }
        case 5 /* NodeTypes.List */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("list" /* HelperNameMap.LIST */ );
            break;
        case 4 /* NodeTypes.Named */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("named" /* HelperNameMap.NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $b46efaa99568cb1e$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $b46efaa99568cb1e$var$createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */ );
    // traverse
    ast.body && $b46efaa99568cb1e$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $b46efaa99568cb1e$var$optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */ ) $b46efaa99568cb1e$var$optimizeMessageNode(body);
    else body.cases.forEach((c)=>$b46efaa99568cb1e$var$optimizeMessageNode(c));
    return ast;
}
function $b46efaa99568cb1e$var$optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    } else {
        const values = [];
        for(let i = 0; i < message.items.length; i++){
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ )) break;
            if (item.value == null) break;
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = (0, $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd)(values);
            for(let i = 0; i < message.items.length; i++){
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) delete item.value; // optimization for size
            }
        }
    }
}
const $b46efaa99568cb1e$var$ERROR_DOMAIN$1 = "minifier";
/* eslint-disable @typescript-eslint/no-explicit-any */ function $b46efaa99568cb1e$var$minify(node) {
    node.t = node.type;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            {
                const resource = node;
                $b46efaa99568cb1e$var$minify(resource.body);
                resource.b = resource.body;
                delete resource.body;
                break;
            }
        case 1 /* NodeTypes.Plural */ :
            {
                const plural = node;
                const cases = plural.cases;
                for(let i = 0; i < cases.length; i++)$b46efaa99568cb1e$var$minify(cases[i]);
                plural.c = cases;
                delete plural.cases;
                break;
            }
        case 2 /* NodeTypes.Message */ :
            {
                const message = node;
                const items = message.items;
                for(let i = 0; i < items.length; i++)$b46efaa99568cb1e$var$minify(items[i]);
                message.i = items;
                delete message.items;
                if (message.static) {
                    message.s = message.static;
                    delete message.static;
                }
                break;
            }
        case 3 /* NodeTypes.Text */ :
        case 9 /* NodeTypes.Literal */ :
        case 8 /* NodeTypes.LinkedModifier */ :
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const valueNode = node;
                if (valueNode.value) {
                    valueNode.v = valueNode.value;
                    delete valueNode.value;
                }
                break;
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$minify(linked.key);
                linked.k = linked.key;
                delete linked.key;
                if (linked.modifier) {
                    $b46efaa99568cb1e$var$minify(linked.modifier);
                    linked.m = linked.modifier;
                    delete linked.modifier;
                }
                break;
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                list.i = list.index;
                delete list.index;
                break;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                named.k = named.key;
                delete named.key;
                break;
            }
        default:
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ // eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const $b46efaa99568cb1e$var$ERROR_DOMAIN = "parser";
function $b46efaa99568cb1e$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) _context.source = ast.loc.source;
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $b46efaa99568cb1e$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */ )}(`);
    $b46efaa99568cb1e$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $b46efaa99568cb1e$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $b46efaa99568cb1e$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $b46efaa99568cb1e$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $b46efaa99568cb1e$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $b46efaa99568cb1e$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $b46efaa99568cb1e$var$generateResource(generator, node) {
    if (node.body) $b46efaa99568cb1e$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $b46efaa99568cb1e$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            $b46efaa99568cb1e$var$generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */ :
            $b46efaa99568cb1e$var$generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("list" /* HelperNameMap.LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("named" /* HelperNameMap.NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
const $b46efaa99568cb1e$var$generate = (ast, options = {} // eslint-disable-line
)=>{
    const mode = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.mode) ? options.mode : "normal";
    const filename = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.filename) ? options.filename : "message.intl";
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    const helpers = ast.helpers || [];
    const generator = $b46efaa99568cb1e$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${(0, $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd)(helpers.map((s)=>`${s}: _${s}`), ", ")} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $b46efaa99568cb1e$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $b46efaa99568cb1e$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = $b46efaa99568cb1e$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        $b46efaa99568cb1e$var$transform(ast, assignedOptions);
        // generate javascript codes
        return $b46efaa99568cb1e$var$generate(ast, assignedOptions);
    } else {
        // optimize ASTs
        enambeOptimize && $b46efaa99568cb1e$var$optimize(ast);
        // minimize ASTs
        enalbeMinify && $b46efaa99568cb1e$var$minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return {
            ast: ast,
            code: ""
        };
    }
}


/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $a739018d680a1535$var$initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
}
const $a739018d680a1535$var$pathStateMachine = [];
$a739018d680a1535$var$pathStateMachine[0 /* States.BEFORE_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        0 /* States.BEFORE_PATH */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[1 /* States.IN_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[2 /* States.BEFORE_IDENT */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[3 /* States.IN_IDENT */ ] = {
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ ,
        1 /* Actions.PUSH */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ ,
        1 /* Actions.PUSH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[4 /* States.IN_SUB_PATH */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        2 /* Actions.INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */ ]: [
        1 /* States.IN_PATH */ ,
        3 /* Actions.PUSH_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[5 /* States.IN_SINGLE_QUOTE */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */ ] = {
    ['"' /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $a739018d680a1535$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $a739018d680a1535$var$isLiteral(exp) {
    return $a739018d680a1535$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $a739018d680a1535$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $a739018d680a1535$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* PathCharTypes.END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* PathCharTypes.IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* PathCharTypes.WORKSPACE */ ;
    }
    return "i" /* PathCharTypes.IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $a739018d680a1535$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $a739018d680a1535$var$isLiteral(trimmed) ? $a739018d680a1535$var$stripQuotes(trimmed) : "*" /* PathCharTypes.ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $a739018d680a1535$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* Actions.PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* Actions.APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */ ;
            actions[0 /* Actions.APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $a739018d680a1535$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* Actions.PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* States.IN_SINGLE_QUOTE */  && nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */  || mode === 6 /* States.IN_DOUBLE_QUOTE */  && nextChar === '"' /* PathCharTypes.DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* Actions.APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $a739018d680a1535$var$getPathCharType(c);
        typeMap = $a739018d680a1535$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */ ] || 8 /* States.ERROR */ ;
        // check parse error
        if (transition === 8 /* States.ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $a739018d680a1535$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$b365de4c3506886c(obj, path) {
    return (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj)) return null;
    // parse path
    let hit = $a739018d680a1535$var$cache.get(path);
    if (!hit) {
        hit = $a739018d680a1535$export$98e6a39c04603d36(path);
        if (hit) $a739018d680a1535$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const val = last[hit[i]];
        if (val === undefined) return null;
        if ((0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(last)) return null;
        last = val;
        i++;
    }
    return last;
}
const $a739018d680a1535$var$DEFAULT_MODIFIER = (str)=>str;
const $a739018d680a1535$var$DEFAULT_MESSAGE = (ctx)=>""; // eslint-disable-line
const $a739018d680a1535$export$12b53af6b8529bfc = "text";
const $a739018d680a1535$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? "" : (0, $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd)(values);
const $a739018d680a1535$var$DEFAULT_INTERPOLATE = (0, $fbd1e3bc010bc8c2$export$b5b1545233b45293);
function $a739018d680a1535$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $a739018d680a1535$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.count) || (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.n)) ? (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.count) ? options.named.count : (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.named.n) ? options.named.n : index : index;
}
function $a739018d680a1535$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $a739018d680a1535$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $a739018d680a1535$var$getPluralIndex(options);
    const pluralRule = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? options.pluralRules[locale] : $a739018d680a1535$var$pluralDefault;
    const orgPluralRule = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? $a739018d680a1535$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || {};
    (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.pluralIndex) && $a739018d680a1535$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key) {
        // prettier-ignore
        const msg = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.messages) ? options.messages(key) : (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $a739018d680a1535$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $a739018d680a1535$var$DEFAULT_MODIFIER;
    const normalize = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.processor.normalize) ? options.processor.normalize : $a739018d680a1535$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) && (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.processor.interpolate) ? options.processor.interpolate : $a739018d680a1535$var$DEFAULT_INTERPOLATE;
    const type = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.processor.type) ? options.processor.type : $a739018d680a1535$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = "text";
        let modifier = "";
        if (args.length === 1) {
            if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
            if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) type = arg2 || type;
        }
        const ret = message(key)(ctx);
        const msg = // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === "vnode" && (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(ret) && modifier ? ret[0] : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */ ]: list,
        ["named" /* HelperNameMap.NAMED */ ]: named,
        ["plural" /* HelperNameMap.PLURAL */ ]: plural,
        ["linked" /* HelperNameMap.LINKED */ ]: linked,
        ["message" /* HelperNameMap.MESSAGE */ ]: message,
        ["type" /* HelperNameMap.TYPE */ ]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */ ]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */ ]: normalize,
        ["values" /* HelperNameMap.VALUES */ ]: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, _list, _named)
    };
    return ctx;
}
let $a739018d680a1535$var$devtools = null;
function $a739018d680a1535$export$c893d6c8966908b9(hook) {
    $a739018d680a1535$var$devtools = hook;
}
function $a739018d680a1535$export$8bd08e70642dc6f4() {
    return $a739018d680a1535$var$devtools;
}
function $a739018d680a1535$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit("i18n:init" /* IntlifyDevToolsHooks.I18nInit */ , {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $a739018d680a1535$export$190d71a47ff3f767 = /* #__PURE__*/ $a739018d680a1535$var$createDevToolsHook("function:translate" /* IntlifyDevToolsHooks.FunctionTranslate */ );
function $a739018d680a1535$var$createDevToolsHook(hook) {
    return (payloads)=>$a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit(hook, payloads);
}
const $a739018d680a1535$var$code$1 = (0, $b46efaa99568cb1e$export$21499b937901db8a).__EXTEND_POINT__;
const $a739018d680a1535$var$inc$1 = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($a739018d680a1535$var$code$1);
const $a739018d680a1535$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: $a739018d680a1535$var$code$1,
    FALLBACK_TO_TRANSLATE: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_NUMBER: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_NUMBER_FORMAT: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_DATE: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_DATE_FORMAT: $a739018d680a1535$var$inc$1(),
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: $a739018d680a1535$var$inc$1(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc$1() // 9
};
/** @internal */ const $a739018d680a1535$var$warnMessages = {
    [$a739018d680a1535$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function $a739018d680a1535$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $fbd1e3bc010bc8c2$export$d9468344d3651243)($a739018d680a1535$var$warnMessages[code], ...args);
}
const $a739018d680a1535$var$code = (0, $b46efaa99568cb1e$export$77436aae039469c4).__EXTEND_POINT__;
const $a739018d680a1535$var$inc = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($a739018d680a1535$var$code);
const $a739018d680a1535$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $a739018d680a1535$var$code,
    INVALID_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_NON_STRING_MESSAGE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_TYPE: $a739018d680a1535$var$inc(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc() // 24
};
function $a739018d680a1535$export$3d702f7ac45b0a6b(code) {
    return (0, $b46efaa99568cb1e$export$21efa8bb37d5fecb)(code, null, undefined);
}
/** @internal */ const $a739018d680a1535$var$errorMessages = {
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT]: "Invalid arguments",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
/** @internal */ function $a739018d680a1535$export$180605366c04f0cd(context, options) {
    return options.locale != null ? $a739018d680a1535$export$df9bcabe7f932e01(options.locale) : $a739018d680a1535$export$df9bcabe7f932e01(context.locale);
}
let $a739018d680a1535$var$_resolveLocale;
/** @internal */ function $a739018d680a1535$export$df9bcabe7f932e01(locale) {
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale)) return locale;
    else {
        if ((0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(locale)) {
            if (locale.resolvedOnce && $a739018d680a1535$var$_resolveLocale != null) return $a739018d680a1535$var$_resolveLocale;
            else if (locale.constructor.name === "Function") {
                const resolve = locale();
                if ((0, $fbd1e3bc010bc8c2$export$4369c812aac99591)(resolve)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                return $a739018d680a1535$var$_resolveLocale = resolve;
            } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
        } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE);
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(fallback) ? fallback : (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(fallback) ? Object.keys(fallback) : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(start) ? start : $a739018d680a1535$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(block))block = $a739018d680a1535$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(fallback) || !(0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(block)) $a739018d680a1535$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $a739018d680a1535$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(follow); i++){
        const locale = block[i];
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale)) follow = $a739018d680a1535$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $a739018d680a1535$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split("-");
    do {
        const target = tokens.join("-");
        follow = $a739018d680a1535$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $a739018d680a1535$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            const locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(blocks) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $a739018d680a1535$export$a4ad2735b021c132 = "9.13.1";
const $a739018d680a1535$export$b7f13a18d1d0f835 = -1;
const $a739018d680a1535$export$1af4c7e47ad72f44 = "en-US";
const $a739018d680a1535$export$a04371e9dbb3870b = "";
const $a739018d680a1535$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $a739018d680a1535$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) ? val.toUpperCase() : type === "vnode" && (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) ? val.toLowerCase() : type === "vnode" && (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) ? $a739018d680a1535$var$capitalize(val) : type === "vnode" && (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? $a739018d680a1535$var$capitalize(val.children) : val;
        }
    };
}
let $a739018d680a1535$var$_compiler;
function $a739018d680a1535$export$6ee2fbe83628b40b(compiler) {
    $a739018d680a1535$var$_compiler = compiler;
}
let $a739018d680a1535$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$45dacdc710815463(resolver) {
    $a739018d680a1535$var$_resolver = resolver;
}
let $a739018d680a1535$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$fd8ec9dd8067edec(fallbacker) {
    $a739018d680a1535$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $a739018d680a1535$var$_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$605703447dca72aa = (meta)=>{
    $a739018d680a1535$var$_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$817795a14e5c6622 = ()=>$a739018d680a1535$var$_additionalMeta;
let $a739018d680a1535$var$_fallbackContext = null;
const $a739018d680a1535$export$e16aca6786e72a5e = (context)=>{
    $a739018d680a1535$var$_fallbackContext = context;
};
const $a739018d680a1535$export$3adddc434faa9e35 = ()=>$a739018d680a1535$var$_fallbackContext;
// ID for CoreContext
let $a739018d680a1535$var$_cid = 0;
function $a739018d680a1535$export$3599d465b05a74a5(options = {}) {
    // setup options
    const onWarn = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.onWarn) ? options.onWarn : (0, $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d);
    const version = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.version) ? options.version : $a739018d680a1535$export$a4ad2735b021c132;
    const locale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) || (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.locale) ? options.locale : $a739018d680a1535$export$1af4c7e47ad72f44;
    const _locale = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(locale) ? $a739018d680a1535$export$1af4c7e47ad72f44 : locale;
    const fallbackLocale = (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
    const messages = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.messages) ? options.messages : {
        [_locale]: {}
    };
    const datetimeFormats = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale]: {}
    };
    const numberFormats = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale]: {}
    };
    const modifiers = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options.modifiers || {}, $a739018d680a1535$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || {};
    const missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.messageCompiler) ? options.messageCompiler : $a739018d680a1535$var$_compiler;
    const messageResolver = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.messageResolver) ? options.messageResolver : $a739018d680a1535$var$_resolver || $a739018d680a1535$export$b365de4c3506886c;
    const localeFallbacker = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.localeFallbacker) ? options.localeFallbacker : $a739018d680a1535$var$_fallbacker || $a739018d680a1535$export$e3330076537ef9d1;
    const fallbackContext = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.fallbackContext) ? options.fallbackContext : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(internalOptions.__meta) ? internalOptions.__meta : {};
    $a739018d680a1535$var$_cid++;
    const context = {
        version: version,
        cid: $a739018d680a1535$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $a739018d680a1535$export$725afc6a300324a0(context, version, __meta);
    return context;
}
/** @internal */ function $a739018d680a1535$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $a739018d680a1535$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $a739018d680a1535$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $a739018d680a1535$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */ function $a739018d680a1535$export$59f8e8904fd79a18(locale, compareLocale) {
    if (locale === compareLocale) return false;
    return locale.split("-")[0] === compareLocale.split("-")[0];
}
/** @internal */ function $a739018d680a1535$export$d783301aca6271c3(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) return false;
    for(let i = index + 1; i < locales.length; i++){
        if ($a739018d680a1535$export$59f8e8904fd79a18(targetLocale, locales[i])) return true;
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ function $a739018d680a1535$var$format(ast) {
    const msg = (ctx)=>$a739018d680a1535$var$formatParts(ctx, ast);
    return msg;
}
function $a739018d680a1535$var$formatParts(ctx, ast) {
    const body = ast.b || ast.body;
    if ((body.t || body.type) === 1 /* NodeTypes.Plural */ ) {
        const plural = body;
        const cases = plural.c || plural.cases;
        return ctx.plural(cases.reduce((messages, c)=>[
                ...messages,
                $a739018d680a1535$var$formatMessageParts(ctx, c)
            ], []));
    } else return $a739018d680a1535$var$formatMessageParts(ctx, body);
}
function $a739018d680a1535$var$formatMessageParts(ctx, node) {
    const _static = node.s || node.static;
    if (_static) return ctx.type === "text" ? _static : ctx.normalize([
        _static
    ]);
    else {
        const messages = (node.i || node.items).reduce((acm, c)=>[
                ...acm,
                $a739018d680a1535$var$formatMessagePart(ctx, c)
            ], []);
        return ctx.normalize(messages);
    }
}
function $a739018d680a1535$var$formatMessagePart(ctx, node) {
    const type = node.t || node.type;
    switch(type){
        case 3 /* NodeTypes.Text */ :
            {
                const text = node;
                return text.v || text.value;
            }
        case 9 /* NodeTypes.Literal */ :
            {
                const literal = node;
                return literal.v || literal.value;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                return ctx.interpolate(ctx.named(named.k || named.key));
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                return ctx.interpolate(ctx.list(list.i != null ? list.i : list.index));
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                const modifier = linked.m || linked.modifier;
                return ctx.linked($a739018d680a1535$var$formatMessagePart(ctx, linked.k || linked.key), modifier ? $a739018d680a1535$var$formatMessagePart(ctx, modifier) : undefined, ctx.type);
            }
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const linkedKey = node;
                return linkedKey.v || linkedKey.value;
            }
        case 8 /* NodeTypes.LinkedModifier */ :
            {
                const linkedModifier = node;
                return linkedModifier.v || linkedModifier.value;
            }
        default:
            throw new Error(`unhandled node type on format message part: ${type}`);
    }
}
const $a739018d680a1535$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $a739018d680a1535$var$checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && (0, $b46efaa99568cb1e$export$6de85467cbd6ae39)(source)) (0, $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d)((0, $fbd1e3bc010bc8c2$export$d9468344d3651243)($a739018d680a1535$var$WARN_MESSAGE, {
        source: source
    }));
}
const $a739018d680a1535$var$defaultOnCacheKey = (message)=>message;
let $a739018d680a1535$var$compileCache = Object.create(null);
function $a739018d680a1535$var$onCompileWarn(_warn) {
    if (_warn.code === (0, $b46efaa99568cb1e$export$21499b937901db8a).USE_MODULO_SYNTAX) (0, $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d)(`The use of named interpolation with modulo syntax is deprecated. ` + `It will be removed in v10.\n` + `reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format \n` + `(message compiler warning message: ${_warn.message})`);
}
function $a739018d680a1535$export$2683c80ae3fe544() {
    $a739018d680a1535$var$compileCache = Object.create(null);
}
const $a739018d680a1535$export$9ba95744594b90e0 = (val)=>(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(val) && (val.t === 0 || val.type === 0) && ("b" in val || "body" in val);
function $a739018d680a1535$var$baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || (0, $b46efaa99568cb1e$export$ad0eb2c702f03471);
    options.onError = (err)=>{
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return {
        ...(0, $b46efaa99568cb1e$export$3243579822c486a0)(message, options),
        detectError: detectError
    };
}
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$1ea8807c727891fc = (message, context)=>{
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(message)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE);
    {
        // check HTML message
        const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile
        const { code: code, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, context);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    }
};
function $a739018d680a1535$export$ef7acd7185315e22(message, context) {
    if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(message)) {
        // check HTML message
        const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile with JIT mode
        const { ast: ast, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, {
            ...context,
            location: false,
            jit: true
        });
        // compose message function from AST
        const msg = $a739018d680a1535$var$format(ast);
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    } else {
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = $a739018d680a1535$var$compileCache[cacheKey];
            if (cached) return cached;
            // compose message function from message (AST)
            return $a739018d680a1535$var$compileCache[cacheKey] = $a739018d680a1535$var$format(message);
        } else return $a739018d680a1535$var$format(message);
    }
}
const $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION = ()=>"";
const $a739018d680a1535$export$92c0a039cf358271 = (val)=>(0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(val);
// implementation of `translate` function
function $a739018d680a1535$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $a739018d680a1535$export$8d9616744e22681a(...args);
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.default) || (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.default) // default by function option
     ? !(0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : "";
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    // escape params
    escapeParameter && $a739018d680a1535$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || {}
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) || !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(targetLocale))) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    let occurred = false;
    const onError = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$a739018d680a1535$export$92c0a039cf358271(format) ? $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $a739018d680a1535$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $a739018d680a1535$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $a739018d680a1535$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(key) ? key : $a739018d680a1535$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($a739018d680a1535$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) ? format : $a739018d680a1535$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, context.__meta, $a739018d680a1535$export$817795a14e5c6622() || {});
        $a739018d680a1535$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $a739018d680a1535$var$escapeParams(options) {
    if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.list)) options.list = options.list.map((item)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(item) ? (0, $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8)(item) : item);
    else if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.named[key])) options.named[key] = (0, $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8)(options.named[key]);
    });
}
function $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "translate";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || {};
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) break;
        if (!$a739018d680a1535$export$d783301aca6271c3(targetLocale, locales)) {
            const missingRet = $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
            if (missingRet !== key) format = missingRet;
        }
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($a739018d680a1535$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const msg = messageCompiler(format, $a739018d680a1535$var$getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $a739018d680a1535$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $a739018d680a1535$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = {};
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1) && !(0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1) && !$a739018d680a1535$export$92c0a039cf358271(arg1) && !$a739018d680a1535$export$9ba95744594b90e0(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1) ? String(arg1) : $a739018d680a1535$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.default = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2) && !(0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(arg2)) options.named = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg2)) options.list = arg2;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg3)) options.plural = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.default = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(options, arg3);
    return [
        key,
        options
    ];
}
function $a739018d680a1535$var$getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale: locale,
        key: key,
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            onError && onError(err);
            throw err;
        },
        onCacheKey: (source)=>(0, $fbd1e3bc010bc8c2$export$5024ef1f92c9a364)(locale, key, source)
    };
}
function $a739018d680a1535$var$getSourceForCodeFrame(source) {
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(source)) return source;
    else {
        if (source.loc && source.loc.source) return source.loc.source;
    }
}
function $a739018d680a1535$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key)=>{
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = $a739018d680a1535$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val) || $a739018d680a1535$export$9ba95744594b90e0(val)) {
            let occurred = false;
            const onError = ()=>{
                occurred = true;
            };
            const msg = $a739018d680a1535$var$compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred ? msg : $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
        } else if ($a739018d680a1535$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
const $a739018d680a1535$var$intlDefined = typeof Intl !== "undefined";
const $a739018d680a1535$var$Availabilities = {
    dateTimeFormat: $a739018d680a1535$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $a739018d680a1535$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $a739018d680a1535$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    const [key, value, options, overrides] = $a739018d680a1535$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(key) || key === "") return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "datetime format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format) || !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c77049eaf05b1508 = [
    "localeMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "formatMatcher",
    "hour12",
    "timeZone",
    "dateStyle",
    "timeStyle",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "hourCycle",
    "fractionalSecondDigits"
];
/** @internal */ function $a739018d680a1535$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    let value;
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $fbd1e3bc010bc8c2$export$871608497c498473)(arg1)) {
        if (isNaN(arg1.getTime())) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1)) value = arg1;
    else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $a739018d680a1535$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    const [key, value, options, overrides] = $a739018d680a1535$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(key) || key === "") return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "number format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(format) || !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c39a7c3789c46ed6 = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "roundingMode",
    "roundingPriority",
    "roundingIncrement",
    "trailingZeroDisplay"
];
/** @internal */ function $a739018d680a1535$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    if (!(0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
$a739018d680a1535$var$initFeatureFlags();


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$a4ad2735b021c132 = "9.13.1";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $409cbe3732db83c2$var$initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__VUE_I18N_FULL_INSTALL__ = true;
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__VUE_I18N_LEGACY_API__ = true;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
const $409cbe3732db83c2$var$code$1 = (0, $a739018d680a1535$export$b6a676a18b27d4c8).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc$1 = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($409cbe3732db83c2$var$code$1);
const $409cbe3732db83c2$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $409cbe3732db83c2$var$code$1,
    NOT_SUPPORTED_PRESERVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $409cbe3732db83c2$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $409cbe3732db83c2$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $409cbe3732db83c2$var$inc$1(),
    IGNORE_OBJ_FLATTEN: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: $409cbe3732db83c2$var$inc$1() // 18
};
const $409cbe3732db83c2$var$warnMessages = {
    [$409cbe3732db83c2$var$I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION]: `'allowComposition' option will be dropped in the next major version. For more information, please see \u{1F449} https://tinyurl.com/2p97mcze`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: `'translateExistCompatible' option will be dropped in the next major version.`
};
function $409cbe3732db83c2$var$getWarnMessage(code, ...args) {
    return (0, $fbd1e3bc010bc8c2$export$d9468344d3651243)($409cbe3732db83c2$var$warnMessages[code], ...args);
}
const $409cbe3732db83c2$var$code = (0, $a739018d680a1535$export$1d4dfd6045c40277).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc = (0, $fbd1e3bc010bc8c2$export$47db5deb603dfca1)($409cbe3732db83c2$var$code);
const $409cbe3732db83c2$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $409cbe3732db83c2$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $409cbe3732db83c2$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED: $409cbe3732db83c2$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $409cbe3732db83c2$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $409cbe3732db83c2$var$inc(),
    INVALID_VALUE: $409cbe3732db83c2$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED_WITH_PROVIDE: $409cbe3732db83c2$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $409cbe3732db83c2$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $409cbe3732db83c2$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $409cbe3732db83c2$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $409cbe3732db83c2$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $409cbe3732db83c2$var$inc() // 38
};
function $409cbe3732db83c2$var$createI18nError(code, ...args) {
    return (0, $b46efaa99568cb1e$export$21efa8bb37d5fecb)(code, null, undefined);
}
const $409cbe3732db83c2$var$errorMessages = {
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED]: "Need to install with `app.use` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [$409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
    [$409cbe3732db83c2$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define \u2018i18n\u2019 option or custom block in Composition API with using local scope in Legacy API mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
};
const $409cbe3732db83c2$var$TranslateVNodeSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__translateVNode");
const $409cbe3732db83c2$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__datetimeParts");
const $409cbe3732db83c2$var$NumberPartsSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__numberParts");
const $409cbe3732db83c2$var$EnableEmitter = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__enableEmitter");
const $409cbe3732db83c2$var$DisableEmitter = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__disableEmitter");
const $409cbe3732db83c2$var$SetPluralRulesSymbol = (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__setPluralRules");
(0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__intlifyMeta");
const $409cbe3732db83c2$var$InejctWithOptionSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__injectWithOption");
const $409cbe3732db83c2$var$DisposeSymbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("__dispose");
const $409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ = "__VUE_I18N_BRIDGE__";
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $409cbe3732db83c2$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj)) return obj;
    for(const key in obj){
        // check key
        if (!(0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(obj[key])) $409cbe3732db83c2$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split(".");
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for(let i = 0; i < lastIndex; i++){
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = {};
                if (!(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(currentObj[subKeys[i]])) {
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                currentObj[subKeys[lastIndex]] = obj[key];
                delete obj[key];
            }
            // recursive process value if value is also a object
            if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(currentObj[subKeys[lastIndex]])) $409cbe3732db83c2$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $409cbe3732db83c2$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(messages) ? messages : (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(__i18n) ? {} : {
        [locale]: {}
    };
    // merge locale messages of i18n custom block
    if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(__i18n)) __i18n.forEach((custom)=>{
        if ("locale" in custom && "resource" in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || {};
                (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(resource, ret[locale]);
            } else (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(resource, ret);
        } else (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(custom) && (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ((0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(ret, key)) $409cbe3732db83c2$var$handleFlatJson(ret[key]);
    }
    return ret;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getComponentOptions(instance) {
    return instance.type;
}
function $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.messages) ? options.messages : {};
    if ("__i18nGlobal" in componentOptions) messages = $409cbe3732db83c2$var$getLocaleMessages(gl.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        gl.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $409cbe3732db83c2$var$createTextNode(key) {
    return (0, $TusQn.createVNode)((0, $TusQn.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $409cbe3732db83c2$var$DEVTOOLS_META = "__INTLIFY_META__";
const $409cbe3732db83c2$var$NOOP_RETURN_ARRAY = ()=>[];
const $409cbe3732db83c2$var$NOOP_RETURN_FALSE = ()=>false;
let $409cbe3732db83c2$var$composerID = 0;
function $409cbe3732db83c2$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, (0, $TusQn.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$var$getMetaInfo = ()=>{
    const instance = (0, $TusQn.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $409cbe3732db83c2$var$getComponentOptions(instance)[$409cbe3732db83c2$var$DEVTOOLS_META]) ? {
        [$409cbe3732db83c2$var$DEVTOOLS_META]: meta
    } // eslint-disable-line @typescript-eslint/no-explicit-any
     : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createComposer(options = {}, VueI18nLegacy) {
    const { __root: __root, __injectWithOption: __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = (0, $fbd1e3bc010bc8c2$export$620a268685f0ac45) ? (0, $01W3b.ref) : (0, $01W3b.shallowRef);
    const translateExistCompatible = !!options.translateExistCompatible;
    let _inheritLocale = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $a739018d680a1535$export$1af4c7e47ad72f44));
    const _fallbackLocale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = _ref($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = _ref((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    let _runtimeMissing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? $409cbe3732db83c2$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && (0, $a739018d680a1535$export$e16aca6786e72a5e)(null);
        const ctxOptions = {
            version: $409cbe3732db83c2$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(_context) ? _context.__numberFormatters : undefined;
        const ctx = (0, $a739018d680a1535$export$3599d465b05a74a5)(ctxOptions);
        _isGlobal && (0, $a739018d680a1535$export$e16aca6786e72a5e)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>_locale.value,
        set: (val1)=>{
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $409cbe3732db83c2$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $a739018d680a1535$export$605703447dca72aa)($409cbe3732db83c2$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $a739018d680a1535$export$3adddc434faa9e35)() : undefined;
            ret = fn(_context);
        } finally{
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $a739018d680a1535$export$605703447dca72aa)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        if (warnType !== "translate exists" && // for not `te` (e.g `t`)
        (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(ret) && ret === (0, $a739018d680a1535$export$b7f13a18d1d0f835) || warnType === "translate exists" && !ret // for `te`
        ) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$d73ee8ef04f5226a), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$8d9616744e22681a)(...args), "translate", (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !(0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(arg3)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$165524b21a0d6b5e)(...args), "datetime format", (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>(0, $a739018d680a1535$export$a04371e9dbb3870b), (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$d0e2eec8b686cf72)(...args), "number format", (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>(0, $a739018d680a1535$export$a04371e9dbb3870b), (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1) || (0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(val1) || (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val1) ? $409cbe3732db83c2$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $a739018d680a1535$export$d73ee8ef04f5226a), null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>(0, $a739018d680a1535$export$8d9616744e22681a)(...args), "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$TranslateVNodeSymbol](...args), (key)=>[
                $409cbe3732db83c2$var$createTextNode(key)
            ], (val1)=>(0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$d0e2eec8b686cf72)(...args), "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$NumberPartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $a739018d680a1535$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $a739018d680a1535$export$165524b21a0d6b5e)(...args), "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$DatetimePartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(val1) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(()=>{
            if (!key) return false;
            const targetLocale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return !translateExistCompatible ? (0, $a739018d680a1535$export$9ba95744594b90e0)(resolved) || (0, $a739018d680a1535$export$92c0a039cf358271)(resolved) || (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(resolved) : resolved != null;
        }, ()=>[
                key
            ], "translate exists", (root)=>{
            return Reflect.apply(root.te, root, [
                key,
                locale
            ]);
        }, $409cbe3732db83c2$var$NOOP_RETURN_FALSE, (val1)=>(0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val1));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = (0, $a739018d680a1535$export$71df9db82dc445)(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = {
                [locale]: message
            };
            for(const key in _message)if ((0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = {
            [locale]: message
        };
        if (flatJson) {
            for(const key in _message)if ((0, $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
        }
        message = _message[locale];
        (0, $fbd1e3bc010bc8c2$export$6c40052bed430212)(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $a739018d680a1535$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $a739018d680a1535$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $a739018d680a1535$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $a739018d680a1535$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // for debug
    $409cbe3732db83c2$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $fbd1e3bc010bc8c2$export$620a268685f0ac45)) {
        (0, $TusQn.watch)(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $TusQn.watch)(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $409cbe3732db83c2$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $a739018d680a1535$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$409cbe3732db83c2$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] = __injectWithOption;
    composer[$409cbe3732db83c2$var$TranslateVNodeSymbol] = translateVNode;
    composer[$409cbe3732db83c2$var$DatetimePartsSymbol] = datetimeParts;
    composer[$409cbe3732db83c2$var$NumberPartsSymbol] = numberParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $409cbe3732db83c2$var$convertComposerOptions(options) {
    const locale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $a739018d680a1535$export$1af4c7e47ad72f44);
    const fallbackLocale = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : undefined;
    const missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.silentTranslationWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.silentFallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.sync) ? options.sync : true;
    let messages = options.messages;
    if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    const translateExistCompatible = options.translateExistCompatible;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        translateExistCompatible: translateExistCompatible,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = $409cbe3732db83c2$var$createComposer($409cbe3732db83c2$var$convertComposerOptions(options));
        const { __extender: __extender } = options;
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate () {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt (...args) {
                return Reflect.apply(composer.rt, composer, [
                    ...args
                ]);
            },
            // tc
            tc (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {
                    plural: 1
                };
                let list = null;
                let named = null;
                if (!(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(arg3)) options.locale = arg3;
                else if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te (key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm (key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage (locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage (locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage (locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d (...args) {
                return Reflect.apply(composer.d, composer, [
                    ...args
                ]);
            },
            // getDateTimeFormat
            getDateTimeFormat (locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat (locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat (locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n (...args) {
                return Reflect.apply(composer.n, composer, [
                    ...args
                ]);
            },
            // getNumberFormat
            getNumberFormat (locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat (locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat (locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex (choice, choicesLength) {
                return -1;
            }
        };
        vueI18n.__extender = __extender;
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $409cbe3732db83c2$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponentI18nScope */ )=>val1 === "parent" || val1 === "global",
        default: "parent" /* ComponentI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $409cbe3732db83c2$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === "default") {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return [
                ...slot,
                // prettier-ignore
                ...current.type === (0, $TusQn.Fragment) ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, {});
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getFragmentableTag(tag) {
    return 0, $TusQn.Fragment;
}
const $409cbe3732db83c2$var$TranslationImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-t",
    props: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val1)=>(0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(val1) || !isNaN(val1)
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== "_");
            const options = {};
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.plural) ? +props.plural : props.plural;
            const arg = $409cbe3732db83c2$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$409cbe3732db83c2$var$TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, attrs);
            const tag = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.tag) || (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
            return (0, $TusQn.h)(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$b63289fbda65eed1 = $409cbe3732db83c2$var$TranslationImpl;
const $409cbe3732db83c2$export$1d08de71ac06ffd6 = $409cbe3732db83c2$export$b63289fbda65eed1;
function $409cbe3732db83c2$var$isVNode(target) {
    return (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(target) && !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(target[0]);
}
function $409cbe3732db83c2$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = {};
        if (props.locale) options.locale = props.locale;
        if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.format)) options.key = props.format;
        else if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, {});
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ((0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($409cbe3732db83c2$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(parts)) children = [
            parts
        ];
        const assignedAttrs = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, attrs);
        const tag = (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(props.tag) || (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
        return (0, $TusQn.h)(tag, assignedAttrs, children);
    };
}
const $409cbe3732db83c2$var$NumberFormatImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-n",
    props: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $a739018d680a1535$export$c39a7c3789c46ed6), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$27bce688931fdfcc = $409cbe3732db83c2$var$NumberFormatImpl;
const $409cbe3732db83c2$export$4665d24327644133 = $409cbe3732db83c2$export$27bce688931fdfcc;
const $409cbe3732db83c2$var$DatetimeFormatImpl = /* #__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: "i18n-d",
    props: (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $a739018d680a1535$export$c77049eaf05b1508), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$64ca50867510e64e = $409cbe3732db83c2$var$DatetimeFormatImpl;
const $409cbe3732db83c2$export$c741260b89dcb234 = $409cbe3732db83c2$export$64ca50867510e64e;
function $409cbe3732db83c2$var$getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $409cbe3732db83c2$export$8a5a05546006d0b5(i18n) {
    const _process = (binding)=>{
        const { instance: instance, modifiers: modifiers, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $409cbe3732db83c2$var$getComposer$2(i18n, instance.$);
        const parsedValue = $409cbe3732db83c2$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ((0, $fbd1e3bc010bc8c2$export$620a268685f0ac45) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $TusQn.watch)(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ((0, $fbd1e3bc010bc8c2$export$620a268685f0ac45) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $409cbe3732db83c2$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $409cbe3732db83c2$var$parseValue(value) {
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(value)) return {
        path: value
    };
    else if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(value)) {
        if (!("path" in value)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE);
}
function $409cbe3732db83c2$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(locale)) options.locale = locale;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(choice)) options.plural = choice;
    if ((0, $fbd1e3bc010bc8c2$export$7e4aa119212bc614)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $409cbe3732db83c2$var$apply(app, i18n, ...options) {
    const pluginOptions = (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options[0]) ? options[0] : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        [
            !useI18nComponentName ? $409cbe3732db83c2$export$b63289fbda65eed1.name : "i18n",
            "I18nT"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$b63289fbda65eed1));
        [
            $409cbe3732db83c2$export$27bce688931fdfcc.name,
            "I18nN"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$27bce688931fdfcc));
        [
            $409cbe3732db83c2$export$64ca50867510e64e.name,
            "I18nD"
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$64ca50867510e64e));
    }
    app.directive("t", $409cbe3732db83c2$export$8a5a05546006d0b5(i18n));
}
const $409cbe3732db83c2$var$VueDevToolsLabels = {
    ["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ]: "Vue I18n devtools",
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "I18n Resources",
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: "Vue I18n"
};
const $409cbe3732db83c2$var$VueDevToolsPlaceholders = {
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: "Search for scopes ..."
};
const $409cbe3732db83c2$var$VueDevToolsTimelineColors = {
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: 0xffcd19
};
const $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
let $409cbe3732db83c2$var$devtoolsApi;
async function $409cbe3732db83c2$var$enableDevTools(app, i18n) {
    return new Promise((resolve, reject)=>{
        try {
            (0, $de8f43bece76d38a$export$63b9a9bba9f20f3e)({
                id: "vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ,
                label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ],
                packageName: "vue-i18n",
                homepage: "https://vue-i18n.intlify.dev",
                logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                componentStateTypes: [
                    $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES
                ],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, (api)=>{
                $409cbe3732db83c2$var$devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance: componentInstance, treeNode: treeNode })=>{
                    $409cbe3732db83c2$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance: componentInstance, instanceData: instanceData })=>{
                    if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                        if (i18n.mode === "legacy") // ignore global scope on legacy mode
                        {
                            if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        } else $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ],
                    icon: "language",
                    treeFilterPlaceholder: $409cbe3732db83c2$var$VueDevToolsPlaceholders["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]
                });
                api.on.getInspectorTree((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$registerScope(payload, i18n);
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) {
                        api.unhighlightElement();
                        $409cbe3732db83c2$var$inspectScope(payload, i18n);
                        if (payload.nodeId === "global") {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        } else {
                            const instance = $409cbe3732db83c2$var$getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$editScope(payload, i18n);
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ],
                    color: $409cbe3732db83c2$var$VueDevToolsTimelineColors["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]
                });
                resolve(true);
            });
        } catch (e) {
            console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $409cbe3732db83c2$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${$409cbe3732db83c2$var$getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $409cbe3732db83c2$var$inspectComposer(instanceData, composer) {
    const type = $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key)=>{
        const v = messages[key];
        if ((0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(v) && "source" in v) value[key] = $409cbe3732db83c2$var$getMessageFunctionDetails(v);
        else if ((0, $a739018d680a1535$export$9ba95744594b90e0)(v) && v.loc && v.loc.source) value[key] = v.loc.source;
        else if ((0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(v)) value[key] = $409cbe3732db83c2$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
const $409cbe3732db83c2$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $409cbe3732db83c2$var$escape(s) {
    return s.replace(/[<>"&]/g, $409cbe3732db83c2$var$escapeChar);
}
function $409cbe3732db83c2$var$escapeChar(a) {
    return $409cbe3732db83c2$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getMessageFunctionDetails(func) {
    const argString = func.source ? `("${$409cbe3732db83c2$var$escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: "function",
            display: `<span>\u{192}</span> ${argString}`
        }
    };
}
function $409cbe3732db83c2$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances){
        // prettier-ignore
        const composer = i18n.mode === "composition" ? instance : instance.__composer;
        if (global === composer) continue;
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${$409cbe3732db83c2$var$getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function $409cbe3732db83c2$var$getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== "global") {
        for (const [component, composer] of i18n.__instances.entries())if (composer.id.toString() === nodeId) {
            instance = component;
            break;
        }
    }
    return instance;
}
function $409cbe3732db83c2$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        const instance = Array.from(i18n.__instances.values()).find((item)=>item.id.toString() === nodeId);
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $409cbe3732db83c2$var$inspectScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $409cbe3732db83c2$var$makeScopeInspectState(composer);
    return null;
}
function $409cbe3732db83c2$var$makeScopeInspectState(composer) {
    const state = {};
    const localeType = "Locale related info";
    const localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = "Locale messages info";
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = "Datetime formats info";
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = "Datetime formats info";
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $409cbe3732db83c2$var$addTimelineEvent(event, payload) {
    if ($409cbe3732db83c2$var$devtoolsApi) {
        let groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $409cbe3732db83c2$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* VueDevToolsTimelineEvents.COMPILE_ERROR */  ? "error" : event === "fallback" /* VueDevToolsTimelineEvents.FALBACK */  || event === "missing" /* VueDevToolsTimelineEvents.MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $409cbe3732db83c2$var$editScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === "locale" && (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(payload.state.value) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(payload.state.value) || (0, $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $409cbe3732db83c2$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, options);
                else {
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else // attach global VueI18n instance
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $409cbe3732db83c2$var$adjustI18nResources(composer, options, options);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$tc = (...args)=>this.$i18n.tc(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted () {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$i18n) {
                const _vueI18n = this.$i18n;
                this.$el.__VUE_I18N__ = _vueI18n.__composer;
                const emitter = this.__v_emitter = (0, $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1)();
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
            }
        },
        unmounted () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const _vueI18n = this.$i18n;
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off("*", $409cbe3732db83c2$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $409cbe3732db83c2$var$mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[$409cbe3732db83c2$var$SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = $409cbe3732db83c2$var$getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>g.mergeNumberFormat(locale, options.numberFormats[locale]));
    return g;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$920091e3d72d80ee(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    const __instances = new Map();
    const [globalScope, __global] = $409cbe3732db83c2$var$createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ (0, $fbd1e3bc010bc8c2$export$cd133c5e04906ece)("");
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            // install plugin
            async install (app, ...options) {
                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // set composer & vuei18n extend hook options from plugin options
                if ((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options[0])) {
                    const opts = options[0];
                    i18n.__composerExtend = opts.__composerExtend;
                    i18n.__vueI18nExtend = opts.__vueI18nExtend;
                }
                // global method and properties injection for Composition API
                let globalReleaseHandler = null;
                if (!__legacyMode && __globalInjection) globalReleaseHandler = $409cbe3732db83c2$var$injectGlobalFields(app, i18n.global);
                // install built-in components and directive
                if (__VUE_I18N_FULL_INSTALL__) $409cbe3732db83c2$var$apply(app, i18n, ...options);
                // setup mixin for Legacy API
                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($409cbe3732db83c2$var$defineMixin(__global, __global.__composer, i18n));
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = ()=>{
                    globalReleaseHandler && globalReleaseHandler();
                    i18n.dispose();
                    unmountApp();
                };
                // setup vue-devtools plugin
                if (__VUE_PROD_DEVTOOLS__ && true) {
                    const ret = await $409cbe3732db83c2$var$enableDevTools(app, i18n);
                    if (!ret) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                    const emitter = (0, $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1)();
                    if (__legacyMode) {
                        const _vueI18n = __global;
                        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const _composer = __global;
                        _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
                    }
                    emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
                }
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose () {
                globalScope.stop();
            },
            __instances: // @internal
            __instances,
            __getInstance: // @internal
            __getInstance,
            __setInstance: // @internal
            __setInstance,
            __deleteInstance: // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$3f3caade1c12f8c9(options = {}) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED);
    const i18n = $409cbe3732db83c2$var$getI18nInstance(instance);
    const gl = $409cbe3732db83c2$var$getGlobalComposer(i18n);
    const componentOptions = $409cbe3732db83c2$var$getComponentOptions(instance);
    const scope = $409cbe3732db83c2$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === "legacy" && !options.__useComponent) {
            if (!i18n.allowComposition) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, gl, options);
        }
    }
    if (scope === "global") {
        $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $409cbe3732db83c2$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = gl;
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = (0, $fbd1e3bc010bc8c2$export$e6e34fd1f2686227)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (gl) composerOptions.__root = gl;
        composer = $409cbe3732db83c2$var$createComposer(composerOptions);
        if (i18nInternal.__composerExtend) composer[$409cbe3732db83c2$var$DisposeSymbol] = i18nInternal.__composerExtend(composer);
        $409cbe3732db83c2$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ /* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$export$ec8a89fa64fbfb0 = (i18n)=>{
    if (!($409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ in i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $409cbe3732db83c2$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0, $01W3b.effectScope)();
    {
        const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(()=>$409cbe3732db83c2$var$createVueI18n(options)) : scope.run(()=>$409cbe3732db83c2$var$createComposer(options));
        if (obj == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $409cbe3732db83c2$var$getI18nInstance(instance) {
    {
        const i18n = (0, $TusQn.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $409cbe3732db83c2$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $409cbe3732db83c2$var$createI18nError(!instance.isCE ? $409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR : $409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $fbd1e3bc010bc8c2$export$83b788b1a3698c03)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $409cbe3732db83c2$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $409cbe3732db83c2$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent);
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent = false) {
    if (target == null) return null;
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent ? target.parent : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function $409cbe3732db83c2$var$setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0, $TusQn.onMounted)(()=>{
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
            emitter.on("*", $409cbe3732db83c2$var$addTimelineEvent);
        }
    }, target);
    (0, $TusQn.onUnmounted)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $409cbe3732db83c2$var$addTimelineEvent);
            _composer[$409cbe3732db83c2$var$DisableEmitter] && _composer[$409cbe3732db83c2$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[$409cbe3732db83c2$var$DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[$409cbe3732db83c2$var$DisposeSymbol];
        }
    }, target);
}
function $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocalScope = scope === "local";
    const _composer = (0, $01W3b.shallowRef)(null);
    if (isLocalScope && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    const _inheritLocale = (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : !(0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale);
    const _locale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.locale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $a739018d680a1535$export$1af4c7e47ad72f44));
    const _fallbackLocale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.fallbackLocale.value : (0, $fbd1e3bc010bc8c2$export$844ec244b1367d54)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $01W3b.ref)($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $01W3b.ref)((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $01W3b.ref)((0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _missingWarn = isLocalScope ? root.missingWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    const _fallbackWarn = isLocalScope ? root.fallbackWarn : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $fbd1e3bc010bc8c2$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    const _fallbackRoot = isLocalScope ? root.fallbackRoot : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = (0, $fbd1e3bc010bc8c2$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocalScope ? root.warnHtmlMessage : (0, $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocalScope ? root.modifiers : (0, $fbd1e3bc010bc8c2$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    const _pluralRules = options.pluralRules || isLocalScope && root.pluralRules;
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>{
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    const datetimeFormats = (0, $01W3b.computed)(()=>_datetimeFormats.value);
    const numberFormats = (0, $01W3b.computed)(()=>_numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    }
    function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.t, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function rt(...args) {
        return _composer.value ? Reflect.apply(_composer.value.rt, null, [
            ...args
        ]) : "";
    }
    function d(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.d, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function n(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.n, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    }
    const wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach((locale)=>{
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach((locale)=>{
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach((locale)=>{
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0, $TusQn.onBeforeMount)(()=>{
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === "global") {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocalScope) sync(composer);
    });
    return wrapper;
}
const $409cbe3732db83c2$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
const $409cbe3732db83c2$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm",
    "te"
];
function $409cbe3732db83c2$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $409cbe3732db83c2$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = (0, $01W3b.isRef)(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}
$409cbe3732db83c2$var$initFeatureFlags();
// register message compiler at vue-i18n
if (__INTLIFY_JIT_COMPILATION__) (0, $a739018d680a1535$export$6ee2fbe83628b40b)((0, $a739018d680a1535$export$ef7acd7185315e22));
else (0, $a739018d680a1535$export$6ee2fbe83628b40b)((0, $a739018d680a1535$export$1ea8807c727891fc));
// register message resolver at vue-i18n
(0, $a739018d680a1535$export$45dacdc710815463)((0, $a739018d680a1535$export$d812c8e1906863d0));
// register fallback locale at vue-i18n
(0, $a739018d680a1535$export$fd8ec9dd8067edec)((0, $a739018d680a1535$export$71df9db82dc445));
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    const target = (0, $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14)();
    target.__INTLIFY__ = true;
    (0, $a739018d680a1535$export$c893d6c8966908b9)(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}


parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");
const $c9dc9fb022ef0335$var$messages = {
    cz: (0, (/*@__PURE__*/$parcel$interopDefault($68a9b4b77dd6865e$exports))),
    en: (0, (/*@__PURE__*/$parcel$interopDefault($dbe0ca9f329339a9$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($b27a1531d0f920dc$exports)))
};
const $c9dc9fb022ef0335$var$i18n = (0, $409cbe3732db83c2$export$920091e3d72d80ee)({
    locale: document.documentElement.lang,
    fallbackLocale: "en",
    messages: $c9dc9fb022ef0335$var$messages
});
const $c9dc9fb022ef0335$var$toastTypes = {
    success: "success",
    error: "error",
    info: "info",
    warn: "warn"
};
(0, $h8ls9.default).init({
    types: $c9dc9fb022ef0335$var$toastTypes
});
function $c9dc9fb022ef0335$var$toast({ title: title, message: message, type: type, timeout: timeout, cb: cb }) {
    return (0, $h8ls9.default)[type]($c9dc9fb022ef0335$var$i18n.global.t(message), $c9dc9fb022ef0335$var$i18n.global.t(title), timeout, cb);
}
const $c9dc9fb022ef0335$var$options = {
    success: $c9dc9fb022ef0335$var$toast,
    error: $c9dc9fb022ef0335$var$toast,
    info: $c9dc9fb022ef0335$var$toast,
    warn: $c9dc9fb022ef0335$var$toast
};
const $c9dc9fb022ef0335$var$app = (0, $eeJ70.createApp)((0, $14645da86d433629$export$2e2bcd8739ae039));
$c9dc9fb022ef0335$var$app.use($c9dc9fb022ef0335$var$i18n).use((0, $060fe58cae938b62$export$2e2bcd8739ae039)).use((0, $0b901d553092e5c6$export$2e2bcd8739ae039), $c9dc9fb022ef0335$var$options).use((0, $a0ff767aa05ebc8a$export$2e2bcd8739ae039));
$c9dc9fb022ef0335$var$app.mount("#app");


//# sourceMappingURL=index.bc1940bd.js.map
